// Copyright (c) 2005  Tom Wu
// All Rights Reserved.
// See "LICENSE" for details.

// Basic JavaScript BN library - subset useful for RSA encryption.

// Bits per digit
var dbits;

// JavaScript engine analysis
var canary = 0xdeadbeefcafe;
var j_lm = ((canary&0xffffff)==0xefcafe);

// (public) Constructor
function BigInteger(a,b,c) {
  if(a != null)
    if("number" == typeof a) this.fromNumber(a,b,c);
    else if(b == null && "string" != typeof a) this.fromString(a,256);
    else this.fromString(a,b);
}

// return new, unset BigInteger
function nbi() { return new BigInteger(null); }

// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.

// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)
function am1(i,x,w,j,c,n) {
  while(--n >= 0) {
    var v = x*this[i++]+w[j]+c;
    c = Math.floor(v/0x4000000);
    w[j++] = v&0x3ffffff;
  }
  return c;
}
// am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
function am2(i,x,w,j,c,n) {
  var xl = x&0x7fff, xh = x>>15;
  while(--n >= 0) {
    var l = this[i]&0x7fff;
    var h = this[i++]>>15;
    var m = xh*l+h*xl;
    l = xl*l+((m&0x7fff)<<15)+w[j]+(c&0x3fffffff);
    c = (l>>>30)+(m>>>15)+xh*h+(c>>>30);
    w[j++] = l&0x3fffffff;
  }
  return c;
}
// Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.
function am3(i,x,w,j,c,n) {
  var xl = x&0x3fff, xh = x>>14;
  while(--n >= 0) {
    var l = this[i]&0x3fff;
    var h = this[i++]>>14;
    var m = xh*l+h*xl;
    l = xl*l+((m&0x3fff)<<14)+w[j]+c;
    c = (l>>28)+(m>>14)+xh*h;
    w[j++] = l&0xfffffff;
  }
  return c;
}
if(j_lm && (navigator.appName == "Microsoft Internet Explorer")) {
  BigInteger.prototype.am = am2;
  dbits = 30;
}
else if(j_lm && (navigator.appName != "Netscape")) {
  BigInteger.prototype.am = am1;
  dbits = 26;
}
else { // Mozilla/Netscape seems to prefer am3
  BigInteger.prototype.am = am3;
  dbits = 28;
}

BigInteger.prototype.DB = dbits;
BigInteger.prototype.DM = ((1<<dbits)-1);
BigInteger.prototype.DV = (1<<dbits);

var BI_FP = 52;
BigInteger.prototype.FV = Math.pow(2,BI_FP);
BigInteger.prototype.F1 = BI_FP-dbits;
BigInteger.prototype.F2 = 2*dbits-BI_FP;

// Digit conversions
var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
var BI_RC = new Array();
var rr,vv;
rr = "0".charCodeAt(0);
for(vv = 0; vv <= 9; ++vv) BI_RC[rr++] = vv;
rr = "a".charCodeAt(0);
for(vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv;
rr = "A".charCodeAt(0);
for(vv = 10; vv < 36; ++vv) BI_RC[rr++] = vv;

function int2char(n) { return BI_RM.charAt(n); }
function intAt(s,i) {
  var c = BI_RC[s.charCodeAt(i)];
  return (c==null)?-1:c;
}

// (protected) copy this to r
function bnpCopyTo(r) {
  for(var i = this.t-1; i >= 0; --i) r[i] = this[i];
  r.t = this.t;
  r.s = this.s;
}

// (protected) set from integer value x, -DV <= x < DV
function bnpFromInt(x) {
  this.t = 1;
  this.s = (x<0)?-1:0;
  if(x > 0) this[0] = x;
  else if(x < -1) this[0] = x+this.DV;
  else this.t = 0;
}

// return bigint initialized to value
function nbv(i) { var r = nbi(); r.fromInt(i); return r; }

// (protected) set from string and radix
function bnpFromString(s,b) {
  var k;
  if(b == 16) k = 4;
  else if(b == 8) k = 3;
  else if(b == 256) k = 8; // byte array
  else if(b == 2) k = 1;
  else if(b == 32) k = 5;
  else if(b == 4) k = 2;
  else { this.fromRadix(s,b); return; }
  this.t = 0;
  this.s = 0;
  var i = s.length, mi = false, sh = 0;
  while(--i >= 0) {
    var x = (k==8)?s[i]&0xff:intAt(s,i);
    if(x < 0) {
      if(s.charAt(i) == "-") mi = true;
      continue;
    }
    mi = false;
    if(sh == 0)
      this[this.t++] = x;
    else if(sh+k > this.DB) {
      this[this.t-1] |= (x&((1<<(this.DB-sh))-1))<<sh;
      this[this.t++] = (x>>(this.DB-sh));
    }
    else
      this[this.t-1] |= x<<sh;
    sh += k;
    if(sh >= this.DB) sh -= this.DB;
  }
  if(k == 8 && (s[0]&0x80) != 0) {
    this.s = -1;
    if(sh > 0) this[this.t-1] |= ((1<<(this.DB-sh))-1)<<sh;
  }
  this.clamp();
  if(mi) BigInteger.ZERO.subTo(this,this);
}

// (protected) clamp off excess high words
function bnpClamp() {
  var c = this.s&this.DM;
  while(this.t > 0 && this[this.t-1] == c) --this.t;
}

// (public) return string representation in given radix
function bnToString(b) {
  if(this.s < 0) return "-"+this.negate().toString(b);
  var k;
  if(b == 16) k = 4;
  else if(b == 8) k = 3;
  else if(b == 2) k = 1;
  else if(b == 32) k = 5;
  else if(b == 4) k = 2;
  else return this.toRadix(b);
  var km = (1<<k)-1, d, m = false, r = "", i = this.t;
  var p = this.DB-(i*this.DB)%k;
  if(i-- > 0) {
    if(p < this.DB && (d = this[i]>>p) > 0) { m = true; r = int2char(d); }
    while(i >= 0) {
      if(p < k) {
        d = (this[i]&((1<<p)-1))<<(k-p);
        d |= this[--i]>>(p+=this.DB-k);
      }
      else {
        d = (this[i]>>(p-=k))&km;
        if(p <= 0) { p += this.DB; --i; }
      }
      if(d > 0) m = true;
      if(m) r += int2char(d);
    }
  }
  return m?r:"0";
}

// (public) -this
function bnNegate() { var r = nbi(); BigInteger.ZERO.subTo(this,r); return r; }

// (public) |this|
function bnAbs() { return (this.s<0)?this.negate():this; }

// (public) return + if this > a, - if this < a, 0 if equal
function bnCompareTo(a) {
  var r = this.s-a.s;
  if(r != 0) return r;
  var i = this.t;
  r = i-a.t;
  if(r != 0) return (this.s<0)?-r:r;
  while(--i >= 0) if((r=this[i]-a[i]) != 0) return r;
  return 0;
}

// returns bit length of the integer x
function nbits(x) {
  var r = 1, t;
  if((t=x>>>16) != 0) { x = t; r += 16; }
  if((t=x>>8) != 0) { x = t; r += 8; }
  if((t=x>>4) != 0) { x = t; r += 4; }
  if((t=x>>2) != 0) { x = t; r += 2; }
  if((t=x>>1) != 0) { x = t; r += 1; }
  return r;
}

// (public) return the number of bits in "this"
function bnBitLength() {
  if(this.t <= 0) return 0;
  return this.DB*(this.t-1)+nbits(this[this.t-1]^(this.s&this.DM));
}

// (protected) r = this << n*DB
function bnpDLShiftTo(n,r) {
  var i;
  for(i = this.t-1; i >= 0; --i) r[i+n] = this[i];
  for(i = n-1; i >= 0; --i) r[i] = 0;
  r.t = this.t+n;
  r.s = this.s;
}

// (protected) r = this >> n*DB
function bnpDRShiftTo(n,r) {
  for(var i = n; i < this.t; ++i) r[i-n] = this[i];
  r.t = Math.max(this.t-n,0);
  r.s = this.s;
}

// (protected) r = this << n
function bnpLShiftTo(n,r) {
  var bs = n%this.DB;
  var cbs = this.DB-bs;
  var bm = (1<<cbs)-1;
  var ds = Math.floor(n/this.DB), c = (this.s<<bs)&this.DM, i;
  for(i = this.t-1; i >= 0; --i) {
    r[i+ds+1] = (this[i]>>cbs)|c;
    c = (this[i]&bm)<<bs;
  }
  for(i = ds-1; i >= 0; --i) r[i] = 0;
  r[ds] = c;
  r.t = this.t+ds+1;
  r.s = this.s;
  r.clamp();
}

// (protected) r = this >> n
function bnpRShiftTo(n,r) {
  r.s = this.s;
  var ds = Math.floor(n/this.DB);
  if(ds >= this.t) { r.t = 0; return; }
  var bs = n%this.DB;
  var cbs = this.DB-bs;
  var bm = (1<<bs)-1;
  r[0] = this[ds]>>bs;
  for(var i = ds+1; i < this.t; ++i) {
    r[i-ds-1] |= (this[i]&bm)<<cbs;
    r[i-ds] = this[i]>>bs;
  }
  if(bs > 0) r[this.t-ds-1] |= (this.s&bm)<<cbs;
  r.t = this.t-ds;
  r.clamp();
}

// (protected) r = this - a
function bnpSubTo(a,r) {
  var i = 0, c = 0, m = Math.min(a.t,this.t);
  while(i < m) {
    c += this[i]-a[i];
    r[i++] = c&this.DM;
    c >>= this.DB;
  }
  if(a.t < this.t) {
    c -= a.s;
    while(i < this.t) {
      c += this[i];
      r[i++] = c&this.DM;
      c >>= this.DB;
    }
    c += this.s;
  }
  else {
    c += this.s;
    while(i < a.t) {
      c -= a[i];
      r[i++] = c&this.DM;
      c >>= this.DB;
    }
    c -= a.s;
  }
  r.s = (c<0)?-1:0;
  if(c < -1) r[i++] = this.DV+c;
  else if(c > 0) r[i++] = c;
  r.t = i;
  r.clamp();
}

// (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.
function bnpMultiplyTo(a,r) {
  var x = this.abs(), y = a.abs();
  var i = x.t;
  r.t = i+y.t;
  while(--i >= 0) r[i] = 0;
  for(i = 0; i < y.t; ++i) r[i+x.t] = x.am(0,y[i],r,i,0,x.t);
  r.s = 0;
  r.clamp();
  if(this.s != a.s) BigInteger.ZERO.subTo(r,r);
}

// (protected) r = this^2, r != this (HAC 14.16)
function bnpSquareTo(r) {
  var x = this.abs();
  var i = r.t = 2*x.t;
  while(--i >= 0) r[i] = 0;
  for(i = 0; i < x.t-1; ++i) {
    var c = x.am(i,x[i],r,2*i,0,1);
    if((r[i+x.t]+=x.am(i+1,2*x[i],r,2*i+1,c,x.t-i-1)) >= x.DV) {
      r[i+x.t] -= x.DV;
      r[i+x.t+1] = 1;
    }
  }
  if(r.t > 0) r[r.t-1] += x.am(i,x[i],r,2*i,0,1);
  r.s = 0;
  r.clamp();
}

// (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.
function bnpDivRemTo(m,q,r) {
  var pm = m.abs();
  if(pm.t <= 0) return;
  var pt = this.abs();
  if(pt.t < pm.t) {
    if(q != null) q.fromInt(0);
    if(r != null) this.copyTo(r);
    return;
  }
  if(r == null) r = nbi();
  var y = nbi(), ts = this.s, ms = m.s;
  var nsh = this.DB-nbits(pm[pm.t-1]);	// normalize modulus
  if(nsh > 0) { pm.lShiftTo(nsh,y); pt.lShiftTo(nsh,r); }
  else { pm.copyTo(y); pt.copyTo(r); }
  var ys = y.t;
  var y0 = y[ys-1];
  if(y0 == 0) return;
  var yt = y0*(1<<this.F1)+((ys>1)?y[ys-2]>>this.F2:0);
  var d1 = this.FV/yt, d2 = (1<<this.F1)/yt, e = 1<<this.F2;
  var i = r.t, j = i-ys, t = (q==null)?nbi():q;
  y.dlShiftTo(j,t);
  if(r.compareTo(t) >= 0) {
    r[r.t++] = 1;
    r.subTo(t,r);
  }
  BigInteger.ONE.dlShiftTo(ys,t);
  t.subTo(y,y);	// "negative" y so we can replace sub with am later
  while(y.t < ys) y[y.t++] = 0;
  while(--j >= 0) {
    // Estimate quotient digit
    var qd = (r[--i]==y0)?this.DM:Math.floor(r[i]*d1+(r[i-1]+e)*d2);
    if((r[i]+=y.am(0,qd,r,j,0,ys)) < qd) {	// Try it out
      y.dlShiftTo(j,t);
      r.subTo(t,r);
      while(r[i] < --qd) r.subTo(t,r);
    }
  }
  if(q != null) {
    r.drShiftTo(ys,q);
    if(ts != ms) BigInteger.ZERO.subTo(q,q);
  }
  r.t = ys;
  r.clamp();
  if(nsh > 0) r.rShiftTo(nsh,r);	// Denormalize remainder
  if(ts < 0) BigInteger.ZERO.subTo(r,r);
}

// (public) this mod a
function bnMod(a) {
  var r = nbi();
  this.abs().divRemTo(a,null,r);
  if(this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r,r);
  return r;
}

// Modular reduction using "classic" algorithm
function Classic(m) { this.m = m; }
function cConvert(x) {
  if(x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);
  else return x;
}
function cRevert(x) { return x; }
function cReduce(x) { x.divRemTo(this.m,null,x); }
function cMulTo(x,y,r) { x.multiplyTo(y,r); this.reduce(r); }
function cSqrTo(x,r) { x.squareTo(r); this.reduce(r); }

Classic.prototype.convert = cConvert;
Classic.prototype.revert = cRevert;
Classic.prototype.reduce = cReduce;
Classic.prototype.mulTo = cMulTo;
Classic.prototype.sqrTo = cSqrTo;

// (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.
function bnpInvDigit() {
  if(this.t < 1) return 0;
  var x = this[0];
  if((x&1) == 0) return 0;
  var y = x&3;		// y == 1/x mod 2^2
  y = (y*(2-(x&0xf)*y))&0xf;	// y == 1/x mod 2^4
  y = (y*(2-(x&0xff)*y))&0xff;	// y == 1/x mod 2^8
  y = (y*(2-(((x&0xffff)*y)&0xffff)))&0xffff;	// y == 1/x mod 2^16
  // last step - calculate inverse mod DV directly;
  // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
  y = (y*(2-x*y%this.DV))%this.DV;		// y == 1/x mod 2^dbits
  // we really want the negative inverse, and -DV < y < DV
  return (y>0)?this.DV-y:-y;
}

// Montgomery reduction
function Montgomery(m) {
  this.m = m;
  this.mp = m.invDigit();
  this.mpl = this.mp&0x7fff;
  this.mph = this.mp>>15;
  this.um = (1<<(m.DB-15))-1;
  this.mt2 = 2*m.t;
}

// xR mod m
function montConvert(x) {
  var r = nbi();
  x.abs().dlShiftTo(this.m.t,r);
  r.divRemTo(this.m,null,r);
  if(x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r,r);
  return r;
}

// x/R mod m
function montRevert(x) {
  var r = nbi();
  x.copyTo(r);
  this.reduce(r);
  return r;
}

// x = x/R mod m (HAC 14.32)
function montReduce(x) {
  while(x.t <= this.mt2)	// pad x so am has enough room later
    x[x.t++] = 0;
  for(var i = 0; i < this.m.t; ++i) {
    // faster way of calculating u0 = x[i]*mp mod DV
    var j = x[i]&0x7fff;
    var u0 = (j*this.mpl+(((j*this.mph+(x[i]>>15)*this.mpl)&this.um)<<15))&x.DM;
    // use am to combine the multiply-shift-add into one call
    j = i+this.m.t;
    x[j] += this.m.am(0,u0,x,i,0,this.m.t);
    // propagate carry
    while(x[j] >= x.DV) { x[j] -= x.DV; x[++j]++; }
  }
  x.clamp();
  x.drShiftTo(this.m.t,x);
  if(x.compareTo(this.m) >= 0) x.subTo(this.m,x);
}

// r = "x^2/R mod m"; x != r
function montSqrTo(x,r) { x.squareTo(r); this.reduce(r); }

// r = "xy/R mod m"; x,y != r
function montMulTo(x,y,r) { x.multiplyTo(y,r); this.reduce(r); }

Montgomery.prototype.convert = montConvert;
Montgomery.prototype.revert = montRevert;
Montgomery.prototype.reduce = montReduce;
Montgomery.prototype.mulTo = montMulTo;
Montgomery.prototype.sqrTo = montSqrTo;

// (protected) true iff this is even
function bnpIsEven() { return ((this.t>0)?(this[0]&1):this.s) == 0; }

// (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
function bnpExp(e,z) {
  if(e > 0xffffffff || e < 1) return BigInteger.ONE;
  var r = nbi(), r2 = nbi(), g = z.convert(this), i = nbits(e)-1;
  g.copyTo(r);
  while(--i >= 0) {
    z.sqrTo(r,r2);
    if((e&(1<<i)) > 0) z.mulTo(r2,g,r);
    else { var t = r; r = r2; r2 = t; }
  }
  return z.revert(r);
}

// (public) this^e % m, 0 <= e < 2^32
function bnModPowInt(e,m) {
  var z;
  if(e < 256 || m.isEven()) z = new Classic(m); else z = new Montgomery(m);
  return this.exp(e,z);
}

// protected
BigInteger.prototype.copyTo = bnpCopyTo;
BigInteger.prototype.fromInt = bnpFromInt;
BigInteger.prototype.fromString = bnpFromString;
BigInteger.prototype.clamp = bnpClamp;
BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
BigInteger.prototype.drShiftTo = bnpDRShiftTo;
BigInteger.prototype.lShiftTo = bnpLShiftTo;
BigInteger.prototype.rShiftTo = bnpRShiftTo;
BigInteger.prototype.subTo = bnpSubTo;
BigInteger.prototype.multiplyTo = bnpMultiplyTo;
BigInteger.prototype.squareTo = bnpSquareTo;
BigInteger.prototype.divRemTo = bnpDivRemTo;
BigInteger.prototype.invDigit = bnpInvDigit;
BigInteger.prototype.isEven = bnpIsEven;
BigInteger.prototype.exp = bnpExp;

// public
BigInteger.prototype.toString = bnToString;
BigInteger.prototype.negate = bnNegate;
BigInteger.prototype.abs = bnAbs;
BigInteger.prototype.compareTo = bnCompareTo;
BigInteger.prototype.bitLength = bnBitLength;
BigInteger.prototype.mod = bnMod;
BigInteger.prototype.modPowInt = bnModPowInt;

// "constants"
BigInteger.ZERO = nbv(0);
BigInteger.ONE = nbv(1);

// Copyright (c) 2005-2009  Tom Wu
// All Rights Reserved.
// See "LICENSE" for details.

// Extended JavaScript BN functions, required for RSA private ops.

// Version 1.1: new BigInteger("0", 10) returns "proper" zero
// Version 1.2: square() API, isProbablePrime fix

// (public)
function bnClone() { var r = nbi(); this.copyTo(r); return r; }

// (public) return value as integer
function bnIntValue() {
  if(this.s < 0) {
    if(this.t == 1) return this[0]-this.DV;
    else if(this.t == 0) return -1;
  }
  else if(this.t == 1) return this[0];
  else if(this.t == 0) return 0;
  // assumes 16 < DB < 32
  return ((this[1]&((1<<(32-this.DB))-1))<<this.DB)|this[0];
}

// (public) return value as byte
function bnByteValue() { return (this.t==0)?this.s:(this[0]<<24)>>24; }

// (public) return value as short (assumes DB>=16)
function bnShortValue() { return (this.t==0)?this.s:(this[0]<<16)>>16; }

// (protected) return x s.t. r^x < DV
function bnpChunkSize(r) { return Math.floor(Math.LN2*this.DB/Math.log(r)); }

// (public) 0 if this == 0, 1 if this > 0
function bnSigNum() {
  if(this.s < 0) return -1;
  else if(this.t <= 0 || (this.t == 1 && this[0] <= 0)) return 0;
  else return 1;
}

// (protected) convert to radix string
function bnpToRadix(b) {
  if(b == null) b = 10;
  if(this.signum() == 0 || b < 2 || b > 36) return "0";
  var cs = this.chunkSize(b);
  var a = Math.pow(b,cs);
  var d = nbv(a), y = nbi(), z = nbi(), r = "";
  this.divRemTo(d,y,z);
  while(y.signum() > 0) {
    r = (a+z.intValue()).toString(b).substr(1) + r;
    y.divRemTo(d,y,z);
  }
  return z.intValue().toString(b) + r;
}

// (protected) convert from radix string
function bnpFromRadix(s,b) {
  this.fromInt(0);
  if(b == null) b = 10;
  var cs = this.chunkSize(b);
  var d = Math.pow(b,cs), mi = false, j = 0, w = 0;
  for(var i = 0; i < s.length; ++i) {
    var x = intAt(s,i);
    if(x < 0) {
      if(s.charAt(i) == "-" && this.signum() == 0) mi = true;
      continue;
    }
    w = b*w+x;
    if(++j >= cs) {
      this.dMultiply(d);
      this.dAddOffset(w,0);
      j = 0;
      w = 0;
    }
  }
  if(j > 0) {
    this.dMultiply(Math.pow(b,j));
    this.dAddOffset(w,0);
  }
  if(mi) BigInteger.ZERO.subTo(this,this);
}

// (protected) alternate constructor
function bnpFromNumber(a,b,c) {
  if("number" == typeof b) {
    // new BigInteger(int,int,RNG)
    if(a < 2) this.fromInt(1);
    else {
      this.fromNumber(a,c);
      if(!this.testBit(a-1))	// force MSB set
        this.bitwiseTo(BigInteger.ONE.shiftLeft(a-1),op_or,this);
      if(this.isEven()) this.dAddOffset(1,0); // force odd
      while(!this.isProbablePrime(b)) {
        this.dAddOffset(2,0);
        if(this.bitLength() > a) this.subTo(BigInteger.ONE.shiftLeft(a-1),this);
      }
    }
  }
  else {
    // new BigInteger(int,RNG)
    var x = new Array(), t = a&7;
    x.length = (a>>3)+1;
    b.nextBytes(x);
    if(t > 0) x[0] &= ((1<<t)-1); else x[0] = 0;
    this.fromString(x,256);
  }
}

// (public) convert to bigendian byte array
function bnToByteArray() {
  var i = this.t, r = new Array();
  r[0] = this.s;
  var p = this.DB-(i*this.DB)%8, d, k = 0;
  if(i-- > 0) {
    if(p < this.DB && (d = this[i]>>p) != (this.s&this.DM)>>p)
      r[k++] = d|(this.s<<(this.DB-p));
    while(i >= 0) {
      if(p < 8) {
        d = (this[i]&((1<<p)-1))<<(8-p);
        d |= this[--i]>>(p+=this.DB-8);
      }
      else {
        d = (this[i]>>(p-=8))&0xff;
        if(p <= 0) { p += this.DB; --i; }
      }
      if((d&0x80) != 0) d |= -256;
      if(k == 0 && (this.s&0x80) != (d&0x80)) ++k;
      if(k > 0 || d != this.s) r[k++] = d;
    }
  }
  return r;
}

function bnEquals(a) { return(this.compareTo(a)==0); }
function bnMin(a) { return(this.compareTo(a)<0)?this:a; }
function bnMax(a) { return(this.compareTo(a)>0)?this:a; }

// (protected) r = this op a (bitwise)
function bnpBitwiseTo(a,op,r) {
  var i, f, m = Math.min(a.t,this.t);
  for(i = 0; i < m; ++i) r[i] = op(this[i],a[i]);
  if(a.t < this.t) {
    f = a.s&this.DM;
    for(i = m; i < this.t; ++i) r[i] = op(this[i],f);
    r.t = this.t;
  }
  else {
    f = this.s&this.DM;
    for(i = m; i < a.t; ++i) r[i] = op(f,a[i]);
    r.t = a.t;
  }
  r.s = op(this.s,a.s);
  r.clamp();
}

// (public) this & a
function op_and(x,y) { return x&y; }
function bnAnd(a) { var r = nbi(); this.bitwiseTo(a,op_and,r); return r; }

// (public) this | a
function op_or(x,y) { return x|y; }
function bnOr(a) { var r = nbi(); this.bitwiseTo(a,op_or,r); return r; }

// (public) this ^ a
function op_xor(x,y) { return x^y; }
function bnXor(a) { var r = nbi(); this.bitwiseTo(a,op_xor,r); return r; }

// (public) this & ~a
function op_andnot(x,y) { return x&~y; }
function bnAndNot(a) { var r = nbi(); this.bitwiseTo(a,op_andnot,r); return r; }

// (public) ~this
function bnNot() {
  var r = nbi();
  for(var i = 0; i < this.t; ++i) r[i] = this.DM&~this[i];
  r.t = this.t;
  r.s = ~this.s;
  return r;
}

// (public) this << n
function bnShiftLeft(n) {
  var r = nbi();
  if(n < 0) this.rShiftTo(-n,r); else this.lShiftTo(n,r);
  return r;
}

// (public) this >> n
function bnShiftRight(n) {
  var r = nbi();
  if(n < 0) this.lShiftTo(-n,r); else this.rShiftTo(n,r);
  return r;
}

// return index of lowest 1-bit in x, x < 2^31
function lbit(x) {
  if(x == 0) return -1;
  var r = 0;
  if((x&0xffff) == 0) { x >>= 16; r += 16; }
  if((x&0xff) == 0) { x >>= 8; r += 8; }
  if((x&0xf) == 0) { x >>= 4; r += 4; }
  if((x&3) == 0) { x >>= 2; r += 2; }
  if((x&1) == 0) ++r;
  return r;
}

// (public) returns index of lowest 1-bit (or -1 if none)
function bnGetLowestSetBit() {
  for(var i = 0; i < this.t; ++i)
    if(this[i] != 0) return i*this.DB+lbit(this[i]);
  if(this.s < 0) return this.t*this.DB;
  return -1;
}

// return number of 1 bits in x
function cbit(x) {
  var r = 0;
  while(x != 0) { x &= x-1; ++r; }
  return r;
}

// (public) return number of set bits
function bnBitCount() {
  var r = 0, x = this.s&this.DM;
  for(var i = 0; i < this.t; ++i) r += cbit(this[i]^x);
  return r;
}

// (public) true iff nth bit is set
function bnTestBit(n) {
  var j = Math.floor(n/this.DB);
  if(j >= this.t) return(this.s!=0);
  return((this[j]&(1<<(n%this.DB)))!=0);
}

// (protected) this op (1<<n)
function bnpChangeBit(n,op) {
  var r = BigInteger.ONE.shiftLeft(n);
  this.bitwiseTo(r,op,r);
  return r;
}

// (public) this | (1<<n)
function bnSetBit(n) { return this.changeBit(n,op_or); }

// (public) this & ~(1<<n)
function bnClearBit(n) { return this.changeBit(n,op_andnot); }

// (public) this ^ (1<<n)
function bnFlipBit(n) { return this.changeBit(n,op_xor); }

// (protected) r = this + a
function bnpAddTo(a,r) {
  var i = 0, c = 0, m = Math.min(a.t,this.t);
  while(i < m) {
    c += this[i]+a[i];
    r[i++] = c&this.DM;
    c >>= this.DB;
  }
  if(a.t < this.t) {
    c += a.s;
    while(i < this.t) {
      c += this[i];
      r[i++] = c&this.DM;
      c >>= this.DB;
    }
    c += this.s;
  }
  else {
    c += this.s;
    while(i < a.t) {
      c += a[i];
      r[i++] = c&this.DM;
      c >>= this.DB;
    }
    c += a.s;
  }
  r.s = (c<0)?-1:0;
  if(c > 0) r[i++] = c;
  else if(c < -1) r[i++] = this.DV+c;
  r.t = i;
  r.clamp();
}

// (public) this + a
function bnAdd(a) { var r = nbi(); this.addTo(a,r); return r; }

// (public) this - a
function bnSubtract(a) { var r = nbi(); this.subTo(a,r); return r; }

// (public) this * a
function bnMultiply(a) { var r = nbi(); this.multiplyTo(a,r); return r; }

// (public) this^2
function bnSquare() { var r = nbi(); this.squareTo(r); return r; }

// (public) this / a
function bnDivide(a) { var r = nbi(); this.divRemTo(a,r,null); return r; }

// (public) this % a
function bnRemainder(a) { var r = nbi(); this.divRemTo(a,null,r); return r; }

// (public) [this/a,this%a]
function bnDivideAndRemainder(a) {
  var q = nbi(), r = nbi();
  this.divRemTo(a,q,r);
  return new Array(q,r);
}

// (protected) this *= n, this >= 0, 1 < n < DV
function bnpDMultiply(n) {
  this[this.t] = this.am(0,n-1,this,0,0,this.t);
  ++this.t;
  this.clamp();
}

// (protected) this += n << w words, this >= 0
function bnpDAddOffset(n,w) {
  if(n == 0) return;
  while(this.t <= w) this[this.t++] = 0;
  this[w] += n;
  while(this[w] >= this.DV) {
    this[w] -= this.DV;
    if(++w >= this.t) this[this.t++] = 0;
    ++this[w];
  }
}

// A "null" reducer
function NullExp() {}
function nNop(x) { return x; }
function nMulTo(x,y,r) { x.multiplyTo(y,r); }
function nSqrTo(x,r) { x.squareTo(r); }

NullExp.prototype.convert = nNop;
NullExp.prototype.revert = nNop;
NullExp.prototype.mulTo = nMulTo;
NullExp.prototype.sqrTo = nSqrTo;

// (public) this^e
function bnPow(e) { return this.exp(e,new NullExp()); }

// (protected) r = lower n words of "this * a", a.t <= n
// "this" should be the larger one if appropriate.
function bnpMultiplyLowerTo(a,n,r) {
  var i = Math.min(this.t+a.t,n);
  r.s = 0; // assumes a,this >= 0
  r.t = i;
  while(i > 0) r[--i] = 0;
  var j;
  for(j = r.t-this.t; i < j; ++i) r[i+this.t] = this.am(0,a[i],r,i,0,this.t);
  for(j = Math.min(a.t,n); i < j; ++i) this.am(0,a[i],r,i,0,n-i);
  r.clamp();
}

// (protected) r = "this * a" without lower n words, n > 0
// "this" should be the larger one if appropriate.
function bnpMultiplyUpperTo(a,n,r) {
  --n;
  var i = r.t = this.t+a.t-n;
  r.s = 0; // assumes a,this >= 0
  while(--i >= 0) r[i] = 0;
  for(i = Math.max(n-this.t,0); i < a.t; ++i)
    r[this.t+i-n] = this.am(n-i,a[i],r,0,0,this.t+i-n);
  r.clamp();
  r.drShiftTo(1,r);
}

// Barrett modular reduction
function Barrett(m) {
  // setup Barrett
  this.r2 = nbi();
  this.q3 = nbi();
  BigInteger.ONE.dlShiftTo(2*m.t,this.r2);
  this.mu = this.r2.divide(m);
  this.m = m;
}

function barrettConvert(x) {
  if(x.s < 0 || x.t > 2*this.m.t) return x.mod(this.m);
  else if(x.compareTo(this.m) < 0) return x;
  else { var r = nbi(); x.copyTo(r); this.reduce(r); return r; }
}

function barrettRevert(x) { return x; }

// x = x mod m (HAC 14.42)
function barrettReduce(x) {
  x.drShiftTo(this.m.t-1,this.r2);
  if(x.t > this.m.t+1) { x.t = this.m.t+1; x.clamp(); }
  this.mu.multiplyUpperTo(this.r2,this.m.t+1,this.q3);
  this.m.multiplyLowerTo(this.q3,this.m.t+1,this.r2);
  while(x.compareTo(this.r2) < 0) x.dAddOffset(1,this.m.t+1);
  x.subTo(this.r2,x);
  while(x.compareTo(this.m) >= 0) x.subTo(this.m,x);
}

// r = x^2 mod m; x != r
function barrettSqrTo(x,r) { x.squareTo(r); this.reduce(r); }

// r = x*y mod m; x,y != r
function barrettMulTo(x,y,r) { x.multiplyTo(y,r); this.reduce(r); }

Barrett.prototype.convert = barrettConvert;
Barrett.prototype.revert = barrettRevert;
Barrett.prototype.reduce = barrettReduce;
Barrett.prototype.mulTo = barrettMulTo;
Barrett.prototype.sqrTo = barrettSqrTo;

// (public) this^e % m (HAC 14.85)
function bnModPow(e,m) {
  var i = e.bitLength(), k, r = nbv(1), z;
  if(i <= 0) return r;
  else if(i < 18) k = 1;
  else if(i < 48) k = 3;
  else if(i < 144) k = 4;
  else if(i < 768) k = 5;
  else k = 6;
  if(i < 8)
    z = new Classic(m);
  else if(m.isEven())
    z = new Barrett(m);
  else
    z = new Montgomery(m);

  // precomputation
  var g = new Array(), n = 3, k1 = k-1, km = (1<<k)-1;
  g[1] = z.convert(this);
  if(k > 1) {
    var g2 = nbi();
    z.sqrTo(g[1],g2);
    while(n <= km) {
      g[n] = nbi();
      z.mulTo(g2,g[n-2],g[n]);
      n += 2;
    }
  }

  var j = e.t-1, w, is1 = true, r2 = nbi(), t;
  i = nbits(e[j])-1;
  while(j >= 0) {
    if(i >= k1) w = (e[j]>>(i-k1))&km;
    else {
      w = (e[j]&((1<<(i+1))-1))<<(k1-i);
      if(j > 0) w |= e[j-1]>>(this.DB+i-k1);
    }

    n = k;
    while((w&1) == 0) { w >>= 1; --n; }
    if((i -= n) < 0) { i += this.DB; --j; }
    if(is1) {	// ret == 1, don't bother squaring or multiplying it
      g[w].copyTo(r);
      is1 = false;
    }
    else {
      while(n > 1) { z.sqrTo(r,r2); z.sqrTo(r2,r); n -= 2; }
      if(n > 0) z.sqrTo(r,r2); else { t = r; r = r2; r2 = t; }
      z.mulTo(r2,g[w],r);
    }

    while(j >= 0 && (e[j]&(1<<i)) == 0) {
      z.sqrTo(r,r2); t = r; r = r2; r2 = t;
      if(--i < 0) { i = this.DB-1; --j; }
    }
  }
  return z.revert(r);
}

// (public) gcd(this,a) (HAC 14.54)
function bnGCD(a) {
  var x = (this.s<0)?this.negate():this.clone();
  var y = (a.s<0)?a.negate():a.clone();
  if(x.compareTo(y) < 0) { var t = x; x = y; y = t; }
  var i = x.getLowestSetBit(), g = y.getLowestSetBit();
  if(g < 0) return x;
  if(i < g) g = i;
  if(g > 0) {
    x.rShiftTo(g,x);
    y.rShiftTo(g,y);
  }
  while(x.signum() > 0) {
    if((i = x.getLowestSetBit()) > 0) x.rShiftTo(i,x);
    if((i = y.getLowestSetBit()) > 0) y.rShiftTo(i,y);
    if(x.compareTo(y) >= 0) {
      x.subTo(y,x);
      x.rShiftTo(1,x);
    }
    else {
      y.subTo(x,y);
      y.rShiftTo(1,y);
    }
  }
  if(g > 0) y.lShiftTo(g,y);
  return y;
}

// (protected) this % n, n < 2^26
function bnpModInt(n) {
  if(n <= 0) return 0;
  var d = this.DV%n, r = (this.s<0)?n-1:0;
  if(this.t > 0)
    if(d == 0) r = this[0]%n;
    else for(var i = this.t-1; i >= 0; --i) r = (d*r+this[i])%n;
  return r;
}

// (public) 1/this % m (HAC 14.61)
function bnModInverse(m) {
  var ac = m.isEven();
  if((this.isEven() && ac) || m.signum() == 0) return BigInteger.ZERO;
  var u = m.clone(), v = this.clone();
  var a = nbv(1), b = nbv(0), c = nbv(0), d = nbv(1);
  while(u.signum() != 0) {
    while(u.isEven()) {
      u.rShiftTo(1,u);
      if(ac) {
        if(!a.isEven() || !b.isEven()) { a.addTo(this,a); b.subTo(m,b); }
        a.rShiftTo(1,a);
      }
      else if(!b.isEven()) b.subTo(m,b);
      b.rShiftTo(1,b);
    }
    while(v.isEven()) {
      v.rShiftTo(1,v);
      if(ac) {
        if(!c.isEven() || !d.isEven()) { c.addTo(this,c); d.subTo(m,d); }
        c.rShiftTo(1,c);
      }
      else if(!d.isEven()) d.subTo(m,d);
      d.rShiftTo(1,d);
    }
    if(u.compareTo(v) >= 0) {
      u.subTo(v,u);
      if(ac) a.subTo(c,a);
      b.subTo(d,b);
    }
    else {
      v.subTo(u,v);
      if(ac) c.subTo(a,c);
      d.subTo(b,d);
    }
  }
  if(v.compareTo(BigInteger.ONE) != 0) return BigInteger.ZERO;
  if(d.compareTo(m) >= 0) return d.subtract(m);
  if(d.signum() < 0) d.addTo(m,d); else return d;
  if(d.signum() < 0) return d.add(m); else return d;
}

var lowprimes = [2,3,5,7,11,13,17,19,23,29,31,37,41,43,47,53,59,61,67,71,73,79,83,89,97,101,103,107,109,113,127,131,137,139,149,151,157,163,167,173,179,181,191,193,197,199,211,223,227,229,233,239,241,251,257,263,269,271,277,281,283,293,307,311,313,317,331,337,347,349,353,359,367,373,379,383,389,397,401,409,419,421,431,433,439,443,449,457,461,463,467,479,487,491,499,503,509,521,523,541,547,557,563,569,571,577,587,593,599,601,607,613,617,619,631,641,643,647,653,659,661,673,677,683,691,701,709,719,727,733,739,743,751,757,761,769,773,787,797,809,811,821,823,827,829,839,853,857,859,863,877,881,883,887,907,911,919,929,937,941,947,953,967,971,977,983,991,997];
var lplim = (1<<26)/lowprimes[lowprimes.length-1];

// (public) test primality with certainty >= 1-.5^t
function bnIsProbablePrime(t) {
  var i, x = this.abs();
  if(x.t == 1 && x[0] <= lowprimes[lowprimes.length-1]) {
    for(i = 0; i < lowprimes.length; ++i)
      if(x[0] == lowprimes[i]) return true;
    return false;
  }
  if(x.isEven()) return false;
  i = 1;
  while(i < lowprimes.length) {
    var m = lowprimes[i], j = i+1;
    while(j < lowprimes.length && m < lplim) m *= lowprimes[j++];
    m = x.modInt(m);
    while(i < j) if(m%lowprimes[i++] == 0) return false;
  }
  return x.millerRabin(t);
}

// (protected) true if probably prime (HAC 4.24, Miller-Rabin)
function bnpMillerRabin(t) {
  var n1 = this.subtract(BigInteger.ONE);
  var k = n1.getLowestSetBit();
  if(k <= 0) return false;
  var r = n1.shiftRight(k);
  t = (t+1)>>1;
  if(t > lowprimes.length) t = lowprimes.length;
  var a = nbi();
  for(var i = 0; i < t; ++i) {
    //Pick bases at random, instead of starting at 2
    a.fromInt(lowprimes[Math.floor(Math.random()*lowprimes.length)]);
    var y = a.modPow(r,this);
    if(y.compareTo(BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {
      var j = 1;
      while(j++ < k && y.compareTo(n1) != 0) {
        y = y.modPowInt(2,this);
        if(y.compareTo(BigInteger.ONE) == 0) return false;
      }
      if(y.compareTo(n1) != 0) return false;
    }
  }
  return true;
}

// protected
BigInteger.prototype.chunkSize = bnpChunkSize;
BigInteger.prototype.toRadix = bnpToRadix;
BigInteger.prototype.fromRadix = bnpFromRadix;
BigInteger.prototype.fromNumber = bnpFromNumber;
BigInteger.prototype.bitwiseTo = bnpBitwiseTo;
BigInteger.prototype.changeBit = bnpChangeBit;
BigInteger.prototype.addTo = bnpAddTo;
BigInteger.prototype.dMultiply = bnpDMultiply;
BigInteger.prototype.dAddOffset = bnpDAddOffset;
BigInteger.prototype.multiplyLowerTo = bnpMultiplyLowerTo;
BigInteger.prototype.multiplyUpperTo = bnpMultiplyUpperTo;
BigInteger.prototype.modInt = bnpModInt;
BigInteger.prototype.millerRabin = bnpMillerRabin;

// public
BigInteger.prototype.clone = bnClone;
BigInteger.prototype.intValue = bnIntValue;
BigInteger.prototype.byteValue = bnByteValue;
BigInteger.prototype.shortValue = bnShortValue;
BigInteger.prototype.signum = bnSigNum;
BigInteger.prototype.toByteArray = bnToByteArray;
BigInteger.prototype.equals = bnEquals;
BigInteger.prototype.min = bnMin;
BigInteger.prototype.max = bnMax;
BigInteger.prototype.and = bnAnd;
BigInteger.prototype.or = bnOr;
BigInteger.prototype.xor = bnXor;
BigInteger.prototype.andNot = bnAndNot;
BigInteger.prototype.not = bnNot;
BigInteger.prototype.shiftLeft = bnShiftLeft;
BigInteger.prototype.shiftRight = bnShiftRight;
BigInteger.prototype.getLowestSetBit = bnGetLowestSetBit;
BigInteger.prototype.bitCount = bnBitCount;
BigInteger.prototype.testBit = bnTestBit;
BigInteger.prototype.setBit = bnSetBit;
BigInteger.prototype.clearBit = bnClearBit;
BigInteger.prototype.flipBit = bnFlipBit;
BigInteger.prototype.add = bnAdd;
BigInteger.prototype.subtract = bnSubtract;
BigInteger.prototype.multiply = bnMultiply;
BigInteger.prototype.divide = bnDivide;
BigInteger.prototype.remainder = bnRemainder;
BigInteger.prototype.divideAndRemainder = bnDivideAndRemainder;
BigInteger.prototype.modPow = bnModPow;
BigInteger.prototype.modInverse = bnModInverse;
BigInteger.prototype.pow = bnPow;
BigInteger.prototype.gcd = bnGCD;
BigInteger.prototype.isProbablePrime = bnIsProbablePrime;

// JSBN-specific extension
BigInteger.prototype.square = bnSquare;

// BigInteger interfaces not implemented in jsbn:

// BigInteger(int signum, byte[] magnitude)
// double doubleValue()
// float floatValue()
// int hashCode()
// long longValue()
// static BigInteger valueOf(long val)

//! moment.js
//! version : 2.14.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
!function(a,b){"object"==typeof exports&&"undefined"!=typeof module?module.exports=b():"function"==typeof define&&define.amd?define(b):a.moment=b()}(this,function(){"use strict";function a(){return md.apply(null,arguments)}
// This is done to register the method called with moment()
// without creating circular dependencies.
function b(a){md=a}function c(a){return a instanceof Array||"[object Array]"===Object.prototype.toString.call(a)}function d(a){return"[object Object]"===Object.prototype.toString.call(a)}function e(a){var b;for(b in a)
// even if its not own property I'd still call it non-empty
return!1;return!0}function f(a){return a instanceof Date||"[object Date]"===Object.prototype.toString.call(a)}function g(a,b){var c,d=[];for(c=0;c<a.length;++c)d.push(b(a[c],c));return d}function h(a,b){return Object.prototype.hasOwnProperty.call(a,b)}function i(a,b){for(var c in b)h(b,c)&&(a[c]=b[c]);return h(b,"toString")&&(a.toString=b.toString),h(b,"valueOf")&&(a.valueOf=b.valueOf),a}function j(a,b,c,d){return qb(a,b,c,d,!0).utc()}function k(){
// We need to deep clone this object.
return{empty:!1,unusedTokens:[],unusedInput:[],overflow:-2,charsLeftOver:0,nullInput:!1,invalidMonth:null,invalidFormat:!1,userInvalidated:!1,iso:!1,parsedDateParts:[],meridiem:null}}function l(a){return null==a._pf&&(a._pf=k()),a._pf}function m(a){if(null==a._isValid){var b=l(a),c=nd.call(b.parsedDateParts,function(a){return null!=a});a._isValid=!isNaN(a._d.getTime())&&b.overflow<0&&!b.empty&&!b.invalidMonth&&!b.invalidWeekday&&!b.nullInput&&!b.invalidFormat&&!b.userInvalidated&&(!b.meridiem||b.meridiem&&c),a._strict&&(a._isValid=a._isValid&&0===b.charsLeftOver&&0===b.unusedTokens.length&&void 0===b.bigHour)}return a._isValid}function n(a){var b=j(NaN);return null!=a?i(l(b),a):l(b).userInvalidated=!0,b}function o(a){return void 0===a}function p(a,b){var c,d,e;if(o(b._isAMomentObject)||(a._isAMomentObject=b._isAMomentObject),o(b._i)||(a._i=b._i),o(b._f)||(a._f=b._f),o(b._l)||(a._l=b._l),o(b._strict)||(a._strict=b._strict),o(b._tzm)||(a._tzm=b._tzm),o(b._isUTC)||(a._isUTC=b._isUTC),o(b._offset)||(a._offset=b._offset),o(b._pf)||(a._pf=l(b)),o(b._locale)||(a._locale=b._locale),od.length>0)for(c in od)d=od[c],e=b[d],o(e)||(a[d]=e);return a}
// Moment prototype object
function q(b){p(this,b),this._d=new Date(null!=b._d?b._d.getTime():NaN),pd===!1&&(pd=!0,a.updateOffset(this),pd=!1)}function r(a){return a instanceof q||null!=a&&null!=a._isAMomentObject}function s(a){return 0>a?Math.ceil(a)||0:Math.floor(a)}function t(a){var b=+a,c=0;return 0!==b&&isFinite(b)&&(c=s(b)),c}
// compare two arrays, return the number of differences
function u(a,b,c){var d,e=Math.min(a.length,b.length),f=Math.abs(a.length-b.length),g=0;for(d=0;e>d;d++)(c&&a[d]!==b[d]||!c&&t(a[d])!==t(b[d]))&&g++;return g+f}function v(b){a.suppressDeprecationWarnings===!1&&"undefined"!=typeof console&&console.warn&&console.warn("Deprecation warning: "+b)}function w(b,c){var d=!0;return i(function(){return null!=a.deprecationHandler&&a.deprecationHandler(null,b),d&&(v(b+"\nArguments: "+Array.prototype.slice.call(arguments).join(", ")+"\n"+(new Error).stack),d=!1),c.apply(this,arguments)},c)}function x(b,c){null!=a.deprecationHandler&&a.deprecationHandler(b,c),qd[b]||(v(c),qd[b]=!0)}function y(a){return a instanceof Function||"[object Function]"===Object.prototype.toString.call(a)}function z(a){var b,c;for(c in a)b=a[c],y(b)?this[c]=b:this["_"+c]=b;this._config=a,
// Lenient ordinal parsing accepts just a number in addition to
// number + (possibly) stuff coming from _ordinalParseLenient.
this._ordinalParseLenient=new RegExp(this._ordinalParse.source+"|"+/\d{1,2}/.source)}function A(a,b){var c,e=i({},a);for(c in b)h(b,c)&&(d(a[c])&&d(b[c])?(e[c]={},i(e[c],a[c]),i(e[c],b[c])):null!=b[c]?e[c]=b[c]:delete e[c]);for(c in a)h(a,c)&&!h(b,c)&&d(a[c])&&(
// make sure changes to properties don't modify parent config
e[c]=i({},e[c]));return e}function B(a){null!=a&&this.set(a)}function C(a,b,c){var d=this._calendar[a]||this._calendar.sameElse;return y(d)?d.call(b,c):d}function D(a){var b=this._longDateFormat[a],c=this._longDateFormat[a.toUpperCase()];return b||!c?b:(this._longDateFormat[a]=c.replace(/MMMM|MM|DD|dddd/g,function(a){return a.slice(1)}),this._longDateFormat[a])}function E(){return this._invalidDate}function F(a){return this._ordinal.replace("%d",a)}function G(a,b,c,d){var e=this._relativeTime[c];return y(e)?e(a,b,c,d):e.replace(/%d/i,a)}function H(a,b){var c=this._relativeTime[a>0?"future":"past"];return y(c)?c(b):c.replace(/%s/i,b)}function I(a,b){var c=a.toLowerCase();zd[c]=zd[c+"s"]=zd[b]=a}function J(a){return"string"==typeof a?zd[a]||zd[a.toLowerCase()]:void 0}function K(a){var b,c,d={};for(c in a)h(a,c)&&(b=J(c),b&&(d[b]=a[c]));return d}function L(a,b){Ad[a]=b}function M(a){var b=[];for(var c in a)b.push({unit:c,priority:Ad[c]});return b.sort(function(a,b){return a.priority-b.priority}),b}function N(b,c){return function(d){return null!=d?(P(this,b,d),a.updateOffset(this,c),this):O(this,b)}}function O(a,b){return a.isValid()?a._d["get"+(a._isUTC?"UTC":"")+b]():NaN}function P(a,b,c){a.isValid()&&a._d["set"+(a._isUTC?"UTC":"")+b](c)}
// MOMENTS
function Q(a){return a=J(a),y(this[a])?this[a]():this}function R(a,b){if("object"==typeof a){a=K(a);for(var c=M(a),d=0;d<c.length;d++)this[c[d].unit](a[c[d].unit])}else if(a=J(a),y(this[a]))return this[a](b);return this}function S(a,b,c){var d=""+Math.abs(a),e=b-d.length,f=a>=0;return(f?c?"+":"":"-")+Math.pow(10,Math.max(0,e)).toString().substr(1)+d}
// token:    'M'
// padded:   ['MM', 2]
// ordinal:  'Mo'
// callback: function () { this.month() + 1 }
function T(a,b,c,d){var e=d;"string"==typeof d&&(e=function(){return this[d]()}),a&&(Ed[a]=e),b&&(Ed[b[0]]=function(){return S(e.apply(this,arguments),b[1],b[2])}),c&&(Ed[c]=function(){return this.localeData().ordinal(e.apply(this,arguments),a)})}function U(a){return a.match(/\[[\s\S]/)?a.replace(/^\[|\]$/g,""):a.replace(/\\/g,"")}function V(a){var b,c,d=a.match(Bd);for(b=0,c=d.length;c>b;b++)Ed[d[b]]?d[b]=Ed[d[b]]:d[b]=U(d[b]);return function(b){var e,f="";for(e=0;c>e;e++)f+=d[e]instanceof Function?d[e].call(b,a):d[e];return f}}
// format date using native date object
function W(a,b){return a.isValid()?(b=X(b,a.localeData()),Dd[b]=Dd[b]||V(b),Dd[b](a)):a.localeData().invalidDate()}function X(a,b){function c(a){return b.longDateFormat(a)||a}var d=5;for(Cd.lastIndex=0;d>=0&&Cd.test(a);)a=a.replace(Cd,c),Cd.lastIndex=0,d-=1;return a}function Y(a,b,c){Wd[a]=y(b)?b:function(a,d){return a&&c?c:b}}function Z(a,b){return h(Wd,a)?Wd[a](b._strict,b._locale):new RegExp($(a))}
// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
function $(a){return _(a.replace("\\","").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,function(a,b,c,d,e){return b||c||d||e}))}function _(a){return a.replace(/[-\/\\^$*+?.()|[\]{}]/g,"\\$&")}function aa(a,b){var c,d=b;for("string"==typeof a&&(a=[a]),"number"==typeof b&&(d=function(a,c){c[b]=t(a)}),c=0;c<a.length;c++)Xd[a[c]]=d}function ba(a,b){aa(a,function(a,c,d,e){d._w=d._w||{},b(a,d._w,d,e)})}function ca(a,b,c){null!=b&&h(Xd,a)&&Xd[a](b,c._a,c,a)}function da(a,b){return new Date(Date.UTC(a,b+1,0)).getUTCDate()}function ea(a,b){return c(this._months)?this._months[a.month()]:this._months[(this._months.isFormat||fe).test(b)?"format":"standalone"][a.month()]}function fa(a,b){return c(this._monthsShort)?this._monthsShort[a.month()]:this._monthsShort[fe.test(b)?"format":"standalone"][a.month()]}function ga(a,b,c){var d,e,f,g=a.toLocaleLowerCase();if(!this._monthsParse)for(
// this is not used
this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[],d=0;12>d;++d)f=j([2e3,d]),this._shortMonthsParse[d]=this.monthsShort(f,"").toLocaleLowerCase(),this._longMonthsParse[d]=this.months(f,"").toLocaleLowerCase();return c?"MMM"===b?(e=sd.call(this._shortMonthsParse,g),-1!==e?e:null):(e=sd.call(this._longMonthsParse,g),-1!==e?e:null):"MMM"===b?(e=sd.call(this._shortMonthsParse,g),-1!==e?e:(e=sd.call(this._longMonthsParse,g),-1!==e?e:null)):(e=sd.call(this._longMonthsParse,g),-1!==e?e:(e=sd.call(this._shortMonthsParse,g),-1!==e?e:null))}function ha(a,b,c){var d,e,f;if(this._monthsParseExact)return ga.call(this,a,b,c);
// TODO: add sorting
// Sorting makes sure if one month (or abbr) is a prefix of another
// see sorting in computeMonthsParse
for(this._monthsParse||(this._monthsParse=[],this._longMonthsParse=[],this._shortMonthsParse=[]),d=0;12>d;d++){
// test the regex
if(e=j([2e3,d]),c&&!this._longMonthsParse[d]&&(this._longMonthsParse[d]=new RegExp("^"+this.months(e,"").replace(".","")+"$","i"),this._shortMonthsParse[d]=new RegExp("^"+this.monthsShort(e,"").replace(".","")+"$","i")),c||this._monthsParse[d]||(f="^"+this.months(e,"")+"|^"+this.monthsShort(e,""),this._monthsParse[d]=new RegExp(f.replace(".",""),"i")),c&&"MMMM"===b&&this._longMonthsParse[d].test(a))return d;if(c&&"MMM"===b&&this._shortMonthsParse[d].test(a))return d;if(!c&&this._monthsParse[d].test(a))return d}}
// MOMENTS
function ia(a,b){var c;if(!a.isValid())
// No op
return a;if("string"==typeof b)if(/^\d+$/.test(b))b=t(b);else
// TODO: Another silent failure?
if(b=a.localeData().monthsParse(b),"number"!=typeof b)return a;return c=Math.min(a.date(),da(a.year(),b)),a._d["set"+(a._isUTC?"UTC":"")+"Month"](b,c),a}function ja(b){return null!=b?(ia(this,b),a.updateOffset(this,!0),this):O(this,"Month")}function ka(){return da(this.year(),this.month())}function la(a){return this._monthsParseExact?(h(this,"_monthsRegex")||na.call(this),a?this._monthsShortStrictRegex:this._monthsShortRegex):(h(this,"_monthsShortRegex")||(this._monthsShortRegex=ie),this._monthsShortStrictRegex&&a?this._monthsShortStrictRegex:this._monthsShortRegex)}function ma(a){return this._monthsParseExact?(h(this,"_monthsRegex")||na.call(this),a?this._monthsStrictRegex:this._monthsRegex):(h(this,"_monthsRegex")||(this._monthsRegex=je),this._monthsStrictRegex&&a?this._monthsStrictRegex:this._monthsRegex)}function na(){function a(a,b){return b.length-a.length}var b,c,d=[],e=[],f=[];for(b=0;12>b;b++)c=j([2e3,b]),d.push(this.monthsShort(c,"")),e.push(this.months(c,"")),f.push(this.months(c,"")),f.push(this.monthsShort(c,""));for(
// Sorting makes sure if one month (or abbr) is a prefix of another it
// will match the longer piece.
d.sort(a),e.sort(a),f.sort(a),b=0;12>b;b++)d[b]=_(d[b]),e[b]=_(e[b]);for(b=0;24>b;b++)f[b]=_(f[b]);this._monthsRegex=new RegExp("^("+f.join("|")+")","i"),this._monthsShortRegex=this._monthsRegex,this._monthsStrictRegex=new RegExp("^("+e.join("|")+")","i"),this._monthsShortStrictRegex=new RegExp("^("+d.join("|")+")","i")}
// HELPERS
function oa(a){return pa(a)?366:365}function pa(a){return a%4===0&&a%100!==0||a%400===0}function qa(){return pa(this.year())}function ra(a,b,c,d,e,f,g){
//can't just apply() to create a date:
//http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
var h=new Date(a,b,c,d,e,f,g);
//the date constructor remaps years 0-99 to 1900-1999
return 100>a&&a>=0&&isFinite(h.getFullYear())&&h.setFullYear(a),h}function sa(a){var b=new Date(Date.UTC.apply(null,arguments));
//the Date.UTC function remaps years 0-99 to 1900-1999
return 100>a&&a>=0&&isFinite(b.getUTCFullYear())&&b.setUTCFullYear(a),b}
// start-of-first-week - start-of-year
function ta(a,b,c){var// first-week day -- which january is always in the first week (4 for iso, 1 for other)
d=7+b-c,
// first-week day local weekday -- which local weekday is fwd
e=(7+sa(a,0,d).getUTCDay()-b)%7;return-e+d-1}
//http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
function ua(a,b,c,d,e){var f,g,h=(7+c-d)%7,i=ta(a,d,e),j=1+7*(b-1)+h+i;return 0>=j?(f=a-1,g=oa(f)+j):j>oa(a)?(f=a+1,g=j-oa(a)):(f=a,g=j),{year:f,dayOfYear:g}}function va(a,b,c){var d,e,f=ta(a.year(),b,c),g=Math.floor((a.dayOfYear()-f-1)/7)+1;return 1>g?(e=a.year()-1,d=g+wa(e,b,c)):g>wa(a.year(),b,c)?(d=g-wa(a.year(),b,c),e=a.year()+1):(e=a.year(),d=g),{week:d,year:e}}function wa(a,b,c){var d=ta(a,b,c),e=ta(a+1,b,c);return(oa(a)-d+e)/7}
// HELPERS
// LOCALES
function xa(a){return va(a,this._week.dow,this._week.doy).week}function ya(){return this._week.dow}function za(){return this._week.doy}
// MOMENTS
function Aa(a){var b=this.localeData().week(this);return null==a?b:this.add(7*(a-b),"d")}function Ba(a){var b=va(this,1,4).week;return null==a?b:this.add(7*(a-b),"d")}
// HELPERS
function Ca(a,b){return"string"!=typeof a?a:isNaN(a)?(a=b.weekdaysParse(a),"number"==typeof a?a:null):parseInt(a,10)}function Da(a,b){return"string"==typeof a?b.weekdaysParse(a)%7||7:isNaN(a)?null:a}function Ea(a,b){return c(this._weekdays)?this._weekdays[a.day()]:this._weekdays[this._weekdays.isFormat.test(b)?"format":"standalone"][a.day()]}function Fa(a){return this._weekdaysShort[a.day()]}function Ga(a){return this._weekdaysMin[a.day()]}function Ha(a,b,c){var d,e,f,g=a.toLocaleLowerCase();if(!this._weekdaysParse)for(this._weekdaysParse=[],this._shortWeekdaysParse=[],this._minWeekdaysParse=[],d=0;7>d;++d)f=j([2e3,1]).day(d),this._minWeekdaysParse[d]=this.weekdaysMin(f,"").toLocaleLowerCase(),this._shortWeekdaysParse[d]=this.weekdaysShort(f,"").toLocaleLowerCase(),this._weekdaysParse[d]=this.weekdays(f,"").toLocaleLowerCase();return c?"dddd"===b?(e=sd.call(this._weekdaysParse,g),-1!==e?e:null):"ddd"===b?(e=sd.call(this._shortWeekdaysParse,g),-1!==e?e:null):(e=sd.call(this._minWeekdaysParse,g),-1!==e?e:null):"dddd"===b?(e=sd.call(this._weekdaysParse,g),-1!==e?e:(e=sd.call(this._shortWeekdaysParse,g),-1!==e?e:(e=sd.call(this._minWeekdaysParse,g),-1!==e?e:null))):"ddd"===b?(e=sd.call(this._shortWeekdaysParse,g),-1!==e?e:(e=sd.call(this._weekdaysParse,g),-1!==e?e:(e=sd.call(this._minWeekdaysParse,g),-1!==e?e:null))):(e=sd.call(this._minWeekdaysParse,g),-1!==e?e:(e=sd.call(this._weekdaysParse,g),-1!==e?e:(e=sd.call(this._shortWeekdaysParse,g),-1!==e?e:null)))}function Ia(a,b,c){var d,e,f;if(this._weekdaysParseExact)return Ha.call(this,a,b,c);for(this._weekdaysParse||(this._weekdaysParse=[],this._minWeekdaysParse=[],this._shortWeekdaysParse=[],this._fullWeekdaysParse=[]),d=0;7>d;d++){
// test the regex
if(e=j([2e3,1]).day(d),c&&!this._fullWeekdaysParse[d]&&(this._fullWeekdaysParse[d]=new RegExp("^"+this.weekdays(e,"").replace(".",".?")+"$","i"),this._shortWeekdaysParse[d]=new RegExp("^"+this.weekdaysShort(e,"").replace(".",".?")+"$","i"),this._minWeekdaysParse[d]=new RegExp("^"+this.weekdaysMin(e,"").replace(".",".?")+"$","i")),this._weekdaysParse[d]||(f="^"+this.weekdays(e,"")+"|^"+this.weekdaysShort(e,"")+"|^"+this.weekdaysMin(e,""),this._weekdaysParse[d]=new RegExp(f.replace(".",""),"i")),c&&"dddd"===b&&this._fullWeekdaysParse[d].test(a))return d;if(c&&"ddd"===b&&this._shortWeekdaysParse[d].test(a))return d;if(c&&"dd"===b&&this._minWeekdaysParse[d].test(a))return d;if(!c&&this._weekdaysParse[d].test(a))return d}}
// MOMENTS
function Ja(a){if(!this.isValid())return null!=a?this:NaN;var b=this._isUTC?this._d.getUTCDay():this._d.getDay();return null!=a?(a=Ca(a,this.localeData()),this.add(a-b,"d")):b}function Ka(a){if(!this.isValid())return null!=a?this:NaN;var b=(this.day()+7-this.localeData()._week.dow)%7;return null==a?b:this.add(a-b,"d")}function La(a){if(!this.isValid())return null!=a?this:NaN;
// behaves the same as moment#day except
// as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
// as a setter, sunday should belong to the previous week.
if(null!=a){var b=Da(a,this.localeData());return this.day(this.day()%7?b:b-7)}return this.day()||7}function Ma(a){return this._weekdaysParseExact?(h(this,"_weekdaysRegex")||Pa.call(this),a?this._weekdaysStrictRegex:this._weekdaysRegex):(h(this,"_weekdaysRegex")||(this._weekdaysRegex=pe),this._weekdaysStrictRegex&&a?this._weekdaysStrictRegex:this._weekdaysRegex)}function Na(a){return this._weekdaysParseExact?(h(this,"_weekdaysRegex")||Pa.call(this),a?this._weekdaysShortStrictRegex:this._weekdaysShortRegex):(h(this,"_weekdaysShortRegex")||(this._weekdaysShortRegex=qe),this._weekdaysShortStrictRegex&&a?this._weekdaysShortStrictRegex:this._weekdaysShortRegex)}function Oa(a){return this._weekdaysParseExact?(h(this,"_weekdaysRegex")||Pa.call(this),a?this._weekdaysMinStrictRegex:this._weekdaysMinRegex):(h(this,"_weekdaysMinRegex")||(this._weekdaysMinRegex=re),this._weekdaysMinStrictRegex&&a?this._weekdaysMinStrictRegex:this._weekdaysMinRegex)}function Pa(){function a(a,b){return b.length-a.length}var b,c,d,e,f,g=[],h=[],i=[],k=[];for(b=0;7>b;b++)c=j([2e3,1]).day(b),d=this.weekdaysMin(c,""),e=this.weekdaysShort(c,""),f=this.weekdays(c,""),g.push(d),h.push(e),i.push(f),k.push(d),k.push(e),k.push(f);for(
// Sorting makes sure if one weekday (or abbr) is a prefix of another it
// will match the longer piece.
g.sort(a),h.sort(a),i.sort(a),k.sort(a),b=0;7>b;b++)h[b]=_(h[b]),i[b]=_(i[b]),k[b]=_(k[b]);this._weekdaysRegex=new RegExp("^("+k.join("|")+")","i"),this._weekdaysShortRegex=this._weekdaysRegex,this._weekdaysMinRegex=this._weekdaysRegex,this._weekdaysStrictRegex=new RegExp("^("+i.join("|")+")","i"),this._weekdaysShortStrictRegex=new RegExp("^("+h.join("|")+")","i"),this._weekdaysMinStrictRegex=new RegExp("^("+g.join("|")+")","i")}
// FORMATTING
function Qa(){return this.hours()%12||12}function Ra(){return this.hours()||24}function Sa(a,b){T(a,0,0,function(){return this.localeData().meridiem(this.hours(),this.minutes(),b)})}
// PARSING
function Ta(a,b){return b._meridiemParse}
// LOCALES
function Ua(a){
// IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
// Using charAt should be more compatible.
return"p"===(a+"").toLowerCase().charAt(0)}function Va(a,b,c){return a>11?c?"pm":"PM":c?"am":"AM"}function Wa(a){return a?a.toLowerCase().replace("_","-"):a}
// pick the locale from the array
// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
function Xa(a){for(var b,c,d,e,f=0;f<a.length;){for(e=Wa(a[f]).split("-"),b=e.length,c=Wa(a[f+1]),c=c?c.split("-"):null;b>0;){if(d=Ya(e.slice(0,b).join("-")))return d;if(c&&c.length>=b&&u(e,c,!0)>=b-1)
//the next array item is better than a shallower substring of this one
break;b--}f++}return null}function Ya(a){var b=null;
// TODO: Find a better way to register and load all the locales in Node
if(!we[a]&&"undefined"!=typeof module&&module&&module.exports)try{b=se._abbr,require("./locale/"+a),
// because defineLocale currently also sets the global locale, we
// want to undo that for lazy loaded locales
Za(b)}catch(c){}return we[a]}
// This function will load locale and then set the global locale.  If
// no arguments are passed in, it will simply return the current global
// locale key.
function Za(a,b){var c;
// moment.duration._locale = moment._locale = data;
return a&&(c=o(b)?ab(a):$a(a,b),c&&(se=c)),se._abbr}function $a(a,b){if(null!==b){var c=ve;
// treat as if there is no base config
// backwards compat for now: also set the locale
return b.abbr=a,null!=we[a]?(x("defineLocaleOverride","use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."),c=we[a]._config):null!=b.parentLocale&&(null!=we[b.parentLocale]?c=we[b.parentLocale]._config:x("parentLocaleUndefined","specified parentLocale is not defined yet. See http://momentjs.com/guides/#/warnings/parent-locale/")),we[a]=new B(A(c,b)),Za(a),we[a]}
// useful for testing
return delete we[a],null}function _a(a,b){if(null!=b){var c,d=ve;
// MERGE
null!=we[a]&&(d=we[a]._config),b=A(d,b),c=new B(b),c.parentLocale=we[a],we[a]=c,
// backwards compat for now: also set the locale
Za(a)}else
// pass null for config to unupdate, useful for tests
null!=we[a]&&(null!=we[a].parentLocale?we[a]=we[a].parentLocale:null!=we[a]&&delete we[a]);return we[a]}
// returns locale data
function ab(a){var b;if(a&&a._locale&&a._locale._abbr&&(a=a._locale._abbr),!a)return se;if(!c(a)){if(b=Ya(a))return b;a=[a]}return Xa(a)}function bb(){return rd(we)}function cb(a){var b,c=a._a;return c&&-2===l(a).overflow&&(b=c[Zd]<0||c[Zd]>11?Zd:c[$d]<1||c[$d]>da(c[Yd],c[Zd])?$d:c[_d]<0||c[_d]>24||24===c[_d]&&(0!==c[ae]||0!==c[be]||0!==c[ce])?_d:c[ae]<0||c[ae]>59?ae:c[be]<0||c[be]>59?be:c[ce]<0||c[ce]>999?ce:-1,l(a)._overflowDayOfYear&&(Yd>b||b>$d)&&(b=$d),l(a)._overflowWeeks&&-1===b&&(b=de),l(a)._overflowWeekday&&-1===b&&(b=ee),l(a).overflow=b),a}
// date from iso format
function db(a){var b,c,d,e,f,g,h=a._i,i=xe.exec(h)||ye.exec(h);if(i){for(l(a).iso=!0,b=0,c=Ae.length;c>b;b++)if(Ae[b][1].exec(i[1])){e=Ae[b][0],d=Ae[b][2]!==!1;break}if(null==e)return void(a._isValid=!1);if(i[3]){for(b=0,c=Be.length;c>b;b++)if(Be[b][1].exec(i[3])){
// match[2] should be 'T' or space
f=(i[2]||" ")+Be[b][0];break}if(null==f)return void(a._isValid=!1)}if(!d&&null!=f)return void(a._isValid=!1);if(i[4]){if(!ze.exec(i[4]))return void(a._isValid=!1);g="Z"}a._f=e+(f||"")+(g||""),jb(a)}else a._isValid=!1}
// date from iso format or fallback
function eb(b){var c=Ce.exec(b._i);return null!==c?void(b._d=new Date(+c[1])):(db(b),void(b._isValid===!1&&(delete b._isValid,a.createFromInputFallback(b))))}
// Pick the first defined of two or three arguments.
function fb(a,b,c){return null!=a?a:null!=b?b:c}function gb(b){
// hooks is actually the exported moment object
var c=new Date(a.now());return b._useUTC?[c.getUTCFullYear(),c.getUTCMonth(),c.getUTCDate()]:[c.getFullYear(),c.getMonth(),c.getDate()]}
// convert an array to a date.
// the array should mirror the parameters below
// note: all values past the year are optional and will default to the lowest possible value.
// [year, month, day , hour, minute, second, millisecond]
function hb(a){var b,c,d,e,f=[];if(!a._d){
// Default to current date.
// * if no year, month, day of month are given, default to today
// * if day of month is given, default month and year
// * if month is given, default only year
// * if year is given, don't default anything
for(d=gb(a),a._w&&null==a._a[$d]&&null==a._a[Zd]&&ib(a),a._dayOfYear&&(e=fb(a._a[Yd],d[Yd]),a._dayOfYear>oa(e)&&(l(a)._overflowDayOfYear=!0),c=sa(e,0,a._dayOfYear),a._a[Zd]=c.getUTCMonth(),a._a[$d]=c.getUTCDate()),b=0;3>b&&null==a._a[b];++b)a._a[b]=f[b]=d[b];
// Zero out whatever was not defaulted, including time
for(;7>b;b++)a._a[b]=f[b]=null==a._a[b]?2===b?1:0:a._a[b];
// Check for 24:00:00.000
24===a._a[_d]&&0===a._a[ae]&&0===a._a[be]&&0===a._a[ce]&&(a._nextDay=!0,a._a[_d]=0),a._d=(a._useUTC?sa:ra).apply(null,f),
// Apply timezone offset from input. The actual utcOffset can be changed
// with parseZone.
null!=a._tzm&&a._d.setUTCMinutes(a._d.getUTCMinutes()-a._tzm),a._nextDay&&(a._a[_d]=24)}}function ib(a){var b,c,d,e,f,g,h,i;b=a._w,null!=b.GG||null!=b.W||null!=b.E?(f=1,g=4,c=fb(b.GG,a._a[Yd],va(rb(),1,4).year),d=fb(b.W,1),e=fb(b.E,1),(1>e||e>7)&&(i=!0)):(f=a._locale._week.dow,g=a._locale._week.doy,c=fb(b.gg,a._a[Yd],va(rb(),f,g).year),d=fb(b.w,1),null!=b.d?(e=b.d,(0>e||e>6)&&(i=!0)):null!=b.e?(e=b.e+f,(b.e<0||b.e>6)&&(i=!0)):e=f),1>d||d>wa(c,f,g)?l(a)._overflowWeeks=!0:null!=i?l(a)._overflowWeekday=!0:(h=ua(c,d,e,f,g),a._a[Yd]=h.year,a._dayOfYear=h.dayOfYear)}
// date from string and format string
function jb(b){
// TODO: Move this to another part of the creation flow to prevent circular deps
if(b._f===a.ISO_8601)return void db(b);b._a=[],l(b).empty=!0;
// This array is used to make a Date, either with `new Date` or `Date.UTC`
var c,d,e,f,g,h=""+b._i,i=h.length,j=0;for(e=X(b._f,b._locale).match(Bd)||[],c=0;c<e.length;c++)f=e[c],d=(h.match(Z(f,b))||[])[0],d&&(g=h.substr(0,h.indexOf(d)),g.length>0&&l(b).unusedInput.push(g),h=h.slice(h.indexOf(d)+d.length),j+=d.length),Ed[f]?(d?l(b).empty=!1:l(b).unusedTokens.push(f),ca(f,d,b)):b._strict&&!d&&l(b).unusedTokens.push(f);
// add remaining unparsed input length to the string
l(b).charsLeftOver=i-j,h.length>0&&l(b).unusedInput.push(h),
// clear _12h flag if hour is <= 12
b._a[_d]<=12&&l(b).bigHour===!0&&b._a[_d]>0&&(l(b).bigHour=void 0),l(b).parsedDateParts=b._a.slice(0),l(b).meridiem=b._meridiem,
// handle meridiem
b._a[_d]=kb(b._locale,b._a[_d],b._meridiem),hb(b),cb(b)}function kb(a,b,c){var d;
// Fallback
return null==c?b:null!=a.meridiemHour?a.meridiemHour(b,c):null!=a.isPM?(d=a.isPM(c),d&&12>b&&(b+=12),d||12!==b||(b=0),b):b}
// date from string and array of format strings
function lb(a){var b,c,d,e,f;if(0===a._f.length)return l(a).invalidFormat=!0,void(a._d=new Date(NaN));for(e=0;e<a._f.length;e++)f=0,b=p({},a),null!=a._useUTC&&(b._useUTC=a._useUTC),b._f=a._f[e],jb(b),m(b)&&(f+=l(b).charsLeftOver,f+=10*l(b).unusedTokens.length,l(b).score=f,(null==d||d>f)&&(d=f,c=b));i(a,c||b)}function mb(a){if(!a._d){var b=K(a._i);a._a=g([b.year,b.month,b.day||b.date,b.hour,b.minute,b.second,b.millisecond],function(a){return a&&parseInt(a,10)}),hb(a)}}function nb(a){var b=new q(cb(ob(a)));
// Adding is smart enough around DST
return b._nextDay&&(b.add(1,"d"),b._nextDay=void 0),b}function ob(a){var b=a._i,d=a._f;return a._locale=a._locale||ab(a._l),null===b||void 0===d&&""===b?n({nullInput:!0}):("string"==typeof b&&(a._i=b=a._locale.preparse(b)),r(b)?new q(cb(b)):(c(d)?lb(a):f(b)?a._d=b:d?jb(a):pb(a),m(a)||(a._d=null),a))}function pb(b){var d=b._i;void 0===d?b._d=new Date(a.now()):f(d)?b._d=new Date(d.valueOf()):"string"==typeof d?eb(b):c(d)?(b._a=g(d.slice(0),function(a){return parseInt(a,10)}),hb(b)):"object"==typeof d?mb(b):"number"==typeof d?
// from milliseconds
b._d=new Date(d):a.createFromInputFallback(b)}function qb(a,b,f,g,h){var i={};
// object construction must be done this way.
// https://github.com/moment/moment/issues/1423
return"boolean"==typeof f&&(g=f,f=void 0),(d(a)&&e(a)||c(a)&&0===a.length)&&(a=void 0),i._isAMomentObject=!0,i._useUTC=i._isUTC=h,i._l=f,i._i=a,i._f=b,i._strict=g,nb(i)}function rb(a,b,c,d){return qb(a,b,c,d,!1)}
// Pick a moment m from moments so that m[fn](other) is true for all
// other. This relies on the function fn to be transitive.
//
// moments should either be an array of moment objects or an array, whose
// first element is an array of moment objects.
function sb(a,b){var d,e;if(1===b.length&&c(b[0])&&(b=b[0]),!b.length)return rb();for(d=b[0],e=1;e<b.length;++e)b[e].isValid()&&!b[e][a](d)||(d=b[e]);return d}
// TODO: Use [].sort instead?
function tb(){var a=[].slice.call(arguments,0);return sb("isBefore",a)}function ub(){var a=[].slice.call(arguments,0);return sb("isAfter",a)}function vb(a){var b=K(a),c=b.year||0,d=b.quarter||0,e=b.month||0,f=b.week||0,g=b.day||0,h=b.hour||0,i=b.minute||0,j=b.second||0,k=b.millisecond||0;
// representation for dateAddRemove
this._milliseconds=+k+1e3*j+// 1000
6e4*i+// 1000 * 60
1e3*h*60*60,//using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
// Because of dateAddRemove treats 24 hours as different from a
// day when working around DST, we need to store them separately
this._days=+g+7*f,
// It is impossible translate months into days without knowing
// which months you are are talking about, so we have to store
// it separately.
this._months=+e+3*d+12*c,this._data={},this._locale=ab(),this._bubble()}function wb(a){return a instanceof vb}
// FORMATTING
function xb(a,b){T(a,0,0,function(){var a=this.utcOffset(),c="+";return 0>a&&(a=-a,c="-"),c+S(~~(a/60),2)+b+S(~~a%60,2)})}function yb(a,b){var c=(b||"").match(a)||[],d=c[c.length-1]||[],e=(d+"").match(Ge)||["-",0,0],f=+(60*e[1])+t(e[2]);return"+"===e[0]?f:-f}
// Return a moment from input, that is local/utc/zone equivalent to model.
function zb(b,c){var d,e;
// Use low-level api, because this fn is low-level api.
return c._isUTC?(d=c.clone(),e=(r(b)||f(b)?b.valueOf():rb(b).valueOf())-d.valueOf(),d._d.setTime(d._d.valueOf()+e),a.updateOffset(d,!1),d):rb(b).local()}function Ab(a){
// On Firefox.24 Date#getTimezoneOffset returns a floating point.
// https://github.com/moment/moment/pull/1871
return 15*-Math.round(a._d.getTimezoneOffset()/15)}
// MOMENTS
// keepLocalTime = true means only change the timezone, without
// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
// +0200, so we adjust the time as needed, to be valid.
//
// Keeping the time actually adds/subtracts (one hour)
// from the actual represented time. That is why we call updateOffset
// a second time. In case it wants us to change the offset again
// _changeInProgress == true case, then we have to adjust, because
// there is no such time in the given timezone.
function Bb(b,c){var d,e=this._offset||0;return this.isValid()?null!=b?("string"==typeof b?b=yb(Td,b):Math.abs(b)<16&&(b=60*b),!this._isUTC&&c&&(d=Ab(this)),this._offset=b,this._isUTC=!0,null!=d&&this.add(d,"m"),e!==b&&(!c||this._changeInProgress?Sb(this,Mb(b-e,"m"),1,!1):this._changeInProgress||(this._changeInProgress=!0,a.updateOffset(this,!0),this._changeInProgress=null)),this):this._isUTC?e:Ab(this):null!=b?this:NaN}function Cb(a,b){return null!=a?("string"!=typeof a&&(a=-a),this.utcOffset(a,b),this):-this.utcOffset()}function Db(a){return this.utcOffset(0,a)}function Eb(a){return this._isUTC&&(this.utcOffset(0,a),this._isUTC=!1,a&&this.subtract(Ab(this),"m")),this}function Fb(){return this._tzm?this.utcOffset(this._tzm):"string"==typeof this._i&&this.utcOffset(yb(Sd,this._i)),this}function Gb(a){return this.isValid()?(a=a?rb(a).utcOffset():0,(this.utcOffset()-a)%60===0):!1}function Hb(){return this.utcOffset()>this.clone().month(0).utcOffset()||this.utcOffset()>this.clone().month(5).utcOffset()}function Ib(){if(!o(this._isDSTShifted))return this._isDSTShifted;var a={};if(p(a,this),a=ob(a),a._a){var b=a._isUTC?j(a._a):rb(a._a);this._isDSTShifted=this.isValid()&&u(a._a,b.toArray())>0}else this._isDSTShifted=!1;return this._isDSTShifted}function Jb(){return this.isValid()?!this._isUTC:!1}function Kb(){return this.isValid()?this._isUTC:!1}function Lb(){return this.isValid()?this._isUTC&&0===this._offset:!1}function Mb(a,b){var c,d,e,f=a,
// matching against regexp is expensive, do it on demand
g=null;// checks for null or undefined
return wb(a)?f={ms:a._milliseconds,d:a._days,M:a._months}:"number"==typeof a?(f={},b?f[b]=a:f.milliseconds=a):(g=He.exec(a))?(c="-"===g[1]?-1:1,f={y:0,d:t(g[$d])*c,h:t(g[_d])*c,m:t(g[ae])*c,s:t(g[be])*c,ms:t(g[ce])*c}):(g=Ie.exec(a))?(c="-"===g[1]?-1:1,f={y:Nb(g[2],c),M:Nb(g[3],c),w:Nb(g[4],c),d:Nb(g[5],c),h:Nb(g[6],c),m:Nb(g[7],c),s:Nb(g[8],c)}):null==f?f={}:"object"==typeof f&&("from"in f||"to"in f)&&(e=Pb(rb(f.from),rb(f.to)),f={},f.ms=e.milliseconds,f.M=e.months),d=new vb(f),wb(a)&&h(a,"_locale")&&(d._locale=a._locale),d}function Nb(a,b){
// We'd normally use ~~inp for this, but unfortunately it also
// converts floats to ints.
// inp may be undefined, so careful calling replace on it.
var c=a&&parseFloat(a.replace(",","."));
// apply sign while we're at it
return(isNaN(c)?0:c)*b}function Ob(a,b){var c={milliseconds:0,months:0};return c.months=b.month()-a.month()+12*(b.year()-a.year()),a.clone().add(c.months,"M").isAfter(b)&&--c.months,c.milliseconds=+b-+a.clone().add(c.months,"M"),c}function Pb(a,b){var c;return a.isValid()&&b.isValid()?(b=zb(b,a),a.isBefore(b)?c=Ob(a,b):(c=Ob(b,a),c.milliseconds=-c.milliseconds,c.months=-c.months),c):{milliseconds:0,months:0}}function Qb(a){return 0>a?-1*Math.round(-1*a):Math.round(a)}
// TODO: remove 'name' arg after deprecation is removed
function Rb(a,b){return function(c,d){var e,f;
//invert the arguments, but complain about it
return null===d||isNaN(+d)||(x(b,"moment()."+b+"(period, number) is deprecated. Please use moment()."+b+"(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."),f=c,c=d,d=f),c="string"==typeof c?+c:c,e=Mb(c,d),Sb(this,e,a),this}}function Sb(b,c,d,e){var f=c._milliseconds,g=Qb(c._days),h=Qb(c._months);b.isValid()&&(e=null==e?!0:e,f&&b._d.setTime(b._d.valueOf()+f*d),g&&P(b,"Date",O(b,"Date")+g*d),h&&ia(b,O(b,"Month")+h*d),e&&a.updateOffset(b,g||h))}function Tb(a,b){var c=a.diff(b,"days",!0);return-6>c?"sameElse":-1>c?"lastWeek":0>c?"lastDay":1>c?"sameDay":2>c?"nextDay":7>c?"nextWeek":"sameElse"}function Ub(b,c){
// We want to compare the start of today, vs this.
// Getting start-of-today depends on whether we're local/utc/offset or not.
var d=b||rb(),e=zb(d,this).startOf("day"),f=a.calendarFormat(this,e)||"sameElse",g=c&&(y(c[f])?c[f].call(this,d):c[f]);return this.format(g||this.localeData().calendar(f,this,rb(d)))}function Vb(){return new q(this)}function Wb(a,b){var c=r(a)?a:rb(a);return this.isValid()&&c.isValid()?(b=J(o(b)?"millisecond":b),"millisecond"===b?this.valueOf()>c.valueOf():c.valueOf()<this.clone().startOf(b).valueOf()):!1}function Xb(a,b){var c=r(a)?a:rb(a);return this.isValid()&&c.isValid()?(b=J(o(b)?"millisecond":b),"millisecond"===b?this.valueOf()<c.valueOf():this.clone().endOf(b).valueOf()<c.valueOf()):!1}function Yb(a,b,c,d){return d=d||"()",("("===d[0]?this.isAfter(a,c):!this.isBefore(a,c))&&(")"===d[1]?this.isBefore(b,c):!this.isAfter(b,c))}function Zb(a,b){var c,d=r(a)?a:rb(a);return this.isValid()&&d.isValid()?(b=J(b||"millisecond"),"millisecond"===b?this.valueOf()===d.valueOf():(c=d.valueOf(),this.clone().startOf(b).valueOf()<=c&&c<=this.clone().endOf(b).valueOf())):!1}function $b(a,b){return this.isSame(a,b)||this.isAfter(a,b)}function _b(a,b){return this.isSame(a,b)||this.isBefore(a,b)}function ac(a,b,c){var d,e,f,g;// 1000
// 1000 * 60
// 1000 * 60 * 60
// 1000 * 60 * 60 * 24, negate dst
// 1000 * 60 * 60 * 24 * 7, negate dst
return this.isValid()?(d=zb(a,this),d.isValid()?(e=6e4*(d.utcOffset()-this.utcOffset()),b=J(b),"year"===b||"month"===b||"quarter"===b?(g=bc(this,d),"quarter"===b?g/=3:"year"===b&&(g/=12)):(f=this-d,g="second"===b?f/1e3:"minute"===b?f/6e4:"hour"===b?f/36e5:"day"===b?(f-e)/864e5:"week"===b?(f-e)/6048e5:f),c?g:s(g)):NaN):NaN}function bc(a,b){
// difference in months
var c,d,e=12*(b.year()-a.year())+(b.month()-a.month()),
// b is in (anchor - 1 month, anchor + 1 month)
f=a.clone().add(e,"months");
//check for negative zero, return zero if negative zero
// linear across the month
// linear across the month
return 0>b-f?(c=a.clone().add(e-1,"months"),d=(b-f)/(f-c)):(c=a.clone().add(e+1,"months"),d=(b-f)/(c-f)),-(e+d)||0}function cc(){return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ")}function dc(){var a=this.clone().utc();return 0<a.year()&&a.year()<=9999?y(Date.prototype.toISOString)?this.toDate().toISOString():W(a,"YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"):W(a,"YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]")}function ec(b){b||(b=this.isUtc()?a.defaultFormatUtc:a.defaultFormat);var c=W(this,b);return this.localeData().postformat(c)}function fc(a,b){return this.isValid()&&(r(a)&&a.isValid()||rb(a).isValid())?Mb({to:this,from:a}).locale(this.locale()).humanize(!b):this.localeData().invalidDate()}function gc(a){return this.from(rb(),a)}function hc(a,b){return this.isValid()&&(r(a)&&a.isValid()||rb(a).isValid())?Mb({from:this,to:a}).locale(this.locale()).humanize(!b):this.localeData().invalidDate()}function ic(a){return this.to(rb(),a)}
// If passed a locale key, it will set the locale for this
// instance.  Otherwise, it will return the locale configuration
// variables for this instance.
function jc(a){var b;return void 0===a?this._locale._abbr:(b=ab(a),null!=b&&(this._locale=b),this)}function kc(){return this._locale}function lc(a){
// the following switch intentionally omits break keywords
// to utilize falling through the cases.
switch(a=J(a)){case"year":this.month(0);/* falls through */
case"quarter":case"month":this.date(1);/* falls through */
case"week":case"isoWeek":case"day":case"date":this.hours(0);/* falls through */
case"hour":this.minutes(0);/* falls through */
case"minute":this.seconds(0);/* falls through */
case"second":this.milliseconds(0)}
// weeks are a special case
// quarters are also special
return"week"===a&&this.weekday(0),"isoWeek"===a&&this.isoWeekday(1),"quarter"===a&&this.month(3*Math.floor(this.month()/3)),this}function mc(a){
// 'date' is an alias for 'day', so it should be considered as such.
return a=J(a),void 0===a||"millisecond"===a?this:("date"===a&&(a="day"),this.startOf(a).add(1,"isoWeek"===a?"week":a).subtract(1,"ms"))}function nc(){return this._d.valueOf()-6e4*(this._offset||0)}function oc(){return Math.floor(this.valueOf()/1e3)}function pc(){return new Date(this.valueOf())}function qc(){var a=this;return[a.year(),a.month(),a.date(),a.hour(),a.minute(),a.second(),a.millisecond()]}function rc(){var a=this;return{years:a.year(),months:a.month(),date:a.date(),hours:a.hours(),minutes:a.minutes(),seconds:a.seconds(),milliseconds:a.milliseconds()}}function sc(){
// new Date(NaN).toJSON() === null
return this.isValid()?this.toISOString():null}function tc(){return m(this)}function uc(){return i({},l(this))}function vc(){return l(this).overflow}function wc(){return{input:this._i,format:this._f,locale:this._locale,isUTC:this._isUTC,strict:this._strict}}function xc(a,b){T(0,[a,a.length],0,b)}
// MOMENTS
function yc(a){return Cc.call(this,a,this.week(),this.weekday(),this.localeData()._week.dow,this.localeData()._week.doy)}function zc(a){return Cc.call(this,a,this.isoWeek(),this.isoWeekday(),1,4)}function Ac(){return wa(this.year(),1,4)}function Bc(){var a=this.localeData()._week;return wa(this.year(),a.dow,a.doy)}function Cc(a,b,c,d,e){var f;return null==a?va(this,d,e).year:(f=wa(a,d,e),b>f&&(b=f),Dc.call(this,a,b,c,d,e))}function Dc(a,b,c,d,e){var f=ua(a,b,c,d,e),g=sa(f.year,0,f.dayOfYear);return this.year(g.getUTCFullYear()),this.month(g.getUTCMonth()),this.date(g.getUTCDate()),this}
// MOMENTS
function Ec(a){return null==a?Math.ceil((this.month()+1)/3):this.month(3*(a-1)+this.month()%3)}
// HELPERS
// MOMENTS
function Fc(a){var b=Math.round((this.clone().startOf("day")-this.clone().startOf("year"))/864e5)+1;return null==a?b:this.add(a-b,"d")}function Gc(a,b){b[ce]=t(1e3*("0."+a))}
// MOMENTS
function Hc(){return this._isUTC?"UTC":""}function Ic(){return this._isUTC?"Coordinated Universal Time":""}function Jc(a){return rb(1e3*a)}function Kc(){return rb.apply(null,arguments).parseZone()}function Lc(a){return a}function Mc(a,b,c,d){var e=ab(),f=j().set(d,b);return e[c](f,a)}function Nc(a,b,c){if("number"==typeof a&&(b=a,a=void 0),a=a||"",null!=b)return Mc(a,b,c,"month");var d,e=[];for(d=0;12>d;d++)e[d]=Mc(a,d,c,"month");return e}
// ()
// (5)
// (fmt, 5)
// (fmt)
// (true)
// (true, 5)
// (true, fmt, 5)
// (true, fmt)
function Oc(a,b,c,d){"boolean"==typeof a?("number"==typeof b&&(c=b,b=void 0),b=b||""):(b=a,c=b,a=!1,"number"==typeof b&&(c=b,b=void 0),b=b||"");var e=ab(),f=a?e._week.dow:0;if(null!=c)return Mc(b,(c+f)%7,d,"day");var g,h=[];for(g=0;7>g;g++)h[g]=Mc(b,(g+f)%7,d,"day");return h}function Pc(a,b){return Nc(a,b,"months")}function Qc(a,b){return Nc(a,b,"monthsShort")}function Rc(a,b,c){return Oc(a,b,c,"weekdays")}function Sc(a,b,c){return Oc(a,b,c,"weekdaysShort")}function Tc(a,b,c){return Oc(a,b,c,"weekdaysMin")}function Uc(){var a=this._data;return this._milliseconds=Ue(this._milliseconds),this._days=Ue(this._days),this._months=Ue(this._months),a.milliseconds=Ue(a.milliseconds),a.seconds=Ue(a.seconds),a.minutes=Ue(a.minutes),a.hours=Ue(a.hours),a.months=Ue(a.months),a.years=Ue(a.years),this}function Vc(a,b,c,d){var e=Mb(b,c);return a._milliseconds+=d*e._milliseconds,a._days+=d*e._days,a._months+=d*e._months,a._bubble()}
// supports only 2.0-style add(1, 's') or add(duration)
function Wc(a,b){return Vc(this,a,b,1)}
// supports only 2.0-style subtract(1, 's') or subtract(duration)
function Xc(a,b){return Vc(this,a,b,-1)}function Yc(a){return 0>a?Math.floor(a):Math.ceil(a)}function Zc(){var a,b,c,d,e,f=this._milliseconds,g=this._days,h=this._months,i=this._data;
// if we have a mix of positive and negative values, bubble down first
// check: https://github.com/moment/moment/issues/2166
// The following code bubbles up values, see the tests for
// examples of what that means.
// convert days to months
// 12 months -> 1 year
return f>=0&&g>=0&&h>=0||0>=f&&0>=g&&0>=h||(f+=864e5*Yc(_c(h)+g),g=0,h=0),i.milliseconds=f%1e3,a=s(f/1e3),i.seconds=a%60,b=s(a/60),i.minutes=b%60,c=s(b/60),i.hours=c%24,g+=s(c/24),e=s($c(g)),h+=e,g-=Yc(_c(e)),d=s(h/12),h%=12,i.days=g,i.months=h,i.years=d,this}function $c(a){
// 400 years have 146097 days (taking into account leap year rules)
// 400 years have 12 months === 4800
return 4800*a/146097}function _c(a){
// the reverse of daysToMonths
return 146097*a/4800}function ad(a){var b,c,d=this._milliseconds;if(a=J(a),"month"===a||"year"===a)return b=this._days+d/864e5,c=this._months+$c(b),"month"===a?c:c/12;switch(b=this._days+Math.round(_c(this._months)),a){case"week":return b/7+d/6048e5;case"day":return b+d/864e5;case"hour":return 24*b+d/36e5;case"minute":return 1440*b+d/6e4;case"second":return 86400*b+d/1e3;
// Math.floor prevents floating point math errors here
case"millisecond":return Math.floor(864e5*b)+d;default:throw new Error("Unknown unit "+a)}}
// TODO: Use this.as('ms')?
function bd(){return this._milliseconds+864e5*this._days+this._months%12*2592e6+31536e6*t(this._months/12)}function cd(a){return function(){return this.as(a)}}function dd(a){return a=J(a),this[a+"s"]()}function ed(a){return function(){return this._data[a]}}function fd(){return s(this.days()/7)}
// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
function gd(a,b,c,d,e){return e.relativeTime(b||1,!!c,a,d)}function hd(a,b,c){var d=Mb(a).abs(),e=jf(d.as("s")),f=jf(d.as("m")),g=jf(d.as("h")),h=jf(d.as("d")),i=jf(d.as("M")),j=jf(d.as("y")),k=e<kf.s&&["s",e]||1>=f&&["m"]||f<kf.m&&["mm",f]||1>=g&&["h"]||g<kf.h&&["hh",g]||1>=h&&["d"]||h<kf.d&&["dd",h]||1>=i&&["M"]||i<kf.M&&["MM",i]||1>=j&&["y"]||["yy",j];return k[2]=b,k[3]=+a>0,k[4]=c,gd.apply(null,k)}
// This function allows you to set the rounding function for relative time strings
function id(a){return void 0===a?jf:"function"==typeof a?(jf=a,!0):!1}
// This function allows you to set a threshold for relative time strings
function jd(a,b){return void 0===kf[a]?!1:void 0===b?kf[a]:(kf[a]=b,!0)}function kd(a){var b=this.localeData(),c=hd(this,!a,b);return a&&(c=b.pastFuture(+this,c)),b.postformat(c)}function ld(){
// for ISO strings we do not use the normal bubbling rules:
//  * milliseconds bubble up until they become hours
//  * days do not bubble at all
//  * months bubble up until they become years
// This is because there is no context-free conversion between hours and days
// (think of clock changes)
// and also not between days and months (28-31 days per month)
var a,b,c,d=lf(this._milliseconds)/1e3,e=lf(this._days),f=lf(this._months);a=s(d/60),b=s(a/60),d%=60,a%=60,c=s(f/12),f%=12;
// inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
var g=c,h=f,i=e,j=b,k=a,l=d,m=this.asSeconds();return m?(0>m?"-":"")+"P"+(g?g+"Y":"")+(h?h+"M":"")+(i?i+"D":"")+(j||k||l?"T":"")+(j?j+"H":"")+(k?k+"M":"")+(l?l+"S":""):"P0D"}var md,nd;nd=Array.prototype.some?Array.prototype.some:function(a){for(var b=Object(this),c=b.length>>>0,d=0;c>d;d++)if(d in b&&a.call(this,b[d],d,b))return!0;return!1};
// Plugins that add properties should also add the key here (null value),
// so we can properly clone ourselves.
var od=a.momentProperties=[],pd=!1,qd={};a.suppressDeprecationWarnings=!1,a.deprecationHandler=null;var rd;rd=Object.keys?Object.keys:function(a){var b,c=[];for(b in a)h(a,b)&&c.push(b);return c};var sd,td={sameDay:"[Today at] LT",nextDay:"[Tomorrow at] LT",nextWeek:"dddd [at] LT",lastDay:"[Yesterday at] LT",lastWeek:"[Last] dddd [at] LT",sameElse:"L"},ud={LTS:"h:mm:ss A",LT:"h:mm A",L:"MM/DD/YYYY",LL:"MMMM D, YYYY",LLL:"MMMM D, YYYY h:mm A",LLLL:"dddd, MMMM D, YYYY h:mm A"},vd="Invalid date",wd="%d",xd=/\d{1,2}/,yd={future:"in %s",past:"%s ago",s:"a few seconds",m:"a minute",mm:"%d minutes",h:"an hour",hh:"%d hours",d:"a day",dd:"%d days",M:"a month",MM:"%d months",y:"a year",yy:"%d years"},zd={},Ad={},Bd=/(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,Cd=/(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,Dd={},Ed={},Fd=/\d/,Gd=/\d\d/,Hd=/\d{3}/,Id=/\d{4}/,Jd=/[+-]?\d{6}/,Kd=/\d\d?/,Ld=/\d\d\d\d?/,Md=/\d\d\d\d\d\d?/,Nd=/\d{1,3}/,Od=/\d{1,4}/,Pd=/[+-]?\d{1,6}/,Qd=/\d+/,Rd=/[+-]?\d+/,Sd=/Z|[+-]\d\d:?\d\d/gi,Td=/Z|[+-]\d\d(?::?\d\d)?/gi,Ud=/[+-]?\d+(\.\d{1,3})?/,Vd=/[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i,Wd={},Xd={},Yd=0,Zd=1,$d=2,_d=3,ae=4,be=5,ce=6,de=7,ee=8;sd=Array.prototype.indexOf?Array.prototype.indexOf:function(a){
// I know
var b;for(b=0;b<this.length;++b)if(this[b]===a)return b;return-1},T("M",["MM",2],"Mo",function(){return this.month()+1}),T("MMM",0,0,function(a){return this.localeData().monthsShort(this,a)}),T("MMMM",0,0,function(a){return this.localeData().months(this,a)}),I("month","M"),L("month",8),Y("M",Kd),Y("MM",Kd,Gd),Y("MMM",function(a,b){return b.monthsShortRegex(a)}),Y("MMMM",function(a,b){return b.monthsRegex(a)}),aa(["M","MM"],function(a,b){b[Zd]=t(a)-1}),aa(["MMM","MMMM"],function(a,b,c,d){var e=c._locale.monthsParse(a,d,c._strict);null!=e?b[Zd]=e:l(c).invalidMonth=a});
// LOCALES
var fe=/D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/,ge="January_February_March_April_May_June_July_August_September_October_November_December".split("_"),he="Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),ie=Vd,je=Vd;
// FORMATTING
T("Y",0,0,function(){var a=this.year();return 9999>=a?""+a:"+"+a}),T(0,["YY",2],0,function(){return this.year()%100}),T(0,["YYYY",4],0,"year"),T(0,["YYYYY",5],0,"year"),T(0,["YYYYYY",6,!0],0,"year"),
// ALIASES
I("year","y"),
// PRIORITIES
L("year",1),
// PARSING
Y("Y",Rd),Y("YY",Kd,Gd),Y("YYYY",Od,Id),Y("YYYYY",Pd,Jd),Y("YYYYYY",Pd,Jd),aa(["YYYYY","YYYYYY"],Yd),aa("YYYY",function(b,c){c[Yd]=2===b.length?a.parseTwoDigitYear(b):t(b)}),aa("YY",function(b,c){c[Yd]=a.parseTwoDigitYear(b)}),aa("Y",function(a,b){b[Yd]=parseInt(a,10)}),
// HOOKS
a.parseTwoDigitYear=function(a){return t(a)+(t(a)>68?1900:2e3)};
// MOMENTS
var ke=N("FullYear",!0);
// FORMATTING
T("w",["ww",2],"wo","week"),T("W",["WW",2],"Wo","isoWeek"),
// ALIASES
I("week","w"),I("isoWeek","W"),
// PRIORITIES
L("week",5),L("isoWeek",5),
// PARSING
Y("w",Kd),Y("ww",Kd,Gd),Y("W",Kd),Y("WW",Kd,Gd),ba(["w","ww","W","WW"],function(a,b,c,d){b[d.substr(0,1)]=t(a)});var le={dow:0,// Sunday is the first day of the week.
doy:6};
// FORMATTING
T("d",0,"do","day"),T("dd",0,0,function(a){return this.localeData().weekdaysMin(this,a)}),T("ddd",0,0,function(a){return this.localeData().weekdaysShort(this,a)}),T("dddd",0,0,function(a){return this.localeData().weekdays(this,a)}),T("e",0,0,"weekday"),T("E",0,0,"isoWeekday"),
// ALIASES
I("day","d"),I("weekday","e"),I("isoWeekday","E"),
// PRIORITY
L("day",11),L("weekday",11),L("isoWeekday",11),
// PARSING
Y("d",Kd),Y("e",Kd),Y("E",Kd),Y("dd",function(a,b){return b.weekdaysMinRegex(a)}),Y("ddd",function(a,b){return b.weekdaysShortRegex(a)}),Y("dddd",function(a,b){return b.weekdaysRegex(a)}),ba(["dd","ddd","dddd"],function(a,b,c,d){var e=c._locale.weekdaysParse(a,d,c._strict);
// if we didn't get a weekday name, mark the date as invalid
null!=e?b.d=e:l(c).invalidWeekday=a}),ba(["d","e","E"],function(a,b,c,d){b[d]=t(a)});
// LOCALES
var me="Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),ne="Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),oe="Su_Mo_Tu_We_Th_Fr_Sa".split("_"),pe=Vd,qe=Vd,re=Vd;T("H",["HH",2],0,"hour"),T("h",["hh",2],0,Qa),T("k",["kk",2],0,Ra),T("hmm",0,0,function(){return""+Qa.apply(this)+S(this.minutes(),2)}),T("hmmss",0,0,function(){return""+Qa.apply(this)+S(this.minutes(),2)+S(this.seconds(),2)}),T("Hmm",0,0,function(){return""+this.hours()+S(this.minutes(),2)}),T("Hmmss",0,0,function(){return""+this.hours()+S(this.minutes(),2)+S(this.seconds(),2)}),Sa("a",!0),Sa("A",!1),
// ALIASES
I("hour","h"),
// PRIORITY
L("hour",13),Y("a",Ta),Y("A",Ta),Y("H",Kd),Y("h",Kd),Y("HH",Kd,Gd),Y("hh",Kd,Gd),Y("hmm",Ld),Y("hmmss",Md),Y("Hmm",Ld),Y("Hmmss",Md),aa(["H","HH"],_d),aa(["a","A"],function(a,b,c){c._isPm=c._locale.isPM(a),c._meridiem=a}),aa(["h","hh"],function(a,b,c){b[_d]=t(a),l(c).bigHour=!0}),aa("hmm",function(a,b,c){var d=a.length-2;b[_d]=t(a.substr(0,d)),b[ae]=t(a.substr(d)),l(c).bigHour=!0}),aa("hmmss",function(a,b,c){var d=a.length-4,e=a.length-2;b[_d]=t(a.substr(0,d)),b[ae]=t(a.substr(d,2)),b[be]=t(a.substr(e)),l(c).bigHour=!0}),aa("Hmm",function(a,b,c){var d=a.length-2;b[_d]=t(a.substr(0,d)),b[ae]=t(a.substr(d))}),aa("Hmmss",function(a,b,c){var d=a.length-4,e=a.length-2;b[_d]=t(a.substr(0,d)),b[ae]=t(a.substr(d,2)),b[be]=t(a.substr(e))});var se,te=/[ap]\.?m?\.?/i,ue=N("Hours",!0),ve={calendar:td,longDateFormat:ud,invalidDate:vd,ordinal:wd,ordinalParse:xd,relativeTime:yd,months:ge,monthsShort:he,week:le,weekdays:me,weekdaysMin:oe,weekdaysShort:ne,meridiemParse:te},we={},xe=/^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/,ye=/^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/,ze=/Z|[+-]\d\d(?::?\d\d)?/,Ae=[["YYYYYY-MM-DD",/[+-]\d{6}-\d\d-\d\d/],["YYYY-MM-DD",/\d{4}-\d\d-\d\d/],["GGGG-[W]WW-E",/\d{4}-W\d\d-\d/],["GGGG-[W]WW",/\d{4}-W\d\d/,!1],["YYYY-DDD",/\d{4}-\d{3}/],["YYYY-MM",/\d{4}-\d\d/,!1],["YYYYYYMMDD",/[+-]\d{10}/],["YYYYMMDD",/\d{8}/],
// YYYYMM is NOT allowed by the standard
["GGGG[W]WWE",/\d{4}W\d{3}/],["GGGG[W]WW",/\d{4}W\d{2}/,!1],["YYYYDDD",/\d{7}/]],Be=[["HH:mm:ss.SSSS",/\d\d:\d\d:\d\d\.\d+/],["HH:mm:ss,SSSS",/\d\d:\d\d:\d\d,\d+/],["HH:mm:ss",/\d\d:\d\d:\d\d/],["HH:mm",/\d\d:\d\d/],["HHmmss.SSSS",/\d\d\d\d\d\d\.\d+/],["HHmmss,SSSS",/\d\d\d\d\d\d,\d+/],["HHmmss",/\d\d\d\d\d\d/],["HHmm",/\d\d\d\d/],["HH",/\d\d/]],Ce=/^\/?Date\((\-?\d+)/i;a.createFromInputFallback=w("moment construction falls back to js Date. This is discouraged and will be removed in upcoming major release. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",function(a){a._d=new Date(a._i+(a._useUTC?" UTC":""))}),
// constant that refers to the ISO standard
a.ISO_8601=function(){};var De=w("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",function(){var a=rb.apply(null,arguments);return this.isValid()&&a.isValid()?this>a?this:a:n()}),Ee=w("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",function(){var a=rb.apply(null,arguments);return this.isValid()&&a.isValid()?a>this?this:a:n()}),Fe=function(){return Date.now?Date.now():+new Date};xb("Z",":"),xb("ZZ",""),
// PARSING
Y("Z",Td),Y("ZZ",Td),aa(["Z","ZZ"],function(a,b,c){c._useUTC=!0,c._tzm=yb(Td,a)});
// HELPERS
// timezone chunker
// '+10:00' > ['10',  '00']
// '-1530'  > ['-15', '30']
var Ge=/([\+\-]|\d\d)/gi;
// HOOKS
// This function will be called whenever a moment is mutated.
// It is intended to keep the offset in sync with the timezone.
a.updateOffset=function(){};
// ASP.NET json date format regex
var He=/^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?\d*)?$/,Ie=/^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;Mb.fn=vb.prototype;var Je=Rb(1,"add"),Ke=Rb(-1,"subtract");a.defaultFormat="YYYY-MM-DDTHH:mm:ssZ",a.defaultFormatUtc="YYYY-MM-DDTHH:mm:ss[Z]";var Le=w("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",function(a){return void 0===a?this.localeData():this.locale(a)});
// FORMATTING
T(0,["gg",2],0,function(){return this.weekYear()%100}),T(0,["GG",2],0,function(){return this.isoWeekYear()%100}),xc("gggg","weekYear"),xc("ggggg","weekYear"),xc("GGGG","isoWeekYear"),xc("GGGGG","isoWeekYear"),
// ALIASES
I("weekYear","gg"),I("isoWeekYear","GG"),
// PRIORITY
L("weekYear",1),L("isoWeekYear",1),
// PARSING
Y("G",Rd),Y("g",Rd),Y("GG",Kd,Gd),Y("gg",Kd,Gd),Y("GGGG",Od,Id),Y("gggg",Od,Id),Y("GGGGG",Pd,Jd),Y("ggggg",Pd,Jd),ba(["gggg","ggggg","GGGG","GGGGG"],function(a,b,c,d){b[d.substr(0,2)]=t(a)}),ba(["gg","GG"],function(b,c,d,e){c[e]=a.parseTwoDigitYear(b)}),
// FORMATTING
T("Q",0,"Qo","quarter"),
// ALIASES
I("quarter","Q"),
// PRIORITY
L("quarter",7),
// PARSING
Y("Q",Fd),aa("Q",function(a,b){b[Zd]=3*(t(a)-1)}),
// FORMATTING
T("D",["DD",2],"Do","date"),
// ALIASES
I("date","D"),
// PRIOROITY
L("date",9),
// PARSING
Y("D",Kd),Y("DD",Kd,Gd),Y("Do",function(a,b){return a?b._ordinalParse:b._ordinalParseLenient}),aa(["D","DD"],$d),aa("Do",function(a,b){b[$d]=t(a.match(Kd)[0],10)});
// MOMENTS
var Me=N("Date",!0);
// FORMATTING
T("DDD",["DDDD",3],"DDDo","dayOfYear"),
// ALIASES
I("dayOfYear","DDD"),
// PRIORITY
L("dayOfYear",4),
// PARSING
Y("DDD",Nd),Y("DDDD",Hd),aa(["DDD","DDDD"],function(a,b,c){c._dayOfYear=t(a)}),
// FORMATTING
T("m",["mm",2],0,"minute"),
// ALIASES
I("minute","m"),
// PRIORITY
L("minute",14),
// PARSING
Y("m",Kd),Y("mm",Kd,Gd),aa(["m","mm"],ae);
// MOMENTS
var Ne=N("Minutes",!1);
// FORMATTING
T("s",["ss",2],0,"second"),
// ALIASES
I("second","s"),
// PRIORITY
L("second",15),
// PARSING
Y("s",Kd),Y("ss",Kd,Gd),aa(["s","ss"],be);
// MOMENTS
var Oe=N("Seconds",!1);
// FORMATTING
T("S",0,0,function(){return~~(this.millisecond()/100)}),T(0,["SS",2],0,function(){return~~(this.millisecond()/10)}),T(0,["SSS",3],0,"millisecond"),T(0,["SSSS",4],0,function(){return 10*this.millisecond()}),T(0,["SSSSS",5],0,function(){return 100*this.millisecond()}),T(0,["SSSSSS",6],0,function(){return 1e3*this.millisecond()}),T(0,["SSSSSSS",7],0,function(){return 1e4*this.millisecond()}),T(0,["SSSSSSSS",8],0,function(){return 1e5*this.millisecond()}),T(0,["SSSSSSSSS",9],0,function(){return 1e6*this.millisecond()}),
// ALIASES
I("millisecond","ms"),
// PRIORITY
L("millisecond",16),
// PARSING
Y("S",Nd,Fd),Y("SS",Nd,Gd),Y("SSS",Nd,Hd);var Pe;for(Pe="SSSS";Pe.length<=9;Pe+="S")Y(Pe,Qd);for(Pe="S";Pe.length<=9;Pe+="S")aa(Pe,Gc);
// MOMENTS
var Qe=N("Milliseconds",!1);
// FORMATTING
T("z",0,0,"zoneAbbr"),T("zz",0,0,"zoneName");var Re=q.prototype;Re.add=Je,Re.calendar=Ub,Re.clone=Vb,Re.diff=ac,Re.endOf=mc,Re.format=ec,Re.from=fc,Re.fromNow=gc,Re.to=hc,Re.toNow=ic,Re.get=Q,Re.invalidAt=vc,Re.isAfter=Wb,Re.isBefore=Xb,Re.isBetween=Yb,Re.isSame=Zb,Re.isSameOrAfter=$b,Re.isSameOrBefore=_b,Re.isValid=tc,Re.lang=Le,Re.locale=jc,Re.localeData=kc,Re.max=Ee,Re.min=De,Re.parsingFlags=uc,Re.set=R,Re.startOf=lc,Re.subtract=Ke,Re.toArray=qc,Re.toObject=rc,Re.toDate=pc,Re.toISOString=dc,Re.toJSON=sc,Re.toString=cc,Re.unix=oc,Re.valueOf=nc,Re.creationData=wc,
// Year
Re.year=ke,Re.isLeapYear=qa,
// Week Year
Re.weekYear=yc,Re.isoWeekYear=zc,
// Quarter
Re.quarter=Re.quarters=Ec,
// Month
Re.month=ja,Re.daysInMonth=ka,
// Week
Re.week=Re.weeks=Aa,Re.isoWeek=Re.isoWeeks=Ba,Re.weeksInYear=Bc,Re.isoWeeksInYear=Ac,
// Day
Re.date=Me,Re.day=Re.days=Ja,Re.weekday=Ka,Re.isoWeekday=La,Re.dayOfYear=Fc,
// Hour
Re.hour=Re.hours=ue,
// Minute
Re.minute=Re.minutes=Ne,
// Second
Re.second=Re.seconds=Oe,
// Millisecond
Re.millisecond=Re.milliseconds=Qe,
// Offset
Re.utcOffset=Bb,Re.utc=Db,Re.local=Eb,Re.parseZone=Fb,Re.hasAlignedHourOffset=Gb,Re.isDST=Hb,Re.isLocal=Jb,Re.isUtcOffset=Kb,Re.isUtc=Lb,Re.isUTC=Lb,
// Timezone
Re.zoneAbbr=Hc,Re.zoneName=Ic,
// Deprecations
Re.dates=w("dates accessor is deprecated. Use date instead.",Me),Re.months=w("months accessor is deprecated. Use month instead",ja),Re.years=w("years accessor is deprecated. Use year instead",ke),Re.zone=w("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",Cb),Re.isDSTShifted=w("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",Ib);var Se=Re,Te=B.prototype;Te.calendar=C,Te.longDateFormat=D,Te.invalidDate=E,Te.ordinal=F,Te.preparse=Lc,Te.postformat=Lc,Te.relativeTime=G,Te.pastFuture=H,Te.set=z,
// Month
Te.months=ea,Te.monthsShort=fa,Te.monthsParse=ha,Te.monthsRegex=ma,Te.monthsShortRegex=la,
// Week
Te.week=xa,Te.firstDayOfYear=za,Te.firstDayOfWeek=ya,
// Day of Week
Te.weekdays=Ea,Te.weekdaysMin=Ga,Te.weekdaysShort=Fa,Te.weekdaysParse=Ia,Te.weekdaysRegex=Ma,Te.weekdaysShortRegex=Na,Te.weekdaysMinRegex=Oa,
// Hours
Te.isPM=Ua,Te.meridiem=Va,Za("en",{ordinalParse:/\d{1,2}(th|st|nd|rd)/,ordinal:function(a){var b=a%10,c=1===t(a%100/10)?"th":1===b?"st":2===b?"nd":3===b?"rd":"th";return a+c}}),
// Side effect imports
a.lang=w("moment.lang is deprecated. Use moment.locale instead.",Za),a.langData=w("moment.langData is deprecated. Use moment.localeData instead.",ab);var Ue=Math.abs,Ve=cd("ms"),We=cd("s"),Xe=cd("m"),Ye=cd("h"),Ze=cd("d"),$e=cd("w"),_e=cd("M"),af=cd("y"),bf=ed("milliseconds"),cf=ed("seconds"),df=ed("minutes"),ef=ed("hours"),ff=ed("days"),gf=ed("months"),hf=ed("years"),jf=Math.round,kf={s:45,// seconds to minute
m:45,// minutes to hour
h:22,// hours to day
d:26,// days to month
M:11},lf=Math.abs,mf=vb.prototype;mf.abs=Uc,mf.add=Wc,mf.subtract=Xc,mf.as=ad,mf.asMilliseconds=Ve,mf.asSeconds=We,mf.asMinutes=Xe,mf.asHours=Ye,mf.asDays=Ze,mf.asWeeks=$e,mf.asMonths=_e,mf.asYears=af,mf.valueOf=bd,mf._bubble=Zc,mf.get=dd,mf.milliseconds=bf,mf.seconds=cf,mf.minutes=df,mf.hours=ef,mf.days=ff,mf.weeks=fd,mf.months=gf,mf.years=hf,mf.humanize=kd,mf.toISOString=ld,mf.toString=ld,mf.toJSON=ld,mf.locale=jc,mf.localeData=kc,
// Deprecations
mf.toIsoString=w("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",ld),mf.lang=Le,
// Side effect imports
// FORMATTING
T("X",0,0,"unix"),T("x",0,0,"valueOf"),
// PARSING
Y("x",Rd),Y("X",Ud),aa("X",function(a,b,c){c._d=new Date(1e3*parseFloat(a,10))}),aa("x",function(a,b,c){c._d=new Date(t(a))}),
// Side effect imports
a.version="2.14.1",b(rb),a.fn=Se,a.min=tb,a.max=ub,a.now=Fe,a.utc=j,a.unix=Jc,a.months=Pc,a.isDate=f,a.locale=Za,a.invalid=n,a.duration=Mb,a.isMoment=r,a.weekdays=Rc,a.parseZone=Kc,a.localeData=ab,a.isDuration=wb,a.monthsShort=Qc,a.weekdaysMin=Tc,a.defineLocale=$a,a.updateLocale=_a,a.locales=bb,a.weekdaysShort=Sc,a.normalizeUnits=J,a.relativeTimeRounding=id,a.relativeTimeThreshold=jd,a.calendarFormat=Tb,a.prototype=Se;var nf=a;return nf});
/**!
 * AngularJS file upload directives and services. Supoorts: file upload/drop/paste, resume, cancel/abort,
 * progress, resize, thumbnail, preview, validation and CORS
 * @author  Danial  <danial.farid@gmail.com>
 * @version 12.2.8
 */

if (window.XMLHttpRequest && !(window.FileAPI && FileAPI.shouldLoad)) {
  window.XMLHttpRequest.prototype.setRequestHeader = (function (orig) {
    return function (header, value) {
      if (header === '__setXHR_') {
        var val = value(this);
        // fix for angular < 1.2.0
        if (val instanceof Function) {
          val(this);
        }
      } else {
        orig.apply(this, arguments);
      }
    };
  })(window.XMLHttpRequest.prototype.setRequestHeader);
}

var ngFileUpload = angular.module('ngFileUpload', []);

ngFileUpload.version = '12.2.8';

ngFileUpload.service('UploadBase', ['$http', '$q', '$timeout', function ($http, $q, $timeout) {
  var upload = this;
  upload.promisesCount = 0;

  this.isResumeSupported = function () {
    return window.Blob && window.Blob.prototype.slice;
  };

  var resumeSupported = this.isResumeSupported();

  function sendHttp(config) {
    config.method = config.method || 'POST';
    config.headers = config.headers || {};

    var deferred = config._deferred = config._deferred || $q.defer();
    var promise = deferred.promise;

    function notifyProgress(e) {
      if (deferred.notify) {
        deferred.notify(e);
      }
      if (promise.progressFunc) {
        $timeout(function () {
          promise.progressFunc(e);
        });
      }
    }

    function getNotifyEvent(n) {
      if (config._start != null && resumeSupported) {
        return {
          loaded: n.loaded + config._start,
          total: (config._file && config._file.size) || n.total,
          type: n.type, config: config,
          lengthComputable: true, target: n.target
        };
      } else {
        return n;
      }
    }

    if (!config.disableProgress) {
      config.headers.__setXHR_ = function () {
        return function (xhr) {
          if (!xhr || !xhr.upload || !xhr.upload.addEventListener) return;
          config.__XHR = xhr;
          if (config.xhrFn) config.xhrFn(xhr);
          xhr.upload.addEventListener('progress', function (e) {
            e.config = config;
            notifyProgress(getNotifyEvent(e));
          }, false);
          //fix for firefox not firing upload progress end, also IE8-9
          xhr.upload.addEventListener('load', function (e) {
            if (e.lengthComputable) {
              e.config = config;
              notifyProgress(getNotifyEvent(e));
            }
          }, false);
        };
      };
    }

    function uploadWithAngular() {
      $http(config).then(function (r) {
          if (resumeSupported && config._chunkSize && !config._finished && config._file) {
            var fileSize = config._file && config._file.size || 0;
            notifyProgress({
                loaded: Math.min(config._end, fileSize),
                total: fileSize,
                config: config,
                type: 'progress'
              }
            );
            upload.upload(config, true);
          } else {
            if (config._finished) delete config._finished;
            deferred.resolve(r);
          }
        }, function (e) {
          deferred.reject(e);
        }, function (n) {
          deferred.notify(n);
        }
      );
    }

    if (!resumeSupported) {
      uploadWithAngular();
    } else if (config._chunkSize && config._end && !config._finished) {
      config._start = config._end;
      config._end += config._chunkSize;
      uploadWithAngular();
    } else if (config.resumeSizeUrl) {
      $http.get(config.resumeSizeUrl).then(function (resp) {
        if (config.resumeSizeResponseReader) {
          config._start = config.resumeSizeResponseReader(resp.data);
        } else {
          config._start = parseInt((resp.data.size == null ? resp.data : resp.data.size).toString());
        }
        if (config._chunkSize) {
          config._end = config._start + config._chunkSize;
        }
        uploadWithAngular();
      }, function (e) {
        throw e;
      });
    } else if (config.resumeSize) {
      config.resumeSize().then(function (size) {
        config._start = size;
        if (config._chunkSize) {
          config._end = config._start + config._chunkSize;
        }
        uploadWithAngular();
      }, function (e) {
        throw e;
      });
    } else {
      if (config._chunkSize) {
        config._start = 0;
        config._end = config._start + config._chunkSize;
      }
      uploadWithAngular();
    }


    promise.success = function (fn) {
      promise.then(function (response) {
        fn(response.data, response.status, response.headers, config);
      });
      return promise;
    };

    promise.error = function (fn) {
      promise.then(null, function (response) {
        fn(response.data, response.status, response.headers, config);
      });
      return promise;
    };

    promise.progress = function (fn) {
      promise.progressFunc = fn;
      promise.then(null, null, function (n) {
        fn(n);
      });
      return promise;
    };
    promise.abort = promise.pause = function () {
      if (config.__XHR) {
        $timeout(function () {
          config.__XHR.abort();
        });
      }
      return promise;
    };
    promise.xhr = function (fn) {
      config.xhrFn = (function (origXhrFn) {
        return function () {
          if (origXhrFn) origXhrFn.apply(promise, arguments);
          fn.apply(promise, arguments);
        };
      })(config.xhrFn);
      return promise;
    };

    upload.promisesCount++;
    if (promise['finally'] && promise['finally'] instanceof Function) {
      promise['finally'](function () {
        upload.promisesCount--;
      });
    }
    return promise;
  }

  this.isUploadInProgress = function () {
    return upload.promisesCount > 0;
  };

  this.rename = function (file, name) {
    file.ngfName = name;
    return file;
  };

  this.jsonBlob = function (val) {
    if (val != null && !angular.isString(val)) {
      val = JSON.stringify(val);
    }
    var blob = new window.Blob([val], {type: 'application/json'});
    blob._ngfBlob = true;
    return blob;
  };

  this.json = function (val) {
    return angular.toJson(val);
  };

  function copy(obj) {
    var clone = {};
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        clone[key] = obj[key];
      }
    }
    return clone;
  }

  this.isFile = function (file) {
    return file != null && (file instanceof window.Blob || (file.flashId && file.name && file.size));
  };

  this.upload = function (config, internal) {
    function toResumeFile(file, formData) {
      if (file._ngfBlob) return file;
      config._file = config._file || file;
      if (config._start != null && resumeSupported) {
        if (config._end && config._end >= file.size) {
          config._finished = true;
          config._end = file.size;
        }
        var slice = file.slice(config._start, config._end || file.size);
        slice.name = file.name;
        slice.ngfName = file.ngfName;
        if (config._chunkSize) {
          formData.append('_chunkSize', config._chunkSize);
          formData.append('_currentChunkSize', config._end - config._start);
          formData.append('_chunkNumber', Math.floor(config._start / config._chunkSize));
          formData.append('_totalSize', config._file.size);
        }
        return slice;
      }
      return file;
    }

    function addFieldToFormData(formData, val, key) {
      if (val !== undefined) {
        if (angular.isDate(val)) {
          val = val.toISOString();
        }
        if (angular.isString(val)) {
          formData.append(key, val);
        } else if (upload.isFile(val)) {
          var file = toResumeFile(val, formData);
          var split = key.split(',');
          if (split[1]) {
            file.ngfName = split[1].replace(/^\s+|\s+$/g, '');
            key = split[0];
          }
          config._fileKey = config._fileKey || key;
          formData.append(key, file, file.ngfName || file.name);
        } else {
          if (angular.isObject(val)) {
            if (val.$$ngfCircularDetection) throw 'ngFileUpload: Circular reference in config.data. Make sure specified data for Upload.upload() has no circular reference: ' + key;

            val.$$ngfCircularDetection = true;
            try {
              for (var k in val) {
                if (val.hasOwnProperty(k) && k !== '$$ngfCircularDetection') {
                  var objectKey = config.objectKey == null ? '[i]' : config.objectKey;
                  if (val.length && parseInt(k) > -1) {
                    objectKey = config.arrayKey == null ? objectKey : config.arrayKey;
                  }
                  addFieldToFormData(formData, val[k], key + objectKey.replace(/[ik]/g, k));
                }
              }
            } finally {
              delete val.$$ngfCircularDetection;
            }
          } else {
            formData.append(key, val);
          }
        }
      }
    }

    function digestConfig() {
      config._chunkSize = upload.translateScalars(config.resumeChunkSize);
      config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;

      config.headers = config.headers || {};
      config.headers['Content-Type'] = undefined;
      config.transformRequest = config.transformRequest ?
        (angular.isArray(config.transformRequest) ?
          config.transformRequest : [config.transformRequest]) : [];
      config.transformRequest.push(function (data) {
        var formData = new window.FormData(), key;
        data = data || config.fields || {};
        if (config.file) {
          data.file = config.file;
        }
        for (key in data) {
          if (data.hasOwnProperty(key)) {
            var val = data[key];
            if (config.formDataAppender) {
              config.formDataAppender(formData, key, val);
            } else {
              addFieldToFormData(formData, val, key);
            }
          }
        }

        return formData;
      });
    }

    if (!internal) config = copy(config);
    if (!config._isDigested) {
      config._isDigested = true;
      digestConfig();
    }

    return sendHttp(config);
  };

  this.http = function (config) {
    config = copy(config);
    config.transformRequest = config.transformRequest || function (data) {
        if ((window.ArrayBuffer && data instanceof window.ArrayBuffer) || data instanceof window.Blob) {
          return data;
        }
        return $http.defaults.transformRequest[0].apply(this, arguments);
      };
    config._chunkSize = upload.translateScalars(config.resumeChunkSize);
    config._chunkSize = config._chunkSize ? parseInt(config._chunkSize.toString()) : null;

    return sendHttp(config);
  };

  this.translateScalars = function (str) {
    if (angular.isString(str)) {
      if (str.search(/kb/i) === str.length - 2) {
        return parseFloat(str.substring(0, str.length - 2) * 1024);
      } else if (str.search(/mb/i) === str.length - 2) {
        return parseFloat(str.substring(0, str.length - 2) * 1048576);
      } else if (str.search(/gb/i) === str.length - 2) {
        return parseFloat(str.substring(0, str.length - 2) * 1073741824);
      } else if (str.search(/b/i) === str.length - 1) {
        return parseFloat(str.substring(0, str.length - 1));
      } else if (str.search(/s/i) === str.length - 1) {
        return parseFloat(str.substring(0, str.length - 1));
      } else if (str.search(/m/i) === str.length - 1) {
        return parseFloat(str.substring(0, str.length - 1) * 60);
      } else if (str.search(/h/i) === str.length - 1) {
        return parseFloat(str.substring(0, str.length - 1) * 3600);
      }
    }
    return str;
  };

  this.urlToBlob = function(url) {
    var defer = $q.defer();
    $http({url: url, method: 'get', responseType: 'arraybuffer'}).then(function (resp) {
      var arrayBufferView = new Uint8Array(resp.data);
      var type = resp.headers('content-type') || 'image/WebP';
      var blob = new window.Blob([arrayBufferView], {type: type});
      var matches = url.match(/.*\/(.+?)(\?.*)?$/);
      if (matches.length > 1) {
        blob.name = matches[1];
      }
      defer.resolve(blob);
    }, function (e) {
      defer.reject(e);
    });
    return defer.promise;
  };

  this.setDefaults = function (defaults) {
    this.defaults = defaults || {};
  };

  this.defaults = {};
  this.version = ngFileUpload.version;
}

]);

ngFileUpload.service('Upload', ['$parse', '$timeout', '$compile', '$q', 'UploadExif', function ($parse, $timeout, $compile, $q, UploadExif) {
  var upload = UploadExif;
  upload.getAttrWithDefaults = function (attr, name) {
    if (attr[name] != null) return attr[name];
    var def = upload.defaults[name];
    return (def == null ? def : (angular.isString(def) ? def : JSON.stringify(def)));
  };

  upload.attrGetter = function (name, attr, scope, params) {
    var attrVal = this.getAttrWithDefaults(attr, name);
    if (scope) {
      try {
        if (params) {
          return $parse(attrVal)(scope, params);
        } else {
          return $parse(attrVal)(scope);
        }
      } catch (e) {
        // hangle string value without single qoute
        if (name.search(/min|max|pattern/i)) {
          return attrVal;
        } else {
          throw e;
        }
      }
    } else {
      return attrVal;
    }
  };

  upload.shouldUpdateOn = function (type, attr, scope) {
    var modelOptions = upload.attrGetter('ngfModelOptions', attr, scope);
    if (modelOptions && modelOptions.updateOn) {
      return modelOptions.updateOn.split(' ').indexOf(type) > -1;
    }
    return true;
  };

  upload.emptyPromise = function () {
    var d = $q.defer();
    var args = arguments;
    $timeout(function () {
      d.resolve.apply(d, args);
    });
    return d.promise;
  };

  upload.rejectPromise = function () {
    var d = $q.defer();
    var args = arguments;
    $timeout(function () {
      d.reject.apply(d, args);
    });
    return d.promise;
  };

  upload.happyPromise = function (promise, data) {
    var d = $q.defer();
    promise.then(function (result) {
      d.resolve(result);
    }, function (error) {
      $timeout(function () {
        throw error;
      });
      d.resolve(data);
    });
    return d.promise;
  };

  function applyExifRotations(files, attr, scope) {
    var promises = [upload.emptyPromise()];
    angular.forEach(files, function (f, i) {
      if (f.type.indexOf('image/jpeg') === 0 && upload.attrGetter('ngfFixOrientation', attr, scope, {$file: f})) {
        promises.push(upload.happyPromise(upload.applyExifRotation(f), f).then(function (fixedFile) {
          files.splice(i, 1, fixedFile);
        }));
      }
    });
    return $q.all(promises);
  }

  function resize(files, attr, scope) {
    var resizeVal = upload.attrGetter('ngfResize', attr, scope);
    if (!resizeVal || !upload.isResizeSupported() || !files.length) return upload.emptyPromise();
    if (resizeVal instanceof Function) {
      var defer = $q.defer();
      return resizeVal(files).then(function (p) {
        resizeWithParams(p, files, attr, scope).then(function (r) {
          defer.resolve(r);
        }, function (e) {
          defer.reject(e);
        });
      }, function (e) {
        defer.reject(e);
      });
    } else {
      return resizeWithParams(resizeVal, files, attr, scope);
    }
  }

  function resizeWithParams(params, files, attr, scope) {
    var promises = [upload.emptyPromise()];

    function handleFile(f, i) {
      if (f.type.indexOf('image') === 0) {
        if (params.pattern && !upload.validatePattern(f, params.pattern)) return;
        params.resizeIf = function (width, height) {
          return upload.attrGetter('ngfResizeIf', attr, scope,
            {$width: width, $height: height, $file: f});
        };
        var promise = upload.resize(f, params);
        promises.push(promise);
        promise.then(function (resizedFile) {
          files.splice(i, 1, resizedFile);
        }, function (e) {
          f.$error = 'resize';
          f.$errorParam = (e ? (e.message ? e.message : e) + ': ' : '') + (f && f.name);
        });
      }
    }

    for (var i = 0; i < files.length; i++) {
      handleFile(files[i], i);
    }
    return $q.all(promises);
  }

  upload.updateModel = function (ngModel, attr, scope, fileChange, files, evt, noDelay) {
    function update(files, invalidFiles, newFiles, dupFiles, isSingleModel) {
      attr.$$ngfPrevValidFiles = files;
      attr.$$ngfPrevInvalidFiles = invalidFiles;
      var file = files && files.length ? files[0] : null;
      var invalidFile = invalidFiles && invalidFiles.length ? invalidFiles[0] : null;

      if (ngModel) {
        upload.applyModelValidation(ngModel, files);
        ngModel.$setViewValue(isSingleModel ? file : files);
      }

      if (fileChange) {
        $parse(fileChange)(scope, {
          $files: files,
          $file: file,
          $newFiles: newFiles,
          $duplicateFiles: dupFiles,
          $invalidFiles: invalidFiles,
          $invalidFile: invalidFile,
          $event: evt
        });
      }

      var invalidModel = upload.attrGetter('ngfModelInvalid', attr);
      if (invalidModel) {
        $timeout(function () {
          $parse(invalidModel).assign(scope, isSingleModel ? invalidFile : invalidFiles);
        });
      }
      $timeout(function () {
        // scope apply changes
      });
    }

    var allNewFiles, dupFiles = [], prevValidFiles, prevInvalidFiles,
      invalids = [], valids = [];

    function removeDuplicates() {
      function equals(f1, f2) {
        return f1.name === f2.name && (f1.$ngfOrigSize || f1.size) === (f2.$ngfOrigSize || f2.size) &&
          f1.type === f2.type;
      }

      function isInPrevFiles(f) {
        var j;
        for (j = 0; j < prevValidFiles.length; j++) {
          if (equals(f, prevValidFiles[j])) {
            return true;
          }
        }
        for (j = 0; j < prevInvalidFiles.length; j++) {
          if (equals(f, prevInvalidFiles[j])) {
            return true;
          }
        }
        return false;
      }

      if (files) {
        allNewFiles = [];
        dupFiles = [];
        for (var i = 0; i < files.length; i++) {
          if (isInPrevFiles(files[i])) {
            dupFiles.push(files[i]);
          } else {
            allNewFiles.push(files[i]);
          }
        }
      }
    }

    function toArray(v) {
      return angular.isArray(v) ? v : [v];
    }

    function resizeAndUpdate() {
      function updateModel() {
        $timeout(function () {
          update(keep ? prevValidFiles.concat(valids) : valids,
            keep ? prevInvalidFiles.concat(invalids) : invalids,
            files, dupFiles, isSingleModel);
        }, options && options.debounce ? options.debounce.change || options.debounce : 0);
      }

      resize(validateAfterResize ? allNewFiles : valids, attr, scope).then(function () {
        if (validateAfterResize) {
          upload.validate(allNewFiles, keep ? prevValidFiles.length : 0, ngModel, attr, scope)
            .then(function (validationResult) {
              valids = validationResult.validsFiles;
              invalids = validationResult.invalidsFiles;
              updateModel();
            });
        } else {
          updateModel();
        }
      }, function (e) {
        throw 'Could not resize files ' + e;
      });
    }

    prevValidFiles = attr.$$ngfPrevValidFiles || [];
    prevInvalidFiles = attr.$$ngfPrevInvalidFiles || [];
    if (ngModel && ngModel.$modelValue) {
      prevValidFiles = toArray(ngModel.$modelValue);
    }

    var keep = upload.attrGetter('ngfKeep', attr, scope);
    allNewFiles = (files || []).slice(0);
    if (keep === 'distinct' || upload.attrGetter('ngfKeepDistinct', attr, scope) === true) {
      removeDuplicates(attr, scope);
    }

    var isSingleModel = !keep && !upload.attrGetter('ngfMultiple', attr, scope) && !upload.attrGetter('multiple', attr);

    if (keep && !allNewFiles.length) return;

    upload.attrGetter('ngfBeforeModelChange', attr, scope, {
      $files: files,
      $file: files && files.length ? files[0] : null,
      $newFiles: allNewFiles,
      $duplicateFiles: dupFiles,
      $event: evt
    });

    var validateAfterResize = upload.attrGetter('ngfValidateAfterResize', attr, scope);

    var options = upload.attrGetter('ngfModelOptions', attr, scope);
    upload.validate(allNewFiles, keep ? prevValidFiles.length : 0, ngModel, attr, scope)
      .then(function (validationResult) {
      if (noDelay) {
        update(allNewFiles, [], files, dupFiles, isSingleModel);
      } else {
        if ((!options || !options.allowInvalid) && !validateAfterResize) {
          valids = validationResult.validFiles;
          invalids = validationResult.invalidFiles;
        } else {
          valids = allNewFiles;
        }
        if (upload.attrGetter('ngfFixOrientation', attr, scope) && upload.isExifSupported()) {
          applyExifRotations(valids, attr, scope).then(function () {
            resizeAndUpdate();
          });
        } else {
          resizeAndUpdate();
        }
      }
    });
  };

  return upload;
}]);

ngFileUpload.directive('ngfSelect', ['$parse', '$timeout', '$compile', 'Upload', function ($parse, $timeout, $compile, Upload) {
  var generatedElems = [];

  function isDelayedClickSupported(ua) {
    // fix for android native browser < 4.4 and safari windows
    var m = ua.match(/Android[^\d]*(\d+)\.(\d+)/);
    if (m && m.length > 2) {
      var v = Upload.defaults.androidFixMinorVersion || 4;
      return parseInt(m[1]) < 4 || (parseInt(m[1]) === v && parseInt(m[2]) < v);
    }

    // safari on windows
    return ua.indexOf('Chrome') === -1 && /.*Windows.*Safari.*/.test(ua);
  }

  function linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, upload) {
    /** @namespace attr.ngfSelect */
    /** @namespace attr.ngfChange */
    /** @namespace attr.ngModel */
    /** @namespace attr.ngfModelOptions */
    /** @namespace attr.ngfMultiple */
    /** @namespace attr.ngfCapture */
    /** @namespace attr.ngfValidate */
    /** @namespace attr.ngfKeep */
    var attrGetter = function (name, scope) {
      return upload.attrGetter(name, attr, scope);
    };

    function isInputTypeFile() {
      return elem[0].tagName.toLowerCase() === 'input' && attr.type && attr.type.toLowerCase() === 'file';
    }

    function fileChangeAttr() {
      return attrGetter('ngfChange') || attrGetter('ngfSelect');
    }

    function changeFn(evt) {
      if (upload.shouldUpdateOn('change', attr, scope)) {
        var fileList = evt.__files_ || (evt.target && evt.target.files), files = [];
        /* Handle duplicate call in  IE11 */
        if (!fileList) return;
        for (var i = 0; i < fileList.length; i++) {
          files.push(fileList[i]);
        }
        upload.updateModel(ngModel, attr, scope, fileChangeAttr(),
          files.length ? files : null, evt);
      }
    }

    upload.registerModelChangeValidator(ngModel, attr, scope);

    var unwatches = [];
    if (attrGetter('ngfMultiple')) {
      unwatches.push(scope.$watch(attrGetter('ngfMultiple'), function () {
        fileElem.attr('multiple', attrGetter('ngfMultiple', scope));
      }));
    }
    if (attrGetter('ngfCapture')) {
      unwatches.push(scope.$watch(attrGetter('ngfCapture'), function () {
        fileElem.attr('capture', attrGetter('ngfCapture', scope));
      }));
    }
    if (attrGetter('ngfAccept')) {
      unwatches.push(scope.$watch(attrGetter('ngfAccept'), function () {
        fileElem.attr('accept', attrGetter('ngfAccept', scope));
      }));
    }
    attr.$observe('accept', function () {
      fileElem.attr('accept', attrGetter('accept'));
    });
    unwatches.push(function () {
      if (attr.$$observers) delete attr.$$observers.accept;
    });
    function bindAttrToFileInput(fileElem) {
      for (var i = 0; i < elem[0].attributes.length; i++) {
        var attribute = elem[0].attributes[i];
        if (attribute.name !== 'type' && attribute.name !== 'class' && attribute.name !== 'style') {
          if (attribute.value == null || attribute.value === '') {
            if (attribute.name === 'required') attribute.value = 'required';
            if (attribute.name === 'multiple') attribute.value = 'multiple';
          }
          fileElem.attr(attribute.name, attribute.name === 'id' ? 'ngf-' + attribute.value : attribute.value);
        }
      }
    }

    function createFileInput() {
      if (isInputTypeFile()) {
        return elem;
      }

      var fileElem = angular.element('<input type="file">');

      bindAttrToFileInput(fileElem);

      var label = angular.element('<label>upload</label>');
      label.css('visibility', 'hidden').css('position', 'absolute').css('overflow', 'hidden')
        .css('width', '0px').css('height', '0px').css('border', 'none')
        .css('margin', '0px').css('padding', '0px').attr('tabindex', '-1');
      if (elem.attr('id')) {
        label.attr('id', 'ngf-label-' + elem.attr('id'));
      }
      generatedElems.push({el: elem, ref: label});

      document.body.appendChild(label.append(fileElem)[0]);

      return fileElem;
    }

    function clickHandler(evt) {
      if (elem.attr('disabled')) return false;
      if (attrGetter('ngfSelectDisabled', scope)) return;

      var r = detectSwipe(evt);
      // prevent the click if it is a swipe
      if (r != null) return r;

      resetModel(evt);

      // fix for md when the element is removed from the DOM and added back #460
      try {
        if (!isInputTypeFile() && !document.body.contains(fileElem[0])) {
          generatedElems.push({el: elem, ref: fileElem.parent()});
          document.body.appendChild(fileElem.parent()[0]);
          fileElem.bind('change', changeFn);
        }
      } catch(e){/*ignore*/}

      if (isDelayedClickSupported(navigator.userAgent)) {
        setTimeout(function () {
          fileElem[0].click();
        }, 0);
      } else {
        fileElem[0].click();
      }

      return false;
    }


    var initialTouchStartY = 0;
    var initialTouchStartX = 0;

    function detectSwipe(evt) {
      var touches = evt.changedTouches || (evt.originalEvent && evt.originalEvent.changedTouches);
      if (touches) {
        if (evt.type === 'touchstart') {
          initialTouchStartX = touches[0].clientX;
          initialTouchStartY = touches[0].clientY;
          return true; // don't block event default
        } else {
          // prevent scroll from triggering event
          if (evt.type === 'touchend') {
            var currentX = touches[0].clientX;
            var currentY = touches[0].clientY;
            if ((Math.abs(currentX - initialTouchStartX) > 20) ||
            (Math.abs(currentY - initialTouchStartY) > 20)) {
              evt.stopPropagation();
              evt.preventDefault();
              return false;
            }
          }
          return true;
        }
      }
    }

    var fileElem = elem;

    function resetModel(evt) {
      if (upload.shouldUpdateOn('click', attr, scope) && fileElem.val()) {
        fileElem.val(null);
        upload.updateModel(ngModel, attr, scope, fileChangeAttr(), null, evt, true);
      }
    }

    if (!isInputTypeFile()) {
      fileElem = createFileInput();
    }
    fileElem.bind('change', changeFn);

    if (!isInputTypeFile()) {
      elem.bind('click touchstart touchend', clickHandler);
    } else {
      elem.bind('click', resetModel);
    }

    function ie10SameFileSelectFix(evt) {
      if (fileElem && !fileElem.attr('__ngf_ie10_Fix_')) {
        if (!fileElem[0].parentNode) {
          fileElem = null;
          return;
        }
        evt.preventDefault();
        evt.stopPropagation();
        fileElem.unbind('click');
        var clone = fileElem.clone();
        fileElem.replaceWith(clone);
        fileElem = clone;
        fileElem.attr('__ngf_ie10_Fix_', 'true');
        fileElem.bind('change', changeFn);
        fileElem.bind('click', ie10SameFileSelectFix);
        fileElem[0].click();
        return false;
      } else {
        fileElem.removeAttr('__ngf_ie10_Fix_');
      }
    }

    if (navigator.appVersion.indexOf('MSIE 10') !== -1) {
      fileElem.bind('click', ie10SameFileSelectFix);
    }

    if (ngModel) ngModel.$formatters.push(function (val) {
      if (val == null || val.length === 0) {
        if (fileElem.val()) {
          fileElem.val(null);
        }
      }
      return val;
    });

    scope.$on('$destroy', function () {
      if (!isInputTypeFile()) fileElem.parent().remove();
      angular.forEach(unwatches, function (unwatch) {
        unwatch();
      });
    });

    $timeout(function () {
      for (var i = 0; i < generatedElems.length; i++) {
        var g = generatedElems[i];
        if (!document.body.contains(g.el[0])) {
          generatedElems.splice(i, 1);
          g.ref.remove();
        }
      }
    });

    if (window.FileAPI && window.FileAPI.ngfFixIE) {
      window.FileAPI.ngfFixIE(elem, fileElem, changeFn);
    }
  }

  return {
    restrict: 'AEC',
    require: '?ngModel',
    link: function (scope, elem, attr, ngModel) {
      linkFileSelect(scope, elem, attr, ngModel, $parse, $timeout, $compile, Upload);
    }
  };
}]);

(function () {

  ngFileUpload.service('UploadDataUrl', ['UploadBase', '$timeout', '$q', function (UploadBase, $timeout, $q) {
    var upload = UploadBase;
    upload.base64DataUrl = function (file) {
      if (angular.isArray(file)) {
        var d = $q.defer(), count = 0;
        angular.forEach(file, function (f) {
          upload.dataUrl(f, true)['finally'](function () {
            count++;
            if (count === file.length) {
              var urls = [];
              angular.forEach(file, function (ff) {
                urls.push(ff.$ngfDataUrl);
              });
              d.resolve(urls, file);
            }
          });
        });
        return d.promise;
      } else {
        return upload.dataUrl(file, true);
      }
    };
    upload.dataUrl = function (file, disallowObjectUrl) {
      if (!file) return upload.emptyPromise(file, file);
      if ((disallowObjectUrl && file.$ngfDataUrl != null) || (!disallowObjectUrl && file.$ngfBlobUrl != null)) {
        return upload.emptyPromise(disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl, file);
      }
      var p = disallowObjectUrl ? file.$$ngfDataUrlPromise : file.$$ngfBlobUrlPromise;
      if (p) return p;

      var deferred = $q.defer();
      $timeout(function () {
        if (window.FileReader && file &&
          (!window.FileAPI || navigator.userAgent.indexOf('MSIE 8') === -1 || file.size < 20000) &&
          (!window.FileAPI || navigator.userAgent.indexOf('MSIE 9') === -1 || file.size < 4000000)) {
          //prefer URL.createObjectURL for handling refrences to files of all sizes
          //since it doesn´t build a large string in memory
          var URL = window.URL || window.webkitURL;
          if (URL && URL.createObjectURL && !disallowObjectUrl) {
            var url;
            try {
              url = URL.createObjectURL(file);
            } catch (e) {
              $timeout(function () {
                file.$ngfBlobUrl = '';
                deferred.reject();
              });
              return;
            }
            $timeout(function () {
              file.$ngfBlobUrl = url;
              if (url) {
                deferred.resolve(url, file);
                upload.blobUrls = upload.blobUrls || [];
                upload.blobUrlsTotalSize = upload.blobUrlsTotalSize || 0;
                upload.blobUrls.push({url: url, size: file.size});
                upload.blobUrlsTotalSize += file.size || 0;
                var maxMemory = upload.defaults.blobUrlsMaxMemory || 268435456;
                var maxLength = upload.defaults.blobUrlsMaxQueueSize || 200;
                while ((upload.blobUrlsTotalSize > maxMemory || upload.blobUrls.length > maxLength) && upload.blobUrls.length > 1) {
                  var obj = upload.blobUrls.splice(0, 1)[0];
                  URL.revokeObjectURL(obj.url);
                  upload.blobUrlsTotalSize -= obj.size;
                }
              }
            });
          } else {
            var fileReader = new FileReader();
            fileReader.onload = function (e) {
              $timeout(function () {
                file.$ngfDataUrl = e.target.result;
                deferred.resolve(e.target.result, file);
                $timeout(function () {
                  delete file.$ngfDataUrl;
                }, 1000);
              });
            };
            fileReader.onerror = function () {
              $timeout(function () {
                file.$ngfDataUrl = '';
                deferred.reject();
              });
            };
            fileReader.readAsDataURL(file);
          }
        } else {
          $timeout(function () {
            file[disallowObjectUrl ? '$ngfDataUrl' : '$ngfBlobUrl'] = '';
            deferred.reject();
          });
        }
      });

      if (disallowObjectUrl) {
        p = file.$$ngfDataUrlPromise = deferred.promise;
      } else {
        p = file.$$ngfBlobUrlPromise = deferred.promise;
      }
      p['finally'](function () {
        delete file[disallowObjectUrl ? '$$ngfDataUrlPromise' : '$$ngfBlobUrlPromise'];
      });
      return p;
    };
    return upload;
  }]);

  function getTagType(el) {
    if (el.tagName.toLowerCase() === 'img') return 'image';
    if (el.tagName.toLowerCase() === 'audio') return 'audio';
    if (el.tagName.toLowerCase() === 'video') return 'video';
    return /./;
  }

  function linkFileDirective(Upload, $timeout, scope, elem, attr, directiveName, resizeParams, isBackground) {
    function constructDataUrl(file) {
      var disallowObjectUrl = Upload.attrGetter('ngfNoObjectUrl', attr, scope);
      Upload.dataUrl(file, disallowObjectUrl)['finally'](function () {
        $timeout(function () {
          var src = (disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl;
          if (isBackground) {
            elem.css('background-image', 'url(\'' + (src || '') + '\')');
          } else {
            elem.attr('src', src);
          }
          if (src) {
            elem.removeClass('ng-hide');
          } else {
            elem.addClass('ng-hide');
          }
        });
      });
    }

    $timeout(function () {
      var unwatch = scope.$watch(attr[directiveName], function (file) {
        var size = resizeParams;
        if (directiveName === 'ngfThumbnail') {
          if (!size) {
            size = {width: elem[0].naturalWidth || elem[0].clientWidth,
              height: elem[0].naturalHeight || elem[0].clientHeight};
          }
          if (size.width === 0 && window.getComputedStyle) {
            var style = getComputedStyle(elem[0]);
            size = {
              width: parseInt(style.width.slice(0, -2)),
              height: parseInt(style.height.slice(0, -2))
            };
          }
        }

        if (angular.isString(file)) {
          elem.removeClass('ng-hide');
          if (isBackground) {
            return elem.css('background-image', 'url(\'' + file + '\')');
          } else {
            return elem.attr('src', file);
          }
        }
        if (file && file.type && file.type.search(getTagType(elem[0])) === 0 &&
          (!isBackground || file.type.indexOf('image') === 0)) {
          if (size && Upload.isResizeSupported()) {
            size.resizeIf = function (width, height) {
              return Upload.attrGetter('ngfResizeIf', attr, scope,
                {$width: width, $height: height, $file: file});
            };
            Upload.resize(file, size).then(
              function (f) {
                constructDataUrl(f);
              }, function (e) {
                throw e;
              }
            );
          } else {
            constructDataUrl(file);
          }
        } else {
          elem.addClass('ng-hide');
        }
      });

      scope.$on('$destroy', function () {
        unwatch();
      });
    });
  }


  /** @namespace attr.ngfSrc */
  /** @namespace attr.ngfNoObjectUrl */
  ngFileUpload.directive('ngfSrc', ['Upload', '$timeout', function (Upload, $timeout) {
    return {
      restrict: 'AE',
      link: function (scope, elem, attr) {
        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfSrc',
          Upload.attrGetter('ngfResize', attr, scope), false);
      }
    };
  }]);

  /** @namespace attr.ngfBackground */
  /** @namespace attr.ngfNoObjectUrl */
  ngFileUpload.directive('ngfBackground', ['Upload', '$timeout', function (Upload, $timeout) {
    return {
      restrict: 'AE',
      link: function (scope, elem, attr) {
        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfBackground',
          Upload.attrGetter('ngfResize', attr, scope), true);
      }
    };
  }]);

  /** @namespace attr.ngfThumbnail */
  /** @namespace attr.ngfAsBackground */
  /** @namespace attr.ngfSize */
  /** @namespace attr.ngfNoObjectUrl */
  ngFileUpload.directive('ngfThumbnail', ['Upload', '$timeout', function (Upload, $timeout) {
    return {
      restrict: 'AE',
      link: function (scope, elem, attr) {
        var size = Upload.attrGetter('ngfSize', attr, scope);
        linkFileDirective(Upload, $timeout, scope, elem, attr, 'ngfThumbnail', size,
          Upload.attrGetter('ngfAsBackground', attr, scope));
      }
    };
  }]);

  ngFileUpload.config(['$compileProvider', function ($compileProvider) {
    if ($compileProvider.imgSrcSanitizationWhitelist) $compileProvider.imgSrcSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|webcal|local|file|data|blob):/);
    if ($compileProvider.aHrefSanitizationWhitelist) $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|webcal|local|file|data|blob):/);
  }]);

  ngFileUpload.filter('ngfDataUrl', ['UploadDataUrl', '$sce', function (UploadDataUrl, $sce) {
    return function (file, disallowObjectUrl, trustedUrl) {
      if (angular.isString(file)) {
        return $sce.trustAsResourceUrl(file);
      }
      var src = file && ((disallowObjectUrl ? file.$ngfDataUrl : file.$ngfBlobUrl) || file.$ngfDataUrl);
      if (file && !src) {
        if (!file.$ngfDataUrlFilterInProgress && angular.isObject(file)) {
          file.$ngfDataUrlFilterInProgress = true;
          UploadDataUrl.dataUrl(file, disallowObjectUrl);
        }
        return '';
      }
      if (file) delete file.$ngfDataUrlFilterInProgress;
      return (file && src ? (trustedUrl ? $sce.trustAsResourceUrl(src) : src) : file) || '';
    };
  }]);

})();

ngFileUpload.service('UploadValidate', ['UploadDataUrl', '$q', '$timeout', function (UploadDataUrl, $q, $timeout) {
  var upload = UploadDataUrl;

  function globStringToRegex(str) {
    var regexp = '', excludes = [];
    if (str.length > 2 && str[0] === '/' && str[str.length - 1] === '/') {
      regexp = str.substring(1, str.length - 1);
    } else {
      var split = str.split(',');
      if (split.length > 1) {
        for (var i = 0; i < split.length; i++) {
          var r = globStringToRegex(split[i]);
          if (r.regexp) {
            regexp += '(' + r.regexp + ')';
            if (i < split.length - 1) {
              regexp += '|';
            }
          } else {
            excludes = excludes.concat(r.excludes);
          }
        }
      } else {
        if (str.indexOf('!') === 0) {
          excludes.push('^((?!' + globStringToRegex(str.substring(1)).regexp + ').)*$');
        } else {
          if (str.indexOf('.') === 0) {
            str = '*' + str;
          }
          regexp = '^' + str.replace(new RegExp('[.\\\\+*?\\[\\^\\]$(){}=!<>|:\\-]', 'g'), '\\$&') + '$';
          regexp = regexp.replace(/\\\*/g, '.*').replace(/\\\?/g, '.');
        }
      }
    }
    return {regexp: regexp, excludes: excludes};
  }

  upload.validatePattern = function (file, val) {
    if (!val) {
      return true;
    }
    var pattern = globStringToRegex(val), valid = true;
    if (pattern.regexp && pattern.regexp.length) {
      var regexp = new RegExp(pattern.regexp, 'i');
      valid = (file.type != null && regexp.test(file.type)) ||
        (file.name != null && regexp.test(file.name));
    }
    var len = pattern.excludes.length;
    while (len--) {
      var exclude = new RegExp(pattern.excludes[len], 'i');
      valid = valid && (file.type == null || exclude.test(file.type)) &&
        (file.name == null || exclude.test(file.name));
    }
    return valid;
  };

  upload.ratioToFloat = function (val) {
    var r = val.toString(), xIndex = r.search(/[x:]/i);
    if (xIndex > -1) {
      r = parseFloat(r.substring(0, xIndex)) / parseFloat(r.substring(xIndex + 1));
    } else {
      r = parseFloat(r);
    }
    return r;
  };

  upload.registerModelChangeValidator = function (ngModel, attr, scope) {
    if (ngModel) {
      ngModel.$formatters.push(function (files) {
        if (ngModel.$dirty) {
          if (files && !angular.isArray(files)) {
            files = [files];
          }
          upload.validate(files, 0, ngModel, attr, scope).then(function () {
            upload.applyModelValidation(ngModel, files);
          });
        }
      });
    }
  };

  function markModelAsDirty(ngModel, files) {
    if (files != null && !ngModel.$dirty) {
      if (ngModel.$setDirty) {
        ngModel.$setDirty();
      } else {
        ngModel.$dirty = true;
      }
    }
  }

  upload.applyModelValidation = function (ngModel, files) {
    markModelAsDirty(ngModel, files);
    angular.forEach(ngModel.$ngfValidations, function (validation) {
      ngModel.$setValidity(validation.name, validation.valid);
    });
  };

  upload.getValidationAttr = function (attr, scope, name, validationName, file) {
    var dName = 'ngf' + name[0].toUpperCase() + name.substr(1);
    var val = upload.attrGetter(dName, attr, scope, {$file: file});
    if (val == null) {
      val = upload.attrGetter('ngfValidate', attr, scope, {$file: file});
      if (val) {
        var split = (validationName || name).split('.');
        val = val[split[0]];
        if (split.length > 1) {
          val = val && val[split[1]];
        }
      }
    }
    return val;
  };

  upload.validate = function (files, prevLength, ngModel, attr, scope) {
    ngModel = ngModel || {};
    ngModel.$ngfValidations = ngModel.$ngfValidations || [];

    angular.forEach(ngModel.$ngfValidations, function (v) {
      v.valid = true;
    });

    var attrGetter = function (name, params) {
      return upload.attrGetter(name, attr, scope, params);
    };

    var ignoredErrors = (upload.attrGetter('ngfIgnoreInvalid', attr, scope) || '').split(' ');
    var runAllValidation = upload.attrGetter('ngfRunAllValidations', attr, scope);

    if (files == null || files.length === 0) {
      return upload.emptyPromise({'validFiles': files, 'invalidFiles': []});
    }

    files = files.length === undefined ? [files] : files.slice(0);
    var invalidFiles = [];

    function validateSync(name, validationName, fn) {
      if (files) {
        var i = files.length, valid = null;
        while (i--) {
          var file = files[i];
          if (file) {
            var val = upload.getValidationAttr(attr, scope, name, validationName, file);
            if (val != null) {
              if (!fn(file, val, i)) {
                if (ignoredErrors.indexOf(name) === -1) {
                  file.$error = name;
                  (file.$errorMessages = (file.$errorMessages || {}))[name] = true;
                  file.$errorParam = val;
                  if (invalidFiles.indexOf(file) === -1) {
                    invalidFiles.push(file);
                  }
                  if (!runAllValidation) {
                    files.splice(i, 1);
                  }
                  valid = false;
                } else {
                  files.splice(i, 1);
                }
              }
            }
          }
        }
        if (valid !== null) {
          ngModel.$ngfValidations.push({name: name, valid: valid});
        }
      }
    }

    validateSync('pattern', null, upload.validatePattern);
    validateSync('minSize', 'size.min', function (file, val) {
      return file.size + 0.1 >= upload.translateScalars(val);
    });
    validateSync('maxSize', 'size.max', function (file, val) {
      return file.size - 0.1 <= upload.translateScalars(val);
    });
    var totalSize = 0;
    validateSync('maxTotalSize', null, function (file, val) {
      totalSize += file.size;
      if (totalSize > upload.translateScalars(val)) {
        files.splice(0, files.length);
        return false;
      }
      return true;
    });

    validateSync('validateFn', null, function (file, r) {
      return r === true || r === null || r === '';
    });

    if (!files.length) {
      return upload.emptyPromise({'validFiles': [], 'invalidFiles': invalidFiles});
    }

    function validateAsync(name, validationName, type, asyncFn, fn) {
      function resolveResult(defer, file, val) {
        function resolveInternal(fn) {
          if (fn()) {
            if (ignoredErrors.indexOf(name) === -1) {
              file.$error = name;
              (file.$errorMessages = (file.$errorMessages || {}))[name] = true;
              file.$errorParam = val;
              if (invalidFiles.indexOf(file) === -1) {
                invalidFiles.push(file);
              }
              if (!runAllValidation) {
                files.splice(files.indexOf(file), 1);
              }
            } else {
              files.splice(files.indexOf(file), 1);
            }
            defer.resolve(false);
          } else {
            defer.resolve(true);
          }
        }

        if (val != null) {
          asyncFn(file, val).then(function (d) {
            resolveInternal(function () {
              return !fn(d, val);
            });
          }, function () {
            resolveInternal(function () {
              return attrGetter('ngfValidateForce', {$file: file});
            });
          });
        } else {
          defer.resolve(true);
        }
      }

      var promises = [upload.emptyPromise(true)];
      if (files) {
        files = files.length === undefined ? [files] : files;
        angular.forEach(files, function (file) {
          var defer = $q.defer();
          promises.push(defer.promise);
          if (type && (file.type == null || file.type.search(type) !== 0)) {
            defer.resolve(true);
            return;
          }
          if (name === 'dimensions' && upload.attrGetter('ngfDimensions', attr) != null) {
            upload.imageDimensions(file).then(function (d) {
              resolveResult(defer, file,
                attrGetter('ngfDimensions', {$file: file, $width: d.width, $height: d.height}));
            }, function () {
              defer.resolve(false);
            });
          } else if (name === 'duration' && upload.attrGetter('ngfDuration', attr) != null) {
            upload.mediaDuration(file).then(function (d) {
              resolveResult(defer, file,
                attrGetter('ngfDuration', {$file: file, $duration: d}));
            }, function () {
              defer.resolve(false);
            });
          } else {
            resolveResult(defer, file,
              upload.getValidationAttr(attr, scope, name, validationName, file));
          }
        });
      }
      var deffer = $q.defer();
      $q.all(promises).then(function (values) {
        var isValid = true;
        for (var i = 0; i < values.length; i++) {
          if (!values[i]) {
            isValid = false;
            break;
          }
        }
        ngModel.$ngfValidations.push({name: name, valid: isValid});
        deffer.resolve(isValid);
      });
      return deffer.promise;
    }

    var deffer = $q.defer();
    var promises = [];

    promises.push(validateAsync('maxHeight', 'height.max', /image/,
      this.imageDimensions, function (d, val) {
        return d.height <= val;
      }));
    promises.push(validateAsync('minHeight', 'height.min', /image/,
      this.imageDimensions, function (d, val) {
        return d.height >= val;
      }));
    promises.push(validateAsync('maxWidth', 'width.max', /image/,
      this.imageDimensions, function (d, val) {
        return d.width <= val;
      }));
    promises.push(validateAsync('minWidth', 'width.min', /image/,
      this.imageDimensions, function (d, val) {
        return d.width >= val;
      }));
    promises.push(validateAsync('dimensions', null, /image/,
      function (file, val) {
        return upload.emptyPromise(val);
      }, function (r) {
        return r;
      }));
    promises.push(validateAsync('ratio', null, /image/,
      this.imageDimensions, function (d, val) {
        var split = val.toString().split(','), valid = false;
        for (var i = 0; i < split.length; i++) {
          if (Math.abs((d.width / d.height) - upload.ratioToFloat(split[i])) < 0.01) {
            valid = true;
          }
        }
        return valid;
      }));
    promises.push(validateAsync('maxRatio', 'ratio.max', /image/,
      this.imageDimensions, function (d, val) {
        return (d.width / d.height) - upload.ratioToFloat(val) < 0.0001;
      }));
    promises.push(validateAsync('minRatio', 'ratio.min', /image/,
      this.imageDimensions, function (d, val) {
        return (d.width / d.height) - upload.ratioToFloat(val) > -0.0001;
      }));
    promises.push(validateAsync('maxDuration', 'duration.max', /audio|video/,
      this.mediaDuration, function (d, val) {
        return d <= upload.translateScalars(val);
      }));
    promises.push(validateAsync('minDuration', 'duration.min', /audio|video/,
      this.mediaDuration, function (d, val) {
        return d >= upload.translateScalars(val);
      }));
    promises.push(validateAsync('duration', null, /audio|video/,
      function (file, val) {
        return upload.emptyPromise(val);
      }, function (r) {
        return r;
      }));

    promises.push(validateAsync('validateAsyncFn', null, null,
      function (file, val) {
        return val;
      }, function (r) {
        return r === true || r === null || r === '';
      }));

    $q.all(promises).then(function () {

      if (runAllValidation) {
        for (var i = 0; i < files.length; i++) {
          var file = files[i];
          if (file.$error) {
            files.splice(i--, 1);
          }
        }
      }

      runAllValidation = false;
      validateSync('maxFiles', null, function (file, val, i) {
        return prevLength + i < val;
      });

      deffer.resolve({'validFiles': files, 'invalidFiles': invalidFiles});
    });
    return deffer.promise;
  };

  upload.imageDimensions = function (file) {
    if (file.$ngfWidth && file.$ngfHeight) {
      var d = $q.defer();
      $timeout(function () {
        d.resolve({width: file.$ngfWidth, height: file.$ngfHeight});
      });
      return d.promise;
    }
    if (file.$ngfDimensionPromise) return file.$ngfDimensionPromise;

    var deferred = $q.defer();
    $timeout(function () {
      if (file.type.indexOf('image') !== 0) {
        deferred.reject('not image');
        return;
      }
      upload.dataUrl(file).then(function (dataUrl) {
        var img = angular.element('<img>').attr('src', dataUrl)
          .css('visibility', 'hidden').css('position', 'fixed')
          .css('max-width', 'none !important').css('max-height', 'none !important');

        function success() {
          var width = img[0].naturalWidth || img[0].clientWidth;
          var height = img[0].naturalHeight || img[0].clientHeight;
          img.remove();
          file.$ngfWidth = width;
          file.$ngfHeight = height;
          deferred.resolve({width: width, height: height});
        }

        function error() {
          img.remove();
          deferred.reject('load error');
        }

        img.on('load', success);
        img.on('error', error);

        var secondsCounter = 0;
        function checkLoadErrorInCaseOfNoCallback() {
          $timeout(function () {
            if (img[0].parentNode) {
              if (img[0].clientWidth) {
                success();
              } else if (secondsCounter++ > 10) {
                error();
              } else {
                checkLoadErrorInCaseOfNoCallback();
              }
            }
          }, 1000);
        }

        checkLoadErrorInCaseOfNoCallback();

        angular.element(document.getElementsByTagName('body')[0]).append(img);
      }, function () {
        deferred.reject('load error');
      });
    });

    file.$ngfDimensionPromise = deferred.promise;
    file.$ngfDimensionPromise['finally'](function () {
      delete file.$ngfDimensionPromise;
    });
    return file.$ngfDimensionPromise;
  };

  upload.mediaDuration = function (file) {
    if (file.$ngfDuration) {
      var d = $q.defer();
      $timeout(function () {
        d.resolve(file.$ngfDuration);
      });
      return d.promise;
    }
    if (file.$ngfDurationPromise) return file.$ngfDurationPromise;

    var deferred = $q.defer();
    $timeout(function () {
      if (file.type.indexOf('audio') !== 0 && file.type.indexOf('video') !== 0) {
        deferred.reject('not media');
        return;
      }
      upload.dataUrl(file).then(function (dataUrl) {
        var el = angular.element(file.type.indexOf('audio') === 0 ? '<audio>' : '<video>')
          .attr('src', dataUrl).css('visibility', 'none').css('position', 'fixed');

        function success() {
          var duration = el[0].duration;
          file.$ngfDuration = duration;
          el.remove();
          deferred.resolve(duration);
        }

        function error() {
          el.remove();
          deferred.reject('load error');
        }

        el.on('loadedmetadata', success);
        el.on('error', error);
        var count = 0;

        function checkLoadError() {
          $timeout(function () {
            if (el[0].parentNode) {
              if (el[0].duration) {
                success();
              } else if (count > 10) {
                error();
              } else {
                checkLoadError();
              }
            }
          }, 1000);
        }

        checkLoadError();

        angular.element(document.body).append(el);
      }, function () {
        deferred.reject('load error');
      });
    });

    file.$ngfDurationPromise = deferred.promise;
    file.$ngfDurationPromise['finally'](function () {
      delete file.$ngfDurationPromise;
    });
    return file.$ngfDurationPromise;
  };
  return upload;
}
]);

ngFileUpload.service('UploadResize', ['UploadValidate', '$q', function (UploadValidate, $q) {
  var upload = UploadValidate;

  /**
   * Conserve aspect ratio of the original region. Useful when shrinking/enlarging
   * images to fit into a certain area.
   * Source:  http://stackoverflow.com/a/14731922
   *
   * @param {Number} srcWidth Source area width
   * @param {Number} srcHeight Source area height
   * @param {Number} maxWidth Nestable area maximum available width
   * @param {Number} maxHeight Nestable area maximum available height
   * @return {Object} { width, height }
   */
  var calculateAspectRatioFit = function (srcWidth, srcHeight, maxWidth, maxHeight, centerCrop) {
    var ratio = centerCrop ? Math.max(maxWidth / srcWidth, maxHeight / srcHeight) :
      Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
    return {
      width: srcWidth * ratio, height: srcHeight * ratio,
      marginX: srcWidth * ratio - maxWidth, marginY: srcHeight * ratio - maxHeight
    };
  };

  // Extracted from https://github.com/romelgomez/angular-firebase-image-upload/blob/master/app/scripts/fileUpload.js#L89
  var resize = function (imagen, width, height, quality, type, ratio, centerCrop, resizeIf) {
    var deferred = $q.defer();
    var canvasElement = document.createElement('canvas');
    var imageElement = document.createElement('img');
    imageElement.setAttribute('style', 'visibility:hidden;position:fixed;z-index:-100000');
    document.body.appendChild(imageElement);

    imageElement.onload = function () {
      var imgWidth = imageElement.width, imgHeight = imageElement.height;
      imageElement.parentNode.removeChild(imageElement);
      if (resizeIf != null && resizeIf(imgWidth, imgHeight) === false) {
        deferred.reject('resizeIf');
        return;
      }
      try {
        if (ratio) {
          var ratioFloat = upload.ratioToFloat(ratio);
          var imgRatio = imgWidth / imgHeight;
          if (imgRatio < ratioFloat) {
            width = imgWidth;
            height = width / ratioFloat;
          } else {
            height = imgHeight;
            width = height * ratioFloat;
          }
        }
        if (!width) {
          width = imgWidth;
        }
        if (!height) {
          height = imgHeight;
        }
        var dimensions = calculateAspectRatioFit(imgWidth, imgHeight, width, height, centerCrop);
        canvasElement.width = Math.min(dimensions.width, width);
        canvasElement.height = Math.min(dimensions.height, height);
        var context = canvasElement.getContext('2d');
        context.drawImage(imageElement,
          Math.min(0, -dimensions.marginX / 2), Math.min(0, -dimensions.marginY / 2),
          dimensions.width, dimensions.height);
        deferred.resolve(canvasElement.toDataURL(type || 'image/WebP', quality || 0.934));
      } catch (e) {
        deferred.reject(e);
      }
    };
    imageElement.onerror = function () {
      imageElement.parentNode.removeChild(imageElement);
      deferred.reject();
    };
    imageElement.src = imagen;
    return deferred.promise;
  };

  upload.dataUrltoBlob = function (dataurl, name, origSize) {
    var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    var blob = new window.Blob([u8arr], {type: mime});
    blob.name = name;
    blob.$ngfOrigSize = origSize;
    return blob;
  };

  upload.isResizeSupported = function () {
    var elem = document.createElement('canvas');
    return window.atob && elem.getContext && elem.getContext('2d') && window.Blob;
  };

  if (upload.isResizeSupported()) {
    // add name getter to the blob constructor prototype
    Object.defineProperty(window.Blob.prototype, 'name', {
      get: function () {
        return this.$ngfName;
      },
      set: function (v) {
        this.$ngfName = v;
      },
      configurable: true
    });
  }

  upload.resize = function (file, options) {
    if (file.type.indexOf('image') !== 0) return upload.emptyPromise(file);

    var deferred = $q.defer();
    upload.dataUrl(file, true).then(function (url) {
      resize(url, options.width, options.height, options.quality, options.type || file.type,
        options.ratio, options.centerCrop, options.resizeIf)
        .then(function (dataUrl) {
          if (file.type === 'image/jpeg' && options.restoreExif !== false) {
            try {
              dataUrl = upload.restoreExif(url, dataUrl);
            } catch (e) {
              setTimeout(function () {throw e;}, 1);
            }
          }
          try {
            var blob = upload.dataUrltoBlob(dataUrl, file.name, file.size);
            deferred.resolve(blob);
          } catch (e) {
            deferred.reject(e);
          }
        }, function (r) {
          if (r === 'resizeIf') {
            deferred.resolve(file);
          }
          deferred.reject(r);
        });
    }, function (e) {
      deferred.reject(e);
    });
    return deferred.promise;
  };

  return upload;
}]);

(function () {
  ngFileUpload.directive('ngfDrop', ['$parse', '$timeout', '$window', 'Upload', '$http', '$q',
    function ($parse, $timeout, $window, Upload, $http, $q) {
      return {
        restrict: 'AEC',
        require: '?ngModel',
        link: function (scope, elem, attr, ngModel) {
          linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $window, Upload, $http, $q);
        }
      };
    }]);

  ngFileUpload.directive('ngfNoFileDrop', function () {
    return function (scope, elem) {
      if (dropAvailable()) elem.css('display', 'none');
    };
  });

  ngFileUpload.directive('ngfDropAvailable', ['$parse', '$timeout', 'Upload', function ($parse, $timeout, Upload) {
    return function (scope, elem, attr) {
      if (dropAvailable()) {
        var model = $parse(Upload.attrGetter('ngfDropAvailable', attr));
        $timeout(function () {
          model(scope);
          if (model.assign) {
            model.assign(scope, true);
          }
        });
      }
    };
  }]);

  function linkDrop(scope, elem, attr, ngModel, $parse, $timeout, $window, upload, $http, $q) {
    var available = dropAvailable();

    var attrGetter = function (name, scope, params) {
      return upload.attrGetter(name, attr, scope, params);
    };

    if (attrGetter('dropAvailable')) {
      $timeout(function () {
        if (scope[attrGetter('dropAvailable')]) {
          scope[attrGetter('dropAvailable')].value = available;
        } else {
          scope[attrGetter('dropAvailable')] = available;
        }
      });
    }
    if (!available) {
      if (attrGetter('ngfHideOnDropNotAvailable', scope) === true) {
        elem.css('display', 'none');
      }
      return;
    }

    function isDisabled() {
      return elem.attr('disabled') || attrGetter('ngfDropDisabled', scope);
    }

    if (attrGetter('ngfSelect') == null) {
      upload.registerModelChangeValidator(ngModel, attr, scope);
    }

    var leaveTimeout = null;
    var stopPropagation = $parse(attrGetter('ngfStopPropagation'));
    var dragOverDelay = 1;
    var actualDragOverClass;

    elem[0].addEventListener('dragover', function (evt) {
      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
      evt.preventDefault();
      if (stopPropagation(scope)) evt.stopPropagation();
      // handling dragover events from the Chrome download bar
      if (navigator.userAgent.indexOf('Chrome') > -1) {
        var b = evt.dataTransfer.effectAllowed;
        evt.dataTransfer.dropEffect = ('move' === b || 'linkMove' === b) ? 'move' : 'copy';
      }
      $timeout.cancel(leaveTimeout);
      if (!actualDragOverClass) {
        actualDragOverClass = 'C';
        calculateDragOverClass(scope, attr, evt, function (clazz) {
          actualDragOverClass = clazz;
          elem.addClass(actualDragOverClass);
          attrGetter('ngfDrag', scope, {$isDragging: true, $class: actualDragOverClass, $event: evt});
        });
      }
    }, false);
    elem[0].addEventListener('dragenter', function (evt) {
      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
      evt.preventDefault();
      if (stopPropagation(scope)) evt.stopPropagation();
    }, false);
    elem[0].addEventListener('dragleave', function (evt) {
      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
      evt.preventDefault();
      if (stopPropagation(scope)) evt.stopPropagation();
      leaveTimeout = $timeout(function () {
        if (actualDragOverClass) elem.removeClass(actualDragOverClass);
        actualDragOverClass = null;
        attrGetter('ngfDrag', scope, {$isDragging: false, $event: evt});
      }, dragOverDelay || 100);
    }, false);
    elem[0].addEventListener('drop', function (evt) {
      if (isDisabled() || !upload.shouldUpdateOn('drop', attr, scope)) return;
      evt.preventDefault();
      if (stopPropagation(scope)) evt.stopPropagation();
      if (actualDragOverClass) elem.removeClass(actualDragOverClass);
      actualDragOverClass = null;
      var items = evt.dataTransfer.items;
      var html;
      try {
        html = evt.dataTransfer && evt.dataTransfer.getData && evt.dataTransfer.getData('text/html');
      } catch (e) {/* Fix IE11 that throw error calling getData */
      }

      extractFiles(items, evt.dataTransfer.files, attrGetter('ngfAllowDir', scope) !== false,
        attrGetter('multiple') || attrGetter('ngfMultiple', scope)).then(function (files) {
        if (files.length) {
          updateModel(files, evt);
        } else {
          extractFilesFromHtml('dropUrl', html).then(function (files) {
            updateModel(files, evt);
          });
        }
      });
    }, false);
    elem[0].addEventListener('paste', function (evt) {
      if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 &&
        attrGetter('ngfEnableFirefoxPaste', scope)) {
        evt.preventDefault();
      }
      if (isDisabled() || !upload.shouldUpdateOn('paste', attr, scope)) return;
      var files = [];
      var clipboard = evt.clipboardData || evt.originalEvent.clipboardData;
      if (clipboard && clipboard.items) {
        for (var k = 0; k < clipboard.items.length; k++) {
          if (clipboard.items[k].type.indexOf('image') !== -1) {
            files.push(clipboard.items[k].getAsFile());
          }
        }
      }
      if (files.length) {
        updateModel(files, evt);
      } else {
        extractFilesFromHtml('pasteUrl', clipboard).then(function (files) {
          updateModel(files, evt);
        });
      }
    }, false);

    if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1 &&
      attrGetter('ngfEnableFirefoxPaste', scope)) {
      elem.attr('contenteditable', true);
      elem.on('keypress', function (e) {
        if (!e.metaKey && !e.ctrlKey) {
          e.preventDefault();
        }
      });
    }

    function updateModel(files, evt) {
      upload.updateModel(ngModel, attr, scope, attrGetter('ngfChange') || attrGetter('ngfDrop'), files, evt);
    }

    function extractFilesFromHtml(updateOn, html) {
      if (!upload.shouldUpdateOn(updateOn, attr, scope) || typeof html !== 'string') return upload.rejectPromise([]);
      var urls = [];
      html.replace(/<(img src|img [^>]* src) *=\"([^\"]*)\"/gi, function (m, n, src) {
        urls.push(src);
      });
      var promises = [], files = [];
      if (urls.length) {
        angular.forEach(urls, function (url) {
          promises.push(upload.urlToBlob(url).then(function (blob) {
            files.push(blob);
          }));
        });
        var defer = $q.defer();
        $q.all(promises).then(function () {
          defer.resolve(files);
        }, function (e) {
          defer.reject(e);
        });
        return defer.promise;
      }
      return upload.emptyPromise();
    }

    function calculateDragOverClass(scope, attr, evt, callback) {
      var obj = attrGetter('ngfDragOverClass', scope, {$event: evt}), dClass = 'dragover';
      if (angular.isString(obj)) {
        dClass = obj;
      } else if (obj) {
        if (obj.delay) dragOverDelay = obj.delay;
        if (obj.accept || obj.reject) {
          var items = evt.dataTransfer.items;
          if (items == null || !items.length) {
            dClass = obj.accept;
          } else {
            var pattern = obj.pattern || attrGetter('ngfPattern', scope, {$event: evt});
            var len = items.length;
            while (len--) {
              if (!upload.validatePattern(items[len], pattern)) {
                dClass = obj.reject;
                break;
              } else {
                dClass = obj.accept;
              }
            }
          }
        }
      }
      callback(dClass);
    }

    function extractFiles(items, fileList, allowDir, multiple) {
      var maxFiles = upload.getValidationAttr(attr, scope, 'maxFiles');
      if (maxFiles == null) {
        maxFiles = Number.MAX_VALUE;
      }
      var maxTotalSize = upload.getValidationAttr(attr, scope, 'maxTotalSize');
      if (maxTotalSize == null) {
        maxTotalSize = Number.MAX_VALUE;
      }
      var includeDir = attrGetter('ngfIncludeDir', scope);
      var files = [], totalSize = 0;

      function traverseFileTree(entry, path) {
        var defer = $q.defer();
        if (entry != null) {
          if (entry.isDirectory) {
            var promises = [upload.emptyPromise()];
            if (includeDir) {
              var file = {type: 'directory'};
              file.name = file.path = (path || '') + entry.name;
              files.push(file);
            }
            var dirReader = entry.createReader();
            var entries = [];
            var readEntries = function () {
              dirReader.readEntries(function (results) {
                try {
                  if (!results.length) {
                    angular.forEach(entries.slice(0), function (e) {
                      if (files.length <= maxFiles && totalSize <= maxTotalSize) {
                        promises.push(traverseFileTree(e, (path ? path : '') + entry.name + '/'));
                      }
                    });
                    $q.all(promises).then(function () {
                      defer.resolve();
                    }, function (e) {
                      defer.reject(e);
                    });
                  } else {
                    entries = entries.concat(Array.prototype.slice.call(results || [], 0));
                    readEntries();
                  }
                } catch (e) {
                  defer.reject(e);
                }
              }, function (e) {
                defer.reject(e);
              });
            };
            readEntries();
          } else {
            entry.file(function (file) {
              try {
                file.path = (path ? path : '') + file.name;
                if (includeDir) {
                  file = upload.rename(file, file.path);
                }
                files.push(file);
                totalSize += file.size;
                defer.resolve();
              } catch (e) {
                defer.reject(e);
              }
            }, function (e) {
              defer.reject(e);
            });
          }
        }
        return defer.promise;
      }

      var promises = [upload.emptyPromise()];

      if (items && items.length > 0 && $window.location.protocol !== 'file:') {
        for (var i = 0; i < items.length; i++) {
          if (items[i].webkitGetAsEntry && items[i].webkitGetAsEntry() && items[i].webkitGetAsEntry().isDirectory) {
            var entry = items[i].webkitGetAsEntry();
            if (entry.isDirectory && !allowDir) {
              continue;
            }
            if (entry != null) {
              promises.push(traverseFileTree(entry));
            }
          } else {
            var f = items[i].getAsFile();
            if (f != null) {
              files.push(f);
              totalSize += f.size;
            }
          }
          if (files.length > maxFiles || totalSize > maxTotalSize ||
            (!multiple && files.length > 0)) break;
        }
      } else {
        if (fileList != null) {
          for (var j = 0; j < fileList.length; j++) {
            var file = fileList.item(j);
            if (file.type || file.size > 0) {
              files.push(file);
              totalSize += file.size;
            }
            if (files.length > maxFiles || totalSize > maxTotalSize ||
              (!multiple && files.length > 0)) break;
          }
        }
      }

      var defer = $q.defer();
      $q.all(promises).then(function () {
        if (!multiple && !includeDir && files.length) {
          var i = 0;
          while (files[i] && files[i].type === 'directory') i++;
          defer.resolve([files[i]]);
        } else {
          defer.resolve(files);
        }
      }, function (e) {
        defer.reject(e);
      });

      return defer.promise;
    }
  }

  function dropAvailable() {
    var div = document.createElement('div');
    return ('draggable' in div) && ('ondrop' in div) && !/Edge\/12./i.test(navigator.userAgent);
  }

})();

// customized version of https://github.com/exif-js/exif-js
ngFileUpload.service('UploadExif', ['UploadResize', '$q', function (UploadResize, $q) {
  var upload = UploadResize;

  upload.isExifSupported = function () {
    return window.FileReader && new FileReader().readAsArrayBuffer && upload.isResizeSupported();
  };

  function applyTransform(ctx, orientation, width, height) {
    switch (orientation) {
      case 2:
        return ctx.transform(-1, 0, 0, 1, width, 0);
      case 3:
        return ctx.transform(-1, 0, 0, -1, width, height);
      case 4:
        return ctx.transform(1, 0, 0, -1, 0, height);
      case 5:
        return ctx.transform(0, 1, 1, 0, 0, 0);
      case 6:
        return ctx.transform(0, 1, -1, 0, height, 0);
      case 7:
        return ctx.transform(0, -1, -1, 0, height, width);
      case 8:
        return ctx.transform(0, -1, 1, 0, 0, width);
    }
  }

  upload.readOrientation = function (file) {
    var defer = $q.defer();
    var reader = new FileReader();
    var slicedFile = file.slice ? file.slice(0, 64 * 1024) : file;
    reader.readAsArrayBuffer(slicedFile);
    reader.onerror = function (e) {
      return defer.reject(e);
    };
    reader.onload = function (e) {
      var result = {orientation: 1};
      var view = new DataView(this.result);
      if (view.getUint16(0, false) !== 0xFFD8) return defer.resolve(result);

      var length = view.byteLength,
        offset = 2;
      while (offset < length) {
        var marker = view.getUint16(offset, false);
        offset += 2;
        if (marker === 0xFFE1) {
          if (view.getUint32(offset += 2, false) !== 0x45786966) return defer.resolve(result);

          var little = view.getUint16(offset += 6, false) === 0x4949;
          offset += view.getUint32(offset + 4, little);
          var tags = view.getUint16(offset, little);
          offset += 2;
          for (var i = 0; i < tags; i++)
            if (view.getUint16(offset + (i * 12), little) === 0x0112) {
              var orientation = view.getUint16(offset + (i * 12) + 8, little);
              if (orientation >= 2 && orientation <= 8) {
                view.setUint16(offset + (i * 12) + 8, 1, little);
                result.fixedArrayBuffer = e.target.result;
              }
              result.orientation = orientation;
              return defer.resolve(result);
            }
        } else if ((marker & 0xFF00) !== 0xFF00) break;
        else offset += view.getUint16(offset, false);
      }
      return defer.resolve(result);
    };
    return defer.promise;
  };

  function arrayBufferToBase64(buffer) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  upload.applyExifRotation = function (file) {
    if (file.type.indexOf('image/jpeg') !== 0) {
      return upload.emptyPromise(file);
    }

    var deferred = $q.defer();
    upload.readOrientation(file).then(function (result) {
      if (result.orientation < 2 || result.orientation > 8) {
        return deferred.resolve(file);
      }
      upload.dataUrl(file, true).then(function (url) {
        var canvas = document.createElement('canvas');
        var img = document.createElement('img');

        img.onload = function () {
          try {
            canvas.width = result.orientation > 4 ? img.height : img.width;
            canvas.height = result.orientation > 4 ? img.width : img.height;
            var ctx = canvas.getContext('2d');
            applyTransform(ctx, result.orientation, img.width, img.height);
            ctx.drawImage(img, 0, 0);
            var dataUrl = canvas.toDataURL(file.type || 'image/WebP', 0.934);
            dataUrl = upload.restoreExif(arrayBufferToBase64(result.fixedArrayBuffer), dataUrl);
            var blob = upload.dataUrltoBlob(dataUrl, file.name);
            deferred.resolve(blob);
          } catch (e) {
            return deferred.reject(e);
          }
        };
        img.onerror = function () {
          deferred.reject();
        };
        img.src = url;
      }, function (e) {
        deferred.reject(e);
      });
    }, function (e) {
      deferred.reject(e);
    });
    return deferred.promise;
  };

  upload.restoreExif = function (orig, resized) {
    var ExifRestorer = {};

    ExifRestorer.KEY_STR = 'ABCDEFGHIJKLMNOP' +
      'QRSTUVWXYZabcdef' +
      'ghijklmnopqrstuv' +
      'wxyz0123456789+/' +
      '=';

    ExifRestorer.encode64 = function (input) {
      var output = '',
        chr1, chr2, chr3 = '',
        enc1, enc2, enc3, enc4 = '',
        i = 0;

      do {
        chr1 = input[i++];
        chr2 = input[i++];
        chr3 = input[i++];

        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;

        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
          enc4 = 64;
        }

        output = output +
          this.KEY_STR.charAt(enc1) +
          this.KEY_STR.charAt(enc2) +
          this.KEY_STR.charAt(enc3) +
          this.KEY_STR.charAt(enc4);
        chr1 = chr2 = chr3 = '';
        enc1 = enc2 = enc3 = enc4 = '';
      } while (i < input.length);

      return output;
    };

    ExifRestorer.restore = function (origFileBase64, resizedFileBase64) {
      if (origFileBase64.match('data:image/jpeg;base64,')) {
        origFileBase64 = origFileBase64.replace('data:image/jpeg;base64,', '');
      }

      var rawImage = this.decode64(origFileBase64);
      var segments = this.slice2Segments(rawImage);

      var image = this.exifManipulation(resizedFileBase64, segments);

      return 'data:image/jpeg;base64,' + this.encode64(image);
    };


    ExifRestorer.exifManipulation = function (resizedFileBase64, segments) {
      var exifArray = this.getExifArray(segments),
        newImageArray = this.insertExif(resizedFileBase64, exifArray);
      return new Uint8Array(newImageArray);
    };


    ExifRestorer.getExifArray = function (segments) {
      var seg;
      for (var x = 0; x < segments.length; x++) {
        seg = segments[x];
        if (seg[0] === 255 & seg[1] === 225) //(ff e1)
        {
          return seg;
        }
      }
      return [];
    };


    ExifRestorer.insertExif = function (resizedFileBase64, exifArray) {
      var imageData = resizedFileBase64.replace('data:image/jpeg;base64,', ''),
        buf = this.decode64(imageData),
        separatePoint = buf.indexOf(255, 3),
        mae = buf.slice(0, separatePoint),
        ato = buf.slice(separatePoint),
        array = mae;

      array = array.concat(exifArray);
      array = array.concat(ato);
      return array;
    };


    ExifRestorer.slice2Segments = function (rawImageArray) {
      var head = 0,
        segments = [];

      while (1) {
        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 218) {
          break;
        }
        if (rawImageArray[head] === 255 & rawImageArray[head + 1] === 216) {
          head += 2;
        }
        else {
          var length = rawImageArray[head + 2] * 256 + rawImageArray[head + 3],
            endPoint = head + length + 2,
            seg = rawImageArray.slice(head, endPoint);
          segments.push(seg);
          head = endPoint;
        }
        if (head > rawImageArray.length) {
          break;
        }
      }

      return segments;
    };


    ExifRestorer.decode64 = function (input) {
      var chr1, chr2, chr3 = '',
        enc1, enc2, enc3, enc4 = '',
        i = 0,
        buf = [];

      // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
      var base64test = /[^A-Za-z0-9\+\/\=]/g;
      if (base64test.exec(input)) {
        console.log('There were invalid base64 characters in the input text.\n' +
          'Valid base64 characters are A-Z, a-z, 0-9, ' + ', ' / ',and "="\n' +
          'Expect errors in decoding.');
      }
      input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

      do {
        enc1 = this.KEY_STR.indexOf(input.charAt(i++));
        enc2 = this.KEY_STR.indexOf(input.charAt(i++));
        enc3 = this.KEY_STR.indexOf(input.charAt(i++));
        enc4 = this.KEY_STR.indexOf(input.charAt(i++));

        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;

        buf.push(chr1);

        if (enc3 !== 64) {
          buf.push(chr2);
        }
        if (enc4 !== 64) {
          buf.push(chr3);
        }

        chr1 = chr2 = chr3 = '';
        enc1 = enc2 = enc3 = enc4 = '';

      } while (i < input.length);

      return buf;
    };

    return ExifRestorer.restore(orig, resized);  //<= EXIF
  };

  return upload;
}]);


"use strict";var sjcl={cipher:{},hash:{},keyexchange:{},mode:{},misc:{},codec:{},exception:{corrupt:function(a){this.toString=function(){return"CORRUPT: "+this.message};this.message=a},invalid:function(a){this.toString=function(){return"INVALID: "+this.message};this.message=a},bug:function(a){this.toString=function(){return"BUG: "+this.message};this.message=a},notReady:function(a){this.toString=function(){return"NOT READY: "+this.message};this.message=a}}};
"undefined"!==typeof module&&module.exports&&(module.exports=sjcl);"function"===typeof define&&define([],function(){return sjcl});
sjcl.cipher.aes=function(a){this.s[0][0][0]||this.O();var b,c,d,e,g=this.s[0][4],f=this.s[1];b=a.length;var h=1;if(4!==b&&6!==b&&8!==b)throw new sjcl.exception.invalid("invalid aes key size");this.b=[d=a.slice(0),e=[]];for(a=b;a<4*b+28;a++){c=d[a-1];if(0===a%b||8===b&&4===a%b)c=g[c>>>24]<<24^g[c>>16&255]<<16^g[c>>8&255]<<8^g[c&255],0===a%b&&(c=c<<8^c>>>24^h<<24,h=h<<1^283*(h>>7));d[a]=d[a-b]^c}for(b=0;a;b++,a--)c=d[b&3?a:a-4],e[b]=4>=a||4>b?c:f[0][g[c>>>24]]^f[1][g[c>>16&255]]^f[2][g[c>>8&255]]^f[3][g[c&
255]]};
sjcl.cipher.aes.prototype={encrypt:function(a){return u(this,a,0)},decrypt:function(a){return u(this,a,1)},s:[[[],[],[],[],[]],[[],[],[],[],[]]],O:function(){var a=this.s[0],b=this.s[1],c=a[4],d=b[4],e,g,f,h=[],l=[],k,m,n,p;for(e=0;0x100>e;e++)l[(h[e]=e<<1^283*(e>>7))^e]=e;for(g=f=0;!c[g];g^=k||1,f=l[f]||1)for(n=f^f<<1^f<<2^f<<3^f<<4,n=n>>8^n&255^99,c[g]=n,d[n]=g,m=h[e=h[k=h[g]]],p=0x1010101*m^0x10001*e^0x101*k^0x1010100*g,m=0x101*h[n]^0x1010100*n,e=0;4>e;e++)a[e][g]=m=m<<24^m>>>8,b[e][n]=p=p<<24^p>>>8;for(e=
0;5>e;e++)a[e]=a[e].slice(0),b[e]=b[e].slice(0)}};
function u(a,b,c){if(4!==b.length)throw new sjcl.exception.invalid("invalid aes block size");var d=a.b[c],e=b[0]^d[0],g=b[c?3:1]^d[1],f=b[2]^d[2];b=b[c?1:3]^d[3];var h,l,k,m=d.length/4-2,n,p=4,r=[0,0,0,0];h=a.s[c];a=h[0];var q=h[1],t=h[2],w=h[3],x=h[4];for(n=0;n<m;n++)h=a[e>>>24]^q[g>>16&255]^t[f>>8&255]^w[b&255]^d[p],l=a[g>>>24]^q[f>>16&255]^t[b>>8&255]^w[e&255]^d[p+1],k=a[f>>>24]^q[b>>16&255]^t[e>>8&255]^w[g&255]^d[p+2],b=a[b>>>24]^q[e>>16&255]^t[g>>8&255]^w[f&255]^d[p+3],p+=4,e=h,g=l,f=k;for(n=
0;4>n;n++)r[c?3&-n:n]=x[e>>>24]<<24^x[g>>16&255]<<16^x[f>>8&255]<<8^x[b&255]^d[p++],h=e,e=g,g=f,f=b,b=h;return r}
sjcl.bitArray={bitSlice:function(a,b,c){a=sjcl.bitArray.$(a.slice(b/32),32-(b&31)).slice(1);return void 0===c?a:sjcl.bitArray.clamp(a,c-b)},extract:function(a,b,c){var d=Math.floor(-b-c&31);return((b+c-1^b)&-32?a[b/32|0]<<32-d^a[b/32+1|0]>>>d:a[b/32|0]>>>d)&(1<<c)-1},concat:function(a,b){if(0===a.length||0===b.length)return a.concat(b);var c=a[a.length-1],d=sjcl.bitArray.getPartial(c);return 32===d?a.concat(b):sjcl.bitArray.$(b,d,c|0,a.slice(0,a.length-1))},bitLength:function(a){var b=a.length;return 0===
b?0:32*(b-1)+sjcl.bitArray.getPartial(a[b-1])},clamp:function(a,b){if(32*a.length<b)return a;a=a.slice(0,Math.ceil(b/32));var c=a.length;b=b&31;0<c&&b&&(a[c-1]=sjcl.bitArray.partial(b,a[c-1]&2147483648>>b-1,1));return a},partial:function(a,b,c){return 32===a?b:(c?b|0:b<<32-a)+0x10000000000*a},getPartial:function(a){return Math.round(a/0x10000000000)||32},equal:function(a,b){if(sjcl.bitArray.bitLength(a)!==sjcl.bitArray.bitLength(b))return!1;var c=0,d;for(d=0;d<a.length;d++)c|=a[d]^b[d];return 0===
c},$:function(a,b,c,d){var e;e=0;for(void 0===d&&(d=[]);32<=b;b-=32)d.push(c),c=0;if(0===b)return d.concat(a);for(e=0;e<a.length;e++)d.push(c|a[e]>>>b),c=a[e]<<32-b;e=a.length?a[a.length-1]:0;a=sjcl.bitArray.getPartial(e);d.push(sjcl.bitArray.partial(b+a&31,32<b+a?c:d.pop(),1));return d},i:function(a,b){return[a[0]^b[0],a[1]^b[1],a[2]^b[2],a[3]^b[3]]},byteswapM:function(a){var b,c;for(b=0;b<a.length;++b)c=a[b],a[b]=c>>>24|c>>>8&0xff00|(c&0xff00)<<8|c<<24;return a}};
sjcl.codec.utf8String={fromBits:function(a){var b="",c=sjcl.bitArray.bitLength(a),d,e;for(d=0;d<c/8;d++)0===(d&3)&&(e=a[d/4]),b+=String.fromCharCode(e>>>24),e<<=8;return decodeURIComponent(escape(b))},toBits:function(a){a=unescape(encodeURIComponent(a));var b=[],c,d=0;for(c=0;c<a.length;c++)d=d<<8|a.charCodeAt(c),3===(c&3)&&(b.push(d),d=0);c&3&&b.push(sjcl.bitArray.partial(8*(c&3),d));return b}};
sjcl.codec.hex={fromBits:function(a){var b="",c;for(c=0;c<a.length;c++)b+=((a[c]|0)+0xf00000000000).toString(16).substr(4);return b.substr(0,sjcl.bitArray.bitLength(a)/4)},toBits:function(a){var b,c=[],d;a=a.replace(/\s|0x/g,"");d=a.length;a=a+"00000000";for(b=0;b<a.length;b+=8)c.push(parseInt(a.substr(b,8),16)^0);return sjcl.bitArray.clamp(c,4*d)}};
sjcl.codec.base32={B:"ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",X:"0123456789ABCDEFGHIJKLMNOPQRSTUV",BITS:32,BASE:5,REMAINING:27,fromBits:function(a,b,c){var d=sjcl.codec.base32.BASE,e=sjcl.codec.base32.REMAINING,g="",f=0,h=sjcl.codec.base32.B,l=0,k=sjcl.bitArray.bitLength(a);c&&(h=sjcl.codec.base32.X);for(c=0;g.length*d<k;)g+=h.charAt((l^a[c]>>>f)>>>e),f<d?(l=a[c]<<d-f,f+=e,c++):(l<<=d,f-=d);for(;g.length&7&&!b;)g+="=";return g},toBits:function(a,b){a=a.replace(/\s|=/g,"").toUpperCase();var c=sjcl.codec.base32.BITS,
d=sjcl.codec.base32.BASE,e=sjcl.codec.base32.REMAINING,g=[],f,h=0,l=sjcl.codec.base32.B,k=0,m,n="base32";b&&(l=sjcl.codec.base32.X,n="base32hex");for(f=0;f<a.length;f++){m=l.indexOf(a.charAt(f));if(0>m){if(!b)try{return sjcl.codec.base32hex.toBits(a)}catch(p){}throw new sjcl.exception.invalid("this isn't "+n+"!");}h>e?(h-=e,g.push(k^m>>>h),k=m<<c-h):(h+=d,k^=m<<c-h)}h&56&&g.push(sjcl.bitArray.partial(h&56,k,1));return g}};
sjcl.codec.base32hex={fromBits:function(a,b){return sjcl.codec.base32.fromBits(a,b,1)},toBits:function(a){return sjcl.codec.base32.toBits(a,1)}};
sjcl.codec.base64={B:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",fromBits:function(a,b,c){var d="",e=0,g=sjcl.codec.base64.B,f=0,h=sjcl.bitArray.bitLength(a);c&&(g=g.substr(0,62)+"-_");for(c=0;6*d.length<h;)d+=g.charAt((f^a[c]>>>e)>>>26),6>e?(f=a[c]<<6-e,e+=26,c++):(f<<=6,e-=6);for(;d.length&3&&!b;)d+="=";return d},toBits:function(a,b){a=a.replace(/\s|=/g,"");var c=[],d,e=0,g=sjcl.codec.base64.B,f=0,h;b&&(g=g.substr(0,62)+"-_");for(d=0;d<a.length;d++){h=g.indexOf(a.charAt(d));
if(0>h)throw new sjcl.exception.invalid("this isn't base64!");26<e?(e-=26,c.push(f^h>>>e),f=h<<32-e):(e+=6,f^=h<<32-e)}e&56&&c.push(sjcl.bitArray.partial(e&56,f,1));return c}};sjcl.codec.base64url={fromBits:function(a){return sjcl.codec.base64.fromBits(a,1,1)},toBits:function(a){return sjcl.codec.base64.toBits(a,1)}};sjcl.hash.sha256=function(a){this.b[0]||this.O();a?(this.F=a.F.slice(0),this.A=a.A.slice(0),this.l=a.l):this.reset()};sjcl.hash.sha256.hash=function(a){return(new sjcl.hash.sha256).update(a).finalize()};
sjcl.hash.sha256.prototype={blockSize:512,reset:function(){this.F=this.Y.slice(0);this.A=[];this.l=0;return this},update:function(a){"string"===typeof a&&(a=sjcl.codec.utf8String.toBits(a));var b,c=this.A=sjcl.bitArray.concat(this.A,a);b=this.l;a=this.l=b+sjcl.bitArray.bitLength(a);for(b=512+b&-512;b<=a;b+=512)v(this,c.splice(0,16));return this},finalize:function(){var a,b=this.A,c=this.F,b=sjcl.bitArray.concat(b,[sjcl.bitArray.partial(1,1)]);for(a=b.length+2;a&15;a++)b.push(0);b.push(Math.floor(this.l/
4294967296));for(b.push(this.l|0);b.length;)v(this,b.splice(0,16));this.reset();return c},Y:[],b:[],O:function(){function a(a){return 0x100000000*(a-Math.floor(a))|0}var b=0,c=2,d;a:for(;64>b;c++){for(d=2;d*d<=c;d++)if(0===c%d)continue a;8>b&&(this.Y[b]=a(Math.pow(c,.5)));this.b[b]=a(Math.pow(c,1/3));b++}}};
function v(a,b){var c,d,e,g=b.slice(0),f=a.F,h=a.b,l=f[0],k=f[1],m=f[2],n=f[3],p=f[4],r=f[5],q=f[6],t=f[7];for(c=0;64>c;c++)16>c?d=g[c]:(d=g[c+1&15],e=g[c+14&15],d=g[c&15]=(d>>>7^d>>>18^d>>>3^d<<25^d<<14)+(e>>>17^e>>>19^e>>>10^e<<15^e<<13)+g[c&15]+g[c+9&15]|0),d=d+t+(p>>>6^p>>>11^p>>>25^p<<26^p<<21^p<<7)+(q^p&(r^q))+h[c],t=q,q=r,r=p,p=n+d|0,n=m,m=k,k=l,l=d+(k&m^n&(k^m))+(k>>>2^k>>>13^k>>>22^k<<30^k<<19^k<<10)|0;f[0]=f[0]+l|0;f[1]=f[1]+k|0;f[2]=f[2]+m|0;f[3]=f[3]+n|0;f[4]=f[4]+p|0;f[5]=f[5]+r|0;f[6]=
f[6]+q|0;f[7]=f[7]+t|0}
sjcl.mode.ccm={name:"ccm",G:[],listenProgress:function(a){sjcl.mode.ccm.G.push(a)},unListenProgress:function(a){a=sjcl.mode.ccm.G.indexOf(a);-1<a&&sjcl.mode.ccm.G.splice(a,1)},fa:function(a){var b=sjcl.mode.ccm.G.slice(),c;for(c=0;c<b.length;c+=1)b[c](a)},encrypt:function(a,b,c,d,e){var g,f=b.slice(0),h=sjcl.bitArray,l=h.bitLength(c)/8,k=h.bitLength(f)/8;e=e||64;d=d||[];if(7>l)throw new sjcl.exception.invalid("ccm: iv must be at least 7 bytes");for(g=2;4>g&&k>>>8*g;g++);g<15-l&&(g=15-l);c=h.clamp(c,
8*(15-g));b=sjcl.mode.ccm.V(a,b,c,d,e,g);f=sjcl.mode.ccm.C(a,f,c,b,e,g);return h.concat(f.data,f.tag)},decrypt:function(a,b,c,d,e){e=e||64;d=d||[];var g=sjcl.bitArray,f=g.bitLength(c)/8,h=g.bitLength(b),l=g.clamp(b,h-e),k=g.bitSlice(b,h-e),h=(h-e)/8;if(7>f)throw new sjcl.exception.invalid("ccm: iv must be at least 7 bytes");for(b=2;4>b&&h>>>8*b;b++);b<15-f&&(b=15-f);c=g.clamp(c,8*(15-b));l=sjcl.mode.ccm.C(a,l,c,k,e,b);a=sjcl.mode.ccm.V(a,l.data,c,d,e,b);if(!g.equal(l.tag,a))throw new sjcl.exception.corrupt("ccm: tag doesn't match");
return l.data},na:function(a,b,c,d,e,g){var f=[],h=sjcl.bitArray,l=h.i;d=[h.partial(8,(b.length?64:0)|d-2<<2|g-1)];d=h.concat(d,c);d[3]|=e;d=a.encrypt(d);if(b.length)for(c=h.bitLength(b)/8,65279>=c?f=[h.partial(16,c)]:0xffffffff>=c&&(f=h.concat([h.partial(16,65534)],[c])),f=h.concat(f,b),b=0;b<f.length;b+=4)d=a.encrypt(l(d,f.slice(b,b+4).concat([0,0,0])));return d},V:function(a,b,c,d,e,g){var f=sjcl.bitArray,h=f.i;e/=8;if(e%2||4>e||16<e)throw new sjcl.exception.invalid("ccm: invalid tag length");
if(0xffffffff<d.length||0xffffffff<b.length)throw new sjcl.exception.bug("ccm: can't deal with 4GiB or more data");c=sjcl.mode.ccm.na(a,d,c,e,f.bitLength(b)/8,g);for(d=0;d<b.length;d+=4)c=a.encrypt(h(c,b.slice(d,d+4).concat([0,0,0])));return f.clamp(c,8*e)},C:function(a,b,c,d,e,g){var f,h=sjcl.bitArray;f=h.i;var l=b.length,k=h.bitLength(b),m=l/50,n=m;c=h.concat([h.partial(8,g-1)],c).concat([0,0,0]).slice(0,4);d=h.bitSlice(f(d,a.encrypt(c)),0,e);if(!l)return{tag:d,data:[]};for(f=0;f<l;f+=4)f>m&&(sjcl.mode.ccm.fa(f/
l),m+=n),c[3]++,e=a.encrypt(c),b[f]^=e[0],b[f+1]^=e[1],b[f+2]^=e[2],b[f+3]^=e[3];return{tag:d,data:h.clamp(b,k)}}};
sjcl.mode.ocb2={name:"ocb2",encrypt:function(a,b,c,d,e,g){if(128!==sjcl.bitArray.bitLength(c))throw new sjcl.exception.invalid("ocb iv must be 128 bits");var f,h=sjcl.mode.ocb2.S,l=sjcl.bitArray,k=l.i,m=[0,0,0,0];c=h(a.encrypt(c));var n,p=[];d=d||[];e=e||64;for(f=0;f+4<b.length;f+=4)n=b.slice(f,f+4),m=k(m,n),p=p.concat(k(c,a.encrypt(k(c,n)))),c=h(c);n=b.slice(f);b=l.bitLength(n);f=a.encrypt(k(c,[0,0,0,b]));n=l.clamp(k(n.concat([0,0,0]),f),b);m=k(m,k(n.concat([0,0,0]),f));m=a.encrypt(k(m,k(c,h(c))));
d.length&&(m=k(m,g?d:sjcl.mode.ocb2.pmac(a,d)));return p.concat(l.concat(n,l.clamp(m,e)))},decrypt:function(a,b,c,d,e,g){if(128!==sjcl.bitArray.bitLength(c))throw new sjcl.exception.invalid("ocb iv must be 128 bits");e=e||64;var f=sjcl.mode.ocb2.S,h=sjcl.bitArray,l=h.i,k=[0,0,0,0],m=f(a.encrypt(c)),n,p,r=sjcl.bitArray.bitLength(b)-e,q=[];d=d||[];for(c=0;c+4<r/32;c+=4)n=l(m,a.decrypt(l(m,b.slice(c,c+4)))),k=l(k,n),q=q.concat(n),m=f(m);p=r-32*c;n=a.encrypt(l(m,[0,0,0,p]));n=l(n,h.clamp(b.slice(c),p).concat([0,
0,0]));k=l(k,n);k=a.encrypt(l(k,l(m,f(m))));d.length&&(k=l(k,g?d:sjcl.mode.ocb2.pmac(a,d)));if(!h.equal(h.clamp(k,e),h.bitSlice(b,r)))throw new sjcl.exception.corrupt("ocb: tag doesn't match");return q.concat(h.clamp(n,p))},pmac:function(a,b){var c,d=sjcl.mode.ocb2.S,e=sjcl.bitArray,g=e.i,f=[0,0,0,0],h=a.encrypt([0,0,0,0]),h=g(h,d(d(h)));for(c=0;c+4<b.length;c+=4)h=d(h),f=g(f,a.encrypt(g(h,b.slice(c,c+4))));c=b.slice(c);128>e.bitLength(c)&&(h=g(h,d(h)),c=e.concat(c,[-2147483648,0,0,0]));f=g(f,c);
return a.encrypt(g(d(g(h,d(h))),f))},S:function(a){return[a[0]<<1^a[1]>>>31,a[1]<<1^a[2]>>>31,a[2]<<1^a[3]>>>31,a[3]<<1^135*(a[0]>>>31)]}};
sjcl.mode.gcm={name:"gcm",encrypt:function(a,b,c,d,e){var g=b.slice(0);b=sjcl.bitArray;d=d||[];a=sjcl.mode.gcm.C(!0,a,g,d,c,e||128);return b.concat(a.data,a.tag)},decrypt:function(a,b,c,d,e){var g=b.slice(0),f=sjcl.bitArray,h=f.bitLength(g);e=e||128;d=d||[];e<=h?(b=f.bitSlice(g,h-e),g=f.bitSlice(g,0,h-e)):(b=g,g=[]);a=sjcl.mode.gcm.C(!1,a,g,d,c,e);if(!f.equal(a.tag,b))throw new sjcl.exception.corrupt("gcm: tag doesn't match");return a.data},ka:function(a,b){var c,d,e,g,f,h=sjcl.bitArray.i;e=[0,0,
0,0];g=b.slice(0);for(c=0;128>c;c++){(d=0!==(a[Math.floor(c/32)]&1<<31-c%32))&&(e=h(e,g));f=0!==(g[3]&1);for(d=3;0<d;d--)g[d]=g[d]>>>1|(g[d-1]&1)<<31;g[0]>>>=1;f&&(g[0]^=-0x1f000000)}return e},j:function(a,b,c){var d,e=c.length;b=b.slice(0);for(d=0;d<e;d+=4)b[0]^=0xffffffff&c[d],b[1]^=0xffffffff&c[d+1],b[2]^=0xffffffff&c[d+2],b[3]^=0xffffffff&c[d+3],b=sjcl.mode.gcm.ka(b,a);return b},C:function(a,b,c,d,e,g){var f,h,l,k,m,n,p,r,q=sjcl.bitArray;n=c.length;p=q.bitLength(c);r=q.bitLength(d);h=q.bitLength(e);
f=b.encrypt([0,0,0,0]);96===h?(e=e.slice(0),e=q.concat(e,[1])):(e=sjcl.mode.gcm.j(f,[0,0,0,0],e),e=sjcl.mode.gcm.j(f,e,[0,0,Math.floor(h/0x100000000),h&0xffffffff]));h=sjcl.mode.gcm.j(f,[0,0,0,0],d);m=e.slice(0);d=h.slice(0);a||(d=sjcl.mode.gcm.j(f,h,c));for(k=0;k<n;k+=4)m[3]++,l=b.encrypt(m),c[k]^=l[0],c[k+1]^=l[1],c[k+2]^=l[2],c[k+3]^=l[3];c=q.clamp(c,p);a&&(d=sjcl.mode.gcm.j(f,h,c));a=[Math.floor(r/0x100000000),r&0xffffffff,Math.floor(p/0x100000000),p&0xffffffff];d=sjcl.mode.gcm.j(f,d,a);l=b.encrypt(e);
d[0]^=l[0];d[1]^=l[1];d[2]^=l[2];d[3]^=l[3];return{tag:q.bitSlice(d,0,g),data:c}}};sjcl.misc.hmac=function(a,b){this.W=b=b||sjcl.hash.sha256;var c=[[],[]],d,e=b.prototype.blockSize/32;this.w=[new b,new b];a.length>e&&(a=b.hash(a));for(d=0;d<e;d++)c[0][d]=a[d]^909522486,c[1][d]=a[d]^1549556828;this.w[0].update(c[0]);this.w[1].update(c[1]);this.R=new b(this.w[0])};
sjcl.misc.hmac.prototype.encrypt=sjcl.misc.hmac.prototype.mac=function(a){if(this.aa)throw new sjcl.exception.invalid("encrypt on already updated hmac called!");this.update(a);return this.digest(a)};sjcl.misc.hmac.prototype.reset=function(){this.R=new this.W(this.w[0]);this.aa=!1};sjcl.misc.hmac.prototype.update=function(a){this.aa=!0;this.R.update(a)};sjcl.misc.hmac.prototype.digest=function(){var a=this.R.finalize(),a=(new this.W(this.w[1])).update(a).finalize();this.reset();return a};
sjcl.misc.pbkdf2=function(a,b,c,d,e){c=c||1E3;if(0>d||0>c)throw sjcl.exception.invalid("invalid params to pbkdf2");"string"===typeof a&&(a=sjcl.codec.utf8String.toBits(a));"string"===typeof b&&(b=sjcl.codec.utf8String.toBits(b));e=e||sjcl.misc.hmac;a=new e(a);var g,f,h,l,k=[],m=sjcl.bitArray;for(l=1;32*k.length<(d||1);l++){e=g=a.encrypt(m.concat(b,[l]));for(f=1;f<c;f++)for(g=a.encrypt(g),h=0;h<g.length;h++)e[h]^=g[h];k=k.concat(e)}d&&(k=m.clamp(k,d));return k};
sjcl.prng=function(a){this.c=[new sjcl.hash.sha256];this.m=[0];this.P=0;this.H={};this.N=0;this.U={};this.Z=this.f=this.o=this.ha=0;this.b=[0,0,0,0,0,0,0,0];this.h=[0,0,0,0];this.L=void 0;this.M=a;this.D=!1;this.K={progress:{},seeded:{}};this.u=this.ga=0;this.I=1;this.J=2;this.ca=0x10000;this.T=[0,48,64,96,128,192,0x100,384,512,768,1024];this.da=3E4;this.ba=80};
sjcl.prng.prototype={randomWords:function(a,b){var c=[],d;d=this.isReady(b);var e;if(d===this.u)throw new sjcl.exception.notReady("generator isn't seeded");if(d&this.J){d=!(d&this.I);e=[];var g=0,f;this.Z=e[0]=(new Date).valueOf()+this.da;for(f=0;16>f;f++)e.push(0x100000000*Math.random()|0);for(f=0;f<this.c.length&&(e=e.concat(this.c[f].finalize()),g+=this.m[f],this.m[f]=0,d||!(this.P&1<<f));f++);this.P>=1<<this.c.length&&(this.c.push(new sjcl.hash.sha256),this.m.push(0));this.f-=g;g>this.o&&(this.o=
g);this.P++;this.b=sjcl.hash.sha256.hash(this.b.concat(e));this.L=new sjcl.cipher.aes(this.b);for(d=0;4>d&&(this.h[d]=this.h[d]+1|0,!this.h[d]);d++);}for(d=0;d<a;d+=4)0===(d+1)%this.ca&&y(this),e=z(this),c.push(e[0],e[1],e[2],e[3]);y(this);return c.slice(0,a)},setDefaultParanoia:function(a,b){if(0===a&&"Setting paranoia=0 will ruin your security; use it only for testing"!==b)throw"Setting paranoia=0 will ruin your security; use it only for testing";this.M=a},addEntropy:function(a,b,c){c=c||"user";
var d,e,g=(new Date).valueOf(),f=this.H[c],h=this.isReady(),l=0;d=this.U[c];void 0===d&&(d=this.U[c]=this.ha++);void 0===f&&(f=this.H[c]=0);this.H[c]=(this.H[c]+1)%this.c.length;switch(typeof a){case "number":void 0===b&&(b=1);this.c[f].update([d,this.N++,1,b,g,1,a|0]);break;case "object":c=Object.prototype.toString.call(a);if("[object Uint32Array]"===c){e=[];for(c=0;c<a.length;c++)e.push(a[c]);a=e}else for("[object Array]"!==c&&(l=1),c=0;c<a.length&&!l;c++)"number"!==typeof a[c]&&(l=1);if(!l){if(void 0===
b)for(c=b=0;c<a.length;c++)for(e=a[c];0<e;)b++,e=e>>>1;this.c[f].update([d,this.N++,2,b,g,a.length].concat(a))}break;case "string":void 0===b&&(b=a.length);this.c[f].update([d,this.N++,3,b,g,a.length]);this.c[f].update(a);break;default:l=1}if(l)throw new sjcl.exception.bug("random: addEntropy only supports number, array of numbers or string");this.m[f]+=b;this.f+=b;h===this.u&&(this.isReady()!==this.u&&A("seeded",Math.max(this.o,this.f)),A("progress",this.getProgress()))},isReady:function(a){a=this.T[void 0!==
a?a:this.M];return this.o&&this.o>=a?this.m[0]>this.ba&&(new Date).valueOf()>this.Z?this.J|this.I:this.I:this.f>=a?this.J|this.u:this.u},getProgress:function(a){a=this.T[a?a:this.M];return this.o>=a?1:this.f>a?1:this.f/a},startCollectors:function(){if(!this.D){this.a={loadTimeCollector:B(this,this.ma),mouseCollector:B(this,this.oa),keyboardCollector:B(this,this.la),accelerometerCollector:B(this,this.ea),touchCollector:B(this,this.qa)};if(window.addEventListener)window.addEventListener("load",this.a.loadTimeCollector,
!1),window.addEventListener("mousemove",this.a.mouseCollector,!1),window.addEventListener("keypress",this.a.keyboardCollector,!1),window.addEventListener("devicemotion",this.a.accelerometerCollector,!1),window.addEventListener("touchmove",this.a.touchCollector,!1);else if(document.attachEvent)document.attachEvent("onload",this.a.loadTimeCollector),document.attachEvent("onmousemove",this.a.mouseCollector),document.attachEvent("keypress",this.a.keyboardCollector);else throw new sjcl.exception.bug("can't attach event");
this.D=!0}},stopCollectors:function(){this.D&&(window.removeEventListener?(window.removeEventListener("load",this.a.loadTimeCollector,!1),window.removeEventListener("mousemove",this.a.mouseCollector,!1),window.removeEventListener("keypress",this.a.keyboardCollector,!1),window.removeEventListener("devicemotion",this.a.accelerometerCollector,!1),window.removeEventListener("touchmove",this.a.touchCollector,!1)):document.detachEvent&&(document.detachEvent("onload",this.a.loadTimeCollector),document.detachEvent("onmousemove",
this.a.mouseCollector),document.detachEvent("keypress",this.a.keyboardCollector)),this.D=!1)},addEventListener:function(a,b){this.K[a][this.ga++]=b},removeEventListener:function(a,b){var c,d,e=this.K[a],g=[];for(d in e)e.hasOwnProperty(d)&&e[d]===b&&g.push(d);for(c=0;c<g.length;c++)d=g[c],delete e[d]},la:function(){C(1)},oa:function(a){var b,c;try{b=a.x||a.clientX||a.offsetX||0,c=a.y||a.clientY||a.offsetY||0}catch(d){c=b=0}0!=b&&0!=c&&sjcl.random.addEntropy([b,c],2,"mouse");C(0)},qa:function(a){a=
a.touches[0]||a.changedTouches[0];sjcl.random.addEntropy([a.pageX||a.clientX,a.pageY||a.clientY],1,"touch");C(0)},ma:function(){C(2)},ea:function(a){a=a.accelerationIncludingGravity.x||a.accelerationIncludingGravity.y||a.accelerationIncludingGravity.z;if(window.orientation){var b=window.orientation;"number"===typeof b&&sjcl.random.addEntropy(b,1,"accelerometer")}a&&sjcl.random.addEntropy(a,2,"accelerometer");C(0)}};
function A(a,b){var c,d=sjcl.random.K[a],e=[];for(c in d)d.hasOwnProperty(c)&&e.push(d[c]);for(c=0;c<e.length;c++)e[c](b)}function C(a){"undefined"!==typeof window&&window.performance&&"function"===typeof window.performance.now?sjcl.random.addEntropy(window.performance.now(),a,"loadtime"):sjcl.random.addEntropy((new Date).valueOf(),a,"loadtime")}function y(a){a.b=z(a).concat(z(a));a.L=new sjcl.cipher.aes(a.b)}
function z(a){for(var b=0;4>b&&(a.h[b]=a.h[b]+1|0,!a.h[b]);b++);return a.L.encrypt(a.h)}function B(a,b){return function(){b.apply(a,arguments)}}sjcl.random=new sjcl.prng(6);
a:try{var D,E,F,G;if(G="undefined"!==typeof module&&module.exports){var H;try{H=require("crypto")}catch(a){H=null}G=E=H}if(G&&E.randomBytes)D=E.randomBytes(128),D=new Uint32Array((new Uint8Array(D)).buffer),sjcl.random.addEntropy(D,1024,"crypto['randomBytes']");else if("undefined"!==typeof window&&"undefined"!==typeof Uint32Array){F=new Uint32Array(32);if(window.crypto&&window.crypto.getRandomValues)window.crypto.getRandomValues(F);else if(window.msCrypto&&window.msCrypto.getRandomValues)window.msCrypto.getRandomValues(F);
else break a;sjcl.random.addEntropy(F,1024,"crypto['getRandomValues']")}}catch(a){"undefined"!==typeof window&&window.console&&(console.log("There was an error collecting entropy from the browser:"),console.log(a))}
sjcl.json={defaults:{v:1,iter:1E3,ks:128,ts:64,mode:"ccm",adata:"",cipher:"aes"},ja:function(a,b,c,d){c=c||{};d=d||{};var e=sjcl.json,g=e.g({iv:sjcl.random.randomWords(4,0)},e.defaults),f;e.g(g,c);c=g.adata;"string"===typeof g.salt&&(g.salt=sjcl.codec.base64.toBits(g.salt));"string"===typeof g.iv&&(g.iv=sjcl.codec.base64.toBits(g.iv));if(!sjcl.mode[g.mode]||!sjcl.cipher[g.cipher]||"string"===typeof a&&100>=g.iter||64!==g.ts&&96!==g.ts&&128!==g.ts||128!==g.ks&&192!==g.ks&&0x100!==g.ks||2>g.iv.length||
4<g.iv.length)throw new sjcl.exception.invalid("json encrypt: invalid parameters");"string"===typeof a?(f=sjcl.misc.cachedPbkdf2(a,g),a=f.key.slice(0,g.ks/32),g.salt=f.salt):sjcl.ecc&&a instanceof sjcl.ecc.elGamal.publicKey&&(f=a.kem(),g.kemtag=f.tag,a=f.key.slice(0,g.ks/32));"string"===typeof b&&(b=sjcl.codec.utf8String.toBits(b));"string"===typeof c&&(g.adata=c=sjcl.codec.utf8String.toBits(c));f=new sjcl.cipher[g.cipher](a);e.g(d,g);d.key=a;g.ct="ccm"===g.mode&&sjcl.arrayBuffer&&sjcl.arrayBuffer.ccm&&
b instanceof ArrayBuffer?sjcl.arrayBuffer.ccm.encrypt(f,b,g.iv,c,g.ts):sjcl.mode[g.mode].encrypt(f,b,g.iv,c,g.ts);return g},encrypt:function(a,b,c,d){var e=sjcl.json,g=e.ja.apply(e,arguments);return e.encode(g)},ia:function(a,b,c,d){c=c||{};d=d||{};var e=sjcl.json;b=e.g(e.g(e.g({},e.defaults),b),c,!0);var g,f;g=b.adata;"string"===typeof b.salt&&(b.salt=sjcl.codec.base64.toBits(b.salt));"string"===typeof b.iv&&(b.iv=sjcl.codec.base64.toBits(b.iv));if(!sjcl.mode[b.mode]||!sjcl.cipher[b.cipher]||"string"===
typeof a&&100>=b.iter||64!==b.ts&&96!==b.ts&&128!==b.ts||128!==b.ks&&192!==b.ks&&0x100!==b.ks||!b.iv||2>b.iv.length||4<b.iv.length)throw new sjcl.exception.invalid("json decrypt: invalid parameters");"string"===typeof a?(f=sjcl.misc.cachedPbkdf2(a,b),a=f.key.slice(0,b.ks/32),b.salt=f.salt):sjcl.ecc&&a instanceof sjcl.ecc.elGamal.secretKey&&(a=a.unkem(sjcl.codec.base64.toBits(b.kemtag)).slice(0,b.ks/32));"string"===typeof g&&(g=sjcl.codec.utf8String.toBits(g));f=new sjcl.cipher[b.cipher](a);g="ccm"===
b.mode&&sjcl.arrayBuffer&&sjcl.arrayBuffer.ccm&&b.ct instanceof ArrayBuffer?sjcl.arrayBuffer.ccm.decrypt(f,b.ct,b.iv,b.tag,g,b.ts):sjcl.mode[b.mode].decrypt(f,b.ct,b.iv,g,b.ts);e.g(d,b);d.key=a;return 1===c.raw?g:sjcl.codec.utf8String.fromBits(g)},decrypt:function(a,b,c,d){var e=sjcl.json;return e.ia(a,e.decode(b),c,d)},encode:function(a){var b,c="{",d="";for(b in a)if(a.hasOwnProperty(b)){if(!b.match(/^[a-z0-9]+$/i))throw new sjcl.exception.invalid("json encode: invalid property name");c+=d+'"'+
b+'":';d=",";switch(typeof a[b]){case "number":case "boolean":c+=a[b];break;case "string":c+='"'+escape(a[b])+'"';break;case "object":c+='"'+sjcl.codec.base64.fromBits(a[b],0)+'"';break;default:throw new sjcl.exception.bug("json encode: unsupported type");}}return c+"}"},decode:function(a){a=a.replace(/\s/g,"");if(!a.match(/^\{.*\}$/))throw new sjcl.exception.invalid("json decode: this isn't json!");a=a.replace(/^\{|\}$/g,"").split(/,/);var b={},c,d;for(c=0;c<a.length;c++){if(!(d=a[c].match(/^\s*(?:(["']?)([a-z][a-z0-9]*)\1)\s*:\s*(?:(-?\d+)|"([a-z0-9+\/%*_.@=\-]*)"|(true|false))$/i)))throw new sjcl.exception.invalid("json decode: this isn't json!");
null!=d[3]?b[d[2]]=parseInt(d[3],10):null!=d[4]?b[d[2]]=d[2].match(/^(ct|adata|salt|iv)$/)?sjcl.codec.base64.toBits(d[4]):unescape(d[4]):null!=d[5]&&(b[d[2]]="true"===d[5])}return b},g:function(a,b,c){void 0===a&&(a={});if(void 0===b)return a;for(var d in b)if(b.hasOwnProperty(d)){if(c&&void 0!==a[d]&&a[d]!==b[d])throw new sjcl.exception.invalid("required parameter overridden");a[d]=b[d]}return a},sa:function(a,b){var c={},d;for(d in a)a.hasOwnProperty(d)&&a[d]!==b[d]&&(c[d]=a[d]);return c},ra:function(a,
b){var c={},d;for(d=0;d<b.length;d++)void 0!==a[b[d]]&&(c[b[d]]=a[b[d]]);return c}};sjcl.encrypt=sjcl.json.encrypt;sjcl.decrypt=sjcl.json.decrypt;sjcl.misc.pa={};sjcl.misc.cachedPbkdf2=function(a,b){var c=sjcl.misc.pa,d;b=b||{};d=b.iter||1E3;c=c[a]=c[a]||{};d=c[d]=c[d]||{firstSalt:b.salt&&b.salt.length?b.salt.slice(0):sjcl.random.randomWords(2,0)};c=void 0===b.salt?d.firstSalt:b.salt;d[c]=d[c]||sjcl.misc.pbkdf2(a,c,b.iter);return{key:d[c].slice(0),salt:c.slice(0)}};

(function () {
  'use strict';
  angular.module('BlurAdmin.pages', [
    'ui.router',
    'BlurAdmin.pages.home',    
    'BlurAdmin.pages.sucursal',
    'BlurAdmin.pages.catalogo',    
    'BlurAdmin.pages.clientes',
    'BlurAdmin.pages.compras',
    'BlurAdmin.pages.almacen',
    'BlurAdmin.pages.inventario',
    'BlurAdmin.pages.contabilidad',
    'BlurAdmin.pages.cobranzas',    
    'BlurAdmin.pages.comprobantes',
    'BlurAdmin.pages.cuentas',
    'BlurAdmin.pages.venta',
    'BlurAdmin.pages.reportes',
    'BlurAdmin.pages.seguridad'
  ])
    .filter('summaryTotal', ['$filter', function ($filter) {
      return function (input, cantidad, precio, decimal) {
        var output = 0;
        if (_.isArray(input)) {
          _.each(input, function (item) {
            output += parseInt(item[cantidad]) * parseFloat(item[precio]);
          });
        }
        console.log(output.toFixed(decimal))
        return output.toFixed(decimal);
      }
    }])
    .filter('Total', ['$filter', function ($filter) {
      return function (input, peso, precio, decimal) {
        var output = 0;
        if (_.isArray(input)) {
          _.each(input, function (item) {
            output += parseFloat(item[precio]) * parseFloat(item[peso]);
          });
        }
        return output.toFixed(decimal);
      }
    }]).factory('Excel',function($window){
      var uri='data:application/vnd.ms-excel;base64,',
          template='<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
          base64=function(s){return $window.btoa(unescape(encodeURIComponent(s)));},
          format=function(s,c){return s.replace(/{(\w+)}/g,function(m,p){return c[p];})};
      return {
          tableToExcel:function(tableId,worksheetName){
              var table=$(tableId),
                  ctx={worksheet:worksheetName,table:table.html()},
                  href=uri+base64(format(template,ctx));
              return href;
          }
      };
  })
    .factory('servFactory', ['$filter', function ($filter) {
      return {
        aplicar_porc: function (mto_compra, mto_porcentaje, decimal) {
          var mto = parseFloat(mto_compra);
          var mto_porc = parseFloat(mto_porcentaje);
          var calculo = parseFloat(mto) + (parseFloat(mto) * parseFloat(mto_porc) / 100);
          return calculo.toFixed(decimal || 2);
        },
        calularNeto: function (monto, excento_impuesto, porc_impuesto) {
          var monto = parseFloat(monto) || 0.00;
          var monto_neto = monto;
          if (!excento_impuesto) {//
            monto_neto = monto / (1 + (parseFloat(porc_impuesto) / 100));
          }
          return monto_neto.toFixed(2);
        },
        calularVenta: function (monto, excento_impuesto, porc_impuesto) {
          var monto = parseFloat(monto) || 0.00;
          var monto_neto = monto;
          if (!excento_impuesto) {//
            monto_neto = monto / (1 + (parseFloat(porc_impuesto) / 100));
          }
          return monto_neto.toFixed(2);
        }
      }
    }])
    .factory('serviceAPI', ['$http', 'apiEndpoint', function ($http, apiEndpoint) {
      return {
        existTipDocumento: function (params) { return $http.post(apiEndpoint + 'tipodocumentos.php?oper=existTipDoc', params); },
        gettipdocpred: function () { return $http.post(apiEndpoint + 'tipodocumentos.php?oper=existPredet'); },
        guardarTipDocumento: function (params) { return $http.post(apiEndpoint + 'tipodocumentos.php?oper=guardar', params); },
        constularTipDocumento: function (params) { return $http.post(apiEndpoint + 'tipodocumentos.php?oper=consultar', params); },
        statusTipDocumento: function (params) { return $http.post(apiEndpoint + 'tipodocumentos.php?oper=status', params); },
        eliminarTipDocumento: function (params) { return $http.post(apiEndpoint + 'tipodocumentos.php?oper=eliminar', params); },
        getConfig: function () { return $http.get(apiEndpoint + 'configuracion.php'); },
        guardarConfig: function (paramas) { return $http.post(apiEndpoint + 'configuracion.php?oper=guardar', paramas) },
        signIn: function (data) { return $http.post(apiEndpoint + 'signin.php', data); },
        existRolUsuario: function (params) { return $http.post(apiEndpoint + 'roles.php?oper=existe', params); },
        guardarRolUsuario: function (params) { return $http.post(apiEndpoint + 'roles.php?oper=guardar', params); },
        consultarRolUsuario: function (params) { return $http.post(apiEndpoint + 'roles.php?oper=consultar', params); },
        getRoles: function () { return $http.get(apiEndpoint + 'roles.php?oper=listar'); },
        deleteRol: function (params) { return $http.post(apiEndpoint + 'roles.php?oper=eliminar', params) },
        cambiarStatusRol: function (params) { return $http.post(apiEndpoint + 'roles.php?oper=changestatus', params); },
        getUsuarios: function () { return $http.get(apiEndpoint + 'usuarios.php?oper=listar'); },
        exitUsuario: function (params) { return $http.post(apiEndpoint + 'usuarios.php?oper=existUser', params); },
        guardarUsuario: function (params) { return $http.post(apiEndpoint + 'usuarios.php?oper=guardar', params); },
        consultarUsuario: function (params) { return $http.post(apiEndpoint + 'usuarios.php?oper=consultar', params); },
        getEmpresas: function () { return $http.get(apiEndpoint + 'empresa.php?oper=listar'); },
        getTiposDocumentos: function (params) { return $http.post(apiEndpoint + 'tipodocumentos.php?oper=listar', params); },
        guardarEmpresa: function (params) { return $http.post(apiEndpoint + 'empresa.php?oper=guardar', params); },
        getDepartamento: function (params) { return $http.post(apiEndpoint + 'ubigeo.php?oper=listarDepartamento', params); },
        getProvincia: function (params) { return $http.post(apiEndpoint + 'ubigeo.php?oper=listarProvincia', params); },
        getDistrito: function (params) { return $http.post(apiEndpoint + 'ubigeo.php?oper=listarDistrito', params); },
        consultaEmpresa: function (params) { return $http.post(apiEndpoint + 'empresa.php?oper=consultar', params); },
        getSucursal: function () { return $http.get(apiEndpoint + 'sucursal.php?oper=listar'); },
        getSucursalId: function (params) { return $http.post(apiEndpoint + 'sucursal.php?oper=listarSucursalId', params); },
        guardarSucursales: function (params) { return $http.post(apiEndpoint + 'sucursal.php?oper=guardar', params); },
        consultaSucursal: function (params) { return $http.post(apiEndpoint + 'sucursal.php?oper=consultar', params); },
        getMarca: function (params) { return $http.post(apiEndpoint + 'marca.php?oper=listar', params); },
        guardarMarca: function (params) { return $http.post(apiEndpoint + 'marca.php?oper=guardar', params); },
        cambiarStatusMarca: function (params) { return $http.post(apiEndpoint + 'marca.php?oper=status', params); },
        getCategoria: function (params) { return $http.post(apiEndpoint + 'categoria.php?oper=listar', params); },
        guardarCategoria: function (params) { return $http.post(apiEndpoint + 'categoria.php?oper=guardar', params); },
        cambiarStatusCategoria: function (params) { return $http.post(apiEndpoint + 'categoria.php?oper=status', params); },
        getAtributo: function (params) { return $http.post(apiEndpoint + 'atributo.php?oper=listar', params); },
        getSubAtributo: function (params) { return $http.post(apiEndpoint + 'atributo.php?oper=listaSub', params); },
        getSubAtributoId: function (params) { return $http.post(apiEndpoint + 'atributo.php?oper=listarSubId', params); },
        listAtributo: function (params) { return $http.post(apiEndpoint + 'atributo.php?oper=listar', params); },
        guardarAtributo: function (params) { return $http.post(apiEndpoint + 'atributo.php?oper=guardar', params); },
        guardarSubAtributo: function (params) { return $http.post(apiEndpoint + 'atributo.php?oper=guardarSub', params); },
        getProducto: function (params) { return $http.post(apiEndpoint + 'producto.php?oper=listar', params); },
        getProductoCompra: function (params) { return $http.post(apiEndpoint + 'producto.php?oper=listarCompra', params); },
        getProductoCompraBusquedad: function (params) { return $http.post(apiEndpoint + 'producto.php?oper=listarProductoCompra', params); },        
        getUnidad: function (params) { return $http.post(apiEndpoint + 'tablas.php?oper=listarUnidad', params); },
        getTipoProducto: function (params) { return $http.post(apiEndpoint + 'tablas.php?oper=listarTipoProducto', params); },
        guardarProducto: function (params) { return $http.post(apiEndpoint + 'producto.php?oper=guardar', params); },
        getProveedor: function (params) { return $http.post(apiEndpoint + 'proveedor.php?oper=listar', params); },
        guardarUProveedor: function (params) { return $http.post(apiEndpoint + 'proveedor.php?oper=guardar', params); },
        consultarProveedor: function (params) { return $http.post(apiEndpoint + 'proveedor.php?oper=consultar', params); },
        getProveedores: function (params) { return $http.post(apiEndpoint + 'proveedor.php?oper=listarProveedor', params); },
        cambiarStatusProveedor: function (params) { return $http.post(apiEndpoint + 'proveedor.php?oper=status', params); },
        eliminarProveedor: function (params) { return $http.post(apiEndpoint + 'proveedor.php?oper=eliminar', params); },
        getTipoComprobante: function (params) { return $http.post(apiEndpoint + 'tipocomprobantes.php?oper=listar', params); },
        getCondicionPago: function (params) { return $http.post(apiEndpoint + 'tablas.php?oper=listarCondicionPago', params); },
        guardarOrdenCompra: function (params) { return $http.post(apiEndpoint + 'compra.php?oper=guardar', params); },
        consultarSucursal: function (params) { return $http.post(apiEndpoint + 'sucursal.php?oper=consultar', params); },
        consultarTotales: function (params) { return $http.post(apiEndpoint + 'compra.php?oper=consultarTotal', params); },
        getCompras: function (params) { return $http.post(apiEndpoint + 'compra.php?oper=listar', params); },
        getComprasCobrar: function (params) { return $http.post(apiEndpoint + 'compra.php?oper=listarCobrar', params); },
        getStockProductos: function (params) { return $http.post(apiEndpoint + 'almacen.php?oper=listarAlmacenStock', params); },
        getProductoDetalleCompras: function (params) { return $http.post(apiEndpoint + 'almacen.php?oper=listaProductosCompras', params); },
        getProductoStock: function (params) { return $http.post(apiEndpoint + 'almacen.php?oper=listarStock', params); },
        getCliente: function (params) { return $http.post(apiEndpoint + 'clientes.php?oper=listar', params); },
        guardarCliente: function (params) { return $http.post(apiEndpoint + 'clientes.php?oper=guardar', params); },
        consultarCliente: function (params) { return $http.post(apiEndpoint + 'clientes.php?oper=consultar', params); },
        eliminarCliente: function (params) { return $http.post(apiEndpoint + 'clientes.php?oper=eliminar', params); },
        getBancos: function (params) { return $http.post(apiEndpoint + 'bancos.php?oper=listar', params); },
        guardarBanco: function (params) { return $http.post(apiEndpoint + 'bancos.php?oper=guardar', params); },
        cambiarStatusBanco: function (params) { return $http.post(apiEndpoint + 'bancos.php?oper=status', params); },
        getCuentas: function (params) { return $http.post(apiEndpoint + 'cuentas.php?oper=listar', params); },
        guardarCuenta: function (params) { return $http.post(apiEndpoint + 'cuentas.php?oper=guardar', params); },
        cambiarStatusCuenta: function (params) { return $http.post(apiEndpoint + 'cuentas.php?oper=status', params); },
        consultarCuenta: function (params) { return $http.post(apiEndpoint + 'cuentas.php?oper=consultar', params); },
        getComprobante: function (params) { return $http.post(apiEndpoint + 'tipocomprobantes.php?oper=listar', params); },
        getEmpleadoSucursal: function (params) { return $http.post(apiEndpoint + 'empleado.php?oper=listarSucursal', params); },
        getPatrimonio: function (params) { return $http.post(apiEndpoint + 'patrimonio.php?oper=listar', params); },
        guardarPatrimonio: function (params) { return $http.post(apiEndpoint + 'patrimonio.php?oper=guardar', params); },
        consultarPatrimonio: function (params) { return $http.post(apiEndpoint + 'patrimonio.php?oper=consultar', params); },
        getTipoPasivo: function (params) { return $http.post(apiEndpoint + 'tablas.php?oper=listarTipoPasivo', params); },
        getAnio: function (params) { return $http.post(apiEndpoint + 'tablas.php?oper=listarAnio', params); },
        getPeriodo: function (params) { return $http.post(apiEndpoint + 'tablas.php?oper=listarPeriodo', params); },
        getPasivo: function (params) { return $http.post(apiEndpoint + 'pasivo.php?oper=listar', params); },
        guardarPasivo: function (params) { return $http.post(apiEndpoint + 'pasivo.php?oper=guardar', params); },
        consultarPasivo: function (params) { return $http.post(apiEndpoint + 'pasivo.php?oper=consultar', params); },
        consultarCorrelativo: function (params) { return $http.post(apiEndpoint + 'tipocomprobantes.php?oper=consultarCorrelativo', params); },
        guardarVenta: function (params) { return $http.post(apiEndpoint + 'ventas.php?oper=guardar', params); },
        getTipoPago: function (params) { return $http.post(apiEndpoint + 'tipoPago.php?oper=listar', params); },
        getVentas: function (params) { return $http.post(apiEndpoint + 'ventas.php?oper=listar', params); },
        getVentasCobrar: function (params) { return $http.post(apiEndpoint + 'ventas.php?oper=listarxCobrar', params); },
        getTotalesVentas: function (params) { return $http.post(apiEndpoint + 'ventas.php?oper=totales', params); },
        getTotalesVentasDia: function (params) { return $http.post(apiEndpoint + 'ventas.php?oper=totalesDia', params); },
        getEmpleado: function (params) { return $http.post(apiEndpoint + 'empleado.php?oper=listar', params); },
        listarSexo: function (params) { return $http.post(apiEndpoint + 'sexo.php?oper=listarSexo', params); },
        listarEstadoCivil: function (params) { return $http.post(apiEndpoint + 'estadoCivil.php?oper=listarEstadoCivil', params); },
        guardarEmpleado: function (params) { return $http.post(apiEndpoint + 'empleado.php?oper=guardar', params); },
        consultarEmpleado: function (params) { return $http.post(apiEndpoint + 'empleado.php?oper=consultar', params); },
        eliminarEmpleado: function (params) { return $http.post(apiEndpoint + 'empleado.php?oper=eliminar', params); },
        getDni: function (params) { return $http.post(apiEndpoint + 'dni.php?oper=consultar', params); },
        getRuc: function (params) { return $http.post(apiEndpoint + 'ruc.php?oper=consultar', params); },
        guardarTemporal: function (params) { return $http.post(apiEndpoint + 'ventas.php?oper=guardarTemporal', params); },
        eliminarTemporal: function (params) { return $http.post(apiEndpoint + 'ventas.php?oper=eliminarTemporal', params); },
        actualizarTemporal: function (params) { return $http.post(apiEndpoint + 'ventas.php?oper=actualizarTemporal', params); },
        actualizarPago: function (params) { return $http.post(apiEndpoint + 'ventas.php?oper=actualizarPago', params); },
        getStockProductosValorizado: function (params) { return $http.post(apiEndpoint + 'almacen.php?oper=listarStockValorizado', params); },
        getCajas: function (params) { return $http.post(apiEndpoint + 'caja.php?oper=listar', params); },
        datosCaja: function (params) { return $http.post(apiEndpoint + 'caja.php?oper=consultar', params); },
        guardarApertura: function (params) { return $http.post(apiEndpoint + 'caja.php?oper=guardar', params); },
        getGastos:function(params) { return $http.post(apiEndpoint + 'gastos.php?oper=listar', params); },
        getTipoGasto:function(params) { return $http.post(apiEndpoint + 'gastos.php?oper=listarTipoGasto', params); },
        guardarGasto:function(params) { return $http.post(apiEndpoint + 'gastos.php?oper=guardar', params); },
        consultarGasto:function(params) { return $http.post(apiEndpoint + 'gastos.php?oper=consultar', params); },
        cerrarCaja:function(params) { return $http.post(apiEndpoint + 'caja.php?oper=cerrarcaja', params); },
        eliminarProducto:function(params) { return $http.post(apiEndpoint + 'producto.php?oper=eliminar', params); },
        eliminarProductoPrincipal:function(params) { return $http.post(apiEndpoint + 'producto.php?oper=eliminarPrincipal', params); },
        consultarVentas: function (params) { return $http.post(apiEndpoint + 'reporte.php?oper=consultarVentas', params); },
        consultarCompras: function (params) { return $http.post(apiEndpoint + 'reporte.php?oper=consultarCompras', params); },
        getFacturaProveedor: function (params) { return $http.post(apiEndpoint + 'compra.php?oper=consultarFacturaProveedor', params); },
        getCuentaxCobrar: function (params) { return $http.post(apiEndpoint + 'cuentas.php?oper=listarxCobrar', params); },
        getCuentaxPagar: function (params) { return $http.post(apiEndpoint + 'cuentas.php?oper=listarxPagar', params); },
        getTipoCliente:function(params) { return $http.post(apiEndpoint + 'tablas.php?oper=listarTipoCliente', params); },
        getOrdenCompra: function (params) { return $http.post(apiEndpoint + 'compra.php?oper=listarOrdenCompra', params); },
        consultaCompra: function (params) { return $http.post(apiEndpoint + 'compra.php?oper=consultar', params); },
        getOrdenCompraDetalle: function (params) { return $http.post(apiEndpoint + 'compra.php?oper=listarOrdenCompraDetalle', params); },
        actualizarOrdenCompra: function (params) { return $http.post(apiEndpoint + 'compra.php?oper=actualizarOrdenCompra', params); },
        listarFacturaProveedor: function (params) { return $http.post(apiEndpoint + 'compra.php?oper=listarFacturaProveedor', params); },
        listCotizacion: function (params) { return $http.post(apiEndpoint + 'cotizacion.php?oper=listar', params); },
        guardarCotizacion: function (params) { return $http.post(apiEndpoint + 'cotizacion.php?oper=guardar', params); },
        getCotizacion: function (params) { return $http.post(apiEndpoint + 'cotizacion.php?oper=getCotizacion', params); },
        getCotizacionId: function (params) { return $http.post(apiEndpoint + 'cotizacion.php?oper=getCotizacionId', params); },
        guardarGuia: function (params) { return $http.post(apiEndpoint + 'guia.php?oper=guardar', params); },
        listarGuia:function (params) { return $http.post(apiEndpoint + 'guia.php?oper=listar', params); },
        getDescuento:function (params) { return $http.post(apiEndpoint + 'marca.php?oper=listarDescuento', params); },
        guardarDescuento:function (params) { return $http.post(apiEndpoint + 'marca.php?oper=guardarDescuento', params); },        
        getTipoMedioPago: function (params) { return $http.post(apiEndpoint + 'tablas.php?oper=listarMedioPago', params); },
        getGuia: function (params) { return $http.post(apiEndpoint + 'guia.php?oper=getGuia', params); },
        getGuiaId: function (params) { return $http.post(apiEndpoint + 'guia.php?oper=getGuiaId', params); },
        guardarFactura: function (params) { return $http.post(apiEndpoint + 'factura.php?oper=guardar', params); },
        listarFactura:function (params) { return $http.post(apiEndpoint + 'factura.php?oper=listar', params); },
        eliminarCoti:function (params) { return $http.post(apiEndpoint + 'cotizacion.php?oper=eliminar', params); },
        guardarBoleta: function (params) { return $http.post(apiEndpoint + 'boleta.php?oper=guardar', params); },
        listarBoleta:function (params) { return $http.post(apiEndpoint + 'boleta.php?oper=listar', params); },
        consultaCotizacion:function (params) { return $http.post(apiEndpoint + 'cotizacion.php?oper=consultar', params); },
        getComprobanteCoti: function (params) { return $http.post(apiEndpoint + 'tipocomprobantes.php?oper=listarCoti', params); },
        getComprobanteGuia: function (params) { return $http.post(apiEndpoint + 'tipocomprobantes.php?oper=listarGuia', params); },
        getComprobanteFactura: function (params) { return $http.post(apiEndpoint + 'tipocomprobantes.php?oper=listarFactura', params); },        
        getComprobanteBoleta : function (params) { return $http.post(apiEndpoint + 'tipocomprobantes.php?oper=listarBoleta', params); },        
        getTipoDescuentoMarca: function (params) { return $http.post(apiEndpoint + 'marca.php?oper=listarDescuentoMarca', params); },
        
        listarTipoEmpresa: function (params) { return $http.post(apiEndpoint + 'tablas.php?oper=listarTipoEmpresa', params); },
        listarModalidad: function (params) { return $http.post(apiEndpoint + 'tablas.php?oper=listarModalidad', params); },
        listarMotivo: function (params) { return $http.post(apiEndpoint + 'tablas.php?oper=listarMotivo', params); },
        getCompraDetalleId:function (params) { return $http.post(apiEndpoint + 'compra.php?oper=consultarDetalle', params); },
        getAlmacenes:function (params) { return $http.post(apiEndpoint + 'almacen.php?oper=listar', params); },
        guardarAlmacen: function (params) { return $http.post(apiEndpoint + 'almacen.php?oper=guardar', params); },
        cambiarStatusAlmacen: function (params) { return $http.post(apiEndpoint + 'almacen.php?oper=status', params); },
        getNotaIngreso: function (params) { return $http.post(apiEndpoint + 'almacen.php?oper=listaNotaIngreso', params); },
        getAlmacenOrigen: function (params) { return $http.post(apiEndpoint + 'almacen.php?oper=listaAlmacen', params); },
        getAlmacenDestino: function (params) { return $http.post(apiEndpoint + 'almacen.php?oper=listaAlmacen', params); },
        getComprobanteIngreso: function (params) { return $http.post(apiEndpoint + 'tipocomprobantes.php?oper=listarNotaIngreso', params); },
        consultarAlmacenOrden: function (params) { return $http.post(apiEndpoint + 'almacen.php?oper=listarAlmacenOrden', params); },
        getAlmacenOrdenDetalle: function (params) { return $http.post(apiEndpoint + 'almacen.php?oper=listarAlmacenOrdenDetalle', params); },
        guardarNotaIngreso:function (params) { return $http.post(apiEndpoint + 'almacen.php?oper=guardarIngreso', params); },
        getVentasClientes:function (params) { return $http.post(apiEndpoint + 'clientes.php?oper=getVentasClientes', params); },
        getProductoStockModalCantidad:function (params) { return $http.post(apiEndpoint + 'almacen.php?oper=listarAlmacenStockCantidad', params); },
        getProductoStockModal:function (params) { return $http.post(apiEndpoint + 'almacen.php?oper=listarAlmacenStockCotizacion', params); },
        getCupon: function (params) { return $http.post(apiEndpoint + 'cupon.php?oper=listar', params); },
        guardarCupon: function (params) { return $http.post(apiEndpoint + 'cupon.php?oper=guardar', params); },
        cambiarStatusCupon: function (params) { return $http.post(apiEndpoint + 'cupon.php?oper=status', params); },
        getDescuentoCupon:function (params) { return $http.post(apiEndpoint + 'cupon.php?oper=listarDescuento', params); },
        guardarDescuentoCupon:function (params) { return $http.post(apiEndpoint + 'cupon.php?oper=guardarDescuento', params); },        
        getTipoDescuentoCupon: function (params) { return $http.post(apiEndpoint + 'cupon.php?oper=listarDescuentoCupon', params); },
        consultarMontoDescuentoCupon: function (params) { return $http.post(apiEndpoint + 'cupon.php?oper=consultarMontoDescuento', params); },
        getCuponDescuento: function (params) { return $http.post(apiEndpoint + 'cupon.php?oper=listarCuponDescuento', params); },
        consultaProducto: function (params) { return $http.post(apiEndpoint + 'producto.php?oper=consultar', params); },
        eliminarCotiTemporal:function (params) { return $http.post(apiEndpoint + 'cotizacion.php?oper=eliminarCotiTemporal', params); },
        getCobranza:function (params) { return $http.post(apiEndpoint + 'cobranzas.php?oper=listar', params); },
        guardarCobranza: function (params) { return $http.post(apiEndpoint + 'cobranzas.php?oper=guardar', params); },
        consultaCobranza:function (params) { return $http.post(apiEndpoint + 'cobranzas.php?oper=consultar', params); },
        getCobranzaId: function (params) { return $http.post(apiEndpoint + 'cobranzas.php?oper=getCobranzaId', params); },
        getComprobantesFacBol: function (params) { return $http.post(apiEndpoint + 'tipocomprobantes.php?oper=listarFacBol', params); },

        getComprobanteCobranza:function (params) { return $http.post(apiEndpoint + 'tipocomprobantes.php?oper=listarCobranza', params); },
        getCompBoloFac:function (params) { return $http.post(apiEndpoint + 'tablas.php?oper=getCompBoloFac', params); },
        getIdComprobanteCobranza:function (params) { return $http.post(apiEndpoint + 'tablas.php?oper=getIdComprobanteCobranza', params); },
        consultarVentasDiarias: function (params) { return $http.post(apiEndpoint + 'producto.php?oper=listarVentasDiarias', params); },
        consultarVentasProductos: function (params) { return $http.post(apiEndpoint + 'producto.php?oper=listaVentasxProducto', params); },
        consultaNotaIngreso: function (params) { return $http.post(apiEndpoint + 'almacen.php?oper=consultar', params); },
        getTipoDescuento: function (params) { return $http.post(apiEndpoint + 'clientes.php?oper=listarDescuentoCliente', params); },
        consultarMontoDescuento: function (params) { return $http.post(apiEndpoint + 'clientes.php?oper=consultarMontoDescuento', params); },
        buscarProductoxCodigo:function (params) { return $http.post(apiEndpoint + 'producto.php?oper=buscarProductoxCodigo', params); },
        buscarProductoxCodigoVenta:function (params) { return $http.post(apiEndpoint + 'producto.php?oper=buscarProductoxCodigoVenta', params); },
        
        getDescuentoCliente:function (params) { return $http.post(apiEndpoint + 'clientes.php?oper=listarClientesDescuento', params); },
        getClienteDistro:function (params) { return $http.post(apiEndpoint + 'clientes.php?oper=listaClienteDistro', params); },
        guardarClienteDescuento:function (params) { return $http.post(apiEndpoint + 'clientes.php?oper=guardarClienteDistro', params); },
        
        
        
      }
    }]);
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme', [
      'toastr',
      'chart.js',
      'angular-chartist',
      'angular.morris-chart',
      'textAngular',
      'BlurAdmin.theme.components',
      'BlurAdmin.theme.inputs'
  ]);

})();


(function () {
    'use strict';
    angular.module('BlurAdmin.pages.almacen', [
      'BlurAdmin.pages.almacen.almacenes',
      'BlurAdmin.pages.almacen.notaingreso'
    ]).config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
        .state('dashboard.almacen', {
          url: '/almacen',
          template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Almacen',
          sidebarMeta: {
            icon: 'ion-clipboard',
            order: 500,
          }
        }).state('dashboard.almacen.almacenes', {
          url: '/almacenes',
          templateUrl: 'app/pages/almacen/almacenes/almacenes.html',
          controller: 'almacenesCtrl',
          title: 'Almacen',
          sidebarMeta: {
            order: 200
          }
        }).state('dashboard.almacen.notaingreso', {
          url: '/notaingreso',
          templateUrl: 'app/pages/almacen/notaingreso/list/notaingresoList.html',
          controller: 'notaingresolistCtrl',
          title: 'Nota Ingreso / Salida',
          sidebarMeta: {
            order: 200
          }
        }).state('dashboard.almacen.notaingreso-details', {
          url: '/notaingreso/details/:idNotaIngreso',
          templateUrl: 'app/pages/almacen/notaingreso/notaingreso.html',
          controller: 'notaingresoCtrl',
          controllerAs: 'vm',
          title: 'Nota Ingreso / Salida',
          params: { 
            idNotaIngreso: '' 
          }
        });
    }
  
  })();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.catalogo', [
      'BlurAdmin.pages.catalogo.marca',
      'BlurAdmin.pages.catalogo.categoria',
      'BlurAdmin.pages.catalogo.atributo',
      'BlurAdmin.pages.catalogo.producto',
      'BlurAdmin.pages.catalogo.empleado',
      'BlurAdmin.pages.catalogo.cuponera',
      'BlurAdmin.pages.catalogo.descuento'
    ]).config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
        .state('dashboard.catalogo', {
          url: '/catalogo',
          template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Catalogo',
          sidebarMeta: {
            icon: 'fa fa-book',
            order: 500,
          }
        }).state('dashboard.catalogo.marca', {
          url: '/marca',
          templateUrl: 'app/pages/catalogo/marca/marca.html',
          controller: 'marcaCtrl',
          title: 'Marca',
          sidebarMeta: {
            order: 100
          }
        }).state('dashboard.catalogo.marca-details', {
          url: '/marca/details/:idmarca',
          templateUrl: 'app/pages/catalogo/marca/marca.html',
          controller: "marcaCtrl",
          title: 'Marca',
          params: {
            idmarca: ''
          }
        }).state('dashboard.catalogo.categoria', {
          url: '/categoria',
          templateUrl: 'app/pages/catalogo/categoria/categoria.html',
          controller: 'categoriaCtrl',
          title: 'Categoria',
          sidebarMeta: {
            order: 100
          }
        }).state('dashboard.catalogo.categoria-details', {
          url: '/categoria/details/:idcategoria',
          templateUrl: 'app/pages/catalogo/categoria/categoria.html',
          controller: "categoriaCtrl",
          title: 'Categoria',
          params: {
            idcategoria: ''
          }
        }).state('dashboard.catalogo.atributo', {
          url: '/atributo',
          templateUrl: 'app/pages/catalogo/atributo/atributo.html',
          controller: 'atributoCtrl',
          title: 'Atributo',
          sidebarMeta: {
            order: 100
          }
        }).state('dashboard.catalogo.producto', {
          url: '/producto',
          templateUrl: 'app/pages/catalogo/producto/list/productoList.html',
          controller: 'productolistCtrl',
          title: 'Producto',
          sidebarMeta: {
            order: 100
          }
        }).state('dashboard.catalogo.producto-details', {
          url: '/producto/details/:idProducto',
          templateUrl: 'app/pages/catalogo/producto/producto.html',
          controller: "productoCtrl",
          title: 'Producto',
          params: {
            idProducto: ''
          }
        }).state('dashboard.catalogo.empleado', {
          url: '/empleado',
          templateUrl: 'app/pages/catalogo/empleado/list/empleadoList.html',
          controller: 'empleadoListCtrl',
          title: 'Empleado',
          sidebarMeta: {
            order: 100
          }
        }).state('dashboard.catalogo.empleado-details', {
          url: '/empleado/details/:idempleado',
          templateUrl: 'app/pages/catalogo/empleado/empleado.html',
          controller: "empleadoCtrl",
          title: 'Empleado',
          params: {
            idempleado: ''
          }
        }).state('dashboard.catalogo.cuponera', {
          url: '/cuponera',
          templateUrl: 'app/pages/catalogo/cuponera/cuponera.html',
          controller: 'cuponCtrl',
          title: 'Cuponera',
          sidebarMeta: {
            order: 100
          }
        }).state('dashboard.catalogo.cuponera-details', {
          url: '/cuponera/details/:idcupon',
          templateUrl: 'app/pages/catalogo/cuponera/cuponera.html',
          controller: "cuponCtrl",
          title: 'Cuponera',
          params: {
            idcupon: ''
          }
        }).state('dashboard.catalogo.descuento', {
          url: '/descuento',
          templateUrl: 'app/pages/catalogo/descuento/descuento.html',
          controller: 'descuentoCtrl',
          title: 'Descuento Cliente',
          sidebarMeta: {
            order: 100
          }
        }).state('dashboard.catalogo.descuento-details', {
          url: '/descuento/details/:idcliente_descuento',
          templateUrl: 'app/pages/catalogo/descuento/descuento.html',
          controller: "descuentoCtrl",
          title: 'Descuento Cliente',
          params: {
            idcliente_descuento: ''
          }
        });
    }
  
  })();
  
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts', [
      'BlurAdmin.pages.charts.amCharts',
      'BlurAdmin.pages.charts.chartJs',
      'BlurAdmin.pages.charts.chartist',
      'BlurAdmin.pages.charts.morris'
  ])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('dashboard.charts', {
          url: '/charts',
          abstract: true,
          template: '<div ui-view></div>',
          title: 'Charts',
          sidebarMeta: {
            icon: 'ion-stats-bars',
            order: 150,
          },
        });
  }

})();

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.clientes', [
      'BlurAdmin.pages.clientes.cliente',
      'BlurAdmin.pages.clientes.historico'
    ]).config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
        .state('dashboard.clientes', {
          url: '/clientes',
          template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Clientes',
          sidebarMeta: {
            icon: 'fa fa-user',
            order: 500,
          }
        }).state('dashboard.clientes.cliente', {
          url: '/cliente',
          templateUrl: 'app/pages/clientes/cliente/list/clienteList.html',
          controller: 'clientelistCtrl',
          title: 'Cliente',
          sidebarMeta: {
            order: 100
          }
        }).state('dashboard.clientes.cliente-details', {
          url: '/cliente/details/:idCliente',
          templateUrl: 'app/pages/clientes/cliente/cliente.html',
          controller: "clienteCtrl",
          title: 'Cliente',
          params: {
            idCliente: ''
          }
        }).state('dashboard.clientes.historico', {
          url: '/historico',
          templateUrl: 'app/pages/clientes/historico/historico.html',
          controller: 'historicolistCtrl',
          title: 'Historico Clientes',
          sidebarMeta: {
            order: 100
          }
        }).state('dashboard.clientes.historico-details', {
          url: '/historico/details/:idcotizacion',
          templateUrl: 'app/pages/clientes/historico/historicoEditar.html',
          controller: "historicoCtrl",
          title: 'Detalle Cotizacion',
          params: {
            idcotizacion: ''
          }
        });
    }
  
  })();
  
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.cobranzas', [
        'BlurAdmin.pages.cobranzas.cobranza'
    ]).config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
          .state('dashboard.cobranzas', {
            url: '/cobranzas',
            template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
            abstract: true,
            title: 'Cobranzas',
            sidebarMeta: {
              icon: 'ion-bag',
              order: 500,
            }
          }).state('dashboard.cobranzas.cobranza', {
            url: '/cobranza',
            templateUrl: 'app/pages/cobranzas/cobranza/list/cobranzaList.html',
            controller: 'cobranzaListCtrl',
            title: 'Cobranza',
            sidebarMeta: {
                order: 100
            }
        }).state('dashboard.cobranzas.cobranza-details', {
          url: '/cobranza/details/:idcobranza',
          templateUrl: 'app/pages/cobranzas/cobranza/cobranza.html',
          controller: "cobranzaCtrl",
          title: 'cobranza',
          params: {
            idcobranza: ''
          }
        });
    }
  })();
  
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.compras', [
        'BlurAdmin.pages.compras.proveedor',
        'BlurAdmin.pages.compras.compra',
        'BlurAdmin.pages.compras.facturaprov'
    ]).config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
          .state('dashboard.compras', {
            url: '/compras',
            template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
            abstract: true,
            title: 'Compras',
            sidebarMeta: {
              icon: 'ion-bag',
              order: 500,
            }
          }).state('dashboard.compras.proveedor', {
            url: '/proveedor',
            templateUrl: 'app/pages/compras/proveedor/list/proveedorList.html',
            controller: 'proveedorlistCtrl',
            title: 'Proveedor',
            sidebarMeta: {
                order: 100
            }
        }).state('dashboard.compras.proveedor-details', {
            url: '/proveedor/details/:idProveedor',
            templateUrl: 'app/pages/compras/proveedor/proveedor.html',
            controller: "proveedorCtrl",
            title: 'Proveedor',
            params:{
                idempleado:''
            }
        }).state('dashboard.compras.compra', {
            url: '/compra',
            templateUrl: 'app/pages/compras/compra/list/comprasList.html',
            controller: 'compralistCtrl',
            title: 'Compra',
            sidebarMeta: {
                order: 200
              }
        }).state('dashboard.compras.compra-details', {
            url: '/compra/details/:idCompras',
            templateUrl: 'app/pages/compras/compra/compra.html',
            controller: 'compraCtrl',
            controllerAs: 'vm',
            title: 'Compra',
            params:{ idrol:''}
        }).state('dashboard.compras.facturaprov', {
          url: '/facturaprov',
          templateUrl: 'app/pages/compras/facturaprov/list/facturaprovList.html',
          controller: 'facturaprovlistCtrl',
          title: 'Factura Proveedor',
          sidebarMeta: {
              order: 200
            }
      }).state('dashboard.compras.facturaprov-details', {
        url: '/facturaprov/details/:idfacturaprov',
        templateUrl: 'app/pages/compras/facturaprov/facturaprov.html',
        controller: 'facturaprovCtrl',
        controllerAs: 'vm',
        title: 'Factura Proveedor',
        params:{ idfacturaprov:''}
    });
    }
  })();
  
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.comprobantes', [
      'BlurAdmin.pages.comprobantes.guia',
      'BlurAdmin.pages.comprobantes.factura',
      'BlurAdmin.pages.comprobantes.boleta',
      'BlurAdmin.pages.comprobantes.notacredito',
      'BlurAdmin.pages.comprobantes.notadebito'
    ]).config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
        .state('dashboard.comprobantes', {
          url: '/comprobantes',
          template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Documentos SEE',
          sidebarMeta: {
            icon: 'ion-android-document',
            order: 500,
          }
        }).state('dashboard.comprobantes.guia', {
          url: '/guia',
          templateUrl: 'app/pages/comprobantes/guia/guiaList.html',
          controller: 'guiaListCtrl',
          title: 'Guia Remisión',
          sidebarMeta: {
            order: 100
          }
        }).state('dashboard.comprobantes.guia-details', {
          url: '/guia/details/:idguia',
          templateUrl: 'app/pages/comprobantes/guia/guia.html',
          controller: "guiaCtrl",
          title: 'Guia Remisión',
          params: {
            idguia: ''
          }
        }).state('dashboard.comprobantes.factura', {
          url: '/factura',
          templateUrl: 'app/pages/comprobantes/factura/facturaList.html',
          controller: 'facturaListCtrl',
          title: 'Factura',
          sidebarMeta: {
            order: 100
          }
        }).state('dashboard.comprobantes.factura-details', {
          url: '/factura/details/:idfactura',
          templateUrl: 'app/pages/comprobantes/factura/factura.html',
          controller: "facturaCtrl",
          title: 'Factura',
          params: {
            idfactura: ''
          }
        }).state('dashboard.comprobantes.boleta', {
          url: '/boleta',
          templateUrl: 'app/pages/comprobantes/boleta/boletaList.html',
          controller: 'boletaListCtrl',
          title: 'Boleta',
          sidebarMeta: {
            order: 100
          }
        }).state('dashboard.comprobantes.boleta-details', {
          url: '/boleta/details/:idboleta',
          templateUrl: 'app/pages/comprobantes/boleta/boleta.html',
          controller: "boletaCtrl",
          title: 'Boleta',
          params: {
            idboleta: ''
          }
        }).state('dashboard.comprobantes.notacredito', {
          url: '/notacredito',
          templateUrl: 'app/pages/comprobantes/notacredito/notacreditoList.html',
          controller: 'notacreditoListCtrl',
          title: 'Nota Credito',
          sidebarMeta: {
            order: 100
          }
        }).state('dashboard.comprobantes.notacredito-details', {
          url: '/notacredito/details/:idnotacredito',
          templateUrl: 'app/pages/comprobantes/notacredito/notacredito.html',
          controller: "notacreditoCtrl",
          title: 'notacredito',
          params: {
            idnotacredito: ''
          }
        })
        .state('dashboard.comprobantes.notadebito', {
            url: '/notadebito',
            templateUrl: 'app/pages/comprobantes/notadebito/notadebitoList.html',
            controller: 'notadebitoListCtrl',
            title: 'Nota Debito',
            sidebarMeta: {
              order: 100
            }
          }).state('dashboard.comprobantes.notadebito-details', {
            url: '/notadebito/details/:idnotadebito',
            templateUrl: 'app/pages/comprobantes/notadebito/notadebito.html',
            controller: "notadebitoCtrl",
            title: 'Nota Debito',
            params: {
                idnotadebito: ''
            }
          });
    }
  
  })();
(function () {
  'use strict';
  angular.module('BlurAdmin.pages.contabilidad', [
    'BlurAdmin.pages.contabilidad.bancos',
    'BlurAdmin.pages.contabilidad.cuentas',
    'BlurAdmin.pages.contabilidad.patrimonio',
    'BlurAdmin.pages.contabilidad.pasivos',
    'BlurAdmin.pages.contabilidad.cobrar',
    'BlurAdmin.pages.contabilidad.pagar'     
  ]).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('dashboard.contabilidad', {
        url: '/contabilidad',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Contabilidad',
        sidebarMeta: {
          icon: 'fas fa-archive',
          order: 500,
        }
      }).state('dashboard.contabilidad.bancos', {
        url: '/bancos',
        templateUrl: 'app/pages/contabilidad/bancos/bancos.html',
        controller: 'bancosCtrl',
        title: 'Bancos',
        sidebarMeta: {
          order: 100
        }
      }).state('dashboard.contabilidad.bancos-details', {
        url: '/bancos/details/:idbancos',
        templateUrl: 'app/pages/contabilidad/bancos/bancos.html',
        controller: "bancosCtrl",
        title: 'Bancos',
        params: {
          idbancos: ''
        }
      }).state('dashboard.contabilidad.cuentas', {
        url: '/cuentas',
        templateUrl: 'app/pages/contabilidad/cuentas/list/cuentasList.html',
        controller: 'cuentasListCtrl',
        title: 'Cuenta Bancaria',
        sidebarMeta: {
          order: 100
        }
      }).state('dashboard.contabilidad.cuentas-details', {
        url: '/cuentas/details/:idcuentas',
        templateUrl: 'app/pages/contabilidad/cuentas/cuentas.html',
        controller: "cuentasCtrl",
        title: 'Cuenta Bancaria',
        params: {
          idcuentas: ''
        }
      }).state('dashboard.contabilidad.patrimonio', {
        url: '/patrimonio',
        templateUrl: 'app/pages/contabilidad/patrimonio/list/patrimonioList.html',
        controller: 'patrimonioListCtrl',
        title: 'Patrimonio',
        sidebarMeta: {
          order: 100
        }
      }).state('dashboard.contabilidad.patrimonio-details', {
        url: '/patrimonio/details/:idpatrimonio',
        templateUrl: 'app/pages/contabilidad/patrimonio/patrimonio.html',
        controller: "patrimonioCtrl",
        title: 'Patrimonio',
        params: {
          idpatrimonio: ''
        }
      }).state('dashboard.contabilidad.pasivos', {
        url: '/pasivos',
        templateUrl: 'app/pages/contabilidad/pasivos/list/pasivosList.html',
        controller: 'pasivosListCtrl',
        title: 'Pasivos',
        sidebarMeta: {
          order: 100
        }
      }).state('dashboard.contabilidad.pasivos-details', {
        url: '/pasivos/details/:idpasivo',
        templateUrl: 'app/pages/contabilidad/pasivos/pasivos.html',
        controller: "pasivosCtrl",
        title: 'Pasivos',
        params: {
          idpasivo: ''
        }
      }).state('dashboard.contabilidad.cobrar', {
        url: '/cobrar',
        templateUrl: 'app/pages/contabilidad/cobrar/cobrar.html',
        controller: 'cobrarCtrl',
        title: 'Cuentas x Cobrar',
        sidebarMeta: {
          order: 100
        }
      }).state('dashboard.contabilidad.pagar', {
        url: '/pagar',
        templateUrl: 'app/pages/contabilidad/pagar/pagar.html',
        controller: 'pagarCtrl',
        title: 'Cuentas x Pagar',
        sidebarMeta: {
          order: 100
        }
      });
  }

})();

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.cuentas', [
      'BlurAdmin.pages.cuentas.cuentaxpagar',
      'BlurAdmin.pages.cuentas.cuentaxcobrar'
    ]).config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
        .state('dashboard.cuentas', {
          url: '/cuentas',
          template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'Cuentas',
          sidebarMeta: {
            icon: 'fas fa-archive',
            order: 500,
          }
        }).state('dashboard.cuentas.cuentaxpagar', {
          url: '/cuentaxpagar',
          templateUrl: 'app/pages/cuentas/cuentaxpagar/list/cuentaxpagarList.html',
          controller: 'cuentaxpagarListCtrl',
          title: 'Cuenta por Pagar',
          sidebarMeta: {
            order: 100
          }
        }).state('dashboard.cuentas.cuentaxpagar-details', {
          url: '/cuentaxpagar/details/:idcuentaxpagar',
          templateUrl: 'app/pages/cuentas/cuentaxpagar/cuentaxpagar.html',
          controller: "cuentaxpagarCtrl",
          title: 'Cuenta por Pagar',
          params: {
            idcuentaxpagar: ''
          }
        }).state('dashboard.cuentas.cuentaxcobrar', {
          url: '/cuentaxcobrar',
          templateUrl: 'app/pages/cuentas/cuentaxcobrar/list/cuentaxcobrarList.html',
          controller: 'cuentaxcobrarListCtrl',
          title: 'Cuenta por Cobrar',
          sidebarMeta: {
            order: 100
          }
        }).state('dashboard.cuentas.cuentaxcobrar-details', {
          url: '/cuentaxcobrar/details/:idxcobrar',
          templateUrl: 'app/pages/cuentas/cuentaxcobrar/cuentaxcobrar.html',
          controller: "cuentaxcobrarCtrl",
          title: 'Cuenta por Cobrar',
          params: {
            idcuentas: ''
          }
        });
    }
  
  })();
  
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('form', {
          url: '/form',
          template : '<ui-view></ui-view>',
          abstract: true,
          title: 'Form Elements',
          sidebarMeta: {
            icon: 'ion-compose',
            order: 250,
          },
        })
        .state('form.inputs', {
          url: '/inputs',
          templateUrl: 'app/pages/form/inputs/inputs.html',
          title: 'Form Inputs',
          sidebarMeta: {
            order: 0,
          },
        })
        .state('form.layouts', {
          url: '/layouts',
          templateUrl: 'app/pages/form/layouts/layouts.html',
          title: 'Form Layouts',
          sidebarMeta: {
            order: 100,
          },
        })
        .state('form.wizard',
        {
          url: '/wizard',
          templateUrl: 'app/pages/form/wizard/wizard.html',
          controller: 'WizardCtrl',
          controllerAs: 'vm',
          title: 'Form Wizard',
          sidebarMeta: {
            order: 200,
          },
        });
  }
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.home', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('dashboard.home', {
                url: '/home',
                templateUrl: 'app/pages/home/home.html',
                title: 'Principal',
                controller: "HomeCtrl",
                sidebarMeta: {
                    icon: 'ion-android-home',
                    order: 0,
                }
            });
    }

})();

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.inventario', [
      'BlurAdmin.pages.inventario.stockProductos',
      'BlurAdmin.pages.inventario.stockValorizado'
    ]).config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
        .state('dashboard.inventario', {
          url: '/inventario',
          template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
          abstract: true,
          title: 'inventario',
          sidebarMeta: {
            icon: 'ion-clipboard',
            order: 500,
          }
        }).state('dashboard.inventario.stockProductos', {
          url: '/stockProductos',
          templateUrl: 'app/pages/inventario/stockProductos/list/stockProductosList.html',
          controller: 'stockProductoslistCtrl',
          title: 'Stock Producto',
          sidebarMeta: {
            order: 200
          }
        }).state('dashboard.inventario.stockProductos-details', {
          url: '/stockProductos/details/:idProducto',
          templateUrl: 'app/pages/inventario/stockProductos/stockProductos.html',
          controller: 'stockProductosCtrl',
          controllerAs: 'vm',
          title: 'Stock Producto',
          params: { 
            idProducto: '' 
          }
        }).state('dashboard.inventario.stockProductos-details2', {
          url: '/stockProductos/details2/:idProducto',
          templateUrl: 'app/pages/inventario/stockProductos/listDetalle/stockProductoDetalle.html',
          controller: 'stockProductosCtrl',
          controllerAs: 'vm',
          title: 'Detalle Compras Producto',
          params: { 
            idProducto: '' 
          }
        }).state('dashboard.inventario.stockValorizado', {
          url: '/stockValorizado',
          templateUrl: 'app/pages/inventario/stockValorizado/list/stockValorizadoList.html',
          controller: 'stockValorizadolistCtrl',
          title: 'Stock Valorizado',
          sidebarMeta: {
            order: 200
          }
        });
    }
  
  })();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function() {
    'use strict';

    angular.module('BlurAdmin.pages.profile', [])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('dashboard.profile', {
                url: '/profile',
                title: 'Perfil',
                templateUrl: 'app/pages/profile/profile.html',
                controller: 'ProfilePageCtrl',
                data: {
                    permissions: {
                        only: ['AUTHORIZED'],
                        redirectTo: function() {
                            return {
                                state: 'signin',
                                options: {
                                    reload: true
                                }
                            };
                        }
                    }
                },
                resolve: {
                    user : ["$http", '$rootScope',
                        function($http, $rootScope ) {
                            return $http.get(IG.api + 'users/user/' +JSON.parse(localStorage.username))
                                .then(function(response) {
                                    return response.data.data.Item;
                                });
                        }
                    ]
                }
            });
    }

})();

(function(){
    'use strict';
    angular.module('BlurAdmin.pages.reportes',[
        'BlurAdmin.pages.reportes.ventas',
        'BlurAdmin.pages.reportes.productos'
    ]).config(['$stateProvider', function($stateProvider){
        $stateProvider.state('dashboard.reportes', {
            url: '/reportes',
            abstract: true,
            template : '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
            title: 'Reportes',
            sidebarMeta: {
              icon: 'fa fa-line-chart',
              order: 700
            }  
        }).state('dashboard.reportes.ventas', {
            url: '/ventas',
            templateUrl: 'app/pages/reporte/ventas/rptventas.html',
            title: 'Ventas',
            controller: 'rptventasCtrl',
            sidebarMeta: {
              order: 100
            }
          }).state('dashboard.reportes.productos',{
            url:'/productos',
            templateUrl: 'app/pages/reporte/productos/rptproductos.html',
            title:'Productos',
            controller: 'rptproductosCtrl',
            sidebarMeta:{
                order: 200
            }
          });
    }])
})();
(function () {
  'use strict';
  angular.module('BlurAdmin.pages.reportes', [
    'BlurAdmin.pages.reportes.general',    
    'BlurAdmin.pages.reportes.compras',
    'BlurAdmin.pages.reportes.ventas',
    'BlurAdmin.pages.reportes.diario'
  ]).config(['$stateProvider', function ($stateProvider) {
    $stateProvider.state('dashboard.reportes', {
      url: '/reportes',
      abstract: true,
      template: '<ui-view autoscroll="true" autoscroll-body-top></ui-view>',
      title: 'Reportes',
      sidebarMeta: {
        icon: 'fa fa-line-chart',
        order: 700
      }
    }).state('dashboard.reportes.general', {
      url: '/general',
      templateUrl: 'app/pages/reportes/general/general.html',
      title: 'General',
      controller: 'generalCtrl',
      sidebarMeta: {
        order: 100
      }
    }).state('dashboard.reportes.compras', {
      url: '/compras',
      templateUrl: 'app/pages/reportes/compras/rptcompras.html',
      title: 'Compras',
      controller: 'rptcomprasCtrl',
      sidebarMeta: {
        order: 100
      }
    }).state('dashboard.reportes.ventas', {
      url: '/ventas',
      templateUrl: 'app/pages/reportes/ventas/ventas.html',
      title: 'Ventas x Producto',
      controller: 'rptventasCtrl',
      sidebarMeta: {
        order: 200
      }
    }).state('dashboard.reportes.diario', {
      url: '/diario',
      templateUrl: 'app/pages/reportes/diario/rptDiario.html',
      title: 'Ventas Diarias',
      controller: 'rptdiariosCtrl',
      sidebarMeta: {
        order: 200
      }
    });
  }])
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.seguridad', [
        'BlurAdmin.pages.seguridad.usuario',
        'BlurAdmin.pages.seguridad.roles'
    ]).config(routeConfig);
  
    /** @ngInject */
    function routeConfig($stateProvider) {
      $stateProvider
          .state('dashboard.seguridad', {
            url: '/seguridad',
            template : '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
            abstract: true,
            title: 'Seguridad',
            sidebarMeta: {
              icon: 'fas fa-user-shield',
              order: 500,
            }
          }).state('dashboard.seguridad.usuarios', {
            url: '/usuarios',
            templateUrl: 'app/pages/seguridad/usuarios/list/usuariosList.html',
            controller: 'usuarioslistCtrl',
            title: 'Usuarios',
            sidebarMeta: {
                order: 100
            }
        }).state('dashboard.seguridad.usuario-details', {
            url: '/usuario/details/:idempleado',
            templateUrl: 'app/pages/seguridad/usuarios/usuario.html',
            controller: "usuarioCtrl",
            title: 'Usuario',
            params:{
                idempleado:''
            }
        }).state('dashboard.seguridad.roles', {
            url: '/roles',
            templateUrl: 'app/pages/seguridad/roles/list/rolesList.html',
            controller: 'rolesListCtrl',
            title: 'Roles de Usuario',
            sidebarMeta: {
                order: 200
              }
        }).state('dashboard.seguridad.rol-details', {
            url: '/roles/details/:idrol',
            templateUrl: 'app/pages/seguridad/roles/roles.html',
            controller: 'rolesCtrl',
            controllerAs: 'vm',
            title: 'Rol de Usuario',
            params:{ idrol:''}
        });
    }
  
  })();
  
(function() {
    'use strict';

    angular.module('BlurAdmin.sides', [])
        .config(['$stateProvider', function($stateProvider){
            $stateProvider
                .state('dashboard', {
                    url: '/dashboard',
                    templateUrl: 'app/pages/sides/sides.html',
                    params:{ defaultState:'' }
                }).state('dashboard.home', {
                    url: '/home',
                    templateUrl: 'app/pages/home/home.html',
                    title: 'Principal',
                    controller: "HomeCtrl",
                    sidebarMeta: {
                        icon: 'fa fa-home',
                        order: 100,
                    }
                });
        }]);
})();

(function() {
    'use strict';

    angular.module('BlurAdmin.signin',[])
        .config(['$stateProvider', function($stateProvider){
            $stateProvider.state('signin', {
                url: '/signin',
                templateUrl: 'app/pages/signin/signin.html',
                controller: 'SignInCtrl'
            }).state('forgotpwd', {
                url: '/signin/forgot',
                templateUrl: 'app/pages/signin/forgotpwd.html',
                controller: 'SignInCtrl'
            }).state('confirm', {
                url: '/signin/confirm',
                templateUrl: 'app/pages/signin/confirm.html',
                controller: 'SignInCtrl'
            });
        }]);
})();

(function () {
  'use strict';
  angular.module('BlurAdmin.pages.sucursal', [
    'BlurAdmin.pages.sucursal.empresa',
    'BlurAdmin.pages.sucursal.sucursales'
  ]).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('dashboard.sucursal', {
        url: '/sucursal',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Sucursal',
        sidebarMeta: {
          icon: 'fas fa-building',
          order: 500,
        }
      }).state('dashboard.sucursal.empresa', {
        url: '/empresa',
        templateUrl: 'app/pages/sucursal/empresa/list/empresaList.html',
        controller: 'empresalistCtrl',
        title: 'Empresa',
        sidebarMeta: {
          order: 100
        }
      }).state('dashboard.sucursal.empresa-details', {
        url: '/empresa/details/:idempresa',
        templateUrl: 'app/pages/sucursal/empresa/empresa.html',
        controller: "empresaCtrl",
        title: 'Empresa',
        params: {
          idempleado: ''
        }
      }).state('dashboard.sucursal.sucursales', {
        url: '/sucursales',
        templateUrl: 'app/pages/sucursal/sucursales/list/sucursalesList.html',
        controller: 'sucursaleslistCtrl',
        title: 'Sucursales',
        sidebarMeta: {
          order: 100
        }
      }).state('dashboard.sucursal.sucursales-details', {
        url: '/sucursales/details/:idsucursales',
        templateUrl: 'app/pages/sucursal/sucursales/sucursales.html',
        controller: "sucursalesCtrl",
        title: 'Sucursales',
        params: {
          idempleado: ''
        }
      });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.tables', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
        .state('tables', {
          url: '/tables',
          template : '<ui-view></ui-view>',
          abstract: true,
          controller: 'TablesPageCtrl',
          title: 'Tables',
          sidebarMeta: {
            icon: 'ion-grid',
            order: 300,
          },
        }).state('tables.basic', {
          url: '/basic',
          templateUrl: 'app/pages/tables/basic/tables.html',
          title: 'Basic Tables',
          sidebarMeta: {
            order: 0,
          },
        }).state('tables.smart', {
          url: '/smart',
          templateUrl: 'app/pages/tables/smart/tables.html',
          title: 'Smart Tables',
          sidebarMeta: {
            order: 100,
          },
        });
    $urlRouterProvider.when('/tables','/tables/basic');
  }

})();

/**
 * @author k.danovsky
 * created on 12.01.2016
 */
(function() {
    'use strict';

    angular.module('BlurAdmin.pages.ui', [
            'BlurAdmin.pages.ui.typography',
            'BlurAdmin.pages.ui.buttons',
            'BlurAdmin.pages.ui.icons',
            'BlurAdmin.pages.ui.modals',
            'BlurAdmin.pages.ui.grid',
            'BlurAdmin.pages.ui.alerts',
            'BlurAdmin.pages.ui.progressBars',
            'BlurAdmin.pages.ui.notifications',
            'BlurAdmin.pages.ui.tabs',
            'BlurAdmin.pages.ui.slider',
            'BlurAdmin.pages.ui.panels',
        ])
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider) {
        $stateProvider
            .state('dashboard.ui', {
                url: '/ui',
                template: '<ui-view></ui-view>',
                abstract: true,
                title: 'UI Features',
                sidebarMeta: {
                    icon: 'ion-android-laptop',
                    order: 200,
                },
            });
    }

})();

(function () {
  'use strict';
  angular.module('BlurAdmin.pages.venta', [
    'BlurAdmin.pages.venta.pos',
    'BlurAdmin.pages.venta.caja',
    'BlurAdmin.pages.venta.gastos',
    'BlurAdmin.pages.venta.cotizacion'

  ]).config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
      .state('dashboard.venta', {
        url: '/venta',
        template: '<ui-view  autoscroll="true" autoscroll-body-top></ui-view>',
        abstract: true,
        title: 'Venta',
        sidebarMeta: {
          icon: 'ion-cash',
          order: 500,
        }
      }).state('dashboard.venta.pos', {
        url: '/pos',
        templateUrl: 'app/pages/ventas/pos/list/posList.html',
        controller: 'poslistCtrl',
        title: 'POS',
        sidebarMeta: {
          order: 200
        }
      })
      .state('dashboard.venta.pos-details', {
        url: '/pos/details/:idpos',
        templateUrl: 'app/pages/ventas/pos/venta.html',
        controller: 'posCtrl',
        controllerAs: 'vm',
        title: 'POS',
        params: { idpos: '' }
      })
      .state('dashboard.venta.caja', {
        url: '/caja',
        templateUrl: 'app/pages/ventas/caja/list/cajaList.html',
        controller: 'cajalistCtrl',
        title: 'Caja',
        sidebarMeta: {
          order: 200
        }
      })
      .state('dashboard.venta.caja-details', {
        url: '/caja/details/:idcaja',
        templateUrl: 'app/pages/ventas/caja/caja.html',
        controller: 'cajaCtrl',
        controllerAs: 'vm',
        title: 'Caja',
        params: { idcaja: '' }
      })
      .state('dashboard.venta.gastos', {
        url: '/gastos',
        templateUrl: 'app/pages/ventas/gastos/list/gastosList.html',
        controller: 'gastoslistCtrl',
        title: 'Gastos',
        sidebarMeta: {
          order: 200
        }
      })
      .state('dashboard.venta.gastos-details', {
        url: '/gastos/details/:idgastos',
        templateUrl: 'app/pages/ventas/gastos/gastos.html',
        controller: 'gastosCtrl',
        controllerAs: 'vm',
        title: 'Gastos',
        params: { idgastos: '' }
      }).state('dashboard.venta.cotizacion', {
        url: '/cotizacion',
        templateUrl: 'app/pages/ventas/cotizacion/list/cotizacionList.html',
        controller: 'cotizacionlistCtrl',
        title: 'Cotización',
        sidebarMeta: {
          order: 200
        }
      })
      .state('dashboard.venta.cotizacion-details', {
        url: '/cotizacion/details/:idcotizacion',
        templateUrl: 'app/pages/ventas/cotizacion/cotizacion.html',
        controller: 'cotizacionCtrl',
        controllerAs: 'vm',
        title: 'Cotización',
        params: { idcotizacion: '' }
      });
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components', []);

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs', []);

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts', [])
      .config(routeConfig).config(amChartConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts.amCharts', {
          url: '/amCharts',
          templateUrl: 'app/pages/charts/amCharts/charts.html',
          title: 'amCharts',
          sidebarMeta: {
            order: 0,
          },
        });
  }

  function amChartConfig(baConfigProvider) {
    var layoutColors = baConfigProvider.colors;
    AmCharts.themes.blur = {

      themeName: "blur",

      AmChart: {
        color: layoutColors.defaultText,
        backgroundColor: "#FFFFFF"
      },

      AmCoordinateChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmStockChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark]
      },

      AmSlicedChart: {
        colors: [layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.primaryDark, layoutColors.warningLight, layoutColors.successDark, layoutColors.successLight, layoutColors.primaryLight, layoutColors.warningDark],
        labelTickColor: "#FFFFFF",
        labelTickAlpha: 0.3
      },

      AmRectangularChart: {
        zoomOutButtonColor: '#FFFFFF',
        zoomOutButtonRollOverAlpha: 0.15,
        zoomOutButtonImage: "lens.png"
      },

      AxisBase: {
        axisColor: "#FFFFFF",
        axisAlpha: 0.3,
        gridAlpha: 0.1,
        gridColor: "#FFFFFF"
      },

      ChartScrollbar: {
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.12,
        graphFillAlpha: 0.5,
        graphLineAlpha: 0,
        selectedBackgroundColor: "#FFFFFF",
        selectedBackgroundAlpha: 0.4,
        gridAlpha: 0.15
      },

      ChartCursor: {
        cursorColor: layoutColors.primary,
        color: "#FFFFFF",
        cursorAlpha: 0.5
      },

      AmLegend: {
        color: "#FFFFFF"
      },

      AmGraph: {
        lineAlpha: 0.9
      },
      GaugeArrow: {
        color: "#FFFFFF",
        alpha: 0.8,
        nailAlpha: 0,
        innerRadius: "40%",
        nailRadius: 15,
        startWidth: 15,
        borderAlpha: 0.8,
        nailBorderAlpha: 0
      },

      GaugeAxis: {
        tickColor: "#FFFFFF",
        tickAlpha: 1,
        tickLength: 15,
        minorTickLength: 8,
        axisThickness: 3,
        axisColor: '#FFFFFF',
        axisAlpha: 1,
        bandAlpha: 0.8
      },

      TrendLine: {
        lineColor: layoutColors.danger,
        lineAlpha: 0.8
      },

      // ammap
      AreasSettings: {
        alpha: 0.8,
        color: layoutColors.info,
        colorSolid: layoutColors.primaryDark,
        unlistedAreasAlpha: 0.4,
        unlistedAreasColor: "#FFFFFF",
        outlineColor: "#FFFFFF",
        outlineAlpha: 0.5,
        outlineThickness: 0.5,
        rollOverColor: layoutColors.primary,
        rollOverOutlineColor: "#FFFFFF",
        selectedOutlineColor: "#FFFFFF",
        selectedColor: "#f15135",
        unlistedAreasOutlineColor: "#FFFFFF",
        unlistedAreasOutlineAlpha: 0.5
      },

      LinesSettings: {
        color: "#FFFFFF",
        alpha: 0.8
      },

      ImagesSettings: {
        alpha: 0.8,
        labelColor: "#FFFFFF",
        color: "#FFFFFF",
        labelRollOverColor: layoutColors.primaryDark
      },

      ZoomControl: {
        buttonFillAlpha: 0.8,
        buttonIconColor: layoutColors.defaultText,
        buttonRollOverColor: layoutColors.danger,
        buttonFillColor: layoutColors.primaryDark,
        buttonBorderColor: layoutColors.primaryDark,
        buttonBorderAlpha: 0,
        buttonCornerRadius: 0,
        gridColor: "#FFFFFF",
        gridBackgroundColor: "#FFFFFF",
        buttonIconAlpha: 0.6,
        gridAlpha: 0.6,
        buttonSize: 20
      },

      SmallMap: {
        mapColor: "#000000",
        rectangleColor: layoutColors.danger,
        backgroundColor: "#FFFFFF",
        backgroundAlpha: 0.7,
        borderThickness: 1,
        borderAlpha: 0.8
      },

      // the defaults below are set using CSS syntax, you can use any existing css property
      // if you don't use Stock chart, you can delete lines below
      PeriodSelector: {
        color: "#FFFFFF"
      },

      PeriodButton: {
        color: "#FFFFFF",
        background: "transparent",
        opacity: 0.7,
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        boxSizing: "border-box"
      },

      PeriodButtonSelected: {
        color: "#FFFFFF",
        backgroundColor: "#b9cdf5",
        border: "1px solid rgba(0, 0, 0, .3)",
        MozBorderRadius: "5px",
        borderRadius: "5px",
        margin: "1px",
        outline: "none",
        opacity: 1,
        boxSizing: "border-box"
      },

      PeriodInputField: {
        color: "#FFFFFF",
        background: "transparent",
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      },

      DataSetSelector: {
        color: "#FFFFFF",
        selectedBackgroundColor: "#b9cdf5",
        rollOverBackgroundColor: "#a8b0e4"
      },

      DataSetCompareList: {
        color: "#FFFFFF",
        lineHeight: "100%",
        boxSizing: "initial",
        webkitBoxSizing: "initial",
        border: "1px solid rgba(0, 0, 0, .3)"
      },

      DataSetSelect: {
        border: "1px solid rgba(0, 0, 0, .3)",
        outline: "none"
      }

    };
  }

})();

/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs', [])
      .config(routeConfig).config(chartJsConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts.chartJs', {
          url: '/chartJs',
          templateUrl: 'app/pages/charts/chartJs/chartJs.html',
          title: 'Chart.js',
          sidebarMeta: {
            order: 200,
          },
        });
  }

  function chartJsConfig(ChartJsProvider, baConfigProvider) {
    var layoutColors = baConfigProvider.colors;
    // Configure all charts
    ChartJsProvider.setOptions({
      colours: [ layoutColors.primary, layoutColors.danger, layoutColors.warning, layoutColors.success, layoutColors.info, layoutColors.default, layoutColors.primaryDark, layoutColors.successDark, layoutColors.warningLight, layoutColors.successLight, layoutColors.primaryLight],
      responsive: true,
      scaleFontColor: layoutColors.defaultText,
      scaleLineColor: layoutColors.border,
      pointLabelFontColor: layoutColors.defaultText
    });
    // Configure all line charts
    ChartJsProvider.setOptions('Line', {
      datasetFill: false
    });
  }

})();

/**
 * @author a.demeshko
 * created on 12/17/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartist', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts.chartist', {
          url: '/chartist',
          templateUrl: 'app/pages/charts/chartist/chartist.html',
          title: 'Chartist',
          sidebarMeta: {
            order: 100,
          },
        });
  }

})();

/**
 * @author a.demeshko
 * created on 12/18/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.morris', [])
    .config(routeConfig).config(function(baConfigProvider){
      var layoutColors = baConfigProvider.colors;
      Morris.Donut.prototype.defaults.backgroundColor = 'transparent';
      Morris.Donut.prototype.defaults.labelColor = layoutColors.defaultText;
      Morris.Grid.prototype.gridDefaults.gridLineColor = layoutColors.borderDark;
      Morris.Grid.prototype.gridDefaults.gridTextColor = layoutColors.defaultText;
    });

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('charts.morris', {
          url: '/morris',
          templateUrl: 'app/pages/charts/morris/morris.html',
          title: 'Morris',
          sidebarMeta: {
            order: 300,
          }
        });
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.home.user', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('dashboard.home.user', {
          url: '/user',
          templateUrl: 'app/pages/home/user/user.html',
          title: 'user'
        });
  }

})();

(function () {
  'use strict';

  angular.module('BlurAdmin.pages.home.users', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('dashboard.home.users', {
          url: '/users',
          templateUrl: 'app/pages/home/users/users.html',
          title: 'Usuarios'
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.alerts', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.alerts', {
          url: '/alerts',
          templateUrl: 'app/pages/ui/alerts/alerts.html',
          title: 'Alerts',
          sidebarMeta: {
            order: 500,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.buttons', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.buttons', {
          url: '/buttons',
          templateUrl: 'app/pages/ui/buttons/buttons.html',
          controller: 'ButtonPageCtrl',
          title: 'Buttons',
          sidebarMeta: {
            order: 100,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.grid', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.grid', {
          url: '/grid',
          templateUrl: 'app/pages/ui/grid/grid.html',
          title: 'Grid',
          sidebarMeta: {
            order: 400,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.icons', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.icons', {
          url: '/icons',
          templateUrl: 'app/pages/ui/icons/icons.html',
          controller: 'IconsPageCtrl',
          title: 'Icons',
          sidebarMeta: {
            order: 200,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.modals', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.modals', {
          url: '/modals',
          templateUrl: 'app/pages/ui/modals/modals.html',
          controller: 'ModalsPageCtrl',
          title: 'Modals',
          sidebarMeta: {
            order: 300,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.notifications', {
          url: '/notifications',
          templateUrl: 'app/pages/ui/notifications/notifications.html',
          controller: 'NotificationsPageCtrl',
          title: 'Notifications',
          sidebarMeta: {
            order: 700,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.panels', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.panels', {
          url: '/panels',
          templateUrl: 'app/pages/ui/panels/panels.html',
          controller: 'NotificationsPageCtrl',
          title: 'Panels',
          sidebarMeta: {
            order: 1100,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.progressBars', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.progressBars', {
          url: '/progressBars',
          templateUrl: 'app/pages/ui/progressBars/progressBars.html',
          title: 'Progress Bars',
          sidebarMeta: {
            order: 600,
          },
        });
  }

})();

/**
 * @author a.demeshko
 * created on 12/22/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.slider', [])
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.slider', {
          url: '/slider',
          templateUrl: 'app/pages/ui/slider/slider.html',
          title: 'Sliders',
          sidebarMeta: {
            order: 1000,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 21.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.tabs', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.tabs', {
          url: '/tabs',
          templateUrl: 'app/pages/ui/tabs/tabs.html',
          title: 'Tabs & Accordions',
          sidebarMeta: {
            order: 800,
          },
        });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.typography', [])
      .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider) {
    $stateProvider
        .state('ui.typography', {
          url: '/typography',
          templateUrl: 'app/pages/ui/typography/typography.html',
          title: 'Typography',
          sidebarMeta: {
            order: 0,
          },
        });
  }

})();

'use strict';
angular.module('BlurAdmin', [
        'ui.grid',
        'ui.grid.edit',
        'ui.grid.rowEdit',
        'ui.grid.cellNav',
        'ui.grid.grouping',
        'ui.grid.pagination',
        'ui.grid.expandable',
        'ui.grid.selection',
        'ui.grid.pinning',
        'ui.grid.treeView',
        'ngAnimate', 
        'ngTouch',
        'ngAnimate',
        'ui.bootstrap',
        'ui.sortable',
        'ui.router',
        'ngTouch',
        'toastr',
        'smart-table',
        'xeditable',
        'ui.slimscroll',
        'ngStorage',
        'permission',
        'permission.ui',
        'angular-progress-button-styles',
        'BlurAdmin.authService',
        'BlurAdmin.printService',
        'BlurAdmin.commonservice',
        'BlurAdmin.getservice',
        'BlurAdmin.facturaservice',
        'BlurAdmin.sides',
        'BlurAdmin.signin',
        'BlurAdmin.theme',
        'BlurAdmin.pages',
        'ngFileUpload', // added for file uploads s3 backet
        'BlurAdmin.theme.components',
        'angular-loading-bar',
        'moment-picker',
        'ui.toggle',
        'ui.select',
        'ngSanitize'
    ])
    .constant('apiEndpoint', '/api/')
    .config(['cfpLoadingBarProvider', '$urlRouterProvider', '$httpProvider', function(cfpLoadingBarProvider, $urlRouterProvider, $httpProvider) {
        cfpLoadingBarProvider.includeSpinner = false;
        $urlRouterProvider
            .otherwise('/signin');
        $httpProvider.interceptors.push(['$q', '$location', '$localStorage', function($q, $location, $localStorage){
            return {
                'request': function(config){
                    config.headers=config.headers || {};
                    if($localStorage.token){
                        config.headers.Authorization='Bearer '+$localStorage.token;
                    }
                    return config;
                },
                'response':function(response){
                    if(response.data.token!==undefined){
                        $localStorage.token=response.data.token;}
                    return response;
                },
                'responseError': function(response){
                    if(response.status===401 || response.status==403){
                        $location.path('/sigin');
                    }
                    return $q.reject(response);
                }
            }
        }])
    }])
    .run(['$rootScope', '$state', 'PermRoleStore', 'PermPermissionStore', 'AuthenticationService', 'serviceAPI', function($rootScope, $state, PermRoleStore, PermPermissionStore, AuthenticationService, serviceAPI) {
        PermRoleStore.defineRole('AUTHORIZED', function(){
            return AuthenticationService.isLoggedIn();
        });
        
        PermRoleStore.defineRole('ADMIN', function(){
            return AuthenticationService.isAdmin();
        });

        PermRoleStore.defineRole('CAJERO', function(){
            return AuthenticationService.isCajero();
        });

        PermRoleStore.defineRole('SUPERVISOR', function(){
            return AuthenticationService.isSupervisor();
        });

        PermRoleStore.defineRole('SUPERUSUARIO', function(){
            return AuthenticationService.isSuperusuario();
        });

        $rootScope.$on('$stateChangeStart', function(evt, to, params, from){
            if((from.name=='signin' && to.name=='dashboard') && params.defaultState!=''){
                evt.preventDefault();
                $state.go(params.defaultState, {}, { location: 'replace' });
            }
            if(to.name=='dashboard.ventas.cajas'){
                serviceAPI.deleteVentaTMP().success(function(r){});
            }
        });
        /*
        $rootScope.$on('$stateChangePermissionDenied', function(){
            console.log('error');
        });
        */
}]);

(function() {
    'use strict';

    angular.module('BlurAdmin.authService', [])
        .factory('AuthenticationService', [ '$localStorage', function($localStorage){
            var service={};
            $localStorage.$default({loggedIn: false, isAdmin:false, isCaja:false, username:false, token:'', namerol:'', states:[]});
            service.setLoggedIn=function(login){
                $localStorage.loggedIn= JSON.stringify(login);
            };

            service.setToken=function(authToken){
                $localStorage.token=authToken;
            };
            
            service.isLoggedIn=function(){
                return JSON.parse($localStorage.loggedIn);
            };
            service.setRol=function(name){
                $localStorage.namerol=name;
            };
            service.getRol=function(){
                return $localStorage.namerol;
            };
            service.setStates=function(statepermission){
                $localStorage.states=statepermission;
            };
            service.getStatesusers=function(){
                return $localStorage.states;
            };
            service.setAdmin=function(isadmin){
                $localStorage.isAdmin= JSON.stringify(isadmin);
            };
            service.isAdmin=function(){
                var uservalid=$localStorage.namerol=="ADMINISTRADOR";
                var login=JSON.parse($localStorage.loggedIn);
                return (uservalid && login);
            };
            service.setCajero=function(iscajero){
                $localStorage.isCaja= JSON.stringify(iscajero);
            };
            service.isCajero=function(){
                var uservalid=$localStorage.namerol=="CAJERO";
                var login=JSON.parse($localStorage.loggedIn);
                return (uservalid && login);
            };
            service.isSupervisor=function(){
                var uservalid=$localStorage.namerol=="SUPERVISOR";
                var login=JSON.parse($localStorage.loggedIn);
                return (uservalid && login);
            };    
            service.isSuperusuario=function(){
                var uservalid=$localStorage.namerol=="SUPERUSUARIO";
                var login=JSON.parse($localStorage.loggedIn);
                return (uservalid && login);
            };
            service.setUser = function(user){
                $localStorage.username=user;
            };
            
            service.getUser=function(){
                return $localStorage.username;
            };

            service.setToken = function(token) {
                $localStorage.token=token;
            };
    
            service.getToken = function() {
                return $localStorage.token;
            };
    
            service.signOut = function() {
                $localStorage.$reset();
            };
            return service;
        }]);

})();

(function() {
    'use strict';

    angular.module('BlurAdmin.commonservice', [])
        .factory('permissions', [ 'AuthenticationService', function(AuthenticationService){
            return {
                hasPermissions:function(state){
                    var permissionList=AuthenticationService.getStatesusers();
                    if(!angular.isString(state)){
                        return false;
                    }
                    return (permissionList.indexOf(state)===-1);
                }
            }
        }])
        .directive('hasPermission', ['permissions', function(permissions){
            return {
                scope:{
                    name:'=namestate'
                },
                link:function(scope, element, attrs){
                    element[0].style.display=(permissions.hasPermissions(scope.name))?'none':'block';
                }
            }
        }])
        .factory('commonService',[ '$localStorage', function($localStorage){
            return {
                setConfig:function(infoConfig){
                    $localStorage.infoConfig=infoConfig;
                },
                setEmpresa:function(infoEmpresa){
                    $localStorage.infoEmpresa=infoEmpresa;
                },
                getConfig:function(){
                    return $localStorage.infoConfig;
                },
                getEmpresa:function(){
                    return $localStorage.infoEmpresa;
                },
                updateConfig:function(data){
                    angular.extend($localStorage.infoConfig, data);
                }
            }
        }]);
})();

(function() {
    'use strict';

    angular.module('BlurAdmin.getservice', [])
        .factory('getservice', getservice);

    /** @ngInject */
    function getservice($http, $httpParamSerializerJQLike) {
			var datas={};
			datas.getDespartamentos=function(){
				return $http({
					url:'http://tlm.localhost/api/controller/rrhh/controller.personal.php', method:"POST", data:$httpParamSerializerJQLike({oper:'cargar_departamentos'}),
					headers:{'Content-Type':'application/x-www-form-urlencoded'}
				});
			};
            datas.getProvincias=function(cod_depart){
				return $http({
					url:'http://tlm.localhost/api/controller/rrhh/controller.personal.php', method:"POST", data:$httpParamSerializerJQLike({oper:'cargar_provincias', co_depart:cod_depart}),
					headers:{'Content-Type':'application/x-www-form-urlencoded'} 
				})
			};
			datas.getDistritos=function(cod_provin){
				return $http({
					url:'http://tlm.localhost/api/controller/rrhh/controller.personal.php', method:"POST", data:$httpParamSerializerJQLike({oper:'cargar_distritos', co_provin:cod_provin}),
					headers:{'Content-Type':'application/x-www-form-urlencoded'}
				});
			};
			datas.getPrimas=function(cod_regimen){
				return $http({
					url:'http://tlm.localhost/api/controller/rrhh/controller.personal.php', method:"POST", data:$httpParamSerializerJQLike({oper:'cargar_primas', co_regimen:cod_regimen}),
					headers:{'Content-Type':'application/x-www-form-urlencoded'}
				});
			};
			datas.getCargos=function(cod_area){
				return $http({
					url:'http://tlm.localhost/api/controller/rrhh/controller.personal.php', method:"POST", data:$httpParamSerializerJQLike({oper:'cargar_cargos_fil', id_area:cod_area}),
					headers:{'Content-Type':'application/x-www-form-urlencoded'}
				});
			};
			return datas;
    }
})();

(function() {
    'use strict';

    angular.module('BlurAdmin.printService', [])
        .factory('printService', printService);

    /** @ngInject */
    function printService($http, $timeout) {
        var service = {};
        service.print = function(content) {
            //console.log(content);
        };

        return service;
    }
})();



(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .config(config);

  /** @ngInject */
  function config(baConfigProvider, colorHelper, $provide) {
    $provide.decorator('$uiViewScroll', uiViewScrollDecorator);
    baConfigProvider.changeTheme({blur: true});
    baConfigProvider.changeColors({
      default: 'rgba(#000000, 0.2)',
      defaultText: '#ffffff',
      dashboard: {
        white: '#ffffff',
      },
    });
  }

  /** @ngInject */
  function uiViewScrollDecorator($delegate, $anchorScroll, baUtil) {
    return function (uiViewElement) {
      if (baUtil.hasAttr(uiViewElement, "autoscroll-body-top")) {
        $anchorScroll();
      } else {
        $delegate(uiViewElement);
      }
    };
  }
})();
/**
 * Created by k.danovsky on 13.05.2016.
 */

(function () {
  'use strict';

  var basic = {
    default: '#ffffff',
    defaultText: '#666666',
    border: '#dddddd',
    borderDark: '#aaaaaa',
  };

  // main functional color scheme
  var colorScheme = {
    primary: '#209e91',
    info: '#2dacd1',
    success: '#90b900',
    warning: '#dfb81c',
    danger: '#e85656',
  };

  // dashboard colors for charts
  var dashboardColors = {
    blueStone: '#005562',
    surfieGreen: '#0e8174',
    silverTree: '#6eba8c',
    gossip: '#b9f2a1',
    white: '#10c4b5',
  };

  angular.module('BlurAdmin.theme')
    .provider('baConfig', configProvider);

  /** @ngInject */
  function configProvider(colorHelper) {
    var conf = {
      theme: {
        blur: false,
      },
      colors: {
        default: basic.default,
        defaultText: basic.defaultText,
        border: basic.border,
        borderDark: basic.borderDark,

        primary: colorScheme.primary,
        info: colorScheme.info,
        success: colorScheme.success,
        warning: colorScheme.warning,
        danger: colorScheme.danger,

        primaryLight: colorHelper.tint(colorScheme.primary, 30),
        infoLight: colorHelper.tint(colorScheme.info, 30),
        successLight: colorHelper.tint(colorScheme.success, 30),
        warningLight: colorHelper.tint(colorScheme.warning, 30),
        dangerLight: colorHelper.tint(colorScheme.danger, 30),

        primaryDark: colorHelper.shade(colorScheme.primary, 15),
        infoDark: colorHelper.shade(colorScheme.info, 15),
        successDark: colorHelper.shade(colorScheme.success, 15),
        warningDark: colorHelper.shade(colorScheme.warning, 15),
        dangerDark: colorHelper.shade(colorScheme.danger, 15),

        dashboard: {
          blueStone: dashboardColors.blueStone,
          surfieGreen: dashboardColors.surfieGreen,
          silverTree: dashboardColors.silverTree,
          gossip: dashboardColors.gossip,
          white: dashboardColors.white,
        },
      }
    };

    conf.changeTheme = function(theme) {
      angular.merge(conf.theme, theme)
    };

    conf.changeColors = function(colors) {
      angular.merge(conf.colors, colors)
    };

    conf.$get = function () {
      delete conf.$get;
      return conf;
    };
    return conf;
  }
})();

/**
 * @author v.lugovsky
 * created on 15.12.2015
 */
(function () {
  'use strict';

  var IMAGES_ROOT = 'assets/img/';

  angular.module('BlurAdmin.theme')
    .constant('layoutSizes', {
      resWidthCollapseSidebar: 1200,
      resWidthHideSidebar: 500
    })
    .constant('layoutPaths', {
      images: {
        root: IMAGES_ROOT,
        profile: IMAGES_ROOT + 'app/profile/',
        amMap: 'assets/img/theme/vendor/ammap//dist/ammap/images/',
        amChart: 'assets/img/theme/vendor/amcharts/dist/amcharts/images/'
      }
    })
    .constant('colorHelper', {
      tint: function(color, weight) {
        return mix('#ffffff', color, weight);
      },
      shade: function(color, weight) {
        return mix('#000000', color, weight);
      },
    });

  function shade(color, weight) {
    return mix('#000000', color, weight);
  }

  function tint(color, weight) {
    return mix('#ffffff', color, weight);
  }

  //SASS mix function
  function mix(color1, color2, weight) {
    // convert a decimal value to hex
    function d2h(d) {
      return d.toString(16);
    }
    // convert a hex value to decimal
    function h2d(h) {
      return parseInt(h, 16);
    }

    var result = "#";
    for(var i = 1; i < 7; i += 2) {
      var color1Part = h2d(color1.substr(i, 2));
      var color2Part = h2d(color2.substr(i, 2));
      var resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  }
})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .run(themeRun);

  /** @ngInject */
  function themeRun($timeout, $rootScope, layoutPaths, preloader, $q, baSidebarService, themeLayoutSettings) {
    var whatToWait = [
      preloader.loadAmCharts(),
      $timeout(3000)
    ];

    var theme = themeLayoutSettings;
    if (theme.blur) {
      if (theme.mobile) {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-mobile.jpg'));
      } else {
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg.jpg'));
        whatToWait.unshift(preloader.loadImg(layoutPaths.images.root + 'blur-bg-blurred.jpg'));
      }
    }

    $q.all(whatToWait).then(function () {
      $rootScope.$pageFinishedLoading = true;
    });

    $timeout(function () {
      if (!$rootScope.$pageFinishedLoading) {
        $rootScope.$pageFinishedLoading = true;
      }
    }, 7000);

    $rootScope.$baSidebarService = baSidebarService;
  }

})();
/**
 * Created by k.danovsky on 12.05.2016.
 */

(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('themeLayoutSettings', themeLayoutSettings);

  /** @ngInject */
  function themeLayoutSettings(baConfig) {
    var isMobile = (/android|webos|iphone|ipad|ipod|blackberry|windows phone/).test(navigator.userAgent.toLowerCase());
    var mobileClass = isMobile ? 'mobile' : '';
    var blurClass = baConfig.theme.blur ? 'blur-theme' : '';
    angular.element(document.body).addClass(mobileClass).addClass(blurClass);

    return {
      blur: baConfig.theme.blur,
      mobile: isMobile,
    }
  }

})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.home', [])
        .controller('HomeCtrl', ['$scope', 'baConfig', function($scope, baConfig){
          var layoutColors = baConfig.colors;
          $scope.colors = [layoutColors.primary, layoutColors.warning, layoutColors.danger, layoutColors.info, layoutColors.success, layoutColors.primaryDark];
          $scope.lineData = [
            {y: "2006", a: 100, b: 90},
            {y: "2007", a: 75, b: 65},
            {y: "2008", a: 50, b: 40},
            {y: "2009", a: 75, b: 65},
            {y: "2010", a: 50, b: 40},
            {y: "2011", a: 75, b: 65},
            {y: "2012", a: 100, b: 90}
          ];
          $scope.areaData = [
            {y: "2006", a: 100, b: 90},
            {y: "2007", a: 75, b: 65},
            {y: "2008", a: 50, b: 40},
            {y: "2009", a: 75, b: 65},
            {y: "2010", a: 50, b: 40},
            {y: "2011", a: 75, b: 65},
            {y: "2012", a: 100, b: 90}
          ];
          $scope.barData = [
            {y: "2006", a: 100, b: 90},
            {y: "2007", a: 75, b: 65},
            {y: "2008", a: 50, b: 40},
            {y: "2009", a: 75, b: 65},
            {y: "2010", a: 50, b: 40},
            {y: "2011", a: 75, b: 65},
            {y: "2012", a: 100, b: 90}
          ];
          $scope.donutData = [
            {label: "Download Sales", value: 12},
            {label: "In-Store Sales", value: 30},
            {label: "Mail-Order Sales", value: 20}
          ];
        }]);
})();

(function() {
    'use strict';

    angular.module('BlurAdmin.pages.profile')
        .controller('ProfilePageCtrl', ProfilePageCtrl);

    /** @ngInject */
    function ProfilePageCtrl($scope, fileReader, $filter, $http, toastr, $uibModal, AuthenticationService, editableOptions, editableThemes, Upload, S3UploadService, user) {
        $scope.picture = null;

        $scope.uploadFiles = function(files) {
            $scope.Files = files;

            if (files && files.length > 0) {
                angular.forEach($scope.Files, function(file, key) {
                    S3UploadService.Upload(file).then(function(result) {
                        // Mark as success
                        file.Success = true;
                        $scope.picture = "https://s3.amazonaws.com/99xt-interns-uploads/profile/" + file.name;
                        $scope.data.profile = $scope.picture;
                        $scope.update($scope.picture);
                    }, function(error) {
                        // Mark the error
                        $scope.Error = error;
                    }, function(progress) {
                        // Write the progress as a percentage
                        file.Progress = (progress.loaded / progress.total) * 100;
                        $scope.fileProgress = file.Progress;
                    });
                });
            }
        };


        $scope.removePicture = function() {
            $scope.picture = $filter('appImage')('theme/no-photo.png');
            $scope.noPicture = true;
        };

        $scope.uploadPicture = function() {
            var fileInput = document.getElementById('uploadFile');
            fileInput.click();
        };



        $scope.data = user;
        var social = [{
            name: 'Facebook',
            icon: 'socicon-facebook'
        }, {
            name: 'LinkedIn',
            icon: 'socicon-linkedin'
        }, {
            name: 'GitHub',
            icon: 'socicon-github'
        }, {
            name: 'StackOverflow',
            icon: 'socicon-stackoverflow'
        }];
        $scope.socialProfiles = user.social || social;

        var techs = [{
                "id": 1,
                "name": "javascript"
            }

        ];
        $scope.techs = user.techs || techs;


        $scope.update = function(profile) {
            // update user details using the form in view.
            var techs = JSON.parse(JSON.stringify($scope.techs));

            var social = JSON.parse(JSON.stringify($scope.socialProfiles));

            if (!$scope.data.goals) {
                $scope.data.goals = "future goals here";

            }
            var sc = JSON.stringify($scope.socialProfiles);
            var name = AuthenticationService.getUser();

            var internDetails = $scope.data;
            internDetails.profile = profile || $scope.data.profile;
            internDetails.social = social;
            internDetails.techs = techs;
            internDetails.id = name;

            $http({
                method: 'POST',
                url: IG.api + 'users/user',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: internDetails
            }).then(function successCallback(response) {
                if (response.data.status == "success") {
                    toastr.success('Your information has been saved successfully!', 'Success');
                } else {
                    toastr.error('response.data', 'ERROR');
                }
            }, function errorCallback(response) {
                toastr.error(response.data);
            });


        };

        $scope.unconnect = function(item) {
            item.href = undefined;
        };

        $scope.showModal = function(item) {
            $uibModal.open({
                animation: true,
                controller: 'ProfileModalCtrl',
                templateUrl: 'app/pages/profile/partials/profileModal.html'
            }).result.then(function(link) {
                item.href = link;
            });
        };

        $scope.getFile = function() {
            fileReader.readAsDataUrl($scope.file, $scope)
                .then(function(result) {
                    $scope.picture = result;
                });
        };

        $scope.showGroup = function(user) {
            if (tech.group && $scope.groups.length) {
                var selected = $filter('filter')($scope.groups, {
                    id: tech.group
                });
                return selected.length ? selected[0].text : 'Not set';
            } else return 'Not set';
        };

        $scope.showStatus = function(user) {
            var selected = [];
            if (tech.status) {
                selected = $filter('filter')($scope.statuses, {
                    value: tech.status
                });
            }
            return selected.length ? selected[0].text : 'Not set';
        };


        $scope.removeUser = function(index) {
            $scope.techs.splice(index, 1);
        };

        $scope.addUser = function() {
            $scope.inserted = {
                id: $scope.techs.length + 1,
                name: '',
                status: null,
                group: null
            };
            $scope.techs.push($scope.inserted);
        };

        editableOptions.theme = 'bs3';
        editableThemes['bs3']
            .submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
        editableThemes['bs3']
            .cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

    }

})();

(function() {
    'use strict';

    angular.module('BlurAdmin.signin')
        .controller('SignInCtrl', ['$scope', '$state', 'AuthenticationService', 'toastr', 'serviceAPI', 'commonService', function($scope, $state, AuthenticationService, toastr, serviceAPI, commonService){
            $scope.data={username:'', clave:''};
            $scope.signIn = function() {
                serviceAPI.signIn($scope.data).success(function(r){
                    AuthenticationService.setLoggedIn(r.auth);
                    if(r.auth){
                        serviceAPI.infoEmpresa().success(function(r){
                            if(r.success && r.num_rows==1){ commonService.setEmpresa(r.data);}
                        });
                        serviceAPI.getConfig().success(function(r){
                            if(r.success && r.num_rows==1){ commonService.setConfig(r.data);}
                        });
                        AuthenticationService.setRol(r.rows.nom_rol);
                        AuthenticationService.setUser($scope.data.username);
                        AuthenticationService.setToken(r.token);
                        AuthenticationService.setStates(r.rows.states);
                        $state.go('dashboard', {defaultState: r.rows.name_state});
                    }else{
                        toastr.error("Datos de acceso inválidos", 'Error');
                    }
                });
            };  
        }]);

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.tables')
      .controller('TablesPageCtrl', TablesPageCtrl);

  /** @ngInject */
  function TablesPageCtrl($scope, $filter, editableOptions, editableThemes) {

    $scope.smartTablePageSize = 10;

    $scope.smartTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45'
      }  
   
    ];

    $scope.editableTableData = $scope.smartTableData.slice(0, 36);

    $scope.peopleTableData = [
      {
        id: 1,
        firstName: 'Mark',
        lastName: 'Otto',
        username: '@mdo',
        email: 'mdo@gmail.com',
        age: '28',
        status: 'info'
      },
      {
        id: 2,
        firstName: 'Jacob',
        lastName: 'Thornton',
        username: '@fat',
        email: 'fat@yandex.ru',
        age: '45',
        status: 'primary'
      },
      {
        id: 3,
        firstName: 'Larry',
        lastName: 'Bird',
        username: '@twitter',
        email: 'twitter@outlook.com',
        age: '18',
        status: 'success'
      },
      {
        id: 4,
        firstName: 'John',
        lastName: 'Snow',
        username: '@snow',
        email: 'snow@gmail.com',
        age: '20',
        status: 'danger'
      },
      {
        id: 5,
        firstName: 'Jack',
        lastName: 'Sparrow',
        username: '@jack',
        email: 'jack@yandex.ru',
        age: '30',
        status: 'warning'
      }
    ];

    $scope.metricsTableData = [
      {
        image: 'app/browsers/chrome.svg',
        browser: 'Google Chrome',
        visits: '10,392',
        isVisitsUp: true,
        purchases: '4,214',
        isPurchasesUp: true,
        percent: '45%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/firefox.svg',
        browser: 'Mozilla Firefox',
        visits: '7,873',
        isVisitsUp: true,
        purchases: '3,031',
        isPurchasesUp: false,
        percent: '28%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/ie.svg',
        browser: 'Internet Explorer',
        visits: '5,890',
        isVisitsUp: false,
        purchases: '2,102',
        isPurchasesUp: false,
        percent: '17%',
        isPercentUp: false
      },
      {
        image: 'app/browsers/safari.svg',
        browser: 'Safari',
        visits: '4,001',
        isVisitsUp: false,
        purchases: '1,001',
        isPurchasesUp: false,
        percent: '14%',
        isPercentUp: true
      },
      {
        image: 'app/browsers/opera.svg',
        browser: 'Opera',
        visits: '1,833',
        isVisitsUp: true,
        purchases: '83',
        isPurchasesUp: true,
        percent: '5%',
        isPercentUp: false
      }
    ];

    $scope.users = [
      {
        "id": 1,
        "name": "Esther Vang",
        "status": 4,
        "group": 3
      },
      {
        "id": 2,
        "name": "Leah Freeman",
        "status": 3,
        "group": 1
      },
      {
        "id": 3,
        "name": "Mathews Simpson",
        "status": 3,
        "group": 2
      },
      {
        "id": 4,
        "name": "Buckley Hopkins",
        "group": 4
      },
      {
        "id": 5,
        "name": "Buckley Schwartz",
        "status": 1,
        "group": 1
      },
      {
        "id": 6,
        "name": "Mathews Hopkins",
        "status": 4,
        "group": 2
      },
      {
        "id": 7,
        "name": "Leah Vang",
        "status": 4,
        "group": 1
      },
      {
        "id": 8,
        "name": "Vang Schwartz",
        "status": 4,
        "group": 2
      },
      {
        "id": 9,
        "name": "Hopkin Esther",
        "status": 1,
        "group": 2
      },
      {
        "id": 10,
        "name": "Mathews Schwartz",
        "status": 1,
        "group": 3
      }
    ];

    $scope.statuses = [
      {value: 1, text: 'Good'},
      {value: 2, text: 'Awesome'},
      {value: 3, text: 'Excellent'},
    ];

    $scope.groups = [
      {id: 1, text: 'user'},
      {id: 2, text: 'customer'},
      {id: 3, text: 'vip'},
      {id: 4, text: 'admin'}
    ];

    $scope.showGroup = function(user) {
      if(user.group && $scope.groups.length) {
        var selected = $filter('filter')($scope.groups, {id: user.group});
        return selected.length ? selected[0].text : 'Not set';
      } else return 'Not set'
    };

    $scope.showStatus = function(user) {
      var selected = [];
      if(user.status) {
        selected = $filter('filter')($scope.statuses, {value: user.status});
      }
      return selected.length ? selected[0].text : 'Not set';
    };


    $scope.removeUser = function(index) {
      $scope.users.splice(index, 1);
    };

    $scope.addUser = function() {
      $scope.inserted = {
        id: $scope.users.length+1,
        name: '',
        status: null,
        group: null
      };
      $scope.users.push($scope.inserted);
    };

    editableOptions.theme = 'bs3';
    editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
    editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


  }

})();

/**
 * @author v.lugovksy
 * created on 15.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .config(toastrLibConfig);

  /** @ngInject */
  function toastrLibConfig(toastrConfig) {
    angular.extend(toastrConfig, {
      closeButton: true,
      closeHtml: '<button>&times;</button>',
      timeOut: 5000,
      autoDismiss: false,
      containerId: 'toast-container',
      maxOpened: 0,
      newestOnTop: true,
      positionClass: 'toast-top-right',
      preventDuplicates: false,
      preventOpenDuplicates: false,
      target: 'body'
    });
  }
})();
/**
 * Change top "Daily Downloads", "Active Users" values with animation effect
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('animatedChange', animatedChange);

  /** @ngInject */
  function animatedChange($timeout) {
    return {
      link: function (scope, element) {
        $timeout(function () {
          var newValue = element.attr('new-value');
          var oldvalue = parseInt(element.html());

          function changeValue(val) {
            $timeout(function () {
              element.html(val);
            }, 30);
          }

          if (newValue > oldvalue) {
            for (var i = oldvalue; i <= newValue; i++) {
              changeValue(i);
            }
          } else {
            for (var j = oldvalue; j >= newValue; j--) {
              changeValue(j);
            }
          }
          $timeout(function () {
            element.next().find('i').addClass('show-arr');
          }, 500);
        }, 3500);
      }
    };
  }

})();
/**
 * Auto expand textarea field
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoExpand', autoExpand);

  /** @ngInject */
  function autoExpand() {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        elem.bind('keydown', function ($event) {
          var element = $event.target;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        });

        // Expand the textarea as soon as it is added to the DOM
        setTimeout(function () {
          var element = elem;
          $(element).height(0);
          var height = $(element)[0].scrollHeight;
          height = (height < 16) ? 16 : height;
          $(element).height(height);
        }, 0)
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('autoFocus', autoFocus);

  /** @ngInject */
  function autoFocus($timeout, $parse) {
    return {
      link: function (scope, element, attrs) {
        var model = $parse(attrs.autoFocus);
        scope.$watch(model, function (value) {
          if (value === true) {
            $timeout(function () {
              element[0].focus();
              element[0].select();
            });
          }
        });
        element.bind('blur', function () {
          scope.$apply(model.assign(scope, false));
        });
      }
    };
  }

})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('includeWithScope', includeWithScope);

  /** @ngInject */
  function includeWithScope() {
    return {
      restrict: 'AE',
      templateUrl: function(ele, attrs) {
        return attrs.includeWithScope;
      }
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.theme')
        .directive('tagInput', tagInput);
  
    /** @ngInject */
    function tagInput() {
      return {
        restrict: 'A',
        link: function( $scope, elem, attr) {
          $(elem).tagsinput({
            tagClass:  'label label-' + attr.tagInput
          });
        }
      };
    }
  })();
/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .directive('ionSlider', ionSlider);

  /** @ngInject */
  function ionSlider($timeout) {
    return {
      restrict: 'EA',
      template: '<div></div>',
      replace: true,
      scope: {
        min: '=',
        max: '=',
        type: '@',
        prefix: '@',
        maxPostfix: '@',
        prettify: '=',
        prettifySeparator: '@',
        grid: '=',
        gridMargin: '@',
        postfix: '@',
        step: '@',
        hideMinMax: '@',
        hideFromTo: '@',
        from: '=',
        to: '=',
        disable: '=',
        onChange: '=',
        onFinish: '=',
        values: '=',
        timeout: '@'
      },
      link: function ($scope, $element) {
            $element.ionRangeSlider({
              min: $scope.min,
              max: $scope.max,
              type: $scope.type,
              prefix: $scope.prefix,
              maxPostfix: $scope.maxPostfix,
              prettify_enabled: $scope.prettify,
              prettify_separator: $scope.prettifySeparator,
              grid: $scope.grid,
              gridMargin: $scope.gridMargin,
              postfix: $scope.postfix,
              step: $scope.step,
              hideMinMax: $scope.hideMinMax,
              hideFromTo: $scope.hideFromTo,
              from: $scope.from,
              to: $scope.to,
              disable: $scope.disable,
              onChange: $scope.onChange,
              onFinish: $scope.onFinish,
              values: $scope.values
            });

            $scope.$watch('min', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({min: value});
              });
            }, true);
            $scope.$watch('max', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({max: value});
              });
            });
            $scope.$watch('from', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({from: value});
              });
            });
            $scope.$watch('to', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({to: value});
              });
            });
            $scope.$watch('disable', function (value) {
              $timeout(function () {
                $element.data("ionRangeSlider").update({disable: value});
              });
            });
      }
    };
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('ngFileSelect', ngFileSelect);

  /** @ngInject */
  function ngFileSelect() {
    return {
      link: function ($scope, el) {
        el.bind('change', function (e) {
          $scope.file = (e.srcElement || e.target).files[0];
          $scope.getFile();
        })
      }
    }
  }

})();
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('scrollPosition', scrollPosition);

  /** @ngInject */
  function scrollPosition() {
    return {
      scope: {
        scrollPosition: '=',
        maxHeight: '='
      },
      link: function (scope) {
        $(window).on('scroll', function() {
          var scrollTop = $(window).scrollTop() > scope.maxHeight;
          if (scrollTop !== scope.prevScrollTop) {
            scope.$apply(function() {
              scope.scrollPosition = scrollTop;
            });
          }
          scope.prevScrollTop = scrollTop;
        });
      }
    };
  }

})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.theme')
        .directive('selectCargos', selectCargos);
  
    /** @ngInject */
    function selectCargos(getservice) {
        return {
            restrict:'A', scope:{cargos:'='}, require:'ngModel',
            link:function(scope, element, attrs, model){
                model.$render=function(){
                };
                angular.element(element).on('change', function(){
                    scope.cargos=[];
                    getservice.getCargos(model.$viewValue).then(function(response){
                        scope.cargos=response.data.cpuestos;
                    });
                });
            }
        }
    } 
   
  })();

(function () {
    'use strict';
  
    angular.module('BlurAdmin.theme')
        .directive('selectDepartamentos', selectDepartamentos);
  
    /** @ngInject */
    function selectDepartamentos(getservice) {
        return {
            restrict:'A', scope:{provincias:'=', distritos:'='  }, require:'ngModel',
            link:function(scope, element, attrs, model){
                model.$render=function(){
                };
                angular.element(element).on('change', function(){
                    scope.provincias=[];
                    scope.distritos=[];
                    getservice.getProvincias(model.$viewValue).then(function(response){
                        scope.provincias=response.data.cprovincia;
                    });
                });
            }
        }
    } 
   
  })();
  //calmate perrote dejame quitarte esos errores

(function () {
    'use strict';
  
    angular.module('BlurAdmin.theme')
        .directive('selectDistritos', selectDistritos);
  
    /** @ngInject */
    function selectDistritos(getservice) {
        return {
            restrict:'A', scope:{distritos:'='}, require:'ngModel',
            link:function(scope, element, attrs, model){
                angular.element(element).on('change', function(){
                    scope.distritos=[];
                    getservice.getDistritos(model.$viewValue).then(function(response){
                        scope.distritos=response.data.cdistrito;
                    });

                });
            }
        }
    }
  
  })();

(function () {
    'use strict';
  
    angular.module('BlurAdmin.theme')
        .directive('selectProvincias', selectProvincias);
  
    /** @ngInject */
    function selectProvincias(getservice) {
        return {
            restrict:'A', scope:{distritos:'='}, require:'ngModel',
            link:function(scope, element, attrs, model){
                angular.element(element).on('change', function(){
                    scope.distritos=[], scope.provincias=[];
                    getservice.getDistritos(model.$viewValue).then(function(response){
                        console.log(response.data)
                        scope.distritos=response.data.cdistrito;
                    });
            });
            }
        }
    }
  
  })();

(function () {
    'use strict';
  
    angular.module('BlurAdmin.theme')
        .directive('selectRegimen', selectRegimen);
  
    /** @ngInject */
    function selectRegimen(getservice) {
        return {
            restrict:'A', scope:{primas:'='}, require:'ngModel',
            link:function(scope, element, attrs, model){
                model.$render=function(){
                };
                angular.element(element).on('change', function(){
                    scope.primas=[];
                    console.log(model.$viewValue)
                    getservice.getPrimas(model.$viewValue).then(function(response){
                        scope.primas=response.data.cprimas;
        
                    });
                });
            }
        }
    } 
   
  })();
 
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('trackWidth', trackWidth);

  /** @ngInject */
  function trackWidth() {
    return {
      scope: {
        trackWidth: '=',
        minWidth: '=',
      },
      link: function (scope, element) {
        scope.trackWidth = $(element).width() < scope.minWidth;
        scope.prevTrackWidth = scope.trackWidth;

        $(window).resize(function() {
          var trackWidth = $(element).width() < scope.minWidth;
          if (trackWidth !== scope.prevTrackWidth) {
            scope.$apply(function() {
              scope.trackWidth = trackWidth;
            });
          }
          scope.prevTrackWidth = trackWidth;
        });
      }
    };
  }

})();
/**
 * Animated load block
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('zoomIn', zoomIn);

  /** @ngInject */
  function zoomIn($timeout, $rootScope) {
    return {
      restrict: 'A',
      link: function ($scope, elem) {
        var delay = 1000;

        if ($rootScope.$pageFinishedLoading) {
          delay = 100;
        }

        $timeout(function () {
          elem.removeClass('full-invisible');
          elem.addClass('animated zoomIn');
        }, delay);
      }
    };
  }

})();
/**
 * @author n.poltoratsky
 * created on 27.06.2016
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme')
        .factory('baProgressModal', baProgressModal);

    /** @ngInject */
    function baProgressModal($uibModal) {
        var methods = {};
        var progress = 0;
        var max = 100;
        var opened = false;

        return {
            setProgress: function (value) {
                if (value > max) {
                    throw Error('Progress can\'t be greater than max');
                }
                progress = value;
            },
            getProgress: function () {
                return progress;
            },
            open: function() {
                if (!opened) {
                    methods = $uibModal.open({
                        animation: true,
                        templateUrl: 'app/pages/ui/modals/progressModal/progressModal.html',
                        size: 'sm',
                        keyboard: false,
                        backdrop: 'static'
                    });
                    opened = true;
                } else {
                    throw Error('Progress modal opened now');
                }

            },
            close: function() {
                if (opened) {
                    methods.close();
                    opened = false;
                } else {
                    throw Error('Progress modal is not active');
                }

            }
        };
    }

})();
/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baUtil', baUtil);

  /** @ngInject */
  function baUtil() {

    this.isDescendant = function(parent, child) {
      var node = child.parentNode;
      while (node != null) {
        if (node == parent) {
          return true;
        }
        node = node.parentNode;
      }
      return false;
    };

    this.hexToRGB = function(hex, alpha) {
      var r = parseInt( hex.slice(1,3), 16 );
      var g = parseInt( hex.slice(3,5), 16 );
      var b = parseInt( hex.slice(5,7), 16 );
      return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    }
  }
})();

(function() {
    'use strict';

    angular.module('BlurAdmin.facturaservice', [])
        .factory('facturaservice', facturaservice);

    /** @ngInject */
    function facturaservice($http, $httpParamSerializerJQLike) {
            var datas={};
            
            datas.getFacturas=function(id_anio, id_mes){
				return $http({
					url:'http://tlm.localhost/api/controller/rrhh/controller.facturas.php', method:"POST", data:$httpParamSerializerJQLike({oper:'facturas',id_anio:id_anio,id_mes:id_mes}),
					headers:{'Content-Type':'application/x-www-form-urlencoded'}
				});
			};
			return datas;
    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('fileReader', fileReader);

  /** @ngInject */
  function fileReader($q) {
    var onLoad = function(reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.resolve(reader.result);
        });
      };
    };

    var onError = function (reader, deferred, scope) {
      return function () {
        scope.$apply(function () {
          deferred.reject(reader.result);
        });
      };
    };

    var onProgress = function(reader, scope) {
      return function (event) {
        scope.$broadcast('fileProgress',
            {
              total: event.total,
              loaded: event.loaded
            });
      };
    };

    var getReader = function(deferred, scope) {
      var reader = new FileReader();
      reader.onload = onLoad(reader, deferred, scope);
      reader.onerror = onError(reader, deferred, scope);
      reader.onprogress = onProgress(reader, scope);
      return reader;
    };

    var readAsDataURL = function (file, scope) {
      var deferred = $q.defer();

      var reader = getReader(deferred, scope);
      reader.readAsDataURL(file);

      return deferred.promise;
    };

    return {
      readAsDataUrl: readAsDataURL
    };
  }
})();
/**
 * @author a.demeshko
 * created on 3/1/16
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('preloader', preloader);

  /** @ngInject */
  function preloader($q) {
    return {
      loadImg: function (src) {
        var d = $q.defer();
        var img = new Image();
        img.src = src;
        img.onload = function(){
          d.resolve();
        };
        return d.promise;
      },
      loadAmCharts : function(){
        var d = $q.defer();
        AmCharts.ready(function(){
          d.resolve();
        });
        return d.promise;
      }
    }
  }

})();
/**
 * @author a.demeshko
 * created on 12/21/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .service('stopableInterval', stopableInterval);

  /** @ngInject */
  function stopableInterval($window) {
    return {
      start: function (interval, calback, time) {
        function startInterval() {
          return interval(calback, time);
        }

        var i = startInterval();

        angular.element($window).bind('focus', function () {
          if (i) interval.cancel(i);
          i = startInterval();
        });

        angular.element($window).bind('blur', function () {
          if (i) interval.cancel(i);
        });
      }
    }
  }

})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.almacen.almacenes', [])
      .controller('almacenesCtrl', ['$scope', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', function ($scope, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log) {
        
        var vm=this;
        $scope.default={id_almacen:0, no_almacen:'',il_stado:''};
        $scope.data={id_almacen:0, no_almacen:'',il_stado:''};

        $scope.displayed = []; 
  
        $scope.callServer = function (tableState) {
          var params = angular.extend({}, tableState.pagination, tableState.search);
          serviceAPI.getAlmacenes(params).success(function (r) {
            if (r.success && r.totalItemCount > 0) {
              $scope.displayed = r.rows;
              tableState.pagination.numberOfPages = r.numberOfPages;
            }
          })
        };

        $scope.changeStatus = function (idalmacen, actividad, index) {
          console.log('entro');
          serviceAPI.cambiarStatusAlmacen({ id: idalmacen, il_stado: actividad }).success(function (r) {
              console.log(r);
              var typenotify = 'error';
              if (r.num_rows == 0) {
                  typenotify = 'warning';
                  $scope.displayed = $scope.displayed.filter(function (i) { return (i.id_almacen != idalmacen); })
              }
              if (r.affected_rows == 1) {
                  typenotify = 'success';
                  $scope.displayed[index].il_stado = r.rows.il_stado;
              }
              toastr[typenotify](r.messages, 'Listado de Almacen');
          });
      };

      $scope.guardar = function (eForm) {
          $scope.displayed = [];
          serviceAPI.guardarAlmacen($scope.data).success(function (r) {
              var typeNotification = 'error';
              if (r.success) {
                  typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
              }
              toastr[typeNotification](r.messages, 'Registro de Almacen Correctamente');
              angular.extend($scope.data, $scope.default);
              eForm.$setPristine();
              eForm.$setUntouched();
              $scope.callServer([]);
          });
      };

      $scope.editar = function (value) {
          $scope.data = value;
      };
  
      }])
  })();
(function () {
  'use strict';
  angular.module('BlurAdmin.pages.almacen.notaingreso', [])
    .controller('notaingresolistCtrl', ['$scope', 'serviceAPI', '$state', 'baConfig', '$element', 'layoutPaths', function ($scope, serviceAPI, $state, baConfig, $element, layoutPaths) {
      $scope.displayed = [];

      $scope.callServer = function (tableState) {
        var params = angular.extend({}, tableState.pagination, tableState.search);
        serviceAPI.getNotaIngreso(params).success(function (r) {
          if (r.success && r.totalItemCount > 0) {
            $scope.displayed = r.rows;
            tableState.pagination.numberOfPages = r.numberOfPages;
          }
        })
      };

      $scope.agregar = function () {
        $state.go('dashboard.almacen.notaingreso-details');
      };
      $scope.editar = function (id_cliente) {
        $state.go('dashboard.almacen.notaingreso-details', { idNotaIngreso: id_nota_ingreso });
      };

    }])
    .controller('notaingresoCtrl', ['$scope', '$uibModal', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', 'editableOptions', 'editableThemes', function ($scope, $uibModal, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log, editableOptions, editableThemes) {
      var vm = this;
      $scope.default = {id_almacen_ingreso:0,id_tipo_comprobante:0, id_almacen_origen:0, id_almacen_destino:0, fe_ingreso:'',nu_serie:'', nu_correlativo:'', no_motivo:'', il_stado:0, id_nota_ingreso: 0 };
      $scope.data = { id_almacen_ingreso:0,id_tipo_comprobante:0, id_almacen_origen:0, id_almacen_destino:0, fe_ingreso:'',nu_serie:'', nu_correlativo:'', no_motivo:'', il_stado:0, id_nota_ingreso: 0 };
      $scope.detalleCompra = [];

      $scope.jComprobante = [];
      $scope.jAlmacenOrigen = [];
      $scope.jAlmacenDestino = [];
      $scope.jAlmacenOrdenAlmacen = [];

      serviceAPI.getAlmacenOrigen().success(function (r) {
        if (r.totalItemCount > 0 && r.success) {
          angular.extend($scope.jAlmacenOrigen, r.rows);
        }
      });
      serviceAPI.getAlmacenDestino().success(function (r) {
        if (r.totalItemCount > 0 && r.success) {
          angular.extend($scope.jAlmacenDestino, r.rows);
        }
      });

      serviceAPI.getComprobanteIngreso().success(function (r) {
        if (r.success && r.totalItemCount > 0) {
          angular.extend($scope.jComprobante, r.rows);
        }
      });

      $scope.getAlmacenOrden = function(value){
        serviceAPI.consultarAlmacenOrden(value).then(function (r) {
          console.log(r);
          if (r.data.success && r.data.totalItemCount > 0) {
            angular.extend($scope.jAlmacenOrdenAlmacen, r.data.rows);
          }
        });
      }


      $scope.getCorrelativo = function (value) {
        serviceAPI.consultarCorrelativo(value).then(function (r) {
          if (r.data.success && r.data.num_rows == 1) {
            console.log(r);
            $scope.data.nu_serie = r.data.rows.nu_serie;
            $scope.data.nu_correlativo = $scope.zfill(r.data.rows.nu_correlativo, 8);
          }
        });
      }

      $scope.zfill = function (number, width) {
        var numberOutput = Math.abs(number); /* Valor absoluto del número */
        var length = number.toString().length; /* Largo del número */
        var zero = "0"; /* String de cero */

        if (width <= length) {
          if (number < 0) {
            return ("-" + numberOutput.toString());
          } else {
            return numberOutput.toString();
          }
        } else {
          if (number < 0) {
            return ("-" + (zero.repeat(width - length)) + numberOutput.toString());
          } else {
            return ((zero.repeat(width - length)) + numberOutput.toString());
          }
        }
      }

            $scope.rowCollection = [];
            $scope.id_coti = 0;
            var k = 0;

            $scope.addItem = function () {                
                serviceAPI.getAlmacenOrdenDetalle($scope.data).then(function (r) {
                    console.log(r);
                    var listaAlmacenOrden = [];
                    var typeNotification = 'error';
                    if (r.data.success && r.data.totalItemCount > 0) {
                        typeNotification = (r.data.affected_rows != 0) ? 'success' : 'warning';
                        angular.extend(listaAlmacenOrden, r.data.rows);
                        for (var i = 0; i < listaAlmacenOrden.length; i++) {
                            var item = listaAlmacenOrden[i];
                            $scope.rowCollection.push(_.extend({
                                id: ++k,
                                id_almacen_insumo: item.id_almacen_insumo,
                                id_compra_cabecera: item.id_compra_cabecera,
                                id_compra_detalle: item.id_compra_detalle,
                                nu_serie : item.nu_serie,
                                nu_correlativo: item.nu_correlativo,
                                id_producto: item.id_producto,
                                no_producto: item.no_producto,
                                co_producto: item.co_producto,
                                nu_cantidad: item.nu_cantidad
                            },
                                item)
                            );
                        }
                    }
                    toastr[typeNotification](r.messages, 'Se Agrego Correctamente la Cotización');
                })
            };

            
            $scope.guardar = function () {
              var params = { orden: $scope.data, detalle: $scope.rowCollection };
              serviceAPI.guardarNotaIngreso(params).success(function (r) {
                  var typeNotification = 'error';
                  if (r.success) {
                      typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                  }
                  toastr[typeNotification](r.messages, 'Registro de Nota Ingreso');
                  angular.extend($scope.data, $scope.default);
                  $scope.rowCollection = [];
              });
          };


            editableOptions.theme = 'bs3';
            editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
            editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';


            $scope.consultar = function () {
              if ($stateParams.idNotaIngreso != '') {                    
                  serviceAPI.consultaNotaIngreso({ id: $stateParams.idNotaIngreso }).success(function (r) { 
                    console.log(r);                   
                      var typeNotification = (!r.success) ? 'error' : 'warning';
                      if (r.success && r.num_rows == 1) {
                          typeNotification = 'success';
                          angular.extend($scope.data, r.rows);

                           $scope.jAlmacenOrigen.map(function (b) {
                             console.log(b);
                              if (b.id_almacen == r.rows.id_almacen_origen) { $scope.data.id_almacen_origen = b; }
                          });
                          $scope.jAlmacenDestino.map(function (c) {
                              if (c.id_almacen == r.rows.id_almacen_destino) { $scope.data.id_almacen_destino = c; }
                          });
                          $scope.jComprobante.map(function (d) {
                              if (d.id_medida == r.rows.id_medida) { $scope.data.id_medida = d; }
                          });                   
                          
                      }
                      toastr[typeNotification](r.messages, 'Información de Nota');
                  });
              }
          };



    }]);
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.almacen.notasalida', [])
      .controller('notasalidalistCtrl', ['$scope', 'serviceAPI', '$state', 'baConfig', '$element', 'layoutPaths', function ($scope, serviceAPI, $state, baConfig, $element, layoutPaths) {
        $scope.displayed = []; 
  
        $scope.callServer = function (tableState) {
          var params = angular.extend({}, tableState.pagination, tableState.search);
          serviceAPI.getnotasalida(params).success(function (r) {
            if (r.success && r.totalItemCount > 0) {
              $scope.displayed = r.rows;
              tableState.pagination.numberOfPages = r.numberOfPages;
            }
          })
        };
  
      }])
      .controller('notasalidaCtrl', ['$scope', '$uibModal', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', function ($scope, $uibModal, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log) {
        var vm = this;
        $scope.default = { id_nota_ingreso:0};
        $scope.data = {id_nota_ingreso:0 };
        $scope.detalleCompra = [];  
  
      }]);
  })();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.catalogo.atributo', [])
        .controller('modalAtributoCtrl', ['$scope','serviceAPI','toastr', 'item', '$http', '$httpParamSerializerJQLike', '$uibModalInstance', function ($scope,serviceAPI,toastr, item, $http, $httpParamSerializerJQLike, $uibModalInstance) {
            $scope.data = { id_atributo: 0, no_atributo: '' ,id_parent_atributo:0, no_sub_atributo: '' };
            $scope.default = { id_atributo: 0, no_atributo: '' ,id_parent_atributo:0, no_sub_atributo: '' };
            $scope.item = $scope.$parent.item || false;
            $scope.carea = [];
            $scope.cerrar = function() {
                $uibModalInstance.close();
            }
            $scope.jAtributo=[];

            serviceAPI.listAtributo().success(function(r){
                if(r.success && r.totalItemCount>0){
                    angular.extend($scope.jAtributo, r.rows);
                }
            });
            $scope.GuardarAtributo=function(value){
                serviceAPI.guardarAtributo(value).success(function(r){
                    var typeNotification='error';
                    if(r.success){
                        typeNotification=(r.affected_rows!=0)?'success':'warning';
                    }
                    toastr[typeNotification](r.messages, 'Registro de Atributo');
                    angular.extend($scope.data, $scope.default);
                    $uibModalInstance.close(value);
                });
            }

            $scope.GuardarSubAtributo=function(value){
                serviceAPI.guardarSubAtributo(value).success(function(r){
                    var typeNotification='error';
                    if(r.success){
                        typeNotification=(r.affected_rows!=0)?'success':'warning';
                    }
                    toastr[typeNotification](r.messages, 'Registro de Sub Atributo');
                    angular.extend($scope.data, $scope.default);
                    $uibModalInstance.close(value);
                });
            }


        }])
        .controller('atributoCtrl', ['$scope', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', '$uibModal', 'editableThemes', 'editableOptions', function ($scope, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log, $uibModal, editableThemes, editableOptions) {
            $scope.data = { id_atributo: 0, no_atributo: '' ,id_sub_atributo:0, no_sub_atributo: '' };
            $scope.default = { id_atributo: 0, no_atributo: '' ,id_sub_atributo:0, no_sub_atributo: '' };
            $scope.catributo = [];
            $scope.csubatributo = [];
            $scope.editableTableArea = $scope.catributo.slice(0, 36);
            $scope.editableTableCargo = $scope.csubatributo.slice(0, 36);
            $scope.smartTablePageSize = 8;


            serviceAPI.getAtributo().then(function (r) {
                if (r.data.totalItemCount > 0 && r.data.success) {
                    $scope.catributo = r.data.rows;
                }
            })

            serviceAPI.getSubAtributo().then(function (r) {
                if (r.data.totalItemCount > 0 && r.data.success) {
                    $scope.csubatributo = r.data.rows;
                }
            })

            $scope.listarAtributo = function () {
                $scope.catributo=[];
                serviceAPI.getAtributo().then(function (r) {
                    if (r.data.totalItemCount > 0 && r.data.success) {
                        $scope.catributo = r.data.rows;
                    }
                })
            }

            $scope.listarSubAtributo = function () {
                $scope.csubatributo=[];
                serviceAPI.getSubAtributo().then(function (r) {
                    if (r.data.totalItemCount > 0 && r.data.success) {
                        $scope.csubatributo = r.data.rows;
                    }
                })
            }

            

            $scope.openAtributo = function (size) {
                $uibModal.open({
                    animation: true,
                    templateUrl: 'app/pages/catalogo/atributo/modal/modal_atributo.html',
                    controller: 'modalAtributoCtrl',
                    backdrop: 'static',
                    scope: $scope,
                    resolve: {
                        item: function () { }
                    }
                }).result.then(function (data) {
                    $scope.listarAtributo();
                });
            };

            $scope.openSubAtributo = function (size) {
                $uibModal.open({
                    animation: true,
                    templateUrl: 'app/pages/catalogo/atributo/modal/modal_sub_atributo.html',
                    controller: 'modalAtributoCtrl',
                    backdrop: 'static',
                    keyboard: false,
                    scope: $scope,
                    resolve: {
                        item: function () { }
                    }
                }).result.then(function (data) {
                    $scope.listarSubAtributo();
                });
            };

            $scope.GuardarAtributo=function(data,item){
                $scope.data = item;
                serviceAPI.guardarAtributo($scope.data).success(function(r){
                    var typeNotification='error';
                    if(r.success){
                        typeNotification=(r.affected_rows!=0)?'success':'warning';
                    }
                    toastr[typeNotification](r.messages, 'Registro de Area');
                    angular.extend($scope.data, $scope.default);
                    $scope.listarAtributo();
                });
            }

            $scope.guardarSubAtributo=function(data,item){
                $scope.data = item
                serviceAPI.guardarSubAtributo($scope.data).success(function(r){
                    var typeNotification='error';
                    if(r.success){
                        typeNotification=(r.affected_rows!=0)?'success':'warning';
                    }
                    toastr[typeNotification](r.messages, 'Registro de Area');
                    angular.extend($scope.data, $scope.default);
                    $scope.listarSubAtributo();
                });
            }


            editableOptions.theme = 'bs3';
            editableThemes['bs3'].submitTpl = '<button type="submit" ng-click="calcular(afp)" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
            editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-danger btn-with-icon"><i class="ion-close-round"></i></button>';

        }]);
})();
(function(){
    'use strict';
    angular.module('BlurAdmin.pages.catalogo.categoria', [])   
    .controller('categoriaCtrl', [ '$scope', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', function($scope, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log){
        var vm=this;
        $scope.default={id_categoria:0, no_categoria:'',status:''};
        $scope.data={id_categoria:0, no_categoria:'',status:''};

        $scope.displayed = [];
        $scope.callServer = function (tableState) {
            var params = angular.extend({}, tableState.pagination, tableState.search);
            serviceAPI.getCategoria(params).success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    $scope.displayed = r.rows;
                    tableState.pagination.numberOfPages = r.numberOfPages;
                }
            });
        };

        $scope.changeStatus = function (idcategoria, actividad, index) {
            console.log('entro');
            serviceAPI.cambiarStatusCategoria({ id: idcategoria, status: actividad }).success(function (r) {
                console.log(r);
                var typenotify = 'error';
                if (r.num_rows == 0) {
                    typenotify = 'warning';
                    $scope.displayed = $scope.displayed.filter(function (i) { return (i.id_categoria != idcategoria); })
                }
                if (r.affected_rows == 1) {
                    typenotify = 'success';
                    $scope.displayed[index].status = r.rows.status;
                }
                toastr[typenotify](r.messages, 'Listado de Sucursal');
            });
        };

        $scope.guardar = function (eForm) {
            $scope.displayed = [];
            serviceAPI.guardarCategoria($scope.data).success(function (r) {
                var typeNotification = 'error';
                if (r.success) {
                    typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                }
                toastr[typeNotification](r.messages, 'Registro de Categoria Correctamente');
                angular.extend($scope.data, $scope.default);
                eForm.$setPristine();
                eForm.$setUntouched();
                $scope.callServer([]);
            });
        };

        $scope.editar = function (value) {
            $scope.data = value;
        };
     
    }]);
})();
(function(){
    'use strict';
    angular.module('BlurAdmin.pages.catalogo.cuponera', []) 
    .controller('modalcuponCtrl', ['$scope','serviceAPI','toastr', 'item', '$http', '$httpParamSerializerJQLike', '$uibModalInstance', function ($scope,serviceAPI,toastr, item, $http, $httpParamSerializerJQLike, $uibModalInstance) {
        $scope.data = { id_cupon: 0, co_cupon: '' ,no_resp_cupon:'',id_cupon_descuento:0,va_comision:0, va_descuento: '' };
        $scope.default = { id_cupon: 0, co_cupon: '',no_resp_cupon:'' ,id_cupon_descuento:0,va_comision:0, va_descuento: '' };
        $scope.item = $scope.$parent.item || false;
        $scope.cerrar = function() {
            $uibModalInstance.close();
        }
        $scope.jCupon=[];
        
        serviceAPI.getCupon().then(function (r) {
            if (r.data.totalItemCount > 0 && r.data.success) {
                angular.extend($scope.jCupon, r.data.rows);
            }
        })

        $scope.GuardarCupon=function(value){
            serviceAPI.guardarCupon(value).success(function(r){
                var typeNotification='error';
                if(r.success){
                    typeNotification=(r.affected_rows!=0)?'success':'warning';
                }
                toastr[typeNotification](r.messages, 'Registro de cupon');
                angular.extend($scope.data, $scope.default);
                $uibModalInstance.close(value);
            });
        }

        $scope.GuardarDescuento=function(value){
            serviceAPI.guardarDescuentoCupon(value).success(function(r){
                var typeNotification='error';
                if(r.success){
                    typeNotification=(r.affected_rows!=0)?'success':'warning';
                }
                toastr[typeNotification](r.messages, 'Registro de Descuento');
                angular.extend($scope.data, $scope.default);
                $uibModalInstance.close(value);
            });
        }

       


    }])
    .controller('ModalCuponCtrl', ['$scope', 'serviceAPI', '$state', '$uibModalInstance', function ($scope, serviceAPI, $state, $uibModalInstance) {
        $scope.displayed = [];
        $scope.callServer = function (tableState) {
            var params = angular.extend({}, tableState.pagination, tableState.search);
            serviceAPI.getCuponDescuento(params).success(function (r) {
              if (r.success && r.totalItemCount > 0) {
                $scope.displayed = r.rows;
                tableState.pagination.numberOfPages = r.numberOfPages;
              }
            });
          };
    
          $scope.obtenerProducto = function (value) {
            $uibModalInstance.close(value);
          };

    }])  
    .controller('cuponCtrl', [ '$scope', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', '$uibModal', 'editableThemes', 'editableOptions', function($scope, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log, $uibModal, editableThemes, editableOptions){
        var vm=this;
        $scope.default={id_cupon:0, co_cupon:'',status:'',no_resp_cupon:'',va_comision:0};
        $scope.data={id_cupon:0, co_cupon:'',status:'',no_resp_cupon:'',va_comision:0};

        $scope.displayed = [];
        $scope.displayed2 = [];

        serviceAPI.getCupon().then(function (r) {
            if (r.data.totalItemCount > 0 && r.data.success) {
                $scope.displayed = r.data.rows;
            }
        })

        serviceAPI.getDescuentoCupon().then(function (r) {
            if (r.data.totalItemCount > 0 && r.data.success) {
                $scope.displayed2 = r.data.rows;
            }
        })

        $scope.changeStatus = function (idcupon, actividad, index) {
            console.log('entro');
            serviceAPI.cambiarStatusCupon({ id: idcupon, status: actividad }).success(function (r) {
                console.log(r);
                var typenotify = 'error';
                if (r.num_rows == 0) {
                    typenotify = 'warning';
                    $scope.displayed = $scope.displayed.filter(function (i) { return (i.id_cupon != idcupon); })
                }
                if (r.affected_rows == 1) {
                    typenotify = 'success';
                    $scope.displayed[index].status = r.rows.status;
                }
                toastr[typenotify](r.messages, 'Listado de Sucursal');
            });
        };

        $scope.guardar = function (eForm) {
            $scope.displayed = [];
            serviceAPI.guardarCupon($scope.data).success(function (r) {
                var typeNotification = 'error';
                if (r.success) {
                    typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                }
                toastr[typeNotification](r.messages, 'Registro de Categoria Correctamente');
                angular.extend($scope.data, $scope.default);
                eForm.$setPristine();
                eForm.$setUntouched();
                $scope.callServer([]);
            });
        };


        $scope.GuardarCupon=function(data,item){
            $scope.data = item;
            serviceAPI.guardarCupon($scope.data).success(function(r){
                var typeNotification='error';
                if(r.success){
                    typeNotification=(r.affected_rows!=0)?'success':'warning';
                }
                toastr[typeNotification](r.messages, 'Registro de cupon');
                angular.extend($scope.data, $scope.default);
                $scope.listarCupon();
                $scope.listarDescuento();
            });
        }

        $scope.GuardarDescuento=function(data,item){
            $scope.data = item
            serviceAPI.guardarDescuentoCupon($scope.data).success(function(r){
                var typeNotification='error';
                if(r.success){
                    typeNotification=(r.affected_rows!=0)?'success':'warning';
                }
                toastr[typeNotification](r.messages, 'Registro de Descuento x cupon');
                angular.extend($scope.data, $scope.default);
                $scope.listarDescuento();
            });
        }

        $scope.editar = function (value) {
            $scope.data = value;
        };



        $scope.listarcupon = function () {
            $scope.displayed=[];
            serviceAPI.getCupon().then(function (r) {
                if (r.data.totalItemCount > 0 && r.data.success) {
                    $scope.displayed = r.data.rows;
                }
            })
        }

        $scope.listarDescuento = function () {
            $scope.displayed2=[];
            serviceAPI.getDescuentoCupon().then(function (r) {
                if (r.data.totalItemCount > 0 && r.data.success) {
                    $scope.displayed2 = r.data.rows;
                }
            })
        }



        $scope.openCupones = function (size) {
            console.log('entro');
            console.log(size);
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/catalogo/cuponera/modal/modal_cupon.html',
                controller: 'modalcuponCtrl',
                backdrop: 'static',
                scope: $scope,
                resolve: {
                    item: function () { }
                }
            }).result.then(function (data) {
                $scope.listarcupon();
            });
        };

        $scope.openDescuento = function (size) {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/catalogo/cuponera/modal/modal_descuento.html',
                controller: 'modalcuponCtrl',
                backdrop: 'static',
                keyboard: false,
                scope: $scope,
                resolve: {
                    item: function () { }
                }
            }).result.then(function (data) {
                $scope.listarDescuento();
            });
        };

     

        editableOptions.theme = 'bs3';
        editableThemes['bs3'].submitTpl = '<button type="submit" ng-click="calcular(afp)" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
        editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-danger btn-with-icon"><i class="ion-close-round"></i></button>';
     
    }]);
})();
(function(){
    'use strict';
    angular.module('BlurAdmin.pages.catalogo.descuento', []) 
    .controller('modalDescuentoCtrl', ['$scope','serviceAPI','toastr', 'item', '$http', '$httpParamSerializerJQLike', '$uibModalInstance', function ($scope,serviceAPI,toastr, item, $http, $httpParamSerializerJQLike, $uibModalInstance) {
        $scope.data = { id_cliente: 0, no_cliente: '' ,id_cliente_descuento:0, pr_descuento: '' };
        $scope.default = { id_cliente: 0, no_cliente: '',id_cliente_descuento:0, pr_descuento: '' };
        $scope.item = $scope.$parent.item || false;
        $scope.cerrar = function() {
            $uibModalInstance.close();
        }
        $scope.jCliente=[];
        
        serviceAPI.getClienteDistro().then(function (r) {
            if (r.data.totalItemCount > 0 && r.data.success) {
                angular.extend($scope.jCliente, r.data.rows);
            }
        })

        $scope.GuardarClienteDescuento=function(value){
            serviceAPI.guardarClienteDescuento(value).success(function(r){
                var typeNotification='error';
                if(r.success){
                    typeNotification=(r.affected_rows!=0)?'success':'warning';
                }
                toastr[typeNotification](r.messages, 'Registro de Descuento Cliente');
                angular.extend($scope.data, $scope.default);
                $uibModalInstance.close(value);
            });
        }
      


    }])
    .controller('descuentoCtrl', [ '$scope', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', '$uibModal', 'editableThemes', 'editableOptions', function($scope, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log, $uibModal, editableThemes, editableOptions){
        var vm=this;
        $scope.default={id_cliente:0, no_cliente:'',status:'',no_resp_cupon:'',va_comision:0};
        $scope.data={id_cliente:0, no_cliente:'',status:'',no_resp_cupon:'',va_comision:0};

        $scope.displayed = [];

        serviceAPI.getDescuentoCliente().then(function (r) {
            console.log(r);
            if (r.data.totalItemCount > 0 && r.data.success) {
                $scope.displayed = r.data.rows;
            }
        })


        $scope.guardar = function (eForm) {
            $scope.displayed = [];
            serviceAPI.guardarCupon($scope.data).success(function (r) {
                var typeNotification = 'error';
                if (r.success) {
                    typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                }
                toastr[typeNotification](r.messages, 'Registro de Categoria Correctamente');
                angular.extend($scope.data, $scope.default);
                eForm.$setPristine();
                eForm.$setUntouched();
                $scope.callServer([]);
            });
        };


        $scope.GuardarClienteDescuento=function(data,item){
            $scope.data = item
            serviceAPI.guardarClienteDescuento($scope.data).success(function(r){
                var typeNotification='error';
                if(r.success){
                    typeNotification=(r.affected_rows!=0)?'success':'warning';
                }
                toastr[typeNotification](r.messages, 'Registro de Descuento Cliente');
                angular.extend($scope.data, $scope.default);
                $scope.listarDescuento();
            });
        }

        $scope.editar = function (value) {
            $scope.data = value;
        };


        $scope.listarDescuento = function () {
            $scope.displayed=[];
            serviceAPI.getDescuentoCliente().then(function (r) {
                console.log(r);
                if (r.data.totalItemCount > 0 && r.data.success) {
                    $scope.displayed = r.data.rows;
                }
            })
        }

        $scope.openDescuento = function (size) {
            console.log('entro');
            console.log(size);
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/catalogo/descuento/modal/modal_descuentos.html',
                controller: 'modalDescuentoCtrl',
                backdrop: 'static',
                scope: $scope,
                resolve: {
                    item: function () { }
                }
            }).result.then(function (data) {
                $scope.listarcupon();
            });
        };

     

        editableOptions.theme = 'bs3';
        editableThemes['bs3'].submitTpl = '<button type="submit" ng-click="calcular(afp)" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
        editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-danger btn-with-icon"><i class="ion-close-round"></i></button>';
     
    }]);
})();
(function(){
    'use strict';
    angular.module('BlurAdmin.pages.catalogo.empleado', [])  
    .controller('empleadoListCtrl',[ '$scope', 'serviceAPI', '$state', function($scope, serviceAPI, $state){
        $scope.displayed=[];
        $scope.callServer=function(tableState){
            var params = angular.extend({}, tableState.pagination, tableState.search);
            serviceAPI.getEmpleado(params).success(function(r){
                if(r.success && r.totalItemCount>0){
                    $scope.displayed=r.rows;
                    tableState.pagination.numberOfPages =r.numberOfPages;
                }
            });
        };
        $scope.agregar=function(){
            $state.go('dashboard.catalogo.empleado-details');
        };
        $scope.editar=function(id_empleado){
            $state.go('dashboard.catalogo.empleado-details', {idempleado:id_empleado});
        };
        $scope.changeStatus=function(id_empleado){
            
        };
        $scope.eliminar=function(id_empleado){
            serviceAPI.eliminarEmpleado({id:id_empleado}).success(function(r){
                var typenotify=(r.success)?'warning':'error';
                if(r.affected_rows==1){
                    typenotify='success';
                    $scope.displayed=$scope.displayed.filter(function(i){ return (i.id_empleado!=id_empleado)});
                }
                toastr[typenotify](r.messages, 'Listado de Monedas')
            });
        };

        $scope.obtenerEmpleado = function (empleado) {
            $uibModalInstance.close(empleado);
        };
    }])
    .controller('empleadoListModaltrl',[ '$scope', 'serviceAPI', '$state', '$uibModalInstance', function($scope, serviceAPI, $state, $uibModalInstance){
        $scope.displayed=[];
        $scope.callServer=function(tableState){
            var params = angular.extend({}, tableState.pagination, tableState.search);
            serviceAPI.getEmpleado(params).success(function(r){
                if(r.success && r.totalItemCount>0){
                    $scope.displayed=r.rows;
                    tableState.pagination.numberOfPages =r.numberOfPages;
                }
            });
        };
       
        $scope.obtenerEmpleado = function (empleado) {
            $uibModalInstance.close(empleado);
        };
    }])
    .controller('empleadoCtrl', [ '$scope', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', function($scope, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log){
        var vm=this;
        $scope.default={id_tipo_documento:0,id_sexo:0,id_estado_civil:0,nu_documento:'',no_apepat:'',no_apemat:'',no_nombres:'',fe_nacimiento:'',
            no_direccion:'',nu_contacto:'',email:'', id_empleado:0};
        $scope.data={id_tipo_documento:0,id_sexo:0,id_estado_civil:0,nu_documento:'',no_apepat:'',no_apemat:'',no_nombres:'',fe_nacimiento:'',
        no_direccion:'',nu_contacto:'',email:'', id_empleado:0};
        
        $scope.jDocumentos=[];        
        $scope.cSexo=[];
        $scope.cEstadoCivil=[];
        $scope.jEmpresa = [];
        $scope.jSucursal = [];

        $scope.getDatosReniec = function(event){
            console.log(event);
            if (event.which === 13){
                serviceAPI.getDni($scope.data.nu_documento).success(function (r) {
                    console.log(r);
                    angular.extend($scope.data, r);
                })
            }
        }

        serviceAPI.getEmpresas().success(function (r) {
            if (r.success && r.totalItemCount > 0) {
                angular.extend($scope.jEmpresa, r.rows);
            }
        });

        $scope.getSucursal = function (value) {
            serviceAPI.getSucursalId(value).success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jSucursal, r.rows);
                }
            });
        }



        serviceAPI.getTiposDocumentos().then(function(r){
            if(r.data.totalItemCount>0 && r.data.success){
                angular.extend($scope.jDocumentos, r.data.rows);
            }
        });

        serviceAPI.listarSexo().then(function(r){
            if(r.data.totalItemCount>0 && r.data.success){
                angular.extend($scope.cSexo, r.data.rows);
            }
        });

        serviceAPI.listarEstadoCivil().then(function(r){
            if(r.data.totalItemCount>0 && r.data.success){
                angular.extend($scope.cEstadoCivil, r.data.rows);
            }
        });

        $scope.guardar=function(eForm){
            serviceAPI.guardarEmpleado($scope.data).success(function(r){
                var typeNotification='error';
                if(r.success){
                    typeNotification=(r.affected_rows!=0)?'success':'warning';
                }
                toastr[typeNotification](r.messages, 'Registro de empleado');
                angular.extend($scope.data, $scope.default);
                eForm.$setPristine();
                eForm.$setUntouched();
            });
        };

        $scope.consultar=function(){
            var _this=this;
            if($stateParams.idempleado!=''){
                serviceAPI.consultarEmpleado({id_empleado:$stateParams.idempleado}).success(function(r){
                    var typeNotification=(!r.success)?'error':'warning';
                    if(r.success && r.num_rows==1){
                        typeNotification='success';
                        angular.extend($scope.data, r.rows);   
                        $scope.cTipoDocumento.map(function(a){
                            if(z.id==r.rows.id_tipo_documento){$scope.data.id_tipo_documento=a;}
                        });                   
                        $scope.cSexo.map(function(b){
                            if(z.id==r.rows.id_sexo){$scope.data.id_sexo=b;}
                        });
                        $scope.cEstadoCivil.map(function(c){
                            if(z.id==r.rows.id_estado_civil){$scope.data.id_estado_civil=c;}
                        });
                    }
                    toastr[typeNotification](r.messages, 'Información de la empleado');
                }); 
            }
        };

    }]);
})();
(function(){
    'use strict';
    angular.module('BlurAdmin.pages.catalogo.marca', []) 
    .controller('modalMarcaCtrl', ['$scope','serviceAPI','toastr', 'item', '$http', '$httpParamSerializerJQLike', '$uibModalInstance', function ($scope,serviceAPI,toastr, item, $http, $httpParamSerializerJQLike, $uibModalInstance) {
        $scope.data = { id_marca: 0, no_marca: '' ,id_marca_descuento:0, pr_descuento: '' };
        $scope.default = { id_marca: 0, no_marca: '' ,id_marca_descuento:0, pr_descuento: '' };
        $scope.item = $scope.$parent.item || false;
        $scope.cerrar = function() {
            $uibModalInstance.close();
        }
        $scope.jMarca=[];

        serviceAPI.getMarca().success(function(r){            
            if(r.success && r.totalItemCount>0){
                console.log(r.rows);
                angular.extend($scope.jMarca, r.rows);
            }
        });

        $scope.GuardarMarca=function(value){
            serviceAPI.guardarMarca(value).success(function(r){
                var typeNotification='error';
                if(r.success){
                    typeNotification=(r.affected_rows!=0)?'success':'warning';
                }
                toastr[typeNotification](r.messages, 'Registro de Marca');
                angular.extend($scope.data, $scope.default);
                $uibModalInstance.close(value);
            });
        }

        $scope.GuardarDescuento=function(value){
            serviceAPI.guardarDescuento(value).success(function(r){
                var typeNotification='error';
                if(r.success){
                    typeNotification=(r.affected_rows!=0)?'success':'warning';
                }
                toastr[typeNotification](r.messages, 'Registro de Descuento');
                angular.extend($scope.data, $scope.default);
                $uibModalInstance.close(value);
            });
        }


    }])  
    .controller('marcaCtrl', [ '$scope', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', '$uibModal', 'editableThemes', 'editableOptions', function($scope, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log, $uibModal, editableThemes, editableOptions){
        var vm=this;
        $scope.default={id_marca:0, no_marca:'',status:''};
        $scope.data={id_marca:0, no_marca:'',status:''};

        $scope.displayed = [];
        $scope.displayed2 = [];


        serviceAPI.getMarca().then(function (r) {
            if (r.data.totalItemCount > 0 && r.data.success) {
                $scope.displayed = r.data.rows;
            }
        })

        serviceAPI.getDescuento().then(function (r) {
            if (r.data.totalItemCount > 0 && r.data.success) {
                $scope.displayed2 = r.data.rows;
            }
        })

        $scope.changeStatus = function (idMarca, actividad, index) {
            console.log('entro');
            serviceAPI.cambiarStatusMarca({ id: idMarca, status: actividad }).success(function (r) {
                console.log(r);
                var typenotify = 'error';
                if (r.num_rows == 0) {
                    typenotify = 'warning';
                    $scope.displayed = $scope.displayed.filter(function (i) { return (i.id_marca != idMarca); })
                }
                if (r.affected_rows == 1) {
                    typenotify = 'success';
                    $scope.displayed[index].status = r.rows.status;
                }
                toastr[typenotify](r.messages, 'Listado de Sucursal');
            });
        };

        $scope.guardar = function (eForm) {
            $scope.displayed = [];
            serviceAPI.guardarMarca($scope.data).success(function (r) {
                var typeNotification = 'error';
                if (r.success) {
                    typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                }
                toastr[typeNotification](r.messages, 'Registro de Categoria Correctamente');
                angular.extend($scope.data, $scope.default);
                eForm.$setPristine();
                eForm.$setUntouched();
                $scope.callServer([]);
            });
        };


        $scope.GuardarMarca=function(data,item){
            $scope.data = item;
            serviceAPI.guardarMarca($scope.data).success(function(r){
                var typeNotification='error';
                if(r.success){
                    typeNotification=(r.affected_rows!=0)?'success':'warning';
                }
                toastr[typeNotification](r.messages, 'Registro de Marca');
                angular.extend($scope.data, $scope.default);
                $scope.listarMarca();
                $scope.listarDescuento();
            });
        }

        $scope.GuardarDescuento=function(data,item){
            $scope.data = item
            serviceAPI.guardarDescuento($scope.data).success(function(r){
                var typeNotification='error';
                if(r.success){
                    typeNotification=(r.affected_rows!=0)?'success':'warning';
                }
                toastr[typeNotification](r.messages, 'Registro de Descuento x Marca');
                angular.extend($scope.data, $scope.default);
                $scope.listarDescuento();
            });
        }

        $scope.editar = function (value) {
            $scope.data = value;
        };


        $scope.openMarca = function (size) {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/catalogo/marca/modal/modal_marca.html',
                controller: 'modalMarcaCtrl',
                backdrop: 'static',
                scope: $scope,
                resolve: {
                    item: function () { }
                }
            }).result.then(function (data) {
                $scope.listarMarca();
            });
        };

        $scope.openDescuento = function (size) {
            $uibModal.open({
                animation: true,
                templateUrl: 'app/pages/catalogo/marca/modal/modal_descuento.html',
                controller: 'modalMarcaCtrl',
                backdrop: 'static',
                keyboard: false,
                scope: $scope,
                resolve: {
                    item: function () { }
                }
            }).result.then(function (data) {
                $scope.listarDescuento();
            });
        };

        $scope.listarMarca = function () {
            $scope.displayed=[];
            serviceAPI.getMarca().then(function (r) {
                if (r.data.totalItemCount > 0 && r.data.success) {
                    $scope.displayed = r.data.rows;
                }
            })
        }

        $scope.listarDescuento = function () {
            $scope.displayed2=[];
            serviceAPI.getDescuento().then(function (r) {
                if (r.data.totalItemCount > 0 && r.data.success) {
                    $scope.displayed2 = r.data.rows;
                }
            })
        }

        editableOptions.theme = 'bs3';
        editableThemes['bs3'].submitTpl = '<button type="submit" ng-click="calcular(afp)" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
        editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-danger btn-with-icon"><i class="ion-close-round"></i></button>';
     
    }]);
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.catalogo.producto', [])
        .controller('productolistCtrl', ['$scope', 'serviceAPI','toastr', '$state', function ($scope, serviceAPI,toastr, $state) {
            $scope.displayed = [];
            $scope.callServer = function (tableState) {
                var params = angular.extend({}, tableState.pagination, tableState.search);
                serviceAPI.getProducto(params).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        console.log(r);
                        $scope.displayed = r.rows;
                        tableState.pagination.numberOfPages = r.numberOfPages;
                    }
                });
            };
            $scope.listar = function () {
                serviceAPI.getProducto([]).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        console.log(r);
                        $scope.displayed = r.rows;
                    }
                });
            }


            $scope.agregar = function () {
                $state.go('dashboard.catalogo.producto-details');
            };
            $scope.editar = function (id) {
                $state.go('dashboard.catalogo.producto-details', { idproducto: id });
            };

            $scope.eliminar = function (idproducto) {
                $scope.displayed = [];
                serviceAPI.eliminarProducto({ id: idproducto }).success(function (r) {
                    console.log(r);
                    var typenotify = (r.success) ? 'warning' : 'error';
                    if (r.affected_rows == 1) {
                        typenotify = 'success';
                        $scope.listar();
                    }
                    toastr[typenotify](r.messages, 'Listado de Producto')
                });
            };

            $scope.eliminarPrincipal = function (idproducto) {
                $scope.displayed = [];
                serviceAPI.eliminarProductoPrincipal({ id: idproducto }).success(function (r) {
                    console.log(r);
                    var typenotify = (r.success) ? 'warning' : 'error';
                    if (r.affected_rows == 1) {
                        typenotify = 'success';
                        $scope.listar();
                    }
                    toastr[typenotify](r.messages, 'Listado de Producto')
                });
            };
        }])
        .controller('productoModalCtrl', ['$scope', 'serviceAPI', '$state', '$uibModalInstance', function ($scope, serviceAPI, $state, $uibModalInstance) {
                        
            $scope.displayed = [];
            $scope.callServer = function (tableState) {
                var params = angular.extend({}, tableState.pagination, tableState.search);
                serviceAPI.getProductoCompraBusquedad(params).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        $scope.displayed = r.rows;
                        tableState.pagination.numberOfPages = r.numberOfPages;
                    }
                });
            };

            $scope.listar = function () {
                serviceAPI.getProducto([]).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        console.log(r);
                        $scope.displayed = r.rows;
                    }
                });
            }

            $scope.obtenerProducto = function (value) {
                $uibModalInstance.close(value);
            };

        }])
        .controller('productoCtrl', ['$filter','$scope', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log','$uibModal', 'editableOptions', 'editableThemes','servFactory', function ($filter,$scope, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log,$uibModal, editableOptions, editableThemes,servFactory) {
            var vm = this;
            $scope.default = { id_producto: 0,co_producto:'',co_barra: '',no_producto: '', no_descripcion: '',mto_ult_compra: 0.00, mto_compra_sin_imp: 0.00,fec_ult_compra:'',mto_ult_venta: 0.00,mto_venta_sin_imp: 0.00,
            fec_ult_venta:'',ti_producto: 0 ,id_categoria: 0,id_marca:0,id_medida: 0,nu_medida: '',no_ruta_producto:'',nu_stock_minimo:'',il_ocultar: '',status: 0,mto_impuesto:'18.00',msgstockminimo:false};
            $scope.data = {id_producto: 0,co_producto:'',co_barra: '',no_producto: '', no_descripcion: '',mto_ult_compra: 0.00, mto_compra_sin_imp: 0.00,fec_ult_compra:'',mto_ult_venta: 0.00,mto_venta_sin_imp: 0.00,
            fec_ult_venta:'',ti_producto: 0 ,id_categoria: 0,id_marca:0,id_medida: 0,nu_medida: '',no_ruta_producto:'',nu_stock_minimo:'',il_ocultar: '',status: 0,mto_impuesto:'18.00',msgstockminimo:false};
            
            $scope.datap = {id_producto:0, co_producto:'', no_producto:'', nu_cantidad_p:0}
            $scope.defaultp = {id_producto:0, co_producto:'', no_producto:'', nu_cantidad_p:0}
            
            $scope.jMarcas = [];
            $scope.jCategoria = [];
            $scope.jUnidad = [];
            $scope.jTipoProducto = [];

            
            $scope.editarCodigo=function(){ $scope.data.custom_code=!($scope.data.custom_code);};

            serviceAPI.getMarca().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jMarcas, r.rows);
                }
            });

            serviceAPI.getCategoria().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jCategoria, r.rows);
                }
            });

            serviceAPI.getUnidad().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jUnidad, r.rows);
                }
            });

            $scope.modalProducto = function (size) {
                $uibModal.open({
                    animation: true,
                    size: size,
                    templateUrl: "app/pages/inventario/stockProductos/list/listProductosModal.html",
                    controller: 'stockProductosModalCtrl',
                    scope: $scope
                }).result.then(function (data) {
                    angular.extend($scope.datap, data);
                    
                }, function () {
                    console.log('Modal dismissed at: ' + new Date());
                });
            };


            $scope.rowCollection = [];
            var $item = 0;
            $scope.agregarProducto = function () {
                var itemActual;
                for (var i = 0; i < $scope.rowCollection.length; i++) {
                    if ($scope.rowCollection[i].id_producto == $scope.datap.id_producto) {
                        itemActual = $scope.rowCollection[i];
                    }
                }
                if (!itemActual) {
                        $scope.notaproducto={
                            id: ++$item,
                            id_producto: $scope.datap.id_producto,
                            co_producto: $scope.datap.co_producto,
                            no_producto: $scope.datap.no_producto,
                            nu_cantidad: $scope.datap.nu_cantidad_p             
                        };
                        $scope.rowCollection.push($scope.notaproducto);                    
                } else {
                    var typeNotification = 'error';
                    toastr[typeNotification]('Ya se agrego el producto', 'Informacion Sistema');
                }
                angular.extend($scope.datap, $scope.defaultp);
            };


            $scope.guardar = function (eForm) {
                var params = { orden: $scope.data , detalle:$scope.rowCollection };
                serviceAPI.guardarProducto(params).success(function (r) {
                    var typeNotification = 'error';
                    if (r.success) {
                        typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                    }
                    toastr[typeNotification](r.messages, 'Registro de Producto');
                    angular.extend($scope.data, $scope.default);
                    angular.extend($scope.datap, $scope.defaultp);
                    $scope.rowCollection = [];
                });
            };

            $scope.consultar = function () {
                if ($stateParams.idProducto != '') {                    
                    serviceAPI.consultaProducto({ id: $stateParams.idProducto }).success(function (r) {                    
                        var typeNotification = (!r.success) ? 'error' : 'warning';
                        if (r.success && r.num_rows == 1) {
                            typeNotification = 'success';
                            angular.extend($scope.data, r.rows);

                            $scope.jMarcas.map(function (b) {
                                if (b.id_marca == r.rows.id_marca) { $scope.data.id_marca = b; }
                            });
                            $scope.jCategoria.map(function (c) {
                                if (c.id_categoria == r.rows.id_categoria) { $scope.data.id_categoria = c; }
                            });
                            $scope.jUnidad.map(function (d) {
                                if (d.id_medida == r.rows.id_medida) { $scope.data.id_medida = d; }
                            });
                            
                        }
                        toastr[typeNotification](r.messages, 'Información de Producto');
                    });
                }
            };

            $scope.openMarca = function (size) {
                $uibModal.open({
                    animation: true,
                    templateUrl: 'app/pages/catalogo/marca/modal/modal_marca.html',
                    controller: 'modalMarcaCtrl',
                    backdrop: 'static',
                    scope: $scope,
                    resolve: {
                        item: function () { }
                    }
                }).result.then(function (data) {
                    $scope.listarMarca();
                });
            };

            $scope.calcular_neto=function(){
                var mto=servFactory.calularNeto($scope.data.mto_ult_compra, $scope.data.exento_impuesto, 18.00);
                $scope.data.mto_compra_sin_imp=$filter('number')(mto, 2);
                if($scope.data.metodo_venta==2){
                    $scope.aplicar_porc();
                }
            };

            $scope.aplicar_porc=function(){
                var mto=$filter('number')($scope.data.mto_ult_compra, 2);
                var mto_porc=$filter('number')($scope.data.mto_porc, 2);
                var calculo=parseFloat(mto)+(parseFloat(mto)*parseFloat(mto_porc)/100);
                $scope.data.mto_venta=$filter('number')(calculo,  2);
            };

            $scope.calcular_neto_venta=function(){
                var mto=servFactory.calularNeto($scope.data.mto_ult_venta, $scope.data.exento_impuesto, 18.00);
                $scope.data.mto_venta_sin_imp=$filter('number')(mto, 2);
                if($scope.data.metodo_venta==2){
                    $scope.aplicar_porc();
                }
            };

            $scope.aplicar_porc_venta=function(){
                var mto=$filter('number')($scope.data.mto_ult_venta, 2);
                var mto_porc=$filter('number')($scope.data.mto_porc, 2);
                var calculo=parseFloat(mto)+(parseFloat(mto)*parseFloat(mto_porc)/100);
                $scope.data.mto_venta=$filter('number')(calculo,  2);
            };


            editableOptions.theme = 'bs3';
            editableThemes['bs3'].submitTpl = '<button type="submit" class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
            editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

        }]);
})();
/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs')
    .controller('chartJs1DCtrl', chartJs1DCtrl);

  /** @ngInject */
  function chartJs1DCtrl($scope) {

    $scope.labels =["Sleeping", "Designing", "Coding", "Cycling"];
    $scope.data = [20, 40, 5, 35];
    $scope.options = {
      segmentShowStroke : false
    };

    $scope.polarOptions = {
      scaleShowLabelBackdrop : false,
      segmentShowStroke : false
    };

    $scope.changeData = function () {
      $scope.data = shuffle($scope.data);
    };

    function shuffle(o){
      for(var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x){}
      return o;
    }
  }

})();

/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs')
    .controller('chartJs2DCtrl', chartJs2DCtrl);

  /** @ngInject */
  function chartJs2DCtrl($scope) {
    $scope.labels =["May", "June", "Jule", "August", "September", "October", "November"];
    $scope.data = [
      [65, 59, 90, 81, 56, 55, 40],
      [28, 48, 40, 19, 88, 27, 45]
    ];
    $scope.series = ['Product A', 'Product B'];


    $scope.changeData = function () {
      $scope.data[0] = shuffle($scope.data[0]);
      $scope.data[1] = shuffle($scope.data[1]);
    };

    function shuffle(o){
      for(var j, x, i = o.length; i; j = Math.floor(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x){}
      return o;
    }
  }

})();

/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartJs')
    .controller('chartJsWaveCtrl', chartJsWaveCtrl);

  /** @ngInject */
  function chartJsWaveCtrl($scope, $interval, stopableInterval) {
    $scope.labels =["April", "May", "June", "Jule", "August", "September", "October", "November", "December"];
    $scope.data = [[1, 9, 3, 4, 5, 6, 7, 8, 2].map(function(e){
      return Math.sin(e) * 25 +25;
    })];

    stopableInterval.start($interval, function(){
      $scope.data[0].unshift($scope.data[0].pop());
    }, 300);
  }

})();

/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.chartist')
    .controller('chartistCtrl', chartistCtrl);

  /** @ngInject */
  function chartistCtrl($scope, $timeout, baConfig) {

    $scope.simpleLineOptions = {
      color: baConfig.colors.defaultText,
      fullWidth: true,
      height: "300px",
      chartPadding: {
        right: 40
      }
    };

    $scope.simpleLineData = {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'],
      series: [
        [20, 20, 12, 45, 50],
        [10, 45, 30, 14, 12],
        [34, 12, 12, 40, 50],
        [10, 43, 25, 22, 16],
        [3, 6, 30, 33, 43]
      ]
    };

    $scope.areaLineData = {
      labels: [1, 2, 3, 4, 5, 6, 7, 8],
      series: [
        [5, 9, 7, 8, 5, 3, 5, 4]
      ]
    };

    $scope.areaLineOptions = {
      fullWidth: true,
      height: "300px",
      low: 0,
      showArea: true
    };

    $scope.biLineData = {
      labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
      series: [
        [1, 2, 3, 1, -2, 0, 1],
        [-2, -1, -2, -1, -2.5, -1, -2],
        [0, 0, 0, 1, 2, 2.5, 2],
        [2.5, 2, 1, 0.5, 1, 0.5, -1]
      ]
    };

    $scope.biLineOptions = {
      height: "300px",
      high: 3,
      low: -3,
      showArea: true,
      showLine: false,
      showPoint: false,
      fullWidth: true,
      axisX: {
        showGrid: false
      }
    };

    $scope.simpleBarData = {
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      series: [
        [15, 24, 43, 27, 5, 10, 23, 44, 68, 50, 26, 8],
        [13, 22, 49, 22, 4, 6, 24, 46, 57, 48, 22, 4]
      ]
    };

    $scope.simpleBarOptions = {
      fullWidth: true,
      height: "300px"
    };

    $scope.multiBarData = {
      labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
      series: [
        [5, 4, 3, 7],
        [3, 2, 9, 5],
        [1, 5, 8, 4],
        [2, 3, 4, 6],
        [4, 1, 2, 1]
      ]
    };

    $scope.multiBarOptions = {
      fullWidth: true,
      height: "300px",
      stackBars: true,
      axisX: {
        labelInterpolationFnc: function (value) {
          return value.split(/\s+/).map(function (word) {
            return word[0];
          }).join('');
        }
      },
      axisY: {
        offset: 20
      }
    };

    $scope.multiBarResponsive = [
      ['screen and (min-width: 400px)', {
        reverseData: true,
        horizontalBars: true,
        axisX: {
          labelInterpolationFnc: Chartist.noop
        },
        axisY: {
          offset: 60
        }
      }],
      ['screen and (min-width: 700px)', {
        stackBars: false,
        reverseData: false,
        horizontalBars: false,
        seriesBarDistance: 15
      }]
    ];

    $scope.stackedBarData = {
      labels: ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4'],
      series: [
        [800000, 1200000, 1400000, 1300000],
        [200000, 400000, 500000, 300000],
        [100000, 200000, 400000, 600000]
      ]
    };

    $scope.stackedBarOptions = {
      fullWidth: true,
      height: "300px",
      stackBars: true,
      axisY: {
        labelInterpolationFnc: function (value) {
          return (value / 1000) + 'k';
        }
      }
    };

    $scope.simplePieData = {
      series: [5, 3, 4]
    };

    $scope.simplePieOptions = {
      fullWidth: true,
      height: "300px",
      weight: "300px",
      labelInterpolationFnc: function (value) {
        return Math.round(value / 12 * 100) + '%';
      }
    };

    $scope.labelsPieData = {
      labels: ['Bananas', 'Apples', 'Grapes'],
      series: [20, 15, 40]
    };

    $scope.labelsPieOptions = {
      fullWidth: true,
      height: "300px",
      weight: "300px",
      labelDirection: 'explode',
      labelInterpolationFnc: function (value) {
        return value[0];
      }
    };

    $scope.simpleDonutData = {
      labels: ['Bananas', 'Apples', 'Grapes'],
      series: [20, 15, 40]
    };

    $scope.simpleDonutOptions = {
      fullWidth: true,
      donut: true,
      height: "300px",
      weight: "300px",
      labelDirection: 'explode',
      labelInterpolationFnc: function (value) {
        return value[0];
      }
    };

    $scope.donutResponsive = getResponsive(5, 40);

    $scope.pieResponsive = getResponsive(20, 80);

    function getResponsive(padding, offset){
      return [
        ['screen and (min-width: 1550px)', {
          chartPadding: padding,
          labelOffset: offset,
          labelDirection: 'explode',
          labelInterpolationFnc: function (value) {
            return value;
          }
        }],
        ['screen and (max-width: 1200px)', {
          chartPadding: padding,
          labelOffset: offset,
          labelDirection: 'explode',
          labelInterpolationFnc: function (value) {
            return value;
          }
        }],
        ['screen and (max-width: 600px)', {
          chartPadding: 0,
          labelOffset: 0,
          labelInterpolationFnc: function (value) {
            return value[0];
          }
        }]
      ];
    }

    $timeout(function(){
      new Chartist.Line('#line-chart', $scope.simpleLineData, $scope.simpleLineOptions);
      new Chartist.Line('#area-chart', $scope.areaLineData, $scope.areaLineOptions);
      new Chartist.Line('#bi-chart', $scope.biLineData, $scope.biLineOptions);

      new Chartist.Bar('#simple-bar', $scope.simpleBarData, $scope.simpleBarOptions);
      new Chartist.Bar('#multi-bar', $scope.multiBarData, $scope.multiBarOptions, $scope.multiBarResponsive);
      new Chartist.Bar('#stacked-bar', $scope.stackedBarData, $scope.stackedBarOptions);

      new Chartist.Pie('#simple-pie', $scope.simplePieData, $scope.simplePieOptions, $scope.pieResponsive);
      new Chartist.Pie('#label-pie', $scope.labelsPieData, $scope.labelsPieOptions);
      new Chartist.Pie('#donut', $scope.simpleDonutData, $scope.simpleDonutOptions, $scope.donutResponsive);
    });
  }
})();

/**
 * @author a.demeshko
 * created on 12/16/15
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.morris')
    .controller('morrisCtrl', morrisCtrl);

  /** @ngInject */
  function morrisCtrl($scope, $window, baConfig) {
    var layoutColors = baConfig.colors;
    $scope.colors = [layoutColors.primary, layoutColors.warning, layoutColors.danger, layoutColors.info, layoutColors.success, layoutColors.primaryDark];
    $scope.lineData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.areaData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.barData = [
      {y: "2006", a: 100, b: 90},
      {y: "2007", a: 75, b: 65},
      {y: "2008", a: 50, b: 40},
      {y: "2009", a: 75, b: 65},
      {y: "2010", a: 50, b: 40},
      {y: "2011", a: 75, b: 65},
      {y: "2012", a: 100, b: 90}
    ];
    $scope.donutData = [
      {label: "Download Sales", value: 12},
      {label: "In-Store Sales", value: 30},
      {label: "Mail-Order Sales", value: 20}
    ];

    angular.element($window).bind('resize', function () {
      //$window.Morris.Grid.prototype.redraw();
    });
  }

})();

(function () {
    'use strict';

    angular.module('BlurAdmin.pages.clientes.cliente', [])
        .directive('formCliente', function () {
            return {
                restrict: 'E',
                templateUrl: 'app/pages/clientes/cliente/cliente.html'
            };
        })
        .directive('modalCliente', function () {
            return {
                restrict: 'E',
                templateUrl: 'app/pages/clientes/cliente/modal-cliente.html'
            };
        })
        .controller('clientelistCtrl', ['$scope', 'serviceAPI', '$state', function ($scope, serviceAPI, $state) {
            $scope.displayed = [];
            $scope.callServer = function (tableState) {
                $scope.displayed = [];
                var params = angular.extend({}, tableState.pagination, tableState.search);
                serviceAPI.getCliente(params).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        $scope.displayed = r.rows;
                        tableState.pagination.numberOfPages = r.numberOfPages;
                    }
                });
            };
            $scope.agregar = function () {
                $state.go('dashboard.clientes.cliente-details');
            };
            $scope.editar = function (id_cliente) {
                $state.go('dashboard.clientes.cliente-details', { idCliente: id_cliente });
            };
            $scope.eliminar = function (idCliente) {
                serviceAPI.eliminarCliente({ id: idCliente }).success(function (r) {
                    console.log(r);
                    var typenotify = (r.success) ? 'warning' : 'error';
                    if (r.affected_rows == 1) {
                        typenotify = 'success';
                        $scope.displayed = $scope.displayed.filter(function (i) { return (i.id_cliente != idCliente) });
                    }
                    toastr[typenotify](r.messages, 'Listado de Cliente')
                });
            };


            $scope.changeStatus = function (idCliente, actividad, index) {
                serviceAPI.cambiarStatusProveedor({ id: idCliente, status: actividad }).success(function (r) {
                    var typenotify = 'error';
                    if (r.num_rows == 0) {
                        typenotify = 'warning';
                        $scope.displayed = $scope.displayed.filter(function (i) { return (i.id_cliente != idCliente); })
                    }
                    if (r.affected_rows == 1) {
                        typenotify = 'success';
                        $scope.displayed[index].status = r.rows.status;
                    }
                    toastr[typenotify](r.messages, 'Listado de Proveedores');
                });
            };
        }])
        .controller('clienteHistoricoCtrl', ['$scope', 'serviceAPI', '$state', function ($scope, serviceAPI, $state) {
            $scope.displayed = [];
            $scope.callServer = function (tableState) {
                $scope.displayed = [];
                var params = angular.extend({}, tableState.pagination, tableState.search);
                serviceAPI.getCliente(params).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        $scope.displayed = r.rows;
                        tableState.pagination.numberOfPages = r.numberOfPages;
                    }
                });
            };
        }])
        .controller('clienteModalCtrl', ['$scope', 'serviceAPI', '$state', '$uibModalInstance', function ($scope, serviceAPI, $state, $uibModalInstance) {
            $scope.displayed = [];
            $scope.callServer = function (tableState) {
                $scope.displayed = [];
                var params = angular.extend({}, tableState.pagination, tableState.search);
                serviceAPI.getCliente(params).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        $scope.displayed = r.rows;
                        tableState.pagination.numberOfPages = r.numberOfPages;
                    }
                });
            };

            $scope.obtenerCliente = function (cliente) {
                $uibModalInstance.close(cliente);
            };

        }])
        .controller('clienteCtrl', ['$scope', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', function ($scope, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log) {
            var vm = this;
            $scope.default = { id_cliente: 0,id_tipo_cliente:0, id_tipo_documento: 0, id_ubigeo: '', no_cliente: '', nu_documento: '', co_depart: 0, co_provin: 0, co_distri: 0, id_provi: 0,no_direccion: '', nu_telefono: '',nu_telefono_fijo: '', no_email: '' ,no_nombres: '',no_apepat: '',no_apemat: '' ,no_proveedor: ''};
            $scope.data = { id_cliente: 0,id_tipo_cliente:0, id_tipo_documento: 0, id_ubigeo: '', no_cliente: '', nu_documento: '', co_depart: 0, co_provin: 0, co_distri: 0,id_provi: 0, no_direccion: '', nu_telefono: '',nu_telefono_fijo: '', no_email: '' ,no_nombres: '',no_apepat: '',no_apemat: '' ,no_proveedor: ''};

            $scope.jDocumentos = [];
            $scope.a_departamento = [];
            $scope.a_provincia = [];
            $scope.a_distrito = [];
            $scope.jTipoCliente = [];

            $scope.getDatosGeneral = function (event) {
                console.log($scope.data.id_tipo_documento);
                var id = $scope.data.id_tipo_documento;
                if(id.id == 1){
                    console.log('entro');
                    if (event.which === 13) {
                        serviceAPI.getDni($scope.data.nu_documento).success(function (r) {                       
                            angular.extend($scope.data, r);
                            $scope.data.no_cliente = $scope.data.no_nombres+' '+$scope.data.no_apepat+' '+$scope.data.no_apemat;
                            $scope.data.no_direccion = '';
                        })
                    }
                }else if(id.id == 6){
                    console.log('entro 2');
                    if (event.which === 13) {
                        serviceAPI.getRuc($scope.data.nu_documento).success(function (r) {
                            angular.extend($scope.data, r);
                            $scope.data.no_cliente = $scope.data.no_proveedor;                            
                        })
                    }
                }
               
            }

            serviceAPI.getTiposDocumentos().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jDocumentos, r.rows);
                }
            });

             serviceAPI.getTipoCliente().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jTipoCliente, r.rows);
                }
            });

            $scope.guardar = function (eForm) {
                serviceAPI.guardarCliente($scope.data).success(function (r) {
                    var typeNotification = 'error';
                    if (r.success) {
                        typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                    }
                    toastr[typeNotification](r.messages, 'Registro de Proveedor');
                    angular.extend($scope.data, $scope.default);
                    eForm.$setPristine();
                    eForm.$setUntouched();
                });
            };


            serviceAPI.getDepartamento().then(function (r) {
                if (r.data.totalItemCount > 0 && r.data.success) { 
                    angular.extend($scope.a_departamento, r.data.rows);
                }
            });

            $scope.getpDepartamento = function () {
                serviceAPI.getProvincia($scope.data).then(function (r) {
                    if (r.data.totalItemCount > 0 && r.data.success) {
                        angular.extend($scope.a_provincia, r.data.rows);
                    }
                });
            }
            $scope.getpProvincia = function () {
                serviceAPI.getDistrito($scope.data).then(function (r) {
                    if (r.data.totalItemCount > 0 && r.data.success) {
                        angular.extend($scope.a_distrito, r.data.rows);
                    }
                });
            }

            $scope.consultar = function () {
                var _this = this;
                if ($stateParams.idCliente != '') {
                    serviceAPI.consultarCliente({ id_cliente: $stateParams.idCliente }).success(function (r) {
                        var typeNotification = (!r.success) ? 'error' : 'warning';
                        console.log(r);
                        if (r.success && r.num_rows == 1) {
                            typeNotification = 'success';
                            angular.extend($scope.data, r.rows);
                            $scope.jTipoCliente.map(function (c) {
                                console.log(c);
                                if (c.id_tipo_cliente == r.rows.id_tipo_cliente) { $scope.data.id_tipo_cliente = c; }
                            });

                            $scope.jDocumentos.map(function (z) {
                                if (z.id == r.rows.id_tipo_documento) { $scope.data.id_tipo_documento = z; }
                            });
                            $scope.a_departamento.map(function (a) {
                                if (a.id == r.rows.co_depart) {
                                    $scope.data.co_depart = a;
                                }
                            });
    
                            serviceAPI.getProvincia($scope.data).then(function (rp) {
                                if (rp.data.totalItemCount > 0 && rp.data.success) {
                                    angular.extend($scope.a_provincia, rp.data.rows);
                                    $scope.a_provincia.map(function (b) {                                       
                                        if(b.id+"" == r.rows.co_provin+"") {
                                            console.log(b);
                                            $scope.data.co_provin = b;
                                            angular.extend( $scope.data.co_provin,b);
                                            serviceAPI.getDistrito($scope.data).then(function (rd) {
                                                if (rd.data.totalItemCount > 0 && rd.data.success) {
                                                    angular.extend($scope.a_distrito, rd.data.rows);
                                                    $scope.a_distrito.map(function (h) {
                                                        if (h.id+"" == r.rows.co_distri+"") {
                                                            $scope.data.co_distri = h;
                                                            angular.extend($scope.data.co_distri, h);
                                                        }
                                                    });
                                                }
                                            });
                                        }
                                    });
                                }
                            });
                           
                        }
                        toastr[typeNotification](r.messages, 'Información del Cliente');
                    });
                }
            };

        }]);
})();
(function () {
    'use strict';

    angular.module('BlurAdmin.pages.clientes.historico', [])
        .controller('historicolistCtrl', ['$scope', '$uibModal','serviceAPI', '$state', function ($scope,$uibModal, serviceAPI, $state) {
            $scope.displayed = [];
            $scope.callServer = function (tableState) {
                $scope.displayed = [];
                var params = angular.extend({}, tableState.pagination, tableState.search);
                serviceAPI.getVentasClientes(params).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        $scope.displayed = r.rows;
                        tableState.pagination.numberOfPages = r.numberOfPages;
                    }
                });
            };

            $scope.openPdf = function (size, item) {
                console.log('entro');
                $scope.item = item;
                $uibModal.open({
                    animation: true,
                    templateUrl: "app/pages/ventas/cotizacion/modal/modalPdf.html",
                    size: size,
                    controller: 'modalCtrl',
                    scope: $scope,
                    resolve: {
                        item: function () { }
                    }
                }).result.then(function (item) {
                    angular.extend($scope.data, item);
                }, function () {

                });
            };
        }])
        .controller('modalCtrl', ['$scope', 'item', '$http', '$httpParamSerializerJQLike', '$uibModalInstance', function ($scope, item, $http, $httpParamSerializerJQLike, $uibModalInstance) {
            $scope.item = $scope.$parent.item || false;
            $scope.status = 0;
            $scope.respuesta = 0;
            $scope.archivo = '';
            $scope.url = '';

            if (angular.isObject($scope.item)) {
                console.log($scope.item);

                $scope.archivo = 'api/api-omec/examples/report/boleta.php';


            }

            $scope.pdf = function () {
                $uibModalInstance.close($scope.item);
            }


            $scope.cerrar = function (data) {
                $uibModalInstance.close($scope.data);

            }
            $scope.enviaCorreo = function () {
                $http({
                    url: 'api/ventas.php',
                    method: 'POST',
                    data: $httpParamSerializerJQLike({ oper: 'envioCorreo', info: $scope.item }),
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }).then(function (response) {
                    if (response.data.success) {
                        $("#result").html(response.data.message);
                    } else
                        $("#result").html(response.data.message);
                }, function (response) {
                    toastr.error("ha fallado el proceso ", 'Error')
                });
            };



        }])
        .controller('historicoCtrl', ['$scope', '$uibModal', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', '$filter', function ($scope, $uibModal, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log, $filter) {
            var vm = this;
            $scope.default = {
                id_cotizacion: 0, id_tipo_pago: 0, no_observacion:'',id_cliente: 0, id_tipo_comprobante: 0, id_usuario: 0, id_estado_sunat: 0, nu_serie: '', nu_correlativo: '', nu_sub_total: 0, nu_igv: 0, nu_total: 0, fe_emision: '', id_estado: 0, id_local: 0, no_cliente: '', nu_documento: '',
                nu_efectivo: 0, nu_izipay: 0, nu_efectivo2: 0, nu_izipay2: 0, nu_trasnferencia: 0, nu_credito: 0, no_descuento: 0, nu_rappi: 0
            };
            $scope.data = {
                id_cotizacion: 0, id_tipo_pago: 0,no_observacion:'', id_cliente: 0, id_tipo_comprobante: 0, id_usuario: 0, id_estado_sunat: 0, nu_serie: '', nu_correlativo: '', nu_sub_total: 0, nu_igv: 0, nu_total: 0, fe_emision: '', id_estado: 0, id_local: 0, no_cliente: '', nu_documento: '',
                nu_efectivo: 0, nu_izipay: 0, nu_efectivo2: 0, nu_izipay2: 0, nu_trasnferencia: 0, nu_credito: 0, no_descuento: 0, nu_rappi: 0
            };

            $scope.datap = { id_producto: 0, igv: 0, id_marca: 0, nu_stock_minimo: 0, codigo: '', no_producto: '', id_categoria: 0, id_medida: 0, no_medida: '', id_tipo_producto: 0, no_descripcion: '', id_atributo: 0, id_parent_atributo: 0, mto_ult_venta: 0, id_empresa: 0, id_local: 0, nu_cantidad_p: 0, co_barra: '', nu_descuento: 0, mto_descueto: 0, id_marca_descuento: 0 };
            $scope.defaultp = { id_producto: 0, igv: 0, id_marca: 0, nu_stock_minimo: 0, codigo: '', no_producto: '', id_categoria: 0, id_medida: 0, no_medida: '', id_tipo_producto: 0, no_descripcion: '', id_atributo: 0, id_parent_atributo: 0, mto_ult_venta: 0, id_empresa: 0, id_local: 0, nu_cantidad_p: 0, co_barra: '', nu_descuento: 0, mto_descueto: 0, id_marca_descuento: 0 };

            $scope.jComprobante = [];
            $scope.jtipopago = [];
            $scope.jDescuento = [];

            serviceAPI.getTipoPago().success(function (r) {
                if (r.num_rows > 0 && r.success) {
                    angular.extend($scope.jtipopago, r.rows);
                }
            });

            serviceAPI.getComprobanteCoti().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jComprobante, r.rows);
                }
            });
            $scope.getCorrelativo = function (value) {
                serviceAPI.consultarCorrelativo(value).then(function (r) {
                    if (r.data.success && r.data.num_rows == 1) {
                        console.log(r);
                        $scope.data.nu_serie = r.data.rows.nu_serie;
                        $scope.data.nu_correlativo = $scope.zfill(r.data.rows.nu_correlativo, 8);
                    }
                });
            }
            $scope.zfill = function (number, width) {
                var numberOutput = Math.abs(number); /* Valor absoluto del número */
                var length = number.toString().length; /* Largo del número */
                var zero = "0"; /* String de cero */

                if (width <= length) {
                    if (number < 0) {
                        return ("-" + numberOutput.toString());
                    } else {
                        return numberOutput.toString();
                    }
                } else {
                    if (number < 0) {
                        return ("-" + (zero.repeat(width - length)) + numberOutput.toString());
                    } else {
                        return ((zero.repeat(width - length)) + numberOutput.toString());
                    }
                }
            }


            $scope.crearProduct = function (size) {
                $uibModal.open({
                    animation: true,
                    size: size,
                    templateUrl: "app/pages/clientes/cliente/clienteModal.html",
                    controller: 'clienteCtrl',
                    scope: $scope
                }).result.then(function (data) {
                    console.log(data);
                    angular.extend($scope.data, data);
                }, function () {
                    console.log('Modal dismissed at: ' + new Date());
                });
            };

            $scope.modalProducts = function (size) {
                $uibModal.open({
                    animation: true,
                    size: size,
                    templateUrl: "app/pages/clientes/cliente/list/clienteListModal.html",
                    controller: 'clienteModalCtrl',
                    scope: $scope
                }).result.then(function (data) {
                    console.log(data);
                    angular.extend($scope.data, data);
                }, function () {
                    console.log('Modal dismissed at: ' + new Date());
                });
            };


            $scope.modalProducto = function (size) {
                $uibModal.open({
                    animation: true,
                    size: size,
                    templateUrl: "app/pages/inventario/stockProductos/list/listProductosModal.html",
                    controller: 'stockProductosModalCtrl',
                    scope: $scope
                }).result.then(function (data) {
                    $scope.jDescuento = [];
                    angular.extend($scope.datap, data);
                    serviceAPI.getTipoDescuentoMarca($scope.datap.id_marca).success(function (r) {
                        if (r.totalItemCount > 0 && r.success) {
                            angular.extend($scope.jDescuento, r.rows);
                        }
                    });
                }, function () {
                    console.log('Modal dismissed at: ' + new Date());
                });
            };


            $scope.selection = [];

            $scope.toggleSelection = function toggleSelection(fruitName) {
                console.log(fruitName);
                var idx = $scope.selection.indexOf(fruitName);
                if (idx > -1) {
                    $scope.selection.splice(idx, 1);
                }
                else {
                    $scope.selection.push(fruitName);
                }
                console.log($scope.selection);
            };
            $scope.rowCollection = [];
            var item = 0;
            var item2 = 0;
            $scope.addItem = function () {
                var itemActual;
                var monto;
                if ($scope.datap.mto_descueto != 0) {
                    monto = $scope.datap.mto_descueto;
                } else {
                    monto = $scope.datap.mto_ult_venta;
                }


                if ($scope.datap.nu_cantidad_p != 0) {
                    for (var i = 0; i < $scope.rowCollection.length; i++) {
                        if ($scope.rowCollection[i].id_producto == $scope.datap.id_producto) {
                            itemActual = $scope.rowCollection[i];
                        }
                    }
                    if (!itemActual) {
                        $scope.rowCollection.push(_.extend({
                            id: ++item,
                            id_producto: $scope.datap.id_producto,
                            no_producto: $scope.datap.no_producto,
                            nu_cantidad_p: $scope.datap.nu_cantidad_p,
                            nu_precio_unitario: $scope.datap.mto_ult_venta,
                            pr_descuento: $scope.datap.pr_descuento,
                            nu_precio_descuento: monto,
                            nu_total: (parseFloat($scope.datap.nu_cantidad_p) * parseFloat(monto)).toFixed(2)
                        },
                            $scope.datap)
                        );
                        $scope.rowCollection2 = [];
                        $scope.rowCollection2.push(_.extend({
                            id: ++item2,
                            id_producto: $scope.datap.id_producto,
                            no_producto: $scope.datap.no_producto,
                            nu_cantidad_p: $scope.datap.nu_cantidad_p,
                            nu_precio_unitario: $scope.datap.mto_ult_venta,
                            pr_descuento: $scope.datap.pr_descuento,
                            nu_precio_descuento: monto,
                            nu_total: (parseFloat($scope.datap.nu_cantidad_p) * parseFloat(monto)).toFixed(2)
                        },
                            $scope.datap)
                        );
                    } else {
                        itemActual.nu_cantidad_p = parseInt(itemActual.nu_cantidad_p) + parseInt($scope.datap.nu_cantidad_p);
                        itemActual.nu_total = itemActual.nu_cantidad_p * itemActual.nu_precio;
                    }
                    $scope.data.nu_total = $filter('Total')($scope.rowCollection, 'nu_cantidad_p', 'nu_precio_descuento', 2);
                    $scope.data.nu_sub_total = parseFloat($scope.data.nu_total / 1.18).toFixed(2);
                    $scope.data.nu_igv = parseFloat($scope.data.nu_total - $scope.data.nu_sub_total).toFixed(2);
                    angular.extend($scope.datap, $scope.defaultp);
                    $scope.jDescuento = [];

                } else {
                    var typeNotification = 'error';
                    toastr[typeNotification]('Ingrese Cantidad', 'Información del Sistema');
                }

            };

            $scope.quitar_producto = function (id) {
                console.log(id);
                $scope.rowCollection = $scope.rowCollection.filter(function (item) {
                    return item.id != id;
                });
                $scope.data.nu_total = $filter('Total')($scope.rowCollection, 'nu_cantidad_p', 'nu_precio_descuento', 2);
                $scope.data.nu_sub_total = parseFloat($scope.data.nu_total / 1.18).toFixed(2);
                $scope.data.nu_igv = parseFloat($scope.data.nu_total - $scope.data.nu_sub_total).toFixed(2);
            };


            $scope.guardar = function () {
                var params = { orden: $scope.data, detalle: $scope.rowCollection };
                serviceAPI.guardarCotizacion(params).success(function (r) {
                    var typeNotification = 'error';
                    if (r.success) {
                        typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                    }
                    toastr[typeNotification](r.messages, 'Registro de Cotización');
                    angular.extend($scope.data, $scope.default);
                    angular.extend($scope.datap, $scope.defaultp);
                    $scope.rowCollection = [];
                });
            };

            $scope.buscarCodigoBarras = function () {
                serviceAPI.buscarProductoxCodigoVenta($scope.datap).success(function (r) {
                    if (r.success && r.num_rows == 1) {
                        angular.extend($scope.datap, r.rows);
                        $scope.datap.nu_cantidad = 1;
                        serviceAPI.getTipoDescuentoMarca($scope.datap.id_marca).success(function (r) {
                            if (r.totalItemCount > 0 && r.success) {
                                angular.extend($scope.jDescuento, r.rows);
                            }
                        });

                        //$scope.addItem();
                    }
                });
            }

            $scope.limpiar = function () {
                angular.extend($scope.datap, $scope.defaultp);
            }

            $scope.getMontoDescuento = function (value) {
                serviceAPI.consultarMontoDescuento(value).then(function (r) {
                    if (r.data.success && r.data.num_rows == 1) {
                        var desc = (r.data.rows.pr_descuento * $scope.datap.mto_ult_venta) / 100;
                        $scope.datap.pr_descuento = r.data.rows.pr_descuento;
                        $scope.datap.mto_descueto = parseFloat($scope.datap.mto_ult_venta - desc).toFixed(2);
                    }
                });
            }


            $scope.consultar = function () {
                if ($stateParams.idcotizacion != '') {
                    serviceAPI.consultaCotizacion({ id: $stateParams.idcotizacion }).success(function (r) {
                        var typeNotification = (!r.success) ? 'error' : 'warning';
                        if (r.success && r.num_rows == 1) {
                            console.log(r);
                            typeNotification = 'success';
                            angular.extend($scope.data, r.rows);
                            $scope.jComprobante.map(function (b) {
                                console.log(b.id);
                                console.log(r.rows.id_tipo_comprobante);
                                if (b.id == r.rows.id_tipo_comprobante) {
                                    $scope.data.id_tipo_comprobante = b;
                                }
                            });

                            $scope.jtipopago.map(function (c) {
                                console.log(c.id);
                                console.log(r.rows.id_tipo_pago);
                                if (c.id == r.rows.id_tipo_pago) {
                                    $scope.data.id_tipo_pago = c;
                                }
                            });
                            serviceAPI.getCotizacionId($scope.data.id_cotizacion).success(function (rs) {
                                var lstDetalle = [];
                                if (rs.success && rs.totalItemCount > 0) {
                                    angular.extend(lstDetalle, rs.rows);
                                    for (var i = 0; i < lstDetalle.length; i++) {
                                        var value = lstDetalle[i];
                                        console.log(value);
                                        $scope.rowCollection.push(_.extend({
                                            id: ++item,
                                            id_producto: value.id_producto,
                                            no_producto: value.no_producto,
                                            nu_cantidad_p: value.nu_cantidad,
                                            nu_precio_unitario: value.nu_precio_unitario,
                                            pr_descuento: value.pr_descuento,
                                            nu_precio_descuento: value.nu_precio_descuento,
                                            nu_total: (parseFloat(value.nu_cantidad) * parseFloat(value.nu_precio_descuento)).toFixed(2)
                                        },
                                            value)
                                        );
                                    }
                                    $scope.data.nu_total = $filter('Total')($scope.rowCollection, 'nu_cantidad_p', 'nu_precio_descuento', 2);
                                    $scope.data.nu_sub_total = parseFloat($scope.data.nu_total / 1.18).toFixed(2);
                                    $scope.data.nu_igv = parseFloat($scope.data.nu_total - $scope.data.nu_sub_total).toFixed(2);
                                }
                            });
                            toastr[typeNotification](r.messages, 'Información de Compra');
                        }
                    });
                };
            }


            }]);




    })();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.cobranzas.cobranza', [])
        .controller('cobranzaListCtrl', ['$scope', 'serviceAPI', '$state', function ($scope, serviceAPI, $state) {
            $scope.displayed = [];
            $scope.callServer = function (tableState) {
                var params = angular.extend({}, tableState.pagination, tableState.search);
                serviceAPI.getCobranza(params).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        $scope.displayed = r.rows;
                        tableState.pagination.numberOfPages = r.numberOfPages;
                    }
                });
            };
            $scope.agregar = function () {
                $state.go('dashboard.cobranzas.cobranza-details');
            };
            $scope.editar = function (id_proveedor) {
                $state.go('dashboard.cobranzas.cobranza-details', { idProveedor: id_proveedor });
            };
            $scope.eliminar = function (idProveedor) {
                serviceAPI.eliminarProveedor({ id: idProveedor }).success(function (r) {
                    console.log(r);
                    var typenotify = (r.success) ? 'warning' : 'error';
                    if (r.affected_rows == 1) {
                        typenotify = 'success';
                        $scope.displayed = $scope.displayed.filter(function (i) { return (i.id_proveedor != idProveedor) });
                    }
                    toastr[typenotify](r.messages, 'Listado de Proveedores')
                });
            };



            $scope.changeStatus = function (idProveedor, actividad, index) {
                serviceAPI.cambiarStatusProveedor({ id: idProveedor, status: actividad }).success(function (r) {
                    var typenotify = 'error';
                    if (r.num_rows == 0) {
                        typenotify = 'warning';
                        $scope.displayed = $scope.displayed.filter(function (i) { return (i.id_proveedor != idProveedor); })
                    }
                    if (r.affected_rows == 1) {
                        typenotify = 'success';
                        $scope.displayed[index].status = r.rows.status;
                    }
                    toastr[typenotify](r.messages, 'Listado de Proveedores');
                });
            };
        }])
        .controller('cobranzaCtrl', ['$scope', '$uibModal', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', function ($scope, $uibModal, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log) {
            var vm = this;
            $scope.default = { id_cobranza: 0, fe_emision: '', nu_total_c: 0, id_tipo_comprobante_c: 0, nu_serie_c: '', nu_correlativo_c: '', id_tipo_comprobante: 0, id_comprobante: 0, nu_serie: '', nu_correlativo: '', nu_sub_total: 0, nu_igv: 0, nu_total: 0, il_estado: 0 };
            $scope.data = { id_cobranza: 0, fe_emision: '', nu_total_c: 0, id_tipo_comprobante_c: 0, nu_serie_c: '', nu_correlativo_c: '', id_tipo_comprobante: 0, id_comprobante: 0, nu_serie: '', nu_correlativo: '', nu_sub_total: 0, nu_igv: 0, nu_total: 0, il_estado: 0 };
            $scope.datam = { id_cobranza_cuota: 0, id_cobranza: 0, nu_cuota: 0, id_tipo_medio_pago: 0, no_medio_pago: '', nu_monto: 0 };
            $scope.defaultm = { id_cobranza_cuota: 0, id_cobranza: 0, nu_cuota: 0, id_tipo_medio_pago: 0, no_medio_pago: '', nu_monto: 0 };

            $scope.jComprobanteBolFac = [];
            $scope.jComprobante = [];
            $scope.jtipopago = [];

            $scope.operacion = function (value) {
                console.log(value);
                $scope.datam.id_tipo_medio_pago = value;
            }

            serviceAPI.getComprobantesFacBol().success(function (r) {
                if (r.totalItemCount > 0 && r.success) {
                    angular.extend($scope.jComprobanteBolFac, r.rows);
                }
            });
            serviceAPI.getComprobanteCobranza().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jComprobante, r.rows);
                }
            });
            serviceAPI.getTipoMedioPago().success(function (r) {
                if (r.totalItemCount > 0 && r.success) {
                    angular.extend($scope.jtipopago, r.rows);
                }
            });


            $scope.getCorrelativo = function (value) {
                console.log(value);
                serviceAPI.consultarCorrelativo(value).then(function (r) {
                    console.log(r);
                    if (r.data.success && r.data.num_rows == 1) {
                        console.log(r);
                        $scope.data.nu_serie = r.data.rows.nu_serie;
                        $scope.data.nu_correlativo = $scope.zfill(r.data.rows.nu_correlativo, 8);
                    }
                });
            }

            $scope.getComprobantesoBoloFac = function (value) {
                $scope.jComprobanteNota = [];
                $scope.data.nu_sub_total = 0;
                $scope.data.nu_igv = 0;
                $scope.data.nu_total = 0;
                serviceAPI.getCompBoloFac(value).then(function (r) {

                    if (r.data.success && r.data.totalItemCount > 0) {
                        angular.extend($scope.jComprobanteNota, r.data.rows);

                    }
                });
            }

            $scope.zfill = function (number, width) {
                var numberOutput = Math.abs(number); /* Valor absoluto del número */
                var length = number.toString().length; /* Largo del número */
                var zero = "0"; /* String de cero */

                if (width <= length) {
                    if (number < 0) {
                        return ("-" + numberOutput.toString());
                    } else {
                        return numberOutput.toString();
                    }
                } else {
                    if (number < 0) {
                        return ("-" + (zero.repeat(width - length)) + numberOutput.toString());
                    } else {
                        return ((zero.repeat(width - length)) + numberOutput.toString());
                    }
                }
            }


            $scope.getMontoComprobante = function (value) {
                serviceAPI.getIdComprobanteCobranza(value).then(function (r) {
                    if (r.data.success && r.data.num_rows > 0) {
                        angular.extend($scope.data, r.data.rows);
                    }
                });
            }

            $scope.rowCollection = [];
            var item = 0;
            var mMonto = 0;
            var mMontoValidator = 0;
            $scope.addItem = function () {
                console.log($scope.datam);
                var itemActual;
                if ($scope.data.nu_total != 0) {
                    if ($scope.datam.nu_monto != 0) {
                        mMontoValidator = (parseFloat(mMonto) + parseFloat($scope.datam.nu_monto)).toFixed(2);
                        console.log(mMontoValidator);
                        if (mMontoValidator > $scope.data.nu_total) {
                            var typeNotification = 'error';
                            toastr[typeNotification]('El monto ingresado supera el monto total', 'Información del Sistema');
                        } else {
                            mMonto = (parseFloat(mMonto) + parseFloat($scope.datam.nu_monto)).toFixed(2);
                            $scope.rowCollection.push(_.extend({
                                id: ++item,
                                id_tipo_medio_pago_p: $scope.datam.id_tipo_medio_pago.id_tipo_medio_pago,
                                no_tipo_medio_pago: $scope.datam.id_tipo_medio_pago.no_tipo_medio_pago,
                                no_medio_pago: $scope.datam.no_medio_pago,
                                nu_monto: $scope.datam.nu_monto
                            },
                                $scope.datam)
                            )
                        }

                        angular.extend($scope.datam, $scope.defaultm);
                    } else {
                        var typeNotification = 'error';
                        toastr[typeNotification]('Ingrese Monto', 'Información del Sistema');
                    }
                } else {
                    var typeNotification = 'error';
                    toastr[typeNotification]('Seleccione Comprobante a Pagar', 'Información del Sistema');
                }

            };

            $scope.quitar_producto = function (value) {
                $scope.rowCollection = $scope.rowCollection.filter(function (item) {
                    return item.id != value.id;
                });
                mMonto = (parseFloat(mMonto) - parseFloat(value.nu_monto)).toFixed(2);
            };

            $scope.guardar = function () {
                var params = { orden: $scope.data, detalle: $scope.rowCollection };
                serviceAPI.guardarCobranza(params).success(function (r) {
                    var typeNotification = 'error';
                    if (r.success) {
                        typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                    }
                    toastr[typeNotification](r.messages, 'Registro de Cobranza Correctamente');
                    angular.extend($scope.data, $scope.default);
                    $scope.rowCollection = [];
                });
            };

            $scope.consultar = function () {
                if ($stateParams.idcobranza != '') {
                    serviceAPI.consultaCobranza({ id: $stateParams.idcobranza }).success(function (r) {
                        console.log(r);
                        var typeNotification = (!r.success) ? 'error' : 'warning';
                        if (r.success && r.num_rows == 1) {
                            console.log(r);
                            typeNotification = 'success';
                            angular.extend($scope.data, r.rows);

                            $scope.jComprobanteBolFac.map(function (c) {
                                if (c.id == r.rows.id_tipo_comprobante_c) {
                                    $scope.data.id_tipo_comprobante_c = c;
                                }
                            });
                            $scope.jComprobante.map(function (b) {
                                if (b.id == r.rows.id_tipo_comprobante) {
                                    $scope.data.id_tipo_comprobante = b;
                                }
                            });

                            serviceAPI.getCompBoloFac($scope.data).then(function (rp) {
                                console.log(rp.data);
                                $scope.jComprobanteNota = rp.data.rows;
                                console.log($scope.jComprobanteNota);
                                $scope.jComprobanteNota.map(function (z) {
                                    if (z.id == r.rows.id_comprobante) {
                                        $scope.data.id_comprobante = z;
                                    }
                                });
                            });




                            serviceAPI.getCobranzaId($scope.data.id_cobranza).success(function (rs) {
                                var lstDetalle = [];
                                if (rs.success && rs.totalItemCount > 0) {
                                    angular.extend(lstDetalle, rs.rows);
                                    for (var i = 0; i < lstDetalle.length; i++) {
                                        var value = lstDetalle[i];
                                        mMonto = (parseFloat(mMonto) + parseFloat(value.nu_monto)).toFixed(2);
                                        console.log(value);
                                        $scope.rowCollection.push(_.extend({
                                            id: ++item,
                                            id_tipo_medio_pago_p: value.id_tipo_medio_pago_p,
                                            no_tipo_medio_pago: value.no_tipo_medio_pago,
                                            no_medio_pago: value.no_medio_pago,
                                            nu_monto: value.nu_monto
                                        },
                                            value)
                                        )
                                    }
                                }
                            });
                            toastr[typeNotification](r.messages, 'Información de Cobranza');
                        }
                    });
                };
            }

        }]);

})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.compras.compra', [])
        .controller('compralistCtrl', ['$scope', '$uibModal', 'serviceAPI', '$state', function ($scope, $uibModal,serviceAPI, $state) {
            $scope.data = { nu_compras: 0, nu_total: 0 };
            $scope.displayed = [];
            $scope.callServer = function (tableState) {
                var params = angular.extend({}, tableState.pagination, tableState.search);
                serviceAPI.getCompras(params).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        $scope.displayed = r.rows;
                        tableState.pagination.numberOfPages = r.numberOfPages;
                    }
                });
            };

            $scope.consultar = function () {
                serviceAPI.consultarTotales().success(function (r) {
                    var typeNotification = (!r.success) ? 'error' : 'warning';
                    if (r.success && r.num_rows == 1) {
                        typeNotification = 'success';
                        angular.extend($scope.data, r.rows);
                    }
                    toastr[typeNotification](r.messages, 'Información Total');
                });
            };
            $scope.agregar = function () {
                $state.go('dashboard.compras.compra-details');
            };
            $scope.editar = function (id) {
                $state.go('dashboard.compras.compra-details', { idCompras: id_compras });
            };
            $scope.changeStatus = function (id) {

            };

            $scope.openPdfCompra = function (size, item) {
                console.log('entro');
                $scope.item = item;
                $uibModal.open({
                    animation: true,
                    templateUrl: "app/pages/compras/compra/modal/modalPdf.html",
                    size: size,
                    controller: 'modalCompraCtrl',
                    scope: $scope,
                    resolve: {
                        item: function () { }
                    }
                }).result.then(function (item) {
                    angular.extend($scope.data, item);
                }, function () {

                });
            };


        }])
        .controller('compraModelCtrl', ['$scope', 'serviceAPI', 'item', '$http', '$httpParamSerializerJQLike', '$uibModalInstance', function ($scope, serviceAPI, item, $http, $httpParamSerializerJQLike, $uibModalInstance) {

            $scope.item = $scope.$parent.item || false;
            $scope.status = 0;
            $scope.respuesta = 0;
            $scope.archivo = '';
            $scope.url = '';

            $scope.displayed = [];
            $scope.callServer = function (tableState) {
                var params = angular.extend({}, tableState.pagination, tableState.search);
                serviceAPI.getInsumos(params).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        $scope.displayed = r.rows;
                        tableState.pagination.numberOfPages = r.numberOfPages;
                    }
                });
            };
            $scope.obtenerInsumo = function (insumo) {
                $uibModalInstance.close(insumo);
            };

            $scope.miFormato = function (valor) {
                return isNaN(valor) ? valor : parseFloat(valor).toFixed(2);
            }

        }])
        .controller('modalCompraCtrl', ['$scope', 'item', '$http', '$httpParamSerializerJQLike', '$uibModalInstance', function ($scope, item, $http, $httpParamSerializerJQLike, $uibModalInstance) {
            $scope.item = $scope.$parent.item || false;
            $scope.status = 0;
            $scope.respuesta = 0;
            $scope.archivo = '';
            $scope.url = '';

            if (angular.isObject($scope.item)) {
                console.log($scope.item);
                $scope.archivo = 'api/api-omeo/examples/report/boleta.php';
            }

            $scope.pdf = function () {
                $uibModalInstance.close($scope.item);
            }


            $scope.cerrar = function (data) {
                $uibModalInstance.close($scope.data);

            }
            $scope.enviaCorreo = function () {
                $http({
                    url: 'api/ventas.php',
                    method: 'POST',
                    data: $httpParamSerializerJQLike({ oper: 'envioCorreo', info: $scope.item }),
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }).then(function (response) {
                    if (response.data.success) {
                        $("#result").html(response.data.message);
                    } else
                        $("#result").html(response.data.message);
                }, function (response) {
                    toastr.error("ha fallado el proceso ", 'Error')
                });
            };



        }])
        .controller('compraCtrl', ['$scope', '$uibModal', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', '$filter', function ($scope, $uibModal, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log, $filter) {
            var vm = this;
            $scope.default = {id_compra_cabecera:0,id_empresa:0,id_local:0,id_proveedor:0,id_tipo_comprobante:0,nu_comprobante:'',id_usuario:0, nu_serie :'',nu_correlativo :'',nu_sub_total :0,  nu_igv :0, nu_total :0, fe_emision :'',id_condicion_pago:0,fe_pago:'',id_tipo_documento:0 , nu_documento:'' , no_proveedor:''};
            $scope.data = {id_compra_cabecera:0,id_empresa:0,id_local:0,id_proveedor:0,id_tipo_comprobante:0,nu_comprobante:'',id_usuario:0, nu_serie :'',nu_correlativo :'',nu_sub_total :0,  nu_igv :0, nu_total :0, fe_emision :'',id_condicion_pago:0,fe_pago:'',id_tipo_documento:0 , nu_documento:'' , no_proveedor:''};
            $scope.datap = { id_producto: 0,igv:0,id_marca: 0,nu_stock_minimo:0,co_producto:'', codigo: '', no_producto: '', id_categoria: 0, id_medida: 0, no_medida: '', id_tipo_producto: 0, no_descripcion: '', id_atributo: 0, id_parent_atributo: 0, mto_ult_compra: 0, id_empresa: 0, id_local: 0 ,nu_cantidad:0 ,co_barra : ''};
            $scope.defaultp = { id_producto: 0,igv:0,id_marca: 0,nu_stock_minimo:0,co_producto:'', codigo: '', no_producto: '', id_categoria: 0, id_medida: 0, no_medida: '', id_tipo_producto: 0, no_descripcion: '', id_atributo: 0, id_parent_atributo: 0, mto_ult_compra: 0, id_empresa: 0, id_local: 0 ,nu_cantidad:0,co_barra : ''};

            $scope.jEmpresa = [];
            $scope.jSucursal = [];
            $scope.jTipoDocumento = [];
            $scope.jTipoComprobante = [];
            $scope.jCondicionPago = [];
            $scope.rowCollection=[];

            serviceAPI.getTiposDocumentos().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jTipoDocumento, r.rows);
                }
            });

            serviceAPI.getEmpresas().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jEmpresa, r.rows);
                }
            });

            $scope.getSucursal = function (value) {
                serviceAPI.getSucursalId(value).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        angular.extend($scope.jSucursal, r.rows);
                    }
                });
            }

            serviceAPI.getTipoComprobante().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jTipoComprobante, r.rows);
                }
            });

            serviceAPI.getCondicionPago().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jCondicionPago, r.rows);
                }
            });

            $scope.getCorrelativo = function (value) {
                serviceAPI.consultarSucursal({ id: value }).then(function (r) {
                    if (r.data.success && r.data.num_rows == 1) {
                        $scope.data.nu_serie = r.data.rows.nu_serie;
                        $scope.data.nu_correlativo = $scope.zfill(r.data.rows.nu_correlativo,8);
                    }
                });
            }
            $scope.zfill = function (number, width){
                var numberOutput = Math.abs(number); /* Valor absoluto del número */
                var length = number.toString().length; /* Largo del número */ 
                var zero = "0"; /* String de cero */  
                
                if (width <= length) {
                    if (number < 0) {
                         return ("-" + numberOutput.toString()); 
                    } else {
                         return numberOutput.toString(); 
                    }
                } else {
                    if (number < 0) {
                        return ("-" + (zero.repeat(width - length)) + numberOutput.toString()); 
                    } else {
                        return ((zero.repeat(width - length)) + numberOutput.toString()); 
                    }
                }
            }

            $scope.crearProveedor = function (size) {
                $uibModal.open({
                    animation: true,
                    size: size,
                    templateUrl: "app/pages/compras/proveedor/proveedorModal.html",
                    controller: 'proveedorCtrl',
                    scope: $scope
                }).result.then(function (data) {
                    angular.extend($scope.data, data);
                }, function () {
                    console.log('Modal dismissed at: ' + new Date());
                });
            };

            $scope.modalProveedor = function (size) {
                $uibModal.open({
                    animation: true,
                    size: size,
                    templateUrl: "app/pages/compras/proveedor/list/proveedorListModal.html",
                    controller: 'proveedorModalCtrl',
                    scope: $scope
                }).result.then(function (data) {
                    console.log(data);
                    angular.extend($scope.data, data);
                }, function () {
                    console.log('Modal dismissed at: ' + new Date());
                });
            };

            $scope.modalProducto = function (size) {
                $uibModal.open({
                    animation: true,
                    size: size,
                    templateUrl: "app/pages/catalogo/producto/list/productoListModalN.html",
                    controller: 'productoModalCtrl',
                    scope: $scope
                }).result.then(function (data) {
                    angular.extend($scope.datap, data);
                }, function () {
                    console.log('Modal dismissed at: ' + new Date());
                });
            };


            $scope.selection=[];

            $scope.toggleSelection = function toggleSelection(fruitName) {
                console.log(fruitName);
                var idx = $scope.selection.indexOf(fruitName);
                if (idx > -1) {
                  $scope.selection.splice(idx, 1);
                }
                else {
                  $scope.selection.push(fruitName);
                }
                console.log($scope.selection);
            };   
            $scope.rowCollection = [];
            var item = 0;
            var item2 = 0;
            $scope.addItem = function () {

                var itemActual;
                if ($scope.datap.nu_cantidad != 0) {
                        for (var i = 0; i < $scope.rowCollection.length; i++) {
                            if ($scope.rowCollection[i].id_producto == $scope.datap.id_producto) {
                                itemActual = $scope.rowCollection[i];
                            }
                        }
                        if (!itemActual) {
                            $scope.rowCollection.push(_.extend({
                                id: ++item,
                                id_producto: $scope.datap.id_producto,
                                co_producto: $scope.datap.co_producto,
                                no_producto: $scope.datap.no_producto,
                                nu_cantidad: $scope.datap.nu_cantidad,
                                nu_precio: $scope.datap.mto_ult_compra,
                                nu_total: (parseFloat($scope.datap.nu_cantidad) * parseFloat($scope.datap.mto_ult_compra)).toFixed(2)
                            },
                                $scope.datap)
                            );
                            $scope.rowCollection2 = [];
                            $scope.rowCollection2.push(_.extend({
                                id: ++item2,
                                id_producto: $scope.datap.id_producto,
                                co_producto: $scope.datap.co_producto,
                                no_producto: $scope.datap.no_producto,
                                nu_cantidad: $scope.datap.nu_cantidad,
                                nu_precio: $scope.datap.mto_ult_compra,
                                nu_total: (parseFloat($scope.datap.nu_cantidad) * parseFloat($scope.datap.mto_ult_compra)).toFixed(2)
                            },
                                $scope.datap)
                            );
                        } else {
                            itemActual.nu_cantidad = parseInt(itemActual.nu_cantidad) + parseInt($scope.datap.nu_cantidad);
                            itemActual.nu_total = itemActual.nu_cantidad * itemActual.nu_precio;
                        }
                        $scope.data.nu_total = $filter('Total')($scope.rowCollection, 'nu_cantidad', 'nu_precio', 2);
                        $scope.data.nu_sub_total = parseFloat($scope.data.nu_total / 1.18).toFixed(2);
                        $scope.data.nu_igv = parseFloat($scope.data.nu_total - $scope.data.nu_sub_total).toFixed(2);
                        angular.extend($scope.datap, $scope.defaultp);
                    
                } else {
                    var typeNotification = 'error';
                    toastr[typeNotification]('Ingrese Cantidad', 'Información del Sistema');
                }  

            };

            $scope.quitar_producto = function (id) {
                console.log(id);
                $scope.rowCollection = $scope.rowCollection.filter(function (item) {
                    return item.id != id;
                });
                $scope.data.nu_total = $filter('Total')($scope.rowCollection, 'nu_cantidad', 'nu_precio', 2);
                $scope.data.nu_sub_total = parseFloat($scope.data.nu_total / 1.18).toFixed(2);
                $scope.data.nu_igv = parseFloat($scope.data.nu_total - $scope.data.nu_sub_total).toFixed(2);
            };


            $scope.guardar = function () {
                var params = { orden: $scope.data, detalle: $scope.rowCollection };
                serviceAPI.guardarOrdenCompra(params).success(function (r) {
                    var typeNotification = 'error';
                    if (r.success) {
                        typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                    }
                    toastr[typeNotification](r.messages, 'Registro Orden de Compras');
                    angular.extend($scope.data, $scope.default);
                    angular.extend($scope.datap, $scope.defaultp);
                    $scope.rowCollection = [];
                });
            };

            $scope.buscarCodigoBarras = function(){
                serviceAPI.buscarProductoxCodigo($scope.datap).success(function (r) {  
                    if (r.success && r.num_rows == 1) {
                        angular.extend($scope.datap, r.rows);
                        //$scope.datap.nu_cantidad = 1;
                        //$scope.addItem();
                    }
                });
            }

            $scope.limpiar = function(){
                angular.extend($scope.datap,$scope.defaultp);
            }


            $scope.consultar = function () {
                if ($stateParams.idCompras != '') {                    
                    serviceAPI.consultaCompra({ id: $stateParams.idCompras }).success(function (r) {   
                        console.log(r);                 
                        var typeNotification = (!r.success) ? 'error' : 'warning';
                        if (r.success && r.num_rows == 1) {
                            typeNotification = 'success';
                            console.log(r);
                            angular.extend($scope.data, r.rows);
                            $scope.jEmpresa.map(function(b){
                                if(b.id_empresa+''==r.rows.id_empresa+''){ 
                                    $scope.data.id_empresa=b; 
                                    console.log($scope.data.id_empresa);
                                    serviceAPI.getSucursalId({id_empresa : $scope.data.id_empresa.id_empresa}).then(function (rs) {
                                        console.log(rs);
                                        if (rs.data.success && rs.data.totalItemCount > 0) {
                                            angular.extend($scope.jSucursal, rs.data.rows);
                                            $scope.jSucursal.map(function (c) {
                                                if (c.id_local == r.rows.id_local) { $scope.data.id_local = c; }
                                            })
                                        }
                                    });
                                }
                            });

                            serviceAPI.getCompraDetalleId($scope.data.id_compra_cabecera).success(function (rs) {
                                var lstDetalle = [];
                                if (rs.success && rs.totalItemCount > 0) {
                                    angular.extend(lstDetalle, rs.rows);
                                    for (var i = 0; i < lstDetalle.length; i++) {
                                        var value = lstDetalle[i];
                                        console.log(value);
                                        $scope.rowCollection.push(_.extend({
                                            id: ++item,
                                            id_producto: value.id_producto,
                                            co_producto: value.co_producto,
                                            no_producto: value.no_producto,
                                            nu_cantidad: value.nu_cantidad,
                                            nu_precio: value.nu_precio_unitario,
                                            nu_total: (parseFloat(value.nu_cantidad) * parseFloat(value.nu_precio_unitario)).toFixed(2)
                                        },
                                            value)
                                        );
                                    }
                                    $scope.data.nu_total = $filter('Total')($scope.rowCollection, 'nu_cantidad', 'nu_precio', 2);
                                    $scope.data.nu_sub_total = parseFloat($scope.data.nu_total / 1.18).toFixed(2);
                                    $scope.data.nu_igv = parseFloat($scope.data.nu_total - $scope.data.nu_sub_total).toFixed(2);
                                }
                            });
                           
                            
                        }
                        toastr[typeNotification](r.messages, 'Información de Compra');
                    });
                }
            };




        }]);
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.compras.facturaprov', [])
        .controller('facturaprovlistCtrl', ['$scope', 'serviceAPI', '$state', function ($scope, serviceAPI, $state) {
            $scope.displayed = [];
            $scope.callServer = function (tableState) {
                var params = angular.extend({}, tableState.pagination, tableState.search);
                serviceAPI.listarFacturaProveedor(params).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        $scope.displayed = r.rows;
                        tableState.pagination.numberOfPages = r.numberOfPages;
                    }
                });

                $scope.agregar = function () {
                    $state.go('dashboard.compras.facturaprov-details');
                };
                $scope.editar = function (id) {
                    $state.go('dashboard.compras.facturaprov-details', { idfacturaprov: id_compras });
                };
            };
        }])
        .controller('facturaprovCtrl', ['$scope', '$uibModal', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', '$filter', function ($scope, $uibModal, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log, $filter) {
            var vm = this;
            $scope.default = {id_compra_cabecera:0,id_proveedor:0,id_tipo_comprobante:0,nu_comprobante:'', id_tipo_medio_pago:0,fe_pago:'',id_tipo_documento:0 , nu_documento:'' , no_proveedor:'', nu_serie_oc : '' ,nu_correlativo_oc:'' ,nu_operacion:''};
            $scope.data = {id_compra_cabecera:0,id_proveedor:0,id_tipo_comprobante:0,nu_comprobante:'', id_tipo_medio_pago:0,fe_pago:'',id_tipo_documento:0 , nu_documento:'' , no_proveedor:'', nu_serie_oc : '' ,nu_correlativo_oc:'' ,nu_operacion:''};
          
            $scope.jEmpresa = [];
            $scope.jSucursal = [];
            $scope.jTipoDocumento = [];
            $scope.jComprobante = [];
            $scope.jtipopago = [];
            $scope.rowCollection=[];
            $scope.jOrdenCompra=[];

            serviceAPI.getTipoComprobante().success(function (r) {
                console.log(r);
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jComprobante, r.rows);
                }
            });
            
            serviceAPI.getTipoMedioPago().success(function (r) {
                console.log(r);
                if (r.totalItemCount > 0 && r.success) {
                    angular.extend($scope.jtipopago, r.rows);
                }
            });

            $scope.modalProveedor = function (size) {
                $uibModal.open({
                    animation: true,
                    size: size,
                    templateUrl: "app/pages/compras/proveedor/list/proveedorListModal.html",
                    controller: 'proveedorModalCtrl',
                    scope: $scope
                }).result.then(function (data) {
                    console.log(data);
                    angular.extend($scope.data, data);
                    $scope.getOrdenCompra(data);
                }, function () {
                    console.log('Modal dismissed at: ' + new Date());
                });
            };



          
            $scope.getOrdenCompra = function (value) {
                serviceAPI.getOrdenCompra(value).then(function (r) {
                    console.log(r);
                    if (r.data.success && r.data.totalItemCount > 0) {
                        angular.extend($scope.jOrdenCompra, r.data.rows);
                    }
                });
            }
            $scope.rowCollection = [];

            $scope.getOrdenDetalle = function(value){
                serviceAPI.getOrdenCompraDetalle(value).then(function (r) {
                    console.log(r);
                    if (r.data.success && r.data.totalItemCount > 0) {
                        angular.extend($scope.rowCollection, r.data.rows);
                    }
                    $scope.data.nu_total = $filter('Total')($scope.rowCollection, 'nu_cantidad', 'mto_ult_compra', 2);
                    $scope.data.nu_sub_total = parseFloat($scope.data.nu_total / 1.18).toFixed(2);
                    $scope.data.nu_igv = parseFloat($scope.data.nu_total - $scope.data.nu_sub_total).toFixed(2);
                });
            }

            $scope.getTipoPago = function (value){
                if(value.id_tipo_medio_pago == 3){
                    $scope.data.id_tipo_medio_pago = value;
                }              
            }

            $scope.guardar = function () {
                var params = {orden: $scope.data};
                serviceAPI.actualizarOrdenCompra(params).success(function (r) {
                    var typeNotification = 'error';
                    if (r.success) {
                        typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                    }
                    toastr[typeNotification](r.messages, 'Registro Factura Proveedor');
                    angular.extend($scope.data, $scope.default);
                    angular.extend($scope.data, $scope.defaultp);
                    $scope.rowCollection = [];
                });
            };


            $scope.limpiar = function(){
                angular.extend($scope.data,$scope.defaultp);
            }


            $scope.consultar = function () {
                if ($stateParams.idCompras != '') {                    
                    serviceAPI.consultaCompra({ id: $stateParams.idCompras }).success(function (r) {                    
                        var typeNotification = (!r.success) ? 'error' : 'warning';
                        if (r.success && r.num_rows == 1) {
                            typeNotification = 'success';
                            angular.extend($scope.data, r.rows);
                            $scope.jEmpresa.map(function(b){
                                if(b.id_empresa==r.rows.id_empresa){ $scope.data.id_empresa=b; }
                            });
                            serviceAPI.getSucursalId({id_empresa : $scope.data.id_empresa}).then(function (rs) {
                                console.log(rs);
                                if (rs.success && rs.totalItemCount > 0) {
                                    angular.extend($scope.jSucursal, rs.rows);
                                    $scope.jSucursal.map(function (c) {
                                        if (c.id_local == r.rows.id_local) { $scope.data.id_local = c; }
                                    })
                                }
                            });
                            
                        }
                        toastr[typeNotification](r.messages, 'Información de Compra');
                    });
                }
            };

        }])
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.compras.proveedor', [])
        .controller('proveedorlistCtrl', ['$scope', 'serviceAPI', '$state', function ($scope, serviceAPI, $state) {
            $scope.displayed = [];
            $scope.callServer = function (tableState) {
                var params = angular.extend({}, tableState.pagination, tableState.search);
                serviceAPI.getProveedor(params).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        $scope.displayed = r.rows;
                        tableState.pagination.numberOfPages = r.numberOfPages;
                    }
                });
            };
            $scope.agregar = function () {
                $state.go('dashboard.compras.proveedor-details');
            };
            $scope.editar = function (id_proveedor) {
                $state.go('dashboard.compras.proveedor-details', { idProveedor: id_proveedor });
            };
            $scope.eliminar = function (idProveedor) {
                serviceAPI.eliminarProveedor({ id: idProveedor }).success(function (r) {
                    console.log(r);
                    var typenotify = (r.success) ? 'warning' : 'error';
                    if (r.affected_rows == 1) {
                        typenotify = 'success';
                        $scope.displayed = $scope.displayed.filter(function (i) { return (i.id_proveedor != idProveedor) });
                    }
                    toastr[typenotify](r.messages, 'Listado de Proveedores')
                });
            };



            $scope.changeStatus = function (idProveedor, actividad, index) {
                serviceAPI.cambiarStatusProveedor({ id: idProveedor, status: actividad }).success(function (r) {
                    var typenotify = 'error';
                    if (r.num_rows == 0) {
                        typenotify = 'warning';
                        $scope.displayed = $scope.displayed.filter(function (i) { return (i.id_proveedor != idProveedor); })
                    }
                    if (r.affected_rows == 1) {
                        typenotify = 'success';
                        $scope.displayed[index].status = r.rows.status;
                    }
                    toastr[typenotify](r.messages, 'Listado de Proveedores');
                });
            };
        }])
        .controller('proveedorModalCtrl', ['$scope', 'serviceAPI', '$state', '$uibModalInstance', function ($scope, serviceAPI, $state, $uibModalInstance) {
            $scope.displayed = [];
            $scope.callServer = function (tableState) {
                var params = angular.extend({}, tableState.pagination, tableState.search);
                serviceAPI.getProveedor(params).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        $scope.displayed = r.rows;
                        tableState.pagination.numberOfPages = r.numberOfPages;
                    }
                });
            };

            $scope.obtenerProveedor = function (value) {
                $uibModalInstance.close(value);
            };

        }])
        .controller('proveedorCtrl', ['$scope', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', function ($scope, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log) {
            var vm = this;
            $scope.default = { id_proveedor: 0, id_tipo_documento: 0, id_ubigeo: '', no_proveedor: '', nu_documento: '', co_depart: '', co_provin: '', co_distri: '', no_direccion: '', nu_telefono: '', nu_celular: '', no_contacto: '', email: '', nu_cuenta_uno: '', nu_cuenta_dos: '', no_observacion: '', no_nombres: '', no_apepat: '', no_apemat: '' };
            $scope.data = { id_proveedor: 0, id_tipo_documento: 0, id_ubigeo: '', no_proveedor: '', nu_documento: '', co_depart: '', co_provin: '', co_distri: '', no_direccion: '', nu_telefono: '', nu_celular: '', no_contacto: '', email: '', nu_cuenta_uno: '', nu_cuenta_dos: '', no_observacion: '', no_nombres: '', no_apepat: '', no_apemat: '' };

            $scope.jDocumentos = [];
            $scope.a_departamento = [];
            $scope.a_provincia = [];
            $scope.a_distrito = [];

            $scope.getDatosConsulta = function (event) {
                console.log('entro');
                var id = $scope.data.id_tipo_documento;
                console.log(id);

                if (id.id == 1) {
                    console.log('entro');
                    if (event.which === 13) {
                        serviceAPI.getDni($scope.data.nu_documento).success(function (r) {
                            console.log(r);
                            angular.extend($scope.data, r);
                            $scope.data.no_proveedor = $scope.data.no_nombres + ' ' + $scope.data.no_apepat + ' ' + $scope.data.no_apemat;
                            $scope.data.no_direccion = '';
                        })
                    }
                } else if (id.id == 6) {
                    console.log('entro 2');
                    if (event.which === 13) {
                        serviceAPI.getRuc($scope.data.nu_documento).success(function (r) {
                            console.log(r);
                            angular.extend($scope.data, r);
                        })
                    }
                }

            }

            serviceAPI.getTiposDocumentos().then(function (r) {
                console.log(r);
                if (r.data.totalItemCount > 0 && r.data.success) {
                    angular.extend($scope.jDocumentos, r.data.rows);
                }
            });

            $scope.guardar = function (eForm) {
                serviceAPI.guardarUProveedor($scope.data).success(function (r) {
                    var typeNotification = 'error';
                    if (r.success) {
                        typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                    }
                    toastr[typeNotification](r.messages, 'Registro de Proveedor');
                    angular.extend($scope.data, $scope.default);
                    eForm.$setPristine();
                    eForm.$setUntouched();
                });
            };


            serviceAPI.getDepartamento().then(function (r) {
                if (r.data.totalItemCount > 0 && r.data.success) {
                    angular.extend($scope.a_departamento, r.data.rows);
                }
            });

            $scope.getpDepartamento = function () {
                serviceAPI.getProvincia($scope.data).then(function (r) {
                    if (r.data.totalItemCount > 0 && r.data.success) {
                        angular.extend($scope.a_provincia, r.data.rows);
                    }
                });
            }
            $scope.getpProvincia = function () {
                serviceAPI.getDistrito($scope.data).then(function (r) {
                    if (r.data.totalItemCount > 0 && r.data.success) {
                        angular.extend($scope.a_distrito, r.data.rows);
                    }
                });
            }

            $scope.consultar = function () {
                var _this = this;
                if ($stateParams.idProveedor != '') {
                    serviceAPI.consultarProveedor({ id_proveedor: $stateParams.idProveedor }).success(function (r) {
                        var typeNotification = (!r.success) ? 'error' : 'warning';
                        if (r.success && r.num_rows == 1) {
                            typeNotification = 'success';
                            angular.extend($scope.data, r.rows);
                            $scope.cTipoDocumento.map(function (z) {
                                if (z.id == r.rows.co_depart) { $scope.data.id_tipo_documento = z; }
                            });
                            $scope.a_departamento.map(function (a) {
                                if (a.value == r.rows.co_depart) {
                                    $scope.data.co_depart = a.value;
                                }
                            });

                            serviceAPI.getProvincia($scope.data).then(function (r) {
                                if (r.data.totalItemCount > 0 && r.data.success) {
                                    var a_provincia = [];
                                    a_provincia = _.map(r.data.rows, function (item) {
                                        return { value: item.id, text: item.no_provincia };
                                    });
                                    $scope.a_provincia = _.union($scope.a_provincia, a_provincia);
                                    $scope.a_provincia.map(function (b) {
                                        if (b.value == r.rows.co_provin) {
                                            $scope.data.co_provin = b.value;
                                        }
                                    });

                                }
                            });
                            serviceAPI.getDistrito($scope.data).then(function (r) {
                                if (r.data.totalItemCount > 0 && r.data.success) {
                                    var a_distrito = [];
                                    a_distrito = _.map(r.data.rows, function (item) {
                                        return { value: item.id, text: item.no_distrito };
                                    });
                                    $scope.a_distrito = _.union($scope.a_distrito, a_distrito);
                                    $scope.a_distrito.map(function (c) {
                                        if (c.value == r.rows.co_distri) {
                                            $scope.data.co_distri = c.value;
                                        }
                                    });
                                }
                            });
                        }
                        toastr[typeNotification](r.messages, 'Información de la Proveedor');
                    });
                }
            };

        }]);
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.comprobantes.boleta', [])
        .controller('boletaListCtrl', ['$scope', 'serviceAPI', '$state', '$uibModal', 'toastr', function ($scope, serviceAPI, $state ,$uibModal, toastr) {
            $scope.data = { nu_ventas: 0, nu_total: 0 };
            $scope.displayed = [];
            $scope.callServer = function (tableState) {
                var params = angular.extend({}, tableState.pagination, tableState.search);
                serviceAPI.listarBoleta(params).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        $scope.displayed = r.rows;
                        tableState.pagination.numberOfPages = r.numberOfPages;
                    }
                });
            };

            $scope.agregar = function () {
                $state.go('dashboard.comprobantes.boleta-details');
            };
            $scope.editar = function (id) {
                $state.go('dashboard.comprobantes.boleta-details', { idfactura: id });
            };

            $scope.openBaja= function (size, item, index) {
                $scope.item=item;
                $uibModal.open({
                    animation: true,
                    templateUrl: "app/pages/comprobantes/boleta/modal/modalbajas.html",
                    size: size,
                    controller: 'modalComprobanteCtrl',
                    scope: $scope,
                    resolve: {
                        item: function () {}
                    }
                }).result.then(function (item) {
                    angular.extend($scope.data, item);
                    if (item.success==true) {
                        $scope.rowCollection[index].no_estado=item.no_estado;
                        $scope.rowCollection[index].no_sunat=item.no_sunat;
                       $scope.rowCollection[index].id_respuesta=item.id_respuesta;
                    }
                   else{
                    $scope.rowCollection[index].no_estado=$scope.data.no_estado;
                    $scope.rowCollection[index].no_sunat=$scope.data.no_sunat;
                   $scope.rowCollection[index].id_respuesta=$scope.data.id_respuesta;
                   }
                    
                }, function(){
                    console.log('Modal dismissed at: ' + new Date());
                });
            };

            $scope.openCorreo= function (size, item) {
                $scope.item=item;
                $uibModal.open({
                    animation: true,
                    size: size,
                    controller: 'modalComprobanteCtrl',
                    scope: $scope,
                    templateUrl: "app/pages/comprobantes/boleta/modal/modalEmail.html",
                    resolve: {
                        item: function () {}
                    }
                })
            };


            $scope.openPdfBoleta = function (size, item) {
                $scope.item = item;
                $uibModal.open({
                    animation: true,
                    templateUrl: "app/pages/comprobantes/boleta/modal/modalPdf.html",
                    size: size,
                    controller: 'modalComprobanteCtrl',
                    scope: $scope,
                    resolve: {
                        item: function () { }
                    }
                }).result.then(function (item) {
                    angular.extend($scope.data, item);
                }, function () {

                });
            };
            $scope.openGenerar = function (size, item, index) {
                $scope.item=item;
                $uibModal.open({
                    animation: true,
                    templateUrl: "app/pages/comprobantes/boleta/modal/generar.html",
                    size: size,
                    controller: 'modalComprobanteCtrl',
                    scope: $scope,
                    resolve: {
                        item: function () {}
                    }
                }).result.then(function (item) {
                    angular.extend($scope.data, item);
                    if (item.success==true) {
                        $scope.displayed[index].no_estado=item.no_estado;
                        $scope.displayed[index].no_sunat=item.no_sunat;
                       $scope.displayed[index].id_respuesta=item.id_respuesta;
                    }
                   else{
                    $scope.displayed[index].no_estado=$scope.data.no_estado;
                    $scope.displayed[index].no_sunat=$scope.data.no_sunat;
                   $scope.displayed[index].id_respuesta=$scope.data.id_respuesta;
                   }
                    
                }, function(){
                    console.log('Modal dismissed at: ' + new Date());
                });
            };

            $scope.openConsulta= function (size, item) {
                $scope.item=item;
                $uibModal.open({
                    animation: true,
                    size: size,
                    controller: 'modalComprobanteCtrl',
                    scope: $scope,
                    templateUrl: "app/pages/comprobantes/boleta/modal/modalConsulta.html",
                    resolve: {
                        item: function () {}
                    }
                })
            };
            $scope.openConsultaTickets= function (size, item) {
                $scope.item=item;
                $uibModal.open({
                    animation: true,
                    size: size,
                    controller: 'modalComprobanteCtrl',
                    scope: $scope,
                    templateUrl: "app/pages/comprobantes/boleta/modal/modalBaja.html",
                    resolve: {
                        item: function () {}
                    }
                })
            };

        }])
        .controller('modalComprobanteCtrl', ['$scope', 'item', '$http', '$httpParamSerializerJQLike', '$uibModalInstance', function ($scope, item, $http, $httpParamSerializerJQLike, $uibModalInstance) {
            $scope.item = $scope.$parent.item || false;
            $scope.status = 0;
            $scope.respuesta = 0;
            $scope.archivo = '';
            $scope.url = '';
            $scope.data={id_estado:0,id_estado_sunat:0,no_boton:'',no_estado_sunat:'',no_estado:'', boton_sunat:''}
            $scope.obtenerData= function(){
                $uibModalInstance.close($scope.item);
              };
        
            $scope.gen=function(){
                console.log($scope.item);
                if ($scope.item.id_tipo_comprobante==1) {
                    $scope.url='api/api-ome/examples/factura.php';
                }else if ($scope.item.id_tipo_comprobante==2) {
                    $scope.url='api/api-ome/examples/boleta.php';
                }else if ($scope.item.id_tipo_comprobante==4) {
                    $scope.url='api/api-ome/examples/nota-credito.php';
                }else if ($scope.item.id_tipo_comprobante==5) {
                    $scope.url='api/api-ome/examples/nota_debito.php';
                }else if ($scope.item.id_tipo_comprobante==6) {
                    $scope.url='api/api-omec/examples/despatch.php';
                }     
                
                $http({
                    url:$scope.url,
                    method: 'POST',
                    data: $httpParamSerializerJQLike({oper:'cargar',item:$scope.item}),
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                }).then(function(response){
                    console.log(response);
                    $("#result").html(response.data.datos);
                    angular.extend($scope.data, response.data);
                    $scope.respuesta=response.data.id_estado_sunat;
                });
            }
        
            $scope.enviaCorreo = function () {
                console.log('aca');
                $http({
                    url: 'api/servicioget.php',
                    method: 'POST',
                    data: $httpParamSerializerJQLike({ oper: 'envioCorreo', info:$scope.item}),
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded'}
                }).then(function (response) {
                    if (response.data.success) {
                        $("#result").html(response.data.message);
                    }else
                    $("#result").html(response.data.message);
                }, function (response) {
                    toastr.error("ha fallado el proceso ", 'Error')
                });
            };
        
            $scope.consultarTickets=function(){
                $http({
                    url:'api/api-ome/examples/pages/status-cdr.php',
                    method: 'POST',
                    data: $httpParamSerializerJQLike({oper:'tickets',item:$scope.item}),
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                }).then(function(response){
                    $("#result").html(response.data.datos);
                    $("#archivo").html(response.data.archivo);
                   angular.extend($scope.data, response.data);
                   $scope.status=response.data.status;
                   $scope.respuesta=response.data.id_respuesta;
        
                });
            }
            $scope.darBaja=function(){
                $http({
                    url:'api/api-ome/examples/comunicacion-baja.php',
                    method: 'POST',
                    data: $httpParamSerializerJQLike({oper:'cargar',item:$scope.item}),
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                }).then(function(response){
                    $("#result").html(response.data.datos);
                    $("#tickets").html(response.data.tikets);
                   angular.extend($scope.data, response.data);
                   $scope.status=response.data.status;
                   $scope.respuesta=response.data.id_respuesta;
                });
            }
        
            $scope.consul=function(){
                $http({
                    url:'api/api-ome/examples/pages/status-cdr.php',
                    method: 'POST',
                    data: $httpParamSerializerJQLike({oper:'cdr',item:$scope.item}),
                    headers: {'Content-Type': 'application/x-www-form-urlencoded'},
                }).then(function(response){
                    $("#result").html(response.data.datos);
                    $("#archivo").html(response.data.archivo);
                   angular.extend($scope.data, response.data);
                   $scope.status=response.data.status;
                   $scope.respuesta=response.data.id_estado_sunat;
        
                });
            }
        
            if (angular.isObject($scope.item)) {
                console.log('entro aca boleta');
                console.log($scope.item);
                if ($scope.item.id_tipo_comprobante==1) {
                    $scope.archivo='api/api-ome/examples/report/factura.php';
                }else if ($scope.item.id_tipo_comprobante==2) {
                    $scope.archivo='api/api-ome/examples/report/boleta.php';
                }else if ($scope.item.id_tipo_comprobante==4) {
                    $scope.archivo='api/api-ome/examples/report/nota-credito.php';
                }else if ($scope.item.id_tipo_comprobante==5) {
                    $scope.archivo='api/api-ome/examples/report/nota_debito.php';
                }else if ($scope.item.id_tipo_comprobante==6) {
                    $scope.archivo='api/api-omec/examples/report/despatch.php';
                }
                
        
            }
        
            $scope.pdf = function () {
                $uibModalInstance.close($scope.item);
            }
        
        
            $scope.cerrar = function (data) {
                $uibModalInstance.close($scope.data);
        
            }
        }])
        .controller('boletaCtrl', ['$scope', '$uibModal', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', '$filter','$http', '$httpParamSerializerJQLike',  function ($scope, $uibModal, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log, $filter,$http, $httpParamSerializerJQLike ) {
            $scope.data = { id_tipo_medio_pago : 0 ,id_boleta: 0, id_cotizacion: 0, id_cliente: 0, nu_documento_entidad:'', no_cliente: '', id_tipo_comprobante: 0, nu_serie: '', nu_correlativo: '', fe_emision: '', fe_vencimiento: '', id_usuario: 0, id_empresa: 0, id_local: 0, nu_placa: '', id_tipo_documento: 0, nu_documento: '', no_observacion: '', id_motivo: 0, id_modalidad: 0, nu_bultos: 0, id_tipo_empresa: 0 ,nu_total:0};
            $scope.default = { id_tipo_medio_pago : 0 ,id_boleta: 0, id_cotizacion: 0, id_cliente: 0,nu_documento_entidad:'', no_cliente: '', id_tipo_comprobante: 0, nu_serie: '', nu_correlativo: '', fe_emision: '', fe_vencimiento: '', id_usuario: 0, id_empresa: 0, id_local: 0, nu_placa: '', id_tipo_documento: 0, nu_documento: '', no_observacion: '', id_motivo: 0, id_modalidad: 0, nu_bultos: 0, id_tipo_empresa: 0 ,nu_total:0};

            $scope.jComprobante = [];
            $scope.jtipopago = [];
            $scope.jCotizacion = [];

            serviceAPI.getTipoMedioPago().success(function (r) {
                if (r.totalItemCount > 0 && r.success) {
                    angular.extend($scope.jtipopago, r.rows);
                }
            });
            serviceAPI.getComprobanteBoleta().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jComprobante, r.rows);
                }
            });
            $scope.getCorrelativo = function (value) {
                serviceAPI.consultarCorrelativo(value).then(function (r) {
                    if (r.data.success && r.data.num_rows == 1) {
                        console.log(r);
                        $scope.data.nu_serie = r.data.rows.nu_serie;
                        $scope.data.nu_correlativo = $scope.zfill(r.data.rows.nu_correlativo, 8);
                    }
                });
            }

            $scope.zfill = function (number, width){
                var numberOutput = Math.abs(number); /* Valor absoluto del número */
                var length = number.toString().length; /* Largo del número */ 
                var zero = "0"; /* String de cero */  
                
                if (width <= length) {
                    if (number < 0) {
                         return ("-" + numberOutput.toString()); 
                    } else {
                         return numberOutput.toString(); 
                    }
                } else {
                    if (number < 0) {
                        return ("-" + (zero.repeat(width - length)) + numberOutput.toString()); 
                    } else {
                        return ((zero.repeat(width - length)) + numberOutput.toString()); 
                    }
                }
            }

            $scope.getCotizacion = function (value) {
                $scope.jCotizacion = [];
                serviceAPI.getCotizacion(value).then(function (r) {
                    console.log(r);
                    if (r.data.success && r.data.totalItemCount > 0) {
                        angular.extend($scope.jCotizacion, r.data.rows);
                    }
                });
            }

            $scope.modalProducts = function (size) {
                $uibModal.open({
                    animation: true,
                    size: size,
                    templateUrl: "app/pages/clientes/cliente/list/clienteListModal.html",
                    controller: 'clienteModalCtrl',
                    scope: $scope
                }).result.then(function (data) {
                    angular.extend($scope.data, data);                    
                    $scope.eliminarCotiTemporal();
                    $scope.getCotizacion(data);
                }, function () {
                    console.log('Modal dismissed at: ' + new Date());
                });
            };

            $scope.eliminarCotiTemporal = function () {
                $scope.rowCollection = [];
                serviceAPI.eliminarCotiTemporal().then(function (r) {
                    console.log(r);
                });
            }

            
            $scope.rowCollection = [];
            $scope.id_coti = 0;
            var k = 0;

            $scope.addItem = function () {
                console.log($scope.data)
                serviceAPI.getCotizacionId($scope.data.id_cotizacion.id).then(function (r) {
                    console.log(r);
                    var listaaCoti = [];
                    var typeNotification = 'error';
                    if (r.data.success && r.data.totalItemCount > 0) {
                        typeNotification = (r.data.affected_rows != 0) ? 'success' : 'warning';
                        angular.extend(listaaCoti, r.data.rows);
                        for (var i = 0; i < listaaCoti.length; i++) {
                            var item = listaaCoti[i];
                            $scope.rowCollection.push(_.extend({
                                id: ++k,
                                id_cotizacion: item.id_cotizacion,
                                id_producto: item.id_producto,
                                no_producto: item.no_producto,
                                no_marca: item.no_marca,
                                nu_cantidad: item.nu_cantidad,
                                nu_precio: item.nu_precio_descuento,
                                nu_total:  (parseFloat(item.nu_cantidad) * parseFloat(item.nu_precio_descuento)).toFixed(2)
                            },
                                item)
                            );
                        }
                        $scope.data.nu_total = $filter('Total')($scope.rowCollection, 'nu_cantidad', 'nu_precio', 2);
                        $scope.data.nu_sub_total = parseFloat($scope.data.nu_total / 1.18).toFixed(2);
                        $scope.data.nu_igv = parseFloat($scope.data.nu_total - $scope.data.nu_sub_total).toFixed(2);
                    }
                    toastr[typeNotification](r.messages, 'Se Agrego Correctamente la Guia');
                })
                $scope.getCotizacion($scope.data);
                $scope.data.id_cotizacion = $scope.default.id_cotizacion;
            };

            $scope.quitar_producto = function (id) {
                $scope.rowCollection = $scope.rowCollection.filter(function (item) {
                    serviceAPI.eliminarCoti(id).then(function (r) {
                        console.log('se elimino '.r.data);
                    });
                    return item.id_cotizacion != id;
                });
                $scope.data.nu_total = $filter('Total')($scope.rowCollection, 'nu_cantidad', 'nu_precio', 2);
                $scope.data.nu_sub_total = parseFloat($scope.data.nu_total / 1.18).toFixed(2);
                $scope.data.nu_igv = parseFloat($scope.data.nu_total - $scope.data.nu_sub_total).toFixed(2);
            
                $scope.getCotizacion($scope.data);
            };

            $scope.guardar = function () {
                var params = { orden: $scope.data, detalle: $scope.rowCollection };
                serviceAPI.guardarBoleta(params).success(function (r) {
                    var typeNotification = 'error';
                    if (r.success) {
                        typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                    }
                    toastr[typeNotification](r.messages, 'Registro de Boleta Correctamente');
                    angular.extend($scope.data, $scope.default);
                    $scope.rowCollection = [];
                    console.log(r);
                    serviceAPI.getBoletaIdCorreo(r.idBoleta).success(function (rr) {
                        $scope.enviaCorreoComprobante(rr.rows);
                    });


                });
            };

            $scope.enviaCorreoComprobante = function (value) {
                console.log('aca comp');
                $http({
                    url: 'api/servicioget.php',
                    method: 'POST',
                    data: $httpParamSerializerJQLike({ oper: 'envioCorreoFacturacion', info:value}),
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded'}
                }).then(function (response) {
                    if (response.data.success) {
                        $("#result").html(response.data.message);
                    }else
                    $("#result").html(response.data.message);
                }, function (response) {
                    toastr.error("ha fallado el proceso ", 'Error')
                });
            };

              

        }]);
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.comprobantes.factura', [])
        .controller('facturaListCtrl', ['$scope', 'serviceAPI', '$state', '$uibModal', 'toastr', function ($scope, serviceAPI, $state ,$uibModal, toastr) {
            $scope.data = { nu_ventas: 0, nu_total: 0 };
            $scope.data = { id_estado:0, no_boton:'warning', boton_sunat:'danger',id_estado_sunat:1, no_estado_sunat:'No Enviado', no_estado:'Generado',respuesta:0,status:0,nro_factura:'',mto_anticipo:0.00, anticipo:false, no_resu_bo: 'RC', id_compro: 0, id_serie: 0, nu_serie: 0, fe_emision: '', fe_recepcion: '', fe_vencimiento: '', fe_registro: '', IdMoneda: 0,
                id_nota: 0, va_subtotal: 0, va_igv: 0, va_total: 0, no_monto_porc: 0, nu_guia: '', no_motivo:'', co_motivo:'' };
            $scope.displayed = [];
            $scope.callServer = function (tableState) {
                var params = angular.extend({}, tableState.pagination, tableState.search);
                serviceAPI.listarFactura(params).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        $scope.displayed = r.rows;
                        tableState.pagination.numberOfPages = r.numberOfPages;
                    }
                });
            };

            $scope.agregar = function () {
                $state.go('dashboard.comprobantes.factura-details');
            };
            $scope.editar = function (id) {
                $state.go('dashboard.comprobantes.factura-details', { idfactura: id });
            };


            $scope.openPdfFactura = function (size, item) {
                $scope.item = item;
                $uibModal.open({
                    animation: true,
                    templateUrl: "app/pages/comprobantes/boleta/modal/modalPdf.html",
                    size: size,
                    controller: 'modalComprobanteCtrl',
                    scope: $scope,
                    resolve: {
                        item: function () { }
                    }
                }).result.then(function (item) {
                    angular.extend($scope.data, item);
                }, function () {

                });
            };

            $scope.openGenerar = function (size, item, index) {
                $scope.item=item;
                $uibModal.open({
                    animation: true,
                    templateUrl: "app/pages/comprobantes/boleta/modal/generar.html",
                    size: size,
                    controller: 'modalComprobanteCtrl',
                    scope: $scope,
                    resolve: {
                        item: function () {}
                    }
                }).result.then(function (item) {
                    angular.extend($scope.data, item);
                    $scope.callServer([]);
                    
                }, function(){
                    console.log('Modal dismissed at: ' + new Date());
                });
            };

            $scope.openConsulta= function (size, item) {
                $scope.item=item;
                $uibModal.open({
                    animation: true,
                    size: size,
                    controller: 'modalComprobanteCtrl',
                    scope: $scope,
                    templateUrl: "app/pages/comprobantes/boleta/modal/modalConsulta.html",
                    resolve: {
                        item: function () {}
                    }
                })
            };
            $scope.openConsultaTickets= function (size, item) {
                $scope.item=item;
                $uibModal.open({
                    animation: true,
                    size: size,
                    controller: 'modalComprobanteCtrl',
                    scope: $scope,
                    templateUrl: "app/pages/comprobantes/boleta/modal/modalBaja.html",
                    resolve: {
                        item: function () {}
                    }
                })
            };

        }])
        .controller('facturaCtrl', ['$scope', '$uibModal', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', '$filter', function ($scope, $uibModal, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log, $filter) {
            $scope.data = { id_tipo_medio_pago : 0 ,id_factura: 0, id_guia: 0, id_cliente: 0, nu_documento_entidad:'', no_cliente: '', id_tipo_comprobante: 0, nu_serie: '', nu_correlativo: '', fe_emision: '', fe_vencimiento: '', id_usuario: 0, id_empresa: 0, id_local: 0, nu_placa: '', id_tipo_documento: 0, nu_documento: '', no_observacion: '', id_motivo: 0, id_modalidad: 0, nu_bultos: 0, id_tipo_empresa: 0 };
            $scope.default = { id_tipo_medio_pago : 0 ,id_factura: 0, id_guia: 0, id_cliente: 0,nu_documento_entidad:'', no_cliente: '', id_tipo_comprobante: 0, nu_serie: '', nu_correlativo: '', fe_emision: '', fe_vencimiento: '', id_usuario: 0, id_empresa: 0, id_local: 0, nu_placa: '', id_tipo_documento: 0, nu_documento: '', no_observacion: '', id_motivo: 0, id_modalidad: 0, nu_bultos: 0, id_tipo_empresa: 0 };

            $scope.jComprobante = [];
            $scope.jtipopago = [];
            $scope.jGuia = [];

            serviceAPI.getTipoMedioPago().success(function (r) {
                if (r.totalItemCount > 0 && r.success) {
                    angular.extend($scope.jtipopago, r.rows);
                }
            });
            serviceAPI.getComprobanteFactura().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jComprobante, r.rows);
                }
            });
            $scope.getCorrelativo = function (value) {
                serviceAPI.consultarCorrelativo(value).then(function (r) {
                    if (r.data.success && r.data.num_rows == 1) {
                        console.log(r);
                        $scope.data.nu_serie = r.data.rows.nu_serie;
                        $scope.data.nu_correlativo = $scope.zfill(r.data.rows.nu_correlativo, 8);
                    }
                });
            }

            $scope.zfill = function (number, width){
                var numberOutput = Math.abs(number); /* Valor absoluto del número */
                var length = number.toString().length; /* Largo del número */ 
                var zero = "0"; /* String de cero */  
                
                if (width <= length) {
                    if (number < 0) {
                         return ("-" + numberOutput.toString()); 
                    } else {
                         return numberOutput.toString(); 
                    }
                } else {
                    if (number < 0) {
                        return ("-" + (zero.repeat(width - length)) + numberOutput.toString()); 
                    } else {
                        return ((zero.repeat(width - length)) + numberOutput.toString()); 
                    }
                }
            }

            $scope.getGuia = function (value) {
                serviceAPI.getGuia(value).then(function (r) {
                    console.log(r);
                    if (r.data.success && r.data.totalItemCount > 0) {
                        angular.extend($scope.jGuia, r.data.rows);
                    }
                });
            }

            $scope.modalProducts = function (size) {
                $uibModal.open({
                    animation: true,
                    size: size,
                    templateUrl: "app/pages/clientes/cliente/list/clienteListModal.html",
                    controller: 'clienteModalCtrl',
                    scope: $scope
                }).result.then(function (data) {
                    angular.extend($scope.data, data);
                    $scope.getGuia(data);
                }, function () {
                    console.log('Modal dismissed at: ' + new Date());
                });
            };


            
            $scope.rowCollection = [];
            $scope.id_coti = 0;
            var k = 0;

            $scope.addItem = function () {
                serviceAPI.getGuiaId($scope.data.id_guia.id).then(function (r) {
                    console.log(r);
                    var listaGuia = [];
                    var typeNotification = 'error';
                    if (r.data.success && r.data.totalItemCount > 0) {
                        typeNotification = (r.data.affected_rows != 0) ? 'success' : 'warning';
                        angular.extend(listaGuia, r.data.rows);
                        for (var i = 0; i < listaGuia.length; i++) {
                            var item = listaGuia[i];
                            $scope.rowCollection.push(_.extend({
                                id: ++k,
                                id_guia: item.id_guia,
                                id_producto: item.id_producto,
                                no_producto: item.no_producto,
                                no_marca: item.no_marca,
                                nu_cantidad: item.nu_cantidad,
                                nu_precio: item.nu_precio_descuento,
                                nu_total:  (parseFloat(item.nu_cantidad) * parseFloat(item.nu_precio_descuento)).toFixed(2)
                            },
                                item)
                            );
                        }
                        $scope.data.nu_total = $filter('Total')($scope.rowCollection, 'nu_cantidad', 'nu_precio', 2);
                        $scope.data.nu_sub_total = parseFloat($scope.data.nu_total / 1.18).toFixed(2);
                        $scope.data.nu_igv = parseFloat($scope.data.nu_total - $scope.data.nu_sub_total).toFixed(2);
                    }
                    toastr[typeNotification](r.messages, 'Se Agrego Correctamente la Guia');
                })
            };

            $scope.quitar_producto = function (id) {
                $scope.rowCollection = $scope.rowCollection.filter(function (item) {
                    return item.id_guia != id;
                });
            };

            $scope.guardar = function () {
                var params = { orden: $scope.data, detalle: $scope.rowCollection };
                serviceAPI.guardarFactura(params).success(function (r) {
                    var typeNotification = 'error';
                    if (r.success) {
                        typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                    }
                    toastr[typeNotification](r.messages, 'Registro de Guia Correctamente');
                    angular.extend($scope.data, $scope.default);
                    $scope.rowCollection = [];
                });
            };

           


              

        }]);
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.comprobantes.guia', [])
        .controller('guiaListCtrl', ['$scope', 'serviceAPI', '$state', '$uibModal', 'toastr', function ($scope, serviceAPI, $state, $uibModal, toastr) {
            $scope.data = { nu_ventas: 0, nu_total: 0 };
            $scope.displayed = [];
            $scope.callServer = function (tableState) {
                var params = angular.extend({}, tableState.pagination, tableState.search);
                serviceAPI.listarGuia(params).success(function (r) {
                    console.log(r);
                    if (r.success && r.totalItemCount > 0) {
                        console.log('entro');
                        $scope.displayed = r.rows;
                        console.log($scope.displayed);
                        tableState.pagination.numberOfPages = r.numberOfPages;
                    }
                });
            };

            $scope.agregar = function () {
                $state.go('dashboard.comprobantes.guia-details');
            };
            $scope.editar = function (id) {
                $state.go('dashboard.comprobantes.guia-details', { idpos: id });
            };


            $scope.openPdfGuia = function (size, item) {
                $scope.item = item;
                $uibModal.open({
                    animation: true,
                    templateUrl: "app/pages/comprobantes/guia/modal/modalPdf.html",
                    size: size,
                    controller: 'modalGuiaCtrl',
                    scope: $scope,
                    resolve: {
                        item: function () { }
                    }
                }).result.then(function (item) {
                    angular.extend($scope.data, item);
                }, function () {

                });
            };

        }])
        .controller('modalGuiaCtrl', ['$scope', 'item', '$http', '$httpParamSerializerJQLike', '$uibModalInstance', function ($scope, item, $http, $httpParamSerializerJQLike, $uibModalInstance) {
            $scope.item = $scope.$parent.item || false;
            $scope.status = 0;
            $scope.respuesta = 0;
            $scope.archivo = '';
            $scope.url = '';

            if (angular.isObject($scope.item)) {
                console.log('guia entro');
                console.log($scope.item);

                $scope.archivo = 'api/api-omec/examples/report/despatch.php';
                //$scope.archivo = 'reports/guia.php';

            }

            $scope.pdf = function () {
                $uibModalInstance.close($scope.item);
            }


            $scope.cerrar = function (data) {
                $uibModalInstance.close($scope.data);

            }
            $scope.enviaCorreo = function () {
                $http({
                    url: 'api/ventas.php',
                    method: 'POST',
                    data: $httpParamSerializerJQLike({ oper: 'envioCorreo', info: $scope.item }),
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }).then(function (response) {
                    if (response.data.success) {
                        $("#result").html(response.data.message);
                    } else
                        $("#result").html(response.data.message);
                }, function (response) {
                    toastr.error("ha fallado el proceso ", 'Error')
                });
            };



        }])
        .controller('guiaCtrl', ['$scope', '$uibModal', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', '$filter', function ($scope, $uibModal, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log, $filter) {

            $scope.data = { id_cotizacion: 0, id_guia: 0, id_cliente: 0, nu_documento_entidad:'', no_cliente: '', id_tipo_comprobante: 0, nu_serie: '', nu_correlativo: '', fe_emision: '', fe_vencimiento: '', id_usuario: 0, id_empresa: 0, id_local: 0, nu_placa: '', id_tipo_documento: 0, nu_documento: '', no_observacion: '', id_motivo: 0, id_modalidad: 0, nu_bultos: 0, id_tipo_empresa: 0 };
            $scope.default = { id_cotizacion: 0, id_guia: 0, id_cliente: 0,nu_documento_entidad:'', no_cliente: '', id_tipo_comprobante: 0, nu_serie: '', nu_correlativo: '', fe_emision: '', fe_vencimiento: '', id_usuario: 0, id_empresa: 0, id_local: 0, nu_placa: '', id_tipo_documento: 0, nu_documento: '', no_observacion: '', id_motivo: 0, id_modalidad: 0, nu_bultos: 0, id_tipo_empresa: 0 };

            $scope.jComprobante = [];
            $scope.jtipopago = [];
            $scope.jMotivo = [];
            $scope.jModalidad = [];
            $scope.jTipoEmpresa = [];
            $scope.jDocumentos = [];
            $scope.jCotizacion = [];
            $scope.jSucursal = [];

            serviceAPI.getTiposDocumentos().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    console.log(r);
                    angular.extend($scope.jDocumentos, r.rows);
                }
            });
            serviceAPI.getTipoPago().success(function (r) {
                if (r.totalItemCount > 0 && r.success) {
                    angular.extend($scope.jtipopago, r.rows);
                }
            });
            serviceAPI.listarMotivo().success(function (r) {
                if (r.totalItemCount > 0 && r.success) {
                    angular.extend($scope.jMotivo, r.rows);
                }
            });
            serviceAPI.listarModalidad().success(function (r) {
                if (r.totalItemCount > 0 && r.success) {
                    angular.extend($scope.jModalidad, r.rows);
                }
            });
            serviceAPI.listarTipoEmpresa().success(function (r) {
                if (r.totalItemCount > 0 && r.success) {
                    angular.extend($scope.jTipoEmpresa, r.rows);
                }
            });

            serviceAPI.getSucursal().success(function (r) {
                if (r.totalItemCount > 0 && r.success) {
                    console.log(r);
                    angular.extend($scope.jSucursal, r.rows);
                }
            });

            serviceAPI.getComprobanteGuia().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jComprobante, r.rows);
                }
            });
            $scope.getCorrelativo = function (value) {
                serviceAPI.consultarCorrelativo(value).then(function (r) {
                    if (r.data.success && r.data.num_rows == 1) {
                        console.log(r);
                        $scope.data.nu_serie = r.data.rows.nu_serie;
                        $scope.data.nu_correlativo = $scope.zfill(r.data.rows.nu_correlativo, 8);
                    }
                });
            }

            $scope.zfill = function (number, width){
                var numberOutput = Math.abs(number); /* Valor absoluto del número */
                var length = number.toString().length; /* Largo del número */ 
                var zero = "0"; /* String de cero */  
                
                if (width <= length) {
                    if (number < 0) {
                         return ("-" + numberOutput.toString()); 
                    } else {
                         return numberOutput.toString(); 
                    }
                } else {
                    if (number < 0) {
                        return ("-" + (zero.repeat(width - length)) + numberOutput.toString()); 
                    } else {
                        return ((zero.repeat(width - length)) + numberOutput.toString()); 
                    }
                }
            }


            $scope.getTipoModalidad = function (data) {
                $scope.data.id_modalidad = data.id_modalidad.id_modalidad;
                angular.extend($scope.data.id_modalidad, data.id_modalidad.id_modalidad);
            }


            $scope.getCotizacion = function (value) {
                $scope.jCotizacion = [];
                serviceAPI.getCotizacion(value).then(function (r) {
                    console.log(r);
                    if (r.data.success && r.data.totalItemCount > 0) {
                        angular.extend($scope.jCotizacion, r.data.rows);
                    }
                });
            }

            $scope.modalProducts = function (size) {
                $uibModal.open({
                    animation: true,
                    size: size,
                    templateUrl: "app/pages/clientes/cliente/list/clienteListModal.html",
                    controller: 'clienteModalCtrl',
                    scope: $scope
                }).result.then(function (data) {
                    angular.extend($scope.data, data);
                    $scope.eliminarCotiTemporal();
                    $scope.getCotizacion(data);
                }, function () {
                    console.log('Modal dismissed at: ' + new Date());
                });
            };

            $scope.eliminarCotiTemporal = function () {
                $scope.rowCollection = [];
                serviceAPI.eliminarCotiTemporal().then(function (r) {
                    console.log(r);
                });
            }

            $scope.rowCollection = [];
            $scope.id_coti = 0;
            var k = 0;

            $scope.addItem = function () {
                serviceAPI.getCotizacionId($scope.data.id_cotizacion.id).then(function (r) {
                    var listaCotizacion = [];
                    var typeNotification = 'error';
                    if (r.data.success && r.data.totalItemCount > 0) {
                        typeNotification = (r.data.affected_rows != 0) ? 'success' : 'warning';
                        angular.extend(listaCotizacion, r.data.rows);
                        for (var i = 0; i < listaCotizacion.length; i++) {
                            var item = listaCotizacion[i];
                            $scope.rowCollection.push(_.extend({
                                id: ++k,
                                id_cotizacion: item.id_cotizacion,
                                id_producto: item.id_producto,
                                no_producto: item.no_producto,
                                co_producto: item.co_producto,
                                id_marca: item.id_marca,
                                no_marca: item.no_marca,
                                nu_cantidad: item.nu_cantidad
                            },
                                item)
                            );
                        }
                    }
                    toastr[typeNotification](r.messages, 'Se Agrego Correctamente la Cotización');
                })
                $scope.getCotizacion($scope.data);
                $scope.data.id_cotizacion = $scope.default.id_cotizacion;
            };

            $scope.quitar_producto = function (id) {
                $scope.rowCollection = $scope.rowCollection.filter(function (item) {
                    serviceAPI.eliminarCoti(id).then(function (r) {
                        console.log('se elimino '.r.data);
                    });
                    return item.id_cotizacion != id;
                });
                $scope.data.nu_total = $filter('Total')($scope.rowCollection, 'nu_cantidad', 'nu_precio', 2);
                $scope.data.nu_sub_total = parseFloat($scope.data.nu_total / 1.18).toFixed(2);
                $scope.data.nu_igv = parseFloat($scope.data.nu_total - $scope.data.nu_sub_total).toFixed(2);
            
                $scope.getCotizacion($scope.data);
            };

            $scope.guardar = function () {
                var params = { orden: $scope.data, detalle: $scope.rowCollection };
                serviceAPI.guardarGuia(params).success(function (r) {
                    var typeNotification = 'error';
                    if (r.success) {
                        typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                    }
                    toastr[typeNotification](r.messages, 'Registro de Guia Correctamente');
                    angular.extend($scope.data, $scope.default);
                    $scope.rowCollection = [];
                });
            };


        }]);
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.comprobantes.notacredito', [])
        .controller('notacreditoListCtrl', ['$scope', 'serviceAPI', '$state', '$uibModal', 'toastr', function ($scope, serviceAPI, $state ,$uibModal, toastr) {
            $scope.data = { nu_ventas: 0, nu_total: 0 };
            $scope.displayed = [];
            $scope.callServer = function (tableState) {
                var params = angular.extend({}, tableState.pagination, tableState.search);
                serviceAPI.getNotaCredito(params).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        $scope.displayed = r.rows;
                        tableState.pagination.numberOfPages = r.numberOfPages;
                    }
                });
            };

            $scope.agregar = function () {
                $state.go('dashboard.comprobantes.notacredito-details');
            };
            $scope.editar = function (id) {
                $state.go('dashboard.comprobantes.notacredito-details', { idnotacredito: id });
            };


            $scope.openPdfNotaCredito = function (size, item) {
                $scope.item = item;
                $uibModal.open({
                    animation: true,
                    templateUrl: "app/pages/comprobantes/boleta//modal/modalPdf.html",
                    size: size,
                    controller: 'modalComprobanteCtrl',
                    scope: $scope,
                    resolve: {
                        item: function () { }
                    }
                }).result.then(function (item) {
                    angular.extend($scope.data, item);
                }, function () {

                });
            };

        }])
        .controller('notacreditoCtrl', ['$scope', '$uibModal', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', '$filter','editableOptions', 'editableThemes', function ($scope, $uibModal, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log, $filter,editableOptions, editableThemes) {
        
            $scope.data = { id_nota_credito : 0 , id_comprobantes : 0 ,id_tipo_comprobante: 0, id_cliente: 0, id_boleta: 0, id_factura:0,nu_documento: '', no_cliente: '', nu_serie: '', nu_correlativo: '', fe_emision: '', id_usuario: 0, id_empresa: 0, id_local: 0, id_estado_sunat:0,id_estado:0, id_motivo_nota: 0, no_motivo: '', id_almacen:0, id_tipo_comprobante_d:0,mto_igv:0, mto_stotal:0, mto_total:0};
            $scope.default = { id_nota_credito : 0 , id_comprobantes : 0 ,id_tipo_comprobante: 0, id_cliente: 0, id_boleta: 0, id_factura:0,nu_documento: '', no_cliente: '', nu_serie: '', nu_correlativo: '', fe_emision: '', id_usuario: 0, id_empresa: 0, id_local: 0, id_estado_sunat:0,id_estado:0, id_motivo_nota: 0, no_motivo: '', id_almacen:0, id_tipo_comprobante_d:0,mto_igv:0, mto_stotal:0, mto_total:0};

            $scope.jComprobante = [];
            $scope.jTipoComprobante = [];
            $scope.jAlmacenDestino = [];
            $scope.jMotivo = [];
            $scope.jNota = [];
            $scope.jComprobanteBolFac = [];
            $scope.jComprobanteNota = [];

            serviceAPI.getMotivoNotaCredito().success(function (r) {
                if (r.totalItemCount > 0 && r.success) {
                  angular.extend($scope.jMotivo, r.rows);
                }
            });
            serviceAPI.getAlmacenDestino().success(function (r) {
                if (r.totalItemCount > 0 && r.success) {
                  angular.extend($scope.jAlmacenDestino, r.rows);
                }
            });
            serviceAPI.getComprobantesFacBol().success(function (r) {
                if (r.totalItemCount > 0 && r.success) {
                    angular.extend($scope.jComprobanteBolFac, r.rows);
                }
            });
            serviceAPI.getComprobanteNotaCredito().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jComprobante, r.rows);
                }
            });
            $scope.getMotivo = function(value){
                console.log(value);
            }
            $scope.getCorrelativo = function (value) {
                serviceAPI.consultarCorrelativo(value).then(function (r) {
                    if (r.data.success && r.data.num_rows == 1) {
                        console.log(r);
                        $scope.data.nu_serie = r.data.rows.nu_serie;
                        $scope.data.nu_correlativo = $scope.zfill(r.data.rows.nu_correlativo, 8);
                    }
                });
            }

            $scope.zfill = function (number, width){
                var numberOutput = Math.abs(number); /* Valor absoluto del número */
                var length = number.toString().length; /* Largo del número */ 
                var zero = "0"; /* String de cero */  
                
                if (width <= length) {
                    if (number < 0) {
                         return ("-" + numberOutput.toString()); 
                    } else {
                         return numberOutput.toString(); 
                    }
                } else {
                    if (number < 0) {
                        return ("-" + (zero.repeat(width - length)) + numberOutput.toString()); 
                    } else {
                        return ((zero.repeat(width - length)) + numberOutput.toString()); 
                    }
                }
            }

            $scope.getComprobantesoBoloFac = function (value) {
                serviceAPI.getComprobantesoBoloFac(value).then(function (r) {
                    $scope.jComprobanteNota = [];
                    if (r.data.success && r.data.totalItemCount > 0) {
                        angular.extend($scope.jComprobanteNota, r.data.rows);
                    }
                });
            }

            $scope.modalProducts = function (size) {
                $uibModal.open({
                    animation: true,
                    size: size,
                    templateUrl: "app/pages/catalogo/cliente/list/clienteListModal.html",
                    controller: 'clienteModalCtrl',
                    scope: $scope
                }).result.then(function (data) {
                    angular.extend($scope.data, data);
                }, function () {
                    console.log('Modal dismissed at: ' + new Date());
                });
            };


            
            $scope.rowCollection = [];
            $scope.id_coti = 0;
            var k = 0;

            $scope.addItem = function () {
                serviceAPI.getComprobanteIdBoletaFactura($scope.data).then(function (r) {
                    console.log(r);
                    $scope.rowCollection = [];
                    var listaComprobantes = [];
                    var typeNotification = 'error';
                    if (r.data.success && r.data.totalItemCount > 0) {
                        typeNotification = (r.data.affected_rows != 0) ? 'success' : 'warning';
                        angular.extend(listaComprobantes, r.data.rows);
                        for (var i = 0; i < listaComprobantes.length; i++) {
                            var item = listaComprobantes[i];
                            $scope.rowCollection.push(_.extend({
                                id: ++k,
                                id_producto: item.id_producto,
                                no_producto: item.no_producto,
                                no_marca: item.no_marca,
                                nu_cantidad: item.nu_cantidad,
                                nu_precio: item.nu_precio_descuento,
                                nu_total:  (parseFloat(item.nu_cantidad) * parseFloat(item.nu_precio_descuento)).toFixed(2)
                            },
                                item)
                            );
                        }
                        $scope.data.mto_total = $filter('Total')($scope.rowCollection, 'nu_cantidad', 'nu_precio', 2);
                        $scope.data.mto_stotal = parseFloat($scope.data.mto_total / 1.18).toFixed(2);
                        $scope.data.mto_igv = parseFloat($scope.data.mto_total - $scope.data.mto_stotal).toFixed(2);
                    }
                    toastr[typeNotification](r.messages, 'Se Agrego Correctamente la Guia');
                })
            };

            $scope.quitar_producto = function (id) {
                $scope.rowCollection = $scope.rowCollection.filter(function (item) {
                    return item.id != id;
                });
                $scope.data.mto_total = $filter('Total')($scope.rowCollection, 'nu_cantidad', 'nu_precio', 2);
                $scope.data.mto_stotal = parseFloat($scope.data.mto_total / 1.18).toFixed(2);
                $scope.data.mto_igv = parseFloat($scope.data.mto_total - $scope.data.mto_stotal).toFixed(2);
            };

            $scope.guardar = function () {
                var params = { orden: $scope.data, detalle: $scope.rowCollection };
                serviceAPI.guardarNotaCredito(params).success(function (r) {
                    var typeNotification = 'error';
                    if (r.success) {
                        typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                    }
                    toastr[typeNotification](r.messages, 'Registro de Nota de Credito Correctamente');
                    angular.extend($scope.data, $scope.default);
                    $scope.rowCollection = [];
                });
            };

            $scope.getCalcular = function (){
                console.log('entro calcular');
                $scope.data.mto_total = 0;
                angular.extend($scope.data.mto_total, $scope.default.mto_total);
                angular.extend($scope.data.mto_stotal, $scope.default.mto_stotal);
                angular.extend($scope.data.mto_igv, $scope.default.mto_igv);
                console.log($scope.data.mto_total);

                $scope.data.mto_total = $filter('Total')($scope.rowCollection, 'nu_cantidad', 'nu_precio', 2);
                $scope.data.mto_stotal = parseFloat($scope.data.mto_total / 1.18).toFixed(2);
                $scope.data.mto_igv = parseFloat($scope.data.mto_total - $scope.data.mto_stotal).toFixed(2);
            }              
            editableOptions.theme = 'bs3';
            editableThemes['bs3'].submitTpl = '<button type="submit" ng-click="getCalcular()"   class="btn btn-primary btn-with-icon"><i class="ion-checkmark-round"></i></button>';
            editableThemes['bs3'].cancelTpl = '<button type="button" ng-click="$form.$cancel()" class="btn btn-default btn-with-icon"><i class="ion-close-round"></i></button>';

        }]);
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.comprobantes.notadebito', [])
        .controller('notadebitoListCtrl', ['$scope', 'serviceAPI', '$state', '$uibModal', 'toastr', function ($scope, serviceAPI, $state ,$uibModal, toastr) {
            $scope.data = { nu_ventas: 0, nu_total: 0 };
            $scope.displayed = [];
            $scope.callServer = function (tableState) {
                var params = angular.extend({}, tableState.pagination, tableState.search);
                serviceAPI.getVentas(params).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        $scope.displayed = r.rows;
                        tableState.pagination.numberOfPages = r.numberOfPages;
                    }
                });
            };

        }])
        .controller('notadebitoCtrl', ['$scope', '$uibModal', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', '$filter', function ($scope, $uibModal, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log, $filter) {
           
              

        }]);
})();
(function(){
    'use strict';
    angular.module('BlurAdmin.pages.contabilidad.bancos', [])   
    .controller('bancosCtrl', [ '$scope', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', function($scope, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log){
        var vm=this;
        $scope.default={id_banco:0, no_banco:'',status:''};
        $scope.data={id_banco:0, no_banco:'',status:''};

        $scope.displayed = [];
        $scope.callServer = function (tableState) {
            var params = angular.extend({}, tableState.pagination, tableState.search);
            serviceAPI.getBancos(params).success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    $scope.displayed = r.rows;
                    tableState.pagination.numberOfPages = r.numberOfPages;
                }
            });
        };

        $scope.changeStatus = function (idMarca, actividad, index) {
            serviceAPI.cambiarStatusBanco({ id: idMarca, status: actividad }).success(function (r) {
                console.log(r);
                var typenotify = 'error';
                if (r.num_rows == 0) {
                    typenotify = 'warning';
                    $scope.displayed = $scope.displayed.filter(function (i) { return (i.id_banco != idMarca); })
                }
                if (r.affected_rows == 1) {
                    typenotify = 'success';
                    $scope.displayed[index].status = r.rows.status;
                }
                toastr[typenotify](r.messages, 'Listado de Sucursal');
            });
        };

        $scope.guardar = function (eForm) {
            $scope.displayed = [];
            serviceAPI.guardarBanco($scope.data).success(function (r) {
                var typeNotification = 'error';
                if (r.success) {
                    typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                }
                toastr[typeNotification](r.messages, 'Registro de Banco Correctamente');
                angular.extend($scope.data, $scope.default);
                eForm.$setPristine();
                eForm.$setUntouched();
                $scope.callServer([]);
            });
        };

        $scope.editar = function (value) {
            $scope.data = value;
        };
     
    }]);
})();
(function(){
    'use strict';
    angular.module('BlurAdmin.pages.contabilidad.cobrar', [])   
    .controller('cobrarCtrl', [ '$scope', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', function($scope, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log){
        var vm=this;
        $scope.default={id_banco:0, no_banco:'',status:''};
        $scope.data={id_banco:0, no_banco:'',status:''};

        $scope.displayed = [];
        $scope.callServer = function (tableState) {
            var params = angular.extend({}, tableState.pagination, tableState.search);
            serviceAPI.getCuentaxCobrar(params).success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    $scope.displayed = r.rows;
                    tableState.pagination.numberOfPages = r.numberOfPages;
                }
            });
        };

        $scope.changeStatus = function (idMarca, actividad, index) {
            serviceAPI.cambiarStatusBanco({ id: idMarca, status: actividad }).success(function (r) {
                console.log(r);
                var typenotify = 'error';
                if (r.num_rows == 0) {
                    typenotify = 'warning';
                    $scope.displayed = $scope.displayed.filter(function (i) { return (i.id_banco != idMarca); })
                }
                if (r.affected_rows == 1) {
                    typenotify = 'success';
                    $scope.displayed[index].status = r.rows.status;
                }
                toastr[typenotify](r.messages, 'Listado de Sucursal');
            });
        };

        $scope.guardar = function (eForm) {
            $scope.displayed = [];
            serviceAPI.guardarBanco($scope.data).success(function (r) {
                var typeNotification = 'error';
                if (r.success) {
                    typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                }
                toastr[typeNotification](r.messages, 'Registro de Banco Correctamente');
                angular.extend($scope.data, $scope.default);
                eForm.$setPristine();
                eForm.$setUntouched();
                $scope.callServer([]);
            });
        };

        $scope.editar = function (value) {
            $scope.data = value;
        };
     
    }]);
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.contabilidad.cuentas', [])
        .controller('cuentasListCtrl', ['$scope', 'serviceAPI', '$state', function ($scope, serviceAPI, $state) {
            $scope.displayed = [];
            $scope.jEmpresa = [];
            $scope.jSucursal = [];
            $scope.callServer = function (tableState) {
                var params = angular.extend({}, tableState.pagination, tableState.search);
                serviceAPI.getCuentas(params).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        $scope.displayed = r.rows;
                        tableState.pagination.numberOfPages = r.numberOfPages;
                    }
                });
            };
            $scope.agregar = function () {
                $state.go('dashboard.contabilidad.cuentas-details');
            };
            $scope.editar = function (id) {
                $state.go('dashboard.contabilidad.cuentas-details', { idcuenta: id });
            };
            $scope.changeStatus = function (idCuenta, actividad, index) {
                serviceAPI.cambiarStatusCuenta({ id: idCuenta, status: actividad }).success(function (r) {
                    var typenotify = 'error';
                    if (r.num_rows == 0) {
                        typenotify = 'warning';
                        $scope.displayed = $scope.displayed.filter(function (i) { return (i.id_banco != idMarca); })
                    }
                    if (r.affected_rows == 1) {
                        typenotify = 'success';
                        $scope.displayed[index].status = r.rows.status;
                    }
                    toastr[typenotify](r.messages, 'Listado de Cuenta');
                });
            };

            serviceAPI.getEmpresas().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jEmpresa, r.rows);
                }
            });

            $scope.getSucursal = function (value) {
                serviceAPI.getSucursalId(value).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        angular.extend($scope.jSucursal, r.rows);
                    }
                });
            }
        }])
        .controller('cuentasCtrl', ['$scope', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', function ($scope, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log) {
            $scope.default = { id_cuenta_bancaria: 0, id_empresa: 0, id_local: 0, id_banco: 0, nu_cuenta_bancaria: '', fe_apertura: '', va_saldo: 0, status: 0 };
            $scope.data = { id_cuenta_bancaria: 0, id_empresa: 0, id_local: 0, id_banco: 0, nu_cuenta_bancaria: '', fe_apertura: '', va_saldo: 0, status: 0 };

            $scope.jEmpresa = [];
            $scope.jSucursal = [];
            $scope.jBancos = [];


            serviceAPI.getBancos().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jBancos, r.rows);
                }
            });

            serviceAPI.getEmpresas().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jEmpresa, r.rows);
                }
            });

            $scope.getSucursal = function (value) {
                serviceAPI.getSucursalId(value).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        angular.extend($scope.jSucursal, r.rows);
                    }
                });
            }

            $scope.guardar = function (eForm) {
                serviceAPI.guardarCuenta($scope.data).success(function (r) {
                    var typeNotification = 'error';
                    if (r.success) {
                        typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                    }
                    toastr[typeNotification](r.messages, 'Registro de Cuenta');
                    angular.extend($scope.data, $scope.default);
                    eForm.$setPristine();
                    eForm.$setUntouched();
                });
            };

            $scope.consultar = function () {

                if ($stateParams.idcuentas != '') {
                    serviceAPI.consultarCuenta({ id: $stateParams.idcuentas}).success(function (r) {
                        var typeNotification = (!r.success) ? 'error' : 'warning';
                        if (r.success && r.num_rows == 1) {
                            typeNotification = 'success';
                            angular.extend($scope.data, r.rows);
                            $scope.jEmpresa.map(function (b) {
                                if (b.id_empresa == r.rows.id_empresa) { $scope.data.id_empresa = b; }
                            });
                            serviceAPI.getSucursalId($scope.data.id_empresa).then(function (rr) {
                                if (rr.data.totalItemCount > 0 && rr.data.success) {
                                    angular.extend($scope.jSucursal, rr.data.rows);
                                    $scope.jSucursal.map(function (c) {
                                        if (c.id_local == r.rows.id_local) {
                                            $scope.data.id_local = c;
                                        }
                                    });
                                }
                            });
                             
                            $scope.jBancos.map(function (b) {
                                if (b.id_banco == r.rows.id_banco) { $scope.data.id_banco = b; }
                            });                             
                        }
                        toastr[typeNotification](r.messages, 'Información de Cuenta');
                    });
                }
            };
        }]);
})();
(function(){
    'use strict';
    angular.module('BlurAdmin.pages.contabilidad.pagar', [])   
    .controller('pagarCtrl', [ '$scope', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', function($scope, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log){
        var vm=this;
        $scope.default={id_banco:0, no_banco:'',status:''};
        $scope.data={id_banco:0, no_banco:'',status:''};

        $scope.displayed = [];
        $scope.callServer = function (tableState) {
            var params = angular.extend({}, tableState.pagination, tableState.search);
            serviceAPI.getCuentaxPagar(params).success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    $scope.displayed = r.rows;
                    tableState.pagination.numberOfPages = r.numberOfPages;
                }
            });
        };

        $scope.changeStatus = function (idMarca, actividad, index) {
            serviceAPI.cambiarStatusBanco({ id: idMarca, status: actividad }).success(function (r) {
                console.log(r);
                var typenotify = 'error';
                if (r.num_rows == 0) {
                    typenotify = 'warning';
                    $scope.displayed = $scope.displayed.filter(function (i) { return (i.id_banco != idMarca); })
                }
                if (r.affected_rows == 1) {
                    typenotify = 'success';
                    $scope.displayed[index].status = r.rows.status;
                }
                toastr[typenotify](r.messages, 'Listado de Sucursal');
            });
        };

        $scope.guardar = function (eForm) {
            $scope.displayed = [];
            serviceAPI.guardarBanco($scope.data).success(function (r) {
                var typeNotification = 'error';
                if (r.success) {
                    typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                }
                toastr[typeNotification](r.messages, 'Registro de Banco Correctamente');
                angular.extend($scope.data, $scope.default);
                eForm.$setPristine();
                eForm.$setUntouched();
                $scope.callServer([]);
            });
        };

        $scope.editar = function (value) {
            $scope.data = value;
        };
     
    }]);
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.contabilidad.pasivos', [])
        .controller('pasivosListCtrl', ['$scope', 'serviceAPI', '$state', function ($scope, serviceAPI, $state) {
            $scope.displayed = [];
            $scope.jEmpresa = [];
            $scope.jSucursal = [];
            $scope.jAnio = [];
            $scope.jPeriodo = [];

            $scope.callServer = function (tableState) {
                var params = angular.extend({}, tableState.pagination, tableState.search);
                serviceAPI.getPasivo(params).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        $scope.displayed = r.rows;
                        tableState.pagination.numberOfPages = r.numberOfPages;
                    }
                });
            };
            $scope.agregar = function () {
                $state.go('dashboard.contabilidad.pasivos-details');
            };
            $scope.editar = function (id) {
                $state.go('dashboard.contabilidad.pasivos-details', { idpatrimonio: id });
            };
            $scope.changeStatus = function (idCuenta, actividad, index) {
                serviceAPI.cambiarStatusCuenta({ id: idCuenta, status: actividad }).success(function (r) {
                    var typenotify = 'error';
                    if (r.num_rows == 0) {
                        typenotify = 'warning';
                        $scope.displayed = $scope.displayed.filter(function (i) { return (i.id_banco != idMarca); })
                    }
                    if (r.affected_rows == 1) {
                        typenotify = 'success';
                        $scope.displayed[index].status = r.rows.status;
                    }
                    toastr[typenotify](r.messages, 'Listado de Cuenta');
                });
            };

            serviceAPI.getEmpresas().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jEmpresa, r.rows);
                }
            });

            $scope.getSucursal = function (value) {
                serviceAPI.getSucursalId(value).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        angular.extend($scope.jSucursal, r.rows);
                    }
                });
            }

            serviceAPI.getAnio().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jAnio, r.rows);
                }
            });

            $scope.getPeriodo = function (value) {
                $scope.jPeriodo= [];
                serviceAPI.getPeriodo(value).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        angular.extend($scope.jPeriodo, r.rows);
                    }
                });
            }
        }])
        .controller('pasivosCtrl', ['$scope', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', function ($scope, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log) {
            $scope.default = { id_pasivo: 0, id_empresa: 0, id_local: 0, id_tipo_pasivo: 0,id_anio:0,id_periodo:0, no_pasivo: '', va_pasivo: 0};
            $scope.data = { id_pasivo: 0, id_empresa: 0, id_local: 0, id_tipo_pasivo: 0,id_anio:0,id_periodo:0, no_pasivo: '', va_pasivo: 0};

            $scope.jEmpresa = [];
            $scope.jSucursal = [];
            $scope.jTipoPasivo = [];

            $scope.jAnio = [];
            $scope.jPeriodo = [];

            serviceAPI.getTipoPasivo().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jTipoPasivo, r.rows);
                }
            });

            serviceAPI.getEmpresas().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jEmpresa, r.rows);
                }
            });

            $scope.getSucursal = function (value) {
                $scope.jSucursal= [];
                serviceAPI.getSucursalId(value).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        angular.extend($scope.jSucursal, r.rows);
                    }
                });
            }

            serviceAPI.getAnio().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jAnio, r.rows);
                }
            });

            $scope.getPeriodo = function (value) {
                $scope.jPeriodo= [];
                serviceAPI.getPeriodo(value).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        angular.extend($scope.jPeriodo, r.rows);
                    }
                });
            }

            $scope.guardar = function (eForm) {
                serviceAPI.guardarPasivo($scope.data).success(function (r) {
                    var typeNotification = 'error';
                    if (r.success) {
                        typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                    }
                    toastr[typeNotification](r.messages, 'Registro de Patrimonio');
                    angular.extend($scope.data, $scope.default);
                    eForm.$setPristine();
                    eForm.$setUntouched();
                });
            };

            $scope.consultar = function () {
                if ($stateParams.idpasivo != '') {
                    serviceAPI.consultarPasivo({ id: $stateParams.idpasivo }).success(function (r) {
                        var typeNotification = (!r.success) ? 'error' : 'warning';
                        if (r.success && r.num_rows == 1) {
                            typeNotification = 'success';
                            angular.extend($scope.data, r.rows);
                            $scope.jEmpresa.map(function (b) {
                                if (b.id_empresa == r.rows.id_empresa) { $scope.data.id_empresa = b; }
                            });
                            serviceAPI.getSucursalId($scope.data.id_empresa).then(function (rr) {
                                if (rr.data.totalItemCount > 0 && rr.data.success) {
                                    angular.extend($scope.jSucursal, rr.data.rows);
                                    $scope.jSucursal.map(function (c) {
                                        if (c.id_local == r.rows.id_local) {
                                            $scope.data.id_local = c;
                                        }
                                    });
                                }
                            });

                            $scope.jTipoPasivo.map(function (c) {
                                if (c.id_tipo_pasivo == r.rows.id_tipo_pasivo) { $scope.data.id_tipo_pasivo = c; }
                            });

                            $scope.jAnio.map(function (d) {
                                if (d.id_anio == r.rows.id_anio) { $scope.data.id_anio = d; }
                            }); 
                            
                            serviceAPI.getPeriodo($scope.data.id_anio).success(function (rd) {                                
                                if (rd.success && rd.totalItemCount > 0) {
                                    angular.extend($scope.jPeriodo, rd.rows);
                                    $scope.jPeriodo.map(function (e) {
                                        if (e.id_periodo == r.rows.id_periodo) {
                                            $scope.data.id_periodo = e;
                                        }
                                    });
                                }
                            });


                        }
                        toastr[typeNotification](r.messages, 'Información de Cuenta');
                    });
                }
            };
        }]);
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.contabilidad.patrimonio', [])
        .controller('patrimonioListCtrl', ['$scope', 'serviceAPI', '$state', function ($scope, serviceAPI, $state) {
            $scope.displayed = [];
            $scope.jEmpresa = [];
            $scope.jSucursal = [];
            $scope.callServer = function (tableState) {
                var params = angular.extend({}, tableState.pagination, tableState.search);
                serviceAPI.getPatrimonio(params).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        $scope.displayed = r.rows;
                        tableState.pagination.numberOfPages = r.numberOfPages;
                    }
                });
            };
            $scope.agregar = function () {
                $state.go('dashboard.contabilidad.patrimonio-details');
            };
            $scope.editar = function (id) {
                $state.go('dashboard.contabilidad.patrimonio-details', { idpatrimonio: id });
            };
            $scope.changeStatus = function (idCuenta, actividad, index) {
                serviceAPI.cambiarStatusCuenta({ id: idCuenta, status: actividad }).success(function (r) {
                    var typenotify = 'error';
                    if (r.num_rows == 0) {
                        typenotify = 'warning';
                        $scope.displayed = $scope.displayed.filter(function (i) { return (i.id_banco != idMarca); })
                    }
                    if (r.affected_rows == 1) {
                        typenotify = 'success';
                        $scope.displayed[index].status = r.rows.status;
                    }
                    toastr[typenotify](r.messages, 'Listado de Cuenta');
                });
            };

            serviceAPI.getEmpresas().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jEmpresa, r.rows);
                }
            });

            $scope.getSucursal = function (value) {
                serviceAPI.getSucursalId(value).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        angular.extend($scope.jSucursal, r.rows);
                    }
                });
            }
        }])
        .controller('patrimonioCtrl', ['$scope', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', function ($scope, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log) {
            $scope.default = { id_patrimonio: 0, id_empresa: 0, id_local: 0, id_empleado: 0, no_patrimonio: '', va_patrimonio: 0};
            $scope.data = { id_patrimonio: 0, id_empresa: 0, id_local: 0, id_empleado: 0, no_patrimonio: '', va_patrimonio: 0};

            $scope.jEmpresa = [];
            $scope.jSucursal = [];
            $scope.jEmpleado = [];

            $scope.getSucursalEmpleado = function (value) {
                $scope.jEmpleado= [];
                serviceAPI.getEmpleadoSucursal(value).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        angular.extend($scope.jEmpleado, r.rows);
                    }
                });
            }

            serviceAPI.getEmpresas().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jEmpresa, r.rows);
                }
            });

            $scope.getSucursal = function (value) {
                $scope.jSucursal= [];
                serviceAPI.getSucursalId(value).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        angular.extend($scope.jSucursal, r.rows);
                    }
                });
            }

            $scope.guardar = function (eForm) {
                serviceAPI.guardarPatrimonio($scope.data).success(function (r) {
                    var typeNotification = 'error';
                    if (r.success) {
                        typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                    }
                    toastr[typeNotification](r.messages, 'Registro de Patrimonio');
                    angular.extend($scope.data, $scope.default);
                    eForm.$setPristine();
                    eForm.$setUntouched();
                });
            };

            $scope.consultar = function () {
                if ($stateParams.idpatrimonio != '') {
                    serviceAPI.consultarPatrimonio({ id: $stateParams.idpatrimonio }).success(function (r) {
                        var typeNotification = (!r.success) ? 'error' : 'warning';
                        if (r.success && r.num_rows == 1) {
                            typeNotification = 'success';
                            angular.extend($scope.data, r.rows);
                            $scope.jEmpresa.map(function (b) {
                                if (b.id_empresa == r.rows.id_empresa) { $scope.data.id_empresa = b; }
                            });
                            serviceAPI.getSucursalId($scope.data.id_empresa).then(function (rr) {
                                if (rr.data.totalItemCount > 0 && rr.data.success) {
                                    angular.extend($scope.jSucursal, rr.data.rows);
                                    $scope.jSucursal.map(function (c) {
                                        if (c.id_local == r.rows.id_local) {
                                            $scope.data.id_local = c;
                                        }
                                    });
                                }
                            });
                            serviceAPI.getEmpleadoSucursal($scope.data).success(function (rrr) {
                                console.log(rrr);
                                if (rrr.success && rrr.totalItemCount > 0) {
                                    angular.extend($scope.jEmpleado, rrr.rows);
                                    $scope.jEmpleado.map(function (c) {
                                        if (c.id_empleado == r.rows.id_empleado) {
                                            $scope.data.id_empleado = c;
                                        }
                                    });
                                }
                            });
                        }
                        toastr[typeNotification](r.messages, 'Información de Cuenta');
                    });
                }
            };
        }]);
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.cuentas.cuentaxcobrar', [])
        .controller('cuentaxcobrarListCtrl', ['$scope', 'serviceAPI', '$state', function ($scope, serviceAPI, $state) {
            $scope.displayed = [];
            $scope.callServer = function (tableState) {
                var params = angular.extend({}, tableState.pagination, tableState.search);
                serviceAPI.getVentasCobrar(params).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        $scope.displayed = r.rows;
                        tableState.pagination.numberOfPages = r.numberOfPages;
                    }
                });
            };
            $scope.agregar = function () {
                $state.go('dashboard.contabilidad.cuentas-details');
            };
            $scope.editar = function (id) {
                $state.go('dashboard.contabilidad.cuentas-details', { idcuenta: id });
            };
            $scope.changeStatus = function (idCuenta, actividad, index) {
                serviceAPI.cambiarStatusCuenta({ id: idCuenta, status: actividad }).success(function (r) {
                    var typenotify = 'error';
                    if (r.num_rows == 0) {
                        typenotify = 'warning';
                        $scope.displayed = $scope.displayed.filter(function (i) { return (i.id_banco != idMarca); })
                    }
                    if (r.affected_rows == 1) {
                        typenotify = 'success';
                        $scope.displayed[index].status = r.rows.status;
                    }
                    toastr[typenotify](r.messages, 'Listado de Cuenta');
                });
            };
        }])
        .controller('cuentaxcobrarCtrl', ['$scope', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', function ($scope, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log) {
            $scope.default = { id_cuenta_bancaria: 0, id_empresa: 0, id_local: 0, id_banco: 0, nu_cuenta_bancaria: '', fe_apertura: '', va_saldo: 0, status: 0 };
            $scope.data = { id_cuenta_bancaria: 0, id_empresa: 0, id_local: 0, id_banco: 0, nu_cuenta_bancaria: '', fe_apertura: '', va_saldo: 0, status: 0 };

            $scope.jEmpresa = [];
            $scope.jSucursal = [];
            $scope.jBancos = [];


            serviceAPI.getBancos().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jBancos, r.rows);
                }
            });

            serviceAPI.getEmpresas().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jEmpresa, r.rows);
                }
            });

            $scope.getSucursal = function (value) {
                serviceAPI.getSucursalId(value).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        angular.extend($scope.jSucursal, r.rows);
                    }
                });
            }

            $scope.guardar = function (eForm) {
                serviceAPI.guardarCuenta($scope.data).success(function (r) {
                    var typeNotification = 'error';
                    if (r.success) {
                        typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                    }
                    toastr[typeNotification](r.messages, 'Registro de Cuenta');
                    angular.extend($scope.data, $scope.default);
                    eForm.$setPristine();
                    eForm.$setUntouched();
                });
            };

            $scope.consultar = function () {

                if ($stateParams.idcuentas != '') {
                    serviceAPI.consultarCuenta({ id: $stateParams.idcuentas}).success(function (r) {
                        var typeNotification = (!r.success) ? 'error' : 'warning';
                        if (r.success && r.num_rows == 1) {
                            typeNotification = 'success';
                            angular.extend($scope.data, r.rows);
                            $scope.jEmpresa.map(function (b) {
                                if (b.id_empresa == r.rows.id_empresa) { $scope.data.id_empresa = b; }
                            });
                            serviceAPI.getSucursalId($scope.data.id_empresa).then(function (rr) {
                                if (rr.data.totalItemCount > 0 && rr.data.success) {
                                    angular.extend($scope.jSucursal, rr.data.rows);
                                    $scope.jSucursal.map(function (c) {
                                        if (c.id_local == r.rows.id_local) {
                                            $scope.data.id_local = c;
                                        }
                                    });
                                }
                            });
                             
                            $scope.jBancos.map(function (b) {
                                if (b.id_banco == r.rows.id_banco) { $scope.data.id_banco = b; }
                            });                             
                        }
                        toastr[typeNotification](r.messages, 'Información de Cuenta');
                    });
                }
            };
        }]);
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.cuentas.cuentaxpagar', [])
        .controller('cuentaxpagarListCtrl', ['$scope', 'serviceAPI', '$state', function ($scope, serviceAPI, $state) {
            $scope.displayed = [];
            $scope.callServer = function (tableState) {
                var params = angular.extend({}, tableState.pagination, tableState.search);
                serviceAPI.getComprasCobrar(params).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        $scope.displayed = r.rows;
                        tableState.pagination.numberOfPages = r.numberOfPages;
                    }
                });
            };
            $scope.agregar = function () {
                $state.go('dashboard.contabilidad.cuentas-details');
            };
            $scope.editar = function (id) {
                $state.go('dashboard.contabilidad.cuentas-details', { idcuenta: id });
            };
            $scope.changeStatus = function (idCuenta, actividad, index) {
                serviceAPI.cambiarStatusCuenta({ id: idCuenta, status: actividad }).success(function (r) {
                    var typenotify = 'error';
                    if (r.num_rows == 0) {
                        typenotify = 'warning';
                        $scope.displayed = $scope.displayed.filter(function (i) { return (i.id_banco != idMarca); })
                    }
                    if (r.affected_rows == 1) {
                        typenotify = 'success';
                        $scope.displayed[index].status = r.rows.status;
                    }
                    toastr[typenotify](r.messages, 'Listado de Cuenta');
                });
            };
        }])
        .controller('cuentaxpagarCtrl', ['$scope', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', function ($scope, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log) {
            $scope.default = { id_cuenta_bancaria: 0, id_empresa: 0, id_local: 0, id_banco: 0, nu_cuenta_bancaria: '', fe_apertura: '', va_saldo: 0, status: 0 };
            $scope.data = { id_cuenta_bancaria: 0, id_empresa: 0, id_local: 0, id_banco: 0, nu_cuenta_bancaria: '', fe_apertura: '', va_saldo: 0, status: 0 };

            $scope.jEmpresa = [];
            $scope.jSucursal = [];
            $scope.jBancos = [];


            serviceAPI.getBancos().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jBancos, r.rows);
                }
            });

            serviceAPI.getEmpresas().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jEmpresa, r.rows);
                }
            });

            $scope.getSucursal = function (value) {
                serviceAPI.getSucursalId(value).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        angular.extend($scope.jSucursal, r.rows);
                    }
                });
            }

            $scope.guardar = function (eForm) {
                serviceAPI.guardarCuenta($scope.data).success(function (r) {
                    var typeNotification = 'error';
                    if (r.success) {
                        typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                    }
                    toastr[typeNotification](r.messages, 'Registro de Cuenta');
                    angular.extend($scope.data, $scope.default);
                    eForm.$setPristine();
                    eForm.$setUntouched();
                });
            };

            $scope.consultar = function () {

                if ($stateParams.idcuentas != '') {
                    serviceAPI.consultarCuenta({ id: $stateParams.idcuentas}).success(function (r) {
                        var typeNotification = (!r.success) ? 'error' : 'warning';
                        if (r.success && r.num_rows == 1) {
                            typeNotification = 'success';
                            angular.extend($scope.data, r.rows);
                            $scope.jEmpresa.map(function (b) {
                                if (b.id_empresa == r.rows.id_empresa) { $scope.data.id_empresa = b; }
                            });
                            serviceAPI.getSucursalId($scope.data.id_empresa).then(function (rr) {
                                if (rr.data.totalItemCount > 0 && rr.data.success) {
                                    angular.extend($scope.jSucursal, rr.data.rows);
                                    $scope.jSucursal.map(function (c) {
                                        if (c.id_local == r.rows.id_local) {
                                            $scope.data.id_local = c;
                                        }
                                    });
                                }
                            });
                             
                            $scope.jBancos.map(function (b) {
                                if (b.id_banco == r.rows.id_banco) { $scope.data.id_banco = b; }
                            });                             
                        }
                        toastr[typeNotification](r.messages, 'Información de Cuenta');
                    });
                }
            };
        }]);
})();
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('WizardCtrl', WizardCtrl);

  /** @ngInject */
  function WizardCtrl($scope) {
   var vm = this;

    vm.personalInfo = {};
    vm.productInfo = {};
    vm.shipment = {};

    vm.arePersonalInfoPasswordsEqual = function () {
      return vm.personalInfo.confirmPassword && vm.personalInfo.password == vm.personalInfo.confirmPassword;
    };
  }

})();


/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.home')
      .controller('DashboardCalendarCtrl', DashboardCalendarCtrl);

  /** @ngInject */
  function DashboardCalendarCtrl(baConfig) {
    var dashboardColors = baConfig.colors.dashboard;
    var $element = $('#calendar').fullCalendar({
      //height: 335,
      header: {
        left: 'prev,next today',
        center: 'title',
        right: 'month,agendaWeek,agendaDay'
      },
      defaultDate: '2018-06-14',
      selectable: true,
      selectHelper: true,
      select: function (start, end) {
        var title = prompt('Evento:');
        var eventData;
        if (title) {
          eventData = {
            title: title,
            start: start,
            end: end
          };
          $element.fullCalendar('renderEvent', eventData, true); // stick? = true
        }
        $element.fullCalendar('unselect');
      },
      editable: true,
      eventLimit: true, // allow "more" link when too many events
      events: [
        {
          title: 'EVento todo el dia',
          start: '2018-06-12',
          color: dashboardColors.silverTree
        },
        {
          title: 'Evento Largo',
          start: '2018-06-07',
          end: '2018-06-15',
          color: dashboardColors.blueStone
        },
        {
          title: 'Feriados',
          start: '2018-05-14T20:00:00',
          color: dashboardColors.surfieGreen
        },
        {
          title: 'Fiesta Cumpleaños',
          start: '2018-06-021T07:00:00',
          color: dashboardColors.gossipDark
        }
      ]
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.home')
      .directive('dashboardCalendar', dashboardCalendar);

  /** @ngInject */
  function dashboardCalendar() {
    return {
      restrict: 'E',
      controller: 'DashboardCalendarCtrl',
      templateUrl: 'app/pages/home/dashboardCalendar/dashboardCalendar.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.home')
      .controller('DashboardLineChartCtrl', DashboardLineChartCtrl);

  /** @ngInject */
  function DashboardLineChartCtrl(baConfig, layoutPaths, baUtil) {
    var layoutColors = baConfig.colors;
    var graphColor = baConfig.theme.blur ? '#000000' : layoutColors.primary;
    var chartData = [
      { date: new Date(2012, 11), value: 0, value0: 0 },
      { date: new Date(2013, 0), value: 15000, value0: 19000},
      { date: new Date(2013, 1), value: 30000, value0: 20000},

      { date: new Date(2013, 2), value: 25000, value0: 22000},
      { date: new Date(2013, 3), value: 21000, value0: 25000},
      { date: new Date(2013, 4), value: 24000, value0: 29000},
      { date: new Date(2013, 5), value: 31000, value0: 26000},
      { date: new Date(2013, 6), value: 40000, value0: 25000},
      { date: new Date(2013, 7), value: 37000, value0: 20000},
      { date: new Date(2013, 8), value: 18000, value0: 22000},
      { date: new Date(2013, 9), value: 5000, value0: 26000},
      { date: new Date(2013, 10), value: 40000, value0: 30000},
      { date: new Date(2013, 11), value: 20000, value0: 25000},
      { date: new Date(2014, 0), value: 5000, value0: 13000},

      { date: new Date(2014, 1), value: 3000, value0: 13000},
      { date: new Date(2014, 2), value: 1800, value0: 13000},
      { date: new Date(2014, 3), value: 10400, value0: 13000},
      { date: new Date(2014, 4), value: 25500, value0: 13000},
      { date: new Date(2014, 5), value: 2100, value0: 13000},
      { date: new Date(2014, 6), value: 6500, value0: 13000},
      { date: new Date(2014, 7), value: 1100, value0: 13000},
      { date: new Date(2014, 8), value: 17200, value0: 13000},
      { date: new Date(2014, 9), value: 26900, value0: 13000},
      { date: new Date(2014, 10), value: 14100, value0: 13000},
      { date: new Date(2014, 11), value: 35300, value0: 13000},
      { date: new Date(2015, 0), value: 54800, value0: 13000},
      { date: new Date(2015, 1), value: 49800, value0: 13000}
    ];

    var chart = AmCharts.makeChart('amchart', {
      type: 'serial',
      theme: 'blur',
      marginTop: 15,
      marginRight: 15,
      dataProvider: chartData,
      categoryField: 'date',
      categoryAxis: {
        parseDates: true,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText
      },
      valueAxes: [
        {
          minVerticalGap: 50,
          gridAlpha: 0,
          color: layoutColors.defaultText,
          axisColor: layoutColors.defaultText
        }
      ],
      graphs: [
        {
          id: 'g0',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.3),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value0',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        },
        {
          id: 'g1',
          bullet: 'none',
          useLineColorForBulletBorder: true,
          lineColor: baUtil.hexToRGB(graphColor, 0.5),
          lineThickness: 1,
          negativeLineColor: layoutColors.danger,
          type: 'smoothedLine',
          valueField: 'value',
          fillAlphas: 1,
          fillColorsField: 'lineColor'
        }
      ],
      chartCursor: {
        categoryBalloonDateFormat: 'MM YYYY',
        categoryBalloonColor: '#4285F4',
        categoryBalloonAlpha: 0.7,
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5
      },
      dataDateFormat: 'MM YYYY',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      zoomOutButton: {
        backgroundColor: '#fff',
        backgroundAlpha: 0
      },
      zoomOutText: '',
      pathToImages: layoutPaths.images.amChart
    });

    function zoomChart() {
      chart.zoomToDates(new Date(2013, 3), new Date(2014, 0));
    }

    chart.addListener('rendered', zoomChart);
    zoomChart();
    if (chart.zoomChart) {
      chart.zoomChart();
    }
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.home')
      .directive('dashboardLineChart', dashboardLineChart);

  /** @ngInject */
  function dashboardLineChart() {
    return {
      restrict: 'E',
      controller: 'DashboardLineChartCtrl',
      templateUrl: 'app/pages/home/dashboardLineChart/dashboardLineChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.home')
      .controller('DashboardMapCtrl', DashboardMapCtrl);

  /** @ngInject */
  function DashboardMapCtrl(baConfig, layoutPaths) {
    var layoutColors = baConfig.colors;
    var map = AmCharts.makeChart('amChartMap', {
      type: 'map',
      theme: 'blur',
      zoomControl: { zoomControlEnabled: false, panControlEnabled: false },

      dataProvider: {
        map: 'worldLow',
        zoomLevel: 3.5,
        zoomLongitude: 10,
        zoomLatitude: 52,
        areas: [
          { title: 'Lima', id: 'AT', color: layoutColors.primary, customData: '1 244', groupId: '1'},
          { title: 'Santa Anita', id: 'IE', color: layoutColors.primary, customData: '1 342', groupId: '1'},
          { title: 'Cuscu', id: 'DK', color: layoutColors.primary, customData: '1 973', groupId: '1'},
          { title: 'Mayorazgo', id: 'FI', color: layoutColors.primary, customData: '1 573', groupId: '1'},
          { title: 'Ate', id: 'SE', color: layoutColors.primary, customData: '1 084', groupId: '1'},
          { title: 'Surco', id: 'GB', color: layoutColors.primary, customData: '1 452', groupId: '1'},
          { title: 'Surquillo', id: 'IT', color: layoutColors.primary, customData: '1 321', groupId: '1'},
          { title: 'Miraflores', id: 'FR', color: layoutColors.primary, customData: '1 112', groupId: '1'},
          { title: 'San Borja', id: 'ES', color: layoutColors.primary, customData: '1 865', groupId: '1'},
          { title: 'San Isidro', id: 'GR', color: layoutColors.primary, customData: '1 453', groupId: '1'},
          { title: 'Chorrillos', id: 'DE', color: layoutColors.primary, customData: '1 957', groupId: '1'},
          { title: 'La Victoria', id: 'BE', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'Arequipa', id: 'LU', color: layoutColors.primary, customData: '1 011', groupId: '1'},
          { title: 'San Miguel', id: 'NL', color: layoutColors.primary, customData: '1 213', groupId: '1'},
          { title: 'EL Callao', id: 'PT', color: layoutColors.primary, customData: '1 291', groupId: '1'},
          { title: 'Ceres', id: 'LT', color: layoutColors.successLight, customData: '567', groupId: '2'},
          { title: 'PLaza Norte', id: 'LV', color: layoutColors.successLight, customData: '589', groupId: '2'},
          { title: 'Trujillo', id: 'CZ', color: layoutColors.successLight, customData: '785', groupId: '2'},
          { title: 'Ica', id: 'SK', color: layoutColors.successLight, customData: '965', groupId: '2'},
          { title: 'Vitarte', id: 'EE', color: layoutColors.successLight, customData: '685', groupId: '2'}
       
        ]
      },

      areasSettings: {
        rollOverOutlineColor: layoutColors.border,
        rollOverColor: layoutColors.primaryDark,
        alpha: 0.8,
        unlistedAreasAlpha: 0.2,
        unlistedAreasColor: layoutColors.defaultText,
        balloonText: '[[title]]: [[customData]] Clientes'
      },


      legend: {
        width: '100%',
        marginRight: 27,
        marginLeft: 27,
        equalWidths: false,
        backgroundAlpha: 0.3,
        backgroundColor: layoutColors.border,
        borderColor: layoutColors.border,
        borderAlpha: 1,
        top: 362,
        left: 0,
        horizontalGap: 10,
        data: [
          {
            title: 'over 1 000 users',
            color: layoutColors.primary
          },
          {
            title: '500 - 1 000 users',
            color: layoutColors.successLight
          },
          {
            title: '100 - 500 users',
            color: layoutColors.success
          },
          {
            title: '0 - 100 users',
            color: layoutColors.danger
          }
        ]
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.home')
      .directive('dashboardMap', dashboardMap);

  /** @ngInject */
  function dashboardMap() {
    return {
      restrict: 'E',
      controller: 'DashboardMapCtrl',
      templateUrl: 'app/pages/home/dashboardMap/dashboardMap.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.home')
      .controller('DashboardPieChartCtrl', DashboardPieChartCtrl);

  /** @ngInject */
  function DashboardPieChartCtrl($scope, $timeout, baConfig, baUtil) {
    var pieColor = baUtil.hexToRGB(baConfig.colors.defaultText, 0.2);
    $scope.charts = [{
      color: pieColor,
      description: 'Patrimonio',
      stats: '5000',
      icon: 'Soles',
    }, {
      color: pieColor,
      description: 'Pasivo',
      stats: '0.00',
      icon: 'Soles',
    }, {
      color: pieColor,
      description: 'Activo',
      stats: '0.00',
      icon: 'Soles',
    }, {
      color: pieColor,
      description: 'IGV',
      stats: '0.00',
      icon: 'Soles',
    }
    ];

    function getRandomArbitrary(min, max) {
      return Math.random() * (max - min) + min;
    }

    function loadPieCharts() {
      $('.chart').each(function () {
        var chart = $(this);
        chart.easyPieChart({
          easing: 'easeOutBounce',
          onStep: function (from, to, percent) {
            $(this.el).find('.percent').text(Math.round(percent));
          },
          barColor: chart.attr('rel'),
          trackColor: 'rgba(0,0,0,0)',
          size: 84,
          scaleLength: 0,
          animation: 2000,
          lineWidth: 9,
          lineCap: 'round',
        });
      });

      $('.refresh-data').on('click', function () {
        updatePieCharts();
      });
    }

    function updatePieCharts() {
      $('.pie-charts .chart').each(function(index, chart) {
        $(chart).data('easyPieChart').update(getRandomArbitrary(55, 90));
      });
    }

    $timeout(function () {
      loadPieCharts();
      updatePieCharts();
    }, 1000);
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.home')
      .directive('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {
    return {
      restrict: 'E',
      controller: 'DashboardPieChartCtrl',
      templateUrl: 'app/pages/home/dashboardPieChart/dashboardPieChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.home')
      .controller('DashboardTodoCtrl', DashboardTodoCtrl);

  /** @ngInject */
  function DashboardTodoCtrl($scope, baConfig) {

    $scope.transparent = baConfig.theme.blur;
    var dashboardColors = baConfig.colors.dashboard;
    var colors = [];
    for (var key in dashboardColors) {
      colors.push(dashboardColors[key]);
    }

    function getRandomColor() {
      var i = Math.floor(Math.random() * (colors.length - 1));
      return colors[i];
    }

    $scope.todoList = [
      { text: 'Check me out' },
      { text: 'Lorem ipsum dolor sit amet, possit denique oportere at his, etiam corpora deseruisse te pro' },
      { text: 'Ex has semper alterum, expetenda dignissim' },
      { text: 'Vim an eius ocurreret abhorreant, id nam aeque persius ornatus.' },
      { text: 'Simul erroribus ad usu' },
      { text: 'Ei cum solet appareat, ex est graeci mediocritatem' },
      { text: 'Get in touch with akveo team' },
      { text: 'Write email to business cat' },
      { text: 'Have fun with blur admin' },
      { text: 'What do you think?' },
    ];

    $scope.todoList.forEach(function(item) {
      item.color = getRandomColor();
    });

    $scope.newTodoText = '';

    $scope.addToDoItem = function (event, clickPlus) {
      if (clickPlus || event.which === 13) {
        $scope.todoList.unshift({
          text: $scope.newTodoText,
          color: getRandomColor(),
        });
        $scope.newTodoText = '';
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.home')
      .directive('dashboardTodo', dashboardTodo);

  /** @ngInject */
  function dashboardTodo() {
    return {
      restrict: 'EA',
      controller: 'DashboardTodoCtrl',
      templateUrl: 'app/pages/home/dashboardTodo/dashboardTodo.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.home')
      .service('dashboardPieChart', dashboardPieChart);

  /** @ngInject */
  function dashboardPieChart() {

  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.home')
      .directive('popularApp', popularApp);

  /** @ngInject */
  function popularApp() {
    return {
      restrict: 'E',
      templateUrl: 'app/pages/home/popularApp/popularApp.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.home')
      .controller('TrafficChartCtrl', TrafficChartCtrl);

  /** @ngInject */
  function TrafficChartCtrl($scope, baConfig, colorHelper) {

    $scope.transparent = baConfig.theme.blur;
    var dashboardColors = baConfig.colors.dashboard;
    $scope.doughnutData = [
      {
        value: 2000,
        color: dashboardColors.white,
        highlight: colorHelper.shade(dashboardColors.white, 15),
        label: 'Otros',
        percentage: 87,
        order: 1,
      }, {
        value: 1500,
        color: dashboardColors.blueStone,
        highlight: colorHelper.shade(dashboardColors.blueStone, 15),
        label: 'Motores',
        percentage: 22,
        order: 4,
      }, {
        value: 1000,
        color: dashboardColors.surfieGreen,
        highlight: colorHelper.shade(dashboardColors.surfieGreen, 15),
        label: 'Trafico',
        percentage: 70,
        order: 3,
      }, {
        value: 1200,
        color: dashboardColors.silverTree,
        highlight: colorHelper.shade(dashboardColors.silverTree, 15),
        label: 'Directos',
        percentage: 38,
        order: 2,
      }, {
        value: 400,
        color: dashboardColors.gossip,
        highlight: colorHelper.shade(dashboardColors.gossip, 15),
        label: 'Campañas',
        percentage: 17,
        order: 0,
      },
    ];

    var ctx = document.getElementById('chart-area').getContext('2d');
    window.myDoughnut = new Chart(ctx).Doughnut($scope.doughnutData, {
      segmentShowStroke: false,
      percentageInnerCutout : 64,
      responsive: true
    });
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.home')
      .directive('trafficChart', trafficChart);

  /** @ngInject */
  function trafficChart() {
    return {
      restrict: 'E',
      controller: 'TrafficChartCtrl',
      templateUrl: 'app/pages/home/trafficChart/trafficChart.html'
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.home')
      .controller('WeatherCtrl', WeatherCtrl);

  /** @ngInject */
  function WeatherCtrl($scope, $http, $timeout, $element) {
    var url = 'http://api.openweathermap.org/data/2.5/forecast';
    var method = 'GET';
    var key = '2de143494c0b295cca9337e1e96b00e0';
    var middleOfTheDay = 15;
    $scope.units = 'metric';
    $scope.weatherIcons = {
      '01d': 'ion-ios-sunny-outline',
      '02d': 'ion-ios-partlysunny-outline',
      '03d': 'ion-ios-cloud-outline',
      '04d': 'ion-ios-cloud',
      '09d': 'ion-ios-rainy',
      '10d': 'ion-ios-rainy-outline',
      '11d': 'ion-ios-thunderstorm-outline',
      '13d': 'ion-ios-snowy',
      '50d': 'ion-ios-cloudy-outline',
      '01n': 'ion-ios-cloudy-night-outline',
      '02n': 'ion-ios-cloudy-night',
      '03n': 'ion-ios-cloud-outline',
      '04n': 'ion-ios-cloud',
      '09n': 'ion-ios-rainy',
      '10n': 'ion-ios-rainy-outline',
      '11n': 'ion-ios-thunderstorm',
      '13n': 'ion-ios-snowy',
      '50n': 'ion-ios-cloudy-outline'
    };
    $scope.weather = {};

    $scope.switchUnits = function (name) {
      $scope.units = name;
      $scope.updateWeather();
    };

    $scope.switchDay = function (day) {
      $scope.weather.current = day;
      makeChart($scope.weather.days[$scope.weather.current].timeTemp)
    };

    $scope.updateWeather = function () {
      $http({
        method: method, url: url, params: {
          appid: key,
          lat: $scope.geoData.geoplugin_latitude,
          lon: $scope.geoData.geoplugin_longitude,
          units: $scope.units
        }
      }).then(function success(response) {
        saveWeatherData(response.data);
        makeChart($scope.weather.days[$scope.weather.current].timeTemp)
      }, function error() {
        console.log("WEATHER FAILED")
      });
    };

    function updateGeoData() {
      $http.jsonp('http://www.geoplugin.net/json.gp?jsoncallback=JSON_CALLBACK').then(function success(response) {
        $scope.geoData = response.data;
        $scope.updateWeather();
      }, function error() {
        console.log("GEO FAILED")
      });
    }

    function makeChart(data) {
      AmCharts.makeChart('tempChart', {
        type: 'serial',
        theme: 'blur',
        handDrawn: true,
        categoryField: 'time',
        dataProvider: data,
        valueAxes: [
          {
            axisAlpha: 0.3,
            gridAlpha: 0
          }
        ],
        graphs: [
          {
            bullet: 'square',
            fillAlphas: 0.3,
            fillColorsField: 'lineColor',
            legendValueText: '[[value]]',
            lineColorField: 'lineColor',
            title: 'Temp',
            valueField: 'temp'
          }
        ],
        categoryAxis: {
          gridAlpha: 0,
          axisAlpha: 0.3
        }
      }).write('tempChart');
    }

    function saveWeatherData(data) {
      var firstItem = data.list[0];
      var weather = {
        days: [{
          date: new Date(),
          timeTemp: [],
          main: firstItem.weather[0].main,
          description: firstItem.weather[0].description,
          icon: firstItem.weather[0].icon,
          temp: firstItem.main.temp
        }], current: 0
      };
      data.list.forEach(function (item, i) {
        var itemDate = new Date(item.dt_txt);
        if (itemDate.getDate() !== weather.days[weather.days.length - 1].date.getDate()) {
          weather.days.push({date: itemDate, timeTemp: []});
        }
        var lastItem = weather.days[weather.days.length - 1];
        lastItem.timeTemp.push({
          time: itemDate.getHours(),
          temp: item.main.temp
        });
        if ((weather.days.length > 1 && itemDate.getHours() == middleOfTheDay) || i == data.list.length - 1) {
          lastItem.main = item.weather[0].main;
          lastItem.description = item.weather[0].description;
          lastItem.icon = item.weather[0].icon;
          lastItem.temp = item.main.temp;
          lastItem.date.setHours(i == data.list.length - 1 ? 0 : middleOfTheDay);
          lastItem.date.setMinutes(0);
        }
      });
      console.log(weather.days[weather.current].date);
      weather.days = weather.days.slice(0, $element.attr('forecast') || 5);
      $scope.weather = weather;
    }

    updateGeoData();
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.home')
      .directive('weather', weather);

  /** @ngInject */
  function weather() {
    return {
      restrict: 'EA',
      controller: 'WeatherCtrl',
      templateUrl: 'app/pages/home/weather/weather.html'
    };
  }
})();
(function () {
  'use strict';
  angular.module('BlurAdmin.pages.inventario.stockProductos', [])
    .controller('stockProductoslistCtrl', ['$scope', 'serviceAPI', '$state', 'baConfig', '$element', 'layoutPaths', function ($scope, serviceAPI, $state, baConfig, $element, layoutPaths) {
      $scope.displayed = [];
      $scope.datos = [];
      $scope.jEmpresa = [];
      $scope.jSucursal = [];


      $scope.callServer = function (tableState) {
        var params = angular.extend({}, tableState.pagination, tableState.search);
        serviceAPI.getStockProductos(params).success(function (r) {
          if (r.success && r.totalItemCount > 0) {
            $scope.displayed = r.rows;
            tableState.pagination.numberOfPages = r.numberOfPages;
          }
        })
      };


      $scope.dataProvider = [];

      serviceAPI.getEmpresas().success(function (r) {
        if (r.success && r.totalItemCount > 0) {
          angular.extend($scope.jEmpresa, r.rows);
        }
      });

      $scope.getSucursal = function (value) {
        serviceAPI.getSucursalId(value).success(function (r) {
          if (r.success && r.totalItemCount > 0) {
            angular.extend($scope.jSucursal, r.rows);
          }
        });
      }

    }])
    .controller('stockProductosModalCtrl', ['$scope', 'serviceAPI', '$state', '$uibModalInstance', function ($scope, serviceAPI, $state, $uibModalInstance) {
      $scope.displayed = [];
      $scope.displayed2 = [];
      $scope.callServer = function (tableState) {
        var params = angular.extend({}, tableState.pagination, tableState.search);
        serviceAPI.getProductoStockModal(params).success(function (r) {
          if (r.success && r.totalItemCount > 0) {
            $scope.displayed = r.rows;
            tableState.pagination.numberOfPages = r.numberOfPages;
          }
        });
      };

      $scope.callServer2 = function (tableState) {
        var params = angular.extend({}, tableState.pagination, tableState.search);
        serviceAPI.getProductoStockModalCantidad(params).success(function (r) {
          if (r.success && r.totalItemCount > 0) {
            $scope.displayed2 = r.rows;
            tableState.pagination.numberOfPages = r.numberOfPages;
          }
        });
      };

      $scope.obtenerProducto = function (value) {
        $uibModalInstance.close(value);
      };

    }])
    .controller('stockProductoslistCtrlModelCtrl', ['$scope', 'serviceAPI', 'item', '$http', '$httpParamSerializerJQLike', '$uibModalInstance', function ($scope, serviceAPI, item, $http, $httpParamSerializerJQLike, $uibModalInstance) {
      $scope.item = $scope.$parent.item || false;
      $scope.jinsumos = [];

      $scope.consultar = function () {
        var i = 1;
        for (i = 1; i <= $scope.item.nu_cantidad; i++) {
          $scope.insumo = {
            id: i,
            no_insumo: $scope.item.no_insumo,
            fe_vencin: ''
          };
          console.log($scope.insumo);
          $scope.jinsumos.push($scope.insumo);
        }
      }

      $scope.opened = {};

      $scope.open = function ($event, elementOpened) {
        $event.preventDefault();
        $event.stopPropagation();

        $scope.opened[elementOpened] = !$scope.opened[elementOpened];
      };
      $scope.cerrar = function () {
        $uibModalInstance.close();
      }

      
      $scope.obtenerProducto = function (value) {
        $uibModalInstance.close(value);
      };

    }])
    .controller('stockProductosCtrl', ['$scope', '$uibModal', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', function ($scope, $uibModal, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log) {
      var vm = this;
      $scope.default = { id_insumo: 0, no_insumo: '', id_categoria_insumo: 0, id_unidad: 0, id_medida: 0, nu_cantidad_medida: 0, nu_stock_minimo: 0, nu_stock_minimo_medida: 0, nu_precio_sugerido: 0 };
      $scope.data = { id_insumo: 0, no_insumo: '', id_categoria_insumo: 0, id_unidad: 0, id_medida: 0, nu_cantidad_medida: 0, nu_stock_minimo: 0, nu_stock_minimo_medida: 0, nu_precio_sugerido: 0 };
      $scope.detalleCompra = [];

      $scope.consultar = function () {
        if ($stateParams.idProducto != '') {
          serviceAPI.getProductoDetalleCompras({ id: $stateParams.idProducto }).success(function (r) {
            if (r.success && r.totalItemCount > 0) {
              $scope.detalleCompra = r.rows;
            }
          });
        }
      };

      $scope.openDetalle = function (size, item, index) {
        $scope.item = item;
        $uibModal.open({
          animation: true,
          templateUrl: "app/pages/inventario/stockInsumos/modal/modalDetalle.html",
          size: size,
          controller: 'stockinsumoModelCtrl',
          scope: $scope,
          resolve: {
            item: function () { }
          }
        }).result.then(function (item) {
          //angular.extend($scope.data, item);                    
        }, function () {
          console.log('Modal dismissed at: ' + new Date());
        });
      };

    }]);
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.inventario.stockValorizado', [])
      .controller('stockValorizadolistCtrl', ['$scope', 'serviceAPI', '$state', 'baConfig', '$element', 'layoutPaths', function ($scope, serviceAPI, $state, baConfig, $element, layoutPaths) {
        $scope.displayed = [];
        $scope.datos = [];
        $scope.jEmpresa = [];
        $scope.jSucursal = [];  
        $scope.data = {nu_total: 0};  
        $scope.default = {nu_total: 0}; 
  
        $scope.callServer = function (tableState) {
          var params = angular.extend({}, tableState.pagination, tableState.search);
          serviceAPI.getStockProductosValorizado(params).success(function (r) {
            angular.extend($scope.data, $scope.default);
            if (r.success && r.totalItemCount > 0) {
              $scope.displayed = r.rows;
              tableState.pagination.numberOfPages = r.numberOfPages;
              angular.forEach($scope.displayed, function(value, key){
                $scope.data.nu_total = parseFloat($scope.data.nu_total) + parseFloat(value.nu_total);
              });  
            }
            console.log($scope.data.nu_total);
          })
        };  
  
        $scope.dataProvider = [];
  
        serviceAPI.getEmpresas().success(function (r) {
          if (r.success && r.totalItemCount > 0) {
            angular.extend($scope.jEmpresa, r.rows);
          }
        });
  
        $scope.getSucursal = function (value) {
          serviceAPI.getSucursalId(value).success(function (r) {
            if (r.success && r.totalItemCount > 0) {
              angular.extend($scope.jSucursal, r.rows);
            }
          });
        }
  
      }])
  })();
(function() {
    'use strict';

    angular.module('BlurAdmin.pages.profile')
        .controller('ProfileModalCtrl', ProfileModalCtrl);

    /** @ngInject */
    function ProfileModalCtrl($scope, $uibModalInstance) {
        $scope.link = '';
        $scope.ok = function() {
            $uibModalInstance.close($scope.link);
        };
    }

})();

(function(){
    'use strict';
    angular.module('BlurAdmin.pages.reportes.productos', [])
        .controller('rptproductosCtrl', [ '$scope', 'serviceAPI', function($scope, serviceAPI){
            $scope.data={id_marca:''};
            $scope.jMarcas=[];
            serviceAPI.getMarcas().success(function(r){
                if(r.success && r.totalItemCount>0){
                    angular.extend($scope.jMarcas, r.rows.map(function(s){
                        return { label: s.desc_laboratorio, value: s.idlaboratorio}
                    }));
                }
            });
        }]);
})();
(function(){
    'use strict';
    angular.module('BlurAdmin.pages.reportes.ventas', [])
        .controller('rptventasCtrl', [ '$scope', 'serviceAPI', 'toastr', function( $scope, serviceAPI, toastr){
            $scope.default={tipdocumento:'', idempleado:0, num_doc: '', apenom:'', fec_inicio:'', fec_hasta:'', details_venta:false};
            $scope.data={tipdocumento:'', idempleado:0, num_doc:'', apenom:'', fec_inicio:'', fec_hasta:'', details_venta:false};
            $scope.open={fec_inicio:false, fec_hasta:false}
            $scope.jTipDocumentos=[];
            serviceAPI.getTiposDocumentos().success(function(r){
                if(r.success && r.totalItemCount>0){
                    angular.extend($scope.jTipDocumentos, r.rows);
                    r.rows.map(function(s){
                        if(s.predeterminado==1){
                            $scope.data.tipdocumento=s;
                        }
                    });
                }
            });

            $scope.consultar_empleado=function(eForm){
                if(eForm.num_doc.$invalid || $scope.data.num_doc==""){
                    if($scope.data.num_doc==""){
                        angular.extend($scope.data, {apenom:'', idempleado:0});
                    }
                    return true;
                }
                serviceAPI.infoEmpleado({tipdoc:$scope.data.tipdocumento.id, numdoc:$scope.data.num_doc}).success(function(r){
                    var typeNotify=(r.success)?'warning':'error';
                    if(r.success && r.num_rows==1){
                        $scope.data.idempleado=r.rows.idempleado;
                        $scope.data.apenom=r.rows.apenom;
                        if(!r.rows.is_vendedor){ r.messages='El empleado no es Vendedor';}else{ typeNotify=''; }
                    }
                    if(typeNotify!='')
                        toastr[typeNotify](r.messages, 'Consulta de Proveedor');
                });
            };

        }]);
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.reportes.compras', [])
        .controller('rptcomprasCtrl', ['$scope', 'serviceAPI', 'toastr', function ($scope, serviceAPI, toastr) {
            $scope.default = {
                tipdocumento: '',
                idempleado: 0,
                num_doc: '',
                apenom: '',
                fec_inicio: '',
                fec_hasta: '',
                details_venta: false
            };
            $scope.data = {
                tipdocumento: 0,
                num_doc: '',
                noclien: '',
                fec_inicio: '',
                fec_hasta: '',
                details_venta: false
            };
            $scope.open = {
                fec_inicio: false,
                fec_hasta: false
            }
            $scope.jTipDocumentos = [];
            serviceAPI.getTiposDocumentos().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jTipDocumentos, r.rows);
                    r.rows.map(function (s) {
                        if (s.predeterminado == 1) {
                            $scope.data.tipdocumento = s;
                        }
                    });
                }
            });

            $scope.consultar_empleado = function (eForm) {
                if (eForm.num_doc.$invalid || $scope.data.num_doc == "") {
                    if ($scope.data.num_doc == "") {
                        angular.extend($scope.data, {
                            apenom: '',
                            idempleado: 0
                        });
                    }
                    return true;
                }
            };


            $scope.rowVentas=[];
            /*
            $scope.consultar = function () {
                serviceAPI.consultarCompras($scope.data).success(function (r) {
                    var typeNotify = (r.success) ? 'warning' : 'error';
                    if (r.success && r.num_rows == 1) {
                        $scope.rowVentas=r.rows;
                        tableState.pagination.numberOfPages =r.numberOfPages;
                        if (!r.rows.is_vendedor) {
                            r.messages = 'El empleado no es Vendedor';
                        } else {
                            typeNotify = '';
                        }
                    }
                    if (typeNotify != '')
                        toastr[typeNotify](r.messages, 'Consulta de Compras');
                });
            };
            */
            $scope.consultar = function () {
                serviceAPI.consultarCompras($scope.data).success(function (r) {
                    var typeNotification=(!r.success)?'error':'warning';
                    if (r.success && r.totalItemCount > 0) {
                        $scope.rowVentas = r.rows;
                        tableState.pagination.numberOfPages = r.numberOfPages;
                    }
                    toastr[typeNotification](r.messages, 'Listado de Compras');
                });
            };

        }]);
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.reportes.diario', [])        
        .controller('rptdiariosCtrl', ['$scope', 'serviceAPI', 'toastr' , 'Excel', '$timeout', function ($scope, serviceAPI, toastr, Excel, $timeout) {
            $scope.data = {fe_inicio: '',fe_fin: ''};
            $scope.default = {fe_inicio: '',fe_fin: ''};
            $scope.jTipDocumentos = [];

            $scope.rowVentas=[];
            
            $scope.consultar = function () {
                serviceAPI.consultarVentasDiarias($scope.data).success(function (r) {
                    var typeNotification=(!r.success)?'error':'warning';
                    console.log(r);
                    if (r.success && r.totalItemCount > 0) {
                        $scope.rowVentas = r.rows;
                        tableState.pagination.numberOfPages = r.numberOfPages;
                    }
                    toastr[typeNotification](r.messages, 'Listado de Ventas');
                });
            };

            $scope.exportToExcel=function(tableId){ // ex: '#my-table'
            console.log(tableId);
            var exportHref= Excel.tableToExcel(tableId,'WireWorkbenchDataExport');
            $timeout(function(){location.href=exportHref;},100); // trigger download
        }

        }]);
})();
(function(){
    'use strict';
    angular.module('BlurAdmin.pages.reportes.general', [])
        .controller('generalCtrl', [ '$scope', 'serviceAPI', 'toastr', function( $scope, serviceAPI, toastr){
            $scope.default={tipdocumento:'', idempleado:0, num_doc: '', apenom:'', fec_inicio:'', fec_hasta:'', details_venta:false};
            $scope.data={tipdocumento:'', idempleado:0, num_doc:'', apenom:'', fec_inicio:'', fec_hasta:'', details_venta:false};
            $scope.open={fec_inicio:false, fec_hasta:false}
            

        }]);
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.reportes.ventas', [])        
        .controller('rptventasCtrl', ['$scope', 'serviceAPI', 'toastr' , 'Excel', '$timeout', function ($scope, serviceAPI, toastr, Excel, $timeout) {
            $scope.data = {fe_inicio: '',fe_fin: ''};
            $scope.default = {fe_inicio: '',fe_fin: ''};
            $scope.jTipDocumentos = [];

            $scope.rowVentas=[];
            
            $scope.consultar = function () {
                serviceAPI.consultarVentasProductos($scope.data).success(function (r) {
                    var typeNotification=(!r.success)?'error':'warning';
                    console.log(r);
                    if (r.success && r.totalItemCount > 0) {
                        $scope.rowVentas = r.rows;
                        tableState.pagination.numberOfPages = r.numberOfPages;
                    }
                    toastr[typeNotification](r.messages, 'Listado de Ventas');
                });
            };

            $scope.exportToExcel=function(tableId){ // ex: '#my-table'
            console.log(tableId);
            var exportHref= Excel.tableToExcel(tableId,'WireWorkbenchDataExport');
            $timeout(function(){location.href=exportHref;},100); // trigger download
        }

        }]);
})();
(function(){
    'use strict';
    angular.module('BlurAdmin.pages.seguridad.roles', [])
    .directive('rolExist', [ '$q', 'serviceAPI', function($q, serviceAPI){
        return {
            require : 'ngModel',
            transclude : true,
            scope :{ idrol:'='},
            link : function($scope, $element, $attrs, ngModel){
                ngModel.$asyncValidators.rolExist=function(modelValue, viewValue){
                    return serviceAPI.existRolUsuario({descripcion:viewValue, id: $scope.idrol}).success(function(r){
                            if(r.success && r.num_rows!=0){
                                return $q.reject();
                            }
                            return true;
                        })
                }
            }
        }
    }])
    .controller('rolesListCtrl',[ '$scope', 'serviceAPI', '$state', 'toastr', function($scope, serviceAPI, $state, toastr){
        $scope.displayed=[];
        $scope.callServer=function(tableState){
            var params = angular.extend({}, tableState.pagination, tableState.search);
            serviceAPI.getRoles(params).success(function(r){
                if(r.success && r.totalItemCount>0){
                    $scope.displayed=r.rows;
                    tableState.pagination.numberOfPages =r.numberOfPages;
                }
            });
        };
        $scope.agregar=function(){
            $state.go('dashboard.seguridad.rol-details');
        };
        $scope.editar=function(id){
            $state.go('dashboard.seguridad.rol-details', {idrol:id});
        };

        $scope.eliminar=function(idrol){
            serviceAPI.deleteRol({id:idrol}).success(function(r){
                var typenotify=(r.success)?'warning':'error';
                if(r.affected_rows==1){
                    typenotify='success';
                    $scope.displayed=$scope.displayed.filter(function(i){ return (i.idrol_sistema!=idrol)});
                }
                toastr[typenotify](r.messages, 'Listado de Roles')
            });
        };

        $scope.changeStatus=function(idrol, actividad, index){
            serviceAPI.cambiarStatusRol({id:idrol, status:actividad}).success(function(r){
                var typenotify='error';
                if(r.num_rows==0){
                    typenotify='warning';
                    $scope.displayed=$scope.displayed.filter(function(i){ return (i.idrol_sistema!=idrol);})
                }
                if(r.affected_rows==1){
                    typenotify='success';
                    $scope.displayed[index].status=r.rows.status;
                }
                toastr[typenotify](r.messages, 'Listado de Rol');
            });
        };

    }])
    .controller('rolesCtrl', [ '$timeout', '$scope', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', function($timeout, $scope, serviceAPI, toastr, $stateParams, baSidebarService){
        var vm=this;
        vm.default={id_rol:0, nombre_rol:'', status:true};
        vm.data={id_rol:0, nombre_rol:'', status:true};
        vm.ignoreChanges = false;
        vm.treeData = [];
        vm.itemsUsuarios=[];
        vm.idrol=$stateParams.idrol || 0;
        $scope.messages={
            nombre_rol:{
                required: 'Campo Obligatorio',
                rolExist: 'Rol Pertenece a otro registro'
            }
        };

        vm.guardar=function(eForm){
            var sendData=angular.extend({}, vm.data, {items: $("#jstree").jstree('get_checked', null, true)});
            serviceAPI.guardarRolUsuario(sendData).success(function(r){
                var typeNotification='error';
                if(r.success){
                    typeNotification=(r.affected_rows==1)?'success':'warning';
                }
                toastr[typeNotification](r.messages, 'Registro de Rol de Usuario');
                angular.extend(vm.data, vm.default);
                eForm.$setPristine();
                eForm.$setUntouched();
                $('#jstree').jstree("uncheck_all");
            });
        };

        vm.consultar=function(){
            if($stateParams.idrol!=''){
                serviceAPI.consultarRolUsuario({id:$stateParams.idrol}).success(function(r){
                    if(r.success && r.num_rows==1){
                        angular.extend(vm.data, r.rows);
                        angular.copy(r.rows.items, vm.itemsUsuarios);
                    }else{
                        toastr.warning(r.messages, 'Información de Rol');
                    }
                }); 
            }
        };

    }]);
})();
(function(){
    'use strict';
    angular.module('BlurAdmin.pages.seguridad.usuario', [])
    .directive('equalToPassword', function(){
        return {
            require: 'ngModel',
            restrict: 'A',
            scope: { password:"="},
            link: function(scope, iElement, iAttrs, ngModel){
                ngModel.$validators.equalToPassword=function(modelValue, viewValue){
                    if(ngModel.$isEmpty(modelValue))
                        return false;
                    return (modelValue==scope.password);
                }
            }
        }
    })
    .directive('passwordStrong', function(){
        return {
            require: 'ngModel',
            restrict: 'A',
            link: function(scope, iElement, iAttrs, ngModelCtrl){
                ngModelCtrl.$validators.passwordStrong=function(modelValue, viewValue){
                    var chars=0;
                    if(ngModelCtrl.$isEmpty(modelValue))
                        return false;
                    if((/[a-z]/).test(modelValue)) chars +=  26;
                    if((/[A-Z]/).test(modelValue)) chars +=  26;
                    if((/[0-9]/).test(modelValue)) chars +=  10;
                    if((/[^a-zA-Z0-9]/).test(modelValue)) chars +=  32;
                    chars += (modelValue.length>8)?6:(modelValue.length<5)?1:3;
                    return (chars>29);
                };
            }
        }
    })
    .directive('jsTree', ['$timeout', 'baSidebarService',  function($timeout, baSidebarService){
        return {
            require: 'ngModel',
            restrict: 'E',
            scope:{ idrol:"="},
            template:"<div id='jstree'></div>",
            link:function(scope, element, attrs, ngModelCtrl){
                var jMenu=[];
                var i=-1;
                baSidebarService.getMenuItems().map(function(item){
                    if(angular.isArray(item.subMenu)){
                        if(!angular.isDefined(id_parent) || id_parent!=item.stateRef){
                            var id_parent=item.stateRef;
                            jMenu.push({id: item.stateRef, icon:item.icon, text: item.title, state:{ opened: true, selected:false}, children:[]});
                            i++;
                        }
                        angular.forEach(item.subMenu, function(value, key){
                            jMenu[i].children.push({id: value.stateRef, text: value.title, state:{selected:false}});
                        });
                    }else{
                        jMenu.push({id: item.stateRef, icon:item.icon, text: item.title, state:{selected:false}});
                        i++;
                    }
                });

                scope.treeInstance=$("div#jstree").jstree({
                    plugins: ["state", "types", "checkbox"],
                    checkbox: {
                        real_checkboxes: true,
                        two_state: true                        
                    },
                    core: {
                        data:{
                            url: 'api/roles.php?oper=menu_user', type: 'POST',
                            contentType: "application/json; charset=utf-8",
                            data: JSON.stringify({id: scope.idrol, menu:jMenu}),
                            dataType: 'json'
                        },
                        types:{
                            default:{
                                icon: 'fa fa-minus'
                            }
                        }
                    }
                }).on('ready.jstree', function(){
                    $('#jstree').jstree("uncheck_all");
                    if(scope.idrol!=''){
                        console.log(ngModelCtrl.$viewValue);
                        angular.forEach(ngModelCtrl.$viewValue, function(item){
                            $('#jstree').jstree("check_node", item.name_state);
                        });
                    }
                    if(angular.isDefined(attrs.hiddenCheckbox) && attrs.hiddenCheckbox){
                        $('#jstree').jstree("hide_checkboxes");
                    }
                });
                
                ngModelCtrl.$render=function(){
                    console.log('render: ', ngModelCtrl.$viewValue)

                }
            }
        }
    }])
    .directive('existUser', [ 'serviceAPI', '$q', function(serviceAPI, $q){
        return {
            require : 'ngModel',
            transclude : true,
            scope :{ id:'=idusuario'},
            link : function($scope, $element, $attrs, ngModel){
                ngModel.$asyncValidators.loginUser=function(modelValue, viewValue){
                    return serviceAPI.exitUsuario({usuario:viewValue, id: $scope.id}).then(function(r){
                            if(r.data.success && r.data.num_rows==1){ 
                                return $q.reject(); 
                            }
                            return $q.resolve();
                    });
                }
            }
        }
    }])
    .controller('usuarioslistCtrl',[ '$scope', 'serviceAPI', '$state', function($scope, serviceAPI, $state){
        $scope.displayed=[];
        $scope.callServer=function(tableState){
            var params = angular.extend({}, tableState.pagination, tableState.search);
            serviceAPI.getUsuarios(params).success(function(r){
                if(r.success && r.totalItemCount>0){
                    $scope.displayed=r.rows;
                    tableState.pagination.numberOfPages =r.numberOfPages;
                }
            });
        };
        $scope.agregar=function(){
            $state.go('dashboard.seguridad.usuario-details');
        };
        $scope.editar=function(id){
            $state.go('dashboard.seguridad.usuario-details', {idempleado:id});
        };
        $scope.changeStatus=function(id){
            
        };
    }])
    .controller('usuarioCtrl', [ '$scope', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', function($scope, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log){
        var vm=this;
        $scope.default={idusuario:0, idempleado:0, idtipdoc:'', num_doc: '', apenom:'', usuario:'', password:'', rep_passw:'', idrol_sistema:'', permission:[]};
        $scope.data={idusuario:0, idempleado:0, idtipdoc:'', num_doc:'', apenom:'', usuario:'', password:'', rep_passw:'', idrol_sistema:'', permission:[]};
        $scope.jTipDocumentos=[];
        $scope.show={password:false, re_passw:false};
        $scope.jRoles=[];
        $scope.class_password='';
        $scope.messages={
            num_doc:{ required: 'Campo Obligatorio' },
            apenom:{ required: 'Campo Obligatorio'}
        };

        serviceAPI.getRoles().success(function(r){
            if(r.success && r.totalItemCount>0){
                angular.extend($scope.jRoles, r.rows);
            }
        });

        serviceAPI.getTiposDocumentos().success(function(r){
            if(r.success && r.totalItemCount>0){
                angular.extend($scope.jTipDocumentos, r.rows);
                r.rows.filter(function(s){
                    if(s.predeterminado==1){ 
                        $scope.data.idtipdoc=s;
                        $scope.default.idtipdoc=s;
                    }
                })
            }
        });
        
        $scope.guardar=function(eForm){
            serviceAPI.guardarUsuario($scope.data).success(function(r){
                var typeNotification='error';
                if(r.success){
                    typeNotification=(r.affected_rows!=0)?'success':'warning';
                }
                toastr[typeNotification](r.messages, 'Registro de Usuario');
                angular.extend($scope.data, $scope.default);
                eForm.$setPristine();
                eForm.$setUntouched();
            });
        };

        $scope.consultar=function(){
            var _this=this;
            if($stateParams.idempleado!=''){
                serviceAPI.consultarUsuario({id:$stateParams.idempleado}).success(function(r){
                    var typeNotification=(!r.success)?'error':'warning';
                    if(r.success && r.num_rows==1){
                        typeNotification='success';
                        angular.extend($scope.data, r.rows);
                        $scope.jTipDocumentos.map(function(a){
                            if(a.id==r.rows.idtipdoc){ $scope.data.idtipdoc=a; }
                        });
                        $scope.jRoles.map(function(b){
                            if(b.idrol_sistema==r.rows.idrol_sistema){ $scope.data.idrol_sistema=b; }
                        });
                    }
                    toastr[typeNotification](r.messages, 'Información de Usuario');
                }); 
            }
        };
        $scope.cargarMenu=function(item){
            serviceAPI.consultarRolUsuario({id: item.idrol_sistema}).success(function(r){
                $('#jstree').jstree("uncheck_all");
                if(r.success && r.num_rows==1){
                    if(r.rows.items.length>0){
                        angular.forEach(r.rows.items, function(item){
                            $('#jstree').jstree("check_node", item.name_state);
                        });
                    }
                }
            })
        };
    }]);
})();

(function(){
    'use strict';
    angular.module('BlurAdmin.pages.sucursal.empresa', [])   
    .controller('empresalistCtrl',[ '$scope', 'serviceAPI', '$state', function($scope, serviceAPI, $state){
        $scope.displayed=[];
        $scope.callServer=function(tableState){
            var params = angular.extend({}, tableState.pagination, tableState.search);
            serviceAPI.getEmpresas(params).success(function(r){
                if(r.success && r.totalItemCount>0){
                    $scope.displayed=r.rows;
                    tableState.pagination.numberOfPages =r.numberOfPages;
                }
            });
        };
        $scope.agregar=function(){
            $state.go('dashboard.sucursal.empresa-details');
        };
        $scope.editar=function(id){
            $state.go('dashboard.sucursal.empresa-details', {idempresa:id});
        };
        $scope.changeStatus=function(id){
            
        };
    }])
    .controller('empresaCtrl', [ '$scope', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', function($scope, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log){
        var vm=this;
        $scope.default={id_empresa:0,id_ubigeo:0,no_empresa:'',nu_ruc:'',no_direccion:'',nu_telefono:'',no_logo:'',status:0,co_depart:'',co_provin:'',co_distri:''};
        $scope.data={id_empresa:0,id_ubigeo:0,no_empresa:'',nu_ruc:'',no_direccion:'',nu_telefono:'',no_logo:'',status:0,co_depart:'',co_provin:'',co_distri:''};
        
        $scope.a_departamento = [];
        $scope.a_provincia = [];
        $scope.a_distrito = [];

        serviceAPI.getDepartamento().then(function (r) {
            if (r.data.totalItemCount > 0 && r.data.success) { 
                angular.extend($scope.a_departamento, r.data.rows);
            }
        });

        $scope.getpDepartamento = function () {
            serviceAPI.getProvincia($scope.data).then(function (r) {
                if (r.data.totalItemCount > 0 && r.data.success) {
                    angular.extend($scope.a_provincia, r.data.rows);
                }
            });
        }
        $scope.getpProvincia = function () {
            serviceAPI.getDistrito($scope.data).then(function (r) {
                if (r.data.totalItemCount > 0 && r.data.success) {
                    angular.extend($scope.a_distrito, r.data.rows);
                }
            });
        }
                
        $scope.guardar=function(eForm){
            serviceAPI.guardarEmpresa($scope.data).success(function(r){
                var typeNotification='error';
                if(r.success){
                    typeNotification=(r.affected_rows!=0)?'success':'warning';
                }
                toastr[typeNotification](r.messages, 'Registro de Empresa');
                angular.extend($scope.data, $scope.default);
                eForm.$setPristine();
                eForm.$setUntouched();
            });
        };

        $scope.consultar=function(){            
            if($stateParams.idempresa!=''){
                serviceAPI.consultaEmpresa({id:$stateParams.idempresa}).success(function(r){
                    var typeNotification=(!r.success)?'error':'warning';
                    if(r.success && r.num_rows==1){
                        typeNotification='success';
                        angular.extend($scope.data, r.rows);
                        $scope.a_departamento.map(function (a) {
                            if (a.id == r.rows.co_depart) {
                                $scope.data.co_depart = a;
                            }
                        });

                        serviceAPI.getProvincia($scope.data).then(function (rp) {
                            if (rp.data.totalItemCount > 0 && rp.data.success) {
                                angular.extend($scope.a_provincia, rp.data.rows);
                                $scope.a_provincia.map(function (b) {
                                    if(b.id == r.rows.co_provin) {
                                        $scope.data.co_provin = b;
                                    }
                                });
                            }
                        });
                        serviceAPI.getDistrito($scope.data).then(function (rd) {
                            if (rd.data.totalItemCount > 0 && rd.data.success) {
                                angular.extend($scope.a_distrito, rd.data.rows);
                                $scope.a_distrito.map(function (c) {
                                    if (c.id == r.rows.co_distri) {
                                        $scope.data.co_distri = c;
                                    }
                                });
                            }
                        });
                    }
                    toastr[typeNotification](r.messages, 'Información de Empresa');
                }); 
            }
        };
    }]);
})();
(function(){
    'use strict';
    angular.module('BlurAdmin.pages.sucursal.sucursales', [])   
    .controller('sucursaleslistCtrl',[ '$scope', 'serviceAPI', '$state', function($scope, serviceAPI, $state){
        $scope.displayed=[];
        $scope.callServer=function(tableState){
            var params = angular.extend({}, tableState.pagination, tableState.search);
            serviceAPI.getSucursal(params).success(function(r){
                if(r.success && r.totalItemCount>0){
                    $scope.displayed=r.rows;
                    tableState.pagination.numberOfPages =r.numberOfPages;
                }
            });
        };
        $scope.agregar=function(){
            $state.go('dashboard.sucursal.sucursales-details');
        };
        $scope.editar=function(id){
            $state.go('dashboard.sucursal.sucursales-details', {idsucursales:id});
        };
        $scope.changeStatus=function(id){
            
        };
    }])
    .controller('sucursalesCtrl', [ '$scope', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', function($scope, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log){
        var vm=this;
        $scope.default={id_local:0,id_ubigeo:0,no_local:'',no_alias:'',no_direccion:'',id_empresa:0,status:0,co_depart:'',co_provin:'',co_distri:''};
        $scope.data={id_local:0,id_ubigeo:0,no_local:'',no_alias:'',no_direccion:'',id_empresa:0,status:0,co_depart:'',co_provin:'',co_distri:''};
        $scope.jEmpresa=[];
        $scope.a_departamento = [];
        $scope.a_provincia = [];
        $scope.a_distrito = [];

        serviceAPI.getEmpresas().success(function(r){
            console.log(r);
            if(r.success && r.totalItemCount>0){
                angular.extend($scope.jEmpresa, r.rows);
            }
        });

        serviceAPI.getDepartamento().then(function (r) {
            if (r.data.totalItemCount > 0 && r.data.success) { 
                angular.extend($scope.a_departamento, r.data.rows);
            }
        });

        $scope.getpDepartamento = function () {
            serviceAPI.getProvincia($scope.data).then(function (r) {
                if (r.data.totalItemCount > 0 && r.data.success) {
                    angular.extend($scope.a_provincia, r.data.rows);
                }
            });
        }
        $scope.getpProvincia = function () {
            serviceAPI.getDistrito($scope.data).then(function (r) {
                if (r.data.totalItemCount > 0 && r.data.success) {
                    angular.extend($scope.a_distrito, r.data.rows);
                }
            });
        }

        $scope.guardar=function(eForm){
            serviceAPI.guardarSucursales($scope.data).success(function(r){
                var typeNotification='error';
                if(r.success){
                    typeNotification=(r.affected_rows!=0)?'success':'warning';
                }
                toastr[typeNotification](r.messages, 'Registro de sucursales');
                angular.extend($scope.data, $scope.default);
                eForm.$setPristine();
                eForm.$setUntouched();
            });
        };

        $scope.consultar=function(){            
            if($stateParams.idsucursales!=''){
                serviceAPI.consultaSucursal({id:$stateParams.idsucursales}).success(function(r){
                    var typeNotification=(!r.success)?'error':'warning';
                    if(r.success && r.num_rows==1){
                        typeNotification='success';
                        angular.extend($scope.data, r.rows);
                        $scope.jEmpresa.map(function(b){
                            if(b.id_empresa==r.rows.id_empresa){ $scope.data.id_empresa=b; }
                        });

                        $scope.a_departamento.map(function (a) {
                            if (a.id == r.rows.co_depart) {
                                $scope.data.co_depart = a;
                            }
                        });

                        serviceAPI.getProvincia($scope.data).then(function (rp) {
                            if (rp.data.totalItemCount > 0 && rp.data.success) {
                                angular.extend($scope.a_provincia, rp.data.rows);
                                $scope.a_provincia.map(function (b) {
                                    if(b.id == r.rows.co_provin) {
                                        $scope.data.co_provin = b;
                                    }
                                });
                            }
                        });
                        serviceAPI.getDistrito($scope.data).then(function (rd) {
                            if (rd.data.totalItemCount > 0 && rd.data.success) {
                                angular.extend($scope.a_distrito, rd.data.rows);
                                $scope.a_distrito.map(function (c) {
                                    if (c.id == r.rows.co_distri) {
                                        $scope.data.co_distri = c;
                                    }
                                });
                            }
                        });
                    }
                    toastr[typeNotification](r.messages, 'Información de Sucursal');
                }); 
            }
        };
    }]);
})();
/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.buttons')
      .controller('ButtonPageCtrl', ButtonPageCtrl);

  /** @ngInject */
  function ButtonPageCtrl($scope, $timeout) {
    $scope.progressFunction = function() {
      return $timeout(function() {}, 3000);
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.icons')
      .controller('IconsPageCtrl', IconsPageCtrl);

  /** @ngInject */
  function IconsPageCtrl($scope) {
    $scope.icons = {
      kameleonIcons: [
        {
          name: 'Beach',
          img: 'Beach'
        },
        {
          name: 'Bus',
          img: 'Bus'
        },
        {
          name: 'Cheese',
          img: 'Cheese'
        },
        {
          name: 'Desert',
          img: 'Desert'
        },
        {
          name: 'Images',
          img: 'Images'
        },
        {
          name: 'Magician',
          img: 'Magician'
        },
        {
          name: 'Makeup',
          img: 'Makeup'
        },
        {
          name: 'Programming',
          img: 'Programming'
        },
        {
          name: 'Shop',
          img: 'Shop'
        },
        {
          name: 'Surfer',
          img: 'Surfer'
        },
        {
          name: 'Phone Booth',
          img: 'Phone-Booth'
        },
        {
          name: 'Ninja',
          img: 'Ninja'
        },
        {
          name: 'Apartment',
          img: 'Apartment'
        },
        {
          name: 'Batman',
          img: 'Batman'
        },
        {
          name: 'Medal',
          img: 'Medal-2'
        },
        {
          name: 'Money',
          img: 'Money-Increase'
        },
        {
          name: 'Street View',
          img: 'Street-View'
        },
        {
          name: 'Student',
          img: 'Student-3'
        },
        {
          name: 'Bell',
          img: 'Bell'
        },
        {
          name: 'Woman',
          img: 'Boss-5'
        },
        {
          name: 'Euro',
          img: 'Euro-Coin'
        },
        {
          name: 'Chessboard',
          img: 'Chessboard'
        },
        {
          name: 'Burglar',
          img: 'Burglar'
        },
        {
          name: 'Dna',
          img: 'Dna'
        },
        {
          name: 'Clipboard Plan',
          img: 'Clipboard-Plan'
        },
        {
          name: 'Boss',
          img: 'Boss-3'
        },
        {
          name: 'Key',
          img: 'Key'
        },
        {
          name: 'Surgeon',
          img: 'Surgeon'
        },
        {
          name: 'Hacker',
          img: 'Hacker'
        },
        {
          name: 'Santa',
          img: 'Santa'
        }
      ],
      kameleonRoundedIcons: [
        {
          color: 'success',
          img: 'Apartment',
          name: 'Apartment'
        },
        {
          color: 'warning',
          img: 'Bus',
          name: 'Bus'
        },
        {
          color: 'primary',
          img: 'Checklist',
          name: 'Checklist'
        },
        {
          color: 'warning',
          img: 'Desert',
          name: 'Desert'
        },
        {
          color: 'danger',
          img: 'Laptop-Signal',
          name: 'Laptop Signal'
        },
        {
          color: 'info',
          img: 'Love-Letter',
          name: 'Love Letter'
        },
        {
          color: 'success',
          img: 'Makeup',
          name: 'Makeup'
        },
        {
          color: 'primary',
          img: 'Santa',
          name: 'Santa'
        },
        {
          color: 'success',
          img: 'Surfer',
          name: 'Surfer'
        },
        {
          color: 'info',
          img: 'Vector',
          name: 'Vector'
        },
        {
          color: 'warning',
          img: 'Money-Increase',
          name: 'Money Increase'
        },
        {
          color: 'info',
          img: 'Alien',
          name: 'Alien'
        },
        {
          color: 'danger',
          img: 'Online-Shopping',
          name: 'Online Shopping'
        },
        {
          color: 'warning',
          img: 'Euro-Coin',
          name: 'Euro'
        },
        {
          color: 'info',
          img: 'Boss-3',
          name: 'Boss'
        }
      ],
      ionicons: ['ion-ionic', 'ion-arrow-right-b', 'ion-arrow-down-b', 'ion-arrow-left-b', 'ion-arrow-up-c', 'ion-arrow-right-c', 'ion-arrow-down-c', 'ion-arrow-left-c', 'ion-arrow-return-right', 'ion-arrow-return-left', 'ion-arrow-swap', 'ion-arrow-shrink', 'ion-arrow-expand', 'ion-arrow-move', 'ion-arrow-resize', 'ion-chevron-up', 'ion-chevron-right', 'ion-chevron-down', 'ion-chevron-left', 'ion-navicon-round', 'ion-navicon', 'ion-drag', 'ion-log-in', 'ion-log-out', 'ion-checkmark-round', 'ion-checkmark', 'ion-checkmark-circled', 'ion-close-round', 'ion-plus-round', 'ion-minus-round', 'ion-information', 'ion-help', 'ion-backspace-outline', 'ion-help-buoy', 'ion-asterisk', 'ion-alert', 'ion-alert-circled', 'ion-refresh', 'ion-loop', 'ion-shuffle', 'ion-home', 'ion-search', 'ion-flag', 'ion-star', 'ion-heart', 'ion-heart-broken', 'ion-gear-a', 'ion-gear-b', 'ion-toggle-filled', 'ion-toggle', 'ion-settings', 'ion-wrench', 'ion-hammer', 'ion-edit', 'ion-trash-a', 'ion-trash-b', 'ion-document', 'ion-document-text', 'ion-clipboard', 'ion-scissors', 'ion-funnel', 'ion-bookmark', 'ion-email', 'ion-email-unread', 'ion-folder', 'ion-filing', 'ion-archive', 'ion-reply', 'ion-reply-all', 'ion-forward'],
      fontAwesomeIcons: ['fa fa-adjust', 'fa fa-anchor', 'fa fa-archive', 'fa fa-area-chart', 'fa fa-arrows', 'fa fa-arrows-h', 'fa fa-arrows-v', 'fa fa-asterisk', 'fa fa-at', 'fa fa-automobile', 'fa fa-ban', 'fa fa-bank', 'fa fa-bar-chart', 'fa fa-bar-chart-o', 'fa fa-barcode', 'fa fa-bars', 'fa fa-bed', 'fa fa-beer', 'fa fa-bell', 'fa fa-bell-o', 'fa fa-bell-slash', 'fa fa-bell-slash-o', 'fa fa-bicycle', 'fa fa-binoculars', 'fa fa-birthday-cake', 'fa fa-bolt', 'fa fa-bomb', 'fa fa-book', 'fa fa-bookmark', 'fa fa-bookmark-o', 'fa fa-briefcase', 'fa fa-bug', 'fa fa-building', 'fa fa-building-o', 'fa fa-bullhorn'],
      socicon: ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', ',', ';', ':', '+', '@', '=', '-', '^', '?', '$', '*', '&', '(', '#', '.', '_', ']', ')', '\'', '"', '}', '{']
    };
  }

})();

/**
 * @author a.demeshko
 * created on 18.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications')
    .controller('ModalsPageCtrl', ModalsPageCtrl);

  /** @ngInject */
  function ModalsPageCtrl($scope, $uibModal) {
    $scope.open = function (page, size) {
      $uibModal.open({
        animation: true,
        templateUrl: page,
        size: size,
        resolve: {
          items: function () {
            return $scope.items;
          }
        }
      });
    };
  }


})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.notifications')
      .controller('NotificationsPageCtrl', NotificationsPageCtrl);

  /** @ngInject */
  function NotificationsPageCtrl($scope, toastr, toastrConfig) {
    var defaultConfig = angular.copy(toastrConfig);
    $scope.types = ['success', 'error', 'info', 'warning'];

    $scope.quotes = [
      {
        title: 'Come to Freenode',
        message: 'We rock at <em>#angularjs</em>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Looking for bootstrap?',
        message: 'Try ui-bootstrap out!'
      },
      {
        title: 'Wants a better router?',
        message: 'We have you covered with ui-router'
      },
      {
        title: 'Angular 2',
        message: 'Is gonna rock the world'
      },
      {
        title: null,
        message: 'Titles are not always needed'
      },
      {
        title: null,
        message: 'Toastr rock!'
      },
      {
        title: 'What about nice html?',
        message: '<strong>Sure you <em>can!</em></strong>',
        options: {
          allowHtml: true
        }
      },
      {
        title: 'Ionic is <em>cool</em>',
        message: 'Best mobile framework ever',
        options: {
          allowHtml: true
        }
      }
    ];

    var openedToasts = [];
    $scope.options = {
      autoDismiss: false,
      positionClass: 'toast-top-right',
      type: 'info',
      timeOut: '5000',
      extendedTimeOut: '2000',
      allowHtml: false,
      closeButton: false,
      tapToDismiss: true,
      progressBar: false,
      newestOnTop: true,
      maxOpened: 0,
      preventDuplicates: false,
      preventOpenDuplicates: false,
      title: "Some title here",
      msg: "Type your message here"
    };


    $scope.clearLastToast = function () {
      var toast = openedToasts.pop();
      toastr.clear(toast);
    };

    $scope.clearToasts = function () {
      toastr.clear();
    };

    $scope.openRandomToast = function () {
      var type = Math.floor(Math.random() * $scope.types.length);
      var quote = Math.floor(Math.random() * $scope.quotes.length);
      var toastType = $scope.types[type];
      var toastQuote = $scope.quotes[quote];
      openedToasts.push(toastr[toastType](toastQuote.message, toastQuote.title, toastQuote.options));
      $scope.optionsStr = "toastr." + toastType + "(\'" + toastQuote.message + "\', \'" + toastQuote.title + "', " + JSON.stringify(toastQuote.options || {}, null, 2) + ")";
    };

    $scope.openToast = function () {
      angular.extend(toastrConfig, $scope.options);
      openedToasts.push(toastr[$scope.options.type]($scope.options.msg, $scope.options.title));
      var strOptions = {};
      for (var o in  $scope.options) if (o != 'msg' && o != 'title')strOptions[o] = $scope.options[o];
      $scope.optionsStr = "toastr." + $scope.options.type + "(\'" + $scope.options.msg + "\', \'" + $scope.options.title + "\', " + JSON.stringify(strOptions, null, 2) + ")";
    };

    $scope.$on('$destroy', function iVeBeenDismissed() {
      angular.extend(toastrConfig, defaultConfig);
    });
  }

})();

(function () {
    'use strict';
    angular.module('BlurAdmin.pages.venta.caja', [])
        .controller('cajalistCtrl', ['$scope', 'serviceAPI','toastr', '$uibModal', '$state', function ($scope, serviceAPI, toastr,$uibModal, $state) {
            $scope.data = { id_local: 0, no_local: '', va_caja: 0, fe_date: '', no_hora: '' };
            $scope.default = { id_local: 0, no_local: '', va_caja: 0, fe_date: '', no_hora: '' };

            $scope.displayed = [];
            $scope.callServer = function (tableState) {
                var params = angular.extend({}, tableState.pagination, tableState.search);
                serviceAPI.getCajas(params).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        $scope.displayed = r.rows;
                        tableState.pagination.numberOfPages = r.numberOfPages;
                    }
                });
            };

            $scope.agregarCaja = function (size) {
                serviceAPI.datosCaja($scope.item).success(function (r) {
                    console.log(r);
                    var typeNotification = 'error';
                    if (r.success) {
                        $uibModal.open({
                            animation: true,
                            size: size,
                            templateUrl: "app/pages/ventas/caja/caja.html",
                            controller: 'cajaCtrl',
                            scope: $scope
                        }).result.then(function (data) {
                            angular.extend($scope.data, data);
                            typeNotification = 'success';
                            toastr[typeNotification](r.messages, 'Informacion del Sistema');
                            $scope.callServer({});
                        }, function () {
                            console.log('Modal dismissed at: ' + new Date());
                        });
                        angular.extend($scope.data, r.rows);                        
                    } else {
                        toastr[typeNotification](r.messages, 'Informacion del Sistema');
                    }                   
                });
            };


            $scope.cierreCaja = function (item) {
                serviceAPI.cerrarCaja(item).success(function (r) {
                    var typeNotification = 'error';
                    if (r.success) {
                        typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                    }
                    toastr[typeNotification](r.messages, 'Registro de Caja');
                })
                serviceAPI.getCajas({}).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        $scope.displayed = r.rows;
                    }
                });           
            };

        }])
        .controller('cajaCtrl', ['$scope', 'serviceAPI', '$http', '$httpParamSerializerJQLike', '$uibModalInstance', function ($scope, serviceAPI, $http, $httpParamSerializerJQLike, $uibModalInstance) {
            $scope.data = $scope.$parent.data || false;
            
            $scope.cerrar = function () {
                $uibModalInstance.close($scope.data);
            }
            $scope.guardar = function (eForm) {
                serviceAPI.guardarApertura($scope.data).success(function (r) {
                    var typeNotification = 'error';
                    if (r.success) {
                        typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                    }
                    toastr[typeNotification](r.messages, 'Registro de Caja');

                });
                $scope.cerrar();
            };
        }])
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.venta.cotizacion', [])
        .controller('cotizacionlistCtrl', ['$scope', '$uibModal', 'serviceAPI', '$state', function ($scope, $uibModal, serviceAPI, $state) {
            $scope.data = { nu_compras: 0, nu_total: 0 };
            $scope.displayed = [];
            $scope.callServer = function (tableState) {
                var params = angular.extend({}, tableState.pagination, tableState.search);
                serviceAPI.listCotizacion(params).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        $scope.displayed = r.rows;
                        tableState.pagination.numberOfPages = r.numberOfPages;
                    }
                });
            };

            $scope.agregar = function () {
                $state.go('dashboard.venta.cotizacion-details');
            };
            $scope.editar = function (id) {
                $state.go('dashboard.venta.cotizacion-details', { idCompras: id_compras });
            };
            $scope.changeStatus = function (id) {

            };

            $scope.openPdf = function (size, item) {
                console.log('entro');
                $scope.item = item;
                $uibModal.open({
                    animation: true,
                    templateUrl: "app/pages/ventas/cotizacion/modal/modalPdf.html",
                    size: size,
                    controller: 'modalCtrl',
                    scope: $scope,
                    resolve: {
                        item: function () { }
                    }
                }).result.then(function (item) {
                    angular.extend($scope.data, item);
                }, function () {

                });
            };


        }])
        .controller('modalCtrl', ['$scope', 'item', '$http', '$httpParamSerializerJQLike', '$uibModalInstance', function ($scope, item, $http, $httpParamSerializerJQLike, $uibModalInstance) {
            $scope.item = $scope.$parent.item || false;
            $scope.status = 0;
            $scope.respuesta = 0;
            $scope.archivo = '';
            $scope.url = '';

            if (angular.isObject($scope.item)) {
                console.log($scope.item);

                $scope.archivo = 'api/api-omec/examples/report/boleta.php';


            }

            $scope.pdf = function () {
                $uibModalInstance.close($scope.item);
            }


            $scope.cerrar = function (data) {
                $uibModalInstance.close($scope.data);

            }
            $scope.enviaCorreo = function () {
                $http({
                    url: 'api/ventas.php',
                    method: 'POST',
                    data: $httpParamSerializerJQLike({ oper: 'envioCorreo', info: $scope.item }),
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
                }).then(function (response) {
                    if (response.data.success) {
                        $("#result").html(response.data.message);
                    } else
                        $("#result").html(response.data.message);
                }, function (response) {
                    toastr.error("ha fallado el proceso ", 'Error')
                });
            };



        }])
        .controller('cotizacionCtrl', ['$scope', '$uibModal', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', '$filter', function ($scope, $uibModal, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log, $filter) {
            var vm = this;
            $scope.default = {
                id_cotizacion: 0, id_tipo_pago: 0, no_observacion:'',id_cliente: 0, id_tipo_comprobante: 0, id_usuario: 0, id_estado_sunat: 0, nu_serie: '', nu_correlativo: '', nu_sub_total: 0, nu_igv: 0, nu_total: 0, fe_emision: '', id_estado: 0, id_local: 0, no_cliente: '', nu_documento: '',
                nu_efectivo: 0, nu_izipay: 0, nu_efectivo2: 0, nu_izipay2: 0, nu_trasnferencia: 0, nu_credito: 0, no_descuento: 0, nu_rappi: 0, id_cupon:0, no_resp_cupon:'', co_cupon:'', va_descuento:0, id_cupon_descuento:0 
            };
            $scope.data = {
                id_cotizacion: 0, id_tipo_pago: 0,no_observacion:'', id_cliente: 0, id_tipo_comprobante: 0, id_usuario: 0, id_estado_sunat: 0, nu_serie: '', nu_correlativo: '', nu_sub_total: 0, nu_igv: 0, nu_total: 0, fe_emision: '', id_estado: 0, id_local: 0, no_cliente: '', nu_documento: '',
                nu_efectivo: 0, nu_izipay: 0, nu_efectivo2: 0, nu_izipay2: 0, nu_trasnferencia: 0, nu_credito: 0, no_descuento: 0, nu_rappi: 0, id_cupon:0, no_resp_cupon:'', co_cupon:'', va_descuento:0, id_cupon_descuento:0 
            };

            $scope.datap = { id_producto: 0, igv: 0, id_marca: 0,nu_cantidad:0, nu_stock_minimo: 0, codigo: '', no_producto: '', id_categoria: 0, id_medida: 0, no_medida: '', id_tipo_producto: 0, no_descripcion: '', id_atributo: 0, id_parent_atributo: 0, mto_ult_venta: 0, id_empresa: 0, id_local: 0, nu_cantidad_p: 0, co_barra: '', nu_descuento: 0, mto_descueto: 0, id_cliente_descuento: 0 , il_descuento: false};
            $scope.defaultp = { id_producto: 0, igv: 0, id_marca: 0,nu_cantidad:0, nu_stock_minimo: 0, codigo: '', no_producto: '', id_categoria: 0, id_medida: 0, no_medida: '', id_tipo_producto: 0, no_descripcion: '', id_atributo: 0, id_parent_atributo: 0, mto_ult_venta: 0, id_empresa: 0, id_local: 0, nu_cantidad_p: 0, co_barra: '', nu_descuento: 0, mto_descueto: 0, id_cliente_descuento: 0 , il_descuento: false};

            $scope.jComprobante = [];
            $scope.jtipopago = [];
            $scope.jDescuento = [];

            serviceAPI.getTipoPago().success(function (r) {
                if (r.num_rows > 0 && r.success) {
                    angular.extend($scope.jtipopago, r.rows);
                }
            });

            serviceAPI.getComprobanteCoti().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jComprobante, r.rows);
                }
            });
            $scope.getCorrelativo = function (value) {
                serviceAPI.consultarCorrelativo(value).then(function (r) {
                    if (r.data.success && r.data.num_rows == 1) {
                        console.log(r);
                        $scope.data.nu_serie = r.data.rows.nu_serie;
                        $scope.data.nu_correlativo = $scope.zfill(r.data.rows.nu_correlativo, 8);
                    }
                });
            }
            $scope.zfill = function (number, width) {
                var numberOutput = Math.abs(number); /* Valor absoluto del número */
                var length = number.toString().length; /* Largo del número */
                var zero = "0"; /* String de cero */

                if (width <= length) {
                    if (number < 0) {
                        return ("-" + numberOutput.toString());
                    } else {
                        return numberOutput.toString();
                    }
                } else {
                    if (number < 0) {
                        return ("-" + (zero.repeat(width - length)) + numberOutput.toString());
                    } else {
                        return ((zero.repeat(width - length)) + numberOutput.toString());
                    }
                }
            }


            $scope.crearProduct = function (size) {
                $uibModal.open({
                    animation: true,
                    size: size,
                    templateUrl: "app/pages/clientes/cliente/clienteModal.html",
                    controller: 'clienteCtrl',
                    scope: $scope
                }).result.then(function (data) {
                    console.log(data);
                    angular.extend($scope.data, data);
                }, function () {
                    console.log('Modal dismissed at: ' + new Date());
                });
            };

            $scope.modalProducts = function (size) {
                $uibModal.open({
                    animation: true,
                    size: size,
                    templateUrl: "app/pages/clientes/cliente/list/clienteListModal.html",
                    controller: 'clienteModalCtrl',
                    scope: $scope
                }).result.then(function (data) {
                    console.log(data);
                    angular.extend($scope.data, data);
                    
                    
                    serviceAPI.getTipoDescuento($scope.data.id_cliente).success(function (r) {
                        if (r.totalItemCount > 0 && r.success) {
                            angular.extend($scope.jDescuento, r.rows);
                        }
                    });

                }, function () {
                    console.log('Modal dismissed at: ' + new Date());
                });
            };

            $scope.modalProducto = function (size) {
                $uibModal.open({
                    animation: true,
                    size: size,
                    templateUrl: "app/pages/inventario/stockProductos/list/listProductosModalPos.html",
                    controller: 'stockProductosModalCtrl',
                    scope: $scope
                }).result.then(function (data) {
                    angular.extend($scope.datap, data);
                }, function () {
                    console.log('Modal dismissed at: ' + new Date());
                });
            };

            $scope.modalCupon = function (size) {
                $uibModal.open({
                    animation: true,
                    size: size,
                    templateUrl: "app/pages/catalogo/cuponera/modal/listCuponModal.html",
                    controller: 'ModalCuponCtrl',
                    scope: $scope
                }).result.then(function (data) {
                    console.log(data);
                    angular.extend($scope.data, data);
                    
                    $scope.descontar(data);
                }, function () {
                    console.log('Modal dismissed at: ' + new Date());
                });
            };

            $scope.descontar = function(value){
                console.log(value.va_descuento);
                var mMonto = ($scope.data.nu_total * value.va_descuento)/100;
                $scope.data.nu_total = $scope.data.nu_total - mMonto;
            }


            $scope.selection = [];

            $scope.toggleSelection = function toggleSelection(fruitName) {
                console.log(fruitName);
                var idx = $scope.selection.indexOf(fruitName);
                if (idx > -1) {
                    $scope.selection.splice(idx, 1);
                }
                else {
                    $scope.selection.push(fruitName);
                }
                console.log($scope.selection);
            };
            $scope.rowCollection = [];
            var item = 0;
            var item2 = 0;
            $scope.addItem = function () {
                var itemActual;
                var monto;
                if ($scope.datap.mto_descueto != 0) {
                    monto = $scope.datap.mto_descueto;
                } else {
                    monto = $scope.datap.mto_ult_venta;
                }
                
                if ($scope.datap.nu_cantidad_p != 0) {
                    for (var i = 0; i < $scope.rowCollection.length; i++) {
                        if ($scope.rowCollection[i].id_producto == $scope.datap.id_producto && $scope.rowCollection[i].pr_descuento == $scope.datap.pr_descuento ) {
                            itemActual = $scope.rowCollection[i];
                        }
                    }
                    if (!itemActual) {
                        $scope.rowCollection.push(_.extend({
                            id: ++item,
                            id_producto: $scope.datap.id_producto,
                            no_producto: $scope.datap.no_producto,
                            nu_cantidad_p: $scope.datap.nu_cantidad_p,
                            nu_precio_unitario: $scope.datap.mto_ult_venta,
                            pr_descuento: $scope.datap.pr_descuento,
                            nu_precio_descuento: monto,
                            nu_total: (parseFloat($scope.datap.nu_cantidad_p) * parseFloat(monto)).toFixed(2)
                        },
                            $scope.datap)
                        );
                        var params = { detalle: $scope.rowCollection };
                            serviceAPI.guardarTemporal(params).success(function (r) {
                                var typeNotification = 'error';
                                if (r.success) {
                                    typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                                }
                                toastr[typeNotification](r.messages, 'Registro Detalle');
                            });
                    } else {
                        itemActual.nu_cantidad_p = parseInt(itemActual.nu_cantidad_p) + parseInt($scope.datap.nu_cantidad_p);
                        itemActual.nu_total = itemActual.nu_cantidad_p * itemActual.nu_precio_descuento;
                        var params = { detalle: $scope.rowCollection };
                        serviceAPI.actualizarTemporal(itemActual).success(function (r) {
                            var typeNotification = 'error';
                            if (r.success) {
                                typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                            }
                            toastr[typeNotification](r.messages, 'Registro Detalle');
                        });

                    }
                    $scope.data.nu_total = $filter('Total')($scope.rowCollection, 'nu_cantidad_p', 'nu_precio_descuento', 2);
                    $scope.data.nu_sub_total = parseFloat($scope.data.nu_total / 1.18).toFixed(2);
                    $scope.data.nu_igv = parseFloat($scope.data.nu_total - $scope.data.nu_sub_total).toFixed(2);
                    angular.extend($scope.datap, $scope.defaultp);

                } else {
                    var typeNotification = 'error';
                    toastr[typeNotification]('Ingrese Cantidad', 'Información del Sistema');
                }

            };

            $scope.quitar_producto = function (id) {
                console.log(id);
                $scope.rowCollection = $scope.rowCollection.filter(function (item) {
                    return item.id != id;
                });
                var params = { detalle: $scope.rowCollection };
                serviceAPI.eliminarTemporal(params).success(function (r) {
                    var typeNotification = 'error';
                    if (r.success) {
                        typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                    }
                    toastr[typeNotification](r.messages, 'Eliminar Detalle');
                });
                $scope.data.nu_total = $filter('Total')($scope.rowCollection, 'nu_cantidad_p', 'nu_precio', 2);
                $scope.data.nu_sub_total = parseFloat($scope.data.nu_total / 1.18).toFixed(2);
                $scope.data.nu_igv = parseFloat($scope.data.nu_total - $scope.data.nu_sub_total).toFixed(2);
            };


            $scope.guardar = function () {

                angular.forEach($scope.rowCollection ,function(value,key){
                    serviceAPI.eliminarTemporal({ id: value.id }).success(function (r) {
                    });
                });

                var params = { orden: $scope.data, detalle: $scope.rowCollection };
                serviceAPI.guardarCotizacion(params).success(function (r) {
                    var typeNotification = 'error';
                    if (r.success) {
                        typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                    }
                    toastr[typeNotification](r.messages, 'Registro de Cotización');
                    angular.extend($scope.data, $scope.default);
                    angular.extend($scope.datap, $scope.defaultp);
                    $scope.rowCollection = [];
                });
            };

            $scope.buscarCodigoBarras = function () {
                serviceAPI.buscarProductoxCodigoVenta($scope.datap).success(function (r) {
                    if (r.success && r.num_rows == 1) {
                        angular.extend($scope.datap, r.rows);
                        //$scope.addItem();
                    }
                });
            }

            $scope.limpiar = function () {
                angular.extend($scope.datap, $scope.defaultp);
            }

            $scope.getMontoDescuento = function (value) {
                serviceAPI.consultarMontoDescuento(value).then(function (r) {
                    if (r.data.success && r.data.num_rows == 1) {
                        var desc = (r.data.rows.pr_descuento * $scope.datap.mto_ult_venta) / 100;
                        $scope.datap.pr_descuento = r.data.rows.pr_descuento;
                        $scope.datap.mto_descueto = parseFloat($scope.datap.mto_ult_venta - desc).toFixed(2);
                    }
                });
            }

            $scope.getMontoDescuento2 = function (event) {
                console.log(event);
                if (event.keyCode == 13) {
                 var desc = ($scope.datap.pr_descuento * $scope.datap.mto_ult_venta) / 100;
                 $scope.datap.mto_descueto = parseFloat($scope.datap.mto_ult_venta - desc).toFixed(2);
                }    
                
            }


            $scope.consultar = function () {
                if ($stateParams.idcotizacion != '') {
                    serviceAPI.consultaCotizacion({ id: $stateParams.idcotizacion }).success(function (r) {
                        var typeNotification = (!r.success) ? 'error' : 'warning';
                        if (r.success && r.num_rows == 1) {
                            console.log(r);
                            typeNotification = 'success';
                            angular.extend($scope.data, r.rows);
                            $scope.jComprobante.map(function (b) {
                                console.log(b.id);
                                console.log(r.rows.id_tipo_comprobante);
                                if (b.id == r.rows.id_tipo_comprobante) {
                                    $scope.data.id_tipo_comprobante = b;
                                }
                            });

                            $scope.jtipopago.map(function (c) {
                                console.log(c.id);
                                console.log(r.rows.id_tipo_pago);
                                if (c.id == r.rows.id_tipo_pago) {
                                    $scope.data.id_tipo_pago = c;
                                }
                            });
                            serviceAPI.getCotizacionId($scope.data.id_cotizacion).success(function (rs) {
                                var lstDetalle = [];
                                if (rs.success && rs.totalItemCount > 0) {
                                    angular.extend(lstDetalle, rs.rows);
                                    for (var i = 0; i < lstDetalle.length; i++) {
                                        var value = lstDetalle[i];
                                        console.log(value);
                                        $scope.rowCollection.push(_.extend({
                                            id: ++item,
                                            id_producto: value.id_producto,
                                            no_producto: value.no_producto,
                                            nu_cantidad_p: value.nu_cantidad,
                                            nu_precio_unitario: value.nu_precio_unitario,
                                            pr_descuento: value.pr_descuento,
                                            nu_precio_descuento: value.nu_precio_descuento,
                                            nu_total: (parseFloat(value.nu_cantidad) * parseFloat(value.nu_precio_descuento)).toFixed(2)
                                        },
                                            value)
                                        );
                                    }
                                    $scope.data.nu_total = $filter('Total')($scope.rowCollection, 'nu_cantidad_p', 'nu_precio_descuento', 2);
                                    $scope.data.nu_sub_total = parseFloat($scope.data.nu_total / 1.18).toFixed(2);
                                    $scope.data.nu_igv = parseFloat($scope.data.nu_total - $scope.data.nu_sub_total).toFixed(2);
                                }
                            });
                            toastr[typeNotification](r.messages, 'Información de Compra');
                        }
                    });
                };
            }


            }]);
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.venta.gastos', [])
        .controller('gastoslistCtrl', ['$scope', 'serviceAPI', 'toastr', '$uibModal', '$state', function ($scope, serviceAPI, toastr, $uibModal, $state) {
            $scope.data = { id_local: 0, no_local: '', va_caja: 0, fe_date: '', no_hora: '' };
            $scope.default = { id_local: 0, no_local: '', va_caja: 0, fe_date: '', no_hora: '' };

            $scope.displayed = [];
            $scope.callServer = function (tableState) {
                var params = angular.extend({}, tableState.pagination, tableState.search);
                $scope.displayed = [];
                serviceAPI.getGastos(params).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        $scope.displayed = r.rows;
                        tableState.pagination.numberOfPages = r.numberOfPages;
                    }
                });
            };

            $scope.agregar = function () {
                $state.go('dashboard.venta.gastos-details');
            };
            $scope.editar = function (id) {
                $state.go('dashboard.venta.gastos-details', { idgastos: id });
            };

        }])
        .controller('gastosCtrl', ['$scope', '$uibModal', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', '$filter', function ($scope, $uibModal, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log, $filter) {
            $scope.default = { id_gasto: 0, id_empresa: 0,id_local: 0, id_tipo_gasto: 0, id_tipo_comprobante:0, id_usuario:0, no_gasto: '', va_subtotal: 0, va_igv: 0, va_total: 0, fe_emision: ''};
            $scope.data = { id_gasto: 0, id_empresa: 0,id_local: 0, id_tipo_gasto: 0, id_tipo_comprobante:0, id_usuario:0, no_gasto: '', va_subtotal: 0, va_igv: 0, va_total: 0, fe_emision: ''};

            $scope.jSucursal = [];
            $scope.jEmpresa = [];            
            $scope.jTipoComprobante = [];
            $scope.jTipoGasto = [];

            serviceAPI.getEmpresas().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jEmpresa, r.rows);
                }
            });

            $scope.getSucursal = function (value) {
                $scope.jSucursal= [];
                serviceAPI.getSucursalId(value).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        angular.extend($scope.jSucursal, r.rows);
                    }
                });
            }

            serviceAPI.getTipoComprobante().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jTipoComprobante, r.rows);
                }
            });

            serviceAPI.getTipoGasto().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jTipoGasto, r.rows);
                }
            });

            

            $scope.calcular = function(value){
                if($scope.data.id_tipo_comprobante.id == 1){
                    $scope.data.va_subtotal = parseFloat(parseFloat(value) / 1.18).toFixed(4);
                    $scope.data.va_igv = parseFloat(parseFloat(value)-parseFloat($scope.data.va_subtotal)).toFixed(4);
                }else{
                    $scope.data.va_subtotal = parseFloat(value).toFixed(4);
                    $scope.data.va_igv = 0;
                }
            }

            $scope.guardar = function (eForm) {
                serviceAPI.guardarGasto($scope.data).success(function (r) {
                    var typeNotification = 'error';
                    if (r.success) {
                        typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                    }
                    toastr[typeNotification](r.messages, 'Registro de Gastos');

                });
            };

            $scope.consultar = function () {
                var _this = this;
                if ($stateParams.idgastos != '') {
                    serviceAPI.consultarGasto({ idgastos: $stateParams.idgastos }).success(function (r) {
                        console.log(r);
                        var typeNotification = (!r.success) ? 'error' : 'warning';
                        if (r.success && r.num_rows == 1) {
                            typeNotification = 'success';
                            angular.extend($scope.data, r.rows);
                            $scope.jEmpresa.map(function (a) {
                                if (a.id_empresa == r.rows.id_empresa) { $scope.data.id_empresa = a; }
                            });
                            serviceAPI.getSucursalId($scope.data.id_empresa).success(function (k) {
                                if (k.success && k.totalItemCount > 0) {
                                    angular.extend($scope.jSucursal, k.rows);
                                    $scope.jSucursal.map(function (z) {
                                        if (z.id_tipo_comprobante == r.rows.id) { $scope.data.id_local = z; }
                                    }); 
                                }
                            });
                            $scope.jTipoComprobante.map(function (b) {
                                if (b.id == r.rows.id_tipo_comprobante) { $scope.data.id_tipo_comprobante = b; }
                            });  
                            $scope.jTipoGasto.map(function (c) {
                                if (c.id_tipo_gasto == r.rows.id_tipo_gasto) { $scope.data.id_tipo_gasto = c; }
                            });                              
                        }
                        toastr[typeNotification](r.messages, 'Información del Gasto');
                    });
                }
            };


        }]);
})();
(function () {
    'use strict';
    angular.module('BlurAdmin.pages.venta.pos', [])
        .controller('poslistCtrl', ['$scope', 'serviceAPI', '$state', '$uibModal', 'toastr', function ($scope, serviceAPI, $state ,$uibModal, toastr) {
            $scope.data = { nu_ventas: 0, nu_total: 0 };
            $scope.displayed = [];
            $scope.callServer = function (tableState) {
                var params = angular.extend({}, tableState.pagination, tableState.search);
                serviceAPI.getVentas(params).success(function (r) {
                    if (r.success && r.totalItemCount > 0) {
                        $scope.displayed = r.rows;
                        tableState.pagination.numberOfPages = r.numberOfPages;
                    }
                });
            };

            $scope.consultar = function () {
                serviceAPI.getTotalesVentas().success(function (r) {
                    var typeNotification = (!r.success) ? 'error' : 'warning';
                    console.log(r);
                    if (r.success && r.num_rows == 1) {
                        typeNotification = 'success';
                        angular.extend($scope.data, r.rows);
                        console.log($scope.data);
                    }
                    toastr[typeNotification](r.messages, 'Información Total');
                });
            };

            $scope.agregar = function () {
                $state.go('dashboard.venta.pos-details');
            };
            $scope.editar = function (id) {
                $state.go('dashboard.venta.pos-details', { idpos: id });
            };
            $scope.changeStatus = function (id) {

            };

            $scope.openBaja= function (size, item, index) {
                $scope.item=item;
                $uibModal.open({
                    animation: true,
                    templateUrl: "app/pages/comprobantes/boleta/modal/modalbajas.html",
                    size: size,
                    controller: 'modalComprobanteCtrl',
                    scope: $scope,
                    resolve: {
                        item: function () {}
                    }
                }).result.then(function (item) {
                    angular.extend($scope.data, item);
                    if (item.success==true) {
                        $scope.rowCollection[index].no_estado=item.no_estado;
                        $scope.rowCollection[index].no_sunat=item.no_sunat;
                       $scope.rowCollection[index].id_respuesta=item.id_respuesta;
                    }
                   else{
                    $scope.rowCollection[index].no_estado=$scope.data.no_estado;
                    $scope.rowCollection[index].no_sunat=$scope.data.no_sunat;
                   $scope.rowCollection[index].id_respuesta=$scope.data.id_respuesta;
                   }
                    
                }, function(){
                    console.log('Modal dismissed at: ' + new Date());
                });
            };

            $scope.openCorreo= function (size, item) {
                $scope.item=item;
                $uibModal.open({
                    animation: true,
                    size: size,
                    controller: 'modalComprobanteCtrl',
                    scope: $scope,
                    templateUrl: "app/pages/comprobantes/boleta/modal/modalEmail.html",
                    resolve: {
                        item: function () {}
                    }
                })
            };


            $scope.openPdfBoleta = function (size, item) {
                $scope.item = item;
                $uibModal.open({
                    animation: true,
                    templateUrl: "app/pages/comprobantes/boleta/modal/modalPdf.html",
                    size: size,
                    controller: 'modalComprobanteCtrl',
                    scope: $scope,
                    resolve: {
                        item: function () { }
                    }
                }).result.then(function (item) {
                    angular.extend($scope.data, item);
                }, function () {

                });
            };
            $scope.openGenerar = function (size, item, index) {
                $scope.item=item;
                $uibModal.open({
                    animation: true,
                    templateUrl: "app/pages/comprobantes/boleta/modal/generar.html",
                    size: size,
                    controller: 'modalComprobanteCtrl',
                    scope: $scope,
                    resolve: {
                        item: function () {}
                    }
                }).result.then(function (item) {
                    angular.extend($scope.data, item);
                    if (item.success==true) {
                        $scope.displayed[index].no_estado=item.no_estado;
                        $scope.displayed[index].no_sunat=item.no_sunat;
                       $scope.displayed[index].id_respuesta=item.id_respuesta;
                    }
                   else{
                    $scope.displayed[index].no_estado=$scope.data.no_estado;
                    $scope.displayed[index].no_sunat=$scope.data.no_sunat;
                   $scope.displayed[index].id_respuesta=$scope.data.id_respuesta;
                   }
                    
                }, function(){
                    console.log('Modal dismissed at: ' + new Date());
                });
            };

            $scope.openConsulta= function (size, item) {
                $scope.item=item;
                $uibModal.open({
                    animation: true,
                    size: size,
                    controller: 'modalComprobanteCtrl',
                    scope: $scope,
                    templateUrl: "app/pages/comprobantes/boleta/modal/modalConsulta.html",
                    resolve: {
                        item: function () {}
                    }
                })
            };
            $scope.openConsultaTickets= function (size, item) {
                $scope.item=item;
                $uibModal.open({
                    animation: true,
                    size: size,
                    controller: 'modalComprobanteCtrl',
                    scope: $scope,
                    templateUrl: "app/pages/comprobantes/boleta/modal/modalBaja.html",
                    resolve: {
                        item: function () {}
                    }
                })
            };

        }])
       
        .controller('posCtrl', ['$scope', '$uibModal', 'serviceAPI', 'toastr', '$stateParams', 'baSidebarService', '$timeout', '$log', '$filter', function ($scope, $uibModal, serviceAPI, toastr, $stateParams, baSidebarService, $timeout, $log, $filter) {
            var vm = this;
            $scope.default = {
                id_venta_cabecera: 0, id_tipo_pago: 0, id_cliente: 0, id_tipo_comprobante: 0, id_usuario: 0, id_estado_sunat: 0, nu_serie: '', nu_correlativo: '', nu_sub_total: 0, nu_igv: 0, nu_total: 0, fe_emision: '', id_estado: 0, id_local: 0, no_cliente: '', nu_documento: '',
                nu_efectivo: 0, nu_izipay: 0, nu_efectivo2: 0, nu_izipay2: 0, nu_trasnferencia: 0, nu_credito: 0, no_descuento: 0 , nu_rappi : 0 , id_cupon:0, no_resp_cupon:'', co_cupon:'', va_descuento:0, id_cupon_descuento:0
            };
            $scope.data = {
                id_venta_cabecera: 0, id_tipo_pago: 0, id_cliente: 0, id_tipo_comprobante: 0, id_usuario: 0, id_estado_sunat: 0, nu_serie: '', nu_correlativo: '', nu_sub_total: 0, nu_igv: 0, nu_total: 0, fe_emision: '', id_estado: 0, id_local: 0, no_cliente: '', nu_documento: '',
                nu_efectivo: 0, nu_izipay: 0, nu_efectivo2: 0, nu_izipay2: 0, nu_trasnferencia: 0, nu_credito: 0, no_descuento: 0 , nu_rappi : 0 , id_cupon:0, no_resp_cupon:'', co_cupon:'', va_descuento:0, id_cupon_descuento:0
            };
            $scope.datap = { id_producto: 0,co_producto:'',co_barra:'', mto_ult_venta: 0, no_producto: '', no_categoria: '', no_marca: '', nu_cantidad: 0, nu_cantidad_p: 0 };
            $scope.defaultp = { id_producto: 0,co_producto:'',co_barra:'', mto_ult_venta: 0, no_producto: '', no_categoria: '', no_marca: '', nu_cantidad: 0, nu_cantidad_p: 0 };

            $scope.jComprobante = [];
            $scope.jtipopago = [];
            $scope.update=0;

            serviceAPI.getTipoPago().success(function (r) {
                if (r.num_rows > 0 && r.success) {
                    angular.extend($scope.jtipopago, r.rows);
                }
            });

            serviceAPI.getComprobante().success(function (r) {
                if (r.success && r.totalItemCount > 0) {
                    angular.extend($scope.jComprobante, r.rows);
                }
            });
            $scope.getCorrelativo = function (value) {
                serviceAPI.consultarCorrelativo(value).then(function (r) {
                    if (r.data.success && r.data.num_rows == 1) {
                        console.log(r);
                        $scope.data.nu_serie = r.data.rows.nu_serie;
                        $scope.data.nu_correlativo = $scope.zfill(r.data.rows.nu_correlativo,8);
                    }
                });
            }
            $scope.zfill = function (number, width){
                var numberOutput = Math.abs(number); /* Valor absoluto del número */
                var length = number.toString().length; /* Largo del número */ 
                var zero = "0"; /* String de cero */  
                
                if (width <= length) {
                    if (number < 0) {
                         return ("-" + numberOutput.toString()); 
                    } else {
                         return numberOutput.toString(); 
                    }
                } else {
                    if (number < 0) {
                        return ("-" + (zero.repeat(width - length)) + numberOutput.toString()); 
                    } else {
                        return ((zero.repeat(width - length)) + numberOutput.toString()); 
                    }
                }
            }
            $scope.guardar = function (eForm) {

                angular.forEach($scope.rowCollection ,function(value,key){
                    serviceAPI.eliminarTemporal({ id: value.id }).success(function (r) {
                    });
                });
                
                var params = { orden: $scope.data, detalle: $scope.rowCollection };
                serviceAPI.guardarVenta(params).success(function (r) {
                    var typeNotification = 'error';
                    if (r.success) {
                        typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                        angular.extend($scope.data.id_tipo_comprobante, r.id_tipo_comprobante);
                        var paramss = { orden: $scope.data, correlativo: r.correlativo, idComprobante: r.id_tipo_comprobante };
                        serviceAPI.actualizarPago(paramss).success(function (b) {
                            if (b.success) {
                                typeNotification = (b.affected_rows != 0) ? 'success' : 'warning';
                            }
                            toastr[typeNotification](b.messages, 'Registro Pagado Correctamente');
                        });
                        $scope.data.id_tipo_comprobante = r.id_tipo_comprobante;
                        angular.extend($scope.data.id_tipo_comprobante, r.id_tipo_comprobante);
                    }
                    toastr[typeNotification](r.messages, 'Registro Venta');
                    angular.extend($scope.data, $scope.default);
                    angular.extend($scope.datap, $scope.defaultp);
                    $scope.rowCollection = [];
                    eForm.$setPristine();
                    eForm.$setUntouched();
                });
                
            };

            $scope.consultar = function () {
                if ($stateParams.idsucursales != '') {
                    serviceAPI.consultaSucursal({ id: $stateParams.idsucursales }).success(function (r) {
                        var typeNotification = (!r.success) ? 'error' : 'warning';
                        if (r.success && r.num_rows == 1) {
                            typeNotification = 'success';
                            angular.extend($scope.data, r.rows);
                            $scope.jEmpresa.map(function (b) {
                                if (b.id_empresa == r.rows.id_empresa) { $scope.data.id_empresa = b; }
                            });
                        }
                        toastr[typeNotification](r.messages, 'Información de Usuario');
                    });
                }
            };

            $scope.crearProduct = function (size) {
                $uibModal.open({
                    animation: true,
                    size: size,
                    templateUrl: "app/pages/clientes/cliente/clienteModal.html",
                    controller: 'clienteCtrl',
                    scope: $scope
                }).result.then(function (data) {
                    console.log(data);
                    angular.extend($scope.data, data);
                }, function () {
                    console.log('Modal dismissed at: ' + new Date());
                });
            };

            $scope.modalProducts = function (size) {
                $uibModal.open({
                    animation: true,
                    size: size,
                    templateUrl: "app/pages/clientes/cliente/list/clienteListModal.html",
                    controller: 'clienteModalCtrl',
                    scope: $scope
                }).result.then(function (data) {
                    console.log(data);
                    angular.extend($scope.data, data);
                }, function () {
                    console.log('Modal dismissed at: ' + new Date());
                });
            };

            $scope.modalProducto = function (size) {
                $uibModal.open({
                    animation: true,
                    size: size,
                    templateUrl: "app/pages/inventario/stockProductos/list/listProductosModalPos.html",
                    controller: 'stockProductosModalCtrl',
                    scope: $scope
                }).result.then(function (data) {
                    angular.extend($scope.datap, data);
                }, function () {
                    console.log('Modal dismissed at: ' + new Date());
                });
            };

            $scope.buscarCodigoBarras = function () {
                serviceAPI.buscarProductoxCodigoVenta($scope.datap).success(function (r) {
                    console.log(r);
                    if (r.success && r.num_rows == 1) {
                        angular.extend($scope.datap, r.rows);
                    }
                });
            }

            $scope.modalCupon = function (size) {
                $uibModal.open({
                    animation: true,
                    size: size,
                    templateUrl: "app/pages/catalogo/cuponera/modal/listCuponModal.html",
                    controller: 'ModalCuponCtrl',
                    scope: $scope
                }).result.then(function (data) {
                    angular.extend($scope.data, data);
                    console.log(data);
                    $scope.descontar(data);
                }, function () {
                    console.log('Modal dismissed at: ' + new Date());
                });
            };

            
            $scope.descontar = function(value){
                console.log(value.va_descuento);
                var mMonto = ($scope.data.nu_total * value.va_descuento)/100;
                $scope.data.nu_total = $scope.data.nu_total - mMonto;
            }

             $scope.limpiar = function () {
                angular.extend($scope.datap, $scope.defaultp);
            }


            $scope.rowCollection = [];
            var item = 0;
            var item2 = 0;
            $scope.addItem = function () {
                var itemActual;
                if ($scope.datap.nu_cantidad_p != 0) {
                    console.log($scope.datap.nu_cantidad_p);
                    console.log($scope.datap.nu_cantidad);
                    if (parseInt($scope.datap.nu_cantidad_p) > parseInt($scope.datap.nu_cantidad)) {
                        var typeNotification = 'error';
                        toastr[typeNotification]('La Cantidad Ingresada Supera El Stock', 'Información del Sistema');
                    } else {

                        for (var i = 0; i < $scope.rowCollection.length; i++) {
                            if ($scope.rowCollection[i].id_producto == $scope.datap.id_producto) {
                                itemActual = $scope.rowCollection[i];
                            }
                        }
                        if (!itemActual) {
                            $scope.rowCollection.push(_.extend({
                                id: ++item,
                                id_producto: $scope.datap.id_producto,
                                co_producto: $scope.datap.co_producto,
                                no_producto: $scope.datap.no_producto,
                                no_categoria: $scope.datap.no_categoria,
                                nu_cantidad_p: $scope.datap.nu_cantidad_p,
                                nu_precio_descuento: $scope.datap.mto_ult_venta,
                                nu_total: (parseFloat($scope.datap.nu_cantidad_p) * parseFloat($scope.datap.mto_ult_venta)).toFixed(2)
                            },
                                $scope.datap)
                            );
                            $scope.rowCollection2 = [];
                            $scope.rowCollection2.push(_.extend({
                                id: ++item2,
                                id_producto: $scope.datap.id_producto,
                                co_producto: $scope.datap.co_producto,
                                no_producto: $scope.datap.no_producto,
                                no_categoria: $scope.datap.no_categoria,
                                nu_cantidad_p: $scope.datap.nu_cantidad_p,
                                nu_precio_descuento: $scope.datap.mto_ult_venta,
                                nu_total: (parseFloat($scope.datap.nu_cantidad_p) * parseFloat($scope.datap.mto_ult_venta)).toFixed(2)
                            },
                                $scope.datap)
                            );
                            var params = { detalle: $scope.rowCollection2 };
                            serviceAPI.guardarTemporal(params).success(function (r) {
                                var typeNotification = 'error';
                                if (r.success) {
                                    typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                                }
                                toastr[typeNotification](r.messages, 'Registro Detalle');
                            });
                        } else {
                            itemActual.nu_cantidad_p = parseInt(itemActual.nu_cantidad_p) + parseInt($scope.datap.nu_cantidad_p);
                            itemActual.nu_total = itemActual.nu_cantidad_p * itemActual.nu_precio_descuento;
                            serviceAPI.actualizarTemporal(itemActual).success(function (r) {
                                var typeNotification = 'error';
                                if (r.success) {
                                    typeNotification = (r.affected_rows != 0) ? 'success' : 'warning';
                                }
                                toastr[typeNotification](r.messages, 'Actualizar Detalle');
                            });

                        }
                        $scope.data.nu_total = $filter('Total')($scope.rowCollection, 'nu_cantidad_p', 'nu_precio_descuento', 2);
                        $scope.data.nu_sub_total = parseFloat($scope.data.nu_total / 1.18).toFixed(2);
                        $scope.data.nu_igv = parseFloat($scope.data.nu_total - $scope.data.nu_sub_total).toFixed(2);
                        angular.extend($scope.datap, $scope.defaultp);
                    }
                } else {
                    var typeNotification = 'error';
                    toastr[typeNotification]('Ingrese Cantidad', 'Información del Sistema');
                }

            };

            $scope.quitar_producto = function (id) {
                serviceAPI.eliminarTemporal({ id: id }).success(function (r) {
                    var typenotify = (r.success) ? 'warning' : 'error';
                    if (r.affected_rows == 1) {
                        typenotify = 'success';
                    }
                    toastr[typenotify](r.messages, 'Registro Eliminado')
                });

                $scope.rowCollection = $scope.rowCollection.filter(function (item) {
                    return item.id != id;
                });
                $scope.data.nu_total = $filter('Total')($scope.rowCollection, 'nu_cantidad_p', 'nu_precio_descuento', 2);
                $scope.data.nu_sub_total = parseFloat($scope.data.nu_total / 1.18).toFixed(2);
                $scope.data.nu_igv = parseFloat($scope.data.nu_total - $scope.data.nu_sub_total).toFixed(2);



            };
            var nu_total = 0;

            $scope.getDescuento = function (event) {
                console.log(event);
                if (event.keyCode == 13) {
                    console.log($scope.data.no_descuento);
                    console.log($scope.data.nu_total);
                    if (parseFloat($scope.data.no_descuento) > parseFloat($scope.data.nu_total)) {
                        var typeNotification = 'error';
                        toastr[typeNotification]('Descueto ingresado supera el total de la venta', 'Información del Sistema');
                        $scope.data.no_descuento = 0
                    } else {
                        $scope.data.nu_total = $filter('Total')($scope.rowCollection, 'nu_cantidad_p', 'nu_precio_descuento', 2) - $scope.data.no_descuento;
                    }
                }
            }

            $scope.getCalcular = function (event) {
                if (event.keyCode == 13) {
                    if ($scope.data.nu_efectivo2 > $scope.data.nu_total) {
                        var typeNotification = 'error';
                        toastr[typeNotification]('Monto ingresado supera el total de la venta', 'Información del Sistema');
                        $scope.data.nu_efectivo2 = 0;
                        $scope.data.nu_izipay2 = 0;
                    } else {
                        $scope.data.nu_izipay2 = $scope.data.nu_total - $scope.data.nu_efectivo2;
                    }
                }
            }

            $scope.getMonto = function (value) {
                console.log(value.id);
                if (value.id == 1) {
                    console.log('entro 1');
                    $scope.data.nu_efectivo = $scope.data.nu_total;
                    $scope.data.nu_efectivo2 = 0;
                    $scope.data.nu_izipay = 0;
                    $scope.data.nu_izipay2 = 0;
                    $scope.data.nu_credito = 0;
                    $scope.data.nu_trasnferencia = 0;
                    $scope.data.nu_rappi = 0;
                } else if (value.id == 2) {
                    console.log('entro 2');
                    $scope.data.nu_efectivo = 0;
                    $scope.data.nu_efectivo2 = 0;
                    $scope.data.nu_izipay = $scope.data.nu_total;
                    $scope.data.nu_izipay2 = 0;
                    $scope.data.nu_credito = 0;
                    $scope.data.nu_trasnferencia = 0;
                    $scope.data.nu_rappi = 0;
                } else if (value.id == 4) {
                    console.log('entro 4');
                    $scope.data.nu_efectivo = 0;
                    $scope.data.nu_efectivo2 = 0;
                    $scope.data.nu_izipay = 0;
                    $scope.data.nu_izipay2 = 0;
                    $scope.data.nu_credito = 0;
                    $scope.data.nu_trasnferencia = $scope.data.nu_total;
                    $scope.data.nu_rappi = 0;
                } else if (value.id == 5) {
                    console.log('entro 5');
                    $scope.data.nu_efectivo = 0;
                    $scope.data.nu_efectivo2 = 0;
                    $scope.data.nu_izipay = 0;
                    $scope.data.nu_izipay2 = 0;
                    $scope.data.nu_credito = $scope.data.nu_total;
                    $scope.data.nu_trasnferencia = 0;
                    $scope.data.nu_rappi = 0;
                }  else if (value.id == 6) {
                    console.log('entro 6');
                    $scope.data.nu_efectivo = 0;
                    $scope.data.nu_efectivo2 = 0;
                    $scope.data.nu_izipay = 0;
                    $scope.data.nu_izipay2 = 0;
                    $scope.data.nu_credito = 0;
                    $scope.data.nu_trasnferencia = 0;
                    $scope.data.nu_rappi = $scope.data.nu_total;
                }else {
                    console.log('entro ninguno');
                }


            }



        }]);
})();
/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Includes basic panel layout inside of current element.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanel', baPanel);

  /** @ngInject */
  function baPanel(baPanel, baConfig) {
    return angular.extend({}, baPanel, {
      template: function(el, attrs) {
        var res = '<div  class="panel ' + (baConfig.theme.blur ? 'panel-blur' : '') + ' full-invisible ' + (attrs.baPanelClass || '');
        res += '" zoom-in ' + (baConfig.theme.blur ? 'ba-panel-blur' : '') + '>';
        res += baPanel.template(el, attrs);
        res += '</div>';
        return res;
      }
    });
  }
})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .factory('baPanel', baPanel);

  /** @ngInject */
  function baPanel() {

    /** Base baPanel directive */
    return {
      restrict: 'A',
      transclude: true,
      template: function(elem, attrs) {
        var res = '<div class="panel-body" ng-transclude></div>';
        if (attrs.baPanelTitle) {
          var titleTpl = '<div class="panel-heading clearfix"><h3 class="panel-title">' + attrs.baPanelTitle + '</h3></div>';
          res = titleTpl + res; // title should be before
        }

        return res;
      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .directive('baPanelBlur', baPanelBlur);

  /** @ngInject */
  function baPanelBlur(baPanelBlurHelper, $window, $rootScope) {
    var bodyBgSize;

    baPanelBlurHelper.bodyBgLoad().then(function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    $window.addEventListener('resize', function() {
      bodyBgSize = baPanelBlurHelper.getBodyBgImageSizes();
    });

    return {
      restrict: 'A',
      link: function($scope, elem) {
        if(!$rootScope.$isMobile) {
          baPanelBlurHelper.bodyBgLoad().then(function () {
            setTimeout(recalculatePanelStyle);
          });
          $window.addEventListener('resize', recalculatePanelStyle);

          $scope.$on('$destroy', function () {
            $window.removeEventListener('resize', recalculatePanelStyle);
          });
        }

        function recalculatePanelStyle() {
          if (!bodyBgSize) {
            return;
          }
          elem.css({
            backgroundSize: Math.round(bodyBgSize.width) + 'px ' + Math.round(bodyBgSize.height) + 'px',
            backgroundPosition: Math.floor(bodyBgSize.positionX) + 'px ' + Math.floor(bodyBgSize.positionY) + 'px'
          });
        }

      }
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 15.01.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .service('baPanelBlurHelper', baPanelBlurHelper);

  /** @ngInject */
  function baPanelBlurHelper($q) {
    var res = $q.defer();
    var computedStyle = getComputedStyle(document.body, ':before');
    var image = new Image();
    image.src = computedStyle.backgroundImage.replace(/url\((['"])?(.*?)\1\)/gi, '$2');
    image.onerror = function() {
      res.reject();
    };
    image.onload = function() {
      res.resolve();
    };

    this.bodyBgLoad = function() {
      return res.promise;
    };

    this.getBodyBgImageSizes = function() {
      var elemW = document.documentElement.clientWidth;
      var elemH = document.documentElement.clientHeight;
      if(elemW <= 640) return;
      var imgRatio = (image.height / image.width);       // original img ratio
      var containerRatio = (elemH / elemW);     // container ratio

      var finalHeight, finalWidth;
      if (containerRatio > imgRatio) {
        finalHeight = elemH;
        finalWidth = (elemH / imgRatio);
      } else {
        finalWidth = elemW;
        finalHeight = (elemW * imgRatio);
      }
      return { width: finalWidth, height: finalHeight, positionX: (elemW - finalWidth)/2, positionY: (elemH - finalHeight)/2};
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 23.12.2015
 */
(function () {
  'use strict';

  /**
   * Represents current element as panel, adding all necessary classes.
   */
  angular.module('BlurAdmin.theme')
      .directive('baPanelSelf', baPanelSelf);

  /** @ngInject */
  function baPanelSelf(baPanel) {
    return angular.extend({}, baPanel, {
      link: function(scope, el, attrs) {
        el.addClass('panel panel-white');
        if (attrs.baPanelClass) {
          el.addClass(attrs.baPanelClass);
        }
      }
    });
  }

})();

(function() {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .controller('BaSidebarCtrl', BaSidebarCtrl);

    /** @ngInject */
    function BaSidebarCtrl($scope, baSidebarService, AuthenticationService) {

        var removeIntern = [{
            name: "addtasks"
        }, {
            name: "register"
        }, {
            name: "internstasks"
        }, {
            name: "viewuser"
        }];

        var removeAdmins = [{
            name : "viewtasks"

        }];

        $scope.menuItems = baSidebarService.getMenuItems();
        $scope.defaultSidebarState = $scope.menuItems[0].stateRef;
        var admin = AuthenticationService.isAdmin();

        if (!admin){
          _.each(removeIntern, function(item) {
              $scope.menuItems = _.without($scope.menuItems, _.findWhere($scope.menuItems, item));
          });
        }
        else {
          _.each(removeAdmins, function(item) {
              $scope.menuItems = _.without($scope.menuItems, _.findWhere($scope.menuItems, item));
          });

        }

        $scope.hoverItem = function($event) {
            $scope.showHoverElem = true;
            $scope.hoverElemHeight = $event.currentTarget.clientHeight;
            var menuTopValue = 66;
            $scope.hoverElemTop = $event.currentTarget.getBoundingClientRect().top - menuTopValue;
        };

        $scope.$on('$stateChangeSuccess', function() {
            if (baSidebarService.canSidebarBeHidden()) {
                baSidebarService.setMenuCollapsed(true);
            }
        });
    }
})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebar', baSidebar);

  /** @ngInject */
  function baSidebar($timeout, baSidebarService, baUtil, layoutSizes) {
    var jqWindow = $(window);
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/baSidebar/ba-sidebar.html',
      controller: 'BaSidebarCtrl',
      link: function(scope, el) {

        scope.menuHeight = el[0].childNodes[0].clientHeight - 84;
        jqWindow.on('click', _onWindowClick);
        jqWindow.on('resize', _onWindowResize);

        scope.$on('$destroy', function() {
          jqWindow.off('click', _onWindowClick);
          jqWindow.off('resize', _onWindowResize);
        });

        function _onWindowClick($evt) {
          if (!baUtil.isDescendant(el[0], $evt.target) &&
              !$evt.originalEvent.$sidebarEventProcessed &&
              !baSidebarService.isMenuCollapsed() &&
              baSidebarService.canSidebarBeHidden()) {
            $evt.originalEvent.$sidebarEventProcessed = true;
            $timeout(function () {
              baSidebarService.setMenuCollapsed(true);
            }, 10);
          }
        }

        // watch window resize to change menu collapsed state if needed
        function _onWindowResize() {
          var newMenuCollapsed = baSidebarService.shouldMenuBeCollapsed();
          var newMenuHeight = _calculateMenuHeight();
          if (newMenuCollapsed != baSidebarService.isMenuCollapsed() || scope.menuHeight != newMenuHeight) {
            scope.$apply(function () {
              scope.menuHeight = newMenuHeight;
              baSidebarService.setMenuCollapsed(newMenuCollapsed)
            });
          }
        }

        function _calculateMenuHeight() {
          return el[0].childNodes[0].clientHeight - 84;
        }
      }
    };
  }

})();
(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .provider('baSidebarService', baSidebarServiceProvider);

  /** @ngInject */
  function baSidebarServiceProvider() {
    var staticMenuItems = [];

    this.addStaticItem = function() {
      staticMenuItems.push.apply(staticMenuItems, arguments);
    };

    /** @ngInject */
    this.$get = function($state, layoutSizes) {
      return new _factory();

      function _factory() {
        var isMenuCollapsed = shouldMenuBeCollapsed();

        this.getMenuItems = function() {
          var states = defineMenuItemStates();
          var menuItems = states.filter(function(item) {
            return item.level == 0;
          });
          menuItems.forEach(function(item) {
            var children = states.filter(function(child) {
              return child.level == 1 && child.name.indexOf(item.name) === 0;
            });
            item.subMenu = children.length ? children : null;
          });

          return menuItems.concat(staticMenuItems);
        };

        this.shouldMenuBeCollapsed = shouldMenuBeCollapsed;
        this.canSidebarBeHidden = canSidebarBeHidden;

        this.setMenuCollapsed = function(isCollapsed) {
          isMenuCollapsed = isCollapsed;
        };

        this.isMenuCollapsed = function() {
          return isMenuCollapsed;
        };

        this.toggleMenuCollapsed = function() {
          isMenuCollapsed = !isMenuCollapsed;
        };

        this.getAllStateRefsRecursive = function(item) {
          var result = [];
          _iterateSubItems(item);
          return result;

          function _iterateSubItems(currentItem) {
            currentItem.subMenu && currentItem.subMenu.forEach(function(subItem) {
              subItem.stateRef && result.push(subItem.stateRef);
              _iterateSubItems(subItem);
            });
          }
        };

        function defineMenuItemStates() {
          return $state.get()
              .filter(function(s) {
                return s.sidebarMeta;
              })
              .map(function(s) {
                var meta = s.sidebarMeta;
                return {
                  name: s.name.substr(10),
                  title: s.title,
                  level: (s.name.match(/\./g) || []).length -1,
                  order: meta.order,
                  icon: meta.icon,
                  stateRef: s.name,
                };
              })
              .sort(function(a, b) {
                return (a.level - b.level) * 100 + a.order - b.order;
              });
        }

        function shouldMenuBeCollapsed() {
          return window.innerWidth <= layoutSizes.resWidthCollapseSidebar;
        }

        function canSidebarBeHidden() {
          return window.innerWidth <= layoutSizes.resWidthHideSidebar;
        }
      }

    };

  }
})();

/**
 * @author v.lugovsky
 * created on 03.05.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('baSidebarToggleMenu', baSidebarToggleMenu)
      .directive('baSidebarCollapseMenu', baSidebarCollapseMenu)
      .directive('baSidebarTogglingItem', baSidebarTogglingItem)
      .controller('BaSidebarTogglingItemCtrl', BaSidebarTogglingItemCtrl)
      .directive('baUiSrefTogglingSubmenu', baUiSrefTogglingSubmenu)
      .directive('baUiSrefToggler', baUiSrefToggler);

  /** @ngInject */
  function baSidebarToggleMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          scope.$apply(function() {
            baSidebarService.toggleMenuCollapsed();
          });
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarCollapseMenu(baSidebarService) {
    return {
      restrict: 'A',
      link: function(scope, elem) {
        elem.on('click', function($evt) {
          $evt.originalEvent.$sidebarEventProcessed = true;
          if (!baSidebarService.isMenuCollapsed()) {
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(true);
            });
          }
        });
      }
    };
  }

  /** @ngInject */
  function baSidebarTogglingItem() {
    return {
      restrict: 'A',
      controller: 'BaSidebarTogglingItemCtrl'
    };
  }

  /** @ngInject */
  function BaSidebarTogglingItemCtrl($scope, $element, $attrs, $state, baSidebarService) {
    var vm = this;
    var menuItem = vm.$$menuItem = $scope.$eval($attrs.baSidebarTogglingItem);
    if (menuItem && menuItem.subMenu && menuItem.subMenu.length) {
      vm.$$expandSubmenu = function() { console.warn('$$expandMenu should be overwritten by baUiSrefTogglingSubmenu') };
      vm.$$collapseSubmenu = function() { console.warn('$$collapseSubmenu should be overwritten by baUiSrefTogglingSubmenu') };

      var subItemsStateRefs = baSidebarService.getAllStateRefsRecursive(menuItem);

      vm.$expand = function() {
        vm.$$expandSubmenu();
        $element.addClass('ba-sidebar-item-expanded');
      };

      vm.$collapse = function() {
        vm.$$collapseSubmenu();
        $element.removeClass('ba-sidebar-item-expanded');
      };

      vm.$toggle = function() {
        $element.hasClass('ba-sidebar-item-expanded') ?
            vm.$collapse() :
            vm.$expand();
      };

      if (_isState($state.current)) {
        $element.addClass('ba-sidebar-item-expanded');
      }

      $scope.$on('$stateChangeStart', function (event, toState) {
        if (!_isState(toState) && $element.hasClass('ba-sidebar-item-expanded')) {
          vm.$collapse();
          $element.removeClass('ba-sidebar-item-expanded');
        }
      });

      $scope.$on('$stateChangeSuccess', function (event, toState) {
        if (_isState(toState) && !$element.hasClass('ba-sidebar-item-expanded')) {
          vm.$expand();
          $element.addClass('ba-sidebar-item-expanded');
        }
      });
    }

    function _isState(state) {
      return state && subItemsStateRefs.some(function(subItemState) {
            return state.name.indexOf(subItemState) == 0;
          });
    }
  }

  /** @ngInject */
  function baUiSrefTogglingSubmenu($state) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        baSidebarTogglingItem.$$expandSubmenu = function() { el.slideDown(); };
        baSidebarTogglingItem.$$collapseSubmenu = function() { el.slideUp(); };
      }
    };
  }

  /** @ngInject */
  function baUiSrefToggler(baSidebarService) {
    return {
      restrict: 'A',
      require: '^baSidebarTogglingItem',
      link: function(scope, el, attrs, baSidebarTogglingItem) {
        el.on('click', function() {
          if (baSidebarService.isMenuCollapsed()) {
            // If the whole sidebar is collapsed and this item has submenu. We need to open sidebar.
            // This should not affect mobiles, because on mobiles sidebar should be hidden at all
            scope.$apply(function() {
              baSidebarService.setMenuCollapsed(false);
            });
            baSidebarTogglingItem.$expand();
          } else {
            baSidebarTogglingItem.$toggle();
          }
        });
      }
    };
  }

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizard', baWizard);

  /** @ngInject */
  function baWizard() {
    return {
      restrict: 'E',
      transclude: true,
      templateUrl: 'app/theme/components/baWizard/baWizard.html',
      controllerAs: '$baWizardController',
      controller: 'baWizardCtrl'
    }
  }
})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .controller('baWizardCtrl', [ '$scope', '$rootScope', '$state',  '$window', '$timeout', 'AuthenticationService', 'toastr', 'printService', '$http', '$httpParamSerializerJQLike', '$q', function($scope,$rootScope,$state,  $window, $timeout, AuthenticationService, toastr, printService, $http, $httpParamSerializerJQLike, $q){
      var vm = this;
      vm.tabs = [];
  
      vm.tabNum = 0;
      vm.progress = 0;
  
      // $rootScope.progress = 0;
  
      vm.addTab = function(tab) {
        tab.setPrev(vm.tabs[vm.tabs.length - 1]);
        vm.tabs.push(tab);
        vm.selectTab(0);
      };
  
      $scope.$watch(angular.bind(vm, function () {return vm.tabNum;}), calcProgress);
  
      vm.selectTab = function (tabNum) {
        vm.tabs[vm.tabNum].submit();
        if (vm.tabs[tabNum].isAvailiable()) {
          vm.tabNum = tabNum;
          vm.tabs.forEach(function (t, tIndex) {
            tIndex == vm.tabNum ? t.select(true) : t.select(false);
          });
        }
      };
  
      vm.isFirstTab = function () {
        return vm.tabNum == 0;
      };
  
      vm.isLastTab = function () {
        return vm.tabNum == vm.tabs.length - 1 ;
      };
  
      vm.nextTab = function () {
        vm.selectTab(vm.tabNum + 1)
      };
  
      vm.previousTab = function () {
        vm.selectTab(vm.tabNum - 1)
      };
  
      function calcProgress() {
  
        // if (((vm.tabNum + 1) / vm.tabs.length) * 100 == 100){
        //   vm.tabNum = 100;
        // }
        // else {
        //   vm.progress = ((vm.tabNum) / vm.tabs.length) * 100;
        // }
        vm.progress = ((vm.tabNum + 1) / vm.tabs.length) * 100;
  
      }  
    }]);

})();

(function() {
  'use strict';

  angular.module('BlurAdmin.theme.components')
    .directive('baWizardStep', baWizardStep);

  /** @ngInject */
  function baWizardStep() {
    return {
      restrict: 'E',
      transclude: true,
      require: '^baWizard',
      scope: {
        form: '='
      },
      templateUrl:  'app/theme/components/baWizard/baWizardStep.html',
      link: function($scope, $element, $attrs, wizard) {
        $scope.selected = true;

        var tab = {
          title: $attrs.title,
          select: select,
          submit: submit,
          isComplete: isComplete,
          isAvailiable: isAvailiable,
          prevTab: undefined,
          setPrev: setPrev
        };

        wizard.addTab(tab);

        function select(isSelected) {
          if (isSelected) {
            $scope.selected = true;
          } else {
            $scope.selected = false;
          }
        }

        function submit() {
          $scope.form && $scope.form.$setSubmitted(true);
        }

        function isComplete() {
          return $scope.form ? $scope.form.$valid : true;
        }

        function isAvailiable() {
          return tab.prevTab ? tab.prevTab.isComplete() : true;
        }

        function setPrev(pTab) {
          tab.prevTab = pTab;
        }
      }
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('backTop', backTop);

  /** @ngInject */
  function backTop() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/backTop/backTop.html',
      controller: function () {
        $('#backTop').backTop({
          'position': 200,
          'speed': 100
        });
      }
    };
  }

})();
(function () {
    'use strict';
  
    angular.module('BlurAdmin.theme.components')
        .directive('canvasLogin', canvasLogin);
  
    /** @ngInject */
    function canvasLogin($location, $state) {
      return {
        restrict: 'E',
        templateUrl: 'app/theme/components/canvas/canvas.html',
        controller:'canvasCtrl',
        link: function($scope) {

            addEventListener("load", function () {
                setTimeout(hideURLbar, 0);
            }, false);
    
            function hideURLbar() {
                window.scrollTo(0, 1);
            }
            var canvas = $('#bg').children('canvas'),
            background = canvas[0],
            foreground1 = canvas[1],
            foreground2 = canvas[2],
            config = {
                circle: {
                    amount: 18,
                    layer: 3,
                    color: [157, 97, 207],
                    alpha: 0.3
                },
                line: {
                    amount: 12,
                    layer: 3,
                    color: [255, 255, 255],
                    alpha: 0.3
                },
                speed: 0.5,
                angle: 20
            };
        if (background.getContext){
            var bctx = background.getContext('2d'),
                fctx1 = foreground1.getContext('2d'),
                fctx2 = foreground2.getContext('2d'),
                M = window.Math, // Cached Math
                degree = config.angle/360*M.PI*2,
                circles = [],
                lines = [],
                wWidth, wHeight, timer;
            
            requestAnimationFrame = window.requestAnimationFrame || 
                window.mozRequestAnimationFrame ||
                window.webkitRequestAnimationFrame ||
                window.msRequestAnimationFrame ||
                window.oRequestAnimationFrame ||
                function(callback, element) { setTimeout(callback, 1000 / 60); };
    
            cancelAnimationFrame = window.cancelAnimationFrame ||
                window.mozCancelAnimationFrame ||
                window.webkitCancelAnimationFrame ||
                window.msCancelAnimationFrame ||
                window.oCancelAnimationFrame ||
                clearTimeout;
    
            var setCanvasHeight = function(){
                wWidth = $(window).width();
                wHeight = $(window).height(),
    
                canvas.each(function(){
                    this.width = wWidth;
                    this.height = wHeight;
                });
            };
    
            var drawCircle = function(x, y, radius, color, alpha){
                var gradient = fctx1.createRadialGradient(x, y, radius, x, y, 0);
                gradient.addColorStop(0, 'rgba('+color[0]+','+color[1]+','+color[2]+','+alpha+')');
                gradient.addColorStop(1, 'rgba('+color[0]+','+color[1]+','+color[2]+','+(alpha-0.1)+')');
    
                fctx1.beginPath();
                fctx1.arc(x, y, radius, 0, M.PI*2, true);
                fctx1.fillStyle = gradient;
                fctx1.fill();
            };
    
            var drawLine = function(x, y, width, color, alpha){
                var endX = x+M.sin(degree)*width,
                    endY = y-M.cos(degree)*width,
                    gradient = fctx2.createLinearGradient(x, y, endX, endY);
                gradient.addColorStop(0, 'rgba('+color[0]+','+color[1]+','+color[2]+','+alpha+')');
                gradient.addColorStop(1, 'rgba('+color[0]+','+color[1]+','+color[2]+','+(alpha-0.1)+')');
    
                fctx2.beginPath();
                fctx2.moveTo(x, y);
                fctx2.lineTo(endX, endY);
                fctx2.lineWidth = 3;
                fctx2.lineCap = 'round';
                fctx2.strokeStyle = gradient;
                fctx2.stroke();
            };
    
            var drawBack = function(){
                bctx.clearRect(0, 0, wWidth, wHeight);
    
                var gradient = [];
                
                gradient[0] = bctx.createRadialGradient(wWidth*0.3, wHeight*0.1, 0, wWidth*0.3, wHeight*0.1, wWidth*0.9);
                gradient[0].addColorStop(0, 'rgb(0, 26, 77)');
                gradient[0].addColorStop(1, 'transparent');
    
                bctx.translate(wWidth, 0);
                bctx.scale(-1,1);
                bctx.beginPath();
                bctx.fillStyle = gradient[0];
                bctx.fillRect(0, 0, wWidth, wHeight);
    
                gradient[1] = bctx.createRadialGradient(wWidth*0.1, wHeight*0.1, 0, wWidth*0.3, wHeight*0.1, wWidth);
                gradient[1].addColorStop(0, 'rgb(0, 150, 240)');
                gradient[1].addColorStop(0.8, 'transparent');
    
                bctx.translate(wWidth, 0);
                bctx.scale(-1,1);
                bctx.beginPath();
                bctx.fillStyle = gradient[1];
                bctx.fillRect(0, 0, wWidth, wHeight);
    
                gradient[2] = bctx.createRadialGradient(wWidth*0.1, wHeight*0.5, 0, wWidth*0.1, wHeight*0.5, wWidth*0.5);
                gradient[2].addColorStop(0, 'rgb(40, 20, 105)');
                gradient[2].addColorStop(1, 'transparent');
    
                bctx.beginPath();
                bctx.fillStyle = gradient[2];
                bctx.fillRect(0, 0, wWidth, wHeight);
            };
    
            var animate = function(){
                var sin = M.sin(degree),
                    cos = M.cos(degree);
    
                if (config.circle.amount > 0 && config.circle.layer > 0){
                    fctx1.clearRect(0, 0, wWidth, wHeight);
                    for (var i=0, len = circles.length; i<len; i++){
                        var item = circles[i],
                            x = item.x,
                            y = item.y,
                            radius = item.radius,
                            speed = item.speed;
    
                        if (x > wWidth + radius){
                            x = -radius;
                        } else if (x < -radius){
                            x = wWidth + radius
                        } else {
                            x += sin*speed;
                        }
    
                        if (y > wHeight + radius){
                            y = -radius;
                        } else if (y < -radius){
                            y = wHeight + radius;
                        } else {
                            y -= cos*speed;
                        }
    
                        item.x = x;
                        item.y = y;
                        drawCircle(x, y, radius, item.color, item.alpha);
                    }
                }
    
                if (config.line.amount > 0 && config.line.layer > 0){
                    fctx2.clearRect(0, 0, wWidth, wHeight);
                    for (var j=0, len = lines.length; j<len; j++){
                        var item = lines[j],
                            x = item.x,
                            y = item.y,
                            width = item.width,
                            speed = item.speed;
    
                        if (x > wWidth + width * sin){
                            x = -width * sin;
                        } else if (x < -width * sin){
                            x = wWidth + width * sin;
                        } else {
                            x += sin*speed;
                        }
    
                        if (y > wHeight + width * cos){
                            y = -width * cos;
                        } else if (y < -width * cos){
                            y = wHeight + width * cos;
                        } else {
                            y -= cos*speed;
                        }
                        
                        item.x = x;
                        item.y = y;
                        drawLine(x, y, width, item.color, item.alpha);
                    }
                }
    
                timer = requestAnimationFrame(animate);
            };
    
            var createItem = function(){
                circles = [];
                lines = [];
    
                if (config.circle.amount > 0 && config.circle.layer > 0){
                    for (var i=0; i<config.circle.amount/config.circle.layer; i++){
                        for (var j=0; j<config.circle.layer; j++){
                            circles.push({
                                x: M.random() * wWidth,
                                y: M.random() * wHeight,
                                radius: M.random()*(20+j*5)+(20+j*5),
                                color: config.circle.color,
                                alpha: M.random()*0.2+(config.circle.alpha-j*0.1),
                                speed: config.speed*(1+j*0.5)
                            });
                        }
                    }
                }
    
                if (config.line.amount > 0 && config.line.layer > 0){
                    for (var m=0; m<config.line.amount/config.line.layer; m++){
                        for (var n=0; n<config.line.layer; n++){
                            lines.push({
                                x: M.random() * wWidth,
                                y: M.random() * wHeight,
                                width: M.random()*(20+n*5)+(20+n*5),
                                color: config.line.color,
                                alpha: M.random()*0.2+(config.line.alpha-n*0.1),
                                speed: config.speed*(1+n*0.5)
                            });
                        }
                    }
                }
    
                cancelAnimationFrame(timer);
                timer = requestAnimationFrame(animate);
                drawBack();
            };
    
            $(document).ready(function(){
                setCanvasHeight();
                createItem();
            });
            $(window).resize(function(){
                setCanvasHeight();
                createItem();
            });
        }
        }
      };
    }
  
  })();
(function() {
    'use strict';

    angular.module('BlurAdmin.theme.components')
    .controller('canvasCtrl', ['$scope', '$state', 'AuthenticationService', 'toastr', 'serviceAPI', 'commonService', function($scope, $state, AuthenticationService, toastr, serviceAPI, commonService){
        $scope.data={username:'', clave:''};
        $scope.signIn = function() {
            serviceAPI.signIn($scope.data).success(function(r){
                AuthenticationService.setLoggedIn(r.auth);
                console.log(r);
                if(r.auth){
                    AuthenticationService.setRol(r.rows.nom_rol);
                    AuthenticationService.setUser($scope.data.username);
                    AuthenticationService.setToken(r.token);
                    AuthenticationService.setStates(r.rows.states);
                    $state.go('dashboard', {defaultState: r.rows.name_state});
                }else{
                    toastr.error("Datos de acceso inválidos", 'Error');
                }
            });
        };  
    }]);

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('contentTop', contentTop);

  /** @ngInject */
  function contentTop($location, $state) {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/contentTop/contentTop.html',
      link: function($scope) {
        $scope.$watch(function () {
          $scope.activePageTitle = $state.current.title;
        });
      }
    };
  }

})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
    'use strict';
  
    angular.module('BlurAdmin.theme.components')
        .directive('fondo', fondo);
  
    /** @ngInject */
    function fondo($location, $state) {
      return {
        restrict: 'E',
        templateUrl: 'app/theme/components/fondo/fondo.html',
        link: function($scope) {

            addEventListener("load", function () {
                setTimeout(hideURLbar, 0);
            }, false);
    
            function hideURLbar() {
                window.scrollTo(0, 1);
            }
            var canvas = $('#bg').children('canvas'),
            background = canvas[0],
            foreground1 = canvas[1],
            foreground2 = canvas[2],
            config = {
                circle: {
                    amount: 18,
                    layer: 3,
                    color: [157, 97, 207],
                    alpha: 0.3
                },
                line: {
                    amount: 12,
                    layer: 3,
                    color: [255, 255, 255],
                    alpha: 0.3
                },
                speed: 0.5,
                angle: 20
            };
        if (background.getContext){
            var bctx = background.getContext('2d'),
                fctx1 = foreground1.getContext('2d'),
                fctx2 = foreground2.getContext('2d'),
                M = window.Math, // Cached Math
                degree = config.angle/360*M.PI*2,
                circles = [],
                lines = [],
                wWidth, wHeight, timer;
            
            requestAnimationFrame = window.requestAnimationFrame || 
                window.mozRequestAnimationFrame ||
                window.webkitRequestAnimationFrame ||
                window.msRequestAnimationFrame ||
                window.oRequestAnimationFrame ||
                function(callback, element) { setTimeout(callback, 1000 / 60); };
    
            cancelAnimationFrame = window.cancelAnimationFrame ||
                window.mozCancelAnimationFrame ||
                window.webkitCancelAnimationFrame ||
                window.msCancelAnimationFrame ||
                window.oCancelAnimationFrame ||
                clearTimeout;
    
            var setCanvasHeight = function(){
                wWidth = $(window).width();
                wHeight = $(window).height(),
    
                canvas.each(function(){
                    this.width = wWidth;
                    this.height = wHeight;
                });
            };
    
            var drawCircle = function(x, y, radius, color, alpha){
                var gradient = fctx1.createRadialGradient(x, y, radius, x, y, 0);
                gradient.addColorStop(0, 'rgba('+color[0]+','+color[1]+','+color[2]+','+alpha+')');
                gradient.addColorStop(1, 'rgba('+color[0]+','+color[1]+','+color[2]+','+(alpha-0.1)+')');
    
                fctx1.beginPath();
                fctx1.arc(x, y, radius, 0, M.PI*2, true);
                fctx1.fillStyle = gradient;
                fctx1.fill();
            };
    
            var drawLine = function(x, y, width, color, alpha){
                var endX = x+M.sin(degree)*width,
                    endY = y-M.cos(degree)*width,
                    gradient = fctx2.createLinearGradient(x, y, endX, endY);
                gradient.addColorStop(0, 'rgba('+color[0]+','+color[1]+','+color[2]+','+alpha+')');
                gradient.addColorStop(1, 'rgba('+color[0]+','+color[1]+','+color[2]+','+(alpha-0.1)+')');
    
                fctx2.beginPath();
                fctx2.moveTo(x, y);
                fctx2.lineTo(endX, endY);
                fctx2.lineWidth = 3;
                fctx2.lineCap = 'round';
                fctx2.strokeStyle = gradient;
                fctx2.stroke();
            };
    
            var drawBack = function(){
                bctx.clearRect(0, 0, wWidth, wHeight);
    
                var gradient = [];
                
                gradient[0] = bctx.createRadialGradient(wWidth*0.3, wHeight*0.1, 0, wWidth*0.3, wHeight*0.1, wWidth*0.9);
                gradient[0].addColorStop(0, 'rgb(0, 26, 77)');
                gradient[0].addColorStop(1, 'transparent');
    
                bctx.translate(wWidth, 0);
                bctx.scale(-1,1);
                bctx.beginPath();
                bctx.fillStyle = gradient[0];
                bctx.fillRect(0, 0, wWidth, wHeight);
    
                gradient[1] = bctx.createRadialGradient(wWidth*0.1, wHeight*0.1, 0, wWidth*0.3, wHeight*0.1, wWidth);
                gradient[1].addColorStop(0, 'rgb(0, 150, 240)');
                gradient[1].addColorStop(0.8, 'transparent');
    
                bctx.translate(wWidth, 0);
                bctx.scale(-1,1);
                bctx.beginPath();
                bctx.fillStyle = gradient[1];
                bctx.fillRect(0, 0, wWidth, wHeight);
    
                gradient[2] = bctx.createRadialGradient(wWidth*0.1, wHeight*0.5, 0, wWidth*0.1, wHeight*0.5, wWidth*0.5);
                gradient[2].addColorStop(0, 'rgb(40, 20, 105)');
                gradient[2].addColorStop(1, 'transparent');
    
                bctx.beginPath();
                bctx.fillStyle = gradient[2];
                bctx.fillRect(0, 0, wWidth, wHeight);
            };
    
            var animate = function(){
                var sin = M.sin(degree),
                    cos = M.cos(degree);
    
                if (config.circle.amount > 0 && config.circle.layer > 0){
                    fctx1.clearRect(0, 0, wWidth, wHeight);
                    for (var i=0, len = circles.length; i<len; i++){
                        var item = circles[i],
                            x = item.x,
                            y = item.y,
                            radius = item.radius,
                            speed = item.speed;
    
                        if (x > wWidth + radius){
                            x = -radius;
                        } else if (x < -radius){
                            x = wWidth + radius
                        } else {
                            x += sin*speed;
                        }
    
                        if (y > wHeight + radius){
                            y = -radius;
                        } else if (y < -radius){
                            y = wHeight + radius;
                        } else {
                            y -= cos*speed;
                        }
    
                        item.x = x;
                        item.y = y;
                        drawCircle(x, y, radius, item.color, item.alpha);
                    }
                }
    
                if (config.line.amount > 0 && config.line.layer > 0){
                    fctx2.clearRect(0, 0, wWidth, wHeight);
                    for (var j=0, len = lines.length; j<len; j++){
                        var item = lines[j],
                            x = item.x,
                            y = item.y,
                            width = item.width,
                            speed = item.speed;
    
                        if (x > wWidth + width * sin){
                            x = -width * sin;
                        } else if (x < -width * sin){
                            x = wWidth + width * sin;
                        } else {
                            x += sin*speed;
                        }
    
                        if (y > wHeight + width * cos){
                            y = -width * cos;
                        } else if (y < -width * cos){
                            y = wHeight + width * cos;
                        } else {
                            y -= cos*speed;
                        }
                        
                        item.x = x;
                        item.y = y;
                        drawLine(x, y, width, item.color, item.alpha);
                    }
                }
    
                timer = requestAnimationFrame(animate);
            };
    
            var createItem = function(){
                circles = [];
                lines = [];
    
                if (config.circle.amount > 0 && config.circle.layer > 0){
                    for (var i=0; i<config.circle.amount/config.circle.layer; i++){
                        for (var j=0; j<config.circle.layer; j++){
                            circles.push({
                                x: M.random() * wWidth,
                                y: M.random() * wHeight,
                                radius: M.random()*(20+j*5)+(20+j*5),
                                color: config.circle.color,
                                alpha: M.random()*0.2+(config.circle.alpha-j*0.1),
                                speed: config.speed*(1+j*0.5)
                            });
                        }
                    }
                }
    
                if (config.line.amount > 0 && config.line.layer > 0){
                    for (var m=0; m<config.line.amount/config.line.layer; m++){
                        for (var n=0; n<config.line.layer; n++){
                            lines.push({
                                x: M.random() * wWidth,
                                y: M.random() * wHeight,
                                width: M.random()*(20+n*5)+(20+n*5),
                                color: config.line.color,
                                alpha: M.random()*0.2+(config.line.alpha-n*0.1),
                                speed: config.speed*(1+n*0.5)
                            });
                        }
                    }
                }
    
                cancelAnimationFrame(timer);
                timer = requestAnimationFrame(animate);
                drawBack();
            };
    
            $(document).ready(function(){
                setCanvasHeight();
                createItem();
            });
            $(window).resize(function(){
                setCanvasHeight();
                createItem();
            });
        }
        }
      };
    }
  
  })();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .controller('MsgCenterCtrl', MsgCenterCtrl);

  /** @ngInject */
  function MsgCenterCtrl($scope, $sce) {
    $scope.users = {
      0: {
        name: 'Vlad',
      },
      1: {
        name: 'Kostya',
      },
      2: {
        name: 'Andrey',
      },
      3: {
        name: 'Nasta',
      }
    };

    $scope.notifications = [
      {
        userId: 0,
        template: '&name posted a new article.',
        time: '1 min ago'
      },
      {
        userId: 1,
        template: '&name changed his contact information.',
        time: '2 hrs ago'
      },
      {
        image: 'assets/img/shopping-cart.svg',
        template: 'New orders received.',
        time: '5 hrs ago'
      },
      {
        userId: 2,
        template: '&name replied to your comment.',
        time: '1 day ago'
      },
      {
        userId: 3,
        template: 'Today is &name\'s birthday.',
        time: '2 days ago'
      },
      {
        image: 'assets/img/comments.svg',
        template: 'New comments on your post.',
        time: '3 days ago'
      },
      {
        userId: 1,
        template: '&name invited you to join the event.',
        time: '1 week ago'
      }
    ];

    $scope.messages = [
      {
        userId: 3,
        text: 'After you get up and running, you can place Font Awesome icons just about...',
        time: '1 min ago'
      },
      {
        userId: 0,
        text: 'You asked, Font Awesome delivers with 40 shiny new icons in version 4.2.',
        time: '2 hrs ago'
      },
      {
        userId: 1,
        text: 'Want to request new icons? Here\'s how. Need vectors or want to use on the...',
        time: '10 hrs ago'
      },
      {
        userId: 2,
        text: 'Explore your passions and discover new ones by getting involved. Stretch your...',
        time: '1 day ago'
      },
      {
        userId: 3,
        text: 'Get to know who we are - from the inside out. From our history and culture, to the...',
        time: '1 day ago'
      },
      {
        userId: 1,
        text: 'Need some support to reach your goals? Apply for scholarships across a variety of...',
        time: '2 days ago'
      },
      {
        userId: 0,
        text: 'Wrap the dropdown\'s trigger and the dropdown menu within .dropdown, or...',
        time: '1 week ago'
      }
    ];

    $scope.getMessage = function(msg) {
      var text = msg.template;
      if (msg.userId || msg.userId === 0) {
        text = text.replace('&name', '<strong>' + $scope.users[msg.userId].name + '</strong>');
      }
      return $sce.trustAsHtml(text);
    };
  }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('msgCenter', msgCenter);

  /** @ngInject */
  function msgCenter() {
    return {
      restrict: 'E',
      templateUrl: 'app/theme/components/msgCenter/msgCenter.html',
      controller: 'MsgCenterCtrl'
    };
  }

})();
(function() {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .controller('SignOutCtrl', ['$scope', 'AuthenticationService', '$state', 'PermRoleStore', function($scope, AuthenticationService, $state, PermRoleStore){
            $scope.username = AuthenticationService.getUser();
            $scope.signOut = function(){
                PermRoleStore.clearStore();
                AuthenticationService.setLoggedIn(false);
                AuthenticationService.signOut();
                $state.go('signin');
                /*$http.defaults.headers.common.Authorization='';*/
            };
        }])
        .directive('pageTop', function(){
            return {
                restrict: 'E',
                templateUrl: 'app/theme/components/pageTop/pageTop.html',
                controller: 'SignOutCtrl'
            };
        });

})();

/**
 * Created by n.poltoratsky
 * on 28.06.2016.
 */
(function () {
    'use strict';

    angular.module('BlurAdmin.theme.components')
        .directive('progressBarRound', progressBarRound);

    /** @ngInject */
    function progressBarRound(baProgressModal) {
        return {
            restrict: 'E',
            templateUrl: 'app/theme/components/progressBarRound/progressBarRound.html',
            link:function($scope, element, attrs) {
                $scope.baProgressDialog = baProgressModal;
                $scope.$watch(function () {
                    return baProgressModal.getProgress();
                }, animateBar);

                function animateBar() {
                    var circle = element.find('#loader')[0];
                    circle.setAttribute("stroke-dasharray", baProgressModal.getProgress() * 180 * Math.PI / 100 + ", 20000");
                    $scope.progress = baProgressModal.getProgress();
                }
            }
        }
    }
})();
/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.components')
      .directive('widgets', widgets);

  /** @ngInject */
  function widgets() {
    return {
      restrict: 'EA',
      scope: {
        ngModel: '='
      },
      templateUrl: 'app/theme/components/widgets/widgets.html',
      replace: true
    };
  }

})();
/**
 * @author a.demeshko
 * created on 23.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
    .filter('plainText', plainText);

  /** @ngInject */
  function plainText() {
    return function(text) {
      return  text ? String(text).replace(/<[^>]+>/gm, '') : '';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('appImage', appImage);

  /** @ngInject */
  function appImage(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + input;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('kameleonImg', kameleonImg);

  /** @ngInject */
  function kameleonImg(layoutPaths) {
    return function(input) {
      return layoutPaths.images.root + 'theme/icon/kameleon/' + input + '.svg';
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 17.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme')
      .filter('profilePicture', profilePicture);

  /** @ngInject */
  function profilePicture(layoutPaths) {
    return function(input, ext) {
      ext = ext || 'png';
      return layoutPaths.images.profile + input + '.' + ext;
    };
  }

})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.theme.inputs')
      .directive('baSwitcher', [function(){
        return {
          templateUrl: 'app/theme/inputs/baSwitcher/baSwitcher.html',
          scope: {
            switcherStyle: '@',
            switcherValue: '=',
            valueOn:'=',
            valueOff:'='
          },
          link:function(){
            console.log('baSwitcher')
          }    
        }
      }]);
})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('AreaChartCtrl', AreaChartCtrl);

  /** @ngInject */
  function AreaChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var areaChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      dataProvider: [
        {
          lineColor: layoutColors.info,
          date: '2012-01-01',
          duration: 408
        },
        {
          date: '2012-01-02',
          duration: 482
        },
        {
          date: '2012-01-03',
          duration: 562
        },
        {
          date: '2012-01-04',
          duration: 379
        },
        {
          lineColor: layoutColors.warning,
          date: '2012-01-05',
          duration: 501
        },
        {
          date: '2012-01-06',
          duration: 443
        },
        {
          date: '2012-01-07',
          duration: 405
        },
        {
          date: '2012-01-08',
          duration: 309,
          lineColor: layoutColors.danger
        },
        {
          date: '2012-01-09',
          duration: 287
        },
        {
          date: '2012-01-10',
          duration: 485
        },
        {
          date: '2012-01-11',
          duration: 890
        },
        {
          date: '2012-01-12',
          duration: 810
        }
      ],
      balloon: {
        cornerRadius: 6,
        horizontalPadding: 15,
        verticalPadding: 10
      },
      valueAxes: [
        {
          duration: 'mm',
          durationUnits: {
            hh: 'h ',
            mm: 'min'
          },
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      graphs: [
        {
          bullet: 'square',
          bulletBorderAlpha: 1,
          bulletBorderThickness: 1,
          fillAlphas: 0.5,
          fillColorsField: 'lineColor',
          legendValueText: '[[value]]',
          lineColorField: 'lineColor',
          title: 'duration',
          valueField: 'duration'
        }
      ],

      chartCursor: {
        categoryBalloonDateFormat: 'YYYY MMM DD',
        cursorAlpha: 0,
        fullWidth: true
      },
      dataDateFormat: 'YYYY-MM-DD',
      categoryField: 'date',
      categoryAxis: {
        dateFormats: [
          {
            period: 'DD',
            format: 'DD'
          },
          {
            period: 'WW',
            format: 'MMM DD'
          },
          {
            period: 'MM',
            format: 'MMM'
          },
          {
            period: 'YYYY',
            format: 'YYYY'
          }
        ],
        parseDates: true,
        autoGridCount: false,
        gridCount: 50,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      pathToImages: layoutPaths.images.amChart
    });

    areaChart.addListener('dataUpdated', zoomAreaChart);

    function zoomAreaChart() {
      areaChart.zoomToDates(new Date(2012, 0, 3), new Date(2012, 0, 11));
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('BarChartCtrl', BarChartCtrl);

  /** @ngInject */
  function BarChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var barChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      dataProvider: [
        {
          country: 'USA',
          visits: 3025,
          color: layoutColors.primary
        },
        {
          country: 'China',
          visits: 1882,
          color: layoutColors.danger

        },
        {
          country: 'Japan',
          visits: 1809,
          color: layoutColors.info
        },
        {
          country: 'Germany',
          visits: 1322,
          color: layoutColors.success
        },
        {
          country: 'UK',
          visits: 1122,
          color: layoutColors.warning
        },
        {
          country: 'France',
          visits: 1114,
          color: layoutColors.primaryLight
        }
      ],
      valueAxes: [
        {
          axisAlpha: 0,
          position: 'left',
          title: 'Visitors from country',
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      startDuration: 1,
      graphs: [
        {
          balloonText: '<b>[[category]]: [[value]]</b>',
          fillColorsField: 'color',
          fillAlphas: 0.7,
          lineAlpha: 0.2,
          type: 'column',
          valueField: 'visits'
        }
      ],
      chartCursor: {
        categoryBalloonEnabled: false,
        cursorAlpha: 0,
        zoomable: false
      },
      categoryField: 'country',
      categoryAxis: {
        gridPosition: 'start',
        labelRotation: 45,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      creditsPosition: 'top-right',
      pathToImages: layoutPaths.images.amChart
    });
  }
})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
    .controller('combinedChartCtrl', combinedChartCtrl);

  /** @ngInject */
  function combinedChartCtrl($element, baConfig, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var chart = AmCharts.makeChart(id, {
      "type": "serial",
      "theme": "none",
      "color": layoutColors.defaultText,
      "dataDateFormat": "YYYY-MM-DD",
      "precision": 2,
      "valueAxes": [{
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText,
        gridColor: layoutColors.defaultText,
        "id": "v1",
        "title": "Sales",
        "position": "left",
        "autoGridCount": false,
        "labelFunction": function(value) {
          return "$" + Math.round(value) + "M";
        }
      }, {
        color: layoutColors.defaultText,
        axisColor: layoutColors.defaultText,
        gridColor: layoutColors.defaultText,
        "id": "v2",
        "title": "Market Days",
        "gridAlpha": 0,
        "position": "right",
        "autoGridCount": false
      }],
      "graphs": [{
        "id": "g3",
        color: layoutColors.defaultText,
        "valueAxis": "v1",
        "lineColor": layoutColors.primaryLight,
        "fillColors": layoutColors.primaryLight,
        "fillAlphas": 0.8,
        "lineAlpha": 0.8,
        "type": "column",
        "title": "Actual Sales",
        "valueField": "sales2",
        "clustered": false,
        "columnWidth": 0.5,
        "lineColorField" : layoutColors.defaultText,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g4",
        "valueAxis": "v1",
        color: layoutColors.defaultText,
        "lineColor": layoutColors.primary,
        "fillColors": layoutColors.primary,
        "fillAlphas": 0.9,
        "lineAlpha": 0.9,
        "type": "column",
        "title": "Target Sales",
        "valueField": "sales1",
        "clustered": false,
        "columnWidth": 0.3,
        "legendValueText": "$[[value]]M",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>$[[value]]M</b>"
      }, {
        "id": "g1",
        "valueAxis": "v2",
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": layoutColors.defaultText,
        color: layoutColors.defaultText,
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": layoutColors.danger,
        "type": "smoothedLine",
        "title": "Market Days",
        "useLineColorForBulletBorder": true,
        "valueField": "market1",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
      }, {
        "id": "g2",
        "valueAxis": "v2",
        color: layoutColors.defaultText,
        "bullet": "round",
        "bulletBorderAlpha": 1,
        "bulletColor": layoutColors.defaultText,
        "bulletSize": 5,
        "hideBulletsCount": 50,
        "lineThickness": 2,
        "lineColor": layoutColors.warning,
        "type": "smoothedLine",
        "dashLength": 5,
        "title": "Market Days ALL",
        "useLineColorForBulletBorder": true,
        "valueField": "market2",
        "balloonText": "[[title]]<br/><b style='font-size: 130%'>[[value]]</b>"
      }],
      "chartScrollbar": {
        "graph": "g1",
        "oppositeAxis": false,
        "offset": 30,
        gridAlpha: 0,
        color: layoutColors.defaultText,
        scrollbarHeight: 50,
        backgroundAlpha: 0,
        selectedBackgroundAlpha: 0.05,
        selectedBackgroundColor: layoutColors.defaultText,
        graphFillAlpha: 0,
        autoGridCount: true,
        selectedGraphFillAlpha: 0,
        graphLineAlpha: 0.2,
        selectedGraphLineColor: layoutColors.defaultText,
        selectedGraphLineAlpha: 1
      },
      "chartCursor": {
        "pan": true,
        "cursorColor" : layoutColors.danger,
        "valueLineEnabled": true,
        "valueLineBalloonEnabled": true,
        "cursorAlpha": 0,
        "valueLineAlpha": 0.2
      },
      "categoryField": "date",
      "categoryAxis": {
        "axisColor": layoutColors.defaultText,
        "color": layoutColors.defaultText,
        "gridColor": layoutColors.defaultText,
        "parseDates": true,
        "dashLength": 1,
        "minorGridEnabled": true
      },
      "legend": {
        "useGraphSettings": true,
        "position": "top",
        "color": layoutColors.defaultText
      },
      "balloon": {
        "borderThickness": 1,
        "shadowAlpha": 0
      },
      "export": {
        "enabled": true
      },
      "dataProvider": [{
        "date": "2013-01-16",
        "market1": 71,
        "market2": 75,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-17",
        "market1": 74,
        "market2": 78,
        "sales1": 4,
        "sales2": 6
      }, {
        "date": "2013-01-18",
        "market1": 78,
        "market2": 88,
        "sales1": 5,
        "sales2": 2
      }, {
        "date": "2013-01-19",
        "market1": 85,
        "market2": 89,
        "sales1": 8,
        "sales2": 9
      }, {
        "date": "2013-01-20",
        "market1": 82,
        "market2": 89,
        "sales1": 9,
        "sales2": 6
      }, {
        "date": "2013-01-21",
        "market1": 83,
        "market2": 85,
        "sales1": 3,
        "sales2": 5
      }, {
        "date": "2013-01-22",
        "market1": 88,
        "market2": 92,
        "sales1": 5,
        "sales2": 7
      }, {
        "date": "2013-01-23",
        "market1": 85,
        "market2": 90,
        "sales1": 7,
        "sales2": 6
      }, {
        "date": "2013-01-24",
        "market1": 85,
        "market2": 91,
        "sales1": 9,
        "sales2": 5
      }, {
        "date": "2013-01-25",
        "market1": 80,
        "market2": 84,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-26",
        "market1": 87,
        "market2": 92,
        "sales1": 4,
        "sales2": 8
      }, {
        "date": "2013-01-27",
        "market1": 84,
        "market2": 87,
        "sales1": 3,
        "sales2": 4
      }, {
        "date": "2013-01-28",
        "market1": 83,
        "market2": 88,
        "sales1": 5,
        "sales2": 7
      }, {
        "date": "2013-01-29",
        "market1": 84,
        "market2": 87,
        "sales1": 5,
        "sales2": 8
      }, {
        "date": "2013-01-30",
        "market1": 81,
        "market2": 85,
        "sales1": 4,
        "sales2": 7
      }],
      pathToImages: layoutPaths.images.amChart
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('FunnelChartCtrl', FunnelChartCtrl);

  /** @ngInject */
  function FunnelChartCtrl($scope, $element, layoutPaths, baConfig) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var funnelChart = AmCharts.makeChart(id, {
      type: 'funnel',
      theme: 'blur',
      color: layoutColors.defaultText,
      labelTickColor: layoutColors.borderDark,
      dataProvider: [
        {
          title: 'Website visits',
          value: 300
        },
        {
          title: 'Downloads',
          value: 123
        },
        {
          title: 'Requested prices',
          value: 98
        },
        {
          title: 'Contaced',
          value: 72
        },
        {
          title: 'Purchased',
          value: 35
        },
        {
          title: 'Asked for support',
          value: 25
        },
        {
          title: 'Purchased more',
          value: 18
        }
      ],
      titleField: 'title',
      marginRight: 160,
      marginLeft: 15,
      labelPosition: 'right',
      funnelAlpha: 0.9,
      valueField: 'value',
      startX: 0,
      alpha: 0.8,
      neckWidth: '0%',
      startAlpha: 0,
      outlineThickness: 1,
      neckHeight: '0%',
      balloonText: '[[title]]:<b>[[value]]</b>',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-left',
      pathToImages: layoutPaths
    });
  }
})();

/**
 * @author a.demeshko
 * created on 22.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
    .controller('ganttChartCtrl', ganttChartCtrl);

  /** @ngInject */
  function ganttChartCtrl($element) {
    var id = $element[0].getAttribute('id');
    var chart = AmCharts.makeChart( id, {
      "type": "gantt",
      "theme": "light",
      "marginRight": 70,
      "period": "hh",
      "dataDateFormat":"YYYY-MM-DD",
      "balloonDateFormat": "JJ:NN",
      "columnWidth": 0.5,
      "valueAxis": {
        "type": "date",
        "minimum": 7,
        "maximum": 31
      },
      "brightnessStep": 10,
      "graph": {
        "fillAlphas": 1,
        "balloonText": "<b>[[task]]</b>: [[open]] [[value]]"
      },
      "rotate": true,
      "categoryField": "category",
      "segmentsField": "segments",
      "colorField": "color",
      "startDate": "2015-01-01",
      "startField": "start",
      "endField": "end",
      "durationField": "duration",
      "dataProvider": [
        {
        "category": "John",
        "segments": [ {
          "start": 7,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Smith",
        "segments": [ {
          "start": 10,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Ben",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Mike",
        "segments": [ {
          "start": 9,
          "duration": 6,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 4,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Lenny",
        "segments": [ {
          "start": 8,
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Scott",
        "segments": [ {
          "start": 15,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Julia",
        "segments": [ {
          "start": 9,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 1,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 8,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Bob",
        "segments": [ {
          "start": 9,
          "duration": 8,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 7,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Kendra",
        "segments": [ {
          "start": 11,
          "duration": 8,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Tom",
        "segments": [ {
          "start": 9,
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 5,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Kyle",
        "segments": [ {
          "start": 6,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Anita",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 16,
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Jack",
        "segments": [ {
          "start": 8,
          "duration": 10,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        } ]
      }, {
        "category": "Kim",
        "segments": [ {
          "start": 12,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 3,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Aaron",
        "segments": [ {
          "start": 18,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      }, {
        "category": "Alan",
        "segments": [ {
          "start": 17,
          "duration": 2,
          "color": "#46615e",
          "task": "Task #1"
        }, {
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 2,
          "color": "#8dc49f",
          "task": "Task #3"
        } ]
      }, {
        "category": "Ruth",
        "segments": [ {
          "start": 13,
          "duration": 2,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "duration": 1,
          "color": "#8dc49f",
          "task": "Task #3"
        }, {
          "duration": 4,
          "color": "#46615e",
          "task": "Task #1"
        } ]
      }, {
        "category": "Simon",
        "segments": [ {
          "start": 10,
          "duration": 3,
          "color": "#727d6f",
          "task": "Task #2"
        }, {
          "start": 17,
          "duration": 4,
          "color": "#FFE4C4",
          "task": "Task #4"
        } ]
      } ],
      "valueScrollbar": {
        "autoGridCount":true
      },
      "chartCursor": {
        "cursorColor":"#55bb76",
        "valueBalloonsEnabled": false,
        "cursorAlpha": 0,
        "valueLineAlpha":0.5,
        "valueLineBalloonEnabled": true,
        "valueLineEnabled": true,
        "zoomable":false,
        "valueZoomable":true
      },
      "export": {
        "enabled": true
      }
    });
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('LineChartCtrl', LineChartCtrl);

  /** @ngInject */
  function LineChartCtrl($scope, baConfig, $element, layoutPaths) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var lineChart = AmCharts.makeChart(id, {
      type: 'serial',
      theme: 'blur',
      color: layoutColors.defaultText,
      marginTop: 0,
      marginRight: 15,
      dataProvider: [
        {
          year: '1990',
          value: -0.17
        },
        {
          year: '1991',
          value: -0.254
        },
        {
          year: '1992',
          value: 0.019
        },
        {
          year: '1993',
          value: -0.063
        },
        {
          year: '1994',
          value: 0.005
        },
        {
          year: '1995',
          value: 0.077
        },
        {
          year: '1996',
          value: 0.12
        },
        {
          year: '1997',
          value: 0.011
        },
        {
          year: '1998',
          value: 0.177
        },
        {
          year: '1999',
          value: -0.021
        },
        {
          year: '2000',
          value: -0.037
        },
        {
          year: '2001',
          value: 0.03
        },
        {
          year: '2002',
          value: 0.179
        },
        {
          year: '2003',
          value: 0.2
        },
        {
          year: '2004',
          value: 0.180
        },
        {
          year: '2005',
          value: 0.21
        }
      ],
      valueAxes: [
        {
          axisAlpha: 0,
          position: 'left',
          gridAlpha: 0.5,
          gridColor: layoutColors.border,
        }
      ],
      graphs: [
        {
          id: 'g1',
          balloonText: '[[value]]',
          bullet: 'round',
          bulletSize: 8,
          lineColor: layoutColors.danger,
          lineThickness: 1,
          negativeLineColor: layoutColors.warning,
          type: 'smoothedLine',
          valueField: 'value'
        }
      ],
      chartScrollbar: {
        graph: 'g1',
        gridAlpha: 0,
        color: layoutColors.defaultText,
        scrollbarHeight: 55,
        backgroundAlpha: 0,
        selectedBackgroundAlpha: 0.05,
        selectedBackgroundColor: layoutColors.defaultText,
        graphFillAlpha: 0,
        autoGridCount: true,
        selectedGraphFillAlpha: 0,
        graphLineAlpha: 0.2,
        selectedGraphLineColor: layoutColors.defaultText,
        selectedGraphLineAlpha: 1
      },
      chartCursor: {
        categoryBalloonDateFormat: 'YYYY',
        cursorAlpha: 0,
        valueLineEnabled: true,
        valueLineBalloonEnabled: true,
        valueLineAlpha: 0.5,
        fullWidth: true
      },
      dataDateFormat: 'YYYY',
      categoryField: 'year',
      categoryAxis: {
        minPeriod: 'YYYY',
        parseDates: true,
        minorGridAlpha: 0.1,
        minorGridEnabled: true,
        gridAlpha: 0.5,
        gridColor: layoutColors.border,
      },
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-right',
      pathToImages: layoutPaths.images.amChart
    });

    lineChart.addListener('rendered', zoomChart);
    if (lineChart.zoomChart) {
      lineChart.zoomChart();
    }

    function zoomChart() {
      lineChart.zoomToIndexes(Math.round(lineChart.dataProvider.length * 0.4), Math.round(lineChart.dataProvider.length * 0.55));
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.charts.amCharts')
      .controller('PieChartCtrl', PieChartCtrl);

  /** @ngInject */
  function PieChartCtrl($element, layoutPaths, baConfig) {
    var layoutColors = baConfig.colors;
    var id = $element[0].getAttribute('id');
    var pieChart = AmCharts.makeChart(id, {
      type: 'pie',
      startDuration: 0,
      theme: 'blur',
      addClassNames: true,
      color: layoutColors.defaultText,
      labelTickColor: layoutColors.borderDark,
      legend: {
        position: 'right',
        marginRight: 100,
        autoMargins: false,
      },
      innerRadius: '40%',
      defs: {
        filter: [
          {
            id: 'shadow',
            width: '200%',
            height: '200%',
            feOffset: {
              result: 'offOut',
              in: 'SourceAlpha',
              dx: 0,
              dy: 0
            },
            feGaussianBlur: {
              result: 'blurOut',
              in: 'offOut',
              stdDeviation: 5
            },
            feBlend: {
              in: 'SourceGraphic',
              in2: 'blurOut',
              mode: 'normal'
            }
          }
        ]
      },
      dataProvider: [
        {
          country: 'Lithuania',
          litres: 501.9
        },
        {
          country: 'Czech Republic',
          litres: 301.9
        },
        {
          country: 'Ireland',
          litres: 201.1
        },
        {
          country: 'Germany',
          litres: 165.8
        },
        {
          country: 'Australia',
          litres: 139.9
        },
        {
          country: 'Austria',
          litres: 128.3
        },
        {
          country: 'UK',
          litres: 99
        },
        {
          country: 'Belgium',
          litres: 60
        }
      ],
      valueField: 'litres',
      titleField: 'country',
      export: {
        enabled: true
      },
      creditsPosition: 'bottom-left',

      autoMargins: false,
      marginTop: 10,
      alpha: 0.8,
      marginBottom: 0,
      marginLeft: 0,
      marginRight: 0,
      pullOutRadius: 0,
      pathToImages: layoutPaths.images.amChart,
      responsive: {
        enabled: true,
        rules: [
          // at 900px wide, we hide legend
          {
            maxWidth: 900,
            overrides: {
              legend: {
                enabled: false
              }
            }
          },

          // at 200 px we hide value axis labels altogether
          {
            maxWidth: 200,
            overrides: {
              valueAxes: {
                labelsEnabled: false
              },
              marginTop: 30,
              marginBottom: 30,
              marginLeft: 30,
              marginRight: 30
            }
          }
        ]
      }
    });

    pieChart.addListener('init', handleInit);

    pieChart.addListener('rollOverSlice', function (e) {
      handleRollOver(e);
    });

    function handleInit() {
      pieChart.legend.addListener('rollOverItem', handleRollOver);
    }

    function handleRollOver(e) {
      var wedge = e.dataItem.wedge.node;
      wedge.parentNode.appendChild(wedge);
    }
  }

})();

/**
 * @author v.lugovsky
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.ui.modals')
      .controller('NotificationsCtrl', NotificationsCtrl);

  /** @ngInject */
  function NotificationsCtrl($scope, toastr) {
    $scope.showSuccessMsg = function() {
      toastr.success('Your information has been saved successfully!');
    };

    $scope.showInfoMsg = function() {
      toastr.info("You've got a new email!", 'Information');
    };

    $scope.showErrorMsg = function() {
      toastr.error("Your information hasn't been saved!", 'Error');
    };

    $scope.showWarningMsg = function() {
      toastr.warning('Your computer is about to explode!', 'Warning');
    };
  }

})();

/* Minified js for jQuery BackTop */
!function(o){o.fn.backTop=function(e){var n=this,i=o.extend({position:400,speed:500,color:"white"},e),t=i.position,c=i.speed,d=i.color;n.addClass("white"==d?"white":"red"==d?"red":"green"==d?"green":"black"),n.css({right:40,bottom:40,position:"fixed"}),o(document).scroll(function(){var e=o(window).scrollTop();e>=t?n.fadeIn(c):n.fadeOut(c)}),n.click(function(){o("html, body").animate({scrollTop:0},{duration:1200})})}}(jQuery);
/**
 * Created by n.poltoratsky
 * on 23.06.2016.
 */
(function(){
    'use strict';

    angular.module('BlurAdmin.pages.form')
        .controller('datepickerCtrl', datepickerCtrl);

    /** @ngInject */
    function datepickerCtrl($scope) {

        $scope.dt = new Date();
        $scope.options = {
            showWeeks: false
        };

    }
})();
/**
 * Created by n.poltoratsky
 * on 23.06.2016.
 */
(function(){
    'use strict';

    angular.module('BlurAdmin.pages.form')
        .controller('datepickerpopupCtrl', datepickerpopupCtrl);

    /** @ngInject */
    function datepickerpopupCtrl($scope) {

        $scope.open = open;
        $scope.opened = false;
        $scope.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
        $scope.format = $scope.formats[0];
        $scope.options = {
            showWeeks: false
        };

        function open() {
            $scope.opened = true;
        }
    }
})();
/**
 * @author v.lugovsky
 * created on 07.06.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('OldSwitchPanelCtrl', OldSwitchPanelCtrl);

  /** @ngInject */
  function OldSwitchPanelCtrl() {
    var vm = this;

    vm.switcherValues = {
      primary: true,
      warning: true,
      danger: true,
      info: true,
      success: true
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 *
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('switch', switchDirective);

  /** @ngInject */
  function switchDirective($timeout) {
    return {
      restrict: 'EA',
      replace: true,
      scope: {
        ngModel: '='
      },
      template: function(el, attrs) {
        return '<div class="switch-container ' + (attrs.color || '') + '"><input type="checkbox" ng-model="ngModel"></div>';
      },
      link: function (scope, elem, attr) {
        var input = $(elem).find('input');
        input.bootstrapSwitch({
          size: 'small',
          onColor: attr.color
        });
        input.on('switchChange.bootstrapSwitch', function(event, state) {
          scope.ngModel = state;
          scope.$apply();
        });

      }
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 22.04.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('SelectpickerPanelCtrl', SelectpickerPanelCtrl);

  /** @ngInject */
  function SelectpickerPanelCtrl() {
    var vm = this;

    vm.standardSelectItems = [
      { label: 'Option 1', value: 1 },
      { label: 'Option 2', value: 2 },
      { label: 'Option 3', value: 3 },
      { label: 'Option 4', value: 4 },
    ];

    vm.selectWithSearchItems = [
      { label: 'Hot Dog, Fries and a Soda', value: 1 },
      { label: 'Burger, Shake and a Smile', value: 2 },
      { label: 'Sugar, Spice and all things nice', value: 3 },
      { label: 'Baby Back Ribs', value: 4 },
    ];

    vm.groupedSelectItems = [
      { label: 'Group 1 - Option 1', value: 1, group: 'Group 1' },
      { label: 'Group 2 - Option 2', value: 2, group: 'Group 2' },
      { label: 'Group 1 - Option 3', value: 3, group: 'Group 1' },
      { label: 'Group 2 - Option 4', value: 4, group: 'Group 2' },
    ];

  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('selectpicker', selectpicker);

  /** @ngInject */
  function selectpicker() {
    return {
      restrict: 'A',
      require: '?ngOptions',
      priority: 1500, // make priority bigger than ngOptions and ngRepeat
      link: {
        pre: function(scope, elem, attrs) {
          elem.append('<option data-hidden="true" disabled value="">' + (attrs.title || 'Select something') + '</option>')
        },
        post: function(scope, elem, attrs) {
          function refresh() {
            elem.selectpicker('refresh');
          }

          if (attrs.ngModel) {
            scope.$watch(attrs.ngModel, refresh);
          }

          if (attrs.ngDisabled) {
            scope.$watch(attrs.ngDisabled, refresh);
          }

          elem.selectpicker({ dropupAuto: false, hideDisabled: true });
        }
      }
    };
  }


})();
/**
 * @author v.lugovsky
 * created on 07.06.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('SwitchPanelCtrl', SwitchPanelCtrl);

  /** @ngInject */
  function SwitchPanelCtrl($scope) {
    vm.switcherValues = {
      primary: true,
      warning: true,
      danger: true,
      info: true,
      success: true
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('switch', switchDirective);

  /** @ngInject */
  function switchDirective($timeout) {
    return {
      restrict: 'EA',
      replace: true,
      scope: {
        ngModel: '='
      },
      template: function(el, attrs) {
        return '<div class="switch-container ' + (attrs.color || '') + '"><input type="checkbox" ng-model="ngModel"></div>';
      },
      link: function (scope, elem, attr) {
        $timeout(function(){
          var input = $(elem).find('input');
          input.bootstrapSwitch({
            size: 'small',
            onColor: attr.color
          });
          input.on('switchChange.bootstrapSwitch', function(event, state) {
            scope.ngModel = state;
            scope.$apply();
          });

        });
      }
    };
  }
})();

/**
 * @author v.lugovsky
 * created on 10.12.2016
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .controller('SwitchDemoPanelCtrl', SwitchDemoPanelCtrl);

  /** @ngInject */
  function SwitchDemoPanelCtrl() {
    var vm = this;
    vm.switches = {
      s1: true,
      s2: false,
      s3: true,
      s4: true,
      s5: false
    };
  }

})();

/**
 * @author v.lugovksy
 * created on 16.12.2015
 */
(function () {
  'use strict';

  angular.module('BlurAdmin.pages.form')
      .directive('tagInput', tagInput);

  /** @ngInject */
  function tagInput() {
    return {
      restrict: 'A',
      link: function( $scope, elem, attr) {
        $(elem).tagsinput({
          tagClass:  'label label-' + attr.tagInput
        });
      }
    };
  }
})();
angular.module("BlurAdmin").run(["$templateCache", function($templateCache) {$templateCache.put("app/pages/action/permission.html","");
$templateCache.put("app/pages/home/home.html","<dashboard-pie-chart></dashboard-pie-chart><div class=\"row\"><div class=\"col-lg-6 col-md-12 col-sm-12\" ba-panel=\"\" ba-panel-title=\"Canales de Acquisión\" ba-panel-class=\"medium-panel traffic-panel\"><traffic-chart></traffic-chart></div><div class=\"col-lg-6 col-md-12 col-sm-12\" ba-panel=\"\" ba-panel-title=\"Usuarios Localidad\" ba-panel-class=\"medium-panel\"><dashboard-map></dashboard-map></div></div>");
$templateCache.put("app/pages/profile/profile.html","<div ba-panel=\"\" ba-panel-class=\"profile-page\"><div class=\"panel-content\"><h3 class=\"with-line\">General Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputFirstName\" class=\"col-sm-3 control-label\">Picture</label><div class=\"col-sm-9\"><div class=\"userpic\"><div class=\"userpic-wrapper\"><img ng-src=\"{{ data.profile }}\" ng-click=\"uploadPicture()\"></div><i class=\"ion-ios-close-outline\" ng-click=\"removePicture()\" ng-if=\"!noPicture\"></i> <a href=\"\" class=\"change-userpic\" ngf-select=\"uploadFiles($files)\" ngf-multiple=\"true\">Change Profile Picture</a> <input type=\"file\" ng-show=\"false\" id=\"uploadFile\" ng-file-select=\"onFileSelect($files)\"></div></div></div></div><div><form novalidate=\"\"><div ng-show=\"Files.length > 0\"><div ng-repeat=\"file in Files\">File:<div>{{file.name}} {{file.$error}} {{file.$errorParam}} {{fileProgress}}</div><div ng-show=\"file.Progress == 100 && !file.Success\">Processing, please wait...</div><div role=\"alert\" ng-show=\"file.Success\">Upload Complete!</div></div><div class=\"alert alert-danger\" role=\"alert\" ng-show=\"errorMsg.length > 0\">Oooops we had trouble uploading the file. Please refresh the page and try again.<p>If the problem persits please supply us with the following details</p><p>{{errorMsg}}</p></div><div>{{Error}}</div></div></form></div><div class=\"col-md-6\"></div></div><form name=\"profile\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"firstName\" class=\"col-sm-3 control-label\">First Name</label><div class=\"col-sm-9\" ng-class=\"{\'has-error\': profile.firstName.$invalid && (profile.firstName.$dirty || profile.firstName.$touched)}\"><input type=\"text\" class=\"form-control\" id=\"firstName\" name=\"firstName\" placeholder=\"\" ng-model=\"data.firstname\" required=\"\"> <span class=\"help-block error-block basic-block\">Required</span></div></div><div class=\"form-group row clearfix\"><label for=\"fullName\" class=\"col-sm-3 control-label\">Full Name</label><div class=\"col-sm-9\" ng-class=\"{\'has-error\': profile.fullName.$invalid && (profile.fullName.$dirty || profile.fullName.$touched) }\"><input type=\"text\" class=\"form-control\" id=\"fullName\" name=\"fullName\" placeholder=\"\" ng-model=\"data.fullname\" required=\"\"> <span class=\"help-block error-block basic-block\">Required</span></div></div><div class=\"form-group row clearfix\"><label for=\"gender\" class=\"col-sm-3 control-label\">Gender</label><div class=\"col-sm-9\" ng-class=\"{\'has-error\': profile.fullName.$invalid && (profile.fullName.$dirty || profile.fullName.$touched) }\"><label for=\"fullName\" class=\"col-sm-3 control-label\">{{data.gender}}</label></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputFirstName\" class=\"col-sm-3 control-label\">Last Name</label><div class=\"col-sm-9\" ng-class=\"{\'has-error\': profile.lastName.$invalid && (profile.lastName.$dirty || profile.lastName.$touched) }\"><input type=\"text\" class=\"form-control\" id=\"lastName\" name=\"lastName\" placeholder=\"\" ng-model=\"data.lastname\" required=\"\"> <span class=\"help-block error-block basic-block\">Required</span></div></div><div class=\"form-group row clearfix\"><label for=\"inputLastName\" class=\"col-sm-3 control-label\">NIC Number</label><div class=\"col-sm-9\" ng-class=\"{\'has-error\': profile.nic.$invalid && (profile.nic.$dirty || profile.nic.$touched)}\"><input type=\"text\" class=\"form-control\" id=\"nic\" name=\"nic\" placeholder=\"\" ng-model=\"data.nic\" required=\"\"> <span class=\"help-block error-block basic-block\">Required</span></div></div></div></div><h3 class=\"with-line\">Contact Information</h3><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputEmail3\" class=\"col-sm-3 control-label\">Email</label><div class=\"col-sm-9\" ng-class=\"{\'has-error\': profile.inputEmail.$invalid && (profile.inputEmail.$dirty || profile.inputEmail.$touched)}\"><input type=\"email\" class=\"form-control\" id=\"inputEmail\" placeholder=\"\" name=\"inputEmail\" value=\"email@gmail.com\" ng-model=\"data.email\" required=\"\"> <span class=\"help-block error-block basic-block\">Required</span></div></div><div class=\"form-group row clearfix\"><label for=\"inputPhone\" class=\"col-sm-3 control-label\">Mobile</label><div class=\"col-sm-9\" ng-class=\"{\'has-error\': profile.inputPhone.$invalid && (profile.inputPhone.$dirty || profile.inputPhone.$touched)}\"><input type=\"number\" max=\"9999999999\" class=\"form-control\" id=\"inputPhone\" placeholder=\"\" name=\"inputPhone\" value=\"\" ng-model=\"data.mobile\" required=\"\"> <span class=\"help-block error-block basic-block\">Required</span></div></div></div><div class=\"col-md-6\"><div class=\"form-group row clearfix\"><label for=\"inputLastName\" class=\"col-sm-3 control-label\">Address</label><div class=\"col-sm-9\" ng-class=\"{\'has-error\': profile.address.$invalid && (profile.address.$dirty || profile.address.$touched)}\"><input type=\"text\" class=\"form-control\" id=\"address\" name=\"address\" placeholder=\"\" value=\"\" ng-model=\"data.address\" required=\"\"> <span class=\"help-block error-block basic-block\">Required</span></div></div><div class=\"form-group row clearfix\"><label for=\"inputRoom\" class=\"col-sm-3 control-label\">Tel No</label><div class=\"col-sm-9\" ng-class=\"{\'has-error\': profile.tel.$invalid && (profile.tel.$dirty || profile.tel.$touched)}\"><input type=\"number\" max=\"9999999999\" class=\"form-control\" id=\"tel\" name=\"tel\" placeholder=\"\" value=\"\" ng-model=\"data.tel\" required=\"\"> <span class=\"help-block error-block basic-block\">Required</span></div></div></div></div></form><h3 class=\"with-line\">Social Profiles</h3><div class=\"social-profiles row clearfix\"><div class=\"col-md-3 col-sm-4\" ng-repeat=\"item in socialProfiles\"><a class=\"sn-link\" href=\"\" ng-click=\"showModal(item)\" ng-if=\"!item.href\"><i class=\"socicon {{ item.icon }}\"></i> <span>{{ item.name }}</span></a> <a class=\"sn-link connected\" href=\"{{ item.href }}\" target=\"_blank\" ng-if=\"item.href\"><i class=\"socicon {{ item.icon }}\"></i> <span>{{ item.name }}</span> <em class=\"ion-ios-close-empty sn-link-close\" ng-mousedown=\"unconnect(item)\"></em></a></div></div><h3 class=\"with-line\">Future Mission and Goals</h3><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group row clearfix\"><label for=\"goals\" class=\"col-sm-2 control-label\">state your goals:</label><div class=\"col-sm-10\"><textarea class=\"form-control\" id=\"goals\" ng-model=\"data.goals\" value=\"goals\">briefly state your goals and expectation form the internship............\r\n              </textarea></div></div></div></div><div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Familier Technoloiges\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/profile/partials/techs.html\"></div></div></div></div></div></div><button type=\"button\" ng-click=\"update()\" class=\"btn btn-primary btn-with-icon save-profile\"><i class=\"ion-android-checkmark-circle\"></i>update profile</button></div>");
$templateCache.put("app/pages/sides/sides.html","<main ng-if=\"$pageFinishedLoading\" ng-class=\"{ \'menu-collapsed\': $baSidebarService.isMenuCollapsed() }\"><page-top></page-top><ba-sidebar></ba-sidebar><div class=\"al-main\"><div class=\"al-content\"><content-top></content-top><div ui-view=\"\"></div></div></div><back-top></back-top><fondo></fondo></main><div id=\"preloader\" ng-show=\"!$pageFinishedLoading\"><div></div></div>");
$templateCache.put("app/pages/signin/confirm.html","<main class=\"auth-main\" style=\"padding-top:150px;\"><div class=\"auth-block\"><h1>Confirm Email</h1><form class=\"form-horizontal\"><div class=\"form-group\"><label for=\"email\" class=\"col-sm-2 control-label\">email</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"email\" ng-model=\"username\" placeholder=\"email\" required=\"\"></div></div><div class=\"form-group\"><label for=\"email\" class=\"col-sm-2 control-label\">Confirmation</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"code\" ng-model=\"code\" placeholder=\"Confirmation Code\" required=\"\"></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-10\"><button type=\"submit\" ng-click=\"confirm()\" class=\"btn btn-default btn-auth\">Confirm</button></div></div></form></div></main>");
$templateCache.put("app/pages/signin/forgotpwd.html","<main class=\"auth-main\" style=\"padding-top:150px;\"><div class=\"auth-block\"><h1>Forgot Password</h1><form class=\"form-horizontal\"><div class=\"form-group\"><label for=\"email\" class=\"col-sm-2 control-label\">email</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"email\" ng-model=\"username\" placeholder=\"email\" required=\"\"></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-10\"><button type=\"submit\" ng-click=\"forgot()\" class=\"btn btn-default btn-auth\">Send</button></div></div></form></div></main>");
$templateCache.put("app/pages/signin/signin.html","<canvas-login></canvas-login>");
$templateCache.put("app/theme/components/baSidebar/ba-sidebar.html","<aside class=\"al-sidebar\" ng-swipe-right=\"$baSidebarService.setMenuCollapsed(false)\" ng-swipe-left=\"$baSidebarService.setMenuCollapsed(true)\" ng-mouseleave=\"hoverElemTop=selectElemTop\"><ul class=\"al-sidebar-list\" slimscroll=\"{height: \'{{menuHeight}}px\'}\" slimscroll-watch=\"menuHeight\"><li ng-repeat=\"item in ::menuItems\" class=\"al-sidebar-list-item\" ng-class=\"::{\'with-sub-menu\': item.subMenu}\" ui-sref-active=\"selected\" ba-sidebar-toggling-item=\"item\"><a has-permission=\"\" namestate=\"item.stateRef\" ng-mouseenter=\"hoverItem($event, item)\" ui-state=\"item.stateRef || \'\'\" ng-href=\"{{::(item.fixedHref ? item.fixedHref: \'\')}}\" ng-if=\"::!item.subMenu\" class=\"al-sidebar-list-link\"><i class=\"{{ ::item.icon }}\"></i><span>{{ ::item.title }}</span></a> <a has-permission=\"\" namestate=\"item.stateRef\" ng-mouseenter=\"hoverItem($event, item)\" ng-if=\"::item.subMenu\" class=\"al-sidebar-list-link\" ba-ui-sref-toggler=\"\"><i class=\"{{ ::item.icon }}\"></i><span>{{ ::item.title }}</span> <b class=\"fa fa-angle-down\" ui-sref-active=\"fa-angle-up\" ng-if=\"::item.subMenu\"></b></a><ul ng-if=\"::item.subMenu\" class=\"al-sidebar-sublist\" ng-class=\"{\'slide-right\': item.slideRight}\" ba-ui-sref-toggling-submenu=\"\"><li ng-repeat=\"subitem in ::item.subMenu\" ng-class=\"::{\'with-sub-menu\': subitem.subMenu}\" ui-sref-active=\"selected\" ba-sidebar-toggling-item=\"subitem\" class=\"ba-sidebar-sublist-item\"><a ng-mouseenter=\"hoverItem($event, item)\" ng-if=\"::subitem.subMenu\" ba-ui-sref-toggler=\"\" class=\"al-sidebar-list-link subitem-submenu-link\"><span>{{ ::subitem.title }}</span> <b class=\"fa\" ng-class=\"{\'fa-angle-up\': subitem.expanded, \'fa-angle-down\': !subitem.expanded}\" ng-if=\"::subitem.subMenu\"></b></a><ul ng-if=\"::subitem.subMenu\" class=\"al-sidebar-sublist subitem-submenu-list\" ng-class=\"{expanded: subitem.expanded, \'slide-right\': subitem.slideRight}\" ba-ui-sref-toggling-submenu=\"\"><li ng-mouseenter=\"hoverItem($event, item)\" ng-repeat=\"subSubitem in ::subitem.subMenu\" ui-sref-active=\"selected\"><a ng-mouseenter=\"hoverItem($event, item)\" href=\"\" ng-if=\"::subSubitem.disabled\" class=\"al-sidebar-list-link\">{{ ::subSubitem.title }}</a> <a ng-mouseenter=\"hoverItem($event, item)\" ui-state=\"subSubitem.stateRef || \'\'\" ng-if=\"::!subSubitem.disabled\" ng-href=\"{{::(subSubitem.fixedHref ? subSubitem.fixedHref: \'\')}}\">{{::subSubitem.title }}</a></li></ul><a ng-mouseenter=\"hoverItem($event, item)\" href=\"\" ng-if=\"::(!subitem.subMenu && subitem.disabled)\" class=\"al-sidebar-list-link\">{{ ::subitem.title }}</a> <a has-permission=\"\" namestate=\"subitem.stateRef\" ng-mouseenter=\"hoverItem($event, item)\" target=\"{{::(subitem.blank ? \'_blank\' : \'_self\')}}\" ng-if=\"::(!subitem.subMenu && !subitem.disabled)\" ui-state=\"subitem.stateRef || \'\'\" ng-href=\"{{::(subitem.fixedHref ? subitem.fixedHref: \'\')}}\">{{ ::subitem.title}}</a></li></ul></li></ul><div class=\"sidebar-hover-elem\" ng-style=\"{top: hoverElemTop + \'px\', height: hoverElemHeight + \'px\'}\" ng-class=\"{\'show-hover-elem\': showHoverElem }\"></div></aside>");
$templateCache.put("app/theme/components/baWizard/baWizard.html","<div class=\"ba-wizard\"><div class=\"ba-wizard-navigation-container\"><div ng-repeat=\"t in $baWizardController.tabs\" class=\"ba-wizard-navigation {{$baWizardController.tabNum == $index ? \'active\' : \'\'}}\" ng-click=\"$baWizardController.selectTab($index)\">{{t.title}}</div></div><div class=\"progress ba-wizard-progress\"><div class=\"progress-bar progress-bar-danger active\" role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\" ng-style=\"{width: $baWizardController.progress + \'%\'}\"></div></div><div class=\"steps\" ng-transclude=\"\"></div></div>");
$templateCache.put("app/theme/components/baWizard/baWizardStep.html","<section ng-show=\"selected\" class=\"step\" ng-transclude=\"\"></section>");
$templateCache.put("app/theme/components/backTop/backTop.html","<i class=\"fa fa-angle-up back-top\" id=\"backTop\" title=\"Back to Top\"></i>");
$templateCache.put("app/theme/components/canvas/canvas.html","<fondo></fondo><br><br><div class=\"sub-main-w3\"><form name=\"formLogin\" id=\"formLogin\" ng-submit=\"signIn()\" novalidate=\"\"><h2 style=\"text-align: center;\">Ingrese Ahora <i class=\"fas fa-level-down-alt\"></i></h2><div class=\"form-style-agile\"><label><i class=\"fas fa-user\"></i> Usuario</label> <input type=\"text\" placeholder=\"Ingrese el Usuario\" class=\"form-control\" id=\"username\" name=\"username\" ng-model=\"data.username\" ng-required=\"true\" autocomplete=\"off\"></div><div class=\"form-style-agile\"><label><i class=\"fas fa-unlock-alt\"></i> Password</label> <input type=\"password\" placeholder=\"Password\" class=\"form-control\" id=\"clave\" name=\"clave\" ng-model=\"data.clave\"></div><input type=\"submit\" class=\"btn btn-default btn-auth\" value=\"Ingresar\" ng-disabled=\"formLogin.$invalid\"></form></div><div class=\"footer\"><p>&copy; Derechos Reservados 2020 | por IAMH S.A.C.</p></div>");
$templateCache.put("app/theme/components/contentTop/contentTop.html","<div class=\"content-top clearfix\"><h1 class=\"al-title\">{{ activePageTitle }}</h1><ul class=\"breadcrumb al-breadcrumb\"><li><a href=\"#/dashboard\">Home</a></li><li>{{ activePageTitle }}</li></ul></div>");
$templateCache.put("app/theme/components/fondo/fondo.html","");
$templateCache.put("app/theme/components/msgCenter/msgCenter.html","<ul class=\"al-msg-center clearfix\"><li uib-dropdown=\"\"><a href=\"\" uib-dropdown-toggle=\"\"><i class=\"fa fa-bell-o\"></i><span>5</span><div class=\"notification-ring\"></div></a><div uib-dropdown-menu=\"\" class=\"top-dropdown-menu\"><i class=\"dropdown-arr\"></i><div class=\"header clearfix\"><strong>Notifications</strong> <a href=\"\">Mark All as Read</a> <a href=\"\">Settings</a></div><div class=\"msg-list\"><a href=\"\" class=\"clearfix\" ng-repeat=\"msg in notifications\"><div class=\"img-area\"><img ng-class=\"{\'photo-msg-item\' : !msg.image}\" ng-src=\"{{::( msg.image || (users[msg.userId].name | profilePicture) )}}\"></div><div class=\"msg-area\"><div ng-bind-html=\"getMessage(msg)\"></div><span>{{ msg.time }}</span></div></a></div><a href=\"\">See all notifications</a></div></li><li uib-dropdown=\"\"><a href=\"\" class=\"msg\" uib-dropdown-toggle=\"\"><i class=\"fa fa-envelope-o\"></i><span>5</span><div class=\"notification-ring\"></div></a><div uib-dropdown-menu=\"\" class=\"top-dropdown-menu\"><i class=\"dropdown-arr\"></i><div class=\"header clearfix\"><strong>Messages</strong> <a href=\"\">Mark All as Read</a> <a href=\"\">Settings</a></div><div class=\"msg-list\"><a href=\"\" class=\"clearfix\" ng-repeat=\"msg in messages\"><div class=\"img-area\"><img class=\"photo-msg-item\" ng-src=\"{{::( users[msg.userId].name | profilePicture )}}\"></div><div class=\"msg-area\"><div>{{ msg.text }}</div><span>{{ msg.time }}</span></div></a></div><a href=\"\">See all messages</a></div></li></ul>");
$templateCache.put("app/theme/components/pageTop/pageTop.html","<div class=\"page-top clearfix\" scroll-position=\"scrolled\" max-height=\"50\" ng-class=\"{\'scrolled\': scrolled}\"><a href=\"#/dashboard/home\" class=\"al-logo clearfix\"><a href=\"#/dashboard/home\" class=\"al-logo clearfix\"><span>BABY</span>GASH</a> <a href=\"\" class=\"collapse-menu-link ion-navicon\" ba-sidebar-toggle-menu=\"\"></a><div class=\"user-profile clearfix\"><div class=\"al-user-profile\" uib-dropdown=\"\"><a uib-dropdown-toggle=\"\" class=\"profile-toggle-link\"><img ng-src=\"{{::( \'Nasta\' | profilePicture )}}\"></a><ul class=\"top-dropdown-menu profile-dropdown\" uib-dropdown-menu=\"\"><li><i class=\"dropdown-arr\"></i></li><li><a permission=\"\" permission-only=\"[\'SUPERVISOR\', \'SUPERUSUARIO\', \'ADMIN\']\" ui-sref=\"dashboard.configuracion.fiscal()\"><i class=\"fa fa-cog\"></i>CONFIGURACIONES</a></li><li><a ng-click=\"signOut()\" class=\"signout\"><i class=\"fa fa-power-off\"></i>SALIR</a></li></ul></div><div style=\"padding-top:15px; float:right;\">{{username}}</div></div></a></div>");
$templateCache.put("app/theme/components/progressBarRound/progressBarRound.html","<svg class=\"center-block progress-bar-round\" width=\"200\" height=\"200\"><circle cx=\"100\" cy=\"100\" r=\"90\" fill=\"none\" stroke=\"#F8F8FF\" stroke-width=\"8\"></circle><circle cx=\"100\" cy=\"100\" r=\"90\" fill=\"none\" id=\"loader\" class=\"\" stroke=\"#209e91\" stroke-width=\"8\" stroke-dasharray=\"0,20000\" transform=\"rotate(-90,100,100)\" stroke-linecap=\"round\"></circle><text text-anchor=\"middle\" class=\"loading\" x=\"100\" y=\"90\">Loading...</text><text class=\"percentage\" text-anchor=\"middle\" x=\"100\" y=\"130\">{{progress}}%</text></svg>");
$templateCache.put("app/theme/components/widgets/widgets.html","<div class=\"widgets\"><div ng-repeat=\"widgetBlock in ngModel\" ng-class=\"{\'row\': widgetBlock.widgets.length > 1}\"><div ng-repeat=\"widgetCol in widgetBlock.widgets\" ng-class=\"{\'col-md-6\': widgetBlock.widgets.length === 2}\" ng-model=\"widgetCol\" class=\"widgets-block\"><div ba-panel=\"\" ba-panel-title=\"{{::widget.title}}\" ng-repeat=\"widget in widgetCol\" ba-panel-class=\"with-scroll {{widget.panelClass}}\"><div ng-include=\"widget.url\"></div></div></div></div></div>");
$templateCache.put("app/theme/inputs/baSwitcher/baSwitcher.html","<label class=\"switcher-container\"><input type=\"checkbox\" ng-model=\"switcherValue\"><div class=\"switcher\" ng-class=\"::switcherStyle\"><div class=\"handle-container\"><span class=\"handle handle-on\">Si</span> <span class=\"handle\"></span> <span class=\"handle handle-off\">No</span></div></div></label>");
$templateCache.put("app/pages/almacen/almacenes/almacenes.html","<div class=\"widgets\" ng-init=\"consultar()\"><div class=\"row\"><div class=\"col-md-5\" ba-panel=\"\" ba-panel-title=\"Registro de Almacen\" ba-panel-class=\"with-scroll\"><form class=\"form-horizontal\" name=\"formAlmacen\" id=\"formAlmacen\" ng-submit=\"guardar(formAlmacen)\" novalidate=\"\"><div class=\"col-sm-9\"><input id=\"no_almacen\" ng-model=\"data.no_almacen\" class=\"input-sm form-control\" placeholder=\"Nombre Almacen\" type=\"text\"></div><div class=\"col-sm-3\" style=\"text-align: center;\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"formAlmacen.$invalid || formAlmacen.$pending\">GUARDAR</button></div></form></div><div class=\"col-md-7\" ba-panel=\"\" ba-panel-title=\"Lista de Almacenes\" ba-panel-class=\"with-scroll\"><div class=\"form-group\"><div class=\"col-sm-12\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:10%;\" class=\"table-id\">#</th><th style=\"width:70%;\">Nombre Almacen</th><th style=\"width:20%;\">&nbsp;</th></tr><tr><th></th><th><input st-search=\"no_almacen\" class=\"input-sm form-control\" placeholder=\"Busqueda Almacen ...\" type=\"search\"></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_almacen}}</td><td><div class=\"btn-group\" role=\"group\"><a class=\"btn btn-xs btn-success\" title=\"Editar\" ng-click=\"editar(item)\"><i class=\"ion-edit\"></i></a> <button class=\"btn btn-xs\" ng-class=\"(item.il_stado==\'1\')?\'btn-success\':\'btn-danger\'\" ng-click=\"changeStatus(item.id_almacen, item.il_stado, displayed.indexOf(item))\" title=\"Activar/inactivar\"><i class=\"fa\" ng-class=\"(item.il_stado==\'1\')?\'fa-check\':\'fa-ban\'\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"3\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/almacen/notaingreso/notaingreso.html","<div class=\"widgets\" ng-init=\"consultar()\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Registrar Nota de Ingreso / Salida\"><div class=\"row\"><div class=\"col-md-5\"><div class=\"form-group\"><label for=\"id_tipo_comprobante\" class=\"control-label\">Tipo de Comprobante:</label><ui-select ng-model=\"data.id_tipo_comprobante\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getCorrelativo(data)\"><ui-select-match placeholder=\"Tipo Comprobante\">{{$select.selected.descripcion}}</ui-select-match><ui-select-choices repeat=\"comprobante in jComprobante | filter: $select.search\"><div ng-bind-html=\"comprobante.descripcion | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"id_tipo_comprobante\" class=\"control-label\">Nº Nota de Ingreso:</label><h4 style=\"text-align: center;\">{{data.nu_serie}}{{\'-\'}}{{data.nu_correlativo}}</h4></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" for=\"fe_ingreso\">Fecha Nota Ingreso</label><div class=\"input-group\" moment-picker=\"data.fe_ingreso\" locales=\"es\" start-view=\"month\" format=\"YYYY-MM-DD\"><input class=\"form-control\" id=\"fe_ingreso\" name=\"fe_ingreso\" placeholder=\"Seleccione Una Fecha\" ng-model=\"data.fe_ingreso\" ng-model-options=\"{ updateOn: \'blur\'}\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"id_almacen_origen\" class=\"control-label\">Almacen Origen:</label><ui-select ng-model=\"data.id_almacen_origen\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getAlmacenOrden(data)\"><ui-select-match placeholder=\"Almacen Origen\">{{$select.selected.no_almacen}}</ui-select-match><ui-select-choices repeat=\"origen in jAlmacenOrigen | filter: $select.search\"><div ng-bind-html=\"origen.no_almacen | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"id_almacen_destino\" class=\"control-label\">Almacen Destino:</label><ui-select ng-model=\"data.id_almacen_destino\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Almacen Destino\">{{$select.selected.no_almacen}}</ui-select-match><ui-select-choices repeat=\"destino in jAlmacenDestino | filter: $select.search\"><div ng-bind-html=\"destino.no_almacen | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"id_nota_ingreso\" class=\"control-label\">Ordenes de Compra Almacen:</label><div class=\"input-group\"><ui-select ng-model=\"data.id_nota_ingreso\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Orden de Compra\">{{$select.selected.nu_orden_compra}}</ui-select-match><ui-select-choices repeat=\"almacen in jAlmacenOrdenAlmacen | filter: $select.search\"><div ng-bind-html=\"almacen.nu_orden_compra | highlight: $select.search\"></div></ui-select-choices></ui-select><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"addItem()\" ng-disabled=\"formONota.va_precio_producto.$invalid || formONota.nu_cantidad.$invalid\"><i class=\"fa fa-plus\"></i></button></span></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"no_motivo\" class=\"control-label\">Motivo:</label> <input type=\"text\" class=\"form-control\" id=\"no_motivo\" name=\"no_motivo\" placeholder=\"Escriba aqui su motivo\" ng-model=\"data.no_motivo\" style=\"text-transform:uppercase\"></div></div></div><div class=\"row\"><table class=\"table table-striped\" st-table=\"editableTableData\"><thead><tr class=\"sortable\"><th style=\"width:10%; text-align:center;\">Item</th><th style=\"width:10%; text-align:center;\">Orden C.</th><th style=\"width:10%; text-align:center;\">Código</th><th style=\"width:35%; text-align:center;\">Producto</th><th style=\"width:10%; text-align:center;\">Cantidad</th><th style=\"width:5%; text-align:center;\">&nbsp;</th></tr></thead><tbody><tr class=\"editable-tr-wrap\" ng-repeat=\"item in rowCollection\"><td style=\"text-align:center;\">{{item.id}}</td><td style=\"text-align:center;\">{{item.nu_serie}} - {{item.nu_correlativo}}</td><td style=\"text-align:center;\">{{item.co_producto}}</td><td style=\"text-align:left;\">{{item.no_producto}}</td><td style=\"text-align:center;\"><span editable-text=\"item.nu_cantidad\" blur=\"cancel\">{{item.nu_cantidad}}</span></td><td style=\"text-align:center;\"><button type=\"button\" class=\"btn btn-xs btn-danger\" ng-click=\"quitar_producto(item.id, displayed.indexOf(item))\" title=\"Quitar\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody><tfoot><tr><td colspan=\"6\" style=\"text-align:right\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"rowCollection.length==0\" ng-click=\"guardar()\"><i class=\"fa fa-print\"></i> Registrar</button> &nbsp;&nbsp;&nbsp; <a class=\"btn btn-default\" ui-sref=\"dashboard.almacen.notaingreso()\"><i class=\"fa fa-list-alt\"></i> Listado</a></td></tr></tfoot></table></div></div></div></div>");
$templateCache.put("app/pages/almacen/notasalida/notasalida.html","");
$templateCache.put("app/pages/catalogo/atributo/atributo.html","<div class=\"row\"><div class=\"col-md-6\"><div class=\"panel panel-blur with-scroll animated zoomIn\" zoom-in=\"\" ba-panel-blur=\"\"><div class=\"panel-heading clearfix\"><h3 class=\"panel-title\">Tabla Atributos</h3></div><div class=\"horizontal-scroll\"><br><table class=\"table table-hover\" st-safe-src=\"catributo\" st-table=\"editableTableArea\"><tr class=\"sortable header-row\"><th style=\"width:10%\" class=\"table-id\" st-sort=\"id\">#</th><th colspan=\"2\" style=\"width:90%\">Atributo</th></tr><tr ng-repeat=\"(key, item) in editableTableArea\" class=\"editable-tr-wrap\"><td style=\"width:10%\" class=\"table-id\">{{item.id_atributo}}</td><td colspan=\"2\" style=\"width:90%\"><span onbeforesave=\"GuardarAtributo($data,item)\" editable-text=\"item.no_atributo\" blur=\"cancel\">{{(item.no_atributo==null)?\'\':item.no_atributo }}</span></td></tr><tfoot><tr><td><div><td><button type=\"button\" class=\"btn btn-info\" data-toggle=\"modal\" ng-click=\"openAtributo(\'md\')\">Agregar<span aria-hidden=\"true\">&rarr;</span></button></td></div></td><td class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"15\"></div></td></tr></tfoot></table></div></div></div><div class=\"col-md-6\"><div class=\"panel panel-blur with-scroll animated zoomIn\" zoom-in=\"\" ba-panel-blur=\"\"><div class=\"panel-heading clearfix\"><h3 class=\"panel-title\">Tabla Sub Atributos</h3></div><div class=\"horizontal-scroll\"><br><table class=\"table table-hover\" st-safe-src=\"csubatributo\" st-table=\"editableTableCargo\"><tr class=\"sortable header-row\"><th style=\"width:10%\" class=\"table-id\" st-sort=\"id\">#</th><th style=\"width:50%\">Sub Atributo</th><th style=\"width:40%\">Atributo</th></tr><tr ng-repeat=\"(key, item) in editableTableCargo\" class=\"editable-tr-wrap\"><td style=\"width:10%\" class=\"table-id\">{{item.id_atributo}}</td><td style=\"width:50%\"><span onbeforesave=\"guardarSubAtributo($data, item)\" editable-text=\"item.no_sub_atributo\" blur=\"cancel\">{{(item.no_sub_atributo==null)?\'\':item.no_sub_atributo }}</span></td><td style=\"width:40%\">{{(item.no_atributo==null)?\'Vacio\':item.no_atributo }}</td></tr><tfoot><tr><td><div><td><button type=\"button\" class=\"btn btn-info\" data-toggle=\"modal\" ng-click=\"openSubAtributo(\'md\')\">Agregar<span aria-hidden=\"true\">&rarr;</span></button></td></div></td><td class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"15\"></div></td></tr></tfoot></table></div></div></div></div>");
$templateCache.put("app/pages/catalogo/categoria/categoria.html","<div class=\"widgets\" ng-init=\"consultar()\"><div class=\"row\"><div class=\"col-md-5\" ba-panel=\"\" ba-panel-title=\"Registro de Categoria Producto\" ba-panel-class=\"with-scroll\"><form class=\"form-horizontal\" name=\"formCategoriaProducto\" id=\"formCategoriaProducto\" ng-submit=\"guardar(formCategoriaProducto)\" novalidate=\"\"><div class=\"col-sm-9\"><input id=\"no_categoria\" ng-model=\"data.no_categoria\" class=\"input-sm form-control\" placeholder=\"Nombre Categoria\" type=\"text\"></div><div class=\"col-sm-3\" style=\"text-align: center;\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"formCategoriaProducto.$invalid || formCategoriaProducto.$pending\">GUARDAR</button></div></form></div><div class=\"col-md-7\" ba-panel=\"\" ba-panel-title=\"Lista de Categoria Producto\" ba-panel-class=\"with-scroll\"><div class=\"form-group\"><div class=\"col-sm-12\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:4%;\" class=\"table-id\">#</th><th style=\"width:6%;\">Nombre Categoria</th><th style=\"width:10%;\">&nbsp;</th></tr><tr><th></th><th><input st-search=\"no_categoria_insumo\" class=\"input-sm form-control\" placeholder=\"Busqueda Categoria ...\" type=\"search\"></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_categoria}}</td><td><div class=\"btn-group\" role=\"group\"><a class=\"btn btn-xs btn-success\" title=\"Editar\" ng-click=\"editar(item)\"><i class=\"ion-edit\"></i></a> <button class=\"btn btn-xs\" ng-class=\"(item.status==\'1\')?\'btn-success\':\'btn-danger\'\" ng-click=\"changeStatus(item.id_categoria, item.status, displayed.indexOf(item))\" title=\"Activar/inactivar\"><i class=\"fa\" ng-class=\"(item.status==\'1\')?\'fa-check\':\'fa-ban\'\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"3\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/catalogo/cuponera/cuponera.html","<div class=\"row\"><div class=\"col-md-6\"><div class=\"panel panel-blur with-scroll animated zoomIn\" zoom-in=\"\" ba-panel-blur=\"\"><div class=\"panel-heading clearfix\"><h3 class=\"panel-title\">Tabla Cupones</h3></div><div class=\"horizontal-scroll\"><br><table class=\"table table-hover\" st-safe-src=\"displayed\" st-table=\"editableTableArea\"><tr class=\"sortable header-row\"><th style=\"width:10%\" class=\"table-id\" st-sort=\"id\">#</th><th style=\"width:40%\">Responsable</th><th style=\"width:20%\">Cupon</th><th style=\"width:30%\">Comisión</th></tr><tr ng-repeat=\"(key, item) in editableTableArea\" class=\"editable-tr-wrap\"><td class=\"table-id\">{{item.id_cupon}}</td><td><span onbeforesave=\"GuardarCupones($data,item)\" editable-text=\"item.no_resp_cupon\" blur=\"cancel\">{{(item.no_resp_cupon==null)?\'\':item.no_resp_cupon }}</span></td><td><span onbeforesave=\"GuardarCupones($data,item)\" editable-text=\"item.co_cupon\" blur=\"cancel\">{{(item.co_cupon==null)?\'\':item.co_cupon}}</span></td><td><span onbeforesave=\"GuardarCupones($data,item)\" editable-text=\"item.va_comision\" blur=\"cancel\">{{(item.va_comision==null)?\'\':item.va_comision}}</span></td></tr><tfoot><tr><td><div><button type=\"button\" class=\"btn btn-info\" data-toggle=\"modal\" ng-click=\"openCupones(\'md\')\">Agregar<span aria-hidden=\"true\">&rarr;</span></button></div></td><td colspan=\"3\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"15\"></div></td></tr></tfoot></table></div></div></div><div class=\"col-md-6\"><div class=\"panel panel-blur with-scroll animated zoomIn\" zoom-in=\"\" ba-panel-blur=\"\"><div class=\"panel-heading clearfix\"><h3 class=\"panel-title\">Tabla Codigo Descuento</h3></div><div class=\"horizontal-scroll\"><br><table class=\"table table-hover\" st-safe-src=\"displayed2\" st-table=\"editableTableCargo\"><tr class=\"sortable header-row\"><th style=\"width:10%\" class=\"table-id\" st-sort=\"id\">#</th><th style=\"width:50%\">Codigo Cupon</th><th style=\"width:40%\">Descuento</th></tr><tr ng-repeat=\"(key, item) in editableTableCargo\" class=\"editable-tr-wrap\"><td style=\"width:10%\" class=\"table-id\">{{item.id_Cupones_descuento}}</td><td style=\"width:40%\">{{(item.co_cupon==null)?\'\':item.co_cupon }}</td><td style=\"width:50%\"><span onbeforesave=\"GuardarDescuento($data, item)\" editable-text=\"item.va_descuento\" blur=\"cancel\">{{(item.va_descuento==null)?\'\':item.va_descuento }}%</span></td></tr><tfoot><tr><td><div><td><button type=\"button\" class=\"btn btn-info\" data-toggle=\"modal\" ng-click=\"openDescuento(\'md\')\">Agregar<span aria-hidden=\"true\">&rarr;</span></button></td></div></td><td class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"15\"></div></td></tr></tfoot></table></div></div></div></div>");
$templateCache.put("app/pages/catalogo/descuento/descuento.html","<div class=\"row\"><div class=\"col-md-12\"><div class=\"panel panel-blur with-scroll animated zoomIn\" zoom-in=\"\" ba-panel-blur=\"\"><div class=\"panel-heading clearfix\"><h3 class=\"panel-title\">Tabla Cliente Descuento</h3></div><div class=\"horizontal-scroll\"><br><table class=\"table table-hover\" st-safe-src=\"displayed\" st-table=\"editableTableCargo\"><tr class=\"sortable header-row\"><th style=\"width:10%\" class=\"table-id\" st-sort=\"id\">#</th><th style=\"width:50%\">Cliente</th><th style=\"width:40%\">Descuento</th></tr><tr ng-repeat=\"(key, item) in editableTableCargo\" class=\"editable-tr-wrap\"><td style=\"width:10%\" class=\"table-id\">{{item.id_cliente_descuento}}</td><td style=\"width:40%\">{{(item.no_cliente==null)?\'\':item.no_cliente }}</td><td style=\"width:50%\"><span onbeforesave=\"GuardarClienteDescuento($data, item)\" editable-text=\"item.pr_descuento\" blur=\"cancel\">{{(item.pr_descuento==null)?\'\':item.pr_descuento }}%</span></td></tr><tfoot><tr><td><div><td><button type=\"button\" class=\"btn btn-info\" data-toggle=\"modal\" ng-click=\"openDescuento(\'md\')\">Agregar<span aria-hidden=\"true\">&rarr;</span></button></td></div></td><td class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"15\"></div></td></tr></tfoot></table></div></div></div></div>");
$templateCache.put("app/pages/catalogo/empleado/empleado.html","<div class=\"widgets\" ng-init=\"consultar()\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Empleado\" ba-panel-class=\"with-scroll\"><form class=\"form-horizontal\" name=\"formEmple\" id=\"formEmple\" ng-submit=\"guardar(formEmple)\" novalidate=\"\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formEmple.nu_documento.$invalid && (formEmple.nu_documento.$dirty || formEmple.nu_documento.$submitted)}\"><label for=\"nu_documento\" class=\"col-sm-2 control-label\">Tipo de Documento:</label><div class=\"col-sm-4\"><ui-select ng-model=\"data.id_tipo_documento\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Doc. Identid.\">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat=\"docidenti in jDocumentos | filter: $select.search\"><div ng-bind-html=\"docidenti.nombre | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"col-sm-6\"><input type=\"text\" class=\"form-control\" id=\"nu_documento\" name=\"nu_documento\" placeholder=\"Nº Documento\" ng-model=\"data.nu_documento\" ng-required=\"true\" doc-exist=\"\" style=\"text-transform:uppercase\" ng-disabled=\"formEmple.id_tipo_documento.$invalid\" autocomplete=\"off\" ng-keypress=\"getDatosReniec($event)\"> <span class=\"help-block error-block basic-block\" ng-if=\"formEmple.nu_documento.$error\"><p ng-repeat=\"(key, value) in formEmple.nu_documento.$error\">{{messages.nu_documento[key]}}</p></span></div></div><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formEmple.no_nombres.$invalid && (formEmple.no_nombres.$dirty || formEmple.no_nombres.$submitted)}\"><label for=\"no_cliente\" class=\"col-sm-2 control-label\">Nombres y Apellidos:</label><div class=\"col-sm-4\"><input type=\"text\" class=\"form-control\" id=\"no_nombres\" name=\"no_nombres\" placeholder=\"Nombre\" ng-model=\"data.no_nombres\" ng-required=\"true\" style=\"text-transform:uppercase\" ng-disabled=\"formEmple.nu_documento.$invalid || formEmple.nu_documento.$pending\"></div><div class=\"col-sm-3\"><input type=\"text\" class=\"form-control\" id=\"no_apepat\" name=\"no_apepat\" placeholder=\"A. Paterno\" ng-model=\"data.no_apepat\" ng-required=\"true\" style=\"text-transform:uppercase\" ng-disabled=\"formEmple.nu_documento.$invalid || formEmple.nu_documento.$pending\"></div><div class=\"col-sm-3\"><input type=\"text\" class=\"form-control\" id=\"no_apemat\" name=\"no_apemat\" placeholder=\"A. Materno\" ng-model=\"data.no_apemat\" ng-required=\"true\" style=\"text-transform:uppercase\" ng-disabled=\"formEmple.nu_documento.$invalid || formEmple.nu_documento.$pending\"></div></div><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formEmple.no_nombres.$invalid && (formEmple.no_nombres.$dirty || formEmple.no_nombres.$submitted)}\"><label for=\"id_empresa\" class=\"col-sm-2 control-label\">Empresa:</label><div class=\"col-md-4\"><ui-select id=\"id_empresa\" ng-model=\"data.id_empresa\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\" ng-disabled=\"formEmple.nu_documento.$invalid || formEmple.nu_documento.$pending\" ng-change=\"getSucursal(data.id_empresa)\"><ui-select-match placeholder=\"Empresa\">{{$select.selected.no_empresa}}</ui-select-match><ui-select-choices repeat=\"empresa in jEmpresa | filter: $select.search\"><span ng-bind-html=\"empresa.no_empresa\"></span></ui-select-choices></ui-select></div><label for=\"id_local\" class=\"col-sm-2 control-label\">Sucursal:</label><div class=\"col-md-4\"><ui-select id=\"id_local\" ng-model=\"data.id_local\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\" ng-disabled=\"formEmple.nu_documento.$invalid || formEmple.nu_documento.$pending\"><ui-select-match placeholder=\"Sucursal\">{{$select.selected.no_local}}</ui-select-match><ui-select-choices repeat=\"local in jSucursal | filter: $select.search\"><span ng-bind-html=\"local.no_local\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formEmple.no_nombres.$invalid && (formEmple.no_nombres.$dirty || formEmple.no_nombres.$submitted)}\"><label for=\"id_sexo\" class=\"col-sm-2 control-label\">Tipo Sexo:</label><div class=\"col-md-4\"><ui-select id=\"id_sexo\" ng-model=\"data.id_sexo\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\" ng-disabled=\"formEmple.nu_documento.$invalid || formEmple.nu_documento.$pending\"><ui-select-match placeholder=\"Tipo Sexo\">{{$select.selected.no_sexo}}</ui-select-match><ui-select-choices repeat=\"sexo in cSexo | filter: $select.search\"><span ng-bind-html=\"sexo.no_sexo\"></span></ui-select-choices></ui-select></div><label for=\"id_estado_civil\" class=\"col-sm-2 control-label\">Estado Civil:</label><div class=\"col-md-4\"><ui-select id=\"id_estado_civil\" ng-model=\"data.id_estado_civil\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\" ng-disabled=\"formEmple.nu_documento.$invalid || formEmple.nu_documento.$pending\"><ui-select-match placeholder=\"Estado Civil\">{{$select.selected.no_estado_civil}}</ui-select-match><ui-select-choices repeat=\"estado in cEstadoCivil | filter: $select.search\"><span ng-bind-html=\"estado.no_estado_civil\"></span></ui-select-choices></ui-select></div></div></form></div></div></div>");
$templateCache.put("app/pages/catalogo/marca/marca.html","<div class=\"row\"><div class=\"col-md-6\"><div class=\"panel panel-blur with-scroll animated zoomIn\" zoom-in=\"\" ba-panel-blur=\"\"><div class=\"panel-heading clearfix\"><h3 class=\"panel-title\">Tabla Marca</h3></div><div class=\"horizontal-scroll\"><br><table class=\"table table-hover\" st-safe-src=\"displayed\" st-table=\"editableTableArea\"><tr class=\"sortable header-row\"><th style=\"width:10%\" class=\"table-id\" st-sort=\"id\">#</th><th colspan=\"2\" style=\"width:90%\">Marca</th></tr><tr ng-repeat=\"(key, item) in editableTableArea\" class=\"editable-tr-wrap\"><td style=\"width:10%\" class=\"table-id\">{{item.id_marca}}</td><td colspan=\"2\" style=\"width:90%\"><span onbeforesave=\"GuardarMarca($data,item)\" editable-text=\"item.no_marca\" blur=\"cancel\">{{(item.no_marca==null)?\'\':item.no_marca }}</span></td></tr><tfoot><tr><td><div><td><button type=\"button\" class=\"btn btn-info\" data-toggle=\"modal\" ng-click=\"openMarca(\'md\')\">Agregar<span aria-hidden=\"true\">&rarr;</span></button></td></div></td><td class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"15\"></div></td></tr></tfoot></table></div></div></div><div class=\"col-md-6\"><div class=\"panel panel-blur with-scroll animated zoomIn\" zoom-in=\"\" ba-panel-blur=\"\"><div class=\"panel-heading clearfix\"><h3 class=\"panel-title\">Tabla Descuentos</h3></div><div class=\"horizontal-scroll\"><br><table class=\"table table-hover\" st-safe-src=\"displayed2\" st-table=\"editableTableCargo\"><tr class=\"sortable header-row\"><th style=\"width:10%\" class=\"table-id\" st-sort=\"id\">#</th><th style=\"width:50%\">Marca</th><th style=\"width:40%\">Descuento</th></tr><tr ng-repeat=\"(key, item) in editableTableCargo\" class=\"editable-tr-wrap\"><td style=\"width:10%\" class=\"table-id\">{{item.id_marca_descuento}}</td><td style=\"width:40%\">{{(item.no_marca==null)?\'Vacio\':item.no_marca }}</td><td style=\"width:50%\"><span onbeforesave=\"GuardarDescuento($data, item)\" editable-text=\"item.pr_descuento\" blur=\"cancel\">{{(item.pr_descuento==null)?\'\':item.pr_descuento }}%</span></td></tr><tfoot><tr><td><div><td><button type=\"button\" class=\"btn btn-info\" data-toggle=\"modal\" ng-click=\"openDescuento(\'md\')\">Agregar<span aria-hidden=\"true\">&rarr;</span></button></td></div></td><td class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"15\"></div></td></tr></tfoot></table></div></div></div></div>");
$templateCache.put("app/pages/catalogo/producto/producto.html","<div class=\"widgets\" ng-init=\"consultar()\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Producto\" ba-panel-class=\"with-scroll\"><ba-wizard><ba-wizard-step title=\"General\" form=\"vm.formProducto\"><form name=\"vm.formProducto\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\" ng-class=\"{\'has-error\':vm.formProducto.id_marca.$invalid}\"><label class=\"control-label\">Marca:</label><ui-select name=\"id_marca\" id=\"id_marca\" ng-model=\"data.id_marca\" class=\"btn-group bootstrap-select form-control\" ng-required=\"true\"><ui-select-match placeholder=\"Marca\">{{$select.selected.no_marca}}</ui-select-match><ui-select-choices repeat=\"marca in jMarcas | filter: $select.search\"><div ng-bind-html=\"marca.no_marca | highlight: $select.search\"></div></ui-select-choices><ui-select-no-choice><strong>No existe!</strong> Si desea agregarlo <button type=\"button\" class=\"btn btn-link\" ng-click=\"openMarca(md)\">Click aquí</button>.</ui-select-no-choice></ui-select></div></div></div><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': vm.formProducto.co_barra.$invalid && (vm.formProducto.co_barra.$dirty || vm.formProducto.$submitted)}\"><label for=\"co_barra\">Código Barras:</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" name=\"co_barra\" id=\"co_barra\" placeholder=\"Codigo de Barras\" ng-model=\"data.co_barra\" ng-required=\"data.co_barra\" exist-codp=\"\" idprod=\"data.id_producto\"></div><span class=\"help-block error-block basic-block\" ng-if=\"formLaboratorio.co_producto.$error\"><p ng-repeat=\"(key, value) in formLaboratorio.co_barra.$error\">{{messages.co_producto[key]}}</p></span></div></div><div class=\"col-md-3\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': vm.formProducto.co_producto.$invalid && (vm.formProducto.co_producto.$dirty || vm.formProducto.$submitted)}\"><label for=\"co_producto\">Código:</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" name=\"co_producto\" id=\"co_producto\" placeholder=\"Automatico\" ng-model=\"data.co_producto\" ng-required=\"data.custom_code\" ng-disabled=\"!data.custom_code\" exist-codp=\"\" idprod=\"data.id_producto\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"editarCodigo()\" ng-disabled=\"vm.formProducto.co_barra.$invalid\"><i class=\"ion-edit\"></i></button></span></div><span class=\"help-block error-block basic-block\" ng-if=\"formLaboratorio.co_producto.$error\"><p ng-repeat=\"(key, value) in formLaboratorio.co_producto.$error\">{{messages.co_producto[key]}}</p></span></div></div><div class=\"col-md-6\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': vm.formProducto.no_producto.$invalid && (vm.formProducto.no_producto.$dirty || vm.formProducto.$submitted)}\"><label for=\"no_producto\">Nombre:</label> <input type=\"hidden\" name=\"id_producto\" id=\"id_producto\" ng-model=\"data.id_producto\"> <input type=\"text\" class=\"form-control\" id=\"no_producto\" name=\"no_producto\" placeholder=\"Nombre\" ng-model=\"data.no_producto\" ng-required=\"true\" exist-nomp=\"\" idprod=\"data.id_producto\" idmarca=\"data.id_marca\" uib-typeahead=\"product as product.no_descripcion for product in getProduct4Name($viewValue, vm.formProducto) | limitTo:8\" typeahead-template-url=\"customTemplate.html\" typeahead-focus-first=\"false\" typeahead-on-select=\"selected_item($item, $model, $label, $event)\" ng-disabled=\"vm.formProducto.id_marca.$invalid\" ng-minlength=\"4\" autocomplete=\"off\"></div></div></div><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"id_categoria\">Tipo Categoria</label><ui-select id=\"id_categoria\" ng-model=\"data.id_categoria\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\" ng-disabled=\"vm.formProducto.no_producto.$invalid\"><ui-select-match placeholder=\"Tipo Categoria\">{{$select.selected.no_categoria}}</ui-select-match><ui-select-choices repeat=\"cate in jCategoria | filter: $select.search\"><span ng-bind-html=\"cate.no_categoria\"></span></ui-select-choices><ui-select-no-choice><strong>No existe!</strong> Si desea agregarlo <button type=\"button\" class=\"btn btn-link\" ng-click=\"open_modal($select.search, \'\')\">Click aquí</button>.</ui-select-no-choice></ui-select></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"id_medida\">Unidad de Medida</label><ui-select id=\"id_medida\" ng-model=\"data.id_medida\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\" ng-disabled=\"vm.formProducto.no_producto.$invalid\"><ui-select-match placeholder=\"Unidad de Medida\">{{$select.selected.no_medida}}</ui-select-match><ui-select-choices repeat=\"medida in jUnidad | filter: $select.search\"><span ng-bind-html=\"medida.no_medida\"></span></ui-select-choices><ui-select-no-choice><strong>No existe!</strong> Si desea agregarlo <button type=\"button\" class=\"btn btn-link\" ng-click=\"open_modal($select.search, \'\')\">Click aquí</button>.</ui-select-no-choice></ui-select></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"nu_medida\">Cantidad de Medida</label> <input type=\"text\" name=\"nu_medida\" id=\"nu_medida\" class=\"form-control\" ng-model=\"data.nu_medida\" ng-disabled=\"vm.formProducto.no_producto.$invalid\"></div></div></div><div class=\"row\"></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"no_descripcion\">Descripción</label> <textarea class=\"form-control\" name=\"no_descripcion\" id=\"no_descripcion\" ng-model=\"data.no_descripcion\" cols=\"30\" rows=\"10\" ng-disabled=\"vm.formProducto.no_producto.$invalid || vm.formProducto.co_producto.$invalid\"></textarea></div></div></div></form></ba-wizard-step><ba-wizard-step title=\"Costos\" form=\"vm.productCosto\"><form name=\"vm.productCosto\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\" ng-class=\"{\'has-error\': vm.productCosto.mto_ult_compra.$invalid && (vm.productCosto.mto_ult_compra.$dirty || vm.productCosto.$submitted)}\"><label for=\"mto_ult_compra\">Costo Ult. Compra:</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" id=\"mto_ult_compra\" name=\"mto_ult_compra\" number-format=\"\" decimal=\"2\" ng-model=\"data.mto_ult_compra\" ng-required=\"true\" style=\"text-align:right\" ng-blur=\"calcular_neto()\"> <span class=\"input-group-addon\">S/.</span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"mto_compra_sin_imp\">Costo Ult. Compra - % {{config.abrev_impuesto}}:</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" id=\"mto_compra_sin_imp\" name=\"mto_compra_sin_imp\" ng-model=\"data.mto_compra_sin_imp\" style=\"text-align:right; color:white !important;\" readonly=\"true\"> <span class=\"input-group-addon\">S/.</span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"fec_ult_compra\">Fecha Ult. Compra</label> <input type=\"text\" class=\"form-control\" id=\"fec_ult_compra\" name=\"fec_ult_compra\" ng-model=\"data.fec_ult_compra\" style=\"text-align:center; color: white !important;\" ng-disabled=\"true\"></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"mto_ult_compra\">Costo Ult. Venta:</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" id=\"mto_ult_venta\" name=\"mto_ult_venta\" ng-model=\"data.mto_ult_venta\" style=\"text-align:right; color: white !important;\" ng-blur=\"calcular_neto_venta()\"> <span class=\"input-group-addon\">S/.</span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"mto_venta_sin_imp\">Costo Ult. Venta - {{config.abrev_impuesto}}:</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" id=\"mto_venta_sin_imp\" name=\"mto_venta_sin_imp\" ng-model=\"data.mto_venta_sin_imp\" style=\"text-align:right; color: white !important;\" readonly=\"true\"> <span class=\"input-group-addon\">S/.</span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"fec_ult_venta\">Fecha Ult. Venta</label> <input type=\"text\" class=\"form-control\" id=\"fec_ult_venta\" name=\"fec_ult_venta\" ng-model=\"data.fec_ult_venta\" style=\"text-align:right;\" readonly=\"true\"></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"panel panel-primary\"><div class=\"panel-heading\">Categoria del Producto</div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><label for=\"prod_normal\" class=\"radio custom-radio nowrap\"><input type=\"radio\" name=\"ti_producto\" id=\"prod_normal\" ng-value=\"1\" ng-model=\"data.ti_producto\"> <span>Producto Normal</span></label></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"prod_servicio\" class=\"radio custom-radio nowrap\"><input type=\"radio\" name=\"ti_producto\" id=\"prod_servicio\" ng-value=\"2\" ng-model=\"data.ti_producto\"> <span>Producto Servicio</span></label></div></div><div class=\"row\"><div class=\"col-md-12\"><label for=\"prod_kit\" class=\"radio custom-radio nowrap\"><input type=\"radio\" name=\"ti_producto\" id=\"prod_kit\" ng-value=\"3\" ng-model=\"data.ti_producto\"> <span>Producto KIT-COMBO</span></label></div></div></div></div></div><div class=\"col-md-8\"><div class=\"panel panel-primary\"><div class=\"panel-heading\">Producto Combo</div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\" ng-class=\"{\'has-error\': formOCompra.codigo.$invalid}\"><label for=\"codigo\" class=\"control-label\" ng-disabled=\"datap.ti_producto!=3\">Código:</label> <input type=\"hidden\" name=\"id_producto\" ng-modal=\"datap.id_producto\" class=\"form-control\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" id=\"co_producto\" name=\"co_producto\" placeholder=\"Codigo\" ng-model=\"datap.co_producto\" ng-required=\"true\" ng-disabled=\"data.ti_producto!=3\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"modalProducto(\'lg\')\" ng-disabled=\"data.ti_producto!=3\"><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=\"col-md-6\"><div class=\"form-group\" ng-class=\"{\'has-error\': formOCompra.codigo.$invalid}\"><label for=\"no_producto\" class=\"control-label\">Producto:</label> <input type=\"text\" name=\"no_producto\" id=\"no_producto\" class=\"form-control\" ng-model=\"datap.no_producto\" style=\"text-transform:uppercase; color:rgb(255, 255, 255);\" uib-typeahead=\"product as product.descripcion for product in getProduct4Name($viewValue) | limitTo:10\" typeahead-on-select=\"selectProduct($item)\" ng-disabled=\"true\"></div></div><div class=\"col-md-2\"><div class=\"form-group\" ng-class=\"{\'has-error\': formOCompra.nu_cantidad_p.$invalid}\"><label for=\"nu_cantidad_p\" class=\"control-label\">Cantidad</label><div class=\"input-group\"><input type=\"text\" name=\"nu_cantidad_p\" id=\"nu_cantidad_p\" class=\"form-control\" ng-model=\"datap.nu_cantidad_p\" ng-required=\"formOCompra.id_producto.$valid\" ng-disabled=\"formOCompra.co_producto.$invalid\" style=\"text-align: right;\"> <span class=\"input-group-btn\" ng-disabled=\"data.ti_producto!=3\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"agregarProducto()\" ng-disabled=\"formOCompra.va_precio_producto.$invalid || formOCompra.nu_cantidad_p.$invalid\"><i class=\"fa fa-plus\" ng-disabled=\"data.ti_producto!=3\"></i></button></span></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><table class=\"table table-striped\" st-table=\"displayed\" st-safe-src=\"rowCollection\"><thead><tr class=\"sortable\"><th style=\"width:15%; text-align:center;\">Código</th><th style=\"width:80%; text-align:center;\">Producto</th><th style=\"width:80%; text-align:center;\">Cantidad</th><th style=\"width:5%; text-align:center;\">&nbsp;</th></tr></thead><tbody><tr st-select-row=\"row\" st-select-mode=\"multiple\" ng-repeat=\"item in displayed\"><td style=\"text-align:center;\">{{item.co_producto}}</td><td style=\"text-align:left;\">{{item.no_producto}}</td><td style=\"text-align:left;\">{{item.nu_cantidad}}</td><td style=\"text-align:center;\"><button type=\"button\" class=\"btn btn-xs btn-danger\" ng-click=\"quitar_producto(item.id, displayed.indexOf(item))\" title=\"Quitar\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody><tfoot><tr><td colspan=\"4\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"2\"></td></tr></tfoot></table></div></div></div></div></div></div></form></ba-wizard-step></ba-wizard><div class=\"row\"><div class=\"col-md-6\"><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\" ng-model=\"data.il_ocultar\"><span>Ocutar Producto en Ventas</span></label></div></div><div class=\"col-md-4\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" id=\"msgstockminimo\" ng-model=\"data.msgstockminimo\" ng-change=\"data.stock_minimo=0;\"> <span>Avisar cuando Stock Mínimo sea menor que</span></label></div><div class=\"col-md-2\"><div class=\"form-group\"><input type=\"text\" name=\"nu_stock_minimo\" id=\"nu_stock_minimo\" class=\"form-control\" ng-model=\"data.nu_stock_minimo\" style=\"text-align:right\" ng-disabled=\"!data.msgstockminimo\"></div></div></div><div class=\"row\"><button type=\"button\" class=\"btn btn-success pull-right\" ng-disabled=\"vm.formProducto.$invalid || vm.productCosto.$invalid || vm.productOtros.$invalid\" ng-click=\"guardar()\">Guardar</button> &nbsp;&nbsp;&nbsp; <a class=\"btn btn-default\" ui-sref=\"dashboard.catalogo.producto()\"><i class=\"fa fa-list-alt\"></i> Listado</a></div></div></div></div></div>");
$templateCache.put("app/pages/charts/amCharts/charts.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-lg-4 col-md-6\" ba-panel=\"\" ba-panel-title=\"Bar Chart\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/charts/amCharts/barChart/barChart.html\'\"></div></div><div class=\"col-lg-4 col-md-6\" ba-panel=\"\" ba-panel-title=\"Area Chart\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/charts/amCharts/areaChart/areaChart.html\'\"></div></div><div class=\"col-lg-4 col-md-12\" ba-panel=\"\" ba-panel-title=\"Line Chart\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/charts/amCharts/lineChart/lineChart.html\'\"></div></div></div><div class=\"row\"><div class=\"col-md-6\" ba-panel=\"\" ba-panel-title=\"Pie Chart\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/charts/amCharts/pieChart/pieChart.html\'\"></div></div><div class=\"col-md-6\" ba-panel=\"\" ba-panel-title=\"Funnel Chart\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/charts/amCharts/funnelChart/funnelChart.html\'\"></div></div></div><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Combined bullet/column and line graphs with multiple value axes\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/charts/amCharts/combinedChart/combinedChart.html\'\"></div></div></div></div>");
$templateCache.put("app/pages/charts/chartJs/chartJs.html","<div class=\"row\"><div class=\"col-md-4\" ng-controller=\"chartJs1DCtrl\"><div ba-panel=\"\" ba-panel-title=\"Pie\" ba-panel-class=\"with-scroll\"><canvas id=\"pie\" class=\"chart chart-pie\" chart-legend=\"true\" chart-options=\"options\" chart-data=\"data\" chart-labels=\"labels\" chart-click=\"changeData\"></canvas></div></div><div class=\"col-md-4\" ng-controller=\"chartJs1DCtrl\"><div ba-panel=\"\" ba-panel-title=\"Doughnut\" ba-panel-class=\"with-scroll\"><canvas id=\"doughnut\" chart-options=\"options\" class=\"chart chart-doughnut\" chart-legend=\"true\" chart-data=\"data\" chart-labels=\"labels\" chart-click=\"changeData\"></canvas></div></div><div class=\"col-md-4\" ng-controller=\"chartJs1DCtrl\"><div ba-panel=\"\" ba-panel-title=\"Polar\" ba-panel-class=\"with-scroll\"><canvas id=\"polar-area\" class=\"chart chart-polar-area\" chart-data=\"data\" chart-options=\"polarOptions\" chart-labels=\"labels\" chart-legend=\"true\" chart-click=\"changeData\"></canvas></div></div></div><div class=\"row\"><div class=\"col-md-6\" ng-controller=\"chartJsWaveCtrl\"><div ba-panel=\"\" ba-panel-title=\"Animated Radar\" ba-panel-class=\"with-scroll col-eq-height\"><canvas id=\"waveLine\" class=\"chart chart-radar\" chart-data=\"data\" chart-labels=\"labels\" chart-legend=\"false\"></canvas></div></div><div class=\"col-md-6\" ng-controller=\"chartJsWaveCtrl\"><div ba-panel=\"\" ba-panel-title=\"Animated Bars\" ba-panel-class=\"with-scroll col-eq-height\"><canvas id=\"waveBars\" class=\"chart chart-bar\" chart-data=\"data\" chart-labels=\"labels\" chart-legend=\"false\"></canvas></div></div></div><div class=\"row\"><div class=\"col-lg-4 col-md-6\" ng-controller=\"chartJs2DCtrl\"><div ba-panel=\"\" ba-panel-title=\"Radar\" ba-panel-class=\"with-scroll\"><canvas id=\"radar\" class=\"chart chart-radar\" chart-legend=\"false\" chart-series=\"series\" chart-data=\"data\" chart-labels=\"labels\" chart-click=\"changeData\"></canvas></div></div><div class=\"col-lg-4 col-md-6\" ng-controller=\"chartJs2DCtrl\"><div ba-panel=\"\" ba-panel-title=\"Line\" ba-panel-class=\"with-scroll\"><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"data\" chart-labels=\"labels\" chart-legend=\"false\" chart-series=\"series\" chart-click=\"changeData\"></canvas></div></div><div class=\"col-lg-4 col-md-12\" ng-controller=\"chartJs2DCtrl\"><div ba-panel=\"\" ba-panel-title=\"Bars\" ba-panel-class=\"with-scroll\"><canvas id=\"bar\" class=\"chart chart-bar\" chart-data=\"data\" chart-labels=\"labels\" chart-series=\"series\" chart-click=\"changeData\"></canvas></div></div></div>");
$templateCache.put("app/pages/charts/chartist/chartist.html","<section ng-controller=\"chartistCtrl\" class=\"chartist\"><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Lines\" ba-panel-class=\"with-scroll\"><h5>Simple line chart</h5><div id=\"line-chart\" class=\"ct-chart\"></div><h5>Line chart with area</h5><div id=\"area-chart\" class=\"ct-chart\"></div><h5>Bi-polar line chart with area only</h5><div id=\"bi-chart\" class=\"ct-chart\"></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Bars\" ba-panel-class=\"with-scroll\"><h5>Simple bar chart</h5><div id=\"simple-bar\" class=\"ct-chart\"></div><h5>Multi-line labels bar chart</h5><div id=\"multi-bar\" class=\"ct-chart\"></div><h5>Stacked bar chart</h5><div id=\"stacked-bar\" class=\"ct-chart stacked-bar\"></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Pies & Donuts\" ba-panel-class=\"with-scroll\"><div class=\"row\"><div class=\"col-md-12 col-lg-4\"><h5>Simple Pie</h5><div id=\"simple-pie\" class=\"ct-chart\"></div></div><div class=\"col-md-12 col-lg-4\"><h5>Pie with labels</h5><div id=\"label-pie\" class=\"ct-chart\"></div></div><div class=\"col-md-12 col-lg-4\"><h5>Donut</h5><div id=\"donut\" class=\"ct-chart\"></div></div></div></div></div></div></section>");
$templateCache.put("app/pages/charts/morris/morris.html","<section ng-controller=\"morrisCtrl\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Line Chart\" ba-panel-class=\"with-scroll\"><div line-chart=\"\" line-data=\"lineData\" line-xkey=\"y\" line-ykeys=\'[\"a\", \"b\"]\' line-labels=\'[\"Serie A\", \"Serie B\"]\' line-colors=\"colors\"></div></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div ba-panel=\"\" ba-panel-title=\"Donut\" ba-panel-class=\"with-scroll\"><div donut-chart=\"\" donut-data=\"donutData\" donut-colors=\"colors\" donut-formatter=\'\"currency\"\'></div></div></div><div class=\"col-md-8\"><div ba-panel=\"\" ba-panel-title=\"Bar Chart\" ba-panel-class=\"with-scroll\"><div bar-chart=\"\" bar-data=\"barData\" bar-x=\"y\" bar-y=\'[\"a\", \"b\"]\' bar-labels=\'[\"Series A\", \"Series B\"]\' bar-colors=\"colors\"></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Area Chart\" ba-panel-class=\"with-scroll\"><div area-chart=\"\" area-data=\"areaData\" area-xkey=\"y\" area-ykeys=\'[\"a\", \"b\"]\' %=\"\" area-labels=\'[\"Serie A\", \"Serie B\"]\' line-colors=\"colors\"></div></div></div></div></section>");
$templateCache.put("app/pages/clientes/cliente/cliente.html","<div class=\"widgets\" ng-init=\"consultar()\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Clientes\" ba-panel-class=\"with-scroll\"><form class=\"form-horizontal\" name=\"formClient\" id=\"formClient\" ng-submit=\"guardar(formClient)\" novalidate=\"\"><div class=\"form-group has-feedback\"><label for=\"nu_documento\" class=\"col-sm-2 control-label\">Tipo de Documento:</label><div class=\"col-sm-4\"><ui-select ng-model=\"data.id_tipo_documento\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Doc. Identid.\">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat=\"docidenti in jDocumentos | filter: $select.search\"><div ng-bind-html=\"docidenti.nombre | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"col-sm-6\"><input type=\"text\" class=\"form-control\" id=\"nu_documento\" name=\"nu_documento\" placeholder=\"Nº Documento\" ng-model=\"data.nu_documento\" ng-required=\"true\" style=\"text-transform:uppercase\" ng-keypress=\"getDatosGeneral($event)\" ng-disabled=\"formClient.id_tipo_documento.$invalid\"></div></div><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formClient.no_cliente.$invalid && (formClient.no_cliente.$dirty || formClient.no_cliente.$submitted)}\"><label for=\"no_cliente\" class=\"col-sm-2 control-label\">Apellidos y Nombres:</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"no_cliente\" name=\"no_cliente\" placeholder=\"Apellidos y Nombres\" ng-model=\"data.no_cliente\" ng-required=\"true\" style=\"text-transform:uppercase\" ng-disabled=\"formClient.nu_documento.$invalid || formClient.nu_documento.$pending\" autocomplete=\"off\"> <span class=\"help-block error-block basic-block\" ng-if=\"formClient.no_cliente.$error\"><p ng-repeat=\"(key, value) in formClient.no_cliente.$error\">{{messages.no_cliente[key]}}</p></span></div></div><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formClient.no_cliente.$invalid && (formClient.no_cliente.$dirty || formClient.no_cliente.$submitted)}\"><label for=\"co_depart\" class=\"col-sm-2 control-label\">Departamento:</label><div class=\"col-sm-2\"><ui-select ng-model=\"data.co_depart\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getpDepartamento()\"><ui-select-match placeholder=\"Departamento\">{{$select.selected.no_departamento}}</ui-select-match><ui-select-choices repeat=\"depart in a_departamento | filter: $select.search\"><div ng-bind-html=\"depart.no_departamento | highlight: $select.search\"></div></ui-select-choices></ui-select></div><label for=\"co_provin\" class=\"col-sm-1 control-label\">Provincia:</label><div class=\"col-sm-3\"><ui-select ng-model=\"data.co_provin\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getpProvincia()\"><ui-select-match placeholder=\"Provincia\">{{$select.selected.no_provincia}}</ui-select-match><ui-select-choices repeat=\"prov in a_provincia | filter: $select.search\"><div ng-bind-html=\"prov.no_provincia | highlight: $select.search\"></div></ui-select-choices></ui-select></div><label for=\"co_distri\" class=\"col-sm-1 control-label\">Distrito:</label><div class=\"col-sm-3\"><ui-select ng-model=\"data.co_distri\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Distrito\">{{$select.selected.no_distrito}}</ui-select-match><ui-select-choices repeat=\"distri in a_distrito | filter: $select.search\"><div ng-bind-html=\"distri.no_distrito | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"form-group has-feedback\"><label for=\"no_direccion\" class=\"col-sm-2 control-label\">Dirección:</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"no_direccion\" name=\"no_direccion\" placeholder=\"Dirección\" ng-model=\"data.no_direccion\" style=\"text-transform:uppercase\" ng-disabled=\"formClient.nu_documento.$invalid || formClient.nu_documento.$pending\" autocomplete=\"off\"></div></div><div class=\"form-group has-feedback\"><label for=\"no_email\" class=\"col-sm-2 control-label\">Correo:</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"no_email\" name=\"no_email\" placeholder=\"Correo\" ng-model=\"data.no_email\" ng-disabled=\"formClient.nu_documento.$invalid || formClient.nu_documento.$pending\"></div></div><div class=\"form-group has-feedback\"><label for=\"nu_telefono_fijo\" class=\"col-sm-2 control-label\">Telefonos</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"nu_telefono_fijo\" name=\"nu_telefono_fijo\" placeholder=\"Telefono Habitacion\" ng-model=\"data.nu_telefono_fijo\" ng-disabled=\"formClient.nu_documento.$invalid || formClient.nu_documento.$pending\"></div><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"nu_telefono\" name=\"nu_telefono\" placeholder=\"Telefono Movil\" ng-model=\"data.nu_telefono\" ng-disabled=\"formClient.nu_documento.$invalid || formClient.nu_documento.$pending\"></div></div><div class=\"form-group has-feedback\"><label for=\"id_tipo_cliente\" class=\"col-sm-2 control-label\">Tipo Cliente:</label><div class=\"col-sm-10\"><ui-select ng-model=\"data.id_tipo_cliente\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Tipo Cliente\">{{$select.selected.no_tipo_cliente}}</ui-select-match><ui-select-choices repeat=\"clien in jTipoCliente | filter: $select.search\"><div ng-bind-html=\"clien.no_tipo_cliente | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-10\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"formClient.$invalid || formClient.$pending\">Guardar</button> &nbsp;&nbsp;&nbsp; <a class=\"btn btn-default\" ui-sref=\"dashboard.clientes.cliente()\"><i class=\"fa fa-list-alt\"></i> Listado</a></div></div></form></div></div></div>");
$templateCache.put("app/pages/clientes/cliente/clienteModal.html","<div class=\"modal-content\"><div class=\"modal-header bg-warning\"><i class=\"ion-information-circled modal-icon\"></i><span>Creación de Clientes</span></div><div class=\"modal-body text-center\"><form class=\"form-horizontal\" name=\"formClient\" id=\"formClient\" ng-submit=\"guardar(formClient)\" novalidate=\"\"><div class=\"form-group has-feedback\"><label for=\"nu_documento\" class=\"col-sm-2 control-label\" style=\"color: black !important;\">Tipo de Documento:</label><div class=\"col-sm-4\"><ui-select ng-model=\"data.id_tipo_documento\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Doc. Identid.\">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat=\"docidenti in jDocumentos | filter: $select.search\"><div ng-bind-html=\"docidenti.nombre | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"col-sm-6\"><input type=\"text\" class=\"form-control\" id=\"nu_documento\" name=\"nu_documento\" placeholder=\"Nº Documento\" ng-model=\"data.nu_documento\" ng-required=\"true\" style=\"text-transform:uppercase\" ng-keypress=\"getDatosGeneral($event)\" ng-disabled=\"formClient.id_tipo_documento.$invalid\"></div></div><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formClient.no_cliente.$invalid && (formClient.no_cliente.$dirty || formClient.no_cliente.$submitted)}\"><label for=\"no_cliente\" class=\"col-sm-2 control-label\" style=\"color: black !important;\">Apellidos y Nombres:</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"no_cliente\" name=\"no_cliente\" placeholder=\"Apellidos y Nombres\" ng-model=\"data.no_cliente\" ng-required=\"true\" style=\"text-transform:uppercase\" ng-disabled=\"formClient.nu_documento.$invalid || formClient.nu_documento.$pending\" autocomplete=\"off\"> <span class=\"help-block error-block basic-block\" ng-if=\"formClient.no_cliente.$error\"><p ng-repeat=\"(key, value) in formClient.no_cliente.$error\">{{messages.no_cliente[key]}}</p></span></div></div><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formClient.no_cliente.$invalid && (formClient.no_cliente.$dirty || formClient.no_cliente.$submitted)}\"><label for=\"co_depart\" class=\"col-sm-2 control-label\" style=\"color: black !important;\">Departamento:</label><div class=\"col-sm-2\"><ui-select ng-model=\"data.co_depart\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getpDepartamento()\"><ui-select-match placeholder=\"Departamento\">{{$select.selected.no_departamento}}</ui-select-match><ui-select-choices repeat=\"depart in a_departamento | filter: $select.search\"><div ng-bind-html=\"depart.no_departamento | highlight: $select.search\"></div></ui-select-choices></ui-select></div><label for=\"co_provin\" class=\"col-sm-1 control-label\" style=\"color: black !important;\">Provincia:</label><div class=\"col-sm-3\"><ui-select ng-model=\"data.co_provin\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getpProvincia()\"><ui-select-match placeholder=\"Provincia\">{{$select.selected.no_provincia}}</ui-select-match><ui-select-choices repeat=\"prov in a_provincia | filter: $select.search\"><div ng-bind-html=\"prov.no_provincia | highlight: $select.search\"></div></ui-select-choices></ui-select></div><label for=\"co_distri\" class=\"col-sm-1 control-label\" style=\"color: black !important;\">Distrito:</label><div class=\"col-sm-3\"><ui-select ng-model=\"data.co_distri\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Distrito\">{{$select.selected.no_distrito}}</ui-select-match><ui-select-choices repeat=\"distri in a_distrito | filter: $select.search\"><div ng-bind-html=\"distri.no_distrito | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"form-group has-feedback\"><label for=\"no_direccion\" class=\"col-sm-2 control-label\" style=\"color: black !important;\">Dirección:</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"no_direccion\" name=\"no_direccion\" placeholder=\"Dirección\" ng-model=\"data.no_direccion\" style=\"text-transform:uppercase\" ng-disabled=\"formClient.nu_documento.$invalid || formClient.nu_documento.$pending\" autocomplete=\"off\"></div></div><div class=\"form-group has-feedback\"><label for=\"no_email\" class=\"col-sm-2 control-label\" style=\"color: black !important;\">Correo:</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"no_email\" name=\"no_email\" placeholder=\"Correo\" ng-model=\"data.no_email\" ng-disabled=\"formClient.nu_documento.$invalid || formClient.nu_documento.$pending\"></div></div><div class=\"form-group has-feedback\"><label for=\"nu_telefono_fijo\" class=\"col-sm-2 control-label\" style=\"color: black !important;\">Telefonos</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"nu_telefono_fijo\" name=\"nu_telefono_fijo\" placeholder=\"Telefono Habitacion\" ng-model=\"data.nu_telefono_fijo\" ng-disabled=\"formClient.nu_documento.$invalid || formClient.nu_documento.$pending\"></div><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"nu_telefono\" name=\"nu_telefono\" placeholder=\"Telefono Movil\" ng-model=\"data.nu_telefono\" ng-disabled=\"formClient.nu_documento.$invalid || formClient.nu_documento.$pending\"></div></div><div class=\"form-group has-feedback\"><label for=\"id_tipo_cliente\" class=\"col-sm-2 control-label\" style=\"color: black !important;\">Tipo Cliente:</label><div class=\"col-sm-10\"><ui-select ng-model=\"data.id_tipo_cliente\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Tipo Cliente\">{{$select.selected.no_tipo_cliente}}</ui-select-match><ui-select-choices repeat=\"clien in jTipoCliente | filter: $select.search\"><div ng-bind-html=\"clien.no_tipo_cliente | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-10\"><button type=\"submit\" class=\"btn btn-warning\" ng-disabled=\"formClient.$invalid || formClient.$pending\">Guardar</button></div></div></form></div></div>");
$templateCache.put("app/pages/clientes/historico/historico.html","<div class=\"widgets\"><div class=\"row\"><div ba-panel=\"\" ba-panel-title=\"Listado de Historial Distribuidor\" ba-panel-class=\"with-scroll\"><div class=\"form-group\"><div class=\"col-sm-12\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:4%;\" class=\"table-id\">#</th><th style=\"width:10%;\">Serie</th><th style=\"width:10%;\">Correlativo</th><th style=\"width:15%;\">Distribuidor</th><th style=\"width:6%;\">Fecha</th><th style=\"width:6%;\">Total</th><th style=\"width:5%;\">&nbsp;</th></tr><tr><th></th><th><input st-search=\"no_cliente\" class=\"input-sm form-control\" placeholder=\"Busqueda Distribuidor...\" type=\"search\"></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.nu_serie }}</td><td>{{item.nu_correlativo}}</td><td>{{item.no_cliente }}</td><td>{{item.fe_emision | date:\'dd-MM-yyyy\' }}</td><td>{{item.nu_total }}</td><td><div class=\"text-center btn-group\" role=\"group\" style=\"background: black;\"><button type=\"button\" title=\"Ver\" class=\"btn btn-default btn-icon\" ui-sref=\"dashboard.clientes.historico-details({idcotizacion: item.id_cotizacion})\"><i class=\"ion-edit text-primary\"></i></button> <button type=\"button\" title=\"Archivo Pdf\" data-toggle=\"popover\" class=\"btn btn-default btn-icon\" ng-disabled=\"\" ng-click=\"openPdf(\'lg\',item)\"><i class=\"ion-clipboard text-primary\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"7\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/clientes/historico/historicoEditar.html","<div class=\"widgets\" ng-init=\"consultar()\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Registro de Cotizaciones\"><div class=\"row\"><div class=\"col-md-5\"><div class=\"form-group\"><label for=\"id_tipo_comprobante\" class=\"control-label\">Tipo de Comprobante:</label><ui-select ng-model=\"data.id_tipo_comprobante\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getCorrelativo(data)\" ng-disabled=\"true\"><ui-select-match placeholder=\"Comprobante de Pago\">{{$select.selected.descripcion}}</ui-select-match><ui-select-choices repeat=\"comprobante in jComprobante | filter: $select.search\"><div ng-bind-html=\"comprobante.descripcion | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"id_tipo_comprobante\" class=\"control-label\">Nº Cotización:</label><h4 style=\"text-align: center;\">{{data.nu_serie}}{{\'-\'}}{{data.nu_correlativo}}</h4></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" for=\"fe_emision\">Fecha Cotización</label><div class=\"input-group\" moment-picker=\"data.fe_emision\" locales=\"es\" start-view=\"month\" format=\"YYYY-MM-DD\"><input class=\"form-control\" id=\"fe_emision\" ng-disabled=\"true\" name=\"fe_emision\" placeholder=\"Seleccione Una Fecha\" ng-model=\"data.fe_emision\" ng-model-options=\"{ updateOn: \'blur\'}\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\" ng-class=\"{\'has-error\': formVenta.nu_documento.$invalid}\"><label for=\"nu_documento\" class=\"control-label\">Nº Documento</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" id=\"nu_documento\" name=\"nu_documento\" placeholder=\"Nº Documento\" ng-model=\"data.nu_documento\" ng-required=\"true\" ng-disabled=\"true\" ng-blur=\"consultarNumdocument(formVenta)\" autocomplete=\"off\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"crearProduct(\'lg\')\" ng-disabled=\"true\"><i class=\"fa fa-plus\"></i></button> <button class=\"btn btn-default\" type=\"button\" data-toggle=\"modal\" ng-disabled=\"true\" ng-click=\"modalProducts(\'lg\')\"><i class=\"fa fa-search\"></i></button></span></div><span class=\"help-block error-block basic-block\" ng-if=\"formVenta.nu_documento.$error\"><p ng-repeat=\"(key, value) in formVenta.nu_documento.$error\">{{messages.nu_documento[key]}}</p></span></div></div><div class=\"col-md-6\"><div class=\"form-group\" ng-class=\"{\'has-error\': formVenta.no_cliente.$invalid}\"><label for=\"no_cliente\" class=\"control-label\">Cliente</label> <input type=\"text\" class=\"form-control\" id=\"no_cliente\" name=\"no_cliente\" ng-disabled=\"true\" placeholder=\"Apellidos y Nombres\" ng-model=\"data.no_cliente\" style=\"color:rgb(255, 255, 255) !important; text-transform: uppercase;\"></div></div><div class=\"col-sm-3\"><div class=\"form-group has-feedback\"><label for=\"apenom\">Tipo Pago:</label><ui-select ng-model=\"data.id_tipo_pago\" ng-disabled=\"true\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getMonto(data.id_tipo_pago)\"><ui-select-match placeholder=\"Tipo Pago\">{{$select.selected.no_tipo_pago}}</ui-select-match><ui-select-choices repeat=\"pago in jtipopago | filter: $select.search\"><div ng-bind-html=\"pago.no_tipo_pago | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"no_observacion\" class=\"control-label\">Comentario:</label> <input type=\"text\" class=\"form-control\" ng-disabled=\"true\" id=\"no_observacion\" name=\"no_observacion\" placeholder=\"Ingrese aqui su comentario\" ng-model=\"data.no_observacion\" ng-required=\"true\"></div></div></div><div class=\"row\"><table class=\"table table-striped\" st-table=\"displayed\" st-safe-src=\"rowCollection\"><thead><tr class=\"sortable\"><th style=\"width:10%; text-align:center;\">Código</th><th style=\"width:25%; text-align:center;\">Producto</th><th style=\"width:20%; text-align:center;\">Cantidad</th><th style=\"width:20%; text-align:center;\">Precio</th><th style=\"width:15%; text-align:center;\">Descuento</th><th style=\"width:10%; text-align:center;\">Precio D.</th><th style=\"width:20%; text-align:center;\">Total</th><th style=\"width:5%; text-align:center;\">&nbsp;</th></tr></thead><tbody><tr st-select-row=\"row\" st-select-mode=\"multiple\" ng-repeat=\"item in displayed\"><td style=\"text-align:center;\">{{item.id}}</td><td style=\"text-align:left;\">{{item.no_producto}}</td><td style=\"text-align:right;\">{{item.nu_cantidad_p}}</td><td style=\"text-align:right;\">{{item.nu_precio_unitario | number:2}}</td><td style=\"text-align:right;\">{{item.pr_descuento | number:2}} %</td><td style=\"text-align:right;\">{{item.nu_precio_descuento | number:2}}</td><td style=\"text-align:right;\">{{(item.nu_total) | number:2}}</td><td style=\"text-align:center;\"><button type=\"button\" class=\"btn btn-xs btn-danger\" ng-click=\"quitar_producto(item.id, displayed.indexOf(item))\" title=\"Quitar\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody><tfoot><tr><td colspan=\"7\" style=\"text-align:right\">Total:</td><td style=\"text-align:right\">{{data.nu_total | number:2}}</td><td>&nbsp;</td></tr><tr><td colspan=\"8\" style=\"text-align:right\"><a class=\"btn btn-default\" ui-sref=\"dashboard.clientes.historico()\"><i class=\"fa fa-list-alt\"></i> Listado</a></td></tr></tfoot></table></div></div></div></div><style>\r\n    .modal .modal-dialog {\r\n        vertical-align: middle;\r\n    }\r\n\r\n    .modal.win_proveedor .modal-dialog {\r\n        width: 65%;\r\n        display: inline-block;\r\n        text-align: left;\r\n    }\r\n\r\n    .modal.win_producto .modal-dialog {\r\n        width: 85%;\r\n        display: inline-block;\r\n        text-align: left;\r\n    }\r\n\r\n    .modal.win_proveedor {\r\n        text-align: center;\r\n        padding: 0 !important;\r\n    }\r\n\r\n    .modal::before {\r\n        content: \'\';\r\n        display: inline-block;\r\n        height: 100%;\r\n        vertical-align: middle;\r\n        margin-right: -4px;\r\n    }\r\n</style>");
$templateCache.put("app/pages/cobranzas/cobranza/cobranza.html","<div class=\"widgets\" ng-init=\"consultar()\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Registro de Cobranza\"><div class=\"row\"><div class=\"col-md-5\"><div class=\"form-group\"><label for=\"id_tipo_comprobante\" class=\"control-label\">Tipo de Comprobante:</label><ui-select ng-model=\"data.id_tipo_comprobante\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getCorrelativo(data)\"><ui-select-match placeholder=\"Tipo de Comprobante\">{{$select.selected.descripcion}}</ui-select-match><ui-select-choices repeat=\"comprobante in jComprobante | filter: $select.search\"><div ng-bind-html=\"comprobante.descripcion | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"id_tipo_comprobante\" class=\"control-label\">Nº Cobranza:</label><h4 style=\"text-align: center;\">{{data.nu_serie}}{{\'-\'}}{{data.nu_correlativo}}</h4></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" for=\"fe_emision\">Fecha Cobranza</label><div class=\"input-group\" moment-picker=\"data.fe_emision\" locales=\"es\" start-view=\"month\" format=\"YYYY-MM-DD\"><input class=\"form-control\" id=\"fe_emision\" name=\"fe_emision\" placeholder=\"Seleccione Una Fecha\" ng-model=\"data.fe_emision\" ng-model-options=\"{ updateOn: \'blur\'}\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"id_tipo_comprobante_c\" class=\"control-label\">Tipo de Comprobante:</label><ui-select ng-model=\"data.id_tipo_comprobante_c\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getComprobantesoBoloFac(data)\"><ui-select-match placeholder=\"Tipo de Comprobante\">{{$select.selected.descripcion}}</ui-select-match><ui-select-choices repeat=\"comprobante in jComprobanteBolFac | filter: $select.search\"><div ng-bind-html=\"comprobante.descripcion | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"id_comprobante\" class=\"control-label\">Comprobante:</label><ui-select ng-model=\"data.id_comprobante\" ng-change=\"getMontoComprobante(data)\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Seleccionar Comprobante\">{{$select.selected.value}}</ui-select-match><ui-select-choices repeat=\"value in jComprobanteNota | filter: $select.search\"><div ng-bind-html=\"value.value | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><div class=\"col-md-4\"><label for=\"nu_sub_total\" class=\"control-label\">Sub Total:</label> <input type=\"text\" class=\"form-control\" id=\"nu_sub_total\" name=\"nu_sub_total\" placeholder=\"Sub total\" ng-model=\"data.nu_sub_total\" ng-disabled=\"true\"></div><div class=\"col-md-4\"><label for=\"nu_igv\" class=\"control-label\">Igv:</label> <input type=\"text\" class=\"form-control\" id=\"nu_igv\" name=\"nu_igv\" placeholder=\"IGV\" ng-model=\"data.nu_igv\" ng-disabled=\"true\"></div><div class=\"col-md-4\"><label for=\"nu_total\" class=\"control-label\">Total:</label> <input type=\"text\" class=\"form-control\" id=\"nu_total\" name=\"nu_total\" placeholder=\"Total\" ng-model=\"data.nu_total\" ng-disabled=\"true\"></div></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"id_tipo_medio_pago\" class=\"control-label\">Tipo Medio de Pago:</label><ui-select ng-model=\"datam.id_tipo_medio_pago\" class=\"btn-group bootstrap-select form-control\" ng-change=\"operacion(datam.id_tipo_medio_pago)\"><ui-select-match placeholder=\"Tipo de Pago\">{{$select.selected.no_tipo_medio_pago}}</ui-select-match><ui-select-choices repeat=\"pago in jtipopago | filter: $select.search\"><div ng-bind-html=\"pago.no_tipo_medio_pago | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-md-4\" ng-show=\"datam.id_tipo_medio_pago.id_tipo_medio_pago != 1\"><div class=\"form-group\"><label for=\"no_medio_pago\" class=\"control-label\">Número Operación:</label> <input type=\"text\" name=\"no_medio_pago\" id=\"no_medio_pago\" class=\"form-control\" ng-model=\"datam.no_medio_pago\" style=\"text-transform:uppercase; color:rgb(255, 255, 255);\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"mto_ult_venta\" class=\"control-label\">Monto:</label><div class=\"input-group\"><input type=\"text\" name=\"nu_monto\" id=\"nu_monto\" class=\"form-control\" ng-model=\"datam.nu_monto\" style=\"text-align: right;\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"addItem()\"><i class=\"fa fa-plus\"></i></button> 6</span></div></div></div></div><div class=\"row\"><table class=\"table table-striped\" st-table=\"displayed\" st-safe-src=\"rowCollection\"><thead><tr class=\"sortable\"><th style=\"width:10%; text-align:center;\">Item</th><th style=\"width:25%; text-align:center;\">Medio de Pago</th><th style=\"width:20%; text-align:center;\">N° Operacion</th><th style=\"width:20%; text-align:center;\">Monto Pago</th><th style=\"width:5%; text-align:center;\">&nbsp;</th></tr></thead><tbody><tr st-select-row=\"row\" st-select-mode=\"multiple\" ng-repeat=\"item in displayed\"><td style=\"text-align:center;\">{{item.id}}</td><td style=\"text-align:left;\">{{item.no_tipo_medio_pago}}</td><td style=\"text-align:left;\">{{item.no_medio_pago}}</td><td style=\"text-align:right;\">{{item.nu_monto | number:2}}</td><td style=\"text-align:center;\"><button type=\"button\" class=\"btn btn-xs btn-danger\" ng-click=\"quitar_producto(item, displayed.indexOf(item))\" title=\"Quitar\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody><tfoot><tr><td colspan=\"5\" style=\"text-align:right\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"rowCollection.length==0\" ng-click=\"guardar()\"><i class=\"fa fa-print\"></i> Registrar</button> &nbsp;&nbsp;&nbsp; <a class=\"btn btn-default\" ui-sref=\"dashboard.cobranzas.cobranza()\"><i class=\"fa fa-list-alt\"></i> Listado</a></td></tr></tfoot></table></div></div></div></div><style>\r\n  .modal .modal-dialog {\r\n    vertical-align: middle;\r\n  }\r\n\r\n  .modal.win_proveedor .modal-dialog {\r\n    width: 65%;\r\n    display: inline-block;\r\n    text-align: left;\r\n  }\r\n\r\n  .modal.win_producto .modal-dialog {\r\n    width: 85%;\r\n    display: inline-block;\r\n    text-align: left;\r\n  }\r\n\r\n  .modal.win_proveedor {\r\n    text-align: center;\r\n    padding: 0 !important;\r\n  }\r\n\r\n  .modal::before {\r\n    content: \'\';\r\n    display: inline-block;\r\n    height: 100%;\r\n    vertical-align: middle;\r\n    margin-right: -4px;\r\n  }\r\n</style>");
$templateCache.put("app/pages/compras/compra/compra.html","<div class=\"widgets\" ng-init=\"consultar()\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Registrar Orden Compra\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"id_empresa\">Empresa</label><ui-select id=\"id_empresa\" ng-model=\"data.id_empresa\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\" ng-disabled=\"formOCompra.no_producto.$invalid\" ng-change=\"getSucursal(data.id_empresa)\"><ui-select-match placeholder=\"Empresa\">{{$select.selected.no_empresa}}</ui-select-match><ui-select-choices repeat=\"empresa in jEmpresa | filter: $select.search\"><span ng-bind-html=\"empresa.no_empresa\"></span></ui-select-choices><ui-select-no-choice><strong>No existe!</strong> Si desea agregarlo <button type=\"button\" class=\"btn btn-link\" ng-click=\"open_modal($select.search, \'\')\">Click aquí</button>.</ui-select-no-choice></ui-select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"id_local\">Sucursal</label><ui-select id=\"id_local\" ng-model=\"data.id_local\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\" ng-disabled=\"formOCompra.no_producto.$invalid\" ng-change=\"getCorrelativo(data.id_local)\"><ui-select-match placeholder=\"Sucursal\">{{$select.selected.no_local}}</ui-select-match><ui-select-choices repeat=\"local in jSucursal | filter: $select.search\"><span ng-bind-html=\"local.no_local\"></span></ui-select-choices><ui-select-no-choice><strong>No existe!</strong> Si desea agregarlo <button type=\"button\" class=\"btn btn-link\" ng-click=\"open_modal($select.search, \'\')\">Click aquí</button>.</ui-select-no-choice></ui-select></div></div><div class=\"col-md-1\"><div class=\"form-group\"><label for=\"nu_serie\" class=\"control-label\">Nº Serie</label> <input type=\"text\" name=\"nu_serie\" id=\"nu_serie\" class=\"form-control\" ng-model=\"data.nu_serie\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"nu_correlativo\" class=\"control-label\">Nº Orden Compra</label> <input type=\"text\" name=\"nu_correlativo\" id=\"nu_correlativo\" class=\"form-control\" ng-model=\"data.nu_correlativo\"></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\" ng-class=\"{\'has-error\': formOCompra.nu_documento.$invalid}\"><label for=\"nu_documento\" class=\"control-label\">Nº Documento:</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" id=\"nu_documento\" name=\"nu_documento\" ng-model=\"data.nu_documento\" ng-required=\"true\" style=\"text-transform:uppercase\" ng-disabled=\"true\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"crearProveedor(\'lg\')\"><i class=\"fa fa-plus\"></i></button> <button type=\"button\" class=\"btn btn-default\" ng-click=\"modalProveedor(\'lg\')\"><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=\"col-md-5\"><div class=\"form-group\"><label for=\"no_proveedor\" class=\"control-label\">Proveedor</label> <input type=\"hidden\" name=\"id_proveedor\" id=\"id_proveedor\" ng-model=\"data.id_proveedor\"> <input type=\"text\" class=\"form-control\" id=\"no_proveedor\" name=\"no_proveedor\" placeholder=\"Proveedor\" ng-model=\"data.no_proveedor\" style=\"text-transform:uppercase; color:rgb(255, 255, 255);\" ng-readonly=\"true\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" for=\"fe_emision\">Fecha Orden</label><div class=\"input-group\" moment-picker=\"data.fe_emision\" locales=\"es\" start-view=\"month\" format=\"YYYY-MM-DD\"><input class=\"form-control\" id=\"fe_emision\" name=\"fe_emision\" placeholder=\"Seleccione Una Fecha\" ng-model=\"data.fe_emision\" ng-model-options=\"{ updateOn: \'blur\'}\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=\"row\"><div class=\"col-md-2\"><div class=\"form-group\" ng-class=\"{\'has-error\': formOCompra.co_barra.$invalid}\"><label for=\"co_barra\" class=\"control-label\">Barras:</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" id=\"co_barra\" name=\"co_barra\" placeholder=\"\" ng-model=\"datap.co_barra\" ng-required=\"true\" ng-keypress=\"buscarCodigoBarras()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"limpiar()\"><i class=\"fa fa-paint-brush\"></i></button></span></div></div></div><div class=\"col-md-2\"><div class=\"form-group\" ng-class=\"{\'has-error\': formOCompra.codigo.$invalid}\"><label for=\"codigo\" class=\"control-label\">Código:</label> <input type=\"hidden\" name=\"id_producto\" ng-modal=\"datap.id_producto\" class=\"form-control\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" id=\"id_producto\" name=\"id_producto\" placeholder=\"id_producto\" ng-model=\"datap.id_producto\" ng-required=\"true\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"modalProducto(\'lg\')\"><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\" ng-class=\"{\'has-error\': formOCompra.codigo.$invalid}\"><label for=\"no_producto\" class=\"control-label\">Producto</label> <input type=\"text\" name=\"no_producto\" id=\"no_producto\" class=\"form-control\" ng-model=\"datap.no_producto\" style=\"text-transform:uppercase; color:rgb(255, 255, 255);\" uib-typeahead=\"product as product.descripcion for product in getProduct4Name($viewValue) | limitTo:10\" typeahead-on-select=\"selectProduct($item)\" ng-disabled=\"true\"></div></div><div class=\"col-md-2\"><div class=\"form-group\" ng-class=\"{\'has-error\': formOCompra.mto_ult_compra.$invalid}\"><label for=\"mto_ult_compra\" class=\"control-label\">Precio {{infoconfig.simb_moneda}}</label> <input type=\"text\" name=\"mto_ult_compra\" id=\"mto_ult_compra\" class=\"form-control\" ng-model=\"datap.mto_ult_compra\" ng-required=\"formOCompra.cod_producto.$valid\" ng-disabled=\"formOCompra.codigo.$invalid\" style=\"text-align: right;\"></div></div><div class=\"col-md-2\"><div class=\"form-group\" ng-class=\"{\'has-error\': formOCompra.nu_cantidad.$invalid}\"><label for=\"nu_cantidad\" class=\"control-label\">Cantidad</label><div class=\"input-group\"><input type=\"text\" name=\"nu_cantidad\" id=\"nu_cantidad\" class=\"form-control\" ng-model=\"datap.nu_cantidad\" ng-required=\"formOCompra.cod_producto.$valid\" ng-disabled=\"formOCompra.id_producto.$invalid\" style=\"text-align: right;\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"addItem()\" ng-disabled=\"formOCompra.va_precio_producto.$invalid || formOCompra.nu_cantidad.$invalid\"><i class=\"fa fa-plus\"></i></button></span></div></div></div></div><div class=\"row\"><table class=\"table table-striped\" st-table=\"displayed\" st-safe-src=\"rowCollection\"><thead><tr class=\"sortable\"><th style=\"width:10%; text-align:center;\">Item</th><th style=\"width:25%; text-align:center;\">Código</th><th style=\"width:25%; text-align:center;\">Producto</th><th style=\"width:20%; text-align:center;\">Cantidad</th><th style=\"width:20%; text-align:center;\">Precio</th><th style=\"width:20%; text-align:center;\">Total</th><th style=\"width:5%; text-align:center;\">&nbsp;</th></tr></thead><tbody><tr st-select-row=\"row\" st-select-mode=\"multiple\" ng-repeat=\"item in displayed\"><td style=\"text-align:center;\">{{item.id}}</td><td style=\"text-align:left;\">{{item.co_producto}}</td><td style=\"text-align:left;\">{{item.no_producto}}</td><td style=\"text-align:right;\">{{item.nu_cantidad}}</td><td style=\"text-align:right;\">{{item.nu_precio | number:2}}</td><td style=\"text-align:right;\">{{(item.nu_total) | number:2}}</td><td style=\"text-align:center;\"><button type=\"button\" class=\"btn btn-xs btn-danger\" ng-click=\"quitar_producto(item.id, displayed.indexOf(item))\" title=\"Quitar\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody><tfoot><tr><td colspan=\"5\" style=\"text-align:right\">Total:</td><td style=\"text-align:right\">{{data.nu_total | number:2}}</td><td>&nbsp;</td></tr><tr><td colspan=\"7\" style=\"text-align:right\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"rowCollection.length==0\" ng-click=\"guardar()\"><i class=\"fa fa-print\"></i> Registrar</button> &nbsp;&nbsp;&nbsp; <a class=\"btn btn-default\" ui-sref=\"dashboard.compras.compra()\"><i class=\"fa fa-list-alt\"></i> Listado</a></td></tr></tfoot></table></div></div></div></div><style>\r\n    .modal .modal-dialog {\r\n        vertical-align: middle;\r\n    }\r\n\r\n    .modal.win_proveedor .modal-dialog {\r\n        width: 65%;\r\n        display: inline-block;\r\n        text-align: left;\r\n    }\r\n\r\n    .modal.win_producto .modal-dialog {\r\n        width: 85%;\r\n        display: inline-block;\r\n        text-align: left;\r\n    }\r\n\r\n    .modal.win_proveedor {\r\n        text-align: center;\r\n        padding: 0 !important;\r\n    }\r\n\r\n    .modal::before {\r\n        content: \'\';\r\n        display: inline-block;\r\n        height: 100%;\r\n        vertical-align: middle;\r\n        margin-right: -4px;\r\n    }\r\n</style>");
$templateCache.put("app/pages/compras/facturaprov/facturaprov.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Registrar Orden Compra\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\" ng-class=\"{\'has-error\': formOCompra.nu_documento.$invalid}\"><label for=\"nu_documento\" class=\"control-label\">Nº Documento:</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" id=\"nu_documento\" name=\"nu_documento\" ng-model=\"data.nu_documento\" ng-required=\"true\" style=\"text-transform:uppercase\" ng-disabled=\"true\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"modalProveedor(\'lg\')\"><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=\"col-md-5\"><div class=\"form-group\"><label for=\"no_proveedor\" class=\"control-label\">Proveedor</label> <input type=\"hidden\" name=\"id_proveedor\" id=\"id_proveedor\" ng-model=\"data.id_proveedor\"> <input type=\"text\" class=\"form-control\" id=\"no_proveedor\" name=\"no_proveedor\" placeholder=\"Proveedor\" ng-model=\"data.no_proveedor\" style=\"text-transform:uppercase; color:rgb(255, 255, 255);\" ng-readonly=\"true\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" for=\"fe_pago\">Fecha Pago</label><div class=\"input-group\" moment-picker=\"data.fe_pago\" locales=\"es\" start-view=\"month\" format=\"YYYY-MM-DD\"><input class=\"form-control\" id=\"fe_pago\" name=\"fe_pago\" placeholder=\"Seleccione Una Fecha\" ng-model=\"data.fe_pago\" ng-model-options=\"{ updateOn: \'blur\'}\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"id_tipo_comprobante\" class=\"control-label\">Tipo de Comprobante:</label><ui-select ng-model=\"data.id_tipo_comprobante\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Comprobante de Pago\">{{$select.selected.descripcion}}</ui-select-match><ui-select-choices repeat=\"comprobante in jComprobante | filter: $select.search\"><div ng-bind-html=\"comprobante.descripcion | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"nu_serie_oc\" class=\"control-label\">Nro Serie</label> <input type=\"text\" class=\"form-control\" id=\"nu_serie_oc\" name=\"nu_serie_oc\" placeholder=\"Serie Comprobante\" ng-model=\"data.nu_serie_oc\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"nu_correlativo_oc\" class=\"control-label\">Nro Correlativo</label> <input type=\"text\" class=\"form-control\" id=\"nu_correlativo_oc\" name=\"nu_correlativo_oc\" placeholder=\"Nro Comprobante\" ng-model=\"data.nu_correlativo_oc\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"id_tipo_medio_pago\" class=\"control-label\">Condición Pago</label><ui-select ng-model=\"data.id_tipo_medio_pago\" name=\"id_tipo_medio_pago\" id=\"id_tipo_medio_pago\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getTipoPago(data.id_tipo_medio_pago)\"><ui-select-match placeholder=\"Comprobante de Pago\">{{$select.selected.no_tipo_medio_pago}}</ui-select-match><ui-select-choices repeat=\"comprobante in jtipopago | filter: $select.search\"><div ng-bind-html=\"comprobante.no_tipo_medio_pago | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></div><div class=\"row\" ng-show=\"data.id_tipo_medio_pago==3\"><div class=\"col-md-12\"><div class=\"form-group\" ng-class=\"{\'has-error\': formVenta.nu_operacion.$invalid}\"><label for=\"nu_operacion\" class=\"control-label\">Número de Operación</label> <input type=\"text\" class=\"form-control\" id=\"nu_operacion\" name=\"nu_operacion\" placeholder=\"Número de Operación\" ng-model=\"data.nu_operacion\" style=\"color:rgb(255, 255, 255) !important; text-transform: uppercase;\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"id_compra_cabecera\" class=\"control-label\">Orden de Compra:</label><div class=\"input-group\"><ui-select ng-model=\"data.id_compra_cabecera\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getOrdenDetalle(data.id_compra_cabecera)\"><ui-select-match placeholder=\"Seleccionar Orden de Compra\">{{$select.selected.value}}</ui-select-match><ui-select-choices repeat=\"value in jOrdenCompra | filter: $select.search\"><div ng-bind-html=\"value.value | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></div></div><div class=\"row\"><table class=\"table table-striped\" st-table=\"displayed\" st-safe-src=\"rowCollection\"><thead><tr class=\"sortable\"><th style=\"width:10%; text-align:center;\">Código</th><th style=\"width:25%; text-align:center;\">Producto</th><th style=\"width:20%; text-align:center;\">Cantidad</th><th style=\"width:20%; text-align:center;\">Precio</th><th style=\"width:20%; text-align:center;\">Total</th><th style=\"width:5%; text-align:center;\">&nbsp;</th></tr></thead><tbody><tr st-select-row=\"row\" st-select-mode=\"multiple\" ng-repeat=\"item in displayed\"><td style=\"text-align:center;\">{{item.id_producto}}</td><td style=\"text-align:left;\">{{item.no_producto}}</td><td style=\"text-align:right;\">{{item.nu_cantidad}}</td><td style=\"text-align:right;\">{{item.mto_ult_compra | number:2}}</td><td style=\"text-align:right;\">{{(item.nu_total) | number:2}}</td><td style=\"text-align:center;\"><button type=\"button\" class=\"btn btn-xs btn-danger\" ng-click=\"quitar_producto(item.id, displayed.indexOf(item))\" title=\"Quitar\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody><tfoot><tr><td colspan=\"4\" style=\"text-align:right\">Total:</td><td style=\"text-align:right\">{{data.nu_total | number:2}}</td><td>&nbsp;</td></tr><tr><td colspan=\"6\" style=\"text-align:right\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"rowCollection.length==0\" ng-click=\"guardar()\"><i class=\"fa fa-print\"></i> Registrar</button> &nbsp;&nbsp;&nbsp; <a class=\"btn btn-default\" ui-sref=\"dashboard.compras.facturaprov()\"><i class=\"fa fa-list-alt\"></i> Listado</a></td></tr></tfoot></table></div></div></div></div>");
$templateCache.put("app/pages/compras/proveedor/proveedor.html","<div class=\"widgets\" ng-init=\"consultar()\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Registro de Proveedor\" ba-panel-class=\"with-scroll\"><form class=\"form-horizontal\" name=\"formProveedor\" id=\"formProveedor\" ng-submit=\"guardar(formProveedor)\" novalidate=\"\"><div class=\"form-group has-feedback\"><label for=\"nu_documento\" class=\"col-sm-2 control-label\">Tipo de Documento:</label><div class=\"col-sm-4\"><ui-select ng-model=\"data.id_tipo_documento\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Doc. Identid.\">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat=\"docidenti in jDocumentos | filter: $select.search\"><div ng-bind-html=\"docidenti.nombre | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"col-sm-6\"><input type=\"text\" class=\"form-control\" id=\"nu_documento\" name=\"nu_documento\" placeholder=\"Nº Documento\" ng-model=\"data.nu_documento\" ng-required=\"true\" style=\"text-transform:uppercase\" ng-keypress=\"getDatosConsulta($event)\" ng-disabled=\"formProveedor.id_tipo_documento.$invalid\"></div></div><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formProveedor.no_proveedor.$invalid && (formProveedor.no_proveedor.$dirty || formProveedor.no_proveedor.$submitted)}\"><label for=\"no_proveedor\" class=\"col-sm-2 control-label\">Nombre Proveedor:</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"no_proveedor\" name=\"no_proveedor\" placeholder=\"Nombre Proveddor\" ng-model=\"data.no_proveedor\" ng-required=\"true\" style=\"text-transform:uppercase\" ng-disabled=\"formProveedor.nu_documento.$invalid || formProveedor.nu_documento.$pending\" autocomplete=\"off\"> <span class=\"help-block error-block basic-block\" ng-if=\"formProveedor.no_proveedor.$error\"><p ng-repeat=\"(key, value) in formProveedor.no_proveedor.$error\">{{messages.no_proveedor[key]}}</p></span></div></div><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formProveedor.no_cliente.$invalid && (formProveedor.no_cliente.$dirty || formProveedor.no_cliente.$submitted)}\"><label for=\"co_depart\" class=\"col-sm-2 control-label\">Departamento:</label><div class=\"col-sm-2\"><ui-select ng-model=\"data.co_depart\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getpDepartamento()\"><ui-select-match placeholder=\"Departamento\">{{$select.selected.no_departamento}}</ui-select-match><ui-select-choices repeat=\"depart in a_departamento | filter: $select.search\"><div ng-bind-html=\"depart.no_departamento | highlight: $select.search\"></div></ui-select-choices></ui-select></div><label for=\"co_provin\" class=\"col-sm-1 control-label\">Provincia:</label><div class=\"col-sm-3\"><ui-select ng-model=\"data.co_provin\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getpProvincia()\"><ui-select-match placeholder=\"Provincia\">{{$select.selected.no_provincia}}</ui-select-match><ui-select-choices repeat=\"prov in a_provincia | filter: $select.search\"><div ng-bind-html=\"prov.no_provincia | highlight: $select.search\"></div></ui-select-choices></ui-select></div><label for=\"co_distri\" class=\"col-sm-1 control-label\">Distrito:</label><div class=\"col-sm-3\"><ui-select ng-model=\"data.co_distri\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Distrito\">{{$select.selected.no_distrito}}</ui-select-match><ui-select-choices repeat=\"distri in a_distrito | filter: $select.search\"><div ng-bind-html=\"distri.no_distrito | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"form-group has-feedback\"><label for=\"no_direccion\" class=\"col-sm-2 control-label\">Dirección:</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"no_direccion\" name=\"no_direccion\" placeholder=\"Dirección\" ng-model=\"data.no_direccion\" style=\"text-transform:uppercase\" ng-disabled=\"formProveedor.nu_documento.$invalid || formProveedor.nu_documento.$pending\" autocomplete=\"off\"></div></div><div class=\"form-group has-feedback\"><label for=\"nu_telefono\" class=\"col-sm-2 control-label\">Contacto:</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"nu_telefono\" name=\"nu_telefono\" placeholder=\"Telefono\" ng-model=\"data.nu_telefono\" style=\"text-transform:uppercase\" ng-disabled=\"formProveedor.nu_documento.$invalid || formProveedor.nu_documento.$pending\" autocomplete=\"off\"></div><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"nu_celular\" name=\"nu_celular\" placeholder=\"Celular\" ng-model=\"data.nu_celular\" style=\"text-transform:uppercase\" ng-disabled=\"formProveedor.nu_documento.$invalid || formProveedor.nu_documento.$pending\" autocomplete=\"off\"></div></div><div class=\"form-group has-feedback\"><label for=\"no_contacto\" class=\"col-sm-2 control-label\">Persona / Correo:</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"no_contacto\" name=\"no_contacto\" placeholder=\"Persona de Contacto\" ng-model=\"data.no_contacto\" style=\"text-transform:uppercase\" ng-disabled=\"formProveedor.nu_documento.$invalid || formProveedor.nu_documento.$pending\" autocomplete=\"off\"></div><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"Correo Electronico\" ng-model=\"data.email\" ng-disabled=\"formProveedor.nu_documento.$invalid || formProveedor.nu_documento.$pending\" autocomplete=\"off\"></div></div><div class=\"form-group has-feedback\"><label for=\"nu_cuenta_uno\" class=\"col-sm-2 control-label\">N° de Cuentas:</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"nu_cuenta_uno\" name=\"nu_cuenta_uno\" placeholder=\"Número de cuenta bancaria\" ng-model=\"data.nu_cuenta_uno\" style=\"text-transform:uppercase\" ng-disabled=\"formProveedor.nu_documento.$invalid || formProveedor.nu_documento.$pending\" autocomplete=\"off\"></div><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"nu_cuenta_dos\" name=\"nu_cuenta_dos\" placeholder=\"Número de cuenta bancaria\" ng-model=\"data.nu_cuenta_dos\" style=\"text-transform:uppercase\" ng-disabled=\"formProveedor.nu_documento.$invalid || formProveedor.nu_documento.$pending\" autocomplete=\"off\"></div></div><div class=\"form-group has-feedback\"><label for=\"no_observacion\" class=\"col-sm-2 control-label\">Comentario:</label><div class=\"col-sm-10\"><textarea name=\"no_observacion\" id=\"no_observacion\" ng-model=\"data.no_observacion\" cols=\"15\" rows=\"5\" class=\"input-sm form-control\" placeholder=\"COMENTARIO\">\r\n\r\n                        </textarea></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-10\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"formProveedor.$invalid || formProveedor.$pending\">Guardar</button> &nbsp;&nbsp;&nbsp; <a class=\"btn btn-default\" ui-sref=\"dashboard.compras.proveedor()\"><i class=\"fa fa-list-alt\"></i> Listado</a></div></div></form></div></div></div>");
$templateCache.put("app/pages/compras/proveedor/proveedorModal.html","<div class=\"modal-content\"><div class=\"modal-header bg-danger\"><i class=\"ion-information-circled modal-icon\"></i><span>Lista de Proveedores</span></div><div class=\"modal-body text-center\"><form class=\"form-horizontal\" name=\"formProveedor\" id=\"formProveedor\" ng-submit=\"guardar(formProveedor)\" novalidate=\"\"><div class=\"form-group has-feedback\"><label for=\"nu_documento\" class=\"col-sm-2 control-label\" style=\"color:black !important\">Tipo de Documento:</label><div class=\"col-sm-4\"><ui-select ng-model=\"data.id_tipo_documento\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Doc. Identid.\">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat=\"docidenti in jDocumentos | filter: $select.search\"><div ng-bind-html=\"docidenti.nombre | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=\"col-sm-6\"><input type=\"text\" class=\"form-control\" id=\"nu_documento\" name=\"nu_documento\" placeholder=\"Nº Documento\" ng-model=\"data.nu_documento\" ng-required=\"true\" style=\"text-transform:uppercase\" ng-keypress=\"getDatosConsulta($event)\" ng-disabled=\"formProveedor.id_tipo_documento.$invalid\"></div></div><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formProveedor.no_proveedor.$invalid && (formProveedor.no_proveedor.$dirty || formProveedor.no_proveedor.$submitted)}\"><label for=\"no_proveedor\" class=\"col-sm-2 control-label\" style=\"color:black !important\">Nombre Proveedor:</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"no_proveedor\" name=\"no_proveedor\" placeholder=\"Nombre Proveddor\" ng-model=\"data.no_proveedor\" ng-required=\"true\" style=\"text-transform:uppercase\" ng-disabled=\"formProveedor.nu_documento.$invalid || formProveedor.nu_documento.$pending\" autocomplete=\"off\"> <span class=\"help-block error-block basic-block\" ng-if=\"formProveedor.no_proveedor.$error\"><p ng-repeat=\"(key, value) in formProveedor.no_proveedor.$error\">{{messages.no_proveedor[key]}}</p></span></div></div><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formProveedor.no_cliente.$invalid && (formProveedor.no_cliente.$dirty || formProveedor.no_cliente.$submitted)}\"><label for=\"co_depart\" class=\"col-sm-2 control-label\" style=\"color:black !important\">Departamento:</label><div class=\"col-sm-2\"><ui-select ng-model=\"data.co_depart\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getpDepartamento()\"><ui-select-match placeholder=\"Departamento\">{{$select.selected.no_departamento}}</ui-select-match><ui-select-choices repeat=\"depart in a_departamento | filter: $select.search\"><div ng-bind-html=\"depart.no_departamento | highlight: $select.search\"></div></ui-select-choices></ui-select></div><label for=\"co_provin\" class=\"col-sm-1 control-label\" style=\"color:black !important\">Provincia:</label><div class=\"col-sm-3\"><ui-select ng-model=\"data.co_provin\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getpProvincia()\"><ui-select-match placeholder=\"Provincia\">{{$select.selected.no_provincia}}</ui-select-match><ui-select-choices repeat=\"prov in a_provincia | filter: $select.search\"><div ng-bind-html=\"prov.no_provincia | highlight: $select.search\"></div></ui-select-choices></ui-select></div><label for=\"co_distri\" class=\"col-sm-1 control-label\" style=\"color:black !important\">Distrito:</label><div class=\"col-sm-3\"><ui-select ng-model=\"data.co_distri\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Distrito\">{{$select.selected.no_distrito}}</ui-select-match><ui-select-choices repeat=\"distri in a_distrito | filter: $select.search\"><div ng-bind-html=\"distri.no_distrito | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"form-group has-feedback\"><label for=\"no_direccion\" class=\"col-sm-2 control-label\" style=\"color:black !important\">Dirección:</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"no_direccion\" name=\"no_direccion\" placeholder=\"Dirección\" ng-model=\"data.no_direccion\" style=\"text-transform:uppercase\" ng-disabled=\"formProveedor.nu_documento.$invalid || formProveedor.nu_documento.$pending\" autocomplete=\"off\"></div></div><div class=\"form-group has-feedback\"><label for=\"nu_telefono\" class=\"col-sm-2 control-label\" style=\"color:black !important\">Contacto:</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"nu_telefono\" name=\"nu_telefono\" placeholder=\"Telefono\" ng-model=\"data.nu_telefono\" style=\"text-transform:uppercase\" ng-disabled=\"formProveedor.nu_documento.$invalid || formProveedor.nu_documento.$pending\" autocomplete=\"off\"></div><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"nu_celular\" name=\"nu_celular\" placeholder=\"Celular\" ng-model=\"data.nu_celular\" style=\"text-transform:uppercase\" ng-disabled=\"formProveedor.nu_documento.$invalid || formProveedor.nu_documento.$pending\" autocomplete=\"off\"></div></div><div class=\"form-group has-feedback\"><label for=\"no_contacto\" class=\"col-sm-2 control-label\" style=\"color:black !important\">Persona / Correo:</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"no_contacto\" name=\"no_contacto\" placeholder=\"Persona de Contacto\" ng-model=\"data.no_contacto\" style=\"text-transform:uppercase\" ng-disabled=\"formProveedor.nu_documento.$invalid || formProveedor.nu_documento.$pending\" autocomplete=\"off\"></div><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"Correo Electronico\" ng-model=\"data.email\" ng-disabled=\"formProveedor.nu_documento.$invalid || formProveedor.nu_documento.$pending\" autocomplete=\"off\"></div></div><div class=\"form-group has-feedback\"><label for=\"nu_cuenta_uno\" class=\"col-sm-2 control-label\" style=\"color:black !important\">N° de Cuentas:</label><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"nu_cuenta_uno\" name=\"nu_cuenta_uno\" placeholder=\"Número de cuenta bancaria\" ng-model=\"data.nu_cuenta_uno\" style=\"text-transform:uppercase\" ng-disabled=\"formProveedor.nu_documento.$invalid || formProveedor.nu_documento.$pending\" autocomplete=\"off\"></div><div class=\"col-sm-5\"><input type=\"text\" class=\"form-control\" id=\"nu_cuenta_dos\" name=\"nu_cuenta_dos\" placeholder=\"Número de cuenta bancaria\" ng-model=\"data.nu_cuenta_dos\" style=\"text-transform:uppercase\" ng-disabled=\"formProveedor.nu_documento.$invalid || formProveedor.nu_documento.$pending\" autocomplete=\"off\"></div></div><div class=\"form-group has-feedback\"><label for=\"no_observacion\" class=\"col-sm-2 control-label\" style=\"color:black !important\">Comentario:</label><div class=\"col-sm-10\"><textarea name=\"no_observacion\" id=\"no_observacion\" ng-model=\"data.no_observacion\" cols=\"15\" rows=\"5\" class=\"input-sm form-control\" placeholder=\"COMENTARIO\">\r\n\r\n                </textarea></div></div><div class=\"form-group\"><div class=\"col-sm-12\"><button type=\"submit\" class=\"btn btn-danger\" ng-disabled=\"formProveedor.$invalid || formProveedor.$pending\">Guardar</button></div></div></form></div></div>");
$templateCache.put("app/pages/comprobantes/boleta/boleta.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Registro de Boleta\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\" ng-class=\"{\'has-error\': formFactura.nu_documento.$invalid}\"><label for=\"nu_documento\" class=\"control-label\">Nº Documento</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" id=\"nu_documento\" name=\"nu_documento\" placeholder=\"Nº Documento\" ng-model=\"data.nu_documento\" ng-required=\"true\" ng-disabled=\"true\" ng-blur=\"consultarNumdocument(formFactura)\" autocomplete=\"off\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" data-toggle=\"modal\" ng-click=\"modalProducts(\'lg\')\"><i class=\"fa fa-search\"></i></button></span></div><span class=\"help-block error-block basic-block\" ng-if=\"formFactura.nu_documento.$error\"><p ng-repeat=\"(key, value) in formFactura.nu_documento.$error\">{{messages.nu_documento[key]}}</p></span></div></div><div class=\"col-md-5\"><div class=\"form-group\" ng-class=\"{\'has-error\': formFactura.no_cliente.$invalid}\"><label for=\"no_cliente\" class=\"control-label\">Cliente</label> <input type=\"text\" class=\"form-control\" id=\"no_cliente\" name=\"no_cliente\" placeholder=\"Apellidos y Nombres\" ng-model=\"data.no_cliente\" ng-disabled=\"true\" style=\"color:rgb(255, 255, 255) !important; text-transform: uppercase;\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"id_tipo_medio_pago\" class=\"control-label\">Medio de Pago:</label><ui-select ng-model=\"data.id_tipo_medio_pago\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Comprobante de Pago\">{{$select.selected.no_tipo_medio_pago}}</ui-select-match><ui-select-choices repeat=\"comprobante in jtipopago | filter: $select.search\"><div ng-bind-html=\"comprobante.no_tipo_medio_pago | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></div><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"id_tipo_comprobante\" class=\"control-label\">Tipo de Comprobante:</label><ui-select ng-model=\"data.id_tipo_comprobante\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getCorrelativo(data)\"><ui-select-match placeholder=\"Comprobante de Pago\">{{$select.selected.descripcion}}</ui-select-match><ui-select-choices repeat=\"comprobante in jComprobante | filter: $select.search\"><div ng-bind-html=\"comprobante.descripcion | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"id_tipo_comprobante\" class=\"control-label\">Nº Boleta:</label><h4 style=\"text-align: center;\">{{data.nu_serie}}{{\'-\'}}{{data.nu_correlativo}}</h4></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" for=\"fe_emision\">Fecha Emision</label><div class=\"input-group\" moment-picker=\"data.fe_emision\" locales=\"es\" start-view=\"month\" format=\"YYYY-MM-DD\"><input class=\"form-control\" id=\"fe_emision\" name=\"fe_emision\" placeholder=\"Seleccione Una Fecha\" ng-model=\"data.fe_emision\" ng-model-options=\"{ updateOn: \'blur\'}\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" for=\"fe_vencimiento\">Fecha Vencimiento</label><div class=\"input-group\" moment-picker=\"data.fe_vencimiento\" locales=\"es\" start-view=\"month\" format=\"YYYY-MM-DD\"><input class=\"form-control\" id=\"fe_vencimiento\" name=\"fe_vencimiento\" placeholder=\"Seleccione Una Fecha\" ng-model=\"data.fe_vencimiento\" ng-model-options=\"{ updateOn: \'blur\'}\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Datos Cotización\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"id_cotizacion\" class=\"control-label\">Cotización:</label><div class=\"input-group\"><ui-select ng-model=\"data.id_cotizacion\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Seleccionar Cotización\">{{$select.selected.value}}</ui-select-match><ui-select-choices repeat=\"value in jCotizacion | filter: $select.search\"><div ng-bind-html=\"value.value | highlight: $select.search\"></div></ui-select-choices></ui-select><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"addItem()\" ng-disabled=\"formFactura.id_cotizacion.$invalid || formFactura.nu_cantidad_p.$invalid\"><i class=\"fa fa-plus\"></i></button></span></div></div></div></div><div class=\"row\"><table class=\"table table-striped\" st-table=\"displayed\" st-safe-src=\"rowCollection\"><thead><tr class=\"sortable\"><th style=\"width:5%; text-align:center;\">Item</th><th style=\"width:10%; text-align:center;\">Codigo</th><th style=\"width:20%; text-align:center;\">Producto</th><th style=\"width:10%; text-align:center;\">Marca</th><th style=\"width:5%; text-align:center;\">Cantidad</th><th style=\"width:5%; text-align:center;\">Precio</th><th style=\"width:5%; text-align:center;\">Total</th><th style=\"width:5%; text-align:center;\">&nbsp;</th></tr></thead><tbody><tr st-select-row=\"row\" st-select-mode=\"multiple\" ng-repeat=\"item in displayed\"><td style=\"text-align:center;\">{{item.id}}</td><td style=\"text-align:left;\">{{item.co_producto}}</td><td style=\"text-align:left;\">{{item.no_producto}}</td><td style=\"text-align:left;\">{{item.no_marca}}</td><td style=\"text-align:right;\">{{item.nu_cantidad}}</td><td style=\"text-align:right;\">{{item.nu_precio}}</td><td style=\"text-align:right;\">{{item.nu_total}}</td><td style=\"text-align:center;\"><button type=\"button\" class=\"btn btn-xs btn-danger\" ng-click=\"quitar_producto(item.id_cotizacion, displayed.indexOf(item))\" title=\"Quitar\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody><tfoot><tr><td colspan=\"7\" style=\"text-align:right\">Total:</td><td style=\"text-align:right\">{{data.nu_total | number:2}}</td></tr><tr><td colspan=\"8\" style=\"text-align:right\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"rowCollection.length==0\" ng-click=\"guardar()\"><i class=\"fa fa-print\"></i> Registrar</button> &nbsp;&nbsp;&nbsp; <a class=\"btn btn-default\" ui-sref=\"dashboard.comprobantes.boleta()\"><i class=\"fa fa-list-alt\"></i> Listado</a></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/comprobantes/boleta/boletaList.html","<div class=\"widgets\"><div class=\"row\"><div ba-panel=\"\" ba-panel-title=\"Listado de Boletas<i ng-click=\'agregar()\' class=\'fa pull-right fa-plus\' style=\' cursor: pointer;\'></i>\" ba-panel-class=\"with-scroll\"><div class=\"form-group\"><div class=\"col-sm-12\"><table st-table=\"displayed\" class=\"table table-striped\" st-pipe=\"callServer\"><thead><tr class=\"sortable\"><th style=\"width:4%;\" class=\"table-id\">#</th><th style=\"width:10%;\">Cliente</th><th style=\"width:6%;\">F. Venta</th><th style=\"width:8%\">Tipo Doc.</th><th style=\"width:3%\">Serie</th><th style=\"width:6%\">Numero</th><th style=\"width:6%;\">Total</th><th style=\"width:6%;\">Estado</th><th style=\"width:6%;\">SUNAT</th><th style=\"width:10%;\">&nbsp;</th></tr><tr><th></th><th><input st-search=\"no_cliente\" placeholder=\"Buscar Nombre\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"fe_emision\" placeholder=\"Buscar Fecha\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"no_tipo_comprobante\" placeholder=\"Buscar Tipo\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"nu_serie\" placeholder=\"Buscar Serie\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"nu_compro\" placeholder=\"Buscar Codigo\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"mto_total\" placeholder=\"Buscar Total\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"no_estado\" placeholder=\"Buscar Estado\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"no_estado_sunat\" placeholder=\"Buscar Sunat\" class=\"input-sm form-control search-input\" type=\"search\"></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_cliente}}</td><td>{{item.fe_emision}}</td><td>{{item.no_tipo_comprobante}}</td><td>{{item.nu_serie}}</td><td>{{item.nu_correlativo}}</td><td>{{item.mto_total }}</td><td><button class=\"status-button btn btn-xs\" style=\"width: 90% !important;\" ng-class=\"{\'btn-warning\': (item.no_estado==\'GENERADO\') , \'btn-success\':(item.no_estado==\'VALIDO\'), \'btn-danger\': (item.no_estado==\'ANULADO\')}\"><i class=\"ion-navigate\"></i> {{item.no_estado}}</button></td><td><button class=\"status-button btn btn-xs\" style=\"width: 90% !important;\" ng-class=\"{\'btn-warning\': (item.no_estado_sunat==\'RESUMEN\') ,\'btn-danger\':(item.no_estado_sunat==\'NO ENVIADO\'), \'btn-info\': (item.no_estado_sunat==\'ENVIADO\')}\"><i class=\"ion-clock\"></i> {{item.no_estado_sunat}}</button></td><td><div class=\"text-center btn-group\" role=\"group\"><button type=\"button\" title=\"Generar Factura y Enviar a la Sunat\" data-toggle=\"popover\" class=\"btn btn-default btn-icon\" ng-click=\"openGenerar(\'lg\',{{item}}, displayCollection.indexOf(item))\" ng-disabled=\"item.id_respuesta==1\"><i class=\"ion-navigate text-primary\"></i></button> <button type=\"button\" title=\"Archivo Pdf\" data-toggle=\"popover\" class=\"btn btn-default btn-icon\" ng-disabled=\"\" ng-click=\"openPdfBoleta(\'lg\',{{item}})\"><i class=\"ion-clipboard text-primary\"></i></button> <button type=\"button\" title=\"Enviar Correo\" data-toggle=\"popover\" class=\"btn btn-default btn-icon\" ng-disabled=\"\" ng-click=\"openCorreo(\'lg\',{{item}})\"><i class=\"ion-link text-success\"></i></button> <button type=\"button\" title=\"Consultar CDR\" data-toggle=\"popover\" class=\"btn btn-default btn-icon\" ng-disabled=\"\" ng-click=\"openConsulta(\'lg\',{{item}})\"><i class=\"ion-code-working text-warning\"></i></button> <button type=\"button\" title=\"Dar de Baja Comprobante\" data-toggle=\"popover\" class=\"btn btn-default btn-icon\" ng-disabled=\"\" ng-click=\"openBaja(\'lg\',{{item}})\"><i class=\"ion-trash-a text-danger\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"10\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"10\"></div></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/comprobantes/factura/factura.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Registro de Factura\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\" ng-class=\"{\'has-error\': formFactura.nu_documento.$invalid}\"><label for=\"nu_documento\" class=\"control-label\">Nº Documento</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" id=\"nu_documento\" name=\"nu_documento\" placeholder=\"Nº Documento\" ng-model=\"data.nu_documento\" ng-required=\"true\" ng-disabled=\"true\" ng-blur=\"consultarNumdocument(formFactura)\" autocomplete=\"off\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"crearProduct(\'lg\')\"><i class=\"fa fa-plus\"></i></button> <button class=\"btn btn-default\" type=\"button\" data-toggle=\"modal\" ng-click=\"modalProducts(\'lg\')\"><i class=\"fa fa-search\"></i></button></span></div><span class=\"help-block error-block basic-block\" ng-if=\"formFactura.nu_documento.$error\"><p ng-repeat=\"(key, value) in formFactura.nu_documento.$error\">{{messages.nu_documento[key]}}</p></span></div></div><div class=\"col-md-5\"><div class=\"form-group\" ng-class=\"{\'has-error\': formFactura.no_cliente.$invalid}\"><label for=\"no_cliente\" class=\"control-label\">Cliente</label> <input type=\"text\" class=\"form-control\" id=\"no_cliente\" name=\"no_cliente\" placeholder=\"Apellidos y Nombres\" ng-model=\"data.no_cliente\" ng-disabled=\"true\" style=\"color:rgb(255, 255, 255) !important; text-transform: uppercase;\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"id_tipo_medio_pago\" class=\"control-label\">Medio de Pago:</label><ui-select ng-model=\"data.id_tipo_medio_pago\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Comprobante de Pago\">{{$select.selected.no_tipo_medio_pago}}</ui-select-match><ui-select-choices repeat=\"comprobante in jtipopago | filter: $select.search\"><div ng-bind-html=\"comprobante.no_tipo_medio_pago | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></div><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"id_tipo_comprobante\" class=\"control-label\">Tipo de Comprobante:</label><ui-select ng-model=\"data.id_tipo_comprobante\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getCorrelativo(data)\"><ui-select-match placeholder=\"Comprobante de Pago\">{{$select.selected.descripcion}}</ui-select-match><ui-select-choices repeat=\"comprobante in jComprobante | filter: $select.search\"><div ng-bind-html=\"comprobante.descripcion | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"id_tipo_comprobante\" class=\"control-label\">Nº Factura:</label><h4 style=\"text-align: center;\">{{data.nu_serie}}{{\'-\'}}{{data.nu_correlativo}}</h4></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" for=\"fe_emision\">Fecha Emision</label><div class=\"input-group\" moment-picker=\"data.fe_emision\" locales=\"es\" start-view=\"month\" format=\"YYYY-MM-DD\"><input class=\"form-control\" id=\"fe_emision\" name=\"fe_emision\" placeholder=\"Seleccione Una Fecha\" ng-model=\"data.fe_emision\" ng-model-options=\"{ updateOn: \'blur\'}\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" for=\"fe_vencimiento\">Fecha Vencimiento</label><div class=\"input-group\" moment-picker=\"data.fe_vencimiento\" locales=\"es\" start-view=\"month\" format=\"YYYY-MM-DD\"><input class=\"form-control\" id=\"fe_vencimiento\" name=\"fe_vencimiento\" placeholder=\"Seleccione Una Fecha\" ng-model=\"data.fe_vencimiento\" ng-model-options=\"{ updateOn: \'blur\'}\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Datos Guia\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"id_guia\" class=\"control-label\">Guia Remisión:</label><div class=\"input-group\"><ui-select ng-model=\"data.id_guia\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Seleccionar Guia Remisión\">{{$select.selected.value}}</ui-select-match><ui-select-choices repeat=\"value in jGuia | filter: $select.search\"><div ng-bind-html=\"value.value | highlight: $select.search\"></div></ui-select-choices></ui-select><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"addItem()\" ng-disabled=\"formFactura.id_guia.$invalid || formFactura.nu_cantidad_p.$invalid\"><i class=\"fa fa-plus\"></i></button></span></div></div></div></div><div class=\"row\"><table class=\"table table-striped\" st-table=\"displayed\" st-safe-src=\"rowCollection\"><thead><tr class=\"sortable\"><th style=\"width:5%; text-align:center;\">Item</th><th style=\"width:10%; text-align:center;\">Codigo</th><th style=\"width:20%; text-align:center;\">Producto</th><th style=\"width:10%; text-align:center;\">Marca</th><th style=\"width:5%; text-align:center;\">Cantidad</th><th style=\"width:5%; text-align:center;\">Precio</th><th style=\"width:5%; text-align:center;\">Total</th><th style=\"width:5%; text-align:center;\">&nbsp;</th></tr></thead><tbody><tr st-select-row=\"row\" st-select-mode=\"multiple\" ng-repeat=\"item in displayed\"><td style=\"text-align:center;\">{{item.id}}</td><td style=\"text-align:left;\">{{item.co_producto}}</td><td style=\"text-align:left;\">{{item.no_producto}}</td><td style=\"text-align:left;\">{{item.no_marca}}</td><td style=\"text-align:right;\">{{item.nu_cantidad}}</td><td style=\"text-align:right;\">{{item.nu_precio}}</td><td style=\"text-align:right;\">{{item.nu_total}}</td><td style=\"text-align:center;\"><button type=\"button\" class=\"btn btn-xs btn-danger\" ng-click=\"quitar_producto(item.id_guia, displayed.indexOf(item))\" title=\"Quitar\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody><tfoot><tr><td colspan=\"6\" style=\"text-align:right\">Total:</td><td style=\"text-align:right\">{{data.nu_total | number:2}}</td></tr><tr><td colspan=\"7\" style=\"text-align:right\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"rowCollection.length==0\" ng-click=\"guardar()\"><i class=\"fa fa-print\"></i> Registrar</button> &nbsp;&nbsp;&nbsp; <a class=\"btn btn-default\" ui-sref=\"dashboard.comprobantes.factura()\"><i class=\"fa fa-list-alt\"></i> Listado</a></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/comprobantes/factura/facturaList.html","<div class=\"widgets\"><div class=\"row\"><div ba-panel=\"\" ba-panel-title=\"Listado de Facturas<i ng-click=\'agregar()\' class=\'fa pull-right fa-plus\' style=\' cursor: pointer;\'></i>\" ba-panel-class=\"with-scroll\"><div class=\"form-group\"><div class=\"col-sm-12\"><table st-table=\"displayed\" class=\"table table-striped\" st-pipe=\"callServer\"><thead><tr class=\"sortable\"><th style=\"width:4%;\" class=\"table-id\">#</th><th style=\"width:10%;\">Cliente</th><th style=\"width:6%;\">F. Venta</th><th style=\"width:8%\">Tipo Doc.</th><th style=\"width:3%\">Serie</th><th style=\"width:6%\">Numero</th><th style=\"width:6%;\">Total</th><th style=\"width:6%;\">Estado</th><th style=\"width:6%;\">SUNAT</th><th style=\"width:10%;\">&nbsp;</th></tr><tr><th></th><th><input st-search=\"no_cliente\" placeholder=\"Buscar Nombre\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"fe_emision\" placeholder=\"Buscar Fecha\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"no_tipo_comprobante\" placeholder=\"Buscar Tipo\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"nu_serie\" placeholder=\"Buscar Serie\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"nu_compro\" placeholder=\"Buscar Codigo\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"mto_total\" placeholder=\"Buscar Total\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"no_estado\" placeholder=\"Buscar Estado\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"no_estado_sunat\" placeholder=\"Buscar Sunat\" class=\"input-sm form-control search-input\" type=\"search\"></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_cliente}}</td><td>{{item.fe_emision}}</td><td>{{item.no_tipo_comprobante}}</td><td>{{item.nu_serie}}</td><td>{{item.nu_correlativo}}</td><td>{{item.mto_total }}</td><td><button class=\"status-button btn btn-xs\" style=\"width: 90% !important;\" ng-class=\"{\'btn-warning\': (item.no_estado==\'GENERADO\') , \'btn-success\':(item.no_estado==\'VALIDO\'), \'btn-danger\': (item.no_estado==\'ANULADO\')}\"><i class=\"ion-navigate\"></i> {{item.no_estado}}</button></td><td><button class=\"status-button btn btn-xs\" style=\"width: 90% !important;\" ng-class=\"{\'btn-warning\': (item.no_estado_sunat==\'RESUMEN\') ,\'btn-danger\':(item.no_estado_sunat==\'NO ENVIADO\'), \'btn-info\': (item.no_estado_sunat==\'ENVIADO\')}\"><i class=\"ion-clock\"></i> {{item.no_estado_sunat}}</button></td><td><div class=\"text-center btn-group\" role=\"group\"><button type=\"button\" title=\"Generar Factura y Enviar a la Sunat\" data-toggle=\"popover\" class=\"btn btn-default btn-icon\" ng-click=\"openGenerar(\'lg\',{{item}}, displayCollection.indexOf(item))\" ng-disabled=\"item.id_estado_sunat==1\"><i class=\"ion-navigate text-primary\"></i></button> <button type=\"button\" title=\"Archivo Pdf\" data-toggle=\"popover\" class=\"btn btn-default btn-icon\" ng-disabled=\"\" ng-click=\"openPdfFactura(\'lg\',{{item}})\"><i class=\"ion-clipboard text-primary\"></i></button> <button type=\"button\" title=\"Enviar Correo\" data-toggle=\"popover\" class=\"btn btn-default btn-icon\" ng-disabled=\"\" ng-click=\"openCorreo(\'lg\',{{item}})\"><i class=\"ion-link text-success\"></i></button> <button type=\"button\" title=\"Consultar CDR\" data-toggle=\"popover\" class=\"btn btn-default btn-icon\" ng-disabled=\"\" ng-click=\"openConsulta(\'lg\',{{item}})\"><i class=\"ion-code-working text-warning\"></i></button> <button type=\"button\" title=\"Dar de Baja Comprobante\" data-toggle=\"popover\" class=\"btn btn-default btn-icon\" ng-disabled=\"\" ng-click=\"openBaja(\'lg\',{{item}})\"><i class=\"ion-trash-a text-danger\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"10\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"10\"></div></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/comprobantes/guia/guia.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Registro de Guia\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\" ng-class=\"{\'has-error\': formVenta.nu_documento.$invalid}\"><label for=\"nu_documento\" class=\"control-label\">Nº Documento</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" id=\"nu_documento\" name=\"nu_documento\" placeholder=\"Nº Documento\" ng-model=\"data.nu_documento\" ng-required=\"true\" ng-disabled=\"true\" ng-blur=\"consultarNumdocument(formVenta)\" autocomplete=\"off\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" data-toggle=\"modal\" ng-click=\"modalProducts(\'lg\')\"><i class=\"fa fa-search\"></i></button></span></div><span class=\"help-block error-block basic-block\" ng-if=\"formVenta.nu_documento.$error\"><p ng-repeat=\"(key, value) in formVenta.nu_documento.$error\">{{messages.nu_documento[key]}}</p></span></div></div><div class=\"col-md-5\"><div class=\"form-group\" ng-class=\"{\'has-error\': formVenta.no_cliente.$invalid}\"><label for=\"no_cliente\" class=\"control-label\">Cliente</label> <input type=\"text\" class=\"form-control\" id=\"no_cliente\" name=\"no_cliente\" placeholder=\"Apellidos y Nombres\" ng-model=\"data.no_cliente\" ng-disabled=\"true\" style=\"color:rgb(255, 255, 255) !important; text-transform: uppercase;\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"id_local\" class=\"control-label\">Punto Partida:</label><ui-select ng-model=\"data.id_local\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Comprobante de Pago\">{{$select.selected.no_local}}</ui-select-match><ui-select-choices repeat=\"comprobante in jSucursal | filter: $select.search\"><div ng-bind-html=\"comprobante.no_local | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></div><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"id_tipo_comprobante\" class=\"control-label\">Tipo de Comprobante:</label><ui-select ng-model=\"data.id_tipo_comprobante\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getCorrelativo(data)\"><ui-select-match placeholder=\"Comprobante de Pago\">{{$select.selected.descripcion}}</ui-select-match><ui-select-choices repeat=\"comprobante in jComprobante | filter: $select.search\"><div ng-bind-html=\"comprobante.descripcion | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"id_tipo_comprobante\" class=\"control-label\">Nº Cotización:</label><h4 style=\"text-align: center;\">{{data.nu_serie}}{{\'-\'}}{{data.nu_correlativo}}</h4></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" for=\"fe_emision\">Fecha Emision</label><div class=\"input-group\" moment-picker=\"data.fe_emision\" locales=\"es\" start-view=\"month\" format=\"YYYY-MM-DD\"><input class=\"form-control\" id=\"fe_emision\" name=\"fe_emision\" placeholder=\"Seleccione Una Fecha\" ng-model=\"data.fe_emision\" ng-model-options=\"{ updateOn: \'blur\'}\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" for=\"fe_vencimiento\">Fecha Vencimiento</label><div class=\"input-group\" moment-picker=\"data.fe_vencimiento\" locales=\"es\" start-view=\"month\" format=\"YYYY-MM-DD\"><input class=\"form-control\" id=\"fe_vencimiento\" name=\"fe_vencimiento\" placeholder=\"Seleccione Una Fecha\" ng-model=\"data.fe_vencimiento\" ng-model-options=\"{ updateOn: \'blur\'}\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><br><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Datos de Envio\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"id_motivo\" class=\"control-label\">Motivo de Traslado:</label><ui-select ng-model=\"data.id_motivo\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Motivo de Traslado\">{{$select.selected.no_motivo}}</ui-select-match><ui-select-choices repeat=\"value in jMotivo | filter: $select.search\"><div ng-bind-html=\"value.no_motivo | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-md-4\"><div class=\"form-group\" ng-class=\"{\'has-error\': formVenta.nu_bultos.$invalid}\"><label for=\"nu_bultos\" class=\"control-label\">N.º de Bultos o Pallets(*)</label> <input type=\"text\" class=\"form-control\" id=\"nu_bultos\" name=\"nu_bultos\" placeholder=\"Numero de Bultos\" ng-model=\"data.nu_bultos\" style=\"color:rgb(255, 255, 255) !important; text-transform: uppercase;\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"id_modalidad\" class=\"control-label\">Modalidad de Traslado:</label><ui-select ng-model=\"data.id_modalidad\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getTipoModalidad(data)\" style=\"color:rgb(255, 255, 255) !important; text-transform: uppercase;\"><ui-select-match placeholder=\"Modalidad de Translado\">{{$select.selected.no_modalidad}}</ui-select-match><ui-select-choices repeat=\"value in jModalidad | filter: $select.search\"><div ng-bind-html=\"value.no_modalidad | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></div></div><div class=\"col-md-12\" ng-show=\"data.id_modalidad==2\" ba-panel=\"\" ba-panel-title=\"Transporte Privado\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\" ng-class=\"{\'has-error\': formVenta.nu_placa.$invalid}\"><label for=\"nu_placa\" class=\"control-label\">Número de Placa</label> <input type=\"text\" class=\"form-control\" id=\"nu_placa\" name=\"nu_placa\" placeholder=\"Número de Placa\" ng-model=\"data.nu_placa\" style=\"color:rgb(255, 255, 255) !important; text-transform: uppercase;\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"id_tipo_documento\" class=\"control-label\">N.º de Constancia de Inscripción:</label><ui-select ng-model=\"data.id_tipo_documento\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Seleccionar Tipo Documento\">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat=\"value in jDocumentos | filter: $select.search\"><div ng-bind-html=\"value.nombre | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-md-4\"><div class=\"form-group\" ng-class=\"{\'has-error\': formVenta.nu_documento_entidad.$invalid}\"><label for=\"nu_documento_entidad\" class=\"control-label\">N.º de Documento de Identidad</label> <input type=\"text\" class=\"form-control\" id=\"nu_documento_entidad\" name=\"nu_documento_entidad\" placeholder=\"Número de Documento\" ng-model=\"data.nu_documento_entidad\" style=\"color:rgb(255, 255, 255) !important; text-transform: uppercase;\"></div></div></div></div><div class=\"col-md-12\" ng-show=\"data.id_modalidad==1\" ba-panel=\"\" ba-panel-title=\"Transporte Publico\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"id_tipo_empresa\" class=\"control-label\">Empresa de Transporte:</label><ui-select ng-model=\"data.id_tipo_empresa\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Seleccionar Empresa\">{{$select.selected.no_tipo_empresa}}</ui-select-match><ui-select-choices repeat=\"value in jTipoEmpresa | filter: $select.search\"><div ng-bind-html=\"value.no_tipo_empresa | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"no_observacion\" class=\"control-label\">Comentario:</label> <input type=\"text\" class=\"form-control\" id=\"no_observacion\" name=\"no_observacion\" placeholder=\"Ingrese aqui su comentario\" ng-model=\"data.no_observacion\" ng-required=\"true\"></div></div></div><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Datos Cotización\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"id_cotizacion\" class=\"control-label\">Cotizaciones:</label><div class=\"input-group\"><ui-select ng-model=\"data.id_cotizacion\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Seleccionar Cotizacióm\">{{$select.selected.value}}</ui-select-match><ui-select-choices repeat=\"value in jCotizacion | filter: $select.search\"><div ng-bind-html=\"value.value | highlight: $select.search\"></div></ui-select-choices></ui-select><span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"addItem()\" ng-disabled=\"formVenta.va_precio_producto.$invalid || formVenta.nu_cantidad_p.$invalid\"><i class=\"fa fa-plus\"></i></button></span></div></div></div></div><div class=\"row\"><table class=\"table table-striped\" st-table=\"displayed\" st-safe-src=\"rowCollection\"><thead><tr class=\"sortable\"><th style=\"width:5%; text-align:center;\">Item</th><th style=\"width:10%; text-align:center;\">Codigo</th><th style=\"width:20%; text-align:center;\">Producto</th><th style=\"width:10%; text-align:center;\">Marca</th><th style=\"width:5%; text-align:center;\">Cantidad</th><th style=\"width:5%; text-align:center;\">Coti</th><th style=\"width:5%; text-align:center;\">&nbsp;</th></tr></thead><tbody><tr st-select-row=\"row\" st-select-mode=\"multiple\" ng-repeat=\"item in displayed\"><td style=\"text-align:center;\">{{item.id}}</td><td style=\"text-align:left;\">{{item.co_producto}}</td><td style=\"text-align:left;\">{{item.no_producto}}</td><td style=\"text-align:left;\">{{item.no_marca}}</td><td style=\"text-align:right;\">{{item.nu_cantidad}}</td><td style=\"text-align:right;\">{{item.id_cotizacion}}</td><td style=\"text-align:center;\"><button type=\"button\" class=\"btn btn-xs btn-danger\" ng-click=\"quitar_producto(item.id_cotizacion, displayed.indexOf(item))\" title=\"Quitar\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody><tfoot><tr><td colspan=\"7\" style=\"text-align:right\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"rowCollection.length==0\" ng-click=\"guardar()\"><i class=\"fa fa-print\"></i> Registrar</button> &nbsp;&nbsp;&nbsp; <a class=\"btn btn-default\" ui-sref=\"dashboard.comprobantes.guia()\"><i class=\"fa fa-list-alt\"></i> Listado</a></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/comprobantes/guia/guiaList.html","<div class=\"widgets\"><div class=\"row\"><div ba-panel=\"\" ba-panel-title=\"Listado de Guias de Remisión<i ng-click=\'agregar()\' class=\'fa pull-right fa-plus\' style=\' cursor: pointer;\'></i>\" ba-panel-class=\"with-scroll\"><div class=\"form-group\"><div class=\"col-sm-12\"><table st-table=\"displayed\" class=\"table table-striped\" st-pipe=\"callServer\"><thead><tr class=\"sortable\"><th style=\"width:4%;\" class=\"table-id\">#</th><th style=\"width:5%\" st-sort=\"FechaEmision\">Fecha</th><th style=\"width:8%\" st-sort=\"ReferenciaDoc\">Tipo Doc.</th><th style=\"width:3%\" st-sort=\"CodDocumentoSerie\">Serie</th><th style=\"width:6%\" st-sort=\"CodDocumento\">Numero</th><th style=\"width:15%\" st-sort=\"no_cliente\">Cliente</th><th style=\"width:5%\">Acciones</th></tr><tr><th></th><th><input st-search=\"fe_emision\" placeholder=\"Buscar Fecha\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"no_compro\" placeholder=\"Buscar Tipo\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"nu_serie\" placeholder=\"Buscar Serie\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"nu_compro\" placeholder=\"Buscar Codigo\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"no_cliente\" placeholder=\"Buscar Nombre\" class=\"input-sm form-control search-input\" type=\"search\"></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.fe_emision}}</td><td>{{item.no_tipo_comprobante}}</td><td>{{item.nu_serie}}</td><td>{{item.nu_correlativo}}</td><td>{{item.no_cliente}}</td><td><div class=\"text-center btn-group\" role=\"group\"><button type=\"button\" title=\"Archivo Pdf\" data-toggle=\"popover\" class=\"btn btn-default btn-icon\" ng-disabled=\"\" ng-click=\"openPdfGuia(\'lg\',{{item}})\"><i class=\"ion-clipboard text-primary\"></i></button> <button type=\"button\" title=\"Enviar Correo\" data-toggle=\"popover\" class=\"btn btn-default btn-icon\" ng-disabled=\"\" ng-click=\"openCorreo(\'lg\',{{item}})\"><i class=\"ion-link text-success\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"7\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"10\"></div></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/comprobantes/notacredito/notacredito.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Registro de Nota de Credito\"><div class=\"row\"><div class=\"col-md-5\"><div class=\"form-group\" ng-class=\"{\'has-error\': formNotaCredito.nu_documento.$invalid}\"><label for=\"nu_documento\" class=\"control-label\">Nº Documento</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" id=\"nu_documento\" name=\"nu_documento\" placeholder=\"Nº Documento\" ng-model=\"data.nu_documento\" ng-required=\"true\" ng-disabled=\"true\" ng-blur=\"consultarNumdocument(formNotaCredito)\" autocomplete=\"off\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" data-toggle=\"modal\" ng-click=\"modalProducts(\'lg\')\"><i class=\"fa fa-search\"></i></button></span></div><span class=\"help-block error-block basic-block\" ng-if=\"formNotaCredito.nu_documento.$error\"><p ng-repeat=\"(key, value) in formNotaCredito.nu_documento.$error\">{{messages.nu_documento[key]}}</p></span></div></div><div class=\"col-md-7\"><div class=\"form-group\" ng-class=\"{\'has-error\': formNotaCredito.no_cliente.$invalid}\"><label for=\"no_cliente\" class=\"control-label\">Cliente</label> <input type=\"text\" class=\"form-control\" id=\"no_cliente\" name=\"no_cliente\" placeholder=\"Apellidos y Nombres\" ng-model=\"data.no_cliente\" ng-disabled=\"true\" style=\"color:rgb(255, 255, 255) !important; text-transform: uppercase;\"></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"id_tipo_comprobante\" class=\"control-label\">Tipo de Comprobante:</label><ui-select ng-model=\"data.id_tipo_comprobante\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getCorrelativo(data)\"><ui-select-match placeholder=\"Comprobante de Pago\">{{$select.selected.descripcion}}</ui-select-match><ui-select-choices repeat=\"comprobante in jComprobante | filter: $select.search\"><div ng-bind-html=\"comprobante.descripcion | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"id_tipo_comprobante\" class=\"control-label\">Nº Factura:</label><h4 style=\"text-align: center;\">{{data.nu_serie}}{{\'-\'}}{{data.nu_correlativo}}</h4></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label class=\"control-label\" for=\"fe_emision\">Fecha Emision</label><div class=\"input-group\" moment-picker=\"data.fe_emision\" locales=\"es\" start-view=\"month\" format=\"YYYY-MM-DD\"><input class=\"form-control\" id=\"fe_emision\" name=\"fe_emision\" placeholder=\"Seleccione Una Fecha\" ng-model=\"data.fe_emision\" ng-model-options=\"{ updateOn: \'blur\'}\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"DETALLE NOTA DE CREDITO\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"id_tipo_comprobante_d\" class=\"control-label\">Tipo de Comprobante:</label><ui-select ng-model=\"data.id_tipo_comprobante_d\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getComprobantesoBoloFac(data)\"><ui-select-match placeholder=\"Tipo de Comprobante\">{{$select.selected.descripcion}}</ui-select-match><ui-select-choices repeat=\"comprobante in jComprobanteBolFac | filter: $select.search\"><div ng-bind-html=\"comprobante.descripcion | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"id_almacen\" class=\"control-label\">Almacen Destino:</label><ui-select ng-model=\"data.id_almacen\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Almacen Destino\">{{$select.selected.no_almacen}}</ui-select-match><ui-select-choices repeat=\"destino in jAlmacenDestino | filter: $select.search\"><div ng-bind-html=\"destino.no_almacen | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"id_motivo_nota\" class=\"control-label\">Motivo:</label><ui-select ng-model=\"data.id_motivo_nota\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getMotivo(data)\"><ui-select-match placeholder=\"Tipo de Motivo\">{{$select.selected.no_motivo_nota}}</ui-select-match><ui-select-choices repeat=\"motivo in jMotivo | filter: $select.search\"><div ng-bind-html=\"motivo.no_motivo_nota | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"no_motivo\" class=\"control-label\">Descripción Motivo</label> <input type=\"text\" class=\"form-control\" id=\"no_motivo\" name=\"no_motivo\" placeholder=\"Descripción de Motivo\" ng-model=\"data.no_motivo\" ng-disabled=\"{{id_motivo_nota=10}}\" style=\"color:rgb(255, 255, 255) !important; text-transform: uppercase;\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"id_comprobantes\" class=\"control-label\">Comprobante:</label><ui-select ng-model=\"data.id_comprobantes\" ng-change=\"addItem()\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Seleccionar Comprobante\">{{$select.selected.value}}</ui-select-match><ui-select-choices repeat=\"value in jComprobanteNota | filter: $select.search\"><div ng-bind-html=\"value.value | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></div><div class=\"row\"><table class=\"table table-striped\" st-table=\"editableTableData\"><thead><tr class=\"sortable\"><th style=\"width:5%; text-align:center;\">Item</th><th style=\"width:10%; text-align:center;\">Codigo</th><th style=\"width:50%; text-align:center;\">Producto</th><th style=\"width:10%; text-align:center;\">Marca</th><th style=\"width:5%; text-align:center;\">Cantidad</th><th style=\"width:10%; text-align:center;\">Precio</th><th style=\"width:10%; text-align:center;\">Total</th><th style=\"width:5%; text-align:center;\">&nbsp;</th></tr></thead><tbody><tr class=\"editable-tr-wrap\" ng-repeat=\"item in rowCollection\"><td style=\"text-align:center;\">{{item.id}}</td><td style=\"text-align:left;\">{{item.co_producto}}</td><td style=\"text-align:left;\">{{item.no_producto}}</td><td style=\"text-align:left;\">{{item.no_marca}}</td><td style=\"text-align:right;\"><span editable-text=\"item.nu_cantidad\" blur=\"cancel\">{{item.nu_cantidad}}</span></td><td style=\"text-align:right;\"><span editable-text=\"item.nu_precio\" blur=\"cancel\">{{item.nu_precio | number:2}}</span></td><td style=\"text-align:center;\"><button type=\"button\" class=\"btn btn-xs btn-danger\" ng-click=\"quitar_producto(item.id, displayed.indexOf(item))\" title=\"Quitar\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody><tfoot><tr><td colspan=\"7\" style=\"text-align:right\">Total:</td><td style=\"text-align:right\">{{data.mto_total | number:2}}</td></tr><tr><td colspan=\"8\" style=\"text-align:right\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"rowCollection.length==0\" ng-click=\"guardar()\"><i class=\"fa fa-print\"></i> Registrar</button> &nbsp;&nbsp;&nbsp; <a class=\"btn btn-default\" ui-sref=\"dashboard.comprobantes.notacredito()\"><i class=\"fa fa-list-alt\"></i> Listado</a></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/comprobantes/notacredito/notacreditoList.html","<div class=\"widgets\"><div class=\"row\"><div ba-panel=\"\" ba-panel-title=\"Listado de Notas de Credito<i ng-click=\'agregar()\' class=\'fa pull-right fa-plus\' style=\' cursor: pointer;\'></i>\" ba-panel-class=\"with-scroll\"><div class=\"form-group\"><div class=\"col-sm-12\"><table st-table=\"displayed\" class=\"table table-striped\" st-pipe=\"callServer\"><thead><tr class=\"sortable\"><th style=\"width:4%;\" class=\"table-id\">#</th><th style=\"width:10%;\">Cliente</th><th style=\"width:6%;\">F. Nota Credito</th><th style=\"width:8%\">Tipo Doc.</th><th style=\"width:3%\">Serie</th><th style=\"width:6%\">Numero</th><th style=\"width:6%;\">Total</th><th style=\"width:6%;\">Estado</th><th style=\"width:6%;\">SUNAT</th><th style=\"width:10%;\">&nbsp;</th></tr><tr><th></th><th><input st-search=\"no_cliente\" placeholder=\"Buscar Nombre\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"fe_emision\" placeholder=\"Buscar Fecha\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"no_tipo_comprobante\" placeholder=\"Buscar Tipo\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"nu_serie\" placeholder=\"Buscar Serie\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"nu_compro\" placeholder=\"Buscar Codigo\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"mto_total\" placeholder=\"Buscar Total\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"no_estado\" placeholder=\"Buscar Estado\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"no_estado_sunat\" placeholder=\"Buscar Sunat\" class=\"input-sm form-control search-input\" type=\"search\"></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_cliente}}</td><td>{{item.fe_emision}}</td><td>{{item.no_tipo_comprobante}}</td><td>{{item.nu_serie}}</td><td>{{item.nu_correlativo}}</td><td>{{item.mto_total }}</td><td><button class=\"status-button btn btn-xs\" style=\"width: 90% !important;\" ng-class=\"{\'btn-warning\': (item.no_estado==\'GENERADO\') , \'btn-success\':(item.no_estado==\'VALIDO\'), \'btn-danger\': (item.no_estado==\'ANULADO\')}\"><i class=\"ion-navigate\"></i> {{item.no_estado}}</button></td><td><button class=\"status-button btn btn-xs\" style=\"width: 90% !important;\" ng-class=\"{\'btn-warning\': (item.no_estado_sunat==\'RESUMEN\') ,\'btn-danger\':(item.no_estado_sunat==\'NO ENVIADO\'), \'btn-info\': (item.no_estado_sunat==\'ENVIADO\')}\"><i class=\"ion-clock\"></i> {{item.no_estado_sunat}}</button></td><td><div class=\"text-center btn-group\" role=\"group\"><button type=\"button\" title=\"Generar Nota de Credito y Enviar a la Sunat\" data-toggle=\"popover\" class=\"btn btn-default btn-icon\" ng-click=\"openGenerar(\'lg\',{{item}}, displayCollection.indexOf(item))\" ng-disabled=\"item.id_respuesta==1\"><i class=\"ion-navigate text-primary\"></i></button> <button type=\"button\" title=\"Archivo Pdf\" data-toggle=\"popover\" class=\"btn btn-default btn-icon\" ng-disabled=\"\" ng-click=\"openPdfNotaCredito(\'lg\',{{item}})\"><i class=\"ion-clipboard text-primary\"></i></button> <button type=\"button\" title=\"Enviar Correo\" data-toggle=\"popover\" class=\"btn btn-default btn-icon\" ng-disabled=\"\" ng-click=\"openCorreo(\'lg\',{{item}})\"><i class=\"ion-link text-success\"></i></button> <button type=\"button\" title=\"Consultar CDR\" data-toggle=\"popover\" class=\"btn btn-default btn-icon\" ng-disabled=\"\" ng-click=\"openConsulta(\'lg\',{{item}})\"><i class=\"ion-code-working text-warning\"></i></button> <button type=\"button\" title=\"Dar de Baja Comprobante\" data-toggle=\"popover\" class=\"btn btn-default btn-icon\" ng-disabled=\"\" ng-click=\"openBaja(\'lg\',{{item}})\"><i class=\"ion-trash-a text-danger\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"10\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"10\"></div></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/comprobantes/notadebito/notadebito.html","");
$templateCache.put("app/pages/comprobantes/notadebito/notadebitoList.html","");
$templateCache.put("app/pages/contabilidad/bancos/bancos.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-5\" ba-panel=\"\" ba-panel-title=\"Registro de Bancos\" ba-panel-class=\"with-scroll\"><form class=\"form-horizontal\" name=\"formBanco\" id=\"formBanco\" ng-submit=\"guardar(formBanco)\" novalidate=\"\"><div class=\"col-sm-9\"><input id=\"no_banco\" ng-model=\"data.no_banco\" class=\"input-sm form-control\" placeholder=\"Nombre Banco\" type=\"text\"></div><div class=\"col-sm-3\" style=\"text-align: center;\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"formBanco.$invalid || formBanco.$pending\">GUARDAR</button></div></form></div><div class=\"col-md-7\" ba-panel=\"\" ba-panel-title=\"Lista de Bancos\" ba-panel-class=\"with-scroll\"><div class=\"form-group\"><div class=\"col-sm-12\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:4%;\" class=\"table-id\">#</th><th style=\"width:6%;\">Nombre Banco</th><th style=\"width:10%;\">&nbsp;</th></tr><tr><th></th><th><input st-search=\"no_banco\" class=\"input-sm form-control\" placeholder=\"Busqueda Banco ...\" type=\"search\"></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_banco}}</td><td><div class=\"btn-group\" role=\"group\"><a class=\"btn btn-xs btn-success\" title=\"Editar\" ng-click=\"editar(item)\"><i class=\"ion-edit\"></i></a> <button class=\"btn btn-xs\" ng-class=\"(item.status==\'1\')?\'btn-success\':\'btn-danger\'\" ng-click=\"changeStatus(item.id_banco, item.status, displayed.indexOf(item))\" title=\"Activar/inactivar\"><i class=\"fa\" ng-class=\"(item.status==\'1\')?\'fa-check\':\'fa-ban\'\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"3\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/contabilidad/cobrar/cobrar.html","<div class=\"widgets\"><div class=\"row\"><div ba-panel=\"\" ba-panel-title=\"Listado de Cuentas por Cobrar\" ba-panel-class=\"with-scroll\"><div class=\"form-group\"><div class=\"col-sm-12\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:4%;\" class=\"table-id\">#</th><th style=\"width:10%;\">Cliente</th><th style=\"width:6%;\">F. Venta</th><th style=\"width:6%;\">Comprobante</th><th style=\"width:6%;\">N° Comprobante</th><th style=\"width:6%;\">Total</th><th style=\"width:6%;\">Estado</th></tr><tr><th></th><th><input st-search=\"no_cliente\" class=\"input-sm form-control\" placeholder=\"Busqueda Cliente\" type=\"search\"></th><th><input st-search=\"fe_emision\" class=\"input-sm form-control\" placeholder=\"Busqueda Fecha\" type=\"search\"></th><th><input st-search=\"no_tipo_comprobante\" class=\"input-sm form-control\" placeholder=\"Busqueda Tipo Comprobante\" type=\"search\"></th><th><input st-search=\"numero_comprobante\" class=\"input-sm form-control\" placeholder=\"Busqueda Numero\" type=\"search\"></th><th><input st-search=\"nu_total\" class=\"input-sm form-control\" placeholder=\"Busqueda Monto\" type=\"search\"></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_cliente }}</td><td>{{item.fe_emision | date:\'dd-MM-yyyy\' }}</td><td>{{item.no_tipo_comprobante }}</td><td>{{item.numero_comprobante }}</td><td>{{item.nu_total }}</td><td><button class=\"status-button btn btn-xs\" style=\"width: 100% !important;\" ng-class=\"{\'btn-danger\': (item.estado==\'DEBE\')}\"><i class=\"ion-navigate\"></i> {{item.estado}}</button></td></tr></tbody><tfoot><tr><td colspan=\"7\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/contabilidad/cuentas/cuentas.html","<div class=\"widgets\" ng-init=\"consultar()\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Cuenta Bancaria\" ba-panel-class=\"with-scroll\"><form class=\"form-horizontal\" name=\"formCuenta\" id=\"formCuenta\" ng-submit=\"guardar(formCuenta)\" novalidate=\"\"><div class=\"form-group has-feedback\"><label for=\"nu_documento\" class=\"col-sm-2 control-label\">Empresa:</label><div class=\"col-sm-10\"><ui-select id=\"id_empresa\" ng-model=\"data.id_empresa\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\" ng-change=\"getSucursal(data.id_empresa)\"><ui-select-match placeholder=\"Empresa\">{{$select.selected.no_empresa}}</ui-select-match><ui-select-choices repeat=\"empresa in jEmpresa | filter: $select.search\"><span ng-bind-html=\"empresa.no_empresa\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group has-feedback\"><label for=\"nu_documento\" class=\"col-sm-2 control-label\">Sucursal:</label><div class=\"col-sm-10\"><ui-select id=\"id_local\" ng-model=\"data.id_local\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\"><ui-select-match placeholder=\"Sucursal\">{{$select.selected.no_local}}</ui-select-match><ui-select-choices repeat=\"local in jSucursal | filter: $select.search\"><span ng-bind-html=\"local.no_local\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group has-feedback\"><label for=\"id_banco\" class=\"col-sm-2 control-label\">Banco:</label><div class=\"col-sm-10\"><ui-select id=\"id_banco\" ng-model=\"data.id_banco\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\"><ui-select-match placeholder=\"Banco\">{{$select.selected.no_banco}}</ui-select-match><ui-select-choices repeat=\"banco in jBancos | filter: $select.search\"><span ng-bind-html=\"banco.no_banco\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group has-feedback\"><label for=\"nu_cuenta_bancaria\" class=\"col-sm-2 control-label\">N° Cuenta:</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"nu_cuenta_bancaria\" name=\"nu_cuenta_bancaria\" placeholder=\"Numero Cuenta\" ng-model=\"data.nu_cuenta_bancaria\" style=\"text-transform:uppercase\" autocomplete=\"off\"></div></div><div class=\"form-group has-feedback\"><label for=\"va_saldo\" class=\"col-sm-2 control-label\">Saldo:</label><div class=\"col-sm-4\"><input type=\"text\" class=\"form-control\" id=\"va_saldo\" name=\"va_saldo\" placeholder=\"Saldo\" ng-model=\"data.va_saldo\" autocomplete=\"off\"></div></div><div class=\"form-group has-feedback\"><label class=\"col-sm-2 control-label\" for=\"fe_apertura\">Fecha Apertura</label><div class=\"col-sm-4\"><div class=\"input-group\" moment-picker=\"data.fe_apertura\" locales=\"es\" start-view=\"month\" format=\"YYYY-MM-DD\"><input class=\"form-control\" id=\"fe_apertura\" name=\"fe_apertura\" placeholder=\"Seleccione Una Fecha\" ng-model=\"data.fe_apertura\" ng-disabled=\"formOCompra.idtip_documento.$invalid\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-10\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"formCuenta.$invalid || formCuenta.$pending\">Guardar</button> &nbsp;&nbsp;&nbsp; <a class=\"btn btn-default\" ui-sref=\"dashboard.contabilidad.cuentas()\"><i class=\"fa fa-list-alt\"></i> Listado</a></div></div></form></div></div></div>");
$templateCache.put("app/pages/contabilidad/pagar/pagar.html","<div class=\"widgets\"><div class=\"row\"><div ba-panel=\"\" ba-panel-title=\"Listado de Cuenas por Pagar\" ba-panel-class=\"with-scroll\"><div class=\"form-group\"><div class=\"col-sm-12\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:4%;\" class=\"table-id\">#</th><th style=\"width:15%;\">Proveedor</th><th style=\"width:5%;\">Tipo C.</th><th style=\"width:6%;\">Comprobante</th><th style=\"width:5%;\">Fecha C.</th><th style=\"width:6%;\">Total</th><th style=\"width:5%;\">Fecha P.</th><th style=\"width:10%;\">Condicion Pago</th></tr><tr><th></th><th><input st-search=\"no_proveedor\" class=\"input-sm form-control\" placeholder=\"Busqueda proveedor ...\" type=\"search\"></th><th><input st-search=\"no_tipo_comprobante\" class=\"input-sm form-control\" placeholder=\"Busqueda Tipo ...\" type=\"search\"></th><th><input st-search=\"nu_comprobante\" class=\"input-sm form-control\" placeholder=\"Busqueda Comprobante ...\" type=\"search\"></th><th><input st-search=\"fe_registro\" class=\"input-sm form-control\" placeholder=\"Busqueda Fecha ...\" type=\"search\"></th><th><input st-search=\"nu_total\" class=\"input-sm form-control\" placeholder=\"Busqueda Monto ...\" type=\"search\"></th><th><input st-search=\"fe_pago\" class=\"input-sm form-control\" placeholder=\"Busqueda Pago ...\" type=\"search\"></th><th><input st-search=\"no_condicion_pago\" class=\"input-sm form-control\" placeholder=\"Busqueda Condición ...\" type=\"search\"></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_proveedor }}</td><td>{{item.no_tipo_comprobante }}</td><td>{{item.nu_comprobante }}</td><td>{{item.fe_registro | date:\'dd-MM-yyyy\'}}</td><td>{{item.nu_total| number:2 }}</td><td>{{item.fe_pago | date:\'dd-MM-yyyy\'}}</td><td><button class=\"status-button btn btn-xs\" style=\"width: 100% !important;\" ng-class=\"{\'btn-danger\': (item.no_condicion_pago==\'CREDITO\')}\"><i class=\"ion-navigate\"></i> {{item.no_condicion_pago}}</button></td></tr></tbody><tfoot><tr><td colspan=\"8\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/contabilidad/pasivos/pasivos.html","<div class=\"widgets\" ng-init=\"consultar()\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Registro de Pasivo\" ba-panel-class=\"with-scroll\"><form class=\"form-horizontal\" name=\"formPasivo\" id=\"formPasivo\" ng-submit=\"guardar(formPasivo)\" novalidate=\"\"><div class=\"form-group has-feedback\"><label for=\"nu_documento\" class=\"col-sm-2 control-label\">Empresa:</label><div class=\"col-sm-10\"><ui-select id=\"id_empresa\" ng-model=\"data.id_empresa\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\" ng-change=\"getSucursal(data.id_empresa)\"><ui-select-match placeholder=\"Empresa\">{{$select.selected.no_empresa}}</ui-select-match><ui-select-choices repeat=\"empresa in jEmpresa | filter: $select.search\"><span ng-bind-html=\"empresa.no_empresa\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group has-feedback\"><label for=\"nu_documento\" class=\"col-sm-2 control-label\">Sucursal:</label><div class=\"col-sm-10\"><ui-select id=\"id_local\" ng-model=\"data.id_local\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\"><ui-select-match placeholder=\"Sucursal\">{{$select.selected.no_local}}</ui-select-match><ui-select-choices repeat=\"local in jSucursal | filter: $select.search\"><span ng-bind-html=\"local.no_local\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group has-feedback\"><label for=\"id_tipo_pasivo\" class=\"col-sm-2 control-label\">Tipo Pasivo:</label><div class=\"col-sm-10\"><ui-select id=\"id_tipo_pasivo\" ng-model=\"data.id_tipo_pasivo\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\"><ui-select-match placeholder=\"Tipo Pasivo\">{{$select.selected.no_tipo_pasivo}}</ui-select-match><ui-select-choices repeat=\"tipo in jTipoPasivo | filter: $select.search\"><span ng-bind-html=\"tipo.no_tipo_pasivo\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group has-feedback\"><label for=\"id_anio\" class=\"col-sm-2 control-label\">Periodo:</label><div class=\"col-sm-5\"><ui-select id=\"id_anio\" ng-model=\"data.id_anio\" ng-change=\"getPeriodo(data.id_anio)\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\"><ui-select-match placeholder=\"Año\">{{$select.selected.no_anio}}</ui-select-match><ui-select-choices repeat=\"anio in jAnio | filter: $select.search\"><span ng-bind-html=\"anio.no_anio\"></span></ui-select-choices></ui-select></div><div class=\"col-sm-5\"><ui-select id=\"id_periodo\" ng-model=\"data.id_periodo\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\"><ui-select-match placeholder=\"Periodo\">{{$select.selected.no_periodo}}</ui-select-match><ui-select-choices repeat=\"periodo in jPeriodo | filter: $select.search\"><span ng-bind-html=\"periodo.no_periodo\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group has-feedback\"><label for=\"no_pasivo\" class=\"col-sm-2 control-label\">Descripcion:</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"no_pasivo\" name=\"no_pasivo\" placeholder=\"\" ng-model=\"data.no_pasivo\" style=\"text-transform:uppercase\" autocomplete=\"off\"></div></div><div class=\"form-group has-feedback\"><label for=\"va_pasivo\" class=\"col-sm-2 control-label\">Monto:</label><div class=\"col-sm-4\"><input type=\"text\" class=\"form-control\" id=\"va_pasivo\" name=\"va_pasivo\" placeholder=\"Monto\" ng-model=\"data.va_pasivo\"></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-10\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"formPasivo.$invalid || formPasivo.$pending\">Guardar</button> &nbsp;&nbsp;&nbsp; <a class=\"btn btn-default\" ui-sref=\"dashboard.contabilidad.pasivos()\"><i class=\"fa fa-list-alt\"></i> Listado</a></div></div></form></div></div></div>");
$templateCache.put("app/pages/contabilidad/patrimonio/patrimonio.html","<div class=\"widgets\" ng-init=\"consultar()\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Registro del Patrimonio\" ba-panel-class=\"with-scroll\"><form class=\"form-horizontal\" name=\"formPatrimonio\" id=\"formPatrimonio\" ng-submit=\"guardar(formPatrimonio)\" novalidate=\"\"><div class=\"form-group has-feedback\"><label for=\"nu_documento\" class=\"col-sm-2 control-label\">Empresa:</label><div class=\"col-sm-10\"><ui-select id=\"id_empresa\" ng-model=\"data.id_empresa\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\" ng-change=\"getSucursal(data.id_empresa)\"><ui-select-match placeholder=\"Empresa\">{{$select.selected.no_empresa}}</ui-select-match><ui-select-choices repeat=\"empresa in jEmpresa | filter: $select.search\"><span ng-bind-html=\"empresa.no_empresa\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group has-feedback\"><label for=\"nu_documento\" class=\"col-sm-2 control-label\">Sucursal:</label><div class=\"col-sm-10\"><ui-select id=\"id_local\" ng-model=\"data.id_local\" ng-change=\"getSucursalEmpleado(data.id_local)\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\"><ui-select-match placeholder=\"Sucursal\">{{$select.selected.no_local}}</ui-select-match><ui-select-choices repeat=\"local in jSucursal | filter: $select.search\"><span ng-bind-html=\"local.no_local\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group has-feedback\"><label for=\"id_empleado\" class=\"col-sm-2 control-label\">Empleado:</label><div class=\"col-sm-10\"><ui-select id=\"id_empleado\" ng-model=\"data.id_empleado\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\"><ui-select-match placeholder=\"Empleado\">{{$select.selected.no_empleado}}</ui-select-match><ui-select-choices repeat=\"empleado in jEmpleado | filter: $select.search\"><span ng-bind-html=\"empleado.no_empleado\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group has-feedback\"><label for=\"no_patrimonio\" class=\"col-sm-2 control-label\">Descripcion:</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"no_patrimonio\" name=\"no_patrimonio\" placeholder=\"Patrimonio\" ng-model=\"data.no_patrimonio\" style=\"text-transform:uppercase\" autocomplete=\"off\"></div></div><div class=\"form-group has-feedback\"><label for=\"va_patrimonio\" class=\"col-sm-2 control-label\">Monto:</label><div class=\"col-sm-4\"><input type=\"text\" class=\"form-control\" id=\"va_patrimonio\" name=\"va_patrimonio\" placeholder=\"Monto\" ng-model=\"data.va_patrimonio\" autocomplete=\"off\"></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-10\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"formPatrimonio.$invalid || formPatrimonio.$pending\">Guardar</button> &nbsp;&nbsp;&nbsp; <a class=\"btn btn-default\" ui-sref=\"dashboard.contabilidad.patrimonio()\"><i class=\"fa fa-list-alt\"></i> Listado</a></div></div></form></div></div></div>");
$templateCache.put("app/pages/cuentas/cuentaxcobrar/cuentaxcobrar.html","");
$templateCache.put("app/pages/cuentas/cuentaxpagar/cuentaxpagar.html","");
$templateCache.put("app/pages/form/inputs/inputs.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Standard Fields\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/inputs/widgets/standardFields.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Tags Input\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/inputs/widgets/tagsInput/tagsInput.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Input Groups\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/inputs/widgets/inputGroups.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Checkboxes & Radios\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/inputs/widgets/checkboxesRadios.html\'\"></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Validation States\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/inputs/widgets/validationStates.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Selects\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/inputs/widgets/select/select.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"On/Off Switches\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/inputs/widgets/switch/switch.html\'\"></div></div></div></div></div>");
$templateCache.put("app/pages/form/layouts/layouts.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Inline Form\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/layouts/widgets/inlineForm.html\'\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Basic Form\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/layouts/widgets/basicForm.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Horizontal Form\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/layouts/widgets/horizontalForm.html\'\"></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Form Without Labels\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/layouts/widgets/formWithoutLabels.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Block Form\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/form/layouts/widgets/blockForm.html\'\"></div></div></div></div></div>");
$templateCache.put("app/pages/form/wizard/wizard.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Form Wizard\" ba-panel-class=\"with-scroll\"><ba-wizard><ba-wizard-step title=\"Informaciòn Personal\" form=\"vm.personalInfoForm\"><form name=\"vm.personalInfoForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': vm.personalInfoForm.username.$invalid && (vm.personalInfoForm.username.$dirty || vm.personalInfoForm.$submitted)}\"><label for=\"exampleUsername1\">Nombres</label> <input type=\"text\" class=\"form-control\" id=\"nombres\" name=\"nombres\" placeholder=\"Ingrese Nombres\" ng-model=\"vm.personalInfo.nombres\"></div><div class=\"form-group\" ng-class=\"{\'has-error\': vm.personalInfoForm.email.$invalid && (vm.personalInfoForm.email.$dirty || vm.personalInfoForm.$submitted)}\"><label for=\"exampleInputEmail1\">Tipo de Documento</label><select class=\"form-control selectpicker\" selectpicker=\"\" title=\"Standard Select\" ng-model=\"data.tip_documento\" ng-options=\"tipdoc.id as tipdoc.text for tipdoc in [{id:\'P\', text:\'Pasaporte\'}, {id:\'D\', text:\'DNI\'}, {id:\'R\', text:\'RUC\'}, {id:\'C\', text:\'Carnet Extranjero\'}]\"><option value=\"\">-- Tipo Documento --</option></select></div></div><div class=\"col-md-6\"><div class=\"form-group\" ng-class=\"{\'has-error\': vm.personalInfoForm.password.$invalid && (vm.personalInfoForm.password.$dirty || vm.personalInfoForm.$submitted)}\"><label for=\"exampleInputPassword1\">Apellidos</label> <input type=\"text\" class=\"form-control\" id=\"apellidos\" name=\"apellidos\" placeholder=\"Ingrese apellidos\" ng-model=\"vm.personalInfo.apellidos\"></div><div class=\"form-group\" ng-class=\"{\'has-error\': !vm.arePersonalInfoPasswordsEqual() && (vm.personalInfoForm.confirmPassword.$dirty || vm.personalInfoForm.$submitted)}\"><label for=\"tipo_documento\">Nro. Documento</label> <input type=\"text\" class=\"form-control\" id=\"nro_documento\" name=\"nro_documento\" placeholder=\"Ingrese Numero Documento\" ng-model=\"vm.personalInfo.confirmPassword\"></div></div><div class=\"col-md-6\"><div class=\"form-group\" ng-class=\"{\'has-error\': vm.personalInfoForm.password.$invalid && (vm.personalInfoForm.password.$dirty || vm.personalInfoForm.$submitted)}\"><label for=\"exampleInputPassword1\">Email</label> <input type=\"text\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"Ingrese el Correo\" ng-model=\"vm.personalInfo.email\"></div><div class=\"form-group\" ng-class=\"{\'has-error\': !vm.arePersonalInfoPasswordsEqual() && (vm.personalInfoForm.confirmPassword.$dirty || vm.personalInfoForm.$submitted)}\"><label for=\"sexo\">Sexo</label><select class=\"form-control selectpicker\" selectpicker=\"\" title=\"Standard Select\" ng-model=\"data.sexo\" ng-options=\"tipdoc.id as tipdoc.text for tipdoc in [{id:\'F\', text:\'Femenino\'}, {id:\'M\', text:\'Masculino\'}]\"><option value=\"\">-- Sexo --</option></select></div></div><div class=\"col-md-6\"><div class=\"form-group\" ng-class=\"{\'has-error\': vm.personalInfoForm.password.$invalid && (vm.personalInfoForm.password.$dirty || vm.personalInfoForm.$submitted)}\"><label for=\"exampleInputPassword1\">Fecha de Nacimiento</label> <input type=\"text\" class=\"form-control\" id=\"fecha_nacimiento\" name=\"fecha_nacimiento\" placeholder=\"selecione una fecha de nacimiento\" ng-model=\"vm.personalInfo.fecha_nacimiento\"></div><div class=\"form-group\" ng-class=\"{\'has-error\': !vm.arePersonalInfoPasswordsEqual() && (vm.personalInfoForm.confirmPassword.$dirty || vm.personalInfoForm.$submitted)}\"><label for=\"sexo\">Estado Civil</label><select class=\"form-control selectpicker\" selectpicker=\"\" title=\"Standard Select\" ng-model=\"data.sexo\" ng-options=\"tipdoc.id as tipdoc.text for tipdoc in [{id:\'1\', text:\'Solter@\'}, {id:\'2\', text:\'Divorsiad@\'},{id:\'3\', text:\'casad@\'},{id:\'4\', text:\'Viud@\'},{id:\'5\', text:\'Otro\'}]\"><option value=\"\">-- Edo-Civil --</option></select></div></div></div></form></ba-wizard-step><ba-wizard-step title=\"Informacion de Contacto\" form=\"vm.productInfoForm\"><form name=\"vm.productInfoForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': vm.productInfoForm.productName.$invalid && (vm.productInfoForm.productName.$dirty || vm.productInfoForm.$submitted)}\"><label for=\"productName\">Direcciòn Habitaciòn</label> <input type=\"text\" class=\"form-control\" id=\"direccion\" name=\"direccion\" placeholder=\"Ingrese la Direccion\" ng-model=\"vm.productInfo.productName\"></div><div class=\"form-group\" ng-class=\"{\'has-error\': vm.productInfoForm.productId.$invalid && (vm.productInfoForm.productId.$dirty || vm.productInfoForm.$submitted)}\"><label for=\"productId\">Telefono Movil</label> <input type=\"text\" class=\"form-control\" id=\"\" name=\"tlf_movil\" placeholder=\"Ingrese Telefono Movil\" ng-model=\"vm.productInfo.tlf_movil\"></div></div><div class=\"col-md-6\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': vm.productInfoForm.productName.$invalid && (vm.productInfoForm.productName.$dirty || vm.productInfoForm.$submitted)}\"><label for=\"productName\">Email</label> <input type=\"text\" class=\"form-control\" id=\"email\" name=\"email\" placeholder=\"Ingrese el email\" ng-model=\"vm.productInfo.email\"></div><div class=\"form-group\" ng-class=\"{\'has-error\': vm.productInfoForm.productId.$invalid && (vm.productInfoForm.productId.$dirty || vm.productInfoForm.$submitted)}\"><label for=\"productId\">Telefono Habitaciòn</label> <input type=\"text\" class=\"form-control\" id=\"tlf_hab\" name=\"tlf_hab\" placeholder=\"Ingrese Telefono Habitacion\" ng-model=\"vm.productInfo.tlf_hab\"></div></div></div></form></ba-wizard-step><ba-wizard-step title=\"Informacion del Trabajo\" form=\"vm.addressForm\"><form name=\"vm.addressForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group has-feedback\" <div=\"\"><label for=\"productName\">Area</label><select class=\"form-control\" title=\"Category\" selectpicker=\"\"><option selected=\"\">RRHH</option><option>Laboratorio</option><option>Sistemas</option><option>Logistica</option></select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"productName\">Puesto de Trabajo</label><select class=\"form-control\" title=\"Category\" selectpicker=\"\"><option selected=\"\">Programador</option><option>Analista</option></select></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group has-feedback\" <div=\"\"><label for=\"productName\">Horario Mintra</label><select class=\"form-control\" title=\"Category\" selectpicker=\"\"><option selected=\"\">Full Time</option><option>Party Time</option></select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"productName\">Forma de Pago</label><select class=\"form-control\" title=\"Category\" selectpicker=\"\"><option selected=\"\">Efectivo</option><option>Transferencia</option></select></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group has-feedback\" <div=\"\"><label for=\"productName\">Entidad Bancaria</label><select class=\"form-control\" title=\"Category\" selectpicker=\"\"><option selected=\"\">BBC</option><option>Wester</option></select></div></div></div></form></ba-wizard-step><ba-wizard-step title=\"Finalizado\"><form class=\"form-horizontal\" name=\"vm.finishForm\" novalidate=\"\">Felicitaciones ! Usted ha completado Todo el Formulario!</form></ba-wizard-step></ba-wizard></div></div></div></div>");
$templateCache.put("app/pages/home/dashboardCalendar/dashboardCalendar.html","<div id=\"calendar\" class=\"blurCalendar\"></div>");
$templateCache.put("app/pages/home/dashboardLineChart/dashboardLineChart.html","<div id=\"amchart\"></div>");
$templateCache.put("app/pages/home/dashboardMap/dashboardMap.html","<div id=\"amChartMap\"></div>");
$templateCache.put("app/pages/home/dashboardPieChart/dashboardPieChart.html","<div class=\"row pie-charts\"><div class=\"pie-chart-item-container\" ng-repeat=\"chart in charts\"><div ba-panel=\"\"><div class=\"pie-chart-item\"><div class=\"chart\" rel=\"{{ ::chart.color }}\" data-percent=\"60\"><span class=\"percent\"></span></div><div class=\"description\"><div>{{ ::chart.description }}</div><div class=\"description-stats\">{{ ::chart.stats }}</div></div><i class=\"chart-icon i-{{ ::chart.icon }}\"></i></div></div></div></div>");
$templateCache.put("app/pages/home/dashboardTodo/dashboardTodo.html","<div class=\"task-todo-container\" ng-class=\"{\'transparent\': transparent}\"><input type=\"text\" value=\"\" class=\"form-control task-todo\" placeholder=\"Task to do..\" ng-keyup=\"addToDoItem($event)\" ng-model=\"newTodoText\"> <i ng-click=\"addToDoItem(\'\',true)\" class=\"add-item-icon ion-plus-round\"></i><div class=\"box-shadow-border\"></div><ul class=\"todo-list\" ui-sortable=\"\" ng-model=\"todoList\"><li ng-repeat=\"item in todoList\" ng-if=\"!item.deleted\" ng-init=\"activeItem=false\" ng-class=\"{checked: isChecked, active: activeItem}\" ng-mouseenter=\"activeItem=true\" ng-mouseleave=\"activeItem=false\"><div class=\"blur-container\"><div class=\"blur-box\"></div></div><i class=\"mark\" style=\"background-color: {{::item.color}}\"></i> <label class=\"todo-checkbox custom-checkbox custom-input-success\"><input type=\"checkbox\" ng-model=\"isChecked\"> <span class=\"cut-with-dots\">{{ item.text }}</span></label> <i class=\"remove-todo ion-ios-close-empty\" ng-click=\"item.deleted = true\"></i></li></ul></div>");
$templateCache.put("app/pages/home/popularApp/popularApp.html","<div class=\"popular-app-img-container\"><div class=\"popular-app-img\"><img ng-src=\"{{::( \'app/my-app-logo.png\' | appImage )}}\"> <span class=\"logo-text\">Super&nbspApp</span></div></div><div class=\"popular-app-cost row\"><div class=\"col-xs-9\">Most Popular App</div><div class=\"col-xs-3 text-right\">175$</div></div><div class=\"popular-app-info row\"><div class=\"col-xs-4 text-left\"><div class=\"info-label\">Total Visits</div><div>47,512</div></div><div class=\"col-xs-4 text-center\"><div class=\"info-label\">New Visits</div><div>9,217</div></div><div class=\"col-xs-4 text-right\"><div class=\"info-label\">Sales</div><div>2,928</div></div></div>");
$templateCache.put("app/pages/home/trafficChart/trafficChart.html","<div class=\"channels-block\" ng-class=\"{\'transparent\': transparent}\"><div class=\"chart-bg\"></div><div class=\"traffic-chart\" id=\"trafficChart\"><div class=\"canvas-holder\"><canvas id=\"chart-area\" width=\"250\" height=\"250\"></canvas><div class=\"traffic-text\">1,900,128 <span>Total</span></div></div><div class=\"traffic-legend\"></div></div><div class=\"channels-info\"><div><div class=\"channels-info-item\" ng-repeat=\"item in doughnutData | orderBy:\'order\'\"><div class=\"legend-color\" style=\"background-color: {{::item.color}}\"></div><p>{{::item.label}}<span class=\"channel-number\">+{{item.percentage}}%</span></p><div class=\"progress progress-sm channel-progress\"><div class=\"progress-bar\" role=\"progressbar\" aria-valuenow=\"{{item.percentage}}\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width:{{item.percentage}}%\"></div></div></div></div></div></div>");
$templateCache.put("app/pages/home/user/user.html","<div><div ba-panel=\"\" ba-panel-title=\"Intern Details\" ba-panel-class=\"with-scroll\"><div class=\"person-info row\"><div class=\"col-lg-4 col-md-12 no-padding kameleon-row\"><div class=\"kameleon-icon with-round-bg {{icon.color}}\"><img ng-src=\"{{user.profile || \'assets/pictures/user.png\'}}\"></div><div class=\"name\"><h2 class=\"name-h\">{{user.firstname}} {{user.lastname}}</h2><div><span class=\"mail-tag tag label\"></span><h5 class=\"name-h\">Interview comment: {{user.comment}}</h5></div></div></div><div class=\"col-lg-4 col-md-6 col-xs-12 no-padding\"><div class=\"contact-info phone-email\"><div><i class=\"ion-iphone\"></i> <span class=\"phone\">{{user.mobile}}</span></div><div><i class=\"ion-email\"></i> <span class=\"email\">{{user.email}}</span></div></div></div><div class=\"col-lg-4 col-md-6 col-xs-12 no-padding\"><div class=\"contact-info position-address\"><div><span class=\"position\">{{user.nic}}</span></div><div><span class=\"address\">{{user.address}}</span></div></div></div></div></div><div ba-panel=\"\" ba-panel-title=\"Intern Task Assignment\" ba-panel-class=\"with-scroll\"><div class=\"row\"><div class=\"col-md-6 col-md-offset-1\"><h3 class=\"with-line\">Tareas</h3><button type=\"button\" class=\"btn btn-success btn-xs btn-icon-sm\" ng-click=\"viewUserTasks(user.id)\">Vista Detalles</button><div class=\"panel panel-blur light-text animated zoomIn\" zoom-in=\"\" ba-panel-blur=\"\"><div class=\"panel-body\"><table class=\"table table-striped\"><tbody><tr ng-repeat=\"task in unassignedTasks| orderBy:\'timestamp\'\"><td>{{task.id}}</td><td ng-hide=\"task.status\"><button type=\"button\" class=\"btn btn-success btn-xs btn-icon-sm\" ng-click=\"assignTaskToUser(task.id)\">Asignar</button></td><td ng-show=\"task.status\">{{task.status}}</td></tr><tr ng-repeat=\"task in user.tasks| orderBy:\'timestamp\'\"><td>{{task.id}}</td><td>{{task.status}}</td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/pages/home/users/users.html","<div ba-panel=\"\" ba-panel-title=\"Usuarios\" ba-panel-class=\"with-scroll\"><div class=\"row clearfix\"><div class=\"kameleon-row\" ng-repeat=\"(key,value) in tabs track by $index\"><div class=\"kameleon-icon with-round-bg {{icon.color}}\" ng-click=\"getUserProfile(key)\"><img ng-src=\"{{value.profile || \'assets/pictures/user.png\'}}\" class=\"prof\"> <span class=\"prof\">{{value.firstname}}</span></div></div></div></div>");
$templateCache.put("app/pages/home/weather/weather.html","<div class=\"weather-wrapper\"><div class=\"weather-main-info\"><h5 class=\"city-date font-x1dot5\"><div>{{geoData.geoplugin_city}} - {{geoData.geoplugin_countryName | uppercase}}</div><div>{{ weather.days[weather.current].date | date : \'EEEE h:mm\'}}</div></h5><div class=\"weather-description font-x1dot5\"><i class=\"font-x3 {{weatherIcons[weather.days[weather.current].icon]}}\"></i><div class=\"weather-info\">{{weather.days[weather.current].main}} - {{weather.days[weather.current].description}}</div></div><div class=\"weather-temp font-x1dot5\"><i class=\"font-x2 ion-thermometer\"></i><div class=\"weather-info\" ng-switch=\"\" on=\"units\"><span ng-switch-when=\"metric\">{{weather.days[weather.current].temp}} °C | <a ng-click=\"switchUnits(\'imperial\')\" href=\"\">°F</a></span> <span ng-switch-when=\"imperial\">{{weather.days[weather.current].temp}} °F | <a ng-click=\"switchUnits(\'metric\')\" href=\"\">°C</a></span></div></div></div><div id=\"tempChart\" class=\"temp-by-time\"></div><div class=\"select-day\"><div class=\"day\" ng-repeat=\"day in weather.days\" ng-click=\"switchDay($index)\"><div><span class=\"font-x1dot25\">{{day.temp}}</span></div><div><i class=\"weatherIcon font-x2 {{weatherIcons[day.icon]}}\"></i> <span class=\"select-day-info\">{{day.main}}</span></div><div><span>{{day.date | date : \'EEE\'}}</span></div></div></div></div>");
$templateCache.put("app/pages/inventario/stockProductos/stockProductos.html","");
$templateCache.put("app/pages/profile/partials/profileModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">Add Account</h4></div><form name=\"linkForm\"><div class=\"modal-body\"><p>Paste a link to your profile into the box below</p><div class=\"form-group\"><input type=\"text\" class=\"form-control\" placeholder=\"Link to Profile\" ng-model=\"link\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"ok(link)\">Save changes</button></div></form></div>");
$templateCache.put("app/pages/profile/partials/techs.html","<div class=\"add-row-editable-table\"><button class=\"btn btn-primary\" ng-click=\"addUser()\">Agregar Fila</button></div><table class=\"table table-bordered table-hover table-condensed\"><tr><td></td><td>Tecnologias</td><td>Acciones</td></tr><tr ng-repeat=\"tech in techs\" class=\"editable-row\"><td>{{$index}}</td><td><span editable-text=\"tech.name\" e-name=\"name\" e-form=\"rowform\" e-required=\"\">{{ tech.name || \'empty\' }}</span></td><td><form editable-form=\"\" name=\"rowform\" ng-show=\"rowform.$visible\" class=\"form-buttons form-inline\" shown=\"inserted == tech\"><button type=\"submit\" ng-disabled=\"rowform.$waiting\" class=\"btn btn-primary editable-table-button btn-xs\">Guardar</button> <button type=\"button\" ng-disabled=\"rowform.$waiting\" ng-click=\"rowform.$cancel()\" class=\"btn btn-default editable-table-button btn-xs\">Cancelar</button></form><div class=\"buttons\" ng-show=\"!rowform.$visible\"><button class=\"btn btn-primary editable-table-button btn-xs\" ng-click=\"rowform.$show()\">Editar</button> <button class=\"btn btn-danger editable-table-button btn-xs\" ng-click=\"removeUser($index)\">Eliminar</button></div></td></tr></table>");
$templateCache.put("app/pages/reporte/productos/rptproductos.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Reporte de Productos\"><form name=\"formRptVentas\" id=\"formRptVentas\" target=\"_blank\" action=\"/reports/productos.php\" method=\"POST\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"fec_ini\" class=\"control-label\">Marca/Laboratorio:</label> <input type=\"hidden\" name=\"idlaboratorio\" id=\"idlaboratorio\" value=\"{{data.id_marca.value}}\"><ui-select ng-model=\"data.id_marca\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Todos...\">{{$select.selected.label}}</ui-select-match><ui-select-choices repeat=\"marca in jMarcas | filter: $select.search\"><div ng-bind-html=\"marca.label | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"tipo_reporte\" value=\"precios\"> <span>Lista de Precios</span></label></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"tipo_reporte\" value=\"precios_existencia\"> <span>Lista de Precios vs Existencia</span></label></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"tipo_reporte\" value=\"precio_costo\"> <span>Lista de Precio Costo</span></label></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"tipo_reporte\" value=\"existencia_lab\"> <span>Existencia Laboratorio</span></label></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"tipo_reporte\" value=\"productos\"> <span>Todos en Orden Alfabetico</span></label></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" name=\"sin_stock\" value=\"1\"> <span>Ignorar productos sin ingreso en almacen</span></label></div></div></div><div class=\"row\"><div class=\"col-md-12\"><button type=\"submit\" class=\"btn btn-success\"><i class=\"fa fa-file-pdf-o\"></i> Generar</button></div></div></form></div></div></div>");
$templateCache.put("app/pages/reporte/ventas/rptventas.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Reporte de Ventas\"><form name=\"formRptVentas\" id=\"formRptVentas\" target=\"_blank\" action=\"api/reports/ventas.php\" method=\"POST\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" for=\"fe_emision\">Desde</label><div class=\"input-group\" moment-picker=\"data.fec_inicio\" locales=\"es\" start-view=\"month\" format=\"YYYY-MM-DD\"><input class=\"form-control\" id=\"fec_inicio\" name=\"fec_inicio\" placeholder=\"Seleccione Una Fecha\" ng-model=\"data.fec_inicio\" ng-model-options=\"{ updateOn: \'blur\'}\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" for=\"fe_emision\">Hasta</label><div class=\"input-group\" moment-picker=\"data.fec_hasta\" locales=\"es\" start-view=\"month\" format=\"YYYY-MM-DD\"><input class=\"form-control\" id=\"fec_hasta\" name=\"fec_hasta\" placeholder=\"Seleccione Una Fecha\" ng-model=\"data.fec_hasta\" ng-model-options=\"{ updateOn: \'blur\'}\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=\"row\"><div class=\"col-md-2\"><div class=\"form-group\"><label class=\"control-label\">Tipo Documento</label><ui-select ng-model=\"data.tipdocumento\" class=\"btn-group bootstrap-select form-control\" ng-disabled=\"vm.formProducto.codigo.$invalid\" ng-required=\"true\"><ui-select-match placeholder=\"Tipo Documento\">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat=\"tipodocumento in jTipDocumentos | filter: $select.search\"><div ng-bind-html=\"tipodocumento.nombre | highlight: $select.search\"></div></ui-select-choices></ui-select><span class=\"help-block error-block basic-block\" ng-if=\"formUsuario.idtipdoc.$error\"><p ng-repeat=\"(key, value) in formUsuario.idtipdoc.$error\">{{messages.idtipdoc[key]}}</p></span></div></div><div class=\"col-md-3\"><div class=\"form-group\" ng-class=\"{\'has-error\': formRptVentas.num_doc.$invalid}\"><label for=\"num_doc\" class=\"control-label\">Nº Documento</label> <input type=\"hidden\" name=\"idempleado\" ng-model=\"data.idempleado\" value=\"{{data.idempleado}}\"> <input type=\"text\" class=\"form-control\" id=\"num_doc\" name=\"num_doc\" placeholder=\"Nº Documento\" ng-model=\"data.num_doc\" existnumdoc-empleado=\"\" idempleado=\"data.idempleado\" otipodocumento=\"data.tipdocumento.id\" ng-blur=\"consultar_empleado(formRptVentas)\" autocomplete=\"off\"></div></div><div class=\"col-md-7\"><div class=\"form-group\"><label class=\"control-label\">Apellidos y Nombres</label> <input type=\"text\" class=\"form-control\" id=\"apenom\" name=\"apenom\" placeholder=\"Apellidos y Nombres\" ng-model=\"data.apenom\" ng-readonly=\"true\" style=\"color:#000 !important;\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" id=\"detail_venta\" name=\"detail_venta\" ng-model=\"data.details_venta\" value=\"{{data.details_venta}}\"> <span>Detalle de ventas</span></label></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><button type=\"submit\" class=\"btn btn-success\"><i class=\"fa fa-file-pdf-o\"></i> Generar</button></div></div></div></form></div></div></div>");
$templateCache.put("app/pages/reportes/compras/rptcompras.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Reporte de Compras\"><form name=\"formRptCompras\" id=\"formRptCompras\" target=\"_blank\" method=\"POST\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" for=\"fe_emision\">Desde</label><div class=\"input-group\" moment-picker=\"data.fec_inicio\" locales=\"es\" start-view=\"month\" format=\"YYYY-MM-DD\"><input class=\"form-control\" id=\"fec_inicio\" name=\"fec_inicio\" placeholder=\"Seleccione Una Fecha\" ng-model=\"data.fec_inicio\" ng-model-options=\"{ updateOn: \'blur\'}\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label class=\"control-label\" for=\"fe_emision\">Hasta</label><div class=\"input-group\" moment-picker=\"data.fec_hasta\" locales=\"es\" start-view=\"month\" format=\"YYYY-MM-DD\"><input class=\"form-control\" id=\"fec_hasta\" name=\"fec_hasta\" placeholder=\"Seleccione Una Fecha\" ng-model=\"data.fec_hasta\" ng-model-options=\"{ updateOn: \'blur\'}\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=\"row\"><div class=\"col-md-2\"><div class=\"form-group\"><label class=\"control-label\">Tipo Documento</label><ui-select ng-model=\"data.tipdocumento\" class=\"btn-group bootstrap-select form-control\" ng-required=\"true\"><ui-select-match placeholder=\"Tipo Documento\">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat=\"tipodocumento in jTipDocumentos | filter: $select.search\"><div ng-bind-html=\"tipodocumento.nombre | highlight: $select.search\"></div></ui-select-choices></ui-select><span class=\"help-block error-block basic-block\" ng-if=\"formRptCompras.idtipdoc.$error\"><p ng-repeat=\"(key, value) in formRptCompras.idtipdoc.$error\">{{messages.idtipdoc[key]}}</p></span></div></div><div class=\"col-md-3\"><div class=\"form-group\" ng-class=\"{\'has-error\': formRptVentas.num_doc.$invalid}\"><label for=\"num_doc\" class=\"control-label\">Nº Documento</label> <input type=\"text\" class=\"form-control\" id=\"num_doc\" name=\"num_doc\" placeholder=\"Nº Documento\" ng-model=\"data.num_doc\" autocomplete=\"off\"></div></div><div class=\"col-md-7\"><div class=\"form-group\"><label class=\"control-label\">Nombre Proveedor</label> <input type=\"text\" class=\"form-control\" id=\"noclien\" name=\"noclien\" placeholder=\"Apellidos y Nombres\" ng-model=\"data.noclien\" style=\"color:#000 !important;\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" id=\"detail_venta\" name=\"detail_venta\" ng-model=\"data.details_venta\" value=\"{{data.details_venta}}\"> <span>Detalle de Compras</span></label></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><button type=\"submit\" class=\"btn btn-success\"><i class=\"fa fa-file-pdf-o\"></i> Generar</button></div></div><div class=\"col-md-6\"><div class=\"form-group\"><button type=\"submit\" class=\"btn btn-success\" ng-click=\"consultar(data)\">ver resultados</button></div></div></div></form></div></div><div ba-panel=\"\" ba-panel-title=\"Resultado de la Busquedad <i ng-click=\'agregar()\' class=\'fa pull-right fa-plus\'>Exportar</i>\" ba-panel-class=\"with-scroll\"><div class=\"form-group\"><div class=\"col-sm-12\"><table class=\"table table-striped\" st-table=\"displayed\" st-safe-src=\"rowVentas\"><thead><tr class=\"sortable\"><th style=\"width:4%;\" class=\"table-id\">#</th><th style=\"width:15%;\">Fecha</th><th style=\"width:20%;\">Proveedor</th><th style=\"width:15%;\">Comprobante</th><th style=\"width:15%;\">Total</th><th style=\"width:15%;\">N° Comprobante</th></tr><tr><th></th><th><input st-search=\"no_proveedor\" class=\"input-sm form-control\" placeholder=\"Busqueda Cliente ...\" type=\"search\"></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.fe_registro }}</td><td>{{item.no_proveedor }}</td><td>{{item.no_tipo_comprobante }}</td><td>{{item.nu_total }}</td><td>{{item.nu_comprobante }}</td></tr></tbody><tfoot><tr><td colspan=\"6\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table></div></div></div></div>");
$templateCache.put("app/pages/reportes/diario/rptDiario.html","<div class=\"widgets\"><div class=\"row\"><div ba-panel=\"\" ba-panel-title=\"Reporte de Ventas Diarias\" ba-panel-class=\"with-scroll\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group has-success has-feedback\"><label class=\"control-label\" for=\"inputGroupSuccess1\">Desde</label><div class=\"input-group\" moment-picker=\"data.fe_inicio\" locales=\"es\" start-view=\"month\" format=\"YYYY-MM-DD\"><span class=\"input-group-addon addon-left\"><i class=\"glyphicon glyphicon-calendar\"></i></span> <input class=\"form-control\" id=\"data.fe_inicio\" name=\"data.fe_inicio\" placeholder=\"Seleccione Una Fecha\" ng-model=\"data.fe_inicio\" ng-model-options=\"{ updateOn: \'blur\' }\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group has-success has-feedback\"><label class=\"control-label\" for=\"inputGroupSuccess1\">Hasta</label><div class=\"input-group\" moment-picker=\"data.fe_fin\" locales=\"es\" start-view=\"month\" format=\"YYYY-MM-DD\"><span class=\"input-group-addon addon-left\"><i class=\"glyphicon glyphicon-calendar\"></i></span> <input class=\"form-control\" id=\"data.fe_fin\" name=\"data.fe_fin\" placeholder=\"Seleccione Una Fecha\" ng-model=\"data.fe_fin\" ng-model-options=\"{ updateOn: \'blur\' }\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><button class=\"btn btn-warning\" ng-click=\"consultar()\"><span class=\"glyphicon glyphicon-share\"></span> Buscar Ventas</button></div><div class=\"col-md-6\"><button class=\"btn btn-info\" ng-click=\"exportToExcel(\'#tableToExport\')\"><span class=\"glyphicon glyphicon-share\"></span> Exportar Ventas</button></div></div><br><div class=\"row\"><table id=\"tableToExport\" class=\"table table-striped\" st-table=\"displayed\" st-safe-src=\"rowVentas\"><thead><tr class=\"sortable\"><th style=\"width:5%;\" class=\"table-id\">#</th><th style=\"width:10%;\">Tipo</th><th style=\"width:8%;\">Serie</th><th style=\"width:10%;\">Correlativo</th><th style=\"width:20%;\">Cliente</th><th style=\"width:10%;\">S. Total</th><th style=\"width:10%;\">Igv</th><th style=\"width:10%;\">Total</th><th style=\"width:10%;\">M. Pago</th><th style=\"width:10%;\">Fecha</th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_tipo_comprobante }}</td><td>{{item.nu_serie }}</td><td>{{item.nu_correlativo }}</td><td>{{item.no_cliente }}</td><td>{{item.mto_stotal | number:2}}</td><td>{{item.mto_igv | number:2}}</td><td>{{item.mto_total | number:2}}</td><td>{{item.no_tipo_medio_pago}}</td><td>{{item.fe_emision}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/pages/reportes/general/general.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Reporte de Ventas\"><div class=\"form-horizontal\" name=\"formGeneral\" id=\"formGeneral\" ng-submit=\"guardar(formGeneral)\" novalidate=\"\"><div class=\"row\"><div class=\"col-sm-6\" ng-controller=\"generalCtrl\"><div class=\"datepicker row\"><h4>Desde</h4><label>Fecha Seleccionada: <em>{{dt | date:\'fullDate\' }}</em></label><div class=\"uib-datepicker-wrap\"><uib-datepicker ng-model=\"dt\" datepicker-options=\"options\"></uib-datepicker></div></div></div><div class=\"col-sm-6\" ng-controller=\"generalCtrl\"><div class=\"datepicker row\"><h4>Hasta</h4><label>Fecha Seleccionada: <em>{{dt | date:\'fullDate\' }}</em></label><div class=\"uib-datepicker-wrap\"><uib-datepicker ng-model=\"dt\" datepicker-options=\"options\"></uib-datepicker></div></div></div></div></div></div></div></div>");
$templateCache.put("app/pages/reportes/ventas/ventas.html","<div class=\"widgets\"><div class=\"row\"><div ba-panel=\"\" ba-panel-title=\"Reporte de Ventas por Producto\" ba-panel-class=\"with-scroll\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group has-success has-feedback\"><label class=\"control-label\" for=\"inputGroupSuccess1\">Desde</label><div class=\"input-group\" moment-picker=\"data.fe_inicio\" locales=\"es\" start-view=\"month\" format=\"YYYY-MM-DD\"><span class=\"input-group-addon addon-left\"><i class=\"glyphicon glyphicon-calendar\"></i></span> <input class=\"form-control\" id=\"data.fe_inicio\" name=\"data.fe_inicio\" placeholder=\"Seleccione Una Fecha\" ng-model=\"data.fe_inicio\" ng-model-options=\"{ updateOn: \'blur\' }\"></div></div></div><div class=\"col-md-6\"><div class=\"form-group has-success has-feedback\"><label class=\"control-label\" for=\"inputGroupSuccess1\">Hasta</label><div class=\"input-group\" moment-picker=\"data.fe_fin\" locales=\"es\" start-view=\"month\" format=\"YYYY-MM-DD\"><span class=\"input-group-addon addon-left\"><i class=\"glyphicon glyphicon-calendar\"></i></span> <input class=\"form-control\" id=\"data.fe_fin\" name=\"data.fe_fin\" placeholder=\"Seleccione Una Fecha\" ng-model=\"data.fe_fin\" ng-model-options=\"{ updateOn: \'blur\' }\"></div></div></div></div><div class=\"row\"><div class=\"col-md-6\"><button class=\"btn btn-warning\" ng-click=\"consultar()\"><span class=\"glyphicon glyphicon-share\"></span> Buscar Productos</button></div><div class=\"col-md-6\"><button class=\"btn btn-info\" ng-click=\"exportToExcel(\'#tableToExport\')\"><span class=\"glyphicon glyphicon-share\"></span> Exportar Productos</button></div></div><br><div class=\"row\"><table id=\"tableToExport\" class=\"table table-striped\" st-table=\"displayed\" st-safe-src=\"rowVentas\"><thead><tr class=\"sortable\"><th style=\"width:5%;\" class=\"table-id\">#</th><th style=\"width:15%;\">Codigo</th><th style=\"width:25%;\">Producto</th><th style=\"width:10%;\">Marca</th><th style=\"width:10%;\">Categoria</th><th style=\"width:10%;\">Cantidad</th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.co_producto }}</td><td>{{item.no_producto }}</td><td>{{item.no_marca }}</td><td>{{item.no_categoria }}</td><td>{{item.nu_cantidad }}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/pages/seguridad/roles/roles.html","<div class=\"widgets\" ng-init=\"vm.consultar()\"><div class=\"row\"><div class=\"col-md-8\" ba-panel=\"\" ba-panel-title=\"Roles de Usuarios\" ba-panel-class=\"with-scroll\"><form class=\"form-horizontal\" name=\"formRoles\" id=\"formRoles\" ng-submit=\"vm.guardar(formRoles)\" novalidate=\"\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formRoles.nombre_rol.$invalid && (formRoles.nombre_rol.$dirty || formRoles.nombre_rol.$submitted)}\"><label for=\"nombre_rol\" class=\"col-sm-2 control-label\">Descripción:</label><div class=\"col-sm-10\"><input type=\"hidden\" name=\"id_rol\" ng-model=\"vm.data.id_rol\"> <input type=\"text\" class=\"form-control\" id=\"nombre_rol\" name=\"nombre_rol\" placeholder=\"Rol de Usuario\" ng-model=\"vm.data.nombre_rol\" ng-required=\"true\" rol-exist=\"\" idrol=\"vm.data.id_rol\" style=\"text-transform:uppercase\" autocomplete=\"off\"> <span class=\"help-block error-block basic-block\" ng-if=\"formRoles.nombre_rol.$error\"><p ng-repeat=\"(key, value) in formRoles.nombre_rol.$error\">{{messages.nombre_rol[key]}}</p></span></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-10\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"formRoles.$invalid || formRoles.$pending\">Guardar</button></div></div></form></div><div class=\"col-md-4\" ba-panel=\"\" ba-panel-title=\"Menú\" ba-panel-class=\"with-scroll\"><js-tree ng-model=\"vm.itemsUsuarios\" idrol=\"vm.idrol\"></js-tree></div></div></div>");
$templateCache.put("app/pages/seguridad/usuarios/usuario.html","<div class=\"widgets\" ng-init=\"consultar()\"><div class=\"row\"><div class=\"col-md-8\" ba-panel=\"\" ba-panel-title=\"Usuario\" ba-panel-class=\"with-scroll\"><form name=\"formUsuario\" id=\"formUsuario\" ng-submit=\"guardar(formUsuario)\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\" ng-class=\"{\'has-error\': formUsuario.idtipdoc.$invalid && (formUsuario.num_doc.$dirty || formUsuario.num_doc.$submitted)}\"><label for=\"idtipdoc\">Tipo de Documento:</label><ui-select name=\"idtipdoc\" id=\"idtipdoc\" ng-model=\"data.idtipdoc\" class=\"btn-group bootstrap-select form-control\" ng-disabled=\"true\"><ui-select-match placeholder=\"Tipo Documento\">{{$select.selected.nombre}}</ui-select-match><ui-select-choices repeat=\"tipodocumento in jTipDocumentos | filter: $select.search\"><div ng-bind-html=\"tipodocumento.nombre | highlight: $select.search\"></div></ui-select-choices></ui-select><span class=\"help-block error-block basic-block\" ng-if=\"formUsuario.idtipdoc.$error\"><p ng-repeat=\"(key, value) in formUsuario.idtipdoc.$error\">{{messages.idtipdoc[key]}}</p></span></div></div><div class=\"col-md-8\"><div class=\"form-group\" ng-class=\"{\'has-error\': formUsuario.num_doc.$invalid}\"><label for=\"num_doc\">Nº de Documento:</label> <input type=\"hidden\" id=\"idempleado\" name=\"idempleado\" ng-model=\"data.idempleado\"> <input type=\"text\" class=\"form-control\" id=\"num_doc\" name=\"num_doc\" placeholder=\"Nº Documento\" ng-model=\"data.num_doc\" ng-disabled=\"true\" style=\"color:#000!important;\"> <span class=\"help-block error-block basic-block\" ng-if=\"formUsuario.num_doc.$error\"><p ng-repeat=\"(key, value) in formUsuario.num_doc.$error\">{{messages.num_doc[key]}}</p></span></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"apenom\">Apellidos y Nombres:</label> <input type=\"text\" class=\"form-control\" id=\"apenom\" name=\"apenom\" placeholder=\"Apellidos y Nombres\" ng-model=\"data.apenom\" ng-required=\"true\" ng-disabled=\"true\" style=\"color:#000 !important;\"> <span class=\"help-block error-block basic-block\" ng-if=\"formUsuario.apenom.$error\"><p ng-repeat=\"(key, value) in formUsuario.apenom.$error\">{{messages.apenom[key]}}</p></span></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\" ng-class=\"{\'has-error\':formUsuario.usuario.$invalid}\"><label for=\"usuario\">Usuario:</label> <input type=\"text\" class=\"form-control\" id=\"usuario\" name=\"usuario\" placeholder=\"Usuario\" ng-required=\"true\" ng-model=\"data.usuario\" ng-disabled=\"data.idempleado==0\" exist-user=\"\" idusuario=\"data.idusuario\" autocomplete=\"off\"></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\" ng-class=\"{\'has-error\':formUsuario.password.$invalid}\"><label for=\"password\">Contraseña:</label> <input type=\"password\" class=\"form-control\" name=\"password\" ng-required=\"true\" ng-model=\"data.password\" ng-disabled=\"formUsuario.usuario.$invalid\" password-strong=\"\"></div></div><div class=\"col-md-6\"><div class=\"form-group\" ng-class=\"{\'has-error\':formUsuario.rep_passw.$invalid}\"><label for=\"rep_passw\" class=\"control-label\">Rep. Contraseña:</label> <input type=\"password\" class=\"form-control\" id=\"rep_passw\" name=\"rep_passw\" ng-required=\"true\" ng-model=\"data.rep_passw\" ng-disabled=\"formUsuario.usuario.$invalid\" equal-to-password=\"\" password=\"data.password\"></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\" ng-class=\"{\'has-error\':formUsuario.idrol.$invalid}\"><label class=\"control-label\">Rol de Usuario:</label><ui-select id=\"idrol\" name=\"idrol\" ng-model=\"data.idrol_sistema\" class=\"btn-group bootstrap-select form-control\" on-select=\"cargarMenu($item)\" ng-disabled=\"formUsuario.rep_passw.$invalid\"><ui-select-match placeholder=\"Rol de Usuario\">{{$select.selected.nom_rol}}</ui-select-match><ui-select-choices repeat=\"rol in jRoles | filter: $select.search\"><div ng-bind-html=\"rol.nom_rol | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"formUsuario.$invalid || formUsuario.$pending\">Guardar</button></div></div></div></form></div><div class=\"col-md-4\" ba-panel=\"\" ba-panel-title=\"Privilegio\" ba-panel-class=\"with-scroll\"><div class=\"form-group\"><div class=\"col-sm-12\"><js-tree ng-model=\"data.permission\" idrol=\"data.idrol_sistema\" hidden-checkbox=\"true\"></js-tree></div></div></div></div></div>");
$templateCache.put("app/pages/sucursal/distribuidores/distribuidores.html","");
$templateCache.put("app/pages/sucursal/empresa/empresa.html","<div class=\"widgets\" ng-init=\"consultar()\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Empresa\" ba-panel-class=\"with-scroll\"><form class=\"form-horizontal\" name=\"formEmpresa\" id=\"formEmpresa\" ng-submit=\"guardar(formEmpresa)\" novalidate=\"\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formEmpresa.nu_ruc.$invalid && (formEmpresa.nu_ruc.$dirty || formClient.nu_ruc.$submitted)}\"><label for=\"nu_ruc\" class=\"col-sm-2 control-label\">RUC:</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"nu_ruc\" name=\"nu_ruc\" placeholder=\"Nº Documento\" ng-model=\"data.nu_ruc\" ng-required=\"true\" ng-disabled=\"formEmpresa.idtipdoc.$invalid\" autocomplete=\"off\"> <span class=\"help-block error-block basic-block\" ng-if=\"formEmpresa.nu_ruc.$error\"><p ng-repeat=\"(key, value) in formEmpresa.nu_ruc.$error\">{{messages.nu_ruc[key]}}</p></span></div></div><div class=\"form-group\" ng-class=\"{\'has-error\': formEmpresa.no_empresa.$invalid && (formEmpresa.no_empresa.$dirty || formEmpresa.no_empresa.$submitted)}\"><label for=\"no_empresa\" class=\"col-sm-2 control-label\">Razón Social:</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"no_empresa\" name=\"no_empresa\" placeholder=\"Razón Social\" ng-model=\"data.no_empresa\" ng-required=\"true\" style=\"text-transform:uppercase\"></div></div><div class=\"form-group\" ng-class=\"{\'has-error\': formEmpresa.no_cliente.$invalid && (formEmpresa.no_cliente.$dirty || formEmpresa.no_cliente.$submitted)}\"><label for=\"co_depart\" class=\"col-sm-2 control-label\">Departamento:</label><div class=\"col-sm-2\"><ui-select ng-model=\"data.co_depart\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getpDepartamento()\"><ui-select-match placeholder=\"Departamento\">{{$select.selected.no_departamento}}</ui-select-match><ui-select-choices repeat=\"depart in a_departamento | filter: $select.search\"><div ng-bind-html=\"depart.no_departamento | highlight: $select.search\"></div></ui-select-choices></ui-select></div><label for=\"co_provin\" class=\"col-sm-1 control-label\">Provincia:</label><div class=\"col-sm-3\"><ui-select ng-model=\"data.co_provin\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getpProvincia()\"><ui-select-match placeholder=\"Provincia\">{{$select.selected.no_provincia}}</ui-select-match><ui-select-choices repeat=\"prov in a_provincia | filter: $select.search\"><div ng-bind-html=\"prov.no_provincia | highlight: $select.search\"></div></ui-select-choices></ui-select></div><label for=\"co_distri\" class=\"col-sm-1 control-label\">Distrito:</label><div class=\"col-sm-3\"><ui-select ng-model=\"data.co_distri\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Distrito\">{{$select.selected.no_distrito}}</ui-select-match><ui-select-choices repeat=\"distri in a_distrito | filter: $select.search\"><div ng-bind-html=\"distri.no_distrito | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-class=\"{\'has-error\': formEmpresa.no_direccion.$invalid && (formEmpresa.no_direccion.$dirty || formEmpresa.no_direccion.$submitted)}\"><label for=\"no_direccion\" class=\"col-sm-2 control-label\">Dirección:</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"no_direccion\" name=\"no_direccion\" placeholder=\"Dirección\" ng-model=\"data.no_direccion\" style=\"text-transform:uppercase\"> <span class=\"help-block error-block basic-block\" ng-if=\"formEmpresa.no_direccion.$error\"><p ng-repeat=\"(key, value) in formEmpresa.no_direccion.$error\">{{messages.no_direccion[key]}}</p></span></div></div><div class=\"form-group\" ng-class=\"{\'has-error\': formEmpresa.nu_telefono.$invalid && (formEmpresa.nu_telefono.$dirty || formEmpresa.nu_telefono.$submitted)}\"><label for=\"nu_telefono\" class=\"col-sm-2 control-label\">Teléfono:</label><div class=\"col-sm-4\"><input type=\"text\" class=\"form-control\" id=\"nu_telefono\" name=\"nu_telefono\" placeholder=\"Teléfono\" ng-model=\"data.nu_telefono\"> <span class=\"help-block error-block basic-block\" ng-if=\"formEmpresa.nu_telefono.$error\"><p ng-repeat=\"(key, value) in formEmpresa.nu_telefono.$error\">{{messages.nu_telefono[key]}}</p></span></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-10\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"formEmpresa.$invalid || formEmpresa.$pending\">Guardar</button> &nbsp;&nbsp;&nbsp; <a class=\"btn btn-default\" ui-sref=\"dashboard.sucursal.empresa\"><i class=\"fa fa-list-alt\"></i> Listado</a></div></div></form></div></div></div>");
$templateCache.put("app/pages/sucursal/sucursales/sucursales.html","<div class=\"widgets\" ng-init=\"consultar()\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Sucursal\" ba-panel-class=\"with-scroll\"><form class=\"form-horizontal\" name=\"formSucursal\" id=\"formSucursal\" ng-submit=\"guardar(formSucursal)\" novalidate=\"\"><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formSucursal.nu_ruc.$invalid && (formSucursal.nu_ruc.$dirty || formClient.nu_ruc.$submitted)}\"><label for=\"nu_ruc\" class=\"col-sm-2 control-label\">Empresa:</label><div class=\"col-sm-10\"><ui-select name=\"id_empresa\" id=\"id_empresa\" ng-model=\"data.id_empresa\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Empresa\">{{$select.selected.no_empresa}}</ui-select-match><ui-select-choices repeat=\"tipodocumento in jEmpresa | filter: $select.search\"><div ng-bind-html=\"tipodocumento.no_empresa | highlight: $select.search\"></div></ui-select-choices></ui-select><span class=\"help-block error-block basic-block\" ng-if=\"formSucursal.id_empresa.$error\"><p ng-repeat=\"(key, value) in formSucursal.id_empresa.$error\">{{messages.id_empresa[key]}}</p></span></div></div><div class=\"form-group\" ng-class=\"{\'has-error\': formSucursal.no_local.$invalid && (formSucursal.no_local.$dirty || formSucursal.no_local.$submitted)}\"><label for=\"no_local\" class=\"col-sm-2 control-label\">Sucursal:</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"no_local\" name=\"no_local\" placeholder=\"Razón Social\" ng-model=\"data.no_local\" ng-required=\"true\" style=\"text-transform:uppercase\"></div></div><div class=\"form-group\" ng-class=\"{\'has-error\': formSucursal.nombre_comercial.$invalid && (formSucursal.nombre_comercial.$dirty || formSucursal.nombre_comercial.$submitted)}\"><label for=\"co_depart\" class=\"col-sm-2 control-label\">Departamento:</label><div class=\"col-sm-2\"><ui-select ng-model=\"data.co_depart\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getpDepartamento()\"><ui-select-match placeholder=\"Departamento\">{{$select.selected.no_departamento}}</ui-select-match><ui-select-choices repeat=\"depart in a_departamento | filter: $select.search\"><div ng-bind-html=\"depart.no_departamento | highlight: $select.search\"></div></ui-select-choices></ui-select></div><label for=\"co_provin\" class=\"col-sm-1 control-label\">Provincia:</label><div class=\"col-sm-3\"><ui-select ng-model=\"data.co_provin\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getpProvincia()\"><ui-select-match placeholder=\"Provincia\">{{$select.selected.no_provincia}}</ui-select-match><ui-select-choices repeat=\"prov in a_provincia | filter: $select.search\"><div ng-bind-html=\"prov.no_provincia | highlight: $select.search\"></div></ui-select-choices></ui-select></div><label for=\"co_distri\" class=\"col-sm-1 control-label\">Distrito:</label><div class=\"col-sm-3\"><ui-select ng-model=\"data.co_distri\" class=\"btn-group bootstrap-select form-control\"><ui-select-match placeholder=\"Distrito\">{{$select.selected.no_distrito}}</ui-select-match><ui-select-choices repeat=\"distri in a_distrito | filter: $select.search\"><div ng-bind-html=\"distri.no_distrito | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"form-group\" ng-class=\"{\'has-error\': formSucursal.no_direccion.$invalid && (formSucursal.no_direccion.$dirty || formSucursal.no_direccion.$submitted)}\"><label for=\"no_direccion\" class=\"col-sm-2 control-label\">Direccion:</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"no_direccion\" name=\"no_direccion\" placeholder=\"Dirección\" ng-model=\"data.no_direccion\" style=\"text-transform:uppercase\"> <span class=\"help-block error-block basic-block\" ng-if=\"formSucursal.no_direccion.$error\"><p ng-repeat=\"(key, value) in formSucursal.no_direccion.$error\">{{messages.no_direccion[key]}}</p></span></div></div><div class=\"form-group\" ng-class=\"{\'has-error\': formSucursal.no_alias.$invaliad && (formSucursal.no_alias.$dirty || formSucursal.no_alias.$submitted)}\"><label for=\"no_alias\" class=\"col-sm-2 control-label\">Alias:</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"no_alias\" name=\"no_alias\" placeholder=\"Alias\" ng-model=\"data.no_alias\" style=\"text-transform:uppercase\"> <span class=\"help-block error-block basic-block\" ng-if=\"formSucursal.no_alias.$error\"><p ng-repeat=\"(key, value) in formSucursal.no_alias.$error\">{{messages.no_alias[key]}}</p></span></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-10\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"formSucursal.$invalid || formSucursal.$pending\">Guardar</button> &nbsp;&nbsp;&nbsp; <a class=\"btn btn-default\" ui-sref=\"dashboard.sucursal.sucursales\"><i class=\"fa fa-list-alt\"></i> Listado</a></div></div></form></div></div></div>");
$templateCache.put("app/pages/tables/basic/tables.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-lg-6 col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Hover Rows\" ba-panel-class=\"with-scroll table-panel\"><div include-with-scope=\"app/pages/tables/widgets/hoverRows.html\"></div></div></div><div class=\"col-lg-6 col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Bordered Table\" ba-panel-class=\"with-scroll table-panel\"><div include-with-scope=\"app/pages/tables/widgets/borderedTable.html\"></div></div></div></div><div class=\"row\"><div class=\"col-lg-6 col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Condensed Table\" ba-panel-class=\"with-scroll table-panel\"><div include-with-scope=\"app/pages/tables/widgets/condensedTable.html\"></div></div></div><div class=\"col-lg-6 col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Striped Rows\" ba-panel-class=\"with-scroll table-panel\"><div include-with-scope=\"app/pages/tables/widgets/stripedRows.html\"></div></div></div></div><div class=\"row\"><div class=\"col-lg-6 col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Contextual Table\" ba-panel-class=\"with-scroll table-panel\"><div include-with-scope=\"app/pages/tables/widgets/contextualTable.html\"></div></div></div><div class=\"col-lg-6 col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Responsive Table\" ba-panel-class=\"with-scroll table-panel\"><div include-with-scope=\"app/pages/tables/widgets/responsiveTable.html\"></div></div></div></div></div>");
$templateCache.put("app/pages/tables/smart/tables.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Editable Rows\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/tables/widgets/editableRowTable.html\"></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Editable Cells\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/tables/widgets/editableTable.html\"></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Smart Table With Filtering, Sorting And Pagination\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/tables/widgets/smartTable.html\"></div></div></div></div></div>");
$templateCache.put("app/pages/tables/widgets/basicTable.html","<div class=\"horizontal-scroll\"><table class=\"table\"><thead><tr><th class=\"browser-icons\"></th><th>Browser</th><th class=\"align-right\">Visits</th><th class=\"table-arr\"></th><th class=\"align-right\">Downloads</th><th class=\"table-arr\"></th><th class=\"align-right\">Purchases</th><th class=\"table-arr\"></th><th class=\"align-right\">DAU</th><th class=\"table-arr\"></th><th class=\"align-right\">MAU</th><th class=\"table-arr\"></th><th class=\"align-right\">LTV</th><th class=\"table-arr\"></th><th class=\"align-right\">Users %</th><th class=\"table-arr\"></th></tr></thead><tbody><tr><td><img src=\"img/chrome.svg\" width=\"20\" height=\"20\"></td><td class=\"nowrap\">Google Chrome</td><td class=\"align-right\">10,392</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">3,822</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">4,214</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">899</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">7,098</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">178</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">45%</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td></tr><tr><td><img src=\"img/firefox.svg\" width=\"20\" height=\"20\"></td><td class=\"nowrap\">Mozilla Firefox</td><td class=\"align-right\">7,873</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">6,003</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">3,031</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">897</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">8,997</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">102</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">28%</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td></tr><tr><td><img src=\"img/ie.svg\" width=\"20\" height=\"20\"></td><td class=\"nowrap\">Internet Explorer</td><td class=\"align-right\">5,890</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">3,492</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">2,102</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">27</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">4,039</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">99</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">17%</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td></tr><tr><td><img src=\"img/safari.svg\" width=\"20\" height=\"20\"></td><td class=\"nowrap\">Safari</td><td class=\"align-right\">4,001</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">2,039</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">1,001</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">104</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">3,983</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">209</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">14%</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td></tr><tr><td><img src=\"img/opera.svg\" width=\"20\" height=\"20\"></td><td class=\"nowrap\">Opera</td><td class=\"align-right\">1,833</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">983</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">83</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">19</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">1,099</td><td class=\"table-arr\"><i class=\"icon-down\"></i></td><td class=\"align-right\">103</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td><td class=\"align-right\">5%</td><td class=\"table-arr\"><i class=\"icon-up\"></i></td></tr></tbody></table></div>");
$templateCache.put("app/pages/tables/widgets/borderedTable.html","<div class=\"horizontal-scroll\"><table class=\"table table-bordered\"><thead><tr><th class=\"browser-icons\"></th><th>Browser</th><th class=\"align-right\">Visits</th><th class=\"align-right\">Purchases</th><th class=\"align-right\">%</th></tr></thead><tbody><tr ng-repeat=\"item in metricsTableData\"><td><img ng-src=\"{{::( item.image | appImage )}}\" width=\"20\" height=\"20\"></td><td ng-class=\"nowrap\">{{item.browser}}</td><td class=\"align-right\">{{item.visits}}</td><td class=\"align-right\">{{item.purchases}}</td><td class=\"align-right\">{{item.percent}}</td></tr></tbody></table></div>");
$templateCache.put("app/pages/tables/widgets/condensedTable.html","<div class=\"horizontal-scroll\"><table class=\"table table-condensed\"><thead><tr><th class=\"table-id\">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Status</th></tr></thead><tbody><tr ng-repeat=\"item in peopleTableData\"><td class=\"table-id\">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class=\"email-link\" ng-href=\"mailto:{{item.email}}\">{{item.email}}</a></td><td><button class=\"status-button btn btn-xs btn-{{item.status}}\">{{item.status}}</button></td></tr></tbody></table></div>");
$templateCache.put("app/pages/tables/widgets/contextualTable.html","<table class=\"table\"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr class=\"primary\"><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class=\"email-link\" ng-href=\"mailto:mdo@gmail.com\" href=\"mailto:mdo@gmail.com\">mdo@gmail.com</a></td><td>28</td></tr><tr class=\"success\"><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class=\"email-link\" ng-href=\"mailto:fat@yandex.ru\" href=\"mailto:fat@yandex.ru\">fat@yandex.ru</a></td><td>45</td></tr><tr class=\"warning\"><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class=\"email-link\" ng-href=\"mailto:twitter@outlook.com\" href=\"mailto:twitter@outlook.com\">twitter@outlook.com</a></td><td>18</td></tr><tr class=\"danger\"><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class=\"email-link\" ng-href=\"mailto:snow@gmail.com\" href=\"mailto:snow@gmail.com\">snow@gmail.com</a></td><td>20</td></tr><tr class=\"info\"><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class=\"email-link\" ng-href=\"mailto:jack@yandex.ru\" href=\"mailto:jack@yandex.ru\">jack@yandex.ru</a></td><td>30</td></tr></table>");
$templateCache.put("app/pages/tables/widgets/editableRowTable.html","<div class=\"add-row-editable-table\"><button class=\"btn btn-primary\" ng-click=\"addUser()\">Add row</button></div><table class=\"table table-bordered table-hover table-condensed\"><tr><td></td><td>Name</td><td>Status</td><td>Group</td><td>Actions</td></tr><tr ng-repeat=\"user in users\" class=\"editable-row\"><td>{{$index}}</td><td><span editable-text=\"user.name\" e-name=\"name\" e-form=\"rowform\" e-required=\"\">{{ user.name || \'empty\' }}</span></td><td class=\"select-td\"><span editable-select=\"user.status\" e-name=\"status\" e-form=\"rowform\" e-selectpicker=\"\" e-ng-options=\"s.value as s.text for s in statuses\">{{ showStatus(user) }}</span></td><td class=\"select-td\"><span editable-select=\"user.group\" e-name=\"group\" onshow=\"loadGroups()\" e-form=\"rowform\" e-selectpicker=\"\" e-ng-options=\"g.id as g.text for g in groups\">{{ showGroup(user) }}</span></td><td><form editable-form=\"\" name=\"rowform\" ng-show=\"rowform.$visible\" class=\"form-buttons form-inline\" shown=\"inserted == user\"><button type=\"submit\" ng-disabled=\"rowform.$waiting\" class=\"btn btn-primary editable-table-button btn-xs\">Save</button> <button type=\"button\" ng-disabled=\"rowform.$waiting\" ng-click=\"rowform.$cancel()\" class=\"btn btn-default editable-table-button btn-xs\">Cancel</button></form><div class=\"buttons\" ng-show=\"!rowform.$visible\"><button class=\"btn btn-primary editable-table-button btn-xs\" ng-click=\"rowform.$show()\">Edit</button> <button class=\"btn btn-danger editable-table-button btn-xs\" ng-click=\"removeUser($index)\">Delete</button></div></td></tr></table>");
$templateCache.put("app/pages/tables/widgets/editableTable.html","<div class=\"horizontal-scroll\"><table class=\"table table-hover\" st-table=\"editableTableData\"><tr class=\"sortable header-row\"><th class=\"table-id\" st-sort=\"id\" st-sort-default=\"true\">#</th><th st-sort=\"firstName\">First Name</th><th st-sort=\"lastName\">Last Name</th><th st-sort=\"username\">Username</th><th st-sort=\"email\">Email</th><th st-sort=\"age\">Age</th></tr><tr ng-repeat=\"item in editableTableData\" class=\"editable-tr-wrap\"><td class=\"table-id\">{{item.id}}</td><td><span editable-text=\"item.firstName\" blur=\"cancel\">{{item.firstName}}</span></td><td><span editable-text=\"item.lastName\" blur=\"cancel\">{{item.lastName}}</span></td><td><span editable-text=\"item.username\" blur=\"cancel\">{{item.username}}</span></td><td><a class=\"email-link\" ng-href=\"mailto:{{item.email}}\">{{item.email}}</a></td><td><span editable-text=\"item.age\" blur=\"cancel\">{{item.age}}</span></td></tr><tfoot><tr><td colspan=\"6\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"12\" st-displayed-pages=\"5\"></div></td></tr></tfoot></table></div>");
$templateCache.put("app/pages/tables/widgets/hoverRows.html","<div class=\"horizontal-scroll\"><table class=\"table table-hover\"><thead><tr class=\"black-muted-bg\"><th class=\"browser-icons\"></th><th>Browser</th><th class=\"align-right\">Visits</th><th class=\"table-arr\"></th><th class=\"align-right\">Purchases</th><th class=\"table-arr\"></th><th class=\"align-right\">%</th><th class=\"table-arr\"></th></tr></thead><tbody><tr ng-repeat=\"item in metricsTableData\" class=\"no-top-border\"><td><img ng-src=\"{{::( item.image | appImage )}}\" width=\"20\" height=\"20\"></td><td ng-class=\"nowrap\">{{item.browser}}</td><td class=\"align-right\">{{item.visits}}</td><td class=\"table-arr\"><i ng-class=\"{\'icon-up\': item.isVisitsUp, \'icon-down\': !item.isVisitsUp }\"></i></td><td class=\"align-right\">{{item.purchases}}</td><td class=\"table-arr\"><i ng-class=\"{\'icon-up\': item.isPurchasesUp, \'icon-down\': !item.isPurchasesUp }\"></i></td><td class=\"align-right\">{{item.percent}}</td><td class=\"table-arr\"><i ng-class=\"{\'icon-up\': item.isPercentUp, \'icon-down\': !item.isPercentUp }\"></i></td></tr></tbody></table></div>");
$templateCache.put("app/pages/tables/widgets/responsiveTable.html","<div class=\"table-responsive\"><table class=\"table\"><tr><th>#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr><tr><td>1</td><td>Mark</td><td>Otto</td><td>@mdo</td><td><a class=\"email-link\" ng-href=\"mailto:mdo@gmail.com\" href=\"mailto:mdo@gmail.com\">mdo@gmail.com</a></td><td>28</td></tr><tr><td>2</td><td>Jacob</td><td>Thornton</td><td>@fat</td><td><a class=\"email-link\" ng-href=\"mailto:fat@yandex.ru\" href=\"mailto:fat@yandex.ru\">fat@yandex.ru</a></td><td>45</td></tr><tr><td>3</td><td>Larry</td><td>Bird</td><td>@twitter</td><td><a class=\"email-link\" ng-href=\"mailto:twitter@outlook.com\" href=\"mailto:twitter@outlook.com\">twitter@outlook.com</a></td><td>18</td></tr><tr><td>4</td><td>John</td><td>Snow</td><td>@snow</td><td><a class=\"email-link\" ng-href=\"mailto:snow@gmail.com\" href=\"mailto:snow@gmail.com\">snow@gmail.com</a></td><td>20</td></tr><tr><td>5</td><td>Jack</td><td>Sparrow</td><td>@jack</td><td><a class=\"email-link\" ng-href=\"mailto:jack@yandex.ru\" href=\"mailto:jack@yandex.ru\">jack@yandex.ru</a></td><td>30</td></tr></table></div>");
$templateCache.put("app/pages/tables/widgets/smartTable.html","<div class=\"horizontal-scroll\"><div class=\"form-group select-page-size-wrap\"><label>Rows on page<select class=\"form-control selectpicker show-tick\" title=\"Rows on page\" selectpicker=\"\" ng-model=\"smartTablePageSize\" ng-options=\"i for i in [5,10,15,20,25]\"></select></label></div><table class=\"table\" st-table=\"smartTableData\"><thead><tr class=\"sortable\"><th class=\"table-id\" st-sort=\"id\" st-sort-default=\"true\">#</th><th st-sort=\"firstName\">First Name</th><th st-sort=\"lastName\">Last Name</th><th st-sort=\"username\">Username</th><th st-sort=\"email\">Email</th><th st-sort=\"age\">Age</th></tr><tr><th></th><th><input st-search=\"firstName\" placeholder=\"Search First Name\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"lastName\" placeholder=\"Search Last Name\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"username\" placeholder=\"Search Username\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"email\" placeholder=\"Search Email\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"age\" placeholder=\"Search Age\" class=\"input-sm form-control search-input\" type=\"search\"></th></tr></thead><tbody><tr ng-repeat=\"item in smartTableData\"><td class=\"table-id\">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class=\"email-link\" ng-href=\"mailto:{{item.email}}\">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody><tfoot><tr><td colspan=\"6\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"5\"></div></td></tr></tfoot></table></div>");
$templateCache.put("app/pages/tables/widgets/stripedRows.html","<div class=\"vertical-scroll\"><table class=\"table table-striped\"><thead><tr><th class=\"table-id\">#</th><th>First Name</th><th>Last Name</th><th>Username</th><th>Email</th><th>Age</th></tr></thead><tbody><tr ng-repeat=\"item in smartTableData\"><td class=\"table-id\">{{item.id}}</td><td>{{item.firstName}}</td><td>{{item.lastName}}</td><td>{{item.username}}</td><td><a class=\"email-link\" ng-href=\"mailto:{{item.email}}\">{{item.email}}</a></td><td>{{item.age}}</td></tr></tbody></table></div>");
$templateCache.put("app/pages/ui/alerts/alerts.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-6\" ba-panel=\"\" ba-panel-title=\"Basic\" ba-panel-class=\"with-scroll\"><div><div class=\"alert bg-success\"><strong>Well done!</strong> You successfully read this important alert message.</div><div class=\"alert bg-info\"><strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class=\"alert bg-warning\"><strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class=\"alert bg-danger\"><strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div><div class=\"col-md-6\" ba-panel=\"\" ba-panel-title=\"Dismissible alerts\" ba-panel-class=\"with-scroll\"><div><div class=\"alert bg-success closeable\" role=\"alert\"><button type=\"button\" class=\"close\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button> <strong>Well done!</strong> You successfully read this important alert message.</div><div class=\"alert bg-info closeable\" role=\"alert\"><button type=\"button\" class=\"close\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button> <strong>Heads up!</strong> This alert needs your attention, but it\'s not super important.</div><div class=\"alert bg-warning closeable\" role=\"alert\"><button type=\"button\" class=\"close\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button> <strong>Warning!</strong> Better check yourself, you\'re not looking too good.</div><div class=\"alert bg-danger closeable\" role=\"alert\"><button type=\"button\" class=\"close\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button> <strong>Oh snap!</strong> Change a few things up and try submitting again.</div></div></div></div><div class=\"row\"><div class=\"col-md-6\" ba-panel=\"\" ba-panel-title=\"Links in alerts\" ba-panel-class=\"with-scroll\"><div><div class=\"alert bg-success\"><strong>Well done!</strong> You successfully read <a href=\"\" class=\"alert-link\">this important alert message</a>.</div><div class=\"alert bg-info\"><strong>Heads up!</strong> This <a href=\"\" class=\"alert-link\">alert needs your attention</a>, but it\'s not super important.</div><div class=\"alert bg-warning\"><strong>Warning!</strong> Better check yourself, you\'re <a href=\"\" class=\"alert-link\">not looking too good</a>.</div><div class=\"alert bg-danger\"><strong>Oh snap!</strong> <a href=\"\" class=\"alert-link\">Change a few things up</a> and try submitting again.</div></div></div><div class=\"col-md-6\" ba-panel=\"\" ba-panel-title=\"Composite alerts\" ba-panel-class=\"with-scroll\"><div><div class=\"alert bg-warning\"><h4>Warning!</h4><strong>Pay attention.</strong> Change a few things up and try submitting again.<div class=\"control-alert\"><button type=\"button\" class=\"btn btn-danger\">Pay Attention</button> <button type=\"button\" class=\"btn btn-primary\">Ignore</button></div></div></div></div></div></div>");
$templateCache.put("app/pages/ui/buttons/buttons.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-3\" ba-panel=\"\" ba-panel-title=\"Flat Buttons\" ba-panel-class=\"with-scroll button-panel\"><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-default\">Default</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-primary\">Primary</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-success\">Success</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-info\">Info</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-warning\">Warning</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-danger\">Danger</button></div></div><div class=\"col-md-3\" ba-panel=\"\" ba-panel-title=\"Raised Buttons\" ba-panel-class=\"with-scroll button-panel\"><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-default btn-raised\">Default</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-primary btn-raised\">Primary</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-success btn-raised\">Success</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-info btn-raised\">Info</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-warning btn-raised\">Warning</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-danger btn-raised\">Danger</button></div></div><div class=\"col-md-3\" ba-panel=\"\" ba-panel-title=\"Different sizes\" ba-panel-class=\"with-scroll button-panel df-size-button-panel\"><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-default btn-xs\">Default</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-primary btn-sm\">Primary</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-success btn-mm\">Success</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-info btn-md\">Info</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-warning btn-xm\">Warning</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-danger btn-lg\">Danger</button></div></div><div class=\"col-md-3\" ba-panel=\"\" ba-panel-title=\"Disabled\" ba-panel-class=\"with-scroll button-panel\"><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-default\" disabled=\"disabled\">Default</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-primary\" disabled=\"disabled\">Primary</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-success\" disabled=\"disabled\">Success</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-info\" disabled=\"disabled\">Info</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-warning\" disabled=\"disabled\">Warning</button></div><div class=\"button-wrapper\"><button type=\"button\" class=\"btn btn-danger\" disabled=\"disabled\">Danger</button></div></div></div><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Icon Buttons\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/buttons/widgets/iconButtons.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Large Buttons\" ba-panel-class=\"with-scroll large-buttons-panel\"><div ng-include=\"\'app/pages/ui/buttons/widgets/largeButtons.html\'\"></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Button Dropdowns\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/buttons/widgets/dropdowns.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Button Groups\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/buttons/widgets/buttonGroups.html\'\"></div></div></div></div><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Progress Buttons\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/buttons/widgets/progressButtons.html\'\"></div></div></div></div>");
$templateCache.put("app/pages/ui/icons/icons.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Kameleon SVG Icons\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/ui/icons/widgets/kameleon.html\"></div></div><div ba-panel=\"\" ba-panel-title=\"Socicon\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/ui/icons/widgets/socicon.html\"></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Icons With Rounded Background\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/ui/icons/widgets/kameleonRounded.html\"></div></div><div ba-panel=\"\" ba-panel-title=\"ionicons\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/ui/icons/widgets/ionicons.html\"></div></div><div ba-panel=\"\" ba-panel-title=\"Font Awesome Icons\" ba-panel-class=\"with-scroll\"><div include-with-scope=\"app/pages/ui/icons/widgets/fontAwesomeIcons.html\"></div></div></div></div></div>");
$templateCache.put("app/pages/ui/modals/modals.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Modals\" ba-panel-class=\"with-scroll\"><div class=\"modal-buttons clearfix\"><button type=\"button\" class=\"btn btn-primary\" data-toggle=\"modal\" ng-click=\"open(\'app/pages/ui/modals/modalTemplates/basicModal.html\', \'md\')\">Default modal</button> <button type=\"button\" class=\"btn btn-success\" data-toggle=\"modal\" ng-click=\"open(\'app/pages/ui/modals/modalTemplates/largeModal.html\', \'lg\')\">Large modal</button> <button type=\"button\" class=\"btn btn-warning\" data-toggle=\"modal\" ng-click=\"open(\'app/pages/ui/modals/modalTemplates/smallModal.html\', \'sm\')\">Small modal</button></div></div></div><div class=\"row\"><div class=\"col-md-6\" ba-panel=\"\" ba-panel-title=\"Message Modals\" ba-panel-class=\"with-scroll\"><div class=\"modal-buttons same-width clearfix\"><button type=\"button\" class=\"btn btn-success\" data-toggle=\"modal\" ng-click=\"open(\'app/pages/ui/modals/modalTemplates/successModal.html\')\">Success Message</button> <button type=\"button\" class=\"btn btn-info\" data-toggle=\"modal\" ng-click=\"open(\'app/pages/ui/modals/modalTemplates/infoModal.html\')\">Info Message</button> <button type=\"button\" class=\"btn btn-warning\" data-toggle=\"modal\" ng-click=\"open(\'app/pages/ui/modals/modalTemplates/warningModal.html\')\">Warning Message</button> <button type=\"button\" class=\"btn btn-danger\" data-toggle=\"modal\" ng-click=\"open(\'app/pages/ui/modals/modalTemplates/dangerModal.html\')\">Danger Message</button></div></div><div class=\"col-md-6\" ba-panel=\"\" ba-panel-title=\"Notifications\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/modals/notifications/notifications.html\'\"></div></div></div></div>");
$templateCache.put("app/pages/ui/panels/panels.html","<h2>Default panels</h2><div class=\"row\"><div class=\"col-md-12 col-lg-4\"><div ba-panel=\"\" ba-panel-class=\"xsmall-panel light-text\">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris ac mi erat. Phasellus placerat, elit a laoreet semper, enim ipsum ultricies orci, ac tincidunt tellus massa eu est. Nam non porta purus, sed facilisis justo. Nam pulvinar sagittis quam.</div></div><div class=\"col-md-12 col-lg-4\"><div ba-panel=\"\" ba-panel-title=\"Panel with header\" ba-panel-class=\"xsmall-panel light-text\">Phasellus maximus venenatis augue, et vestibulum neque aliquam ut. Morbi mattis libero vitae vulputate dignissim. Praesent placerat, sem non dapibus cursus, lacus nisi blandit quam, vitae porttitor lectus lacus non turpis. Donec suscipit consequat tellus.</div></div><div class=\"col-md-12 col-lg-4\"><div ba-panel=\"\" ba-panel-title=\"Panel with header & scroll\" ba-panel-class=\"xsmall-panel with-scroll light-text\"><p>Suspendisse nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Sed dapibus, purus vel hendrerit consectetur, lectus orci gravida massa, sed bibendum dui mauris et eros. Nulla dolor massa, posuere et dictum sit amet, dignissim quis odio. Fusce mollis finibus dignissim. Integer sodales augue erat. Pellentesque laoreet vestibulum urna at iaculis. Nulla libero augue, euismod at diam eget, aliquam condimentum ligula. Donec a leo eu est molestie lacinia hendrerit sed lorem. Duis id diam eu metus sodales consequat vel eu elit. Praesent dolor nibh, convallis eleifend feugiat a, finibus porttitor nibh. Ut non libero vel velit pulvinar scelerisque non vel lorem. Integer porta tempor nulla. Sed nibh erat, ultrices vel lorem eu, rutrum vehicula sem.</p><p>Donec nec tellus urna. Sed id est metus. Nullam sit amet dolor nec ipsum dictum suscipit. Mauris sed nisi mauris. Nulla iaculis nisl ut velit ornare imperdiet. Suspendisse potenti. In tempor leo sed sem malesuada pellentesque. Maecenas faucibus metus lacus, ac egestas diam vulputate vitae.</p><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque fermentum nec ligula egestas rhoncus. Sed dignissim, augue vel scelerisque vulputate, nisi ante posuere lorem, quis iaculis eros dolor eu nisl. Etiam sagittis, ipsum ac tempor iaculis, justo neque mattis ante, ac maximus sapien risus eu sapien. Morbi erat urna, varius et lectus vel, porta dictum orci. Duis bibendum euismod elit, et lobortis purus venenatis in. Mauris eget lacus enim. Cras quis sem et magna fringilla convallis. Proin hendrerit nulla vel gravida mollis. Interdum et malesuada fames ac ante ipsum primis in faucibus. Vestibulum consectetur quis purus vel aliquam.</p></div></div></div><h2>Bootstrap panels</h2><div class=\"row\"><div class=\"col-md-12 col-lg-4\"><div class=\"panel panel-default bootstrap-panel xsmall-panel\"><div class=\"panel-body\"><p>A panel in bootstrap is a bordered box with some padding around its content.</p><p class=\"p-with-code\">Panels are created with the <code>.panel</code> class, and content inside the panel has a <code>.panel-body</code> class. The <code>.panel-default .panel-primary .panel-danger</code> and other classes are used to style the color of the panel. See the next example on this page for more contextual classes.</p></div></div></div><div class=\"col-md-12 col-lg-4\"><div class=\"panel panel-default bootstrap-panel xsmall-panel\"><div class=\"panel-heading\">Panel Heading</div><div class=\"panel-body\"><p class=\"p-with-code\">The <code>.panel-heading</code> class adds a heading to the panel.Easily add a heading container to your panel with .panel-heading. You may also include any <code>h1-h6</code> with a <code>.panel-title</code> class to add a pre-styled heading.</p></div></div></div><div class=\"col-md-12 col-lg-4\"><div class=\"panel panel-default bootstrap-panel\"><div class=\"panel-body footer-panel\"><p class=\"p-with-code\">Wrap buttons or secondary text in <code>.panel-footer</code>. Note that panel footers do not inherit colors and borders when using contextual variations as they are not meant to be in the foreground.</p></div><div class=\"panel-footer\">Panel Footer</div></div></div></div><h2>Panels with Contextual Classes</h2><div class=\"row\"><div class=\"col-md-6 col-lg-4\"><div class=\"panel panel-default contextual-example-panel bootstrap-panel\"><div class=\"panel-heading\">Panel with panel-default class</div><div class=\"panel-body\">To color the panel, use contextual classes. This is sample <code>.panel-default</code> panel</div></div></div><div class=\"col-md-6 col-lg-4\"><div class=\"panel panel-primary contextual-example-panel bootstrap-panel\"><div class=\"panel-heading\">Panel with panel-primary class</div><div class=\"panel-body\">Sample <code>.panel-primary</code> panel</div></div></div><div class=\"col-md-6 col-lg-4\"><div class=\"panel panel-success contextual-example-panel bootstrap-panel\"><div class=\"panel-heading\">Panel with panel-success class</div><div class=\"panel-body\">Sample <code>.panel-success</code> panel</div></div></div><div class=\"col-md-6 col-lg-4\"><div class=\"panel panel-info contextual-example-panel bootstrap-panel\"><div class=\"panel-heading\">Panel with panel-info class</div><div class=\"panel-body\">Sample <code>.panel-info</code> panel</div></div></div><div class=\"col-md-6 col-lg-4\"><div class=\"panel panel-warning contextual-example-panel bootstrap-panel\"><div class=\"panel-heading\">Panel with panel-warning class</div><div class=\"panel-body\">Sample <code>.panel-warning</code> panel</div></div></div><div class=\"col-md-6 col-lg-4\"><div class=\"panel panel-danger contextual-example-panel bootstrap-panel\"><div class=\"panel-heading\">Panel with panel-danger class</div><div class=\"panel-body\">Sample <code>.panel-danger</code> panel</div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><h2>Panel Group</h2><div class=\"panel-group\"><div class=\"panel panel-default bootstrap-panel\"><div class=\"panel-heading\">Panel group 1</div><div class=\"panel-body\"><p>To group many panels together, wrap a <code>&lt;div&gt;</code> with class <code>\r\n            .panel-group</code> around them.</p></div></div><div class=\"panel panel-default bootstrap-panel\"><div class=\"panel-heading\">Panel group 2</div><div class=\"panel-body\"><p>The <code>.panel-group</code> class clears the bottom-margin of each panel.</p></div></div></div></div></div>");
$templateCache.put("app/pages/ui/notifications/notifications.html","<div ba-panel=\"\" ba-panel-class=\"with-scroll notification-panel\"><div class=\"row\"><div class=\"col-md-3 col-sm-4\"><div class=\"control\"><label for=\"title\">Title</label> <input ng-model=\"options.title\" type=\"text\" class=\"form-control\" id=\"title\" placeholder=\"Enter a title ...\"></div><div class=\"control\"><label for=\"message\">Message</label> <textarea ng-model=\"options.msg\" class=\"form-control\" id=\"message\" rows=\"3\" placeholder=\"Enter a message ...\"></textarea></div><div class=\"control-group\"><div class=\"control\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"options.closeButton\" type=\"checkbox\" id=\"closeButton\"> <span>Close Button</span></label></div><div class=\"control\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"options.allowHtml\" type=\"checkbox\" id=\"html\"> <span>Allow html</span></label></div><div class=\"control\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"options.progressBar\" type=\"checkbox\" id=\"progressBar\"> <span>Progress bar</span></label></div><div class=\"control\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"options.preventDuplicates\" type=\"checkbox\" id=\"preventDuplicates\"> <span>Prevent duplicates</span></label></div><div class=\"control\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"options.preventOpenDuplicates\" type=\"checkbox\" id=\"preventOpenDuplicates\"> <span>Prevent open duplicates</span></label></div><div class=\"control\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"options.tapToDismiss\" type=\"checkbox\" id=\"tapToDismiss\"> <span>Tap to dismiss</span></label></div><div class=\"control\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"options.newestOnTop\" type=\"checkbox\" id=\"newestOnTop\"> <span>Newest on top</span></label></div></div></div><div class=\"col-md-2 col-sm-3 toastr-radio-setup\"><div id=\"toastTypeGroup\"><div class=\"controls radio-controls\"><label class=\"radio-header\">Toast Type</label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.type\" name=\"toasts\" value=\"success\"><span>Success</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.type\" name=\"toasts\" value=\"info\"><span>Info</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.type\" name=\"toasts\" value=\"warning\"><span>Warning</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.type\" name=\"toasts\" value=\"error\"><span>Error</span></label></div></div><div id=\"positionGroup\"><div class=\"controls radio-controls\"><label class=\"radio-header position-header\">Position</label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.positionClass\" name=\"positions\" value=\"toast-top-right\"> <span>Top Right</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.positionClass\" name=\"positions\" value=\"toast-bottom-right\"> <span>Bottom Right</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.positionClass\" name=\"positions\" value=\"toast-bottom-left\"> <span>Bottom Left</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.positionClass\" name=\"positions\" value=\"toast-top-left\"> <span>Top Left</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.positionClass\" name=\"positions\" value=\"toast-top-full-width\"> <span>Top Full Width</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.positionClass\" name=\"positions\" value=\"toast-bottom-full-width\"> <span>Bottom Full Width</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.positionClass\" name=\"positions\" value=\"toast-top-center\"> <span>Top Center</span></label> <label class=\"radio custom-radio\"><input type=\"radio\" ng-model=\"options.positionClass\" name=\"positions\" value=\"toast-bottom-center\"> <span>Bottom Center</span></label></div></div></div><div class=\"col-md-2 col-sm-3\"><div class=\"control\"><label for=\"timeOut\">Time out</label> <input type=\"text\" class=\"form-control\" id=\"timeOut\" ng-model=\"options.timeOut\" placeholder=\"ms\"> <label class=\"sub-label\" for=\"timeOut\">If you set it to 0, it will stick</label></div><div class=\"control\"><label for=\"extendedTimeOut\">Extended time out</label> <input type=\"text\" class=\"form-control\" id=\"extendedTimeOut\" ng-model=\"options.extendedTimeOut\" placeholder=\"ms\"></div><div class=\"control\"><label for=\"maxOpened\">Maximum number of toasts</label> <input type=\"text\" class=\"form-control\" id=\"maxOpened\" ng-model=\"options.maxOpened\" value=\"0\"> <label for=\"maxOpened\" class=\"sub-label\">0 means no limit</label></div><div class=\"control\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input ng-model=\"options.autoDismiss\" type=\"checkbox\" id=\"autoDismiss\"> <span>Auto dismiss</span></label></div></div><div class=\"col-md-5 col-sm-12\"><label>Result:</label><pre class=\"result-toastr\" id=\"toastrOptions\">{{optionsStr}}</pre></div></div><div class=\"row\"><div class=\"col-md-12 button-row\"><button ng-click=\"openToast()\" class=\"btn btn-primary\">Open Toast</button> <button ng-click=\"openRandomToast()\" class=\"btn btn-primary\">Random Toast</button> <button ng-click=\"clearToasts()\" class=\"btn btn-danger\">Clear Toasts</button> <button ng-click=\"clearLastToast()\" class=\"btn btn-danger\">Clear Last Toast</button></div></div></div>");
$templateCache.put("app/pages/ui/grid/baseGrid.html","<h4 class=\"grid-h\">Stacked to horizontal</h4><div class=\"row show-grid\"><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div><div class=\"col-md-1\"><div>.col-md-1</div></div></div><div class=\"row show-grid\"><div class=\"col-md-8\"><div>.col-md-8</div></div><div class=\"col-md-4\"><div>.col-md-4</div></div></div><div class=\"row show-grid\"><div class=\"col-md-4\"><div>.col-md-4</div></div><div class=\"col-md-4\"><div>.col-md-4</div></div><div class=\"col-md-4\"><div>.col-md-4</div></div></div><div class=\"row show-grid\"><div class=\"col-md-6\"><div>.col-md-6</div></div><div class=\"col-md-6\"><div>.col-md-6</div></div></div><h4 class=\"grid-h\">Mobile and desktop</h4><div class=\"row show-grid\"><div class=\"col-xs-12 col-md-8\"><div>xs-12 .col-md-8</div></div><div class=\"col-xs-6 col-md-4\"><div>xs-6 .col-md-4</div></div></div><div class=\"row show-grid\"><div class=\"col-xs-6 col-md-4\"><div>xs-6 .col-md-4</div></div><div class=\"col-xs-6 col-md-4\"><div>xs-6 .col-md-4</div></div><div class=\"col-xs-6 col-md-4\"><div>xs-6 .col-md-4</div></div></div><div class=\"row show-grid\"><div class=\"col-xs-6\"><div>.col-xs-6</div></div><div class=\"col-xs-6\"><div>.col-xs-6</div></div></div><h4 class=\"grid-h\">Mobile, tablet, desktop</h4><div class=\"row show-grid\"><div class=\"col-xs-12 col-sm-6 col-md-8\"><div>.col-xs-12 .col-sm-6 .col-md-8</div></div><div class=\"col-xs-6 col-md-4\"><div>.col-xs-6 .col-md-4</div></div></div><div class=\"row show-grid\"><div class=\"col-xs-6 col-sm-4\"><div>.col-xs-6 .col-sm-4</div></div><div class=\"col-xs-6 col-sm-4\"><div>.col-xs-6 .col-sm-4</div></div><div class=\"clearfix visible-xs-block\"></div><div class=\"col-xs-6 col-sm-4\"><div>.col-xs-6 .col-sm-4</div></div></div><h4 class=\"grid-h\">Column wrapping</h4><div class=\"row show-grid\"><div class=\"col-xs-9\"><div>.col-xs-9</div></div><div class=\"col-xs-4\"><div>.col-xs-4<br>Since 9 + 4 = 13 &gt; 12, this 4-column-wide div gets wrapped onto a new line as one contiguous unit.</div></div><div class=\"col-xs-6\"><div>.col-xs-6<br>Subsequent columns continue along the new line.</div></div></div><h4 class=\"grid-h\">Responsive column resets</h4><div class=\"row show-grid\"><div class=\"col-xs-6 col-sm-3\"><div>.col-xs-6 .col-sm-3<p>Resize your viewport or check it out on your phone for an example.</p></div></div><div class=\"col-xs-6 col-sm-3\"><div>.col-xs-6 .col-sm-3</div></div><div class=\"clearfix visible-xs-block\"></div><div class=\"col-xs-6 col-sm-3\"><div>.col-xs-6 .col-sm-3</div></div><div class=\"col-xs-6 col-sm-3\"><div>.col-xs-6 .col-sm-3</div></div></div><h4 class=\"grid-h\">Offsetting columns</h4><div class=\"row show-grid\"><div class=\"col-md-4\"><div>.col-md-4</div></div><div class=\"col-md-4 col-md-offset-4\"><div>.col-md-4 .col-md-offset-4</div></div></div><div class=\"row show-grid\"><div class=\"col-md-3 col-md-offset-3\"><div>.col-md-3 .col-md-offset-3</div></div><div class=\"col-md-3 col-md-offset-3\"><div>.col-md-3 .col-md-offset-3</div></div></div><div class=\"row show-grid\"><div class=\"col-md-6 col-md-offset-3\"><div>.col-md-6 .col-md-offset-3</div></div></div><h4 class=\"grid-h\">Grid options</h4><div class=\"table-responsive\"><table class=\"table table-bordered table-striped\"><thead><tr><th></th><th>Extra small devices <small>Phones (&lt;768px)</small></th><th>Small devices <small>Tablets (≥768px)</small></th><th>Medium devices <small>Desktops (≥992px)</small></th><th>Large devices <small>Desktops (≥1200px)</small></th></tr></thead><tbody><tr><th class=\"text-nowrap\" scope=\"row\">Grid behavior</th><td>Horizontal at all times</td><td colspan=\"3\">Collapsed to start, horizontal above breakpoints</td></tr><tr><th class=\"text-nowrap\" scope=\"row\">Container width</th><td>None (auto)</td><td>750px</td><td>970px</td><td>1170px</td></tr><tr><th class=\"text-nowrap\" scope=\"row\">Class prefix</th><td><code>.col-xs-</code></td><td><code>.col-sm-</code></td><td><code>.col-md-</code></td><td><code>.col-lg-</code></td></tr><tr><th class=\"text-nowrap\" scope=\"row\"># of columns</th><td colspan=\"4\">12</td></tr><tr><th class=\"text-nowrap\" scope=\"row\">Column width</th><td class=\"text-muted\">Auto</td><td>~62px</td><td>~81px</td><td>~97px</td></tr><tr><th class=\"text-nowrap\" scope=\"row\">Gutter width</th><td colspan=\"4\">30px (15px on each side of a column)</td></tr><tr><th class=\"text-nowrap\" scope=\"row\">Nestable</th><td colspan=\"4\">Yes</td></tr><tr><th class=\"text-nowrap\" scope=\"row\">Offsets</th><td colspan=\"4\">Yes</td></tr><tr><th class=\"text-nowrap\" scope=\"row\">Column ordering</th><td colspan=\"4\">Yes</td></tr></tbody></table></div>");
$templateCache.put("app/pages/ui/grid/grid.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Inline Form\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/grid/baseGrid.html\'\"></div></div></div></div>");
$templateCache.put("app/pages/ui/progressBars/progressBars.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"Basic\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/progressBars/widgets/basic.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Striped\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/progressBars/widgets/striped.html\'\"></div></div></div><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-title=\"With label\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/progressBars/widgets/label.html\'\"></div></div><div ba-panel=\"\" ba-panel-title=\"Animated\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/progressBars/widgets/animated.html\'\"></div></div></div></div><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Stacked\" ba-panel-class=\"with-scroll\"><div ng-include=\"\'app/pages/ui/progressBars/widgets/stacked.html\'\"></div></div></div></div>");
$templateCache.put("app/pages/ui/slider/slider.html","<div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Ion Range Slider\" ba-panel-class=\"with-scroll\"><div class=\"slider-box\"><h5>Basic</h5><ion-slider type=\"single\" grid=\"false\" min=\"0\" max=\"100\" from=\"45\" disable=\"false\"></ion-slider></div><div class=\"slider-box\"><h5>With prefix</h5><ion-slider type=\"single\" grid=\"true\" min=\"100\" max=\"1200\" prefix=\"$\" from=\"420\" disable=\"false\"></ion-slider></div><div class=\"slider-box\"><h5>With postfix</h5><ion-slider type=\"single\" grid=\"true\" min=\"-90\" max=\"90\" postfix=\"°\" from=\"36\" disable=\"false\"></ion-slider></div><div class=\"slider-box\"><h5>Two way range</h5><ion-slider type=\"double\" grid=\"true\" min=\"100\" max=\"1200\" from=\"420\" to=\"900\" disable=\"false\"></ion-slider></div><div class=\"slider-box\"><h5>With Steps</h5><ion-slider type=\"single\" grid=\"true\" min=\"0\" max=\"1000\" from=\"300\" step=\"50\" disable=\"false\"></ion-slider></div><div class=\"slider-box\"><h5>Decorating numbers</h5><ion-slider type=\"single\" grid=\"true\" min=\"0\" max=\"1000000\" from=\"300000\" step=\"1000\" prettify-separator=\".\" prettify=\"true\" disable=\"false\"></ion-slider></div><div class=\"slider-box\"><h5>Using custom values array</h5><ion-slider type=\"single\" grid=\"true\" from=\"5\" step=\"1000\" values=\"[\'January\', \'February\', \'March\', \'April\', \'May\', \'June\', \'July\', \'August\', \'September\', \'October\', \'November\', \'December\']\" disable=\"false\"></ion-slider></div><div class=\"slider-box\"><h5>Disabled</h5><ion-slider type=\"single\" grid=\"false\" min=\"0\" max=\"100\" from=\"45\" disable=\"true\"></ion-slider></div></div></div></div>");
$templateCache.put("app/pages/ui/tabs/contextualAccordion.html","<uib-accordion><uib-accordion-group heading=\"Primary\" panel-class=\"panel-primary bootstrap-panel accordion-panel\">Primary <i class=\"ion-heart\"></i></uib-accordion-group><uib-accordion-group heading=\"Success\" panel-class=\"panel-success bootstrap-panel accordion-panel\">Success <i class=\"ion-checkmark-round\"></i></uib-accordion-group><uib-accordion-group heading=\"Info\" panel-class=\"panel-info bootstrap-panel accordion-panel\">Info <i class=\"ion-information-circled\"></i></uib-accordion-group><uib-accordion-group heading=\"Warning\" panel-class=\"panel-warning bootstrap-panel accordion-panel\">Warning <i class=\"ion-alert\"></i></uib-accordion-group><uib-accordion-group heading=\"Danger\" panel-class=\"panel-danger bootstrap-panel accordion-panel\">Danger <i class=\"ion-nuclear\"></i></uib-accordion-group></uib-accordion>");
$templateCache.put("app/pages/ui/tabs/mainTabs.html","<uib-tabset active=\"$tabSetStatus.activeTab\"><uib-tab heading=\"Start\"><p>Take up one idea. Make that one idea your life--think of it, dream of it, live on that idea. Let the brain, muscles, nerves, every part of your body, be full of that idea, and just leave every other idea alone. This is the way to success.</p><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed. Similarly, when someone is failing, the tendency is to get on a downward spiral that can even become a self-fulfilling prophecy.</p><div class=\"text-center\"><div class=\"kameleon-icon with-round-bg primary inline-icon\"><img ng-src=\"{{::( \'Shop\' | kameleonImg )}}\"></div><div class=\"kameleon-icon with-round-bg primary inline-icon\"><img ng-src=\"{{::( \'Programming\' | kameleonImg )}}\"></div><div class=\"kameleon-icon with-round-bg primary inline-icon\"><img ng-src=\"{{::( \'Dna\' | kameleonImg )}}\"></div></div><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading=\"Getting Done\"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab ng-init=\"$dropdownTabActive = 1\" class=\"with-dropdown\"><uib-tab-heading uib-dropdown=\"\"><a uib-dropdown-toggle=\"\" ng-click=\"$event.stopPropagation()\">Dropdown tab <i class=\"caret\"></i></a><ul class=\"dropdown-menu\" uib-dropdown-menu=\"\"><li><a ng-click=\"$dropdownTabActive = 1; $tabSetStatus.activeTab = 3\">Tab 1</a></li><li><a ng-click=\"$dropdownTabActive = 2; $tabSetStatus.activeTab = 3\">Tab 2</a></li></ul></uib-tab-heading><div ng-show=\"$dropdownTabActive == 1\"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></div><div ng-show=\"$dropdownTabActive == 2\"><p class=\"text-center\"><button class=\"btn btn-danger\">I\'m just a dummy button</button></p></div></uib-tab></uib-tabset>");
$templateCache.put("app/pages/ui/tabs/sampleAccordion.html","<uib-accordion><uib-accordion-group is-open=\"true\" heading=\"Static Header, initially expanded\" panel-class=\"bootstrap-panel accordion-panel panel-default\">This content is straight in the template.</uib-accordion-group><uib-accordion-group heading=\"Dynamic Body Content\" panel-class=\"bootstrap-panel accordion-panel panel-default\"><p>The body of the uib-accordion group grows to fit the contents</p><button type=\"button\" class=\"btn btn-primary btn-sm\">Add Item</button></uib-accordion-group><uib-accordion-group heading=\"Custom template\" panel-class=\"bootstrap-panel accordion-panel panel-default\">Hello</uib-accordion-group><uib-accordion-group panel-class=\"bootstrap-panel accordion-panel panel-default\"><uib-accordion-heading>I can have markup, too! <i class=\"fa pull-right ion-settings\"></i></uib-accordion-heading>This is just some content to illustrate fancy headings.</uib-accordion-group></uib-accordion>");
$templateCache.put("app/pages/ui/tabs/sideTabs.html","<div ba-panel=\"\" ba-panel-class=\"tabs-panel xsmall-panel with-scroll\"><uib-tabset class=\"tabs-left\"><uib-tab heading=\"Start\"><p class=\"text-center\">Take up one idea.</p><div class=\"kameleon-icon-tabs kameleon-icon with-round-bg danger\"><img ng-src=\"{{::( \'Key\' | kameleonImg )}}\"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading=\"Get it done\"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading=\"Achieve\"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div><div ba-panel=\"\" ba-panel-class=\"tabs-panel xsmall-panel with-scroll\"><uib-tabset class=\"tabs-right\"><uib-tab heading=\"Start\"><p class=\"text-center\">Take up one idea.</p><div class=\"kameleon-icon-tabs kameleon-icon with-round-bg warning\"><img ng-src=\"{{::( \'Phone-Booth\' | kameleonImg )}}\"></div><p>People who succeed have momentum. The more they succeed, the more they want to succeed, and the more they find a way to succeed.</p></uib-tab><uib-tab heading=\"Get it done\"><p>You can\'t connect the dots looking forward; you can only connect them looking backwards. So you have to trust that the dots will somehow connect in your future. You have to trust in something--your gut, destiny, life, karma, whatever. This approach has never let me down, and it has made all the difference in my life.</p><p>The reason most people never reach their goals is that they don\'t define them, or ever seriously consider them as believable or achievable. Winners can tell you where they are going, what they plan to do along the way, and who will be sharing the adventure with them.</p></uib-tab><uib-tab heading=\"Achieve\"><p>Success is ... knowing your purpose in life, growing to reach your maximum potential, and sowing seeds that benefit others.</p><p>Failure is the condiment that gives success its flavor.</p></uib-tab></uib-tabset></div>");
$templateCache.put("app/pages/ui/tabs/tabs.html","<div><div class=\"row\"><div class=\"col-md-6\"><div ba-panel=\"\" ba-panel-class=\"with-scroll horizontal-tabs tabs-panel medium-panel\"><div ng-include=\"\'app/pages/ui/tabs/mainTabs.html\'\"></div></div></div><div class=\"col-md-6 tabset-group\" ng-include=\"\'app/pages/ui/tabs/sideTabs.html\'\"></div></div><div class=\"row accordions-row\"><div class=\"col-md-6\" ng-include=\"\'app/pages/ui/tabs/sampleAccordion.html\'\"></div><div class=\"col-md-6\" ng-include=\"\'app/pages/ui/tabs/contextualAccordion.html\'\"></div></div></div>");
$templateCache.put("app/pages/ui/typography/typography.html","<div class=\"typography-document-samples row-fluid\"><div class=\"col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget\"><div ba-panel=\"\" ba-panel-class=\"with-scroll heading-widget\" ba-panel-title=\"Text Size\"><div class=\"section-block\"><h1>H1. Heading 1</h1><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class=\"section-block\"><h2>H2. Heading 2</h2><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class=\"section-block\"><h3>H3. Heading 3</h3><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra, placerat vestibulum eleifend pellentesque.</p></div><div class=\"section-block\"><h4>H4. Heading 4</h4><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra,.</p></div><div class=\"section-block\"><h5>H5. Heading 5</h5><p>Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</p></div></div></div><div class=\"col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget\"><div ba-panel=\"\" ba-panel-class=\"with-scroll more-text-widget\" ba-panel-title=\"Some more text\"><div class=\"section-block light-text\"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis.</p></div><div class=\"section-block regular-text\"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id.</p></div><div class=\"section-block upper-text bold-text\"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class=\"section-block bold-text\"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullam-corper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla.</p></div><div class=\"section-block small-text\"><p>Secondary text. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar,</p><p>lacinia scelerisque pharetra, placerat vestibulum eleifend</p><p>pellentesque, mi nam.</p></div></div></div><div class=\"col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget\"><div ba-panel=\"\" ba-panel-class=\"with-scroll lists-widget\" ba-panel-title=\"Lists\"><div class=\"section-block\"><h5 class=\"list-header\">Unordered list:</h5><ul class=\"blur\"><li>Lorem ipsum dolor sit amet</li><li>Сlacinia scelerisque pharetra<ul><li>Dui rhoncus quisque integer lorem<ul><li>Libero iaculis vestibulum eu vitae</li></ul></li></ul></li><li>Nisl lectus nibh habitasse suspendisse ut</li><li><span>Posuere cursus hac, vestibulum wisi nulla bibendum</span></li></ul><h5 class=\"list-header\">Ordered Lists:</h5><ol class=\"blur\"><li><span>Eu non nec cursus quis mollis, amet quam nec</span></li><li><span>Et suspendisse, adipiscing fringilla ornare sit ligula sed</span><ol><li><span>Interdum et justo nulla</span><ol><li><span>Magna amet, suscipit suscipit non amet</span></li></ol></li></ol></li><li><span>Metus duis eu non eu ridiculus turpis</span></li><li><span>Neque egestas id fringilla consectetuer justo curabitur, wisi magna neque commodo volutpat</span></li></ol><div class=\"accent\">Important text fragment. Lorem ipsum dolor sit amet, id mollis iaculis mi nisl pulvinar, lacinia scelerisque pharetra.</div></div></div></div><div class=\"col-xlg-3 col-lg-6 col-md-6 col-sm-6 col-xs-12 typography-widget\"><div ba-panel=\"\" ba-panel-class=\"with-scroll color-widget\" ba-panel-title=\"Text Color\"><div class=\"section-block red-text\"><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis ullamcorper ligula sodales at. Nulla tellus elit, varius non commodo eget, mattis vel eros. In sed ornare nulla. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p></div><div class=\"section-block yellow-text\"><p>Curabitur bibendum ornare dolor, quis ullamcorper ligula dfgz`zzsodales at. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Nullam id dolor id nibh ultricies vehicula ut id elit. In sed ornare nulla.</p></div><div class=\"section-block links\"><p>Lorem ipsum <a href=\"\">dolor</a> sit amet, consectetur adipiscing elit. Curabitur bibendum ornare dolor, quis <a href=\"\">ullamcorper</a> ligula sodales at. Nulla tellus elit, varius non commodo eget, <a href=\"\">mattis</a> vel eros. In sed ornare nulla.</p></div><div class=\"section-block links\"><p><a href=\"\">Active link — #209e91</a></p><p class=\"hovered\"><a href=\"\">Hover link — #17857a</a></p></div></div></div></div><div class=\"row-fluid\"><div class=\"col-lg-12 col-sm-12 col-xs-12\"><div ba-panel=\"\" ba-panel-class=\"banner-column-panel\"><div class=\"banner\"><div class=\"large-banner-wrapper\"><img ng-src=\"{{::( \'app/typography/banner.png\' | appImage )}}\" alt=\"\"></div><div class=\"banner-text-wrapper\"><div class=\"banner-text\"><h1>Simple Banner Text</h1><p>Lorem ipsum dolor sit amet</p><p>Odio amet viverra rutrum</p></div></div></div><div class=\"section\"><h2>Columns</h2><div class=\"row\"><div class=\"col-sm-6\"><div class=\"img-wrapper\"><img ng-src=\"{{::( \'app/typography/typo03.png\' | appImage )}}\" alt=\"\" title=\"\"></div><p>Vel elit, eros elementum, id lacinia, duis non ut ut tortor blandit. Mauris <a href=\"\">dapibus</a> magna rutrum. Ornare neque suspendisse <a href=\"\">phasellus wisi</a>, quam cras pede rutrum suspendisse, <a href=\"\">felis amet eu</a>. Congue magna elit quisque quia, nullam justo sagittis, ante erat libero placerat, proin condimentum consectetuer lacus. Velit condimentum velit, sed penatibus arcu nulla.</p></div><div class=\"col-sm-6\"><div class=\"img-wrapper\"><img ng-src=\"{{::( \'app/typography/typo01.png\' | appImage )}}\" alt=\"\" title=\"\"></div><p>Et suspendisse, adipiscing fringilla ornare sit ligula sed, vel nam. Interdum et justo nulla, fermentum lobortis purus ut eu, duis nibh dolor massa tristique elementum, nibh iste potenti risus fusce aliquet fusce, ullamcorper debitis primis arcu tellus vestibulum ac.</p></div></div><div class=\"separator\"></div><div class=\"row\"><div class=\"col-sm-4\"><h4>Column heading example</h4><div class=\"img-wrapper\"><img ng-src=\"{{::( \'app/typography/typo04.png\' | appImage )}}\" alt=\"\"></div><p>Eget augue, lacus erat ante egestas scelerisque aliquam, metus molestie leo in habitasse magna maecenas</p><a href=\"\" class=\"learn-more\">Lean more</a></div><div class=\"col-sm-4\"><h4>Yet another column heading example</h4><div class=\"img-wrapper\"><img ng-src=\"{{::( \'app/typography/typo05.png\' | appImage )}}\" alt=\"\"></div><p>Augue massa et parturient, suspendisse orci nec scelerisque sit, integer nam mauris pede consequat in velit</p><a href=\"\" class=\"learn-more\">Lean more</a></div><div class=\"col-sm-4\"><h4>Third column heading example</h4><div class=\"img-wrapper\"><img ng-src=\"{{::( \'app/typography/typo06.png\' | appImage )}}\" alt=\"\"></div><p>Eget turpis, tortor lobortis porttitor, vestibulum nullam vehicula aliquam</p><a href=\"\" class=\"learn-more\">Lean more</a></div></div><div class=\"separator\"></div></div></div></div></div>");
$templateCache.put("app/pages/ventas/caja/caja.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><i class=\"ion-information-circled modal-icon\"></i><span>Abrir / Cerrar Caja</span></div><div class=\"modal-body text-left\"><div style=\"text-align: center;\"><h3>INFORMACION DE CAJA</h3><br><table class=\"table table-hover\"><thead><tr class=\"black-muted-bg\"><td><h3>Fecha:</h3></td><td><h3>Hora:</h3></td><td><h3>Sucursal:</h3></td><td><h3>Monto:</h3></td></tr></thead><tbody><tr><td>{{data.fe_date}}</td><td>{{data.no_hora}}</td><td>{{data.no_local}}</td><td>{{data.va_caja}}</td></tr></tbody></table></div><br><div class=\"col-md-12\" style=\"text-align: center;\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"guardar()\">Abrir Caja</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"cerrar()\">Cancelar</button></div></div><div class=\"modal-footer\"></div></div>");
$templateCache.put("app/pages/ventas/caja/cajaCierre.html","<div class=\"modal-content\"><div class=\"modal-header bg-danger\"><i class=\"ion-information-circled modal-icon\"></i><span>Abrir / Cerrar Caja</span></div><div class=\"modal-body text-left\"><div style=\"text-align: center;\"><h3>INFORMACION DE CAJA</h3><br><table class=\"table table-hover\"><thead><tr class=\"black-muted-bg\"><td><h3>Fecha:</h3></td><td><h3>Hora:</h3></td><td><h3>Sucursal:</h3></td><td><h3>Monto:</h3></td></tr></thead><tbody><tr><td>{{item.fe_caja}}</td><td>{{item.ho_inicio}}</td><td>{{item.no_local}}</td><td>{{item.va_inicio}}</td></tr></tbody></table></div><br><div class=\"col-md-12\" style=\"text-align: center;\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"actualizar()\">Cerrar Caja</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"cerrar()\">Cancelar</button></div></div><div class=\"modal-footer\"></div></div>");
$templateCache.put("app/pages/ventas/cotizacion/cotizacion.html","<div class=\"widgets\" ng-init=\"consultar()\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Registro de Cotizaciones\"><div class=\"row\"><div class=\"col-md-5\"><div class=\"form-group\"><label for=\"id_tipo_comprobante\" class=\"control-label\">Tipo de Comprobante:</label><ui-select ng-model=\"data.id_tipo_comprobante\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getCorrelativo(data)\"><ui-select-match placeholder=\"Comprobante de Pago\">{{$select.selected.descripcion}}</ui-select-match><ui-select-choices repeat=\"comprobante in jComprobante | filter: $select.search\"><div ng-bind-html=\"comprobante.descripcion | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"id_tipo_comprobante\" class=\"control-label\">Nº Cotización:</label><h4 style=\"text-align: center;\">{{data.nu_serie}}{{\'-\'}}{{data.nu_correlativo}}</h4></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" for=\"fe_emision\">Fecha Cotización</label><div class=\"input-group\" moment-picker=\"data.fe_emision\" locales=\"es\" start-view=\"month\" format=\"YYYY-MM-DD\"><input class=\"form-control\" id=\"fe_emision\" name=\"fe_emision\" placeholder=\"Seleccione Una Fecha\" ng-model=\"data.fe_emision\" ng-model-options=\"{ updateOn: \'blur\'}\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\" ng-class=\"{\'has-error\': formVenta.nu_documento.$invalid}\"><label for=\"nu_documento\" class=\"control-label\">Nº Documento</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" id=\"nu_documento\" name=\"nu_documento\" placeholder=\"Nº Documento\" ng-model=\"data.nu_documento\" ng-required=\"true\" ng-disabled=\"true\" ng-blur=\"consultarNumdocument(formVenta)\" autocomplete=\"off\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"crearProduct(\'lg\')\"><i class=\"fa fa-plus\"></i></button> <button class=\"btn btn-default\" type=\"button\" data-toggle=\"modal\" ng-click=\"modalProducts(\'lg\')\"><i class=\"fa fa-search\"></i></button></span></div><span class=\"help-block error-block basic-block\" ng-if=\"formVenta.nu_documento.$error\"><p ng-repeat=\"(key, value) in formVenta.nu_documento.$error\">{{messages.nu_documento[key]}}</p></span></div></div><div class=\"col-md-6\"><div class=\"form-group\" ng-class=\"{\'has-error\': formVenta.no_cliente.$invalid}\"><label for=\"no_cliente\" class=\"control-label\">Cliente</label> <input type=\"text\" class=\"form-control\" id=\"no_cliente\" name=\"no_cliente\" placeholder=\"Apellidos y Nombres\" ng-model=\"data.no_cliente\" ng-disabled=\"true\" style=\"color:rgb(255, 255, 255) !important; text-transform: uppercase;\"></div></div><div class=\"col-sm-3\"><div class=\"form-group has-feedback\"><label for=\"apenom\">Tipo Pago:</label><ui-select ng-model=\"data.id_tipo_pago\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getMonto(data.id_tipo_pago)\"><ui-select-match placeholder=\"Tipo Pago\">{{$select.selected.no_tipo_pago}}</ui-select-match><ui-select-choices repeat=\"pago in jtipopago | filter: $select.search\"><div ng-bind-html=\"pago.no_tipo_pago | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"no_observacion\" class=\"control-label\">Comentario:</label> <input type=\"text\" class=\"form-control\" id=\"no\" name=\"no_observacion\" placeholder=\"Ingrese aqui su comentario\" ng-model=\"data.no_observacion\" ng-required=\"true\"></div></div></div><div class=\"row\"><div class=\"col-md-2\"><div class=\"form-group\" ng-class=\"{\'has-error\': formOCompra.co_barra.$invalid}\"><label for=\"co_barra\" class=\"control-label\">Barras:</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" id=\"co_barra\" name=\"co_barra\" placeholder=\"\" ng-model=\"datap.co_barra\" ng-required=\"true\" ng-keypress=\"buscarCodigoBarras()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"limpiar()\"><i class=\"fa fa-paint-brush\"></i></button></span></div></div></div><div class=\"col-md-1\"><div class=\"form-group\" ng-class=\"{\'has-error\': formOCompra.codigo.$invalid}\"><label for=\"codigo\" class=\"control-label\">Código:</label> <input type=\"hidden\" name=\"id_producto\" ng-modal=\"datap.id_producto\" class=\"form-control\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" id=\"id_producto\" name=\"id_producto\" placeholder=\"id_producto\" ng-model=\"datap.id_producto\" ng-required=\"true\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"modalProducto(\'lg\')\"><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=\"col-md-3\"><div class=\"form-group\" ng-class=\"{\'has-error\': formOCompra.codigo.$invalid}\"><label for=\"no_producto\" class=\"control-label\">Producto</label><div class=\"input-group\"><input type=\"text\" name=\"no_producto\" id=\"no_producto\" class=\"form-control\" ng-model=\"datap.no_producto\" ng-required=\"true\" ng-disabled=\"true\" autocomplete=\"off\"> <span class=\"input-group-addon\"><a ng-click=\"findPActivo()\"><i class=\"fa fa-book\"></i></a></span> <span class=\"input-group-addon\">Stock: {{datap.nu_cantidad}}</span></div></div></div><div class=\"col-md-1\"><div class=\"form-group has-success has-feedback\"><label class=\"control-label\" for=\"inputGroupSuccess1\">Desc. M.?</label><div class=\"input-group\"><toggle id=\"il_descuento\" name=\"il_descuento\" ng-model=\"datap.il_descuento\" ng-change=\"changed()\" on=\"SI\" off=\"No\" onstyle=\"btn-primary\" offstyle=\"btn-danger\"></toggle></div></div></div><div class=\"col-md-1\" ng-show=\"datap.il_descuento!=true\"><div class=\"form-group\"><label for=\"id_cliente_descuento\" class=\"control-label\">Descuento:</label><ui-select ng-model=\"datap.id_cliente_descuento\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getMontoDescuento(datap.id_cliente_descuento)\"><ui-select-match placeholder=\"Descuento\">{{$select.selected.pr_descuento}}</ui-select-match><ui-select-choices repeat=\"desc in jDescuento | filter: $select.search\"><div ng-bind-html=\"desc.pr_descuento | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-md-1\" ng-show=\"datap.il_descuento!=false\"><div class=\"form-group\"><label for=\"id_cliente_descuento\" class=\"control-label\">Descuento:</label> <input type=\"text\" name=\"pr_descuento\" id=\"pr_descuento\" class=\"form-control\" ng-model=\"datap.pr_descuento\" ng-keypress=\"getMontoDescuento2($event)\"></div></div><div class=\"col-md-2\"><div class=\"form-group\" ng-class=\"{\'has-error\': formOCompra.mto_ult_venta.$invalid}\"><label for=\"mto_ult_venta\" class=\"control-label\">Precio</label> <input type=\"text\" name=\"mto_ult_venta\" id=\"mto_ult_venta\" class=\"form-control\" ng-model=\"datap.mto_ult_venta\" ng-required=\"formOCompra.cod_producto.$valid\" ng-disabled=\"formOCompra.codigo.$invalid\" style=\"text-align: right;\"></div></div><div class=\"col-md-2\"><div class=\"form-group\" ng-class=\"{\'has-error\': formOCompra.nu_cantidad_p.$invalid}\"><label for=\"nu_cantidad_p\" class=\"control-label\">Cantidad</label><div class=\"input-group\"><input type=\"text\" name=\"nu_cantidad_p\" id=\"nu_cantidad_p\" class=\"form-control\" ng-model=\"datap.nu_cantidad_p\" ng-required=\"formOCompra.cod_producto.$valid\" ng-disabled=\"formOCompra.id_producto.$invalid\" style=\"text-align: right;\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"addItem()\" ng-disabled=\"formOCompra.va_precio_producto.$invalid || formOCompra.nu_cantidad_p.$invalid\"><i class=\"fa fa-plus\"></i></button></span></div></div></div></div><div class=\"row\"><table class=\"table table-striped\" st-table=\"displayed\" st-safe-src=\"rowCollection\"><thead><tr class=\"sortable\"><th style=\"width:10%; text-align:center;\">Código</th><th style=\"width:25%; text-align:center;\">Producto</th><th style=\"width:15%; text-align:center;\">Cantidad</th><th style=\"width:20%; text-align:center;\">Precio</th><th style=\"width:15%; text-align:center;\">Descuento</th><th style=\"width:10%; text-align:center;\">Precio D.</th><th style=\"width:20%; text-align:center;\">Total</th><th style=\"width:5%; text-align:center;\">&nbsp;</th></tr></thead><tbody><tr st-select-row=\"row\" st-select-mode=\"multiple\" ng-repeat=\"item in displayed\"><td style=\"text-align:center;\">{{item.id}}</td><td style=\"text-align:left;\">{{item.no_producto}}</td><td style=\"text-align:right;\">{{item.nu_cantidad_p}}</td><td style=\"text-align:right;\">{{item.nu_precio_unitario | number:2}}</td><td style=\"text-align:right;\">{{item.pr_descuento | number:2}} %</td><td style=\"text-align:right;\">{{item.nu_precio_descuento | number:2}}</td><td style=\"text-align:right;\">{{(item.nu_total) | number:2}}</td><td style=\"text-align:center;\"><button type=\"button\" class=\"btn btn-xs btn-danger\" ng-click=\"quitar_producto(item.id, displayed.indexOf(item))\" title=\"Quitar\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody><tfoot><tr><td><label for=\"co_cupon\" class=\"control-label\">Codigo</label></td><td><div class=\"input-group\"><input type=\"text\" class=\"form-control\" id=\"co_cupon\" name=\"co_cupon\" ng-model=\"data.co_cupon\" ng-disabled=\"true\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" data-toggle=\"modal\" ng-click=\"modalCupon(\'lg\')\"><i class=\"fa fa-search\"></i></button></span></div></td><td style=\"text-align:right\"><label for=\"va_descuento\" class=\"control-label\">Monto</label></td><td><input type=\"text\" class=\"form-control\" id=\"va_descuento\" name=\"va_descuento\" ng-model=\"data.va_descuento\" ng-disabled=\"true\" style=\"color:rgb(255, 255, 255) !important;\"></td><td colspan=\"2\" style=\"text-align:right\">Total:</td><td style=\"text-align:right\">{{data.nu_total | number:2}}</td><td>&nbsp;</td></tr><tr><td colspan=\"8\" style=\"text-align:right\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"rowCollection.length==0\" ng-click=\"guardar()\"><i class=\"fa fa-print\"></i> Registrar</button> &nbsp;&nbsp;&nbsp; <a class=\"btn btn-default\" ui-sref=\"dashboard.venta.cotizacion()\"><i class=\"fa fa-list-alt\"></i> Listado</a></td></tr></tfoot></table></div></div></div></div><style>\r\n    .modal .modal-dialog {\r\n        vertical-align: middle;\r\n    }\r\n\r\n    .modal.win_proveedor .modal-dialog {\r\n        width: 65%;\r\n        display: inline-block;\r\n        text-align: left;\r\n    }\r\n\r\n    .modal.win_producto .modal-dialog {\r\n        width: 85%;\r\n        display: inline-block;\r\n        text-align: left;\r\n    }\r\n\r\n    .modal.win_proveedor {\r\n        text-align: center;\r\n        padding: 0 !important;\r\n    }\r\n\r\n    .modal::before {\r\n        content: \'\';\r\n        display: inline-block;\r\n        height: 100%;\r\n        vertical-align: middle;\r\n        margin-right: -4px;\r\n    }\r\n</style>");
$templateCache.put("app/pages/ventas/gastos/gastos.html","<div class=\"widgets\" ng-init=\"consultar()\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Registro de Gastos\" ba-panel-class=\"with-scroll\"><form class=\"form-horizontal\" name=\"formGatos\" id=\"formGatos\" ng-submit=\"guardar(formGatos)\" novalidate=\"\"><div class=\"form-group has-feedback\"><label for=\"nu_documento\" class=\"col-sm-2 control-label\">Empresa / Sucursal:</label><div class=\"col-sm-5\"><ui-select id=\"id_empresa\" ng-model=\"data.id_empresa\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\" ng-change=\"getSucursal(data.id_empresa)\"><ui-select-match placeholder=\"Empresa\">{{$select.selected.no_empresa}}</ui-select-match><ui-select-choices repeat=\"empresa in jEmpresa | filter: $select.search\"><span ng-bind-html=\"empresa.no_empresa\"></span></ui-select-choices></ui-select></div><div class=\"col-sm-5\"><ui-select id=\"id_local\" ng-model=\"data.id_local\" ng-change=\"getSucursalEmpleado(data.id_local)\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\"><ui-select-match placeholder=\"Sucursal\">{{$select.selected.no_local}}</ui-select-match><ui-select-choices repeat=\"local in jSucursal | filter: $select.search\"><span ng-bind-html=\"local.no_local\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group has-feedback\" ng-class=\"{\'has-error\': formGatos.no_proveedor.$invalid && (formGatos.no_proveedor.$dirty || formGatos.no_proveedor.$submitted)}\"><label for=\"no_proveedor\" class=\"col-sm-2 control-label\">T. Gasto / Comprobante:</label><div class=\"col-sm-5\"><ui-select id=\"id_tipo_gasto\" ng-model=\"data.id_tipo_gasto\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\"><ui-select-match placeholder=\"Tipo Gasto\">{{$select.selected.no_tipo_gasto}}</ui-select-match><ui-select-choices repeat=\"gasto in jTipoGasto | filter: $select.search\"><span ng-bind-html=\"gasto.no_tipo_gasto\"></span></ui-select-choices></ui-select></div><div class=\"col-sm-5\"><ui-select id=\"id_tipo_comprobante\" ng-model=\"data.id_tipo_comprobante\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\"><ui-select-match placeholder=\"Tipo Comprobante\">{{$select.selected.descripcion}}</ui-select-match><ui-select-choices repeat=\"compro in jTipoComprobante | filter: $select.search\"><span ng-bind-html=\"compro.descripcion\"></span></ui-select-choices></ui-select></div></div><div class=\"form-group has-feedback\"><label for=\"no_gasto\" class=\"col-sm-2 control-label\">Gasto:</label><div class=\"col-sm-10\"><input type=\"text\" class=\"form-control\" id=\"no_gasto\" name=\"no_gasto\" placeholder=\"Descripcion del gasto\" ng-model=\"data.no_gasto\" style=\"text-transform:uppercase\" ng-disabled=\"formGatos.nu_documento.$invalid || formGatos.nu_documento.$pending\" autocomplete=\"off\"></div></div><div class=\"form-group has-feedback\"><label for=\"va_total\" class=\"col-sm-2 control-label\">Total / Igv / SubTotal:</label><div class=\"col-sm-4\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" id=\"va_total\" name=\"va_total\" placeholder=\"TOTAL\" ng-model=\"data.va_total\" style=\"text-transform:uppercase\" ng-disabled=\"formGatos.id_tipo_comprobante.id.$invalid || formGatos.id_tipo_comprobante.id.$pending\" autocomplete=\"off\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"calcular(data.va_total)\"><i class=\"fas fa-calculator\"></i></button></span></div></div><div class=\"col-sm-3\"><input type=\"text\" class=\"form-control\" id=\"va_igv\" name=\"va_igv\" placeholder=\"IGV\" ng-model=\"data.va_igv\" style=\"text-transform:uppercase\" ng-disabled=\"true\" autocomplete=\"off\"></div><div class=\"col-sm-3\"><input type=\"text\" class=\"form-control\" id=\"va_subtotal\" name=\"va_subtotal\" placeholder=\"SUB TOTAL\" ng-model=\"data.va_subtotal\" style=\"text-transform:uppercase\" ng-disabled=\"true\" autocomplete=\"off\"></div></div><div class=\"form-group has-feedback\"><label for=\"no_contacto\" class=\"col-sm-2 control-label\">Fecha:</label><div class=\"col-sm-5\"><div class=\"input-group\" moment-picker=\"data.fe_emision\" locales=\"es\" start-view=\"month\" format=\"YYYY-MM-DD\"><input class=\"form-control\" id=\"fe_emision\" name=\"fe_emision\" placeholder=\"Seleccione Una Fecha\" ng-model=\"data.fe_emision\" ng-disabled=\"formGatos.idtip_documento.$invalid\" ng-model-options=\"{ updateOn: \'blur\'}\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-10\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"formGatos.$invalid || formGatos.$pending\">Guardar</button> &nbsp;&nbsp;&nbsp; <a class=\"btn btn-default\" ui-sref=\"dashboard.venta.gastos()\"><i class=\"fa fa-list-alt\"></i> Listado</a></div></div></form></div></div></div>");
$templateCache.put("app/pages/ventas/pos/pos.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\" ba-panel=\"\" ba-panel-title=\"Venta Caja\"><form name=\"formVenta\" id=\"formVenta\" ng-submit=\"guardar(formVenta)\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"id_tipo_comprobante\" class=\"control-label\">Tipo de Comprobante:</label><ui-select ng-model=\"data.id_tipo_comprobante\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getCorrelativo(data)\"><ui-select-match placeholder=\"Comprobante de Pago\">{{$select.selected.descripcion}}</ui-select-match><ui-select-choices repeat=\"comprobante in jComprobante | filter: $select.search\"><div ng-bind-html=\"comprobante.descripcion | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"id_tipo_comprobante\" class=\"control-label\">Serie - Correlativo:</label><h4 style=\"text-align: center;\">{{data.nu_serie}}{{\'-\'}}{{data.nu_correlativo}}</h4></div></div></div><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\" ng-class=\"{\'has-error\': formVenta.nu_documento.$invalid}\"><label for=\"nu_documento\" class=\"control-label\">Nº Documento</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" id=\"nu_documento\" name=\"nu_documento\" placeholder=\"Nº Documento\" ng-model=\"data.nu_documento\" ng-required=\"true\" ng-disabled=\"true\" ng-blur=\"consultarNumdocument(formVenta)\" autocomplete=\"off\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"crearProduct(\'lg\')\"><i class=\"fa fa-plus\"></i></button> <button class=\"btn btn-default\" type=\"button\" data-toggle=\"modal\" ng-click=\"modalProducts(\'lg\')\"><i class=\"fa fa-search\"></i></button></span></div><span class=\"help-block error-block basic-block\" ng-if=\"formVenta.nu_documento.$error\"><p ng-repeat=\"(key, value) in formVenta.nu_documento.$error\">{{messages.nu_documento[key]}}</p></span></div></div><div class=\"col-md-5\"><div class=\"form-group\" ng-class=\"{\'has-error\': formVenta.no_cliente.$invalid}\"><label for=\"no_cliente\" class=\"control-label\">Cliente</label> <input type=\"text\" class=\"form-control\" id=\"no_cliente\" name=\"no_cliente\" placeholder=\"Apellidos y Nombres\" ng-model=\"data.no_cliente\" ng-disabled=\"true\" style=\"color:rgb(255, 255, 255) !important; text-transform: uppercase;\"></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label class=\"control-label\" for=\"fe_emision\">Fecha Venta</label><div class=\"input-group\" moment-picker=\"data.fe_emision\" locales=\"es\" start-view=\"month\" format=\"YYYY-MM-DD\"><input class=\"form-control\" id=\"fe_emision\" name=\"fe_emision\" placeholder=\"Seleccione Una Fecha\" ng-model=\"data.fe_emision\" ng-model-options=\"{ updateOn: \'blur\'}\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=\"row\"><div class=\"col-md-2\"><div class=\"form-group\"><label for=\"id_producto\" class=\"control-label\">Código:</label> <input type=\"hidden\" name=\"id_producto\" ng-modal=\"datap.id_producto\" class=\"form-control\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" id=\"id_producto\" name=\"id_producto\" placeholder=\"Código\" ng-model=\"datap.id_producto\" ng-required=\"true\" ng-disabled=\"formVenta.num_documento.$invalid\" ng-blur=\"codigoProducto()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"modalProducto(\'lg\')\"><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=\"col-md-6\"><div class=\"form-group\"><label for=\"nom_producto\" class=\"control-label\">Nombre</label><div class=\"input-group\"><input type=\"text\" name=\"no_producto\" id=\"no_producto\" class=\"form-control\" ng-model=\"datap.no_producto\" uib-typeahead=\"product as product.no_producto for product in getProduct4Name($viewValue) | limitTo:8\" typeahead-template-url=\"customTypeahead.html\" typeahead-on-select=\"selectProduct($item)\" aria-describedby=\"price-compra\" ng-required=\"true\" ng-disabled=\"formVenta.num_documento.$invalid\" autocomplete=\"off\"> <span class=\"input-group-addon\"><a ng-click=\"findPActivo()\"><i class=\"fa fa-book\"></i></a></span> <span class=\"input-group-addon\">Stock: {{datap.nu_cantidad}}</span></div></div></div><div class=\"col-md-2\"><div class=\"form-group\" ng-class=\"{\'has-error\': formVenta.va_precio_producto.$invalid}\"><label for=\"va_precio_producto\" class=\"control-label\">Precio</label><div class=\"input-group\"><input type=\"text\" name=\"va_precio_producto\" id=\"va_precio_producto\" class=\"form-control\" ng-model=\"datap.va_precio_producto\" ng-disabled=\"(formVenta.id_producto.$invalid)\" style=\"text-align:right; color:rgb(255, 255, 255) !important;\" uib-popover-template=\"templatePopover\" popover-title=\"Rango de Precios\" popover-trigger=\"focus\" popover-placement=\"bottom\" autocomplete=\"off\"></div></div></div><div class=\"col-md-2\"><div class=\"form-group\" ng-class=\"{\'has-error\': formVenta.nu_cantidad_p.$invalid}\"><label for=\"nu_cantidad_p\" class=\"control-label\">Cantidad</label><div class=\"input-group\"><input type=\"text\" name=\"nu_cantidad_p\" id=\"nu_cantidad_p\" ng-model=\"datap.nu_cantidad_p\" class=\"form-control\" ng-disabled=\"formVenta.id_producto.$invalid || formVenta.va_precio_producto.$invalid\" style=\"text-align:right;\" valid-venta=\"\" stock=\"(product.stock-product.cnt_tmp)\" salewithoutstock=\"product.facturarsinstock\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-info\" ng-disabled=\"formVenta.id_producto.$invalid || formVenta.va_precio_producto.$invalid || formVenta.nu_cantidad_p.$invalid\" ng-click=\"addItem()\"><i class=\"fa fa-plus\"></i></button></span></div></div></div></div><div class=\"row\"><table class=\"table table-striped\" st-table=\"displayed\" st-safe-src=\"rowCollection\"><thead><tr class=\"sortable\"><th style=\"text-align:center;\" class=\"table-id\" st-sort=\"id\" st-sort-default=\"true\">#</th><th style=\"width:57%\">Producto</th><th style=\"width:8%; text-align:right;\">Cantidad</th><th style=\"text-align:right; width:8%\">Precio</th><th style=\"text-align:right; width:8%\">Total</th><th style=\"text-align:center; width:3%\">&nbsp;</th></tr></thead><tbody><tr st-select-row=\"row\" st-select-mode=\"multiple\" ng-repeat=\"iRows in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{iRows.id}}</td><td>{{iRows.no_producto}}</td><td>{{iRows.nu_cantidad_p}}</td><td style=\"text-align: right;\">{{iRows.nu_precio_descuento | number:2}}</td><td style=\"text-align: right;\">{{iRows.nu_total | number:2}}</td><td><button type=\"button\" class=\"btn btn-xs btn-danger\" ng-click=\"quitar_producto(iRows.id)\" title=\"Quitar\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody><tfoot><tr><td colspan=\"4\" style=\"text-align:right\">Total:</td><td style=\"text-align:right\">{{data.nu_total | number:2}}</td><td>&nbsp;</td></tr></tfoot></table><div class=\"row\"></div><div class=\"row\"><button type=\"submit\" class=\"btn btn-success\" ng-disabled=\"rowCollection.length==0\"><i class=\"fa fa-print\"></i> Registrar</button> &nbsp;&nbsp;&nbsp; <a class=\"btn btn-default\" ui-sref=\"dashboard.venta.pos()\"><i class=\"fa fa-list-alt\"></i> Listado</a></div></div></form></div></div></div>");
$templateCache.put("app/pages/ventas/pos/venta.html","<div class=\"row\"><div class=\"col-md-8\"><div ba-panel=\"\" ba-panel-title=\"Administracion Venta\" ba-panel-class=\"panel panel-blur with-scroll light-text\"><div class=\"row\"><div class=\"col-md-2\"><div class=\"form-group\"><label for=\"co_barra\" class=\"control-label\">Barras:</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" id=\"co_barra\" name=\"co_barra\" placeholder=\"\" ng-model=\"datap.co_barra\" ng-required=\"true\" ng-keypress=\"buscarCodigoBarras()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"limpiar()\"><i class=\"fa fa-paint-brush\"></i></button></span></div></div></div><div class=\"col-md-2\"><div class=\"form-group\"><label for=\"id_producto\" class=\"control-label\">Código:</label> <input type=\"hidden\" name=\"id_producto\" ng-modal=\"datap.id_producto\" class=\"form-control\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" id=\"id_producto\" name=\"id_producto\" placeholder=\"Código\" ng-model=\"datap.id_producto\" ng-required=\"true\" ng-disabled=\"formVenta.num_documento.$invalid\" ng-blur=\"codigoProducto()\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"modalProducto(\'lg\')\"><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label for=\"nom_producto\" class=\"control-label\">Nombre</label><div class=\"input-group\"><input type=\"text\" name=\"no_producto\" id=\"no_producto\" class=\"form-control\" ng-model=\"datap.no_producto\" uib-typeahead=\"product as product.no_producto for product in getProduct4Name($viewValue) | limitTo:8\" typeahead-template-url=\"customTypeahead.html\" typeahead-on-select=\"selectProduct($item)\" aria-describedby=\"price-compra\" ng-required=\"true\" ng-disabled=\"formVenta.num_documento.$invalid\" autocomplete=\"off\"> <span class=\"input-group-addon\"><a ng-click=\"findPActivo()\"><i class=\"fa fa-book\"></i></a></span> <span class=\"input-group-addon\">Stock: {{datap.nu_cantidad}}</span></div></div></div><div class=\"col-md-2\"><div class=\"form-group\" ng-class=\"{\'has-error\': formVenta.mto_ult_venta.$invalid}\"><label for=\"mto_ult_venta\" class=\"control-label\">Precio</label><div class=\"input-group\"><input type=\"text\" name=\"mto_ult_venta\" id=\"mto_ult_venta\" class=\"form-control\" ng-model=\"datap.mto_ult_venta\" ng-disabled=\"true\" style=\"text-align:right; color:rgb(255, 255, 255) !important;\" uib-popover-template=\"templatePopover\" popover-title=\"Rango de Precios\" popover-trigger=\"focus\" popover-placement=\"bottom\" autocomplete=\"off\"></div></div></div><div class=\"col-md-2\"><div class=\"form-group\" ng-class=\"{\'has-error\': formVenta.nu_cantidad_p.$invalid}\"><label for=\"nu_cantidad_p\" class=\"control-label\">Cantidad</label><div class=\"input-group\"><input type=\"text\" name=\"nu_cantidad_p\" id=\"nu_cantidad_p\" ng-model=\"datap.nu_cantidad_p\" class=\"form-control\" ng-disabled=\"formVenta.id_producto.$invalid || formVenta.mto_ult_venta.$invalid\" style=\"text-align:right;\" valid-venta=\"\" stock=\"(product.stock-product.cnt_tmp)\" salewithoutstock=\"product.facturarsinstock\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-info\" ng-disabled=\"formVenta.id_producto.$invalid || formVenta.mto_ult_venta.$invalid || formVenta.nu_cantidad_p.$invalid\" ng-click=\"addItem()\"><i class=\"fa fa-plus\"></i></button></span></div></div></div></div><div class=\"row\"><table class=\"table table-striped\" st-table=\"displayed\" st-safe-src=\"rowCollection\"><thead><tr class=\"sortable\"><th style=\"text-align:center;\" class=\"table-id\" st-sort=\"id\" st-sort-default=\"true\">#</th><th style=\"width:20%\">Codigo</th><th style=\"width:35%\">Producto</th><th style=\"width:22%\">Categoria</th><th style=\"width:8%; text-align:right;\">Cantidad</th><th style=\"text-align:right; width:8%\">Precio</th><th style=\"text-align:right; width:8%\">Total</th><th style=\"text-align:center; width:3%\">&nbsp;</th></tr></thead><tbody><tr st-select-row=\"row\" st-select-mode=\"multiple\" ng-repeat=\"iRows in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{iRows.id}}</td><td>{{iRows.co_producto}}</td><td>{{iRows.no_producto}}</td><td>{{iRows.no_categoria}}</td><td>{{iRows.nu_cantidad_p}}</td><td style=\"text-align: right;\">{{iRows.nu_precio_descuento | number:2}}</td><td style=\"text-align: right;\">{{iRows.nu_total | number:2}}</td><td><button type=\"button\" class=\"btn btn-xs btn-danger\" ng-click=\"quitar_producto(iRows.id)\" title=\"Quitar\"><i class=\"fa fa-trash\"></i></button></td></tr></tbody><tfoot><tr><td style=\"text-align:right\">Descuento:</td><td><input type=\"text\" class=\"form-control\" id=\"no_descuento\" name=\"no_descuento\" ng-model=\"data.no_descuento\" ng-keypress=\"getDescuento($event)\"></td><td><label for=\"co_cupon\" class=\"control-label\">Codigo</label></td><td><div class=\"input-group\"><input type=\"text\" class=\"form-control\" id=\"co_cupon\" name=\"co_cupon\" ng-model=\"data.co_cupon\" ng-disabled=\"true\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\" data-toggle=\"modal\" ng-click=\"modalCupon(\'lg\')\"><i class=\"fa fa-search\"></i></button></span></div></td><td><input type=\"text\" class=\"form-control\" id=\"va_descuento\" name=\"va_descuento\" ng-model=\"data.va_descuento\" ng-disabled=\"true\" style=\"color:rgb(255, 255, 255) !important;\"></td><td style=\"text-align:right\">Total:</td><td style=\"text-align:right\">{{data.nu_total | number:2}}</td><td>&nbsp;</td></tr></tfoot></table></div></div></div><div class=\"col-md-4\"><div ba-panel=\"\" ba-panel-title=\"Administracion Venta\" ba-panel-class=\"medium-panel panel-blur with-scroll light-text\"><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"id_tipo_comprobante\" class=\"control-label\">Tipo de Comprobante:</label><ui-select ng-model=\"data.id_tipo_comprobante\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getCorrelativo(data)\"><ui-select-match placeholder=\"Comprobante de Pago\">{{$select.selected.descripcion}}</ui-select-match><ui-select-choices repeat=\"comprobante in jComprobante | filter: $select.search\"><div ng-bind-html=\"comprobante.descripcion | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label for=\"id_tipo_comprobante\" class=\"control-label\">Serie - Correlativo:</label><h4 style=\"text-align: center;\">{{data.nu_serie}}{{\'-\'}}{{data.nu_correlativo}}</h4></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\" ng-class=\"{\'has-error\': formVenta.nu_documento.$invalid}\"><label for=\"nu_documento\" class=\"control-label\">Nº Documento</label><div class=\"input-group\"><input type=\"text\" class=\"form-control\" id=\"nu_documento\" name=\"nu_documento\" placeholder=\"Nº Documento\" ng-model=\"data.nu_documento\" ng-required=\"true\" ng-disabled=\"true\" ng-blur=\"consultarNumdocument(formVenta)\" autocomplete=\"off\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"crearProduct(\'lg\')\"><i class=\"fa fa-plus\"></i></button> <button class=\"btn btn-default\" type=\"button\" data-toggle=\"modal\" ng-click=\"modalProducts(\'lg\')\"><i class=\"fa fa-search\"></i></button></span></div><span class=\"help-block error-block basic-block\" ng-if=\"formVenta.nu_documento.$error\"><p ng-repeat=\"(key, value) in formVenta.nu_documento.$error\">{{messages.nu_documento[key]}}</p></span></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\" ng-class=\"{\'has-error\': formVenta.nu_documento.$invalid}\"><label class=\"control-label\" for=\"fe_emision\">Fecha Venta</label><div class=\"input-group\" moment-picker=\"data.fe_emision\" locales=\"es\" start-view=\"month\" format=\"YYYY-MM-DD\"><input class=\"form-control\" id=\"fe_emision\" name=\"fe_emision\" placeholder=\"Seleccione Una Fecha\" ng-model=\"data.fe_emision\" ng-model-options=\"{ updateOn: \'blur\'}\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\" ng-class=\"{\'has-error\': formVenta.no_cliente.$invalid}\"><label for=\"no_cliente\" class=\"control-label\">Cliente</label> <input type=\"text\" class=\"form-control\" id=\"no_cliente\" name=\"no_cliente\" placeholder=\"Apellidos y Nombres\" ng-model=\"data.no_cliente\" ng-disabled=\"true\" style=\"color:rgb(255, 255, 255) !important; text-transform: uppercase;\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group has-feedback\"><label for=\"apenom\">Tipo Pago:</label><ui-select ng-model=\"data.id_tipo_pago\" class=\"btn-group bootstrap-select form-control\" ng-change=\"getMonto(data.id_tipo_pago)\"><ui-select-match placeholder=\"Tipo Pago\">{{$select.selected.no_tipo_pago}}</ui-select-match><ui-select-choices repeat=\"pago in jtipopago | filter: $select.search\"><div ng-bind-html=\"pago.no_tipo_pago | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div></div><div class=\"row\" ng-show=\"data.id_tipo_pago.id==1\"><div class=\"col-sm-12\"><div class=\"col-sm-4\"><label for=\"apenom\">Efectivo:</label></div><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control\" id=\"nu_efectivo\" name=\"nu_efectivo\" ng-model=\"data.nu_efectivo\"></div></div></div><div class=\"row\" ng-show=\"data.id_tipo_pago.id==2\"><div class=\"col-sm-12\"><div class=\"col-sm-4\"><label for=\"apenom\">Izipay:</label></div><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control\" id=\"nu_izipay\" name=\"nu_izipay\" ng-model=\"data.nu_izipay\"></div></div></div><div class=\"row\" ng-show=\"data.id_tipo_pago.id==3\"><div class=\"col-sm-12\"><div class=\"col-sm-4\"><label for=\"apenom\">Efectivo:</label></div><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control\" id=\"nu_efectivo2\" name=\"nu_efectivo2\" ng-keypress=\"getCalcular($event)\" ng-model=\"data.nu_efectivo2\"></div></div><br><br><div class=\"col-sm-12\"><div class=\"col-sm-4\"><label for=\"apenom\">Izipay:</label></div><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control\" id=\"nu_izipay2\" name=\"nu_izipay2\" ng-model=\"data.nu_izipay2\"></div></div></div><div class=\"row\" ng-show=\"data.id_tipo_pago.id==4\"><div class=\"col-sm-12\"><div class=\"col-sm-4\"><label for=\"apenom\">Transferencia:</label></div><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control\" id=\"nu_trasnferencia\" name=\"nu_trasnferencia\" ng-model=\"data.nu_trasnferencia\"></div></div></div><div class=\"row\" ng-show=\"data.id_tipo_pago.id==5\"><div class=\"col-sm-12\"><div class=\"col-sm-4\"><label for=\"nu_credito\">Credito:</label></div><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control\" id=\"nu_credito\" name=\"nu_credito\" ng-model=\"data.nu_credito\"></div></div></div><div class=\"row\" ng-show=\"data.id_tipo_pago.id==6\"><div class=\"col-sm-12\"><div class=\"col-sm-4\"><label for=\"nu_rappi\">Rappi:</label></div><div class=\"col-sm-8\"><input type=\"text\" class=\"form-control\" id=\"nu_rappi\" name=\"nu_rappi\" ng-model=\"data.nu_rappi\"></div></div></div><br><div class=\"row\"><div class=\"col-sm-12\" style=\"text-align: right;\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"guardar()\" ng-disabled=\"formProducto.$invalid || formProducto.$pending\">Guardar</button></div></div></div></div></div><style>\r\n    .modal .modal-dialog {\r\n        vertical-align: middle;\r\n    }\r\n\r\n    .modal.win_proveedor .modal-dialog {\r\n        width: 65%;\r\n        display: inline-block;\r\n        text-align: left;\r\n    }\r\n\r\n    .modal.win_producto .modal-dialog {\r\n        width: 85%;\r\n        display: inline-block;\r\n        text-align: left;\r\n    }\r\n\r\n    .modal.win_proveedor {\r\n        text-align: center;\r\n        padding: 0 !important;\r\n    }\r\n\r\n    .modal::before {\r\n        content: \'\';\r\n        display: inline-block;\r\n        height: 100%;\r\n        vertical-align: middle;\r\n        margin-right: -4px;\r\n    }\r\n</style>");
$templateCache.put("app/pages/almacen/notaingreso/list/notaingresoList.html","<div class=\"widgets\"><div class=\"row\"><div ba-panel=\"\" ba-panel-title=\"Listado de Notas de Ingreso / Salida <i ng-click=\'agregar()\' class=\'fa pull-right fa-plus\' style=\' cursor: pointer;\'></i>\" ba-panel-class=\"with-scroll\"><div class=\"form-group\"><div class=\"col-sm-12\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:4%;\" class=\"table-id\">#</th><th style=\"width:10%;\">A. Origen</th><th style=\"width:6%;\">Serie</th><th style=\"width:6%;\">Correlativo</th><th style=\"width:6%;\">Fecha</th><th style=\"width:10%;\">A. Destino</th><th style=\"width:8%;\">&nbsp;</th></tr><tr><th></th><th><input st-search=\"no_origen\" class=\"input-sm form-control\" placeholder=\"Busqueda Origen...\" type=\"search\"></th><th><input st-search=\"nu_serie\" class=\"input-sm form-control\" placeholder=\"Busqueda N° Serie...\" type=\"search\"></th><th><input st-search=\"nu_correlativo\" class=\"input-sm form-control\" placeholder=\"Busqueda N° Correlativo ...\" type=\"search\"></th><th><input st-search=\"fe_emision\" class=\"input-sm form-control\" placeholder=\"Busqueda Fecha...\" type=\"search\"></th><th><input st-search=\"no_destino\" class=\"input-sm form-control\" placeholder=\"Busqueda Destino...\" type=\"search\"></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_almacen_origen }}</td><td>{{item.nu_serie }}</td><td>{{item.nu_correlativo }}</td><td>{{item.fe_ingreso }}</td><td>{{item.no_almacen_destino }}</td><td><div class=\"btn-group\" role=\"group\"><button class=\"btn btn-xs\" ng-class=\"(item.il_stado==\'1\')?\'btn-success\':\'btn-danger\'\" ng-click=\"\" title=\"Activar/inactivar\"><i class=\"fa\" ng-class=\"(item.il_stado==\'1\')?\'fa-check\':\'fa-ban\'\"></i></button> <a class=\"btn btn-xs btn-primary\" title=\"Editar\" ui-sref=\"dashboard.almacen.notaingreso-details({idNotaIngreso: item.id_almacen_ingreso})\"><i class=\"ion-edit\"></i></a> <button class=\"btn btn-xs btn-danger\" title=\"Eliminar\" ng-click=\"eliminar(item.id_almacen_ingreso, displayed.indexOf(item))\"><i class=\"ion-trash-a\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"7\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/almacen/notasalida/list/notasalidaList.html","");
$templateCache.put("app/pages/catalogo/atributo/modal/modal_atributo.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><i class=\"ion-information-circled modal-icon\"></i><span>Control de Atributos</span></div><div class=\"modal-body text-left\"><div class=\"row\"><div class=\"col-xs-3\"><span>Nombre del Atributo:</span></div><div class=\"form-group has-success has-feedback col-xs-8\"><div class=\"col-xs-8\"><div class=\"input-group\"><span class=\"input-group-addon addon-left\"><i class=\"fa fa-hashtag fa-fw\"></i></span> <input type=\"text\" class=\"form-control\" id=\"no_atributo\" ng-model=\"data.no_atributo\" name=\"no_atributo\" aria-describedby=\"inputGroupSuccess1Status\"> <i class=\"ion-checkmark-circled form-control-feedback\" aria-hidden=\"true\"></i> <span id=\"inputGroupSuccess1Status\" class=\"sr-only\">(success)</span></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"GuardarAtributo(data)\">Guardar</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">Cancelar</button></div></div>");
$templateCache.put("app/pages/catalogo/atributo/modal/modal_sub_atributo.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><i class=\"ion-information-circled modal-icon\"></i><span>Control de Sub Atributos</span></div><div class=\"modal-body text-left\"><div class=\"row\" ng-init=\"combos_defaults()\"><div class=\"col-xs-3\"><span>Seleccione un Atributo:</span></div><div class=\"col-md-6\"><div class=\"form-group has-success has-feedback\"><select class=\"form-control\" name=\"id_atributo\" id=\"id_atributo\" selectpicker=\"\" ng-model=\"data.id_atributo\" ng-options=\"area.id_atributo as area.no_atributo for area in jAtributo\"><option selected=\"\" value=\"\">---Atributo---</option></select></div></div></div><div class=\"row\"><div class=\"col-xs-3\"><span>Nombre del Sub Atributo:</span></div><div class=\"form-group has-success has-feedback col-xs-8\"><div class=\"col-xs-8\"><div class=\"input-group\"><span class=\"input-group-addon addon-left\"><i class=\"fa fa-hashtag fa-fw\"></i></span> <input type=\"text\" class=\"form-control\" id=\"no_sub_atributo\" ng-model=\"data.no_sub_atributo\" name=\"no_sub_atributo\" aria-describedby=\"inputGroupSuccess1Status\"> <i class=\"ion-checkmark-circled form-control-feedback\" aria-hidden=\"true\"></i> <span id=\"inputGroupSuccess1Status\" class=\"sr-only\">(success)</span></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"GuardarSubAtributo(data)\">Guardar</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">Cancelar</button></div></div>");
$templateCache.put("app/pages/catalogo/cuponera/modal/listCuponModal.html","<div class=\"modal-content\"><div class=\"modal-header bg-success\"><i class=\"ion-information-circled modal-icon\"></i><span>Lista de Cupones</span></div><div class=\"modal-body text-center\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:4%;\" class=\"table-id\">#</th><th style=\"width:30%;\">Responsable</th><th style=\"width:20%;\">Codigo Cupon</th><th style=\"width:30%;\">Monto</th><th style=\"width:10%;\">&nbsp;</th></tr><tr><th></th><th><input st-search=\"no_resp_cupon\" class=\"input-sm form-control\" placeholder=\"Busqueda cliente ...\" type=\"search\"></th><th><input st-search=\"co_cupon\" class=\"input-sm form-control\" placeholder=\"Busqueda N° Documento ...\" type=\"search\"></th><th></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_resp_cupon }}</td><td>{{item.co_cupon }}</td><td>{{item.va_descuento }}</td><td><div class=\"btn-group\" role=\"group\"><button class=\"btn btn-icon btn-success\" title=\"Agregar\" ng-click=\"obtenerProducto(item, displayed.indexOf(item))\"><i class=\"ion-plus\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center bg-success\" st-pagination=\"\" st-items-by-page=\"5\"></td></tr></tfoot></table></div></div>");
$templateCache.put("app/pages/catalogo/cuponera/modal/modal_cupon.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><i class=\"ion-information-circled modal-icon\"></i><span>Registro de Cupones</span></div><div class=\"modal-body text-left\"><div class=\"row\"><div class=\"col-xs-3\"><span>Responsable:</span></div><div class=\"form-group has-success has-feedback col-xs-8\"><div class=\"col-xs-12\"><div class=\"input-group\"><span class=\"input-group-addon addon-left\"></span> <input type=\"text\" class=\"form-control\" id=\"no_resp_cupon\" ng-model=\"data.no_resp_cupon\" name=\"no_resp_cupon\" aria-describedby=\"inputGroupSuccess1Status\"> <i class=\"ion-checkmark-circled form-control-feedback\" aria-hidden=\"true\"></i> <span id=\"inputGroupSuccess1Status\" class=\"sr-only\">(success)</span></div></div></div></div><div class=\"row\"><div class=\"col-xs-3\"><span>Codigo:</span></div><div class=\"form-group has-success has-feedback col-xs-8\"><div class=\"col-xs-8\"><div class=\"input-group\"><span class=\"input-group-addon addon-left\"></span> <input type=\"text\" class=\"form-control\" id=\"co_cupon\" ng-model=\"data.co_cupon\" name=\"co_cupon\" aria-describedby=\"inputGroupSuccess1Status\"> <i class=\"ion-checkmark-circled form-control-feedback\" aria-hidden=\"true\"></i> <span id=\"inputGroupSuccess1Status\" class=\"sr-only\">(success)</span></div></div></div></div><div class=\"row\"><div class=\"col-xs-3\"><span>Comisión:</span></div><div class=\"form-group has-success has-feedback col-xs-8\"><div class=\"col-xs-8\"><div class=\"input-group\"><span class=\"input-group-addon addon-left\"></span> <input type=\"text\" class=\"form-control\" id=\"va_comision\" ng-model=\"data.va_comision\" name=\"va_comision\" aria-describedby=\"inputGroupSuccess1Status\"> <i class=\"ion-checkmark-circled form-control-feedback\" aria-hidden=\"true\"></i> <span id=\"inputGroupSuccess1Status\" class=\"sr-only\">(success)</span></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"GuardarCupon(data)\">Guardar</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">Cancelar</button></div></div>");
$templateCache.put("app/pages/catalogo/cuponera/modal/modal_descuento.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><i class=\"ion-information-circled modal-icon\"></i><span>Control de Cupon por Descuento</span></div><div class=\"modal-body text-left\"><div class=\"row\"><div class=\"col-xs-3\"><span>Seleccione Cupon:</span></div><div class=\"col-md-6\"><div class=\"form-group has-success has-feedback\"><select class=\"form-control\" name=\"id_cupon\" id=\"id_cupon\" ng-model=\"data.id_cupon\" ng-options=\"mar.id_cupon as mar.co_cupon for mar in jCupon\"><option selected=\"\" value=\"\">---Cupon---</option></select></div></div></div><div class=\"row\"><div class=\"col-xs-3\"><span>Valor Descuento:</span></div><div class=\"form-group has-success has-feedback col-xs-8\"><div class=\"col-xs-8\"><div class=\"input-group\"><span class=\"input-group-addon addon-left\"><i class=\"fa fa-hashtag fa-fw\"></i></span> <input type=\"text\" class=\"form-control\" id=\"va_descuento\" ng-model=\"data.va_descuento\" name=\"va_descuento\" aria-describedby=\"inputGroupSuccess1Status\"> <i class=\"ion-checkmark-circled form-control-feedback\" aria-hidden=\"true\"></i> <span id=\"inputGroupSuccess1Status\" class=\"sr-only\">(success)</span></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"GuardarDescuento(data)\">Guardar</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">Cancelar</button></div></div>");
$templateCache.put("app/pages/catalogo/descuento/modal/modal_descuentos.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><i class=\"ion-information-circled modal-icon\"></i><span>Control de Clientes</span></div><div class=\"modal-body text-left\"><div class=\"row\"><div class=\"col-xs-3\"><span>Seleccione Cliente:</span></div><div class=\"col-md-6\"><div class=\"form-group has-success has-feedback\"><select class=\"form-control\" name=\"id_cliente\" id=\"id_cliente\" ng-model=\"data.id_cliente\" ng-options=\"cli.id_cliente as cli.no_cliente for cli in jCliente\"><option selected=\"\" value=\"\">---Cliente---</option></select></div></div></div><div class=\"row\"><div class=\"col-xs-3\"><span>Valor Descuento:</span></div><div class=\"form-group has-success has-feedback col-xs-8\"><div class=\"col-xs-8\"><div class=\"input-group\"><span class=\"input-group-addon addon-left\"><i class=\"fa fa-hashtag fa-fw\"></i></span> <input type=\"text\" class=\"form-control\" id=\"pr_descuento\" ng-model=\"data.pr_descuento\" name=\"pr_descuento\" aria-describedby=\"inputGroupSuccess1Status\"> <i class=\"ion-checkmark-circled form-control-feedback\" aria-hidden=\"true\"></i> <span id=\"inputGroupSuccess1Status\" class=\"sr-only\">(success)</span></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"GuardarClienteDescuento(data)\">Guardar</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">Cancelar</button></div></div>");
$templateCache.put("app/pages/catalogo/empleado/list/empleadoList.html","<div class=\"widgets\"><div class=\"row\"><div ba-panel=\"\" ba-panel-title=\"Listado de Empleados <i ng-click=\'agregar()\' class=\'fa pull-right fa-plus\' style=\' cursor: pointer;\'></i>\" ba-panel-class=\"with-scroll\"><div class=\"form-group\"><div class=\"col-sm-12\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:1%;\" class=\"table-id\">#</th><th style=\"width:10%;\">Nombre Empleado</th><th style=\"width:8%;\">N° Documento</th><th style=\"widows:28%;\">Dirección</th><th style=\"width:4%;\">N° Contacto</th><th style=\"width:4%;\">E-mail</th><th style=\"width:3%;\">F. Ingreso</th><th style=\"width:10%;\">&nbsp;</th></tr><tr><th></th><th><input st-search=\"no_empleado\" class=\"input-sm form-control\" placeholder=\"Busqueda Empleado ...\" type=\"search\"></th><th><input st-search=\"nu_documento\" class=\"input-sm form-control\" placeholder=\"Busqueda N° Documento ...\" type=\"search\"></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_empleado }}</td><td>{{item.nu_documento }}</td><td>{{item.no_direccion }}</td><td>{{item.nu_contacto }}</td><td>{{item.email }}</td><td>{{item.fe_ingreso }}</td><td><div class=\"btn-group\" role=\"group\"><a class=\"btn btn-xs btn-success\" title=\"Editar\" ui-sref=\"dashboard.empleado.empleado-details({idempleado: item.id_empleado})\"><i class=\"ion-edit\"></i></a> <button class=\"btn btn-xs btn-default\" ng-click=\"changeStatus(displayed.indexOf(item), item.id_empleado, item.status)\"><i class=\"fa\" ng-class=\"(item.status==true)?\'fa-toggle-on\':\'fa-toggle-off\'\"></i></button> <button class=\"btn btn-xs btn-danger\" title=\"Eliminar\" ng-click=\"eliminar(item.id_empleado, displayed.indexOf(item))\"><i class=\"ion-trash-a\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"8\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/catalogo/marca/modal/modal_descuento.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><i class=\"ion-information-circled modal-icon\"></i><span>Control de Marca por Descuento</span></div><div class=\"modal-body text-left\"><div class=\"row\"><div class=\"col-xs-3\"><span>Seleccione una Marca:</span></div><div class=\"col-md-6\"><div class=\"form-group has-success has-feedback\"><select class=\"form-control\" name=\"id_marca\" id=\"id_marca\" ng-model=\"data.id_marca\" ng-options=\"mar.id_marca as mar.no_marca for mar in jMarca\"><option selected=\"\" value=\"\">---Marca---</option></select></div></div></div><div class=\"row\"><div class=\"col-xs-3\"><span>Valor Descuento:</span></div><div class=\"form-group has-success has-feedback col-xs-8\"><div class=\"col-xs-8\"><div class=\"input-group\"><span class=\"input-group-addon addon-left\"><i class=\"fa fa-hashtag fa-fw\"></i></span> <input type=\"text\" class=\"form-control\" id=\"pr_descuento\" ng-model=\"data.pr_descuento\" name=\"pr_descuento\" aria-describedby=\"inputGroupSuccess1Status\"> <i class=\"ion-checkmark-circled form-control-feedback\" aria-hidden=\"true\"></i> <span id=\"inputGroupSuccess1Status\" class=\"sr-only\">(success)</span></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"GuardarDescuento(data)\">Guardar</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">Cancelar</button></div></div>");
$templateCache.put("app/pages/catalogo/marca/modal/modal_marca.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><i class=\"ion-information-circled modal-icon\"></i><span>Control de Marcas</span></div><div class=\"modal-body text-left\"><div class=\"row\"><div class=\"col-xs-3\"><span>Nombre de la Marca:</span></div><div class=\"form-group has-success has-feedback col-xs-8\"><div class=\"col-xs-8\"><div class=\"input-group\"><span class=\"input-group-addon addon-left\"><i class=\"fa fa-hashtag fa-fw\"></i></span> <input type=\"text\" class=\"form-control\" id=\"no_marca\" ng-model=\"data.no_marca\" name=\"no_marca\" aria-describedby=\"inputGroupSuccess1Status\"> <i class=\"ion-checkmark-circled form-control-feedback\" aria-hidden=\"true\"></i> <span id=\"inputGroupSuccess1Status\" class=\"sr-only\">(success)</span></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"GuardarMarca(data)\">Guardar</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">Cancelar</button></div></div>");
$templateCache.put("app/pages/catalogo/producto/list/productoList.html","<div class=\"widgets\" ng-init=\"listar()\"><div class=\"row\"><div ba-panel=\"\" ba-panel-title=\"Listado de Productos<i ng-click=\'agregar()\' class=\'fa pull-right fa-plus\' style=\' cursor: pointer;\'></i>\" ba-panel-class=\"with-scroll\"><div class=\"form-group\"><div class=\"col-sm-12\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:3%;\" class=\"table-id\" st-sort=\"id\">#</th><th style=\"width:3%;\" st-sort=\"co_producto\">Código</th><th style=\"width:25%;\" st-sort=\"no_producto\">Producto</th><th style=\"width:20%;\" st-sort=\"co_barra\">C. Barra</th><th style=\"width:15%;\">Marca</th><th style=\"width:15%;\">Categoria</th><th style=\"width:10%;\">Precio</th><th style=\"width:8%;\">&nbsp;</th></tr><tr><th></th><th><input st-search=\"co_producto\" class=\"input-sm form-control\" placeholder=\"Busqueda Código ...\" type=\"search\"></th><th><input st-search=\"no_producto\" class=\"input-sm form-control\" placeholder=\"Busqueda Nombre ...\" type=\"search\"></th><th><input st-search=\"co_barra\" class=\"input-sm form-control\" placeholder=\"Busqueda Barra ...\" type=\"search\"></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" st-select-mode=\"multiple\" ng-repeat=\"item in displayed\"><td style=\"text-align: right;\">{{item.item}}</td><td style=\"text-align: right !important;\">{{item.co_producto}}</td><td>{{item.no_producto}}</td><td>{{item.co_barra}}</td><td>{{item.no_marca}}</td><td>{{item.no_categoria}}</td><td style=\"text-align: right;\">{{item.mto_ult_venta | number:2}}</td><td><div class=\"btn-group\" role=\"group\"><a class=\"btn btn-xs btn-primary\" title=\"Editar\" ui-sref=\"dashboard.catalogo.producto-details({idProducto: item.id_producto})\"><i class=\"ion-edit\"></i></a> <button class=\"btn btn-xs btn-danger\" title=\"Eliminar\" ng-click=\"eliminar(item.id_producto, displayed.indexOf(item))\"><i class=\"ion-trash-a\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"8\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/catalogo/producto/list/productoListModal.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><i class=\"ion-information-circled modal-icon\"></i><span>Lista de Productos</span></div><div class=\"modal-body text-center\" ng-init=\"listar()\"><table class=\"table table-striped\"><thead><tr><th style=\"width:4%;\" class=\"table-id\">#</th><th style=\"width:4%;\"></th><th style=\"width:30%;\">Producto</th><th style=\"width:20%;\">Marca</th><th style=\"width:20%;\">Categoria</th><th style=\"width:5%;\">Precio</th><th style=\"width:10%;\">&nbsp;</th></tr></thead><tbody><tr ng-repeat-start=\"Package in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{Package.id_producto}}</td><td><button type=\"button\" class=\"btn btn-primary btn-icon\" ng-click=\"viewChilds= !viewChilds\"><i class=\"ion-plus\"></i></button></td><td>{{Package.no_producto}}</td><td>{{Package.no_marca}}</td><td>{{Package.no_categoria}}</td><td>{{Package.va_precio_producto}}</td><td></td></tr><tr><td colspan=\"7\" ng-class=\"viewChilds? \'\' : \'hide\'\"><table class=\"table table-striped\"><tbody><tr class=\"primary\" ng-repeat=\"chilItem in Package.childItems\"><td class=\"table-id\" style=\"text-align: right;\">{{chilItem.id_producto}}</td><td></td><td>{{chilItem.no_producto}}</td><td>{{chilItem.no_marca}}</td><td>{{chilItem.no_categoria}}</td><td>{{chilItem.va_precio_producto}}</td><td><div class=\"btn-group\" role=\"group\"><button type=\"button\" class=\"btn btn-default btn-icon\" ng-click=\"obtenerProducto(chilItem, displayed.indexOf(chilItem))\"><i class=\"ion-plus\"></i></button></div></td></tr></tbody></table></td></tr><tr ng-repeat-end=\"\"></tr></tbody></table></div></div>");
$templateCache.put("app/pages/catalogo/producto/list/productoListModalN.html","<div class=\"modal-content\"><div class=\"modal-header bg-primary\"><i class=\"ion-information-circled modal-icon\"></i><span>Lista de Productos</span></div><div class=\"modal-body text-center\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:4%;\" class=\"table-id\">#</th><th style=\"width:15%;\">Codigo B.</th><th style=\"width:15%;\">Codigo</th><th style=\"width:30%;\">Producto</th><th style=\"width:15%;\">Marca</th><th style=\"width:15%;\">Categoria</th><th style=\"width:5%;\">Precio</th><th style=\"width:10%;\">&nbsp;</th></tr><tr><th></th><th><input st-search=\"co_barra\" class=\"input-sm form-control\" placeholder=\"Busqueda Barra\" type=\"search\"></th><th><input st-search=\"co_producto\" class=\"input-sm form-control\" placeholder=\"Busqueda Codigo\" type=\"search\"></th><th><input st-search=\"no_producto\" class=\"input-sm form-control\" placeholder=\"Busqueda Producto ...\" type=\"search\"></th><th><input st-search=\"no_marca\" class=\"input-sm form-control\" placeholder=\"Busqueda Marca ...\" type=\"search\"></th><th></th><th></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.id_producto}}</td><td>{{item.co_barra }}</td><td>{{item.co_producto }}</td><td>{{item.no_producto }}</td><td>{{item.no_marca }}</td><td>{{item.no_categoria }}</td><td>{{item.mto_ult_compra }}</td><td><div class=\"btn-group\" role=\"group\"><button type=\"button\" class=\"btn btn-primary btn-icon\" ng-click=\"obtenerProducto(item, displayed.indexOf(item))\"><i class=\"ion-plus\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"8\" class=\"text-center bg-primary\" st-pagination=\"\" st-items-by-page=\"7\"></td></tr></tfoot></table></div></div>");
$templateCache.put("app/pages/charts/amCharts/areaChart/areaChart.html","<div id=\"areaChart\" class=\"admin-chart\" ng-controller=\"AreaChartCtrl\"></div>");
$templateCache.put("app/pages/charts/amCharts/barChart/barChart.html","<div id=\"barChart\" class=\"admin-chart\" ng-controller=\"BarChartCtrl\"></div>");
$templateCache.put("app/pages/charts/amCharts/combinedChart/combinedChart.html","<div id=\"zoomAxisChart\" class=\"admin-chart\" ng-controller=\"combinedChartCtrl\"></div>");
$templateCache.put("app/pages/charts/amCharts/funnelChart/funnelChart.html","<div id=\"funnelChart\" class=\"admin-chart\" ng-controller=\"FunnelChartCtrl\"></div>");
$templateCache.put("app/pages/charts/amCharts/ganttChart/ganttChart.html","<div id=\"gnattChart\" class=\"admin-chart\" ng-controller=\"ganttChartCtrl\"></div>");
$templateCache.put("app/pages/charts/amCharts/lineChart/lineChart.html","<div id=\"lineChart\" class=\"admin-chart\" ng-controller=\"LineChartCtrl\"></div>");
$templateCache.put("app/pages/charts/amCharts/pieChart/pieChart.html","<div id=\"pieChart\" class=\"admin-chart\" ng-controller=\"PieChartCtrl\"></div>");
$templateCache.put("app/pages/clientes/cliente/list/clienteList.html","<div class=\"widgets\"><div class=\"row\"><div ba-panel=\"\" ba-panel-title=\"Listado de Clientes <i ng-click=\'agregar()\' class=\'fa pull-right fa-plus\' style=\' cursor: pointer;\'></i>\" ba-panel-class=\"with-scroll\"><div class=\"form-group\"><div class=\"col-sm-12\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:4%;\" class=\"table-id\">#</th><th style=\"width:20%;\">Nombre Cliente</th><th style=\"width:6%;\">N° Documento</th><th style=\"width:30%;\">Dirección</th><th style=\"width:6%;\">Teléfono</th><th style=\"width:6%;\">E-mail</th><th style=\"width:10%;\">&nbsp;</th></tr><tr><th></th><th><input st-search=\"no_cliente\" class=\"input-sm form-control\" placeholder=\"Busqueda cliente ...\" type=\"search\"></th><th><input st-search=\"nu_documento\" class=\"input-sm form-control\" placeholder=\"Busqueda N° Documento ...\" type=\"search\"></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_cliente }}</td><td>{{item.nu_documento }}</td><td>{{item.no_direccion }}</td><td>{{item.nu_telefono }}</td><td>{{item.no_email }}</td><td><div class=\"btn-group\" role=\"group\"><a class=\"btn btn-xs btn-primary\" title=\"Editar\" ui-sref=\"dashboard.clientes.cliente-details({idCliente: item.id_cliente})\"><i class=\"ion-edit\"></i></a> <button class=\"btn btn-xs btn-danger\" title=\"Eliminar\" ng-click=\"eliminar(item.id_cliente, displayed.indexOf(item))\"><i class=\"ion-trash-a\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"7\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/clientes/cliente/list/clienteListModal.html","<div class=\"modal-content\"><div class=\"modal-header bg-warning\"><i class=\"ion-information-circled modal-icon\"></i><span>Lista de Clientes</span></div><div class=\"modal-body text-center\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:4%;\" class=\"table-id\">#</th><th style=\"width:30%;\">Nombre Cliente</th><th style=\"width:20%;\">N° Documento</th><th style=\"width:30%;\">Dirección</th><th style=\"width:10%;\">&nbsp;</th></tr><tr><th></th><th><input st-search=\"no_cliente\" class=\"input-sm form-control\" placeholder=\"Busqueda cliente ...\" type=\"search\"></th><th><input st-search=\"nu_documento\" class=\"input-sm form-control\" placeholder=\"Busqueda N° Documento ...\" type=\"search\"></th><th></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_cliente }}</td><td>{{item.nu_documento }}</td><td>{{item.no_direccion }}</td><td><div class=\"btn-group\" role=\"group\"><button class=\"btn btn-icon btn-warning\" title=\"Agregar\" ng-click=\"obtenerCliente(item, displayed.indexOf(item))\"><i class=\"ion-plus\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center bg-warning\" st-pagination=\"\" st-items-by-page=\"7\"></td></tr></tfoot></table></div></div>");
$templateCache.put("app/pages/cobranzas/cobranza/list/cobranzaList.html","<div class=\"widgets\"><div class=\"row\"><div ba-panel=\"\" ba-panel-title=\"Listado de Comprobantes Pagados <i ng-click=\'agregar()\' class=\'fa pull-right fa-plus\' style=\' cursor: pointer;\'></i>\" ba-panel-class=\"with-scroll\"><div class=\"form-group\"><div class=\"col-sm-12\"><table st-table=\"displayed\" class=\"table table-striped\" st-pipe=\"callServer\"><thead><tr class=\"sortable\"><th style=\"width:4%;\" class=\"table-id\">#</th><th style=\"width:10%;\">Fecha</th><th style=\"width:6%;\">Serie</th><th style=\"width:8%\">Correlativo</th><th style=\"width:8%\">Tipo Comprobante</th><th style=\"width:6%\">Serie</th><th style=\"width:8%\">Correlativo</th><th style=\"width:6%;\">Total</th><th style=\"width:5%;\">Estado</th><th style=\"width:5%;\">&nbsp;</th></tr><tr><th></th><th><input st-search=\"fe_emision\" placeholder=\"Buscar Fecha\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"nu_serie_c\" placeholder=\"Buscar Serie\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"nu_correlativo_c\" placeholder=\"Buscar Correlativo\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"no_tipo_comprobante\" placeholder=\"Buscar Comprobante\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"nu_serie\" placeholder=\"Buscar Serie\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"nu_correlativo\" placeholder=\"Buscar Correlativo\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"nu_total\" placeholder=\"Buscar Total\" class=\"input-sm form-control search-input\" type=\"search\"></th><th></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.fe_emision | date:\'dd-MM-yyyy\'}}</td><td>{{item.nu_serie}}</td><td>{{item.nu_correlativo}}</td><td>{{item.no_tipo_comprobante_c}}</td><td>{{item.nu_serie_c}}</td><td>{{item.nu_correlativo_c}}</td><td>{{item.nu_total }}</td><td><button class=\"status-button btn btn-xs\" style=\"width: 90% !important;\" ng-class=\"{\'btn-success\':(item.no_estado==\'COMPLETO\'), \'btn-danger\': (item.no_estado==\'INCOMPLETO\')}\"><i class=\"ion-navigate\"></i> {{item.no_estado}}</button></td><td><div class=\"btn-group\" role=\"group\"><a class=\"btn btn-xs btn-primary\" title=\"Editar\" ui-sref=\"dashboard.cobranzas.cobranza-details({idcobranza: item.id_cobranza})\"><i class=\"ion-edit\"></i></a> <button class=\"btn btn-xs btn-danger\" title=\"Eliminar\" ng-click=\"eliminar(item.id_cobranza, displayed.indexOf(item))\"><i class=\"ion-trash-a\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"10\" class=\"text-center\"><div st-pagination=\"\" st-items-by-page=\"smartTablePageSize\" st-displayed-pages=\"10\"></div></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/compras/compra/list/comprasList.html","<div class=\"widgets\" ng-init=\"consultar()\"><div class=\"row\"><div ba-panel-title=\"TOTAL COMPRAS\" ba-panel=\"\" ba-panel-class=\"with-scroll\" class=\"col-md-6 col-lg-6\"><div class=\"col-md-6\"><h1 class=\"al-title ng-binding\"><i class=\"fas fa-thumbs-up\"></i> {{data.nu_compras}}</h1></div></div><div ba-panel-title=\"TOTAL EGRESOS POR COMPRAS\" ba-panel=\"\" ba-panel-class=\"with-scroll\" class=\"col-md-6 col-lg-6\"><div class=\"col-md-6\"><h1 class=\"al-title ng-binding\"><i class=\"fas fa-coins\"></i> {{data.nu_total | number:2}}</h1></div></div></div><div class=\"row\"><div ba-panel=\"\" ba-panel-title=\"Listado de Ordenes de Compras<i ng-click=\'agregar()\' class=\'fa pull-right fa-plus\' style=\' cursor: pointer;\'></i>\" ba-panel-class=\"with-scroll\"><div class=\"form-group\"><div class=\"col-sm-12\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:4%;\" class=\"table-id\">#</th><th style=\"width:10%;\">Sucursal</th><th style=\"width:10%;\">Proveedor</th><th style=\"width:5%;\">F. Compra</th><th style=\"width:5%;\">Serie</th><th style=\"width:5%;\">Correlativo</th><th style=\"width:6%;\">Total</th><th style=\"width:10%;\">Estado</th><th style=\"width:10%;\">&nbsp;</th></tr><tr><th></th><th><input st-search=\"no_local\" class=\"input-sm form-control\" placeholder=\"Busqueda Local ...\" type=\"search\"></th><th><input st-search=\"no_proveedor\" class=\"input-sm form-control\" placeholder=\"Busqueda Proveedor ...\" type=\"search\"></th><th><input st-search=\"fe_registro\" class=\"input-sm form-control\" placeholder=\"Busqueda Fecha ...\" type=\"search\"></th><th><input st-search=\"nu_serie\" class=\"input-sm form-control\" placeholder=\"Busqueda Serie ...\" type=\"search\"></th><th><input st-search=\"nu_correlativo\" class=\"input-sm form-control\" placeholder=\"Busqueda Correlativo ...\" type=\"search\"></th><th><input st-search=\"nu_total\" class=\"input-sm form-control\" placeholder=\"Busqueda Monto ...\" type=\"search\"></th><th></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_local }}</td><td>{{item.no_proveedor }}</td><td>{{item.fe_emision | date:\'dd-MM-yyyy\' }}</td><td>{{item.nu_serie }}</td><td>{{item.nu_correlativo }}</td><td>{{item.nu_total| number:2 }}</td><td><button class=\"status-button btn btn-xs\" style=\"width: 90% !important;\" ng-class=\"{\'btn-danger\': (item.il_stado==\'0\') , \'btn-success\':(item.il_stado==\'1\')}\"><i class=\"ion-navigate\"></i> {{item.no_estado}}</button></td><td><div class=\"text-center btn-group\" role=\"group\" style=\"background: black;\"><button type=\"button\" title=\"Editar\" class=\"btn btn-default btn-icon\" ui-sref=\"dashboard.compras.compra-details({idCompras: item.id_compra_cabecera})\"><i class=\"ion-edit text-success\"></i></button> <button type=\"button\" title=\"Archivo Pdf\" data-toggle=\"popover\" class=\"btn btn-default btn-icon\" ng-disabled=\"\" ng-click=\"openPdfCompra(\'lg\',item)\"><i class=\"ion-clipboard text-primary\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"8\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/compras/compra/modal/listInsumos.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><i class=\"ion-information-circled modal-icon\"></i><span>Lista de Insumos</span></div><div class=\"modal-body text-left\"><div class=\"horizontal-scroll\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:4%;\" class=\"table-id\">#</th><th style=\"width:15%;\">Nombre Insumo</th><th style=\"width:10%;\">Categoria</th><th style=\"width:10%;\">Unidad</th><th style=\"width:10%;\">Medida</th><th style=\"width:6%;\">Precio Sugerido</th><th style=\"width:10%;\">&nbsp;</th></tr><tr><th></th><th><input st-search=\"no_insumo\" class=\"input-sm form-control\" placeholder=\"Busqueda Insumo ...\" type=\"search\"></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_insumo }}</td><td>{{item.no_categoria_insumo }}</td><td>{{item.no_unidad }}</td><td>{{item.no_medida }}</td><td>{{item.nu_precio_sugerido }}</td><td><div class=\"btn-group\" role=\"group\"><button class=\"btn btn-xs btn-sucess\" title=\"Agregar Insumo a la compra\" ng-click=\"obtenerInsumo(item, displayed.indexOf(item))\"><i class=\"fa pull-center fa-plus\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"9\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"\">Confirmar</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">Cancelar</button></div></div>");
$templateCache.put("app/pages/compras/compra/modal/modalPdf.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><i class=\"ion-information-circled modal-icon\"></i><span>Control de Acciòn</span></div><div class=\"modal-body text-left\"><div class=\"col-md-12\">Precione Confirmar Para Visualizar La {{item.no_tipo_comprobante}} {{item.nu_serie}}-{{item.nu_correlativo}}</div></div><div class=\"modal-footer\"><form action=\"{{archivo}}\" method=\"POST\" target=\"_blank\"><input type=\"hidden\" name=\"item\" value=\"{{item}}\"> <input type=\"hidden\" name=\"oper\" value=\"rpt_boleta\"> <button type=\"submit\" class=\"btn btn-info\" ng-click=\"pdf({{item}})\"><i class=\"fa fa-print fa-fw\"></i> Generar</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">Cancelar</button></form></div></div>");
$templateCache.put("app/pages/compras/facturaprov/list/facturaprovList.html","<div class=\"widgets\"><div class=\"row\"><div ba-panel=\"\" ba-panel-title=\"Listado de Ordenes de Compras<i ng-click=\'agregar()\' class=\'fa pull-right fa-plus\' style=\' cursor: pointer;\'></i>\" ba-panel-class=\"with-scroll\"><div class=\"form-group\"><div class=\"col-sm-12\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:4%;\" class=\"table-id\">#</th><th style=\"width:15%;\">Proveedor</th><th style=\"width:6%;\">Tipo C.</th><th style=\"width:6%;\">Serie</th><th style=\"width:6%;\">Correlativo</th><th style=\"width:5%;\">Fecha C.</th><th style=\"width:6%;\">Total</th><th style=\"width:10%;\">Condicion Pago</th><th style=\"width:5%;\">Estado</th></tr><tr><th></th><th><input st-search=\"no_proveedor\" class=\"input-sm form-control\" placeholder=\"Busqueda proveedor ...\" type=\"search\"></th><th><input st-search=\"no_tipo_comprobante\" class=\"input-sm form-control\" placeholder=\"Busqueda Tipo ...\" type=\"search\"></th><th><input st-search=\"nu_serie_oc\" class=\"input-sm form-control\" placeholder=\"Busqueda Serie ...\" type=\"search\"></th><th><input st-search=\"nu_correlativo_oc\" class=\"input-sm form-control\" placeholder=\"Busqueda Correlativo ...\" type=\"search\"></th><th><input st-search=\"fe_registro\" class=\"input-sm form-control\" placeholder=\"Busqueda Fecha ...\" type=\"search\"></th><th><input st-search=\"nu_total\" class=\"input-sm form-control\" placeholder=\"Busqueda Monto ...\" type=\"search\"></th><th><input st-search=\"no_tipo_medio_pago\" class=\"input-sm form-control\" placeholder=\"Busqueda Condición ...\" type=\"search\"></th><th><input st-search=\"no_estado\" class=\"input-sm form-control\" placeholder=\"Busqueda Condición ...\" type=\"search\"></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_proveedor }}</td><td>{{item.no_tipo_comprobante }}</td><td>{{item.nu_serie_oc }}</td><td>{{item.nu_correlativo_oc }}</td><td>{{item.fe_pago | date:\'dd-MM-yyyy\'}}</td><td>{{item.nu_total| number:2 }}</td><td>{{item.no_tipo_medio_pago }}</td><td><button class=\"status-button btn btn-xs\" style=\"width: 90% !important;\" ng-class=\"{\'btn-danger\': (item.il_stado==\'0\') , \'btn-success\':(item.il_stado==\'1\')}\"><i class=\"ion-navigate\"></i> {{item.no_estado}}</button></td></tr></tbody><tfoot><tr><td colspan=\"9\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/compras/proveedor/list/proveedorList.html","<div class=\"widgets\"><div class=\"row\"><div ba-panel=\"\" ba-panel-title=\"Listado de Proveedores <i ng-click=\'agregar()\' class=\'fa pull-right fa-plus\' style=\' cursor: pointer;\'></i>\" ba-panel-class=\"with-scroll\"><div class=\"form-group\"><div class=\"col-sm-12\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:4%;\" class=\"table-id\">#</th><th style=\"width:20%;\">Nombre Proveedor</th><th style=\"width:10%;\">N° Documento</th><th style=\"width:20%;\">Dirección</th><th style=\"width:10%;\">&nbsp;</th></tr><tr><th></th><th><input st-search=\"no_proveedor\" class=\"input-sm form-control\" placeholder=\"Busqueda proveedor ...\" type=\"search\"></th><th><input st-search=\"nu_documento\" class=\"input-sm form-control\" placeholder=\"Busqueda N° Documento ...\" type=\"search\"></th><th></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_proveedor }}</td><td>{{item.nu_documento }}</td><td>{{item.no_direccion }}</td><td><div class=\"btn-group\" role=\"group\"><button class=\"btn btn-xs btn-default\" popover-trigger=\"mouseenter\" uib-popover=\"{{item.no_contacto}}\"><i class=\"fa fa-user\"></i></button> <button class=\"btn btn-xs btn-default\" popover-trigger=\"mouseenter\" uib-popover=\"{{item.nu_telefono}}\"><i class=\"fa fa-phone\"></i></button> <button class=\"btn btn-xs btn-default\" popover-trigger=\"mouseenter\" uib-popover=\"{{item.nu_celular}}\"><i class=\"fa fa-mobile\"></i></button> <button class=\"btn btn-xs btn-default\" popover-trigger=\"mouseenter\" uib-popover=\"{{item.email}}\"><i class=\"fa fa-envelope-square\"></i></button> <a class=\"btn btn-xs btn-primary\" title=\"Editar\" ui-sref=\"dashboard.compras.proveedor-details({idProveedor: item.id_proveedor})\"><i class=\"ion-edit\"></i></a> <button class=\"btn btn-xs btn-danger\" title=\"Eliminar\" ng-click=\"eliminar(item.id_proveedor, displayed.indexOf(item))\"><i class=\"ion-trash-a\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/compras/proveedor/list/proveedorListModal.html","<div class=\"modal-content\"><div class=\"modal-header bg-danger\"><i class=\"ion-information-circled modal-icon\"></i><span>Lista de Proveedores</span></div><div class=\"modal-body text-center\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:5%;\" class=\"table-id\">#</th><th style=\"width:25%;\">Nombre Proveedor</th><th style=\"width:20%;\">N° Documento</th><th style=\"width:40%;\">Dirección</th><th style=\"width:5%;\">&nbsp;</th></tr><tr><th></th><th><input st-search=\"no_proveedor\" class=\"input-sm form-control\" placeholder=\"Busqueda proveedor ...\" type=\"search\"></th><th><input st-search=\"nu_documento\" class=\"input-sm form-control\" placeholder=\"Busqueda N° Documento ...\" type=\"search\"></th><th></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_proveedor }}</td><td>{{item.nu_documento }}</td><td>{{item.no_direccion }}</td><td><div class=\"btn-group\" role=\"group\"><button class=\"btn btn-icon btn-danger\" title=\"Agregar\" ng-click=\"obtenerProveedor(item, displayed.indexOf(item))\"><i class=\"ion-plus\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"5\" class=\"text-center bg-danger\" st-pagination=\"\" st-items-by-page=\"7\"></td></tr></tfoot></table></div></div>");
$templateCache.put("app/pages/comprobantes/boleta/modal/generar.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><i class=\"ion-information-circled modal-icon\"></i><span>Control de Acciòn</span></div><div class=\"modal-body text-left\"><div class=\"col-md-12\">Esta Seguro de Generar La {{item.no_tipo_comprobante}} {{item.nu_serie}}-{{item.nu_correlativo}}<div id=\"result\"></div></div></div><div class=\"modal-footer\"><form action=\"{{archivo}}\" method=\"POST\" target=\"_blank\"><input type=\"hidden\" name=\"item\" value=\"{{item}}\"> <input type=\"hidden\" name=\"oper\" value=\"rpt_boleta\"> <button type=\"button\" class=\"btn btn-info\" ng-click=\"gen({{item}})\" ng-disabled=\"respuesta==1\"><i class=\"fa fa-print fa-fw\"></i> Generar</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"cerrar()\">Cancelar</button></form></div></div>");
$templateCache.put("app/pages/comprobantes/boleta/modal/modalConsulta.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><i class=\"ion-information-circled modal-icon\"></i><span>Consultar Status CDR</span></div><div class=\"modal-body text-left\"><div class=\"col-md-12\">Esta Seguro de Consultar La {{item.no_tipo_comprobante}} {{item.nu_serie}}-{{item.nu_correlativo}}<div id=\"result\"></div><div id=\"archivo\"></div></div></div><div class=\"modal-footer\"><form action=\"{{archivo}}\" method=\"POST\" target=\"_blank\"><input type=\"hidden\" name=\"item\" value=\"{{item}}\"> <input type=\"hidden\" name=\"oper\" value=\"rpt_boleta\"> <button type=\"button\" class=\"btn btn-info\" ng-click=\"consul({{item}})\" ng-disabled=\"respuesta==1\"><i class=\"fa fa-print fa-fw\"></i> Generar</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"cerrar()\">Cancelar</button></form></div></div>");
$templateCache.put("app/pages/comprobantes/boleta/modal/modalEmail.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><i class=\"ion-information-circled modal-icon\"></i><span>Envio de Correo Electronico</span></div><div class=\"modal-body\"><div>Recuerde que para Realizar el Envio Correctamente ya deben estar Generados los Archivos Xml y Pdf.</div><div></div><div id=\"result\"></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"enviaCorreo({{item}})\"><i class=\"fa fa-print fa-fw\"></i> Enviar</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">Cancelar</button></div></div>");
$templateCache.put("app/pages/comprobantes/boleta/modal/modalPdf.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><i class=\"ion-information-circled modal-icon\"></i><span>Control de Acciòn</span></div><div class=\"modal-body text-left\"><div class=\"col-md-12\">Precione Confirmar Para Visualizar La {{item.no_tipo_comprobante}} {{item.nu_serie}}-{{item.nu_correlativo}}</div></div><div class=\"modal-footer\"><form action=\"{{archivo}}\" method=\"POST\" target=\"_blank\"><input type=\"hidden\" name=\"item\" value=\"{{item}}\"> <input type=\"hidden\" name=\"oper\" value=\"rpt_boleta\"> <button type=\"submit\" class=\"btn btn-info\" ng-click=\"pdf({{item}})\"><i class=\"fa fa-print fa-fw\"></i> Generar</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">Cancelar</button></form></div></div>");
$templateCache.put("app/pages/comprobantes/boleta/modal/modalXml.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><i class=\"ion-information-circled modal-icon\"></i><span>Visualizaciòn</span></div><div class=\"modal-body\"><iframe src=\"api/files/20549511750-01-F001-123.xml\" id=\"modeliframe\" style=\"zoom:0.60\" frameborder=\"0\" height=\"350\" width=\"99.6%\"></iframe></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"\"><i class=\"fa fa-print fa-fw\"></i> Generar</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">Cancelar</button></div></div>");
$templateCache.put("app/pages/comprobantes/boleta/modal/modalbajas.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><i class=\"ion-information-circled modal-icon\"></i><span>Control de Acciòn</span></div><div class=\"modal-body text-left\"><div class=\"col-md-12\">Esta Seguro de dar de Baja La {{item.no_tipo_comprobante}} {{item.nu_serie}}-{{item.nu_correlativo}}<div id=\"tickets\"></div><div id=\"result\"></div></div></div><div class=\"modal-footer\"><form action=\"{{archivo}}\" method=\"POST\" target=\"_blank\"><input type=\"hidden\" name=\"item\" value=\"{{item}}\"> <input type=\"hidden\" name=\"oper\" value=\"rpt_boleta\"> <button type=\"button\" class=\"btn btn-info\" ng-click=\"darBaja({{item}})\" ng-disabled=\"respuesta==1\"><i class=\"fa fa-print fa-fw\"></i> Confirmar</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"cerrar()\">Cancelar</button></form></div></div>");
$templateCache.put("app/pages/comprobantes/guia/modal/modalPdf.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><i class=\"ion-information-circled modal-icon\"></i><span>Control de Acciòn</span></div><div class=\"modal-body text-left\"><div class=\"col-md-12\">Precione Confirmar Para Visualizar La {{item.no_tipo_comprobante}} {{item.nu_serie}}-{{item.nu_correlativo}}</div></div><div class=\"modal-footer\"><form action=\"{{archivo}}\" method=\"POST\" target=\"_blank\"><input type=\"hidden\" name=\"item\" value=\"{{item}}\"> <input type=\"hidden\" name=\"oper\" value=\"rpt_boleta\"> <button type=\"submit\" class=\"btn btn-info\" ng-click=\"pdf({{item}})\"><i class=\"fa fa-print fa-fw\"></i> Generar</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">Cancelar</button></form></div></div>");
$templateCache.put("app/pages/comprobantes/notacredito/modal/modalPdf.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><i class=\"ion-information-circled modal-icon\"></i><span>Control de Acciòn</span></div><div class=\"modal-body text-left\"><div class=\"col-md-12\">Precione Confirmar Para Visualizar La {{item.no_tipo_comprobante}} {{item.nu_serie}}-{{item.nu_correlativo}}</div></div><div class=\"modal-footer\"><form action=\"{{archivo}}\" method=\"POST\" target=\"_blank\"><input type=\"hidden\" name=\"item\" value=\"{{item}}\"> <input type=\"hidden\" name=\"oper\" value=\"rpt_boleta\"> <button type=\"submit\" class=\"btn btn-info\" ng-click=\"pdf({{item}})\"><i class=\"fa fa-print fa-fw\"></i> Generar</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">Cancelar</button></form></div></div>");
$templateCache.put("app/pages/contabilidad/cuentas/list/cuentasList.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-sm-12\"><div ba-panel=\"\" ba-panel-title=\"Listado de Cuentas Bancarias<i ng-click=\'agregar()\' class=\'fa pull-right fa-plus\' style=\' cursor: pointer;\'></i>\" ba-panel-class=\"with-scroll\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"id_empresa\">Empresa</label><ui-select id=\"id_empresa\" ng-model=\"data.id_empresa\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\" ng-disabled=\"vm.productCosto.no_producto.$invalid\" ng-change=\"getSucursal(data.id_empresa)\"><ui-select-match placeholder=\"Empresa\">{{$select.selected.no_empresa}}</ui-select-match><ui-select-choices repeat=\"empresa in jEmpresa | filter: $select.search\"><span ng-bind-html=\"empresa.no_empresa\"></span></ui-select-choices><ui-select-no-choice><strong>No existe!</strong> Si desea agregarlo <button type=\"button\" class=\"btn btn-link\" ng-click=\"open_modal($select.search, \'\')\">Click aquí</button>.</ui-select-no-choice></ui-select></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"id_local\">Sucursal</label><ui-select id=\"id_local\" ng-model=\"data.id_local\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\" ng-disabled=\"vm.productCosto.no_producto.$invalid\"><ui-select-match placeholder=\"Sucursal\">{{$select.selected.no_local}}</ui-select-match><ui-select-choices repeat=\"local in jSucursal | filter: $select.search\"><span ng-bind-html=\"local.no_local\"></span></ui-select-choices><ui-select-no-choice><strong>No existe!</strong> Si desea agregarlo <button type=\"button\" class=\"btn btn-link\" ng-click=\"open_modal($select.search, \'\')\">Click aquí</button>.</ui-select-no-choice></ui-select></div></div></div><div class=\"col-sm-12\"><table class=\"table\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:5%;\" class=\"table-id\">#</th><th style=\"width:15%;\">Sucursal</th><th style=\"width:15%;\">Banco</th><th style=\"width:10%;\">Cuenta</th><th style=\"width:10%;\">Fecha Apertura</th><th style=\"width:10%;\">Saldo</th><th style=\"width:7%;\"></th></tr><tr><th></th><th><input st-search=\"no_producto\" class=\"input-sm form-control\" placeholder=\"Busqueda Sucursal\" type=\"search\"></th><th><input st-search=\"no_atributo\" class=\"input-sm form-control\" placeholder=\"Busqueda Banco\" type=\"search\"></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_local }}</td><td>{{item.no_banco }}</td><td>{{item.nu_cuenta_bancaria }}</td><td>{{item.fe_apertura }}</td><td>{{item.va_saldo | number:2 }}</td><td><div class=\"btn-group\" role=\"group\"><a class=\"btn btn-xs btn-primary\" title=\"Editar\" ui-sref=\"dashboard.contabilidad.cuentas-details({idcuentas: item.id_cuenta_bancaria})\"><i class=\"ion-edit\"></i></a> <button class=\"btn btn-xs btn-danger\" title=\"Eliminar\" ng-click=\"eliminar(item.id_cuenta_bancaria, displayed.indexOf(item))\"><i class=\"ion-trash-a\"></i></button> <button class=\"btn btn-xs\" ng-class=\"(item.status==\'1\')?\'btn-success\':\'btn-danger\'\" ng-click=\"changeStatus(item.id_cuenta_bancaria, item.status, displayed.indexOf(item))\" title=\"Activar/inactivar\"><i class=\"fa\" ng-class=\"(item.status==\'1\')?\'fa-check\':\'fa-ban\'\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"7\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/contabilidad/pasivos/list/pasivosList.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-sm-12\"><div ba-panel=\"\" ba-panel-title=\"Listado de Pasivos<i ng-click=\'agregar()\' class=\'fa pull-right fa-plus\' style=\' cursor: pointer;\'></i>\" ba-panel-class=\"with-scroll\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group has-feedback\"><label for=\"id_empresa\">Empresa</label><ui-select id=\"id_empresa\" ng-model=\"data.id_empresa\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\" ng-disabled=\"vm.productCosto.no_producto.$invalid\" ng-change=\"getSucursal(data.id_empresa)\"><ui-select-match placeholder=\"Empresa\">{{$select.selected.no_empresa}}</ui-select-match><ui-select-choices repeat=\"empresa in jEmpresa | filter: $select.search\"><span ng-bind-html=\"empresa.no_empresa\"></span></ui-select-choices></ui-select></div></div><div class=\"col-md-3\"><div class=\"form-group has-feedback\"><label for=\"id_local\">Sucursal</label><ui-select id=\"id_local\" ng-model=\"data.id_local\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\" ng-disabled=\"vm.productCosto.no_producto.$invalid\"><ui-select-match placeholder=\"Sucursal\">{{$select.selected.no_local}}</ui-select-match><ui-select-choices repeat=\"local in jSucursal | filter: $select.search\"><span ng-bind-html=\"local.no_local\"></span></ui-select-choices></ui-select></div></div><div class=\"col-md-3\"><div class=\"form-group has-feedback\"><label for=\"regimen\">Años</label><ui-select id=\"id_anio\" ng-model=\"data.id_anio\" ng-change=\"getPeriodo(data.id_anio)\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\"><ui-select-match placeholder=\"Año\">{{$select.selected.no_anio}}</ui-select-match><ui-select-choices repeat=\"anio in jAnio | filter: $select.search\"><span ng-bind-html=\"anio.no_anio\"></span></ui-select-choices></ui-select></div></div><div class=\"col-md-3\"><div class=\"form-group has-feedback\"><label for=\"regimen\">Periodos</label><ui-select id=\"id_periodo\" ng-model=\"data.id_periodo\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\"><ui-select-match placeholder=\"Periodo\">{{$select.selected.no_periodo}}</ui-select-match><ui-select-choices repeat=\"periodo in jPeriodo | filter: $select.search\"><span ng-bind-html=\"periodo.no_periodo\"></span></ui-select-choices></ui-select></div></div></div><div class=\"col-sm-12\"><table class=\"table\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:5%;\" class=\"table-id\">#</th><th style=\"width:15%;\">Sucursal</th><th style=\"width:10%;\">Tipo Pasivo</th><th style=\"width:10%;\">Periodo</th><th style=\"width:15%;\">Detalle</th><th style=\"width:10%;\">Monto</th><th style=\"width:7%;\"></th></tr><tr><th></th><th></th><th><input st-search=\"no_atributo\" class=\"input-sm form-control\" placeholder=\"Busqueda Tipo\" type=\"search\"></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_local }}</td><td>{{item.no_tipo_pasivo }}</td><td>{{item.no_periodo }}</td><td>{{item.no_pasivo }}</td><td>{{item.va_pasivo | number:2 }}</td><td><div class=\"btn-group\" role=\"group\"><a class=\"btn btn-xs btn-primary\" title=\"Editar\" ui-sref=\"dashboard.contabilidad.pasivos-details({idpasivo: item.id_pasivo})\"><i class=\"ion-edit\"></i></a> <button class=\"btn btn-xs btn-danger\" title=\"Eliminar\" ng-click=\"eliminar(item.id_pasivo, displayed.indexOf(item))\"><i class=\"ion-trash-a\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"7\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/contabilidad/patrimonio/list/patrimonioList.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-sm-12\"><div ba-panel=\"\" ba-panel-title=\"Listado de Patrimonio<i ng-click=\'agregar()\' class=\'fa pull-right fa-plus\' style=\' cursor: pointer;\'></i>\" ba-panel-class=\"with-scroll\"><div class=\"row\"><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"id_empresa\">Empresa</label><ui-select id=\"id_empresa\" ng-model=\"data.id_empresa\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\" ng-disabled=\"vm.productCosto.no_producto.$invalid\" ng-change=\"getSucursal(data.id_empresa)\"><ui-select-match placeholder=\"Empresa\">{{$select.selected.no_empresa}}</ui-select-match><ui-select-choices repeat=\"empresa in jEmpresa | filter: $select.search\"><span ng-bind-html=\"empresa.no_empresa\"></span></ui-select-choices></ui-select></div></div><div class=\"col-md-3\"><div class=\"form-group\"><label for=\"id_local\">Sucursal</label><ui-select id=\"id_local\" ng-model=\"data.id_local\" class=\"btn-group bootstrap-select form-control\" search-enabled=\"true\" ng-disabled=\"vm.productCosto.no_producto.$invalid\"><ui-select-match placeholder=\"Sucursal\">{{$select.selected.no_local}}</ui-select-match><ui-select-choices repeat=\"local in jSucursal | filter: $select.search\"><span ng-bind-html=\"local.no_local\"></span></ui-select-choices></ui-select></div></div></div><div class=\"col-sm-12\"><table class=\"table\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:5%;\" class=\"table-id\">#</th><th style=\"width:15%;\">Sucursal</th><th style=\"width:15%;\">Empleado</th><th style=\"width:15%;\">Descripcion</th><th style=\"width:10%;\">Monto</th><th style=\"width:7%;\"></th></tr><tr><th></th><th><input st-search=\"no_atributo\" class=\"input-sm form-control\" placeholder=\"Busqueda Banco\" type=\"search\"></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_local }}</td><td>{{item.no_empleado }}</td><td>{{item.no_patrimonio }}</td><td>{{item.va_patrimonio | number:2 }}</td><td><div class=\"btn-group\" role=\"group\"><a class=\"btn btn-xs btn-primary\" title=\"Editar\" ui-sref=\"dashboard.contabilidad.patrimonio-details({idpatrimonio: item.id_patrimonio})\"><i class=\"ion-edit\"></i></a> <button class=\"btn btn-xs btn-danger\" title=\"Eliminar\" ng-click=\"eliminar(item.id_cuenta_bancaria, displayed.indexOf(item))\"><i class=\"ion-trash-a\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"6\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/cuentas/cuentaxcobrar/list/cuentaxcobrarList.html","<div class=\"widgets\"><div class=\"row\"><div ba-panel=\"\" ba-panel-title=\"Listado Cuentas por Cobrar\" ba-panel-class=\"with-scroll\"><div class=\"form-group\"><div class=\"col-sm-12\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:4%;\" class=\"table-id\">#</th><th style=\"width:10%;\">Cliente</th><th style=\"width:6%;\">F. Venta</th><th style=\"width:6%;\">Recibo</th><th style=\"width:6%;\">N° Venta</th><th style=\"width:6%;\">Total</th><th style=\"width:10%;\">&nbsp;</th></tr><tr><th></th><th><input st-search=\"no_cliente\" class=\"input-sm form-control\" placeholder=\"Busqueda cliente ...\" type=\"search\"></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_cliente }}</td><td>{{item.fe_emision | date:\'dd-MM-yyyy\' }}</td><td>{{item.no_tipo_comprobante }}</td><td>{{item.numero_comprobante }}</td><td>{{item.nu_total }}</td><td><div class=\"text-center btn-group\" role=\"group\" style=\"background: black;\"><button type=\"button\" title=\"Enviar Correo\" data-toggle=\"popover\" class=\"btn btn-default btn-icon\" ng-disabled=\"\" ng-click=\"openCorreo(\'lg\',{{item}})\"><i class=\"ion-link text-success\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"9\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/cuentas/cuentaxpagar/list/cuentaxpagarList.html","<div class=\"widgets\"><div class=\"row\"><div ba-panel=\"\" ba-panel-title=\"Listado de Cuentas por Pagar\" ba-panel-class=\"with-scroll\"><div class=\"form-group\"><div class=\"col-sm-12\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:4%;\" class=\"table-id\">#</th><th style=\"width:20%;\">Proveedor</th><th style=\"width:5%;\">F. Compra</th><th style=\"width:5%;\">F. Pago</th><th style=\"width:5%;\">Recibo</th><th style=\"width:6%;\">N° Compra</th><th style=\"width:6%;\">Total</th><th style=\"width:10%;\">Condicion Pago</th><th style=\"width:5%;\">&nbsp;</th></tr><tr><th></th><th><input st-search=\"no_proveedor\" class=\"input-sm form-control\" placeholder=\"Busqueda proveedor ...\" type=\"search\"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_proveedor }}</td><td>{{item.fe_registro | date:\'dd-MM-yyyy\' }}</td><td>{{item.fe_pago | date:\'dd-MM-yyyy\' }}</td><td>{{item.no_tipo_comprobante }}</td><td>{{item.nu_comprobante }}</td><td>{{item.nu_total| number:2 }}</td><td>{{item.no_condicion_pago }}</td><td><div class=\"btn-group\" role=\"group\"><a class=\"btn btn-xs btn-success\" title=\"Editar\" ui-sref=\"dashboard.compras.compra-details({idCompras: item.id_compra_cabecera})\"><i class=\"ion-edit\"></i></a></div></td></tr></tbody><tfoot><tr><td colspan=\"9\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/form/inputs/widgets/checkboxesRadios.html","<div class=\"checkbox-demo-row\"><div class=\"input-demo checkbox-demo row\"><div class=\"col-md-4\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" id=\"inlineCheckbox01\" value=\"option1\"> <span>Check 1</span></label></div><div class=\"col-md-4\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" id=\"inlineCheckbox02\" value=\"option2\"> <span>Check 2</span></label></div><div class=\"col-md-4\"><label class=\"checkbox-inline custom-checkbox nowrap\"><input type=\"checkbox\" id=\"inlineCheckbox03\" value=\"option3\"> <span>Check 3</span></label></div></div><div class=\"input-demo radio-demo row\"><div class=\"col-md-4\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"inlineRadioOptions\" id=\"inlineRadio1\" value=\"option1\"> <span>Option 1</span></label></div><div class=\"col-md-4\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"inlineRadioOptions\" id=\"inlineRadio2\" value=\"option2\"> <span>Option 2</span></label></div><div class=\"col-md-4\"><label class=\"radio-inline custom-radio nowrap\"><input type=\"radio\" name=\"inlineRadioOptions\" id=\"inlineRadio3\" value=\"option3\"> <span>Option3</span></label></div></div></div><div><div class=\"checkbox disabled\"><label class=\"custom-checkbox nowrap\"><input type=\"checkbox\" value=\"\" disabled=\"\"> <span>Checkbox is disabled</span></label></div><div class=\"radio disabled\"><label class=\"custom-radio nowrap\"><input type=\"radio\" name=\"optionsRadios\" id=\"optionsRadios3\" value=\"option3\" disabled=\"\"> <span>Disabled option</span></label></div></div>");
$templateCache.put("app/pages/form/inputs/widgets/inputGroups.html","<div class=\"input-group\"><span class=\"input-group-addon input-group-addon-primary addon-left\" id=\"basic-addon1\">@</span> <input type=\"text\" class=\"form-control with-primary-addon\" placeholder=\"Username\" aria-describedby=\"basic-addon1\"></div><div class=\"input-group\"><input type=\"text\" class=\"form-control with-warning-addon\" placeholder=\"Recipient\'s username\" aria-describedby=\"basic-addon2\"> <span class=\"input-group-addon input-group-addon-warning addon-right\" id=\"basic-addon2\">@example.com</span></div><div class=\"input-group\"><span class=\"input-group-addon addon-left input-group-addon-success\">$</span> <input type=\"text\" class=\"form-control with-success-addon\" aria-label=\"Amount (to the nearest dollar)\"> <span class=\"input-group-addon addon-right input-group-addon-success\">.00</span></div><div class=\"input-group\"><input type=\"text\" class=\"form-control with-danger-addon\" placeholder=\"Search for...\"> <span class=\"input-group-btn\"><button class=\"btn btn-danger\" type=\"button\">Go!</button></span></div>");
$templateCache.put("app/pages/form/inputs/widgets/standardFields.html","<form><div class=\"form-group\"><label for=\"input01\">Text</label> <input type=\"text\" class=\"form-control\" id=\"input01\" placeholder=\"Text\"></div><div class=\"form-group\"><label for=\"input02\">Password</label> <input type=\"password\" class=\"form-control\" id=\"input02\" placeholder=\"Password\"></div><div class=\"form-group\"><label for=\"input03\">Rounded Corners</label> <input type=\"text\" class=\"form-control form-control-rounded\" id=\"input03\" placeholder=\"Rounded Corners\"></div><div class=\"form-group\"><label for=\"input04\">With help</label> <input type=\"text\" class=\"form-control\" id=\"input04\" placeholder=\"With help\"> <span class=\"help-block sub-little-text\">A block of help text that breaks onto a new line and may extend beyond one line.</span></div><div class=\"form-group\"><label for=\"input05\">Disabled Input</label> <input type=\"text\" class=\"form-control\" id=\"input05\" placeholder=\"Disabled Input\" disabled=\"\"></div><div class=\"form-group\"><label for=\"textarea01\">Textarea</label> <textarea placeholder=\"Default Input\" class=\"form-control\" id=\"textarea01\"></textarea></div><div class=\"form-group\"><input type=\"text\" class=\"form-control input-sm\" id=\"input2\" placeholder=\"Small Input\"></div><div class=\"form-group\"><input type=\"text\" class=\"form-control input-lg\" id=\"input4\" placeholder=\"Large Input\"></div></form>");
$templateCache.put("app/pages/form/inputs/widgets/validationStates.html","<div class=\"form-group has-success\"><label class=\"control-label\" for=\"inputSuccess1\">Input with success</label> <input type=\"text\" class=\"form-control\" id=\"inputSuccess1\"></div><div class=\"form-group has-warning\"><label class=\"control-label\" for=\"inputWarning1\">Input with warning</label> <input type=\"text\" class=\"form-control\" id=\"inputWarning1\"></div><div class=\"form-group has-error\"><label class=\"control-label\" for=\"inputError1\">Input with error</label> <input type=\"text\" class=\"form-control\" id=\"inputError1\"></div><div class=\"has-success\"><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\" id=\"checkboxSuccess\" value=\"option1\"> <span>Checkbox with success</span></label></div></div><div class=\"has-warning\"><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\" id=\"checkboxWarning\" value=\"option1\"> <span>Checkbox with warning</span></label></div></div><div class=\"has-error\"><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\" id=\"checkboxError\" value=\"option1\"> <span>Checkbox with error</span></label></div></div><div class=\"form-group has-success has-feedback\"><label class=\"control-label\" for=\"inputSuccess2\">Input with success</label> <input type=\"text\" class=\"form-control\" id=\"inputSuccess2\" aria-describedby=\"inputSuccess2Status\"> <i class=\"ion-checkmark-circled form-control-feedback\" aria-hidden=\"true\"></i> <span id=\"inputSuccess2Status\" class=\"sr-only\">(success)</span></div><div class=\"form-group has-warning has-feedback\"><label class=\"control-label\" for=\"inputWarning2\">Input with warning</label> <input type=\"text\" class=\"form-control\" id=\"inputWarning2\" aria-describedby=\"inputWarning2Status\"> <i class=\"ion-alert-circled form-control-feedback\" aria-hidden=\"true\"></i> <span id=\"inputWarning2Status\" class=\"sr-only\">(warning)</span></div><div class=\"form-group has-error has-feedback\"><label class=\"control-label\" for=\"inputError2\">Input with error</label> <input type=\"text\" class=\"form-control\" id=\"inputError2\" aria-describedby=\"inputError2Status\"> <i class=\"ion-android-cancel form-control-feedback\" aria-hidden=\"true\"></i> <span id=\"inputError2Status\" class=\"sr-only\">(error)</span></div><div class=\"form-group has-success has-feedback\"><label class=\"control-label\" for=\"inputGroupSuccess1\">Input group with success</label><div class=\"input-group\"><span class=\"input-group-addon addon-left\">@</span> <input type=\"text\" class=\"form-control\" id=\"inputGroupSuccess1\" aria-describedby=\"inputGroupSuccess1Status\"></div><i class=\"ion-checkmark-circled form-control-feedback\" aria-hidden=\"true\"></i> <span id=\"inputGroupSuccess1Status\" class=\"sr-only\">(success)</span></div>");
$templateCache.put("app/pages/form/layouts/widgets/basicForm.html","<form><div class=\"form-group\"><label for=\"exampleInputEmail1\">Email address</label> <input type=\"email\" class=\"form-control\" id=\"exampleInputEmail1\" placeholder=\"Email\"></div><div class=\"form-group\"><label for=\"exampleInputPassword1\">Password</label> <input type=\"password\" class=\"form-control\" id=\"exampleInputPassword1\" placeholder=\"Password\"></div><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\"> <span>Check me out</span></label></div><button type=\"submit\" class=\"btn btn-danger\">Submit</button></form>");
$templateCache.put("app/pages/form/layouts/widgets/blockForm.html","<div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputFirstName\">First Name</label> <input type=\"text\" class=\"form-control\" id=\"inputFirstName\" placeholder=\"First Name\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputLastName\">Last Name</label> <input type=\"text\" class=\"form-control\" id=\"inputLastName\" placeholder=\"Last Name\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputFirstName\">Email</label> <input type=\"email\" class=\"form-control\" id=\"inputEmail\" placeholder=\"Email\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label for=\"inputWebsite\">Website</label> <input type=\"text\" class=\"form-control\" id=\"inputWebsite\" placeholder=\"Website\"></div></div></div><button type=\"submit\" class=\"btn btn-primary\">Submit</button>");
$templateCache.put("app/pages/form/layouts/widgets/formWithoutLabels.html","<form><div class=\"form-group\"><input type=\"text\" class=\"form-control\" placeholder=\"Recipients\"></div><div class=\"form-group\"><input type=\"text\" class=\"form-control\" placeholder=\"Subject\"></div><div class=\"form-group\"><textarea class=\"form-control\" placeholder=\"Message\"></textarea></div><button type=\"submit\" class=\"btn btn-success\">Send</button></form>");
$templateCache.put("app/pages/form/layouts/widgets/horizontalForm.html","<form class=\"form-horizontal\"><div class=\"form-group\"><label for=\"inputEmail3\" class=\"col-sm-2 control-label\">Email</label><div class=\"col-sm-10\"><input type=\"email\" class=\"form-control\" id=\"inputEmail3\" placeholder=\"Email\"></div></div><div class=\"form-group\"><label for=\"inputPassword3\" class=\"col-sm-2 control-label\">Password</label><div class=\"col-sm-10\"><input type=\"password\" class=\"form-control\" id=\"inputPassword3\" placeholder=\"Password\"></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-10\"><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\"> <span>Remember me</span></label></div></div></div><div class=\"form-group\"><div class=\"col-sm-offset-2 col-sm-10\"><button type=\"submit\" class=\"btn btn-warning\">Sign in</button></div></div></form>");
$templateCache.put("app/pages/form/layouts/widgets/inlineForm.html","<form class=\"row form-inline\"><div class=\"form-group col-sm-3 col-xs-6\"><input type=\"text\" class=\"form-control\" id=\"exampleInputName2\" placeholder=\"Name\"></div><div class=\"form-group col-sm-3 col-xs-6\"><input type=\"email\" class=\"form-control\" id=\"exampleInputEmail2\" placeholder=\"Email\"></div><div class=\"checkbox\"><label class=\"custom-checkbox\"><input type=\"checkbox\"> <span>Remember me</span></label></div><button type=\"submit\" class=\"btn btn-primary\">Send invitation</button></form>");
$templateCache.put("app/pages/inventario/stockProductos/list/listProductosModal.html","<div class=\"modal-content\"><div class=\"modal-header bg-primary\"><i class=\"ion-information-circled modal-icon\"></i><span>Lista de Productos</span></div><div class=\"modal-body text-center\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th class=\"table-id\" st-sort=\"id\" st-sort-default=\"true\">#</th><th st-sort=\"no_producto\">Codigo</th><th st-sort=\"no_producto\">Producto</th><th st-sort=\"no_atributo\">Categoria</th><th st-sort=\"no_marca\">Marca</th><th st-sort=\"mto_ult_venta_distro\">Precio</th><th st-sort=\"nu_cantidad\">Cantidad</th><th></th></tr><tr><th></th><th><input st-search=\"co_producto\" placeholder=\"Buscar Codigo\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"no_producto\" placeholder=\"Buscar Producto\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"no_categoria\" placeholder=\"Buscar Atributo\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"no_marca\" placeholder=\"Buscar Marca\" class=\"input-sm form-control search-input\" type=\"search\"></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat=\"item in displayed\" ng-if=\"displayed.length>0\"><td class=\"table-id\">{{item.id_producto}}</td><td>{{item.co_producto}}</td><td>{{item.no_producto}}</td><td>{{item.no_categoria}}</td><td>{{item.no_marca}}</td><td>{{item.mto_ult_venta}}</td><td>{{item.nu_cantidad}}</td><td><div class=\"btn-group\" role=\"group\"><button type=\"button\" class=\"btn btn-primary btn-icon\" ng-click=\"obtenerProducto(item)\"><i class=\"ion-plus\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"8\" class=\"text-center bg-primary\" st-pagination=\"\" st-items-by-page=\"5\"></td></tr></tfoot></table></div></div>");
$templateCache.put("app/pages/inventario/stockProductos/list/listProductosModalPos.html","<div class=\"modal-content\"><div class=\"modal-header bg-primary\"><i class=\"ion-information-circled modal-icon\"></i><span>Lista de Productos</span></div><div class=\"modal-body text-center\"><table class=\"table table-striped\" st-pipe=\"callServer2\" st-table=\"displayed2\"><thead><tr class=\"sortable\"><th class=\"table-id\" st-sort=\"id\" st-sort-default=\"true\">#</th><th st-sort=\"no_producto\">Codigo</th><th st-sort=\"no_producto\">Producto</th><th st-sort=\"no_atributo\">Categoria</th><th st-sort=\"no_marca\">Marca</th><th st-sort=\"mto_ult_venta\">Precio</th><th st-sort=\"nu_cantidad\">Stock</th><th></th></tr><tr><th></th><th><input st-search=\"co_producto\" placeholder=\"Buscar Codigo\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"no_producto\" placeholder=\"Buscar Producto\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"no_categoria\" placeholder=\"Buscar Atributo\" class=\"input-sm form-control search-input\" type=\"search\"></th><th><input st-search=\"no_marca\" placeholder=\"Buscar Marca\" class=\"input-sm form-control search-input\" type=\"search\"></th><th></th><th></th><th></th></tr></thead><tbody><tr ng-repeat=\"item in displayed2\" ng-if=\"displayed2.length>0\"><td class=\"table-id\">{{item.id_producto}}</td><td>{{item.co_producto}}</td><td>{{item.no_producto}}</td><td>{{item.no_categoria}}</td><td>{{item.no_marca}}</td><td>{{item.mto_ult_venta}}</td><td>{{item.nu_cantidad}}</td><td><div class=\"btn-group\" role=\"group\"><button type=\"button\" class=\"btn btn-primary btn-icon\" ng-click=\"obtenerProducto(item, displayed.indexOf(item))\"><i class=\"ion-plus\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"8\" class=\"text-center bg-primary\" st-pagination=\"\" st-items-by-page=\"7\"></td></tr></tfoot></table></div></div>");
$templateCache.put("app/pages/inventario/stockProductos/list/stockProductosList.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-sm-12\"><div ba-panel=\"\" ba-panel-title=\"Listado de Productos\" ba-panel-class=\"with-scroll\"><div class=\"col-sm-12\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:5%;\" class=\"table-id\">#</th><th style=\"width:10%;\">Almacen</th><th style=\"width:10%;\">Sucursal</th><th style=\"width:25%;\">Producto</th><th style=\"width:10%;\">Marca</th><th style=\"width:10%;\">Categoria</th><th style=\"width:8%;\">Cantidad</th><th style=\"width:5%;\">Detalle</th></tr><tr><th></th><th><input st-search=\"no_almacen\" class=\"input-sm form-control\" placeholder=\"Busqueda Almacen\" type=\"search\"></th><th><input st-search=\"no_sucursal\" class=\"input-sm form-control\" placeholder=\"Busqueda Sucursal\" type=\"search\"></th><th><input st-search=\"no_producto\" class=\"input-sm form-control\" placeholder=\"Busqueda Producto\" type=\"search\"></th><th><input st-search=\"no_marca\" class=\"input-sm form-control\" placeholder=\"Busqueda Marca\" type=\"search\"></th><th><input st-search=\"no_categoria\" class=\"input-sm form-control\" placeholder=\"Busqueda Categoria\" type=\"search\"></th><th></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_almacen }}</td><td>{{item.no_local }}</td><td>{{item.no_producto }}</td><td>{{item.no_marca }}</td><td>{{item.no_categoria }}</td><td>{{item.nu_cantidad }}</td><td style=\"text-align: center;\"><a class=\"btn btn-xs btn-success\" ui-sref=\"dashboard.almacen.stockProductos-details2({idProducto: item.id_producto})\"><i class=\"ion-images\"></i></a></td></tr></tbody><tfoot><tr><td colspan=\"8\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/inventario/stockProductos/listDetalle/stockProductoDetalle.html","<div class=\"widgets\" ng-init=\"consultar()\"><div class=\"row\"><div class=\"col-sm-12\"><div ba-panel=\"\" ba-panel-title=\"Listado de Detalle Compras\" ba-panel-class=\"with-scroll\"><div class=\"col-sm-12\"><table class=\"table table-striped\" st-table=\"displayed\" st-safe-src=\"detalleCompra\"><thead><tr class=\"sortable\"><th style=\"width:5%;\" class=\"table-id\">#</th><th style=\"width:20%;\">Sucursal</th><th style=\"width:10%;\">Serie</th><th style=\"width:15%;\">Correlativo</th><th style=\"width:10%;\">Fecha</th><th style=\"width:20%;\">Producto</th><th style=\"width:12%;\">Cantidad</th><th style=\"width:12%;\">Precio</th><th style=\"width:15%;\">Total</th><th style=\"width:5%;\">Detalle</th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_local }}</td><td>{{item.nu_serie }}</td><td>{{item.nu_correlativo }}</td><td>{{item.fe_emision }}</td><td>{{item.no_producto }}</td><td>{{item.nu_cantidad | number:2}}</td><td>{{item.nu_precio_unitario | number:2}}</td><td>{{item.nu_total }}</td><td style=\"text-align: center;\"><a class=\"btn btn-xs btn-success\" ng-click=\"openDetalle(\'md\',{{item}}, displayed.indexOf(item))\"><i class=\"ion-navigate text-primary\"></i></a></td></tr></tbody><tfoot><tr><td colspan=\"10\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table><br>&nbsp;&nbsp;&nbsp; <a class=\"btn btn-default\" ui-sref=\"dashboard.almacen.stockProductos\"><i class=\"fa fa-list-alt\"></i> Listado</a></div></div></div></div></div>");
$templateCache.put("app/pages/inventario/stockValorizado/list/stockValorizadoList.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-sm-12\"><div ba-panel=\"\" ba-panel-title=\"Listado de Stock Valorizado\" ba-panel-class=\"with-scroll\"><div class=\"col-sm-12\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:5%;\" class=\"table-id\">#</th><th style=\"width:10%;\">Almacen</th><th style=\"width:10%;\">Sucursal</th><th style=\"width:25%;\">Producto</th><th style=\"width:10%;\">Marca</th><th style=\"width:10%;\">Categoria</th><th style=\"width:8%;\">Cantidad</th><th style=\"width:10%;\">Costo</th></tr><tr><th></th><th><input st-search=\"no_almacen\" class=\"input-sm form-control\" placeholder=\"Busqueda Almacen\" type=\"search\"></th><th><input st-search=\"no_sucursal\" class=\"input-sm form-control\" placeholder=\"Busqueda Sucursal\" type=\"search\"></th><th><input st-search=\"no_producto\" class=\"input-sm form-control\" placeholder=\"Busqueda Producto\" type=\"search\"></th><th><input st-search=\"no_marca\" class=\"input-sm form-control\" placeholder=\"Busqueda Marca\" type=\"search\"></th><th><input st-search=\"no_categoria\" class=\"input-sm form-control\" placeholder=\"Busqueda Categoria\" type=\"search\"></th><th></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_almacen }}</td><td>{{item.no_local }}</td><td>{{item.no_producto }}</td><td>{{item.no_marca }}</td><td>{{item.no_categoria }}</td><td>{{item.nu_cantidad }}</td><td>{{item.nu_precio_unitario | number:2 }}</td></tr></tbody><tfoot><tr><td colspan=\"7\" style=\"text-align:right\">Total:</td><td style=\"text-align:right\">{{data.nu_total | number:2}}</td></tr><tr><td colspan=\"8\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"20\"></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/seguridad/roles/list/rolesList.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Listado de Roles <button type=\'button\' class=\'btn btn-link pull-right\' ng-click=\'agregar()\' ><i class=\'fa fa-plus\'></i> Agregar</button>\" ba-panel-class=\"with-scroll\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:4%;\" class=\"table-id\">#</th><th style=\"width:84%;\">Descripción</th><th style=\"width:12%;\">&nbsp;</th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_rol_sistema}}</td><td><div class=\"btn-group\" role=\"group\"><button class=\"btn btn-xs btn-success\" ng-click=\"editar(item.idrol_sistema)\" title=\"Editar\"><i class=\"fa fa-pencil\"></i></button> <button class=\"btn btn-xs\" ng-class=\"(item.status==\'1\')?\'btn-success\':\'btn-danger\'\" ng-click=\"changeStatus(item.idrol_sistema, item.status, displayed.indexOf(item))\" title=\"Activar/inactivar\"><i class=\"fa\" ng-class=\"(item.status==\'1\')?\'fa-check\':\'fa-ban\'\"></i></button> <button class=\"btn btn-xs btn-danger\" ng-click=\"eliminar(item.idrol_sistema)\"><i class=\"fa fa-trash\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"3\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table></div></div></div></div>");
$templateCache.put("app/pages/seguridad/usuarios/list/usuariosList.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Listado de Usuarios\" ba-panel-class=\"with-scroll\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:4%;\" class=\"table-id\">#</th><th style=\"width:6%;\">Código</th><th style=\"width:35%;\">Empleado</th><th style=\"width:15%;\">Usuario</th><th style=\"width:14%;\">Fecha Ing.</th><th style=\"width:16%;\">Rol</th><th style=\"width:10%;\">&nbsp;</th></tr><tr><th></th><th></th><th><input st-search=\"cod_producto\" class=\"input-sm form-control\" placeholder=\"Busqueda Empleado ...\" type=\"search\"></th><th><input st-search=\"nom_producto\" class=\"input-sm form-control\" placeholder=\"Busqueda Usuario...\" type=\"search\"></th><th></th><th></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.id_empleado}}</td><td>{{item.no_apepat }} {{item.no_apemat}}, {{item.no_nombres}}</td><td>{{item.login}}</td><td>{{item.fec_ingreso | date: \'dd/MM/yyyy\'}}</td><td>{{item.nom_rol}}</td><td><div class=\"btn-group\" role=\"group\"><button class=\"btn btn-xs btn-success\" type=\"button\" title=\"Editar\" ng-click=\"editar(item.idempleado)\"><i class=\"fas fa-pencil-alt\"></i></button> <button class=\"btn btn-xs\" ng-class=\"(item.status==\'1\')?\'btn-success\':\'btn-danger\'\" type=\"button\" title=\"Activar/inactivar\" ng-click=\"changeStatus(item.idempleado, item.status)\" ng-disabled=\"item.idusuario==0\"><i class=\"fa\" ng-class=\"(item.status==\'1\')?\'fa-check\':\'fa-ban\'\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"7\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table></div></div></div></div>");
$templateCache.put("app/pages/sucursal/empresa/list/empresaList.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Listado de Empresas <button type=\'button\' class=\'btn btn-link pull-right\' ng-click=\'agregar()\' ><i class=\'fa fa-plus\'></i></button>\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:5%\" class=\"table-id\" st-sort=\"id\" st-sort-default=\"true\">#</th><th style=\"width:10%\">Ubicacion</th><th style=\"width:10%\">Razón Social</th><th style=\"width:10%\">RUC</th><th style=\"width:20%\">Direccion</th><th style=\"width:5%\">&nbsp;</th></tr><tr><th></th><th></th><th><input st-search=\"no_empresa\" class=\"input-sm form-control\" placeholder=\"Buscar Razón Social\" type=\"search\"></th><th></th><th></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" st-select-mode=\"multiple\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_distrito}}</td><td style=\"overflow: hidden; white-space: nowrap;\">{{item.no_empresa}}</td><td style=\"overflow: hidden; white-space: nowrap;\">{{item.nu_ruc}}</td><td>{{item.no_direccion}}</td><td><div class=\"btn-group\" role=\"group\"><button class=\"btn btn-xs btn-success\" type=\"button\" title=\"Editar\" ng-click=\"editar(item.id_empresa)\"><i class=\"fas fa-pencil-alt\"></i></button> <button class=\"btn btn-xs\" ng-class=\"(item.status==\'1\')?\'btn-success\':\'btn-danger\'\" type=\"button\" title=\"Activar/inactivar\" ng-click=\"changeStatus(item.id_empresa, item.status)\" ng-disabled=\"item.id_empresa==0\"><i class=\"fa\" ng-class=\"(item.status==\'1\')?\'fa-check\':\'fa-ban\'\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"6\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table></div></div></div></div>");
$templateCache.put("app/pages/sucursal/sucursales/list/sucursalesList.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Listado de Sucursal <button type=\'button\' class=\'btn btn-link pull-right\' ng-click=\'agregar()\' ><i class=\'fa fa-plus\'></i></button>\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:5%\" class=\"table-id\" st-sort=\"id\" st-sort-default=\"true\">#</th><th style=\"width:10%\">Ubicacion</th><th style=\"width:10%\">Sucursal</th><th style=\"width:10%\">Alias</th><th style=\"width:10%\">Empresa</th><th style=\"width:5%\">&nbsp;</th></tr><tr><th></th><th></th><th><input st-search=\"no_distrito\" class=\"input-sm form-control\" placeholder=\"Buscar\" type=\"search\"></th><th></th><th></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" st-select-mode=\"multiple\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_distrito}}</td><td style=\"overflow: hidden; white-space: nowrap;\">{{item.no_local}}</td><td style=\"overflow: hidden; white-space: nowrap;\">{{item.no_alias}}</td><td>{{item.no_empresa}}</td><td><div class=\"btn-group\" role=\"group\"><button class=\"btn btn-xs btn-success\" type=\"button\" title=\"Editar\" ng-click=\"editar(item.id_local)\"><i class=\"fas fa-pencil-alt\"></i></button> <button class=\"btn btn-xs\" ng-class=\"(item.status==\'1\')?\'btn-success\':\'btn-danger\'\" type=\"button\" title=\"Activar/inactivar\" ng-click=\"changeStatus(item.id_local, item.status)\" ng-disabled=\"item.id_empresa==0\"><i class=\"fa\" ng-class=\"(item.status==\'1\')?\'fa-check\':\'fa-ban\'\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"6\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table></div></div></div></div>");
$templateCache.put("app/pages/ui/buttons/widgets/buttonGroups.html","<div class=\"btn-group-example\"><div class=\"btn-group\" role=\"group\" aria-label=\"Basic example\"><button type=\"button\" class=\"btn btn-danger\">Left</button> <button type=\"button\" class=\"btn btn-danger\">Middle</button> <button type=\"button\" class=\"btn btn-danger\">Right</button></div></div><div class=\"btn-toolbar-example\"><div class=\"btn-toolbar\" role=\"toolbar\" aria-label=\"Toolbar with button groups\"><div class=\"btn-group\" role=\"group\" aria-label=\"First group\"><button type=\"button\" class=\"btn btn-primary\">1</button> <button type=\"button\" class=\"btn btn-primary\">2</button> <button type=\"button\" class=\"btn btn-primary\">3</button> <button type=\"button\" class=\"btn btn-primary\">4</button></div><div class=\"btn-group\" role=\"group\" aria-label=\"Second group\"><button type=\"button\" class=\"btn btn-primary\">5</button> <button type=\"button\" class=\"btn btn-primary\">6</button> <button type=\"button\" class=\"btn btn-primary\">7</button></div><div class=\"btn-group\" role=\"group\" aria-label=\"Third group\"><button type=\"button\" class=\"btn btn-primary\">8</button></div></div></div>");
$templateCache.put("app/pages/ui/buttons/widgets/buttons.html","<div class=\"basic-btns\"><div class=\"row\"><div class=\"col-md-2\"><h5>Default button</h5></div><div class=\"col-md-10\"><div class=\"row btns-row btns-same-width-md\"><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-primary\">Primary</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-default\">Default</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-success\">Success</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-info\">Info</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-warning\">Warning</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-danger\">Danger</button></div></div></div></div><div class=\"row\"><div class=\"col-md-2\"><h5 class=\"row-sm\">Small button</h5></div><div class=\"col-md-10\"><div class=\"row btns-row btns-same-width-md\"><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-primary btn-sm\">Primary</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-default btn-sm\">Default</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-success btn-sm\">Success</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-info btn-sm\">Info</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-warning btn-sm\">Warning</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-danger btn-sm\">Danger</button></div></div></div></div><div class=\"row\"><div class=\"col-md-2\"><h5 class=\"row-xs\">Extra small button</h5></div><div class=\"col-md-10\"><div class=\"row btns-row btns-same-width-md\"><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-primary btn-xs\">Primary</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-default btn-xs\">Default</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-success btn-xs\">Success</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-info btn-xs\">Info</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-warning btn-xs\">Warning</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-danger btn-xs\">Danger</button></div></div></div></div><div class=\"row\"><div class=\"col-md-2\"><h5>Disabled button</h5></div><div class=\"col-md-10\"><div class=\"row btns-row btns-same-width-md\"><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-primary\" disabled=\"disabled\">Primary</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-default\" disabled=\"disabled\">Default</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-success\" disabled=\"disabled\">Success</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-info\" disabled=\"disabled\">Info</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-warning\" disabled=\"disabled\">Warning</button></div><div class=\"col-sm-2 col-xs-4\"><button type=\"button\" class=\"btn btn-danger\" disabled=\"disabled\">Danger</button></div></div></div></div></div>");
$templateCache.put("app/pages/ui/buttons/widgets/dropdowns.html","<div class=\"row btns-row\"><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-primary\" uib-dropdown-toggle=\"\">Primary <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-success\" uib-dropdown-toggle=\"\">Success <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-info\" uib-dropdown-toggle=\"\">Info <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle=\"\">Default <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-warning\" uib-dropdown-toggle=\"\">Warning <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-danger\" uib-dropdown-toggle=\"\">Danger <span class=\"caret\"></span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div></div><h5 class=\"panel-subtitle\">Split button dropdowns</h5><div class=\"row btns-row\"><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-primary\">Primary</button> <button type=\"button\" class=\"btn btn-primary\" uib-dropdown-toggle=\"\"><span class=\"caret\"></span> <span class=\"sr-only\">Toggle Dropdown</span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-success\">Success</button> <button type=\"button\" class=\"btn btn-success\" uib-dropdown-toggle=\"\"><span class=\"caret\"></span> <span class=\"sr-only\">Toggle Dropdown</span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-info\">Info</button> <button type=\"button\" class=\"btn btn-info\" uib-dropdown-toggle=\"\"><span class=\"caret\"></span> <span class=\"sr-only\">Toggle Dropdown</span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-default\">Default</button> <button type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle=\"\"><span class=\"caret\"></span> <span class=\"sr-only\">Toggle Dropdown</span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-warning\">Warning</button> <button type=\"button\" class=\"btn btn-warning\" uib-dropdown-toggle=\"\"><span class=\"caret\"></span> <span class=\"sr-only\">Toggle Dropdown</span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div><div class=\"col-sm-4 col-xs-6\"><div class=\"btn-group\" uib-dropdown=\"\" dropdown-append-to-body=\"\"><button type=\"button\" class=\"btn btn-danger\">Danger</button> <button type=\"button\" class=\"btn btn-danger\" uib-dropdown-toggle=\"\"><span class=\"caret\"></span> <span class=\"sr-only\">Toggle Dropdown</span></button><ul uib-dropdown-menu=\"\"><li><a href=\"\">Action</a></li><li><a href=\"\">Another action</a></li><li><a href=\"\">Something else here</a></li><li role=\"separator\" class=\"divider\"></li><li><a href=\"\">Separated link</a></li></ul></div></div></div>");
$templateCache.put("app/pages/ui/buttons/widgets/iconButtons.html","<ul class=\"btn-list clearfix\"><li><button type=\"button\" class=\"btn btn-primary btn-icon\"><i class=\"ion-android-download\"></i></button></li><li><button type=\"button\" class=\"btn btn-default btn-icon\"><i class=\"ion-stats-bars\"></i></button></li><li><button type=\"button\" class=\"btn btn-success btn-icon\"><i class=\"ion-android-checkmark-circle\"></i></button></li><li><button type=\"button\" class=\"btn btn-info btn-icon\"><i class=\"ion-information\"></i></button></li><li><button type=\"button\" class=\"btn btn-warning btn-icon\"><i class=\"ion-android-warning\"></i></button></li><li><button type=\"button\" class=\"btn btn-danger btn-icon\"><i class=\"ion-nuclear\"></i></button></li></ul><h5 class=\"panel-subtitle\">Buttons with icons</h5><ul class=\"btn-list clearfix\"><li><button type=\"button\" class=\"btn btn-primary btn-with-icon\"><i class=\"ion-android-download\"></i>Primary</button></li><li><button type=\"button\" class=\"btn btn-default btn-with-icon\"><i class=\"ion-stats-bars\"></i>Default</button></li><li><button type=\"button\" class=\"btn btn-success btn-with-icon\"><i class=\"ion-android-checkmark-circle\"></i>Success</button></li><li><button type=\"button\" class=\"btn btn-info btn-with-icon\"><i class=\"ion-information\"></i>Info</button></li><li><button type=\"button\" class=\"btn btn-warning btn-with-icon\"><i class=\"ion-android-warning\"></i>Warning</button></li><li><button type=\"button\" class=\"btn btn-danger btn-with-icon\"><i class=\"ion-nuclear\"></i>Danger</button></li></ul>");
$templateCache.put("app/pages/ui/buttons/widgets/largeButtons.html","<div class=\"row btns-row btns-same-width-lg\"><div class=\"col-sm-4 col-xs-6\"><button type=\"button\" class=\"btn btn-primary btn-lg\">Primary</button></div><div class=\"col-sm-4 col-xs-6\"><button type=\"button\" class=\"btn btn-success btn-lg\">Success</button></div><div class=\"col-sm-4 col-xs-6\"><button type=\"button\" class=\"btn btn-info btn-lg\">Info</button></div><div class=\"col-sm-4 col-xs-6\"><button type=\"button\" class=\"btn btn-default btn-lg\">Default</button></div><div class=\"col-sm-4 col-xs-6\"><button type=\"button\" class=\"btn btn-warning btn-lg\">Warning</button></div><div class=\"col-sm-4 col-xs-6\"><button type=\"button\" class=\"btn btn-danger btn-lg\">Danger</button></div></div>");
$templateCache.put("app/pages/ui/buttons/widgets/progressButtons.html","<div class=\"progress-buttons-container text-center default-text\"><div class=\"row\"><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">fill horizontal</span> <button progress-button=\"progressFunction()\" class=\"btn btn-success\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">fill vertical</span> <button progress-button=\"progressFunction()\" pb-direction=\"vertical\" class=\"btn btn-danger\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">shrink horizontal</span> <button progress-button=\"progressFunction()\" pb-style=\"shrink\" class=\"btn btn-warning\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">shrink vertical</span> <button progress-button=\"progressFunction()\" pb-style=\"shrink\" pb-direction=\"vertical\" class=\"btn btn-info\">Submit</button></section></div><div class=\"row\"><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">rotate-angle-bottom<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"rotate-angle-bottom\" class=\"btn btn-success\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">rotate-angle-top<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"rotate-angle-top\" class=\"btn btn-danger\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">rotate-angle-left<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"rotate-angle-left\" class=\"btn btn-warning\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">rotate-angle-right<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"rotate-angle-right\" class=\"btn btn-info\">Submit</button></section></div><div class=\"row\"><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">rotate-side-down<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"rotate-side-down\" class=\"btn btn-success\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">rotate-side-up<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"rotate-side-up\" class=\"btn btn-danger\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">rotate-side-left<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"rotate-side-left\" class=\"btn btn-warning\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">rotate-side-right<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"rotate-side-right\" class=\"btn btn-info\">Submit</button></section></div><div class=\"row\"><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">rotate-back<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"rotate-back\" class=\"btn btn-success\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">flip-open<br>perspective</span> <button progress-button=\"progressFunction()\" pb-style=\"flip-open\" class=\"btn btn-danger\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">slide-down<br>horizontal</span> <button progress-button=\"progressFunction()\" pb-style=\"slide-down\" class=\"btn btn-warning\">Submit</button></section><section class=\"col-md-6 col-lg-3\"><span class=\"button-title\">move-up<br>horizontal</span> <button progress-button=\"progressFunction()\" pb-style=\"move-up\" class=\"btn btn-info\">Submit</button></section></div><div class=\"row\"><section class=\"col-md-6\"><span class=\"button-title\">top-line<br>horizontal</span> <button progress-button=\"progressFunction()\" pb-style=\"top-line\" class=\"btn btn-success\">Submit</button></section><section class=\"col-md-6\"><span class=\"button-title\">lateral-lines<br>vertical</span> <button progress-button=\"progressFunction()\" pb-style=\"lateral-lines\" class=\"btn btn-info\">Submit</button></section></div></div>");
$templateCache.put("app/pages/ui/icons/widgets/fontAwesomeIcons.html","<div class=\"row icons-list success awesomeIcons\"><div class=\"col-xs-2\" ng-repeat=\"icon in icons.fontAwesomeIcons\"><i class=\"fa {{icon}}\"></i></div></div><a href=\"http://fortawesome.github.io/Font-Awesome/icons/\" target=\"_blank\" class=\"see-all-icons\">See all Font Awesome icons</a>");
$templateCache.put("app/pages/ui/icons/widgets/ionicons.html","<div class=\"row icons-list primary\"><div class=\"col-xs-2\" ng-repeat=\"icon in icons.ionicons\"><i class=\"{{icon}}\"></i></div></div><a href=\"http://ionicons.com/\" target=\"_blank\" class=\"see-all-icons\">See all ionicons icons</a>");
$templateCache.put("app/pages/ui/icons/widgets/kameleon.html","<div class=\"row clearfix\"><div class=\"kameleon-row\" ng-repeat=\"icon in icons.kameleonIcons\"><div class=\"kameleon-icon\"><img ng-src=\"{{:: (icon.img | kameleonImg )}}\"><span>{{icon.name}}</span></div></div></div><a href=\"http://www.kameleon.pics/\" target=\"_blank\" class=\"see-all-icons\">See all Kamaleon icons</a>");
$templateCache.put("app/pages/ui/icons/widgets/kameleonRounded.html","<div class=\"row clearfix\"><div class=\"kameleon-row\" ng-repeat=\"icon in icons.kameleonRoundedIcons\"><div class=\"kameleon-icon with-round-bg {{icon.color}}\"><img ng-src=\"{{::( icon.img | kameleonImg )}}\"><span>{{ icon.name }}</span></div></div></div><a href=\"http://www.kameleon.pics/\" target=\"_blank\" class=\"see-all-icons\">See all Kamaleon icons</a>");
$templateCache.put("app/pages/ui/icons/widgets/socicon.html","<div class=\"row icons-list danger\"><div class=\"col-xs-2\" ng-repeat=\"icon in icons.socicon\"><i class=\"socicon\">{{ icon }}</i></div></div><a href=\"http://www.socicon.com/chart.php\" target=\"_blank\" class=\"see-all-icons\">See all Socicon icons</a>");
$templateCache.put("app/pages/ui/modals/modalTemplates/basicModal.html","<div class=\"modal-content\" style=\"width:620px; height:620px ;\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\" id=\"myModalLabel\">Consultar Informaciòn</h4></div><div class=\"modal-body\"><iframe src=\"https://www2.sbs.gob.pe/afiliados/paginas/Consulta.aspx\" width=\"600\" height=\"520\" align=\"center\" style=\"border: 0ch\"></iframe></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"$dismiss()\">Save changes</button></div></div>");
$templateCache.put("app/pages/ui/modals/modalTemplates/dangerModal.html","<div class=\"modal-content\"><div class=\"modal-header bg-danger\"><i class=\"ion-flame modal-icon\"></i><span>Error</span></div><div class=\"modal-body text-center\">Your information hasn\'t been saved!</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">OK</button></div></div>");
$templateCache.put("app/pages/ui/modals/modalTemplates/infoModal.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><i class=\"ion-information-circled modal-icon\"></i><span>Information</span></div><div class=\"modal-body text-center\">You\'ve got a new email!</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-info\" ng-click=\"$dismiss()\">OK</button></div></div>");
$templateCache.put("app/pages/ui/modals/modalTemplates/largeModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\">Asignacion Remuneraciones</h4></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"panel panel-info contextual-example-panel bootstrap-panel\"><div class=\"panel-heading\">Informaciòn del Personal</div><div class=\"panel-body\"><div class=\"row\"><div class=\"col-sm-4\">Cod: 635</div><div class=\"col-sm-4\">Apellido Paterno: Villegas</div><div class=\"col-sm-4\">Apellido Materno: Ramirez</div></div><br><div class=\"row\"><div class=\"col-sm-4\">Nombres: Ali Jonas Ramirez</div><div class=\"col-sm-4\">Area: Systemas</div><div class=\"col-sm-4\">Status: Activo</div></div></div></div></div></div><div class=\"row\"><div class=\"col-md-8\"><div class=\"panel panel-info bootstrap-panel\"><div class=\"panel-heading\"><h3 class=\"panel-title\">Remuneraciones</h3></div><div class=\"panel-body\"><div class=\"horizontal-scroll\"><table class=\"table table-hover\"><thead><tr class=\"black-muted-bg\"><th class=\"browser-icons\"></th><th>Browser</th><th class=\"align-right\">Visits</th><th class=\"table-arr\"></th><th class=\"align-right\">Purchases</th><th class=\"table-arr\"></th><th class=\"align-right\">%</th><th class=\"table-arr\"></th></tr></thead><tbody><tr ng-repeat=\"item in metricsTableData\" class=\"no-top-border\"><td><img ng-src=\"{{::( item.image | appImage )}}\" width=\"20\" height=\"20\"></td><td ng-class=\"nowrap\">{{item.browser}}</td><td class=\"align-right\">{{item.visits}}</td><td class=\"table-arr\"><i ng-class=\"{\'icon-up\': item.isVisitsUp, \'icon-down\': !item.isVisitsUp }\"></i></td><td class=\"align-right\">{{item.purchases}}</td><td class=\"table-arr\"><i ng-class=\"{\'icon-up\': item.isPurchasesUp, \'icon-down\': !item.isPurchasesUp }\"></i></td><td class=\"align-right\">{{item.percent}}</td><td class=\"table-arr\"><i ng-class=\"{\'icon-up\': item.isPercentUp, \'icon-down\': !item.isPercentUp }\"></i></td></tr></tbody></table></div></div></div></div><div class=\"col-md-4\"><div class=\"panel panel-info bootstrap-panel\"><div class=\"panel-heading\"><h3 class=\"panel-title\">Totales</h3></div><div class=\"panel-body\"></div></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"\">Guardar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"\">Generar</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">Salir</button></div></div>");
$templateCache.put("app/pages/ui/modals/modalTemplates/smallModal.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" ng-click=\"$dismiss()\" aria-label=\"Close\"><em class=\"ion-ios-close-empty sn-link-close\"></em></button><h4 class=\"modal-title\">Modal title</h4></div><div class=\"modal-body\">Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat.</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"$dismiss()\">Save changes</button></div></div>");
$templateCache.put("app/pages/ui/modals/modalTemplates/successModal.html","<div class=\"modal-content\"><div class=\"modal-header bg-success\"><i class=\"ion-checkmark modal-icon\"></i><span>Success</span></div><div class=\"modal-body text-center\">Your information has been saved successfully</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"$dismiss()\">OK</button></div></div>");
$templateCache.put("app/pages/ui/modals/modalTemplates/warningModal.html","<div class=\"modal-content\"><div class=\"modal-header bg-warning\"><i class=\"ion-android-warning modal-icon\"></i><span>Warning</span></div><div class=\"modal-body text-center\">Your computer is about to explode!</div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-warning\" ng-click=\"$dismiss()\">OK</button></div></div>");
$templateCache.put("app/pages/ui/modals/notifications/notifications.html","<div class=\"modal-buttons same-width clearfix\" ng-controller=\"NotificationsCtrl\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"showSuccessMsg()\">Success Notification</button> <button type=\"button\" class=\"btn btn-info\" ng-click=\"showInfoMsg()\">Info Notification</button> <button type=\"button\" class=\"btn btn-warning\" ng-click=\"showWarningMsg()\">Warning Notification</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"showErrorMsg()\">Danger Notification</button></div>");
$templateCache.put("app/pages/ui/progressBars/widgets/animated.html","<div class=\"progress\"><div class=\"progress-bar progress-bar-success progress-bar-striped active\" role=\"progressbar\" aria-valuenow=\"40\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 40%\"><span class=\"sr-only\">40% Complete (success)</span></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-info progress-bar-striped active\" role=\"progressbar\" aria-valuenow=\"20\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 20%\"><span class=\"sr-only\">20% Complete</span></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-warning progress-bar-striped active\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 60%\"><span class=\"sr-only\">60% Complete (warning)</span></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-danger progress-bar-striped active\" role=\"progressbar\" aria-valuenow=\"80\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 80%\"><span class=\"sr-only\">80% Complete (danger)</span></div></div>");
$templateCache.put("app/pages/ui/progressBars/widgets/basic.html","<div class=\"progress\"><div class=\"progress-bar progress-bar-success\" role=\"progressbar\" aria-valuenow=\"40\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 40%\"><span class=\"sr-only\">40% Complete (success)</span></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"20\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 20%\"><span class=\"sr-only\">20% Complete</span></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-warning\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 60%\"><span class=\"sr-only\">60% Complete (warning)</span></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-danger\" role=\"progressbar\" aria-valuenow=\"80\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 80%\"><span class=\"sr-only\">80% Complete (danger)</span></div></div>");
$templateCache.put("app/pages/ui/progressBars/widgets/label.html","<div class=\"progress\"><div class=\"progress-bar progress-bar-success\" role=\"progressbar\" aria-valuenow=\"40\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 40%\">40% Complete (success)</div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-info\" role=\"progressbar\" aria-valuenow=\"20\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 20%\">20% Complete</div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-warning\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 60%\">60% Complete (warning)</div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-danger\" role=\"progressbar\" aria-valuenow=\"80\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 80%\">80% Complete (danger)</div></div>");
$templateCache.put("app/pages/ui/progressBars/widgets/stacked.html","<div class=\"progress\"><div class=\"progress-bar progress-bar-success\" style=\"width: 35%\"><span class=\"sr-only\">35% Complete (success)</span></div><div class=\"progress-bar progress-bar-warning progress-bar-striped\" style=\"width: 20%\"><span class=\"sr-only\">20% Complete (warning)</span></div><div class=\"progress-bar progress-bar-danger\" style=\"width: 10%\"><span class=\"sr-only\">10% Complete (danger)</span></div><div class=\"progress-bar progress-bar-info progress-bar-striped active\" style=\"width: 20%\"><span class=\"sr-only\">20% Complete (warning)</span></div></div>");
$templateCache.put("app/pages/ui/progressBars/widgets/striped.html","<div class=\"progress\"><div class=\"progress-bar progress-bar-success progress-bar-striped\" role=\"progressbar\" aria-valuenow=\"40\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 40%\"><span class=\"sr-only\">40% Complete (success)</span></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-info progress-bar-striped\" role=\"progressbar\" aria-valuenow=\"20\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 20%\"><span class=\"sr-only\">20% Complete</span></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-warning progress-bar-striped\" role=\"progressbar\" aria-valuenow=\"60\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 60%\"><span class=\"sr-only\">60% Complete (warning)</span></div></div><div class=\"progress\"><div class=\"progress-bar progress-bar-danger progress-bar-striped\" role=\"progressbar\" aria-valuenow=\"80\" aria-valuemin=\"0\" aria-valuemax=\"100\" style=\"width: 80%\"><span class=\"sr-only\">80% Complete (danger)</span></div></div>");
$templateCache.put("app/pages/ventas/caja/list/cajaList.html","<div class=\"widgets\" ng-init=\"consultar()\"><div class=\"row\"><div ba-panel=\"\" ba-panel-title=\"Listado de Caja<i ng-click=\'agregarCaja(lg)\' class=\'fa pull-right fa-plus\' style=\' cursor: pointer;\'></i>\" ba-panel-class=\"with-scroll\"><div class=\"form-group\"><div class=\"col-sm-12\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:4%;\" class=\"table-id\">#</th><th style=\"width:15%;\">Sucursal</th><th style=\"width:20%;\">Usuario</th><th style=\"width:10%;\">Fecha</th><th style=\"width:10%;\">Hora Inicio</th><th style=\"width:10%;\">Hora Final</th><th style=\"width:10%;\">Caja Inicial</th><th style=\"width:10%;\">&nbsp;</th></tr><tr><th></th><th><input st-search=\"no_local\" class=\"input-sm form-control\" placeholder=\"Busqueda Sucursal ...\" type=\"search\"></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_local }}</td><td>{{item.no_empleado }}</td><td>{{item.fe_caja | date:\'dd-MM-yyyy\' }}</td><td>{{item.ho_inicio }}</td><td>{{item.ho_final }}</td><td>{{item.va_inicio | number:2 }}</td><td><div class=\"btn-group\" role=\"group\"><button ng-if=\"item.bloqueo\" class=\"btn btn-xs {{item.color}}\" type=\"button\" title=\"{{item.titulo}}\" ng-click=\"cierreCaja(item)\"><i class=\"ion-unlocked\"></i></button> <button class=\"btn btn-xs btn-success\" type=\"button\" title=\"Imprimir\" ng-click=\"getCierre(item.id_caja)\"><i class=\"fas fa-print\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"8\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/ventas/cotizacion/list/cotizacionList.html","<div class=\"widgets\"><div class=\"row\"><div ba-panel=\"\" ba-panel-title=\"Listado de Cotizaciones<i ng-click=\'agregar()\' class=\'fa pull-right fa-plus\' style=\' cursor: pointer;\'></i>\" ba-panel-class=\"with-scroll\"><div class=\"form-group\"><div class=\"col-sm-12\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:4%;\" class=\"table-id\">#</th><th style=\"width:10%;\">Serie</th><th style=\"width:10%;\">Correlativo</th><th style=\"width:15%;\">Cliente</th><th style=\"width:6%;\">Fecha</th><th style=\"width:6%;\">Total</th><th style=\"width:5%;\">&nbsp;</th></tr><tr><th></th><th><input st-search=\"no_cliente\" class=\"input-sm form-control\" placeholder=\"Busqueda cliente ...\" type=\"search\"></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.nu_serie }}</td><td>{{item.nu_correlativo}}</td><td>{{item.no_cliente }}</td><td>{{item.fe_emision | date:\'dd-MM-yyyy\' }}</td><td>{{item.nu_total }}</td><td><div class=\"text-center btn-group\" role=\"group\" style=\"background: black;\"><button type=\"button\" title=\"Editar\" ng-disabled=\"{{item.il_editable == 0}}\" class=\"btn btn-default btn-icon\" ui-sref=\"dashboard.venta.cotizacion-details({idcotizacion: item.id_cotizacion})\"><i class=\"ion-edit text-primary\"></i></button> <button type=\"button\" title=\"Archivo Pdf\" data-toggle=\"popover\" class=\"btn btn-default btn-icon\" ng-disabled=\"\" ng-click=\"openPdf(\'lg\',item)\"><i class=\"ion-clipboard text-primary\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"7\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/ventas/cotizacion/modal/modalPdf.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><i class=\"ion-information-circled modal-icon\"></i><span>Control de Acciòn</span></div><div class=\"modal-body text-left\"><div class=\"col-md-12\">Precione Confirmar Para Visualizar La {{item.no_tipo_comprobante}} {{item.nu_serie}}-{{item.nu_correlativo}}</div></div><div class=\"modal-footer\"><form action=\"{{archivo}}\" method=\"POST\" target=\"_blank\"><input type=\"hidden\" name=\"item\" value=\"{{item}}\"> <input type=\"hidden\" name=\"oper\" value=\"rpt_boleta\"> <button type=\"submit\" class=\"btn btn-info\" ng-click=\"pdf({{item}})\"><i class=\"fa fa-print fa-fw\"></i> Generar</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">Cancelar</button></form></div></div>");
$templateCache.put("app/pages/ventas/gastos/list/gastosList.html","<div class=\"widgets\"><div class=\"row\"><div class=\"col-md-12\"><div ba-panel=\"\" ba-panel-title=\"Listado de Gastos <button type=\'button\' class=\'btn btn-link pull-right\' ng-click=\'agregar()\' ><i class=\'fa fa-plus\'></i></button>\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:5%\" class=\"table-id\" st-sort=\"id\" st-sort-default=\"true\">#</th><th style=\"width:10%\">Tipo Gasto</th><th style=\"width:10%\">T. Comprobante</th><th style=\"width:10%\">Gasto</th><th style=\"width:15%\">Fecha</th><th style=\"width:10%\">Total</th><th style=\"width:10%\">&nbsp;</th></tr><tr><th></th><th></th><th></th><th><input st-search=\"no_gasto\" class=\"input-sm form-control\" placeholder=\"Buscar Gasto\" type=\"search\"></th><th></th><th></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" st-select-mode=\"multiple\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_tipo_gasto}}</td><td>{{item.no_tipo_comprobante}}</td><td>{{item.no_gasto}}</td><td>{{item.fe_emision| date:\'dd-MM-yyyy\' }}</td><td>{{item.va_total}}</td><td><div class=\"btn-group\" role=\"group\"><button class=\"btn btn-xs btn-default\" popover-trigger=\"mouseenter\" uib-popover=\"{{item.no_empleado}}\"><i class=\"fa fa-user-alt\"></i></button> <button class=\"btn btn-xs btn-default\" popover-trigger=\"mouseenter\" uib-popover=\"{{item.no_local}}\"><i class=\"fa fa-house-damage\"></i></button> <button class=\"btn btn-xs btn-success\" type=\"button\" title=\"Editar\" ng-click=\"editar(item.id_gasto)\"><i class=\"fas fa-pencil-alt\"></i></button> <button class=\"btn btn-xs btn-danger\" title=\"Eliminar\" ng-click=\"eliminar(item.id_gasto, displayed.indexOf(item))\"><i class=\"ion-trash-a\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"7\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table></div></div></div></div>");
$templateCache.put("app/pages/ventas/pos/list/posList.html","<div class=\"widgets\" ng-init=\"consultar()\"><div class=\"row\"><div ba-panel-title=\"TOTAL VENTAS\" ba-panel=\"\" ba-panel-class=\"with-scroll\" class=\"col-md-6 col-lg-6\"><div class=\"col-md-6\"><h1 class=\"al-title ng-binding\"><i class=\"fas fa-thumbs-up\"></i> {{data.nu_ventas}}</h1></div></div><div ba-panel-title=\"TOTAL INGRESOS\" ba-panel=\"\" ba-panel-class=\"with-scroll\" class=\"col-md-6 col-lg-6\"><div class=\"col-md-6\"><h1 class=\"al-title ng-binding\"><i class=\"fas fa-coins\"></i> S/{{data.nu_total}}</h1></div></div></div><div class=\"row\"><div ba-panel=\"\" ba-panel-title=\"Listado de Ventas<i ng-click=\'agregar()\' class=\'fa pull-right fa-plus\' style=\' cursor: pointer;\'></i>\" ba-panel-class=\"with-scroll\"><div class=\"form-group\"><div class=\"col-sm-12\"><table class=\"table table-striped\" st-pipe=\"callServer\" st-table=\"displayed\"><thead><tr class=\"sortable\"><th style=\"width:4%;\" class=\"table-id\">#</th><th style=\"width:10%;\">Cliente</th><th style=\"width:6%;\">F. Venta</th><th style=\"width:6%;\">Recibo</th><th style=\"width:6%;\">N° Venta</th><th style=\"width:6%;\">Total</th><th style=\"width:6%;\">Estado</th><th style=\"width:6%;\">SUNAT</th><th style=\"width:10%;\">&nbsp;</th></tr><tr><th></th><th><input st-search=\"no_cliente\" class=\"input-sm form-control\" placeholder=\"Busqueda cliente ...\" type=\"search\"></th><th></th><th></th><th></th><th></th><th></th><th></th><th></th></tr></thead><tbody><tr st-select-row=\"row\" ng-repeat=\"item in displayed\"><td class=\"table-id\" style=\"text-align: right;\">{{item.item}}</td><td>{{item.no_cliente }}</td><td>{{item.fe_emision | date:\'dd-MM-yyyy\' }}</td><td>{{item.no_tipo_comprobante }}</td><td>{{item.numero_comprobante }}</td><td>{{item.mto_total }}</td><td><button class=\"status-button btn btn-xs\" style=\"width: 90% !important;\" ng-class=\"{\'btn-warning\': (item.no_estado==\'GENERADO\') , \'btn-success\':(item.no_estado==\'VALIDO\'), \'btn-danger\': (item.no_estado==\'ANULADO\')}\"><i class=\"ion-navigate\"></i> {{item.no_estado}}</button></td><td><button class=\"status-button btn btn-xs\" style=\"width: 90% !important;\" ng-class=\"{\'btn-warning\': (item.no_estado_sunat==\'RESUMEN\') ,\'btn-danger\':(item.no_estado_sunat==\'NO ENVIADO\'), \'btn-info\': (item.no_estado_sunat==\'ENVIADO\')}\"><i class=\"ion-clock\"></i> {{item.no_estado_sunat}}</button></td><td><div class=\"text-center btn-group\" role=\"group\" style=\"background: black;\"><button type=\"button\" title=\"Archivo Pdf\" data-toggle=\"popover\" class=\"btn btn-default btn-icon\" ng-disabled=\"\" ng-click=\"openPdfBoleta(\'lg\',item)\"><i class=\"ion-clipboard text-primary\"></i></button> <button type=\"button\" title=\"Enviar Correo\" data-toggle=\"popover\" class=\"btn btn-default btn-icon\" ng-disabled=\"\" ng-click=\"openCorreo(\'lg\',{{item}})\"><i class=\"ion-link text-success\"></i></button></div></td></tr></tbody><tfoot><tr><td colspan=\"9\" class=\"text-center\" st-pagination=\"\" st-items-by-page=\"10\"></td></tr></tfoot></table></div></div></div></div></div>");
$templateCache.put("app/pages/ventas/pos/modal/modalPdf.html","<div class=\"modal-content\"><div class=\"modal-header bg-info\"><i class=\"ion-information-circled modal-icon\"></i><span>Control de Acciòn</span></div><div class=\"modal-body text-left\"><div class=\"col-md-12\">Precione Confirmar Para Visualizar La {{item.no_tipo_comprobante}} {{item.nu_serie}}-{{item.nu_correlativo}}</div></div><div class=\"modal-footer\"><form action=\"{{archivo}}\" method=\"POST\" target=\"_blank\"><input type=\"hidden\" name=\"item\" value=\"{{item}}\"> <input type=\"hidden\" name=\"oper\" value=\"rpt_boleta\"> <button type=\"submit\" class=\"btn btn-info\" ng-click=\"pdf({{item}})\"><i class=\"fa fa-print fa-fw\"></i> Generar</button> <button type=\"button\" class=\"btn btn-danger\" ng-click=\"$dismiss()\">Cancelar</button></form></div></div>");
$templateCache.put("app/pages/form/inputs/widgets/datePickers/datePickers.html","<div class=\"datepicker row\"><div class=\"col-xlg-6 col-md-12 col-sm-6\" ng-controller=\"datepickerCtrl\"><h4>Inline</h4><label>Selected date is: <em>{{dt | date:\'fullDate\' }}</em></label><div class=\"uib-datepicker-wrap\"><uib-datepicker ng-model=\"dt\" datepicker-options=\"options\"></uib-datepicker></div></div><div class=\"col-xlg-6 col-md-12 col-sm-6\" ng-controller=\"datepickerpopupCtrl\"><h4>Popup</h4><label>Selected date is: <em>{{dt | date:\'fullDate\' }}</em></label><p class=\"input-group\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"{{format}}\" datepicker-options=\"options\" ng-model=\"dt\" is-open=\"opened\" ng-required=\"true\" close-text=\"Close\" alt-input-formats=\"altInputFormats\" show-button-bar=\"false\"> <span class=\"input-group-btn\"><button type=\"button\" class=\"btn btn-default\" ng-click=\"open()\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p><label>Format: <span class=\"muted-text\">(manual alternate <em>{{altInputFormats[0]}}</em>)</span></label><select class=\"form-control\" ng-model=\"format\" ng-options=\"f for f in formats\"><option></option></select></div></div>");
$templateCache.put("app/pages/form/inputs/widgets/oldSwitches/switch.html","<div class=\"switches clearfix\"><switch color=\"primary\"></switch><switch color=\"warning\"></switch><switch color=\"danger\"></switch></div>");
$templateCache.put("app/pages/form/inputs/widgets/select/select.html","<div ng-controller=\"SelectpickerPanelCtrl as selectpickerVm\"><div class=\"form-group\"><select class=\"form-control selectpicker\" selectpicker=\"\" title=\"Standard Select\" ng-model=\"selectpickerVm.standardSelected\" ng-options=\"item as item.label for item in selectpickerVm.standardSelectItems\"></select></div><div class=\"form-group\"><select class=\"form-control selectpicker with-search\" data-live-search=\"true\" title=\"Select With Search\" selectpicker=\"\" ng-model=\"selectpickerVm.searchSelectedItem\" ng-options=\"item as item.label for item in selectpickerVm.selectWithSearchItems\"></select></div><div class=\"form-group\"><select class=\"form-control selectpicker\" title=\"Option Types\" selectpicker=\"\"><option>Standard option</option><option data-subtext=\"option subtext\">Option with subtext</option><option disabled=\"\">Disabled Option</option><option data-icon=\"glyphicon-heart\">Option with cion</option></select></div><div class=\"form-group\"><select class=\"form-control selectpicker\" disabled=\"\" title=\"Disabled Select\" selectpicker=\"\"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><select class=\"form-control\" title=\"Select with Option Groups\" selectpicker=\"\" ng-model=\"selectpickerVm.groupedSelectedItem\" ng-options=\"item as item.label group by item.group for item in selectpickerVm.groupedSelectItems\"></select></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><select class=\"form-control\" title=\"Select with Divider\" selectpicker=\"\"><option>Group 1 - Option 1</option><option>Group 1 - Option 2</option><option data-divider=\"true\"></option><option>Group 2 - Option 1</option><option>Group 2 - Option 2</option></select></div></div></div><div class=\"form-group\"><select class=\"form-control\" title=\"Multiple Select\" multiple=\"\" selectpicker=\"\" ng-model=\"selectpickerVm.multipleSelectedItems\" ng-options=\"item as item.label for item in selectpickerVm.standardSelectItems\"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class=\"form-group\"><select class=\"form-control\" title=\"Multiple Select with Limit\" multiple=\"\" data-max-options=\"2\" selectpicker=\"\" ng-model=\"selectpickerVm.multipleSelectedItems2\" ng-options=\"item as item.label for item in selectpickerVm.standardSelectItems\"><option>Option 1</option><option>Option 2</option><option>Option 3</option></select></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><select class=\"form-control\" title=\"Primary Select\" data-style=\"btn-primary\" data-container=\"body\" selectpicker=\"\"><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class=\"form-group\"><select class=\"form-control\" title=\"Success Select\" data-style=\"btn-success\" data-container=\"body\" selectpicker=\"\"><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class=\"form-group\"><select class=\"form-control\" title=\"Warning Select\" data-style=\"btn-warning\" data-container=\"body\" selectpicker=\"\"><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><select class=\"form-control\" title=\"Info Select\" data-style=\"btn-info\" data-container=\"body\" selectpicker=\"\"><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class=\"form-group\"><select class=\"form-control\" title=\"Danger Select\" data-style=\"btn-danger\" data-container=\"body\" selectpicker=\"\"><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div><div class=\"form-group\"><select class=\"form-control\" title=\"Inverse Select\" data-style=\"btn-inverse\" data-container=\"body\" selectpicker=\"\"><option>Option 1</option><option>Option 2</option><option>Option 3</option><option>Option 4</option></select></div></div></div></div>");
$templateCache.put("app/pages/form/inputs/widgets/switch/switch.html","<div ng-controller=\"SwitchPanelCtrl as switchPanelVm\" class=\"switches clearfix\"><switch color=\"primary\" ng-model=\"switchPanelVm.switcherValues.primary\"></switch><switch color=\"warning\" ng-model=\"switchPanelVm.switcherValues.warning\"></switch><switch color=\"danger\" ng-model=\"switchPanelVm.switcherValues.danger\"></switch><switch color=\"info\" ng-model=\"switchPanelVm.switcherValues.info\"></switch><switch color=\"success\" ng-model=\"switchPanelVm.switcherValues.success\"></switch></div>");
$templateCache.put("app/pages/form/inputs/widgets/switches/switch.html","<div ng-controller=\"SwitchDemoPanelCtrl as vm\"><ba-switcher switcher-style=\"primary\" switcher-value=\"vm.switches.s1\"></ba-switcher><ba-switcher switcher-style=\"success\" switcher-value=\"vm.switches.s2\"></ba-switcher><ba-switcher switcher-style=\"warning\" switcher-value=\"vm.switches.s3\"></ba-switcher><ba-switcher switcher-style=\"danger\" switcher-value=\"vm.switches.s4\"></ba-switcher><ba-switcher switcher-style=\"info\" switcher-value=\"vm.switches.s5\"></ba-switcher></div>");
$templateCache.put("app/pages/form/inputs/widgets/tagsInput/tagsInput.html","<div class=\"form-group\"><div class=\"form-group\"><input type=\"text\" tag-input=\"primary\" value=\"Amsterdam,Washington,Sydney,Beijing,Cairo\" data-role=\"tagsinput\" placeholder=\"Add Tag\"></div><div class=\"form-group\"><input type=\"text\" tag-input=\"warning\" value=\"Minsk,Prague,Vilnius,Warsaw\" data-role=\"tagsinput\" placeholder=\"Add Tag\"></div><div class=\"form-group\"><input type=\"text\" tag-input=\"danger\" value=\"London,Berlin,Paris,Rome,Munich\" data-role=\"tagsinput\" placeholder=\"Add Tag\"></div></div>");}]);